// 座標系
export const cood = [
  {
    label: "EPSG:4326 / WGS84 / World Geodetic System 1984, used in GPS",
    value: 4326,
  },
  { label: "EPSG:6669 / JGD2011 / Japan Plane Rectangular CS I", value: 6669 },
  { label: "EPSG:6670 / JGD2011 / Japan Plane Rectangular CS II", value: 6670 },
  {
    label: "EPSG:6671 / JGD2011 / Japan Plane Rectangular CS III",
    value: 6671,
  },
  { label: "EPSG:6672 / JGD2011 / Japan Plane Rectangular CS IV", value: 6672 },
  { label: "EPSG:6673 / JGD2011 / Japan Plane Rectangular CS V", value: 6673 },
  { label: "EPSG:6674 / JGD2011 / Japan Plane Rectangular CS VI", value: 6674 },
  {
    label: "EPSG:6675 / JGD2011 / Japan Plane Rectangular CS VII",
    value: 6675,
  },
  {
    label: "EPSG:6676 / JGD2011 / Japan Plane Rectangular CS VIII",
    value: 6676,
  },
  { label: "EPSG:6677 / JGD2011 / Japan Plane Rectangular CS IX", value: 6677 },
  { label: "EPSG:6678 / JGD2011 / Japan Plane Rectangular CS X", value: 6678 },
  { label: "EPSG:6679 / JGD2011 / Japan Plane Rectangular CS XI", value: 6679 },
  {
    label: "EPSG:6680 / JGD2011 / Japan Plane Rectangular CS XII",
    value: 6680,
  },
  {
    label: "EPSG:6681 / JGD2011 / Japan Plane Rectangular CS XIII",
    value: 6681,
  },
  {
    label: "EPSG:6682 / JGD2011 / Japan Plane Rectangular CS XIV",
    value: 6682,
  },
  { label: "EPSG:6683 / JGD2011 / Japan Plane Rectangular CS XV", value: 6683 },
  {
    label: "EPSG:6684 / JGD2011 / Japan Plane Rectangular CS XVI",
    value: 6684,
  },
  {
    label: "EPSG:6685 / JGD2011 / Japan Plane Rectangular CS XVII",
    value: 6685,
  },
  {
    label: "EPSG:6686 / JGD2011 / Japan Plane Rectangular CS XVIII",
    value: 6686,
  },
  {
    label: "EPSG:6687 / JGD2011 / Japan Plane Rectangular CS XIX",
    value: 6687,
  },
  { label: "EPSG:6688 / JGD2011 / UTM zone 51N", value: 6688 },
  { label: "EPSG:6689 / JGD2011 / UTM zone 52N", value: 6689 },
  { label: "EPSG:6690 / JGD2011 / UTM zone 53N", value: 6690 },
  { label: "EPSG:6691 / JGD2011 / UTM zone 54N", value: 6691 },
  { label: "EPSG:6692 / JGD2011 / UTM zone 55N", value: 6692 },
  { label: "EPSG:2443 / JGD2000 / Japan Plane Rectangular CS I", value: 2443 },
  { label: "EPSG:2444 / JGD2000 / Japan Plane Rectangular CS II", value: 2444 },
  {
    label: "EPSG:2445 / JGD2000 / Japan Plane Rectangular CS III",
    value: 2445,
  },
  { label: "EPSG:2446 / JGD2000 / Japan Plane Rectangular CS IV", value: 2446 },
  { label: "EPSG:2447 / JGD2000 / Japan Plane Rectangular CS V", value: 2447 },
  { label: "EPSG:2448 / JGD2000 / Japan Plane Rectangular CS VI", value: 2448 },
  {
    label: "EPSG:2449 / JGD2000 / Japan Plane Rectangular CS VII",
    value: 2449,
  },
  {
    label: "EPSG:2450 / JGD2000 / Japan Plane Rectangular CS VIII",
    value: 2450,
  },
  { label: "EPSG:2451 / JGD2000 / Japan Plane Rectangular CS IX", value: 2451 },
  { label: "EPSG:2452 / JGD2000 / Japan Plane Rectangular CS X", value: 2452 },
  { label: "EPSG:2453 / JGD2000 / Japan Plane Rectangular CS XI", value: 2453 },
  {
    label: "EPSG:2454 / JGD2000 / Japan Plane Rectangular CS XII",
    value: 2454,
  },
  {
    label: "EPSG:2455 / JGD2000 / Japan Plane Rectangular CS XIII",
    value: 2455,
  },
  {
    label: "EPSG:2456 / JGD2000 / Japan Plane Rectangular CS XIV",
    value: 2456,
  },
  { label: "EPSG:2457 / JGD2000 / Japan Plane Rectangular CS XV", value: 2457 },
  {
    label: "EPSG:2458 / JGD2000 / Japan Plane Rectangular CS XVI",
    value: 2458,
  },
  {
    label: "EPSG:2459 / JGD2000 / Japan Plane Rectangular CS XVII",
    value: 2459,
  },
  {
    label: "EPSG:2460 / JGD2000 / Japan Plane Rectangular CS XVIII",
    value: 2460,
  },
  {
    label: "EPSG:2461 / JGD2000 / Japan Plane Rectangular CS XIX",
    value: 2461,
  },
  { label: "EPSG:3097 / JGD2000 / UTM zone 51N", value: 3097 },
  { label: "EPSG:3098 / JGD2000 / UTM zone 52N", value: 3098 },
  { label: "EPSG:3099 / JGD2000 / UTM zone 53N", value: 3099 },
  { label: "EPSG:3100 / JGD2000 / UTM zone 54N", value: 3100 },
  { label: "EPSG:3101 / JGD2000 / UTM zone 55N", value: 3101 },
  { label: "EPSG:32651 / WGS84 / UTM zone 51N", value: 32651 },
  { label: "EPSG:32652 / WGS84 / UTM zone 52N", value: 32652 },
  { label: "EPSG:32653 / WGS84 / UTM zone 53N", value: 32653 },
  { label: "EPSG:32654 / WGS84 / UTM zone 54N", value: 32654 },
  { label: "EPSG:32655 / WGS84 / UTM zone 55N", value: 32655 },
];

// 標高基準
export const vertical = [
  { label: "EPSG:5773 / EGM96 height", value: 5773 },
  {
    label: "EPSG:6695 / JGD2011 height (gsigeo2011_ver2_1 geoid)",
    value: 6695,
  },
  {
    label: "EPSG:6694 / JGD2000 height (gsigeo2011_ver2_1 geoid)",
    value: 6694,
  },
];

// 現場座標(投影座標) + 地理座標(WGS84) + 複合座標系
export const coordinateSystem = [
  { value: "CZM:ALB", label: "ALB / Albany Grid 1984" },
  { value: "CZM:ALB94", label: "ALB94 / Albany Grid 1994" },
  { value: "CZM:BCG", label: "BCG / Busselton Coastal Grid 1984" },
  { value: "CZM:BCG94", label: "BCG94 / Busselton Coastal Grid 1994" },
  { value: "CZM:BIO94", label: "BIO94 / Barrow Island and Onslow Grid 1994" },
  { value: "CZM:BRO", label: "BRO / Broome Grid 1984" },
  { value: "CZM:BRO94", label: "BRO94 / Broome Grid 1994" },
  { value: "CZM:CARN", label: "CARN / Carnarvon Grid 1984" },
  { value: "CZM:CARN94", label: "CARN94 / Carnarvon Grid 1994" },
  { value: "CZM:CIG92", label: "CIG92 / Christmas Island Grid 1992" },
  { value: "CZM:CIG94", label: "CIG94 / Christmas Island Grid 1994" },
  { value: "CZM:CKIG92", label: "CKIG92 / Cocos (Keeling) Islands Grid 1992" },
  { value: "CZM:CKIG94", label: "CKIG94 / Cocos (Keeling) Islands Grid 1994" },
  { value: "CZM:COL94", label: "COL94 / Collie Grid 1994" },
  { value: "CZM:EG", label: "EG / Esperance Grid  1984" },
  { value: "CZM:ESP94", label: "ESP94 / Esperance Grid 1994" },
  { value: "CZM:EXM", label: "EXM / Exmouth Grid  1984" },
  { value: "CZM:EXM94", label: "EXM94 / Exmouth Grid 1994" },
  { value: "CZM:GCG", label: "GCG / Geraldton Coastal Grid 1984" },
  { value: "CZM:GCG94", label: "GCG94 / Geraldton Coastal Grid 1994" },
  { value: "CZM:GG", label: "GG / Goldfields Grid 1984" },
  { value: "CZM:GOLD94", label: "GOLD94 / Goldfields Grid 1994" },
  {
    value: "CZM:H1BANWIL2020",
    label: "H1BANWIL2020 / GDA2020 / Nth Banister to Williams 97 - 158 SLK",
  },
  {
    value: "CZM:H1BANWIL94",
    label: "H1BANWIL94 / GDA94 / Nth Banister to Williams 97 - 158 SLK",
  },
  { value: "CZM:JCG", label: "JCG / Jurien Coastal Grid 1984" },
  { value: "CZM:JCG94", label: "JCG94 / Jurien Coastal Grid 1994" },
  { value: "CZM:KALB94", label: "KALB94 / Kalbarri Grid 1994" },
  { value: "CZM:KAR", label: "KAR / Karratha Grid 1984" },
  { value: "CZM:KAR94", label: "KAR94 / Karratha Grid 1994" },
  { value: "CZM:KG", label: "KG / Kununurra Grid 1984" },
  { value: "CZM:KUN94", label: "KUN94 / Kununurra Grid 1994" },
  { value: "CZM:LCG", label: "LCG / Lancelin Coastal Grid 1984" },
  { value: "CZM:LCG94", label: "LCG94 / Lancelin Coastal Grid 1994" },
  { value: "CZM:MRCG", label: "MRCG / Margaret River Coastal Grid 1984" },
  { value: "CZM:MRCG94", label: "MRCG94 / Margaret River Coastal Grid 1994" },
  {
    value: "CZM:OSGB36",
    label: "OSGB36 / EPSG:27700 OSGB36 / British National Grid",
  },
  {
    value: "CZM:OSTN02",
    label: "OSTN02 / OSGB36 with OSTN02 grid shift / British National Grid",
  },
  { value: "CZM:PCG", label: "PCG / Perth Coastal Grid 1984" },
  { value: "CZM:PCG94", label: "PCG94 / Perth Coastal Grid 1994" },
  { value: "CZM:PHG", label: "PHG / Port Hedland Grid 1984" },
  { value: "CZM:PHG94", label: "PHG94 / Port Hedland Grid 1994" },
  {
    value: "EPSG:2000",
    label: "EPSG:2000 / Anguilla 1957 / British West Indies Grid",
  },
  {
    value: "EPSG:2001",
    label: "EPSG:2001 / Antigua 1943 / British West Indies Grid",
  },
  {
    value: "EPSG:2002",
    label: "EPSG:2002 / Dominica 1945 / British West Indies Grid",
  },
  {
    value: "EPSG:2003",
    label: "EPSG:2003 / Grenada 1953 / British West Indies Grid",
  },
  {
    value: "EPSG:2004",
    label: "EPSG:2004 / Montserrat 1958 / British West Indies Grid",
  },
  {
    value: "EPSG:2005",
    label: "EPSG:2005 / St. Kitts 1955 / British West Indies Grid",
  },
  {
    value: "EPSG:2006",
    label: "EPSG:2006 / St. Lucia 1955 / British West Indies Grid",
  },
  {
    value: "EPSG:2007",
    label: "EPSG:2007 / St. Vincent 45 / British West Indies Grid",
  },
  { value: "EPSG:2008", label: "EPSG:2008 / NAD27(CGQ77) / SCoPQ zone 2" },
  { value: "EPSG:2009", label: "EPSG:2009 / NAD27(CGQ77) / SCoPQ zone 3" },
  { value: "EPSG:2010", label: "EPSG:2010 / NAD27(CGQ77) / SCoPQ zone 4" },
  { value: "EPSG:2011", label: "EPSG:2011 / NAD27(CGQ77) / SCoPQ zone 5" },
  { value: "EPSG:2012", label: "EPSG:2012 / NAD27(CGQ77) / SCoPQ zone 6" },
  { value: "EPSG:2013", label: "EPSG:2013 / NAD27(CGQ77) / SCoPQ zone 7" },
  { value: "EPSG:2014", label: "EPSG:2014 / NAD27(CGQ77) / SCoPQ zone 8" },
  { value: "EPSG:2015", label: "EPSG:2015 / NAD27(CGQ77) / SCoPQ zone 9" },
  { value: "EPSG:2016", label: "EPSG:2016 / NAD27(CGQ77) / SCoPQ zone 10" },
  { value: "EPSG:2017", label: "EPSG:2017 / NAD27(76) / MTM zone 8" },
  { value: "EPSG:2018", label: "EPSG:2018 / NAD27(76) / MTM zone 9" },
  { value: "EPSG:2019", label: "EPSG:2019 / NAD27(76) / MTM zone 10" },
  { value: "EPSG:2020", label: "EPSG:2020 / NAD27(76) / MTM zone 11" },
  { value: "EPSG:2021", label: "EPSG:2021 / NAD27(76) / MTM zone 12" },
  { value: "EPSG:2022", label: "EPSG:2022 / NAD27(76) / MTM zone 13" },
  { value: "EPSG:2023", label: "EPSG:2023 / NAD27(76) / MTM zone 14" },
  { value: "EPSG:2024", label: "EPSG:2024 / NAD27(76) / MTM zone 15" },
  { value: "EPSG:2025", label: "EPSG:2025 / NAD27(76) / MTM zone 16" },
  { value: "EPSG:2026", label: "EPSG:2026 / NAD27(76) / MTM zone 17" },
  { value: "EPSG:2027", label: "EPSG:2027 / NAD27(76) / UTM zone 15N" },
  { value: "EPSG:2028", label: "EPSG:2028 / NAD27(76) / UTM zone 16N" },
  { value: "EPSG:2029", label: "EPSG:2029 / NAD27(76) / UTM zone 17N" },
  { value: "EPSG:2030", label: "EPSG:2030 / NAD27(76) / UTM zone 18N" },
  { value: "EPSG:2031", label: "EPSG:2031 / NAD27(CGQ77) / UTM zone 17N" },
  { value: "EPSG:2032", label: "EPSG:2032 / NAD27(CGQ77) / UTM zone 18N" },
  { value: "EPSG:2033", label: "EPSG:2033 / NAD27(CGQ77) / UTM zone 19N" },
  { value: "EPSG:2034", label: "EPSG:2034 / NAD27(CGQ77) / UTM zone 20N" },
  { value: "EPSG:2035", label: "EPSG:2035 / NAD27(CGQ77) / UTM zone 21N" },
  {
    value: "EPSG:2036",
    label: "EPSG:2036 / NAD83(CSRS98) / New Brunswick Stereo",
  },
  { value: "EPSG:2037", label: "EPSG:2037 / NAD83(CSRS98) / UTM zone 19N" },
  { value: "EPSG:2038", label: "EPSG:2038 / NAD83(CSRS98) / UTM zone 20N" },
  { value: "EPSG:2039", label: "EPSG:2039 / Israel 1993 / Israeli TM Grid" },
  { value: "EPSG:2040", label: "EPSG:2040 / Locodjo 1965 / UTM zone 30N" },
  { value: "EPSG:2041", label: "EPSG:2041 / Abidjan 1987 / UTM zone 30N" },
  { value: "EPSG:2042", label: "EPSG:2042 / Locodjo 1965 / UTM zone 29N" },
  { value: "EPSG:2043", label: "EPSG:2043 / Abidjan 1987 / UTM zone 29N" },
  {
    value: "EPSG:2044",
    label: "EPSG:2044 / Hanoi 1972 / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:2045",
    label: "EPSG:2045 / Hanoi 1972 / Gauss-Kruger zone 19",
  },
  { value: "EPSG:2046", label: "EPSG:2046 / Hartebeesthoek94 / Lo15" },
  { value: "EPSG:2047", label: "EPSG:2047 / Hartebeesthoek94 / Lo17" },
  { value: "EPSG:2048", label: "EPSG:2048 / Hartebeesthoek94 / Lo19" },
  { value: "EPSG:2049", label: "EPSG:2049 / Hartebeesthoek94 / Lo21" },
  { value: "EPSG:2050", label: "EPSG:2050 / Hartebeesthoek94 / Lo23" },
  { value: "EPSG:2051", label: "EPSG:2051 / Hartebeesthoek94 / Lo25" },
  { value: "EPSG:2052", label: "EPSG:2052 / Hartebeesthoek94 / Lo27" },
  { value: "EPSG:2053", label: "EPSG:2053 / Hartebeesthoek94 / Lo29" },
  { value: "EPSG:2054", label: "EPSG:2054 / Hartebeesthoek94 / Lo31" },
  { value: "EPSG:2055", label: "EPSG:2055 / Hartebeesthoek94 / Lo33" },
  { value: "EPSG:2056", label: "EPSG:2056 / CH1903+ / LV95" },
  { value: "EPSG:2057", label: "EPSG:2057 / Rassadiran / Nakhl e Taqi" },
  { value: "EPSG:2058", label: "EPSG:2058 / ED50(ED77) / UTM zone 38N" },
  { value: "EPSG:2059", label: "EPSG:2059 / ED50(ED77) / UTM zone 39N" },
  { value: "EPSG:2060", label: "EPSG:2060 / ED50(ED77) / UTM zone 40N" },
  { value: "EPSG:2061", label: "EPSG:2061 / ED50(ED77) / UTM zone 41N" },
  { value: "EPSG:2062", label: "EPSG:2062 / Madrid 1870 (Madrid) / Spain LCC" },
  { value: "EPSG:2063", label: "EPSG:2063 / Dabola 1981 / UTM zone 28N" },
  { value: "EPSG:2064", label: "EPSG:2064 / Dabola 1981 / UTM zone 29N" },
  { value: "EPSG:2065", label: "EPSG:2065 / S-JTSK (Ferro) / Krovak" },
  { value: "EPSG:2066", label: "EPSG:2066 / Mount Dillon / Tobago Grid" },
  { value: "EPSG:2067", label: "EPSG:2067 / Naparima 1955 / UTM zone 20N" },
  { value: "EPSG:2068", label: "EPSG:2068 / ELD79 / Libya zone 5" },
  { value: "EPSG:2069", label: "EPSG:2069 / ELD79 / Libya zone 6" },
  { value: "EPSG:2070", label: "EPSG:2070 / ELD79 / Libya zone 7" },
  { value: "EPSG:2071", label: "EPSG:2071 / ELD79 / Libya zone 8" },
  { value: "EPSG:2072", label: "EPSG:2072 / ELD79 / Libya zone 9" },
  { value: "EPSG:2073", label: "EPSG:2073 / ELD79 / Libya zone 10" },
  { value: "EPSG:2074", label: "EPSG:2074 / ELD79 / Libya zone 11" },
  { value: "EPSG:2075", label: "EPSG:2075 / ELD79 / Libya zone 12" },
  { value: "EPSG:2076", label: "EPSG:2076 / ELD79 / Libya zone 13" },
  { value: "EPSG:2077", label: "EPSG:2077 / ELD79 / UTM zone 32N" },
  { value: "EPSG:2078", label: "EPSG:2078 / ELD79 / UTM zone 33N" },
  { value: "EPSG:2079", label: "EPSG:2079 / ELD79 / UTM zone 34N" },
  { value: "EPSG:2080", label: "EPSG:2080 / ELD79 / UTM zone 35N" },
  { value: "EPSG:2081", label: "EPSG:2081 / Chos Malal 1914 / Argentina 2" },
  { value: "EPSG:2082", label: "EPSG:2082 / Pampa del Castillo / Argentina 2" },
  { value: "EPSG:2083", label: "EPSG:2083 / Hito XVIII 1963 / Argentina 2" },
  { value: "EPSG:2084", label: "EPSG:2084 / Hito XVIII 1963 / UTM zone 19S" },
  { value: "EPSG:2085", label: "EPSG:2085 / NAD27 / Cuba Norte" },
  { value: "EPSG:2086", label: "EPSG:2086 / NAD27 / Cuba Sur" },
  { value: "EPSG:2087", label: "EPSG:2087 / ELD79 / TM 12 NE" },
  { value: "EPSG:2088", label: "EPSG:2088 / Carthage / TM 11 NE" },
  { value: "EPSG:2089", label: "EPSG:2089 / Yemen NGN96 / UTM zone 38N" },
  { value: "EPSG:2090", label: "EPSG:2090 / Yemen NGN96 / UTM zone 39N" },
  {
    value: "EPSG:2091",
    label: "EPSG:2091 / South Yemen / Gauss Kruger zone 8",
  },
  {
    value: "EPSG:2092",
    label: "EPSG:2092 / South Yemen / Gauss Kruger zone 9",
  },
  { value: "EPSG:2093", label: "EPSG:2093 / Hanoi 1972 / GK 106 NE" },
  { value: "EPSG:2094", label: "EPSG:2094 / WGS 72BE / TM 106 NE" },
  { value: "EPSG:2095", label: "EPSG:2095 / Bissau / UTM zone 28N" },
  { value: "EPSG:2096", label: "EPSG:2096 / Korean 1985 / East Belt" },
  { value: "EPSG:2097", label: "EPSG:2097 / Korean 1985 / Central Belt" },
  { value: "EPSG:2098", label: "EPSG:2098 / Korean 1985 / West Belt" },
  { value: "EPSG:2099", label: "EPSG:2099 / Qatar 1948 / Qatar Grid" },
  { value: "EPSG:2100", label: "EPSG:2100 / GGRS87 / Greek Grid" },
  { value: "EPSG:2101", label: "EPSG:2101 / Lake / Maracaibo Grid M1" },
  { value: "EPSG:2102", label: "EPSG:2102 / Lake / Maracaibo Grid" },
  { value: "EPSG:2103", label: "EPSG:2103 / Lake / Maracaibo Grid M3" },
  { value: "EPSG:2104", label: "EPSG:2104 / Lake / Maracaibo La Rosa Grid" },
  { value: "EPSG:2105", label: "EPSG:2105 / NZGD2000 / Mount Eden 2000" },
  { value: "EPSG:2106", label: "EPSG:2106 / NZGD2000 / Bay of Plenty 2000" },
  { value: "EPSG:2107", label: "EPSG:2107 / NZGD2000 / Poverty Bay 2000" },
  { value: "EPSG:2108", label: "EPSG:2108 / NZGD2000 / Hawkes Bay 2000" },
  { value: "EPSG:2109", label: "EPSG:2109 / NZGD2000 / Taranaki 2000" },
  { value: "EPSG:2110", label: "EPSG:2110 / NZGD2000 / Tuhirangi 2000" },
  { value: "EPSG:2111", label: "EPSG:2111 / NZGD2000 / Wanganui 2000" },
  { value: "EPSG:2112", label: "EPSG:2112 / NZGD2000 / Wairarapa 2000" },
  { value: "EPSG:2113", label: "EPSG:2113 / NZGD2000 / Wellington 2000" },
  { value: "EPSG:2114", label: "EPSG:2114 / NZGD2000 / Collingwood 2000" },
  { value: "EPSG:2115", label: "EPSG:2115 / NZGD2000 / Nelson 2000" },
  { value: "EPSG:2116", label: "EPSG:2116 / NZGD2000 / Karamea 2000" },
  { value: "EPSG:2117", label: "EPSG:2117 / NZGD2000 / Buller 2000" },
  { value: "EPSG:2118", label: "EPSG:2118 / NZGD2000 / Grey 2000" },
  { value: "EPSG:2119", label: "EPSG:2119 / NZGD2000 / Amuri 2000" },
  { value: "EPSG:2120", label: "EPSG:2120 / NZGD2000 / Marlborough 2000" },
  { value: "EPSG:2121", label: "EPSG:2121 / NZGD2000 / Hokitika 2000" },
  { value: "EPSG:2122", label: "EPSG:2122 / NZGD2000 / Okarito 2000" },
  { value: "EPSG:2123", label: "EPSG:2123 / NZGD2000 / Jacksons Bay 2000" },
  { value: "EPSG:2124", label: "EPSG:2124 / NZGD2000 / Mount Pleasant 2000" },
  { value: "EPSG:2125", label: "EPSG:2125 / NZGD2000 / Gawler 2000" },
  { value: "EPSG:2126", label: "EPSG:2126 / NZGD2000 / Timaru 2000" },
  { value: "EPSG:2127", label: "EPSG:2127 / NZGD2000 / Lindis Peak 2000" },
  { value: "EPSG:2128", label: "EPSG:2128 / NZGD2000 / Mount Nicholas 2000" },
  { value: "EPSG:2129", label: "EPSG:2129 / NZGD2000 / Mount York 2000" },
  {
    value: "EPSG:2130",
    label: "EPSG:2130 / NZGD2000 / Observation Point 2000",
  },
  { value: "EPSG:2131", label: "EPSG:2131 / NZGD2000 / North Taieri 2000" },
  { value: "EPSG:2132", label: "EPSG:2132 / NZGD2000 / Bluff 2000" },
  { value: "EPSG:2133", label: "EPSG:2133 / NZGD2000 / UTM zone 58S" },
  { value: "EPSG:2134", label: "EPSG:2134 / NZGD2000 / UTM zone 59S" },
  { value: "EPSG:2135", label: "EPSG:2135 / NZGD2000 / UTM zone 60S" },
  { value: "EPSG:2136", label: "EPSG:2136 / Accra / Ghana National Grid" },
  { value: "EPSG:2137", label: "EPSG:2137 / Accra / TM 1 NW" },
  { value: "EPSG:2138", label: "EPSG:2138 / NAD27(CGQ77) / Quebec Lambert" },
  { value: "EPSG:2139", label: "EPSG:2139 / NAD83(CSRS98) / SCoPQ zone 2" },
  { value: "EPSG:2140", label: "EPSG:2140 / NAD83(CSRS98) / MTM zone 3" },
  { value: "EPSG:2141", label: "EPSG:2141 / NAD83(CSRS98) / MTM zone 4" },
  { value: "EPSG:2142", label: "EPSG:2142 / NAD83(CSRS98) / MTM zone 5" },
  { value: "EPSG:2143", label: "EPSG:2143 / NAD83(CSRS98) / MTM zone 6" },
  { value: "EPSG:2144", label: "EPSG:2144 / NAD83(CSRS98) / MTM zone 7" },
  { value: "EPSG:2145", label: "EPSG:2145 / NAD83(CSRS98) / MTM zone 8" },
  { value: "EPSG:2146", label: "EPSG:2146 / NAD83(CSRS98) / MTM zone 9" },
  { value: "EPSG:2147", label: "EPSG:2147 / NAD83(CSRS98) / MTM zone 10" },
  { value: "EPSG:2148", label: "EPSG:2148 / NAD83(CSRS98) / UTM zone 21N" },
  { value: "EPSG:2149", label: "EPSG:2149 / NAD83(CSRS98) / UTM zone 18N" },
  { value: "EPSG:2150", label: "EPSG:2150 / NAD83(CSRS98) / UTM zone 17N" },
  { value: "EPSG:2151", label: "EPSG:2151 / NAD83(CSRS98) / UTM zone 13N" },
  { value: "EPSG:2152", label: "EPSG:2152 / NAD83(CSRS98) / UTM zone 12N" },
  { value: "EPSG:2153", label: "EPSG:2153 / NAD83(CSRS98) / UTM zone 11N" },
  { value: "EPSG:2154", label: "EPSG:2154 / RGF93 v1 / Lambert-93" },
  {
    value: "EPSG:2155",
    label: "EPSG:2155 / American Samoa 1962 / American Samoa Lambert",
  },
  { value: "EPSG:2156", label: "EPSG:2156 / NAD83(HARN) / UTM zone 59S" },
  {
    value: "EPSG:2157",
    label: "EPSG:2157 / IRENET95 / Irish Transverse Mercator",
  },
  { value: "EPSG:2158", label: "EPSG:2158 / IRENET95 / UTM zone 29N" },
  {
    value: "EPSG:2159",
    label: "EPSG:2159 / Sierra Leone 1924 / New Colony Grid",
  },
  {
    value: "EPSG:2160",
    label: "EPSG:2160 / Sierra Leone 1924 / New War Office Grid",
  },
  { value: "EPSG:2161", label: "EPSG:2161 / Sierra Leone 1968 / UTM zone 28N" },
  { value: "EPSG:2162", label: "EPSG:2162 / Sierra Leone 1968 / UTM zone 29N" },
  { value: "EPSG:2163", label: "EPSG:2163 / US National Atlas Equal Area" },
  { value: "EPSG:2164", label: "EPSG:2164 / Locodjo 1965 / TM 5 NW" },
  { value: "EPSG:2165", label: "EPSG:2165 / Abidjan 1987 / TM 5 NW" },
  {
    value: "EPSG:2166",
    label: "EPSG:2166 / Pulkovo 1942(83) / Gauss Kruger zone 3",
  },
  {
    value: "EPSG:2167",
    label: "EPSG:2167 / Pulkovo 1942(83) / Gauss Kruger zone 4",
  },
  {
    value: "EPSG:2168",
    label: "EPSG:2168 / Pulkovo 1942(83) / Gauss Kruger zone 5",
  },
  { value: "EPSG:2169", label: "EPSG:2169 / LUREF / Luxembourg TM" },
  { value: "EPSG:2170", label: "EPSG:2170 / MGI / Slovenia Grid" },
  { value: "EPSG:2171", label: "EPSG:2171 / Pulkovo 1942(58) / Poland zone I" },
  {
    value: "EPSG:2172",
    label: "EPSG:2172 / Pulkovo 1942(58) / Poland zone II",
  },
  {
    value: "EPSG:2173",
    label: "EPSG:2173 / Pulkovo 1942(58) / Poland zone III",
  },
  {
    value: "EPSG:2174",
    label: "EPSG:2174 / Pulkovo 1942(58) / Poland zone IV",
  },
  { value: "EPSG:2175", label: "EPSG:2175 / Pulkovo 1942(58) / Poland zone V" },
  { value: "EPSG:2176", label: "EPSG:2176 / ETRF2000-PL / CS2000/15" },
  { value: "EPSG:2177", label: "EPSG:2177 / ETRF2000-PL / CS2000/18" },
  { value: "EPSG:2178", label: "EPSG:2178 / ETRF2000-PL / CS2000/21" },
  { value: "EPSG:2179", label: "EPSG:2179 / ETRF2000-PL / CS2000/24" },
  { value: "EPSG:2180", label: "EPSG:2180 / ETRF2000-PL / CS92" },
  {
    value: "EPSG:2188",
    label: "EPSG:2188 / Azores Occidental 1939 / UTM zone 25N",
  },
  {
    value: "EPSG:2189",
    label: "EPSG:2189 / Azores Central 1948 / UTM zone 26N",
  },
  {
    value: "EPSG:2190",
    label: "EPSG:2190 / Azores Oriental 1940 / UTM zone 26N",
  },
  { value: "EPSG:2191", label: "EPSG:2191 / Madeira 1936 / UTM zone 28N" },
  { value: "EPSG:2192", label: "EPSG:2192 / ED50 / France EuroLambert" },
  {
    value: "EPSG:2193",
    label: "EPSG:2193 / NZGD2000 / New Zealand Transverse Mercator 2000",
  },
  {
    value: "EPSG:2194",
    label: "EPSG:2194 / American Samoa 1962 / American Samoa Lambert",
  },
  { value: "EPSG:2195", label: "EPSG:2195 / NAD83(HARN) / UTM zone 2S" },
  { value: "EPSG:2196", label: "EPSG:2196 / ETRS89 / Kp2000 Jutland" },
  { value: "EPSG:2197", label: "EPSG:2197 / ETRS89 / Kp2000 Zealand" },
  { value: "EPSG:2198", label: "EPSG:2198 / ETRS89 / Kp2000 Bornholm" },
  {
    value: "EPSG:2199",
    label: "EPSG:2199 / Albanian 1987 / Gauss Kruger zone 4",
  },
  {
    value: "EPSG:2200",
    label: "EPSG:2200 / ATS77 / New Brunswick Stereographic (ATS77)",
  },
  { value: "EPSG:2201", label: "EPSG:2201 / REGVEN / UTM zone 18N" },
  { value: "EPSG:2202", label: "EPSG:2202 / REGVEN / UTM zone 19N" },
  { value: "EPSG:2203", label: "EPSG:2203 / REGVEN / UTM zone 20N" },
  { value: "EPSG:2204", label: "EPSG:2204 / NAD27 / Tennessee" },
  { value: "EPSG:2205", label: "EPSG:2205 / NAD83 / Kentucky North" },
  {
    value: "EPSG:2206",
    label: "EPSG:2206 / ED50 / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:2207",
    label: "EPSG:2207 / ED50 / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:2208",
    label: "EPSG:2208 / ED50 / 3-degree Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:2209",
    label: "EPSG:2209 / ED50 / 3-degree Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:2210",
    label: "EPSG:2210 / ED50 / 3-degree Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:2211",
    label: "EPSG:2211 / ED50 / 3-degree Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:2212",
    label: "EPSG:2212 / ED50 / 3-degree Gauss-Kruger zone 15",
  },
  { value: "EPSG:2213", label: "EPSG:2213 / ETRS89 / TM 30 NE" },
  { value: "EPSG:2214", label: "EPSG:2214 / Douala 1948 / AOF west" },
  { value: "EPSG:2215", label: "EPSG:2215 / Manoca 1962 / UTM zone 32N" },
  { value: "EPSG:2216", label: "EPSG:2216 / Qornoq 1927 / UTM zone 22N" },
  { value: "EPSG:2217", label: "EPSG:2217 / Qornoq 1927 / UTM zone 23N" },
  {
    value: "EPSG:2218",
    label: "EPSG:2218 / Scoresbysund 1952 / Greenland zone 5 east",
  },
  { value: "EPSG:2219", label: "EPSG:2219 / ATS77 / UTM zone 19N" },
  { value: "EPSG:2220", label: "EPSG:2220 / ATS77 / UTM zone 20N" },
  {
    value: "EPSG:2221",
    label: "EPSG:2221 / Scoresbysund 1952 / Greenland zone 6 east",
  },
  { value: "EPSG:2222", label: "EPSG:2222 / NAD83 / Arizona East (ft)" },
  { value: "EPSG:2223", label: "EPSG:2223 / NAD83 / Arizona Central (ft)" },
  { value: "EPSG:2224", label: "EPSG:2224 / NAD83 / Arizona West (ft)" },
  { value: "EPSG:2225", label: "EPSG:2225 / NAD83 / California zone 1 (ftUS)" },
  { value: "EPSG:2226", label: "EPSG:2226 / NAD83 / California zone 2 (ftUS)" },
  { value: "EPSG:2227", label: "EPSG:2227 / NAD83 / California zone 3 (ftUS)" },
  { value: "EPSG:2228", label: "EPSG:2228 / NAD83 / California zone 4 (ftUS)" },
  { value: "EPSG:2229", label: "EPSG:2229 / NAD83 / California zone 5 (ftUS)" },
  { value: "EPSG:2230", label: "EPSG:2230 / NAD83 / California zone 6 (ftUS)" },
  { value: "EPSG:2231", label: "EPSG:2231 / NAD83 / Colorado North (ftUS)" },
  { value: "EPSG:2232", label: "EPSG:2232 / NAD83 / Colorado Central (ftUS)" },
  { value: "EPSG:2233", label: "EPSG:2233 / NAD83 / Colorado South (ftUS)" },
  { value: "EPSG:2234", label: "EPSG:2234 / NAD83 / Connecticut (ftUS)" },
  { value: "EPSG:2235", label: "EPSG:2235 / NAD83 / Delaware (ftUS)" },
  { value: "EPSG:2236", label: "EPSG:2236 / NAD83 / Florida East (ftUS)" },
  { value: "EPSG:2237", label: "EPSG:2237 / NAD83 / Florida West (ftUS)" },
  { value: "EPSG:2238", label: "EPSG:2238 / NAD83 / Florida North (ftUS)" },
  { value: "EPSG:2239", label: "EPSG:2239 / NAD83 / Georgia East (ftUS)" },
  { value: "EPSG:2240", label: "EPSG:2240 / NAD83 / Georgia West (ftUS)" },
  { value: "EPSG:2241", label: "EPSG:2241 / NAD83 / Idaho East (ftUS)" },
  { value: "EPSG:2242", label: "EPSG:2242 / NAD83 / Idaho Central (ftUS)" },
  { value: "EPSG:2243", label: "EPSG:2243 / NAD83 / Idaho West (ftUS)" },
  { value: "EPSG:2244", label: "EPSG:2244 / NAD83 / Indiana East (ftUS)" },
  { value: "EPSG:2245", label: "EPSG:2245 / NAD83 / Indiana West (ftUS)" },
  { value: "EPSG:2246", label: "EPSG:2246 / NAD83 / Kentucky North (ftUS)" },
  { value: "EPSG:2247", label: "EPSG:2247 / NAD83 / Kentucky South (ftUS)" },
  { value: "EPSG:2248", label: "EPSG:2248 / NAD83 / Maryland (ftUS)" },
  {
    value: "EPSG:2249",
    label: "EPSG:2249 / NAD83 / Massachusetts Mainland (ftUS)",
  },
  {
    value: "EPSG:2250",
    label: "EPSG:2250 / NAD83 / Massachusetts Island (ftUS)",
  },
  { value: "EPSG:2251", label: "EPSG:2251 / NAD83 / Michigan North (ft)" },
  { value: "EPSG:2252", label: "EPSG:2252 / NAD83 / Michigan Central (ft)" },
  { value: "EPSG:2253", label: "EPSG:2253 / NAD83 / Michigan South (ft)" },
  { value: "EPSG:2254", label: "EPSG:2254 / NAD83 / Mississippi East (ftUS)" },
  { value: "EPSG:2255", label: "EPSG:2255 / NAD83 / Mississippi West (ftUS)" },
  { value: "EPSG:2256", label: "EPSG:2256 / NAD83 / Montana (ft)" },
  { value: "EPSG:2257", label: "EPSG:2257 / NAD83 / New Mexico East (ftUS)" },
  {
    value: "EPSG:2258",
    label: "EPSG:2258 / NAD83 / New Mexico Central (ftUS)",
  },
  { value: "EPSG:2259", label: "EPSG:2259 / NAD83 / New Mexico West (ftUS)" },
  { value: "EPSG:2260", label: "EPSG:2260 / NAD83 / New York East (ftUS)" },
  { value: "EPSG:2261", label: "EPSG:2261 / NAD83 / New York Central (ftUS)" },
  { value: "EPSG:2262", label: "EPSG:2262 / NAD83 / New York West (ftUS)" },
  {
    value: "EPSG:2263",
    label: "EPSG:2263 / NAD83 / New York Long Island (ftUS)",
  },
  { value: "EPSG:2264", label: "EPSG:2264 / NAD83 / North Carolina (ftUS)" },
  { value: "EPSG:2265", label: "EPSG:2265 / NAD83 / North Dakota North (ft)" },
  { value: "EPSG:2266", label: "EPSG:2266 / NAD83 / North Dakota South (ft)" },
  { value: "EPSG:2267", label: "EPSG:2267 / NAD83 / Oklahoma North (ftUS)" },
  { value: "EPSG:2268", label: "EPSG:2268 / NAD83 / Oklahoma South (ftUS)" },
  { value: "EPSG:2269", label: "EPSG:2269 / NAD83 / Oregon North (ft)" },
  { value: "EPSG:2270", label: "EPSG:2270 / NAD83 / Oregon South (ft)" },
  {
    value: "EPSG:2271",
    label: "EPSG:2271 / NAD83 / Pennsylvania North (ftUS)",
  },
  {
    value: "EPSG:2272",
    label: "EPSG:2272 / NAD83 / Pennsylvania South (ftUS)",
  },
  { value: "EPSG:2273", label: "EPSG:2273 / NAD83 / South Carolina (ft)" },
  { value: "EPSG:2274", label: "EPSG:2274 / NAD83 / Tennessee (ftUS)" },
  { value: "EPSG:2275", label: "EPSG:2275 / NAD83 / Texas North (ftUS)" },
  {
    value: "EPSG:2276",
    label: "EPSG:2276 / NAD83 / Texas North Central (ftUS)",
  },
  { value: "EPSG:2277", label: "EPSG:2277 / NAD83 / Texas Central (ftUS)" },
  {
    value: "EPSG:2278",
    label: "EPSG:2278 / NAD83 / Texas South Central (ftUS)",
  },
  { value: "EPSG:2279", label: "EPSG:2279 / NAD83 / Texas South (ftUS)" },
  { value: "EPSG:2280", label: "EPSG:2280 / NAD83 / Utah North (ft)" },
  { value: "EPSG:2281", label: "EPSG:2281 / NAD83 / Utah Central (ft)" },
  { value: "EPSG:2282", label: "EPSG:2282 / NAD83 / Utah South (ft)" },
  { value: "EPSG:2283", label: "EPSG:2283 / NAD83 / Virginia North (ftUS)" },
  { value: "EPSG:2284", label: "EPSG:2284 / NAD83 / Virginia South (ftUS)" },
  { value: "EPSG:2285", label: "EPSG:2285 / NAD83 / Washington North (ftUS)" },
  { value: "EPSG:2286", label: "EPSG:2286 / NAD83 / Washington South (ftUS)" },
  { value: "EPSG:2287", label: "EPSG:2287 / NAD83 / Wisconsin North (ftUS)" },
  { value: "EPSG:2288", label: "EPSG:2288 / NAD83 / Wisconsin Central (ftUS)" },
  { value: "EPSG:2289", label: "EPSG:2289 / NAD83 / Wisconsin South (ftUS)" },
  {
    value: "EPSG:2290",
    label: "EPSG:2290 / ATS77 / Prince Edward Isl. Stereographic (ATS77)",
  },
  {
    value: "EPSG:2291",
    label:
      "EPSG:2291 / NAD83(CSRS98) / Prince Edward Isl. Stereographic (NAD83)",
  },
  {
    value: "EPSG:2292",
    label:
      "EPSG:2292 / NAD83(CSRS98) / Prince Edward Isl. Stereographic (NAD83)",
  },
  { value: "EPSG:2294", label: "EPSG:2294 / ATS77 / MTM Nova Scotia zone 4" },
  { value: "EPSG:2295", label: "EPSG:2295 / ATS77 / MTM Nova Scotia zone 5" },
  {
    value: "EPSG:2296",
    label: "EPSG:2296 / Ammassalik 1958 / Greenland zone 7 east",
  },
  {
    value: "EPSG:2297",
    label: "EPSG:2297 / Qornoq 1927 / Greenland zone 1 east",
  },
  {
    value: "EPSG:2298",
    label: "EPSG:2298 / Qornoq 1927 / Greenland zone 2 east",
  },
  {
    value: "EPSG:2299",
    label: "EPSG:2299 / Qornoq 1927 / Greenland zone 2 west",
  },
  {
    value: "EPSG:2300",
    label: "EPSG:2300 / Qornoq 1927 / Greenland zone 3 east",
  },
  {
    value: "EPSG:2301",
    label: "EPSG:2301 / Qornoq 1927 / Greenland zone 3 west",
  },
  {
    value: "EPSG:2302",
    label: "EPSG:2302 / Qornoq 1927 / Greenland zone 4 east",
  },
  {
    value: "EPSG:2303",
    label: "EPSG:2303 / Qornoq 1927 / Greenland zone 4 west",
  },
  {
    value: "EPSG:2304",
    label: "EPSG:2304 / Qornoq 1927 / Greenland zone 5 west",
  },
  {
    value: "EPSG:2305",
    label: "EPSG:2305 / Qornoq 1927 / Greenland zone 6 west",
  },
  {
    value: "EPSG:2306",
    label: "EPSG:2306 / Qornoq 1927 / Greenland zone 7 west",
  },
  {
    value: "EPSG:2307",
    label: "EPSG:2307 / Qornoq 1927 / Greenland zone 8 east",
  },
  { value: "EPSG:2308", label: "EPSG:2308 / Batavia / TM 109 SE" },
  { value: "EPSG:2309", label: "EPSG:2309 / WGS 84 / TM 116 SE" },
  { value: "EPSG:2310", label: "EPSG:2310 / WGS 84 / TM 132 SE" },
  { value: "EPSG:2311", label: "EPSG:2311 / WGS 84 / TM 6 NE" },
  { value: "EPSG:2312", label: "EPSG:2312 / Garoua / UTM zone 33N" },
  { value: "EPSG:2313", label: "EPSG:2313 / Kousseri / UTM zone 33N" },
  {
    value: "EPSG:2314",
    label: "EPSG:2314 / Trinidad 1903 / Trinidad Grid (ftCla)",
  },
  { value: "EPSG:2315", label: "EPSG:2315 / Campo Inchauspe / UTM zone 19S" },
  { value: "EPSG:2316", label: "EPSG:2316 / Campo Inchauspe / UTM zone 20S" },
  { value: "EPSG:2317", label: "EPSG:2317 / PSAD56 / ICN Regional" },
  { value: "EPSG:2318", label: "EPSG:2318 / Ain el Abd / Aramco Lambert" },
  { value: "EPSG:2319", label: "EPSG:2319 / ED50 / TM27" },
  { value: "EPSG:2320", label: "EPSG:2320 / ED50 / TM30" },
  { value: "EPSG:2321", label: "EPSG:2321 / ED50 / TM33" },
  { value: "EPSG:2322", label: "EPSG:2322 / ED50 / TM36" },
  { value: "EPSG:2323", label: "EPSG:2323 / ED50 / TM39" },
  { value: "EPSG:2324", label: "EPSG:2324 / ED50 / TM42" },
  { value: "EPSG:2325", label: "EPSG:2325 / ED50 / TM45" },
  { value: "EPSG:2326", label: "EPSG:2326 / Hong Kong 1980 Grid System" },
  { value: "EPSG:2327", label: "EPSG:2327 / Xian 1980 / Gauss-Kruger zone 13" },
  { value: "EPSG:2328", label: "EPSG:2328 / Xian 1980 / Gauss-Kruger zone 14" },
  { value: "EPSG:2329", label: "EPSG:2329 / Xian 1980 / Gauss-Kruger zone 15" },
  { value: "EPSG:2330", label: "EPSG:2330 / Xian 1980 / Gauss-Kruger zone 16" },
  { value: "EPSG:2331", label: "EPSG:2331 / Xian 1980 / Gauss-Kruger zone 17" },
  { value: "EPSG:2332", label: "EPSG:2332 / Xian 1980 / Gauss-Kruger zone 18" },
  { value: "EPSG:2333", label: "EPSG:2333 / Xian 1980 / Gauss-Kruger zone 19" },
  { value: "EPSG:2334", label: "EPSG:2334 / Xian 1980 / Gauss-Kruger zone 20" },
  { value: "EPSG:2335", label: "EPSG:2335 / Xian 1980 / Gauss-Kruger zone 21" },
  { value: "EPSG:2336", label: "EPSG:2336 / Xian 1980 / Gauss-Kruger zone 22" },
  { value: "EPSG:2337", label: "EPSG:2337 / Xian 1980 / Gauss-Kruger zone 23" },
  { value: "EPSG:2338", label: "EPSG:2338 / Xian 1980 / Gauss-Kruger CM 75E" },
  { value: "EPSG:2339", label: "EPSG:2339 / Xian 1980 / Gauss-Kruger CM 81E" },
  { value: "EPSG:2340", label: "EPSG:2340 / Xian 1980 / Gauss-Kruger CM 87E" },
  { value: "EPSG:2341", label: "EPSG:2341 / Xian 1980 / Gauss-Kruger CM 93E" },
  { value: "EPSG:2342", label: "EPSG:2342 / Xian 1980 / Gauss-Kruger CM 99E" },
  { value: "EPSG:2343", label: "EPSG:2343 / Xian 1980 / Gauss-Kruger CM 105E" },
  { value: "EPSG:2344", label: "EPSG:2344 / Xian 1980 / Gauss-Kruger CM 111E" },
  { value: "EPSG:2345", label: "EPSG:2345 / Xian 1980 / Gauss-Kruger CM 117E" },
  { value: "EPSG:2346", label: "EPSG:2346 / Xian 1980 / Gauss-Kruger CM 123E" },
  { value: "EPSG:2347", label: "EPSG:2347 / Xian 1980 / Gauss-Kruger CM 129E" },
  { value: "EPSG:2348", label: "EPSG:2348 / Xian 1980 / Gauss-Kruger CM 135E" },
  {
    value: "EPSG:2349",
    label: "EPSG:2349 / Xian 1980 / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:2350",
    label: "EPSG:2350 / Xian 1980 / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:2351",
    label: "EPSG:2351 / Xian 1980 / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:2352",
    label: "EPSG:2352 / Xian 1980 / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:2353",
    label: "EPSG:2353 / Xian 1980 / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:2354",
    label: "EPSG:2354 / Xian 1980 / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:2355",
    label: "EPSG:2355 / Xian 1980 / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:2356",
    label: "EPSG:2356 / Xian 1980 / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:2357",
    label: "EPSG:2357 / Xian 1980 / 3-degree Gauss-Kruger zone 33",
  },
  {
    value: "EPSG:2358",
    label: "EPSG:2358 / Xian 1980 / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:2359",
    label: "EPSG:2359 / Xian 1980 / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:2360",
    label: "EPSG:2360 / Xian 1980 / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:2361",
    label: "EPSG:2361 / Xian 1980 / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:2362",
    label: "EPSG:2362 / Xian 1980 / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:2363",
    label: "EPSG:2363 / Xian 1980 / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:2364",
    label: "EPSG:2364 / Xian 1980 / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:2365",
    label: "EPSG:2365 / Xian 1980 / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:2366",
    label: "EPSG:2366 / Xian 1980 / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:2367",
    label: "EPSG:2367 / Xian 1980 / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:2368",
    label: "EPSG:2368 / Xian 1980 / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:2369",
    label: "EPSG:2369 / Xian 1980 / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:2370",
    label: "EPSG:2370 / Xian 1980 / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2371",
    label: "EPSG:2371 / Xian 1980 / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:2372",
    label: "EPSG:2372 / Xian 1980 / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2373",
    label: "EPSG:2373 / Xian 1980 / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:2374",
    label: "EPSG:2374 / Xian 1980 / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2375",
    label: "EPSG:2375 / Xian 1980 / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:2376",
    label: "EPSG:2376 / Xian 1980 / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2377",
    label: "EPSG:2377 / Xian 1980 / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:2378",
    label: "EPSG:2378 / Xian 1980 / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2379",
    label: "EPSG:2379 / Xian 1980 / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:2380",
    label: "EPSG:2380 / Xian 1980 / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2381",
    label: "EPSG:2381 / Xian 1980 / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:2382",
    label: "EPSG:2382 / Xian 1980 / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2383",
    label: "EPSG:2383 / Xian 1980 / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:2384",
    label: "EPSG:2384 / Xian 1980 / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2385",
    label: "EPSG:2385 / Xian 1980 / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:2386",
    label: "EPSG:2386 / Xian 1980 / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2387",
    label: "EPSG:2387 / Xian 1980 / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:2388",
    label: "EPSG:2388 / Xian 1980 / 3-degree Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:2389",
    label: "EPSG:2389 / Xian 1980 / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:2390",
    label: "EPSG:2390 / Xian 1980 / 3-degree Gauss-Kruger CM 135E",
  },
  { value: "EPSG:2391", label: "EPSG:2391 / KKJ / Finland zone 1" },
  { value: "EPSG:2392", label: "EPSG:2392 / KKJ / Finland zone 2" },
  {
    value: "EPSG:2393",
    label: "EPSG:2393 / KKJ / Finland Uniform Coordinate System",
  },
  { value: "EPSG:2394", label: "EPSG:2394 / KKJ / Finland zone 4" },
  {
    value: "EPSG:2395",
    label: "EPSG:2395 / South Yemen / Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:2396",
    label: "EPSG:2396 / South Yemen / Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:2397",
    label: "EPSG:2397 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:2398",
    label: "EPSG:2398 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:2399",
    label: "EPSG:2399 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5",
  },
  { value: "EPSG:2400", label: "EPSG:2400 / RT90 2.5 gon W" },
  {
    value: "EPSG:2401",
    label: "EPSG:2401 / Beijing 1954 / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:2402",
    label: "EPSG:2402 / Beijing 1954 / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:2403",
    label: "EPSG:2403 / Beijing 1954 / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:2404",
    label: "EPSG:2404 / Beijing 1954 / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:2405",
    label: "EPSG:2405 / Beijing 1954 / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:2406",
    label: "EPSG:2406 / Beijing 1954 / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:2407",
    label: "EPSG:2407 / Beijing 1954 / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:2408",
    label: "EPSG:2408 / Beijing 1954 / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:2409",
    label: "EPSG:2409 / Beijing 1954 / 3-degree Gauss-Kruger zone 33",
  },
  {
    value: "EPSG:2410",
    label: "EPSG:2410 / Beijing 1954 / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:2411",
    label: "EPSG:2411 / Beijing 1954 / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:2412",
    label: "EPSG:2412 / Beijing 1954 / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:2413",
    label: "EPSG:2413 / Beijing 1954 / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:2414",
    label: "EPSG:2414 / Beijing 1954 / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:2415",
    label: "EPSG:2415 / Beijing 1954 / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:2416",
    label: "EPSG:2416 / Beijing 1954 / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:2417",
    label: "EPSG:2417 / Beijing 1954 / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:2418",
    label: "EPSG:2418 / Beijing 1954 / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:2419",
    label: "EPSG:2419 / Beijing 1954 / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:2420",
    label: "EPSG:2420 / Beijing 1954 / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:2421",
    label: "EPSG:2421 / Beijing 1954 / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:2422",
    label: "EPSG:2422 / Beijing 1954 / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2423",
    label: "EPSG:2423 / Beijing 1954 / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:2424",
    label: "EPSG:2424 / Beijing 1954 / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2425",
    label: "EPSG:2425 / Beijing 1954 / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:2426",
    label: "EPSG:2426 / Beijing 1954 / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2427",
    label: "EPSG:2427 / Beijing 1954 / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:2428",
    label: "EPSG:2428 / Beijing 1954 / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2429",
    label: "EPSG:2429 / Beijing 1954 / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:2430",
    label: "EPSG:2430 / Beijing 1954 / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2431",
    label: "EPSG:2431 / Beijing 1954 / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:2432",
    label: "EPSG:2432 / Beijing 1954 / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2433",
    label: "EPSG:2433 / Beijing 1954 / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:2434",
    label: "EPSG:2434 / Beijing 1954 / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2435",
    label: "EPSG:2435 / Beijing 1954 / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:2436",
    label: "EPSG:2436 / Beijing 1954 / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2437",
    label: "EPSG:2437 / Beijing 1954 / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:2438",
    label: "EPSG:2438 / Beijing 1954 / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2439",
    label: "EPSG:2439 / Beijing 1954 / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:2440",
    label: "EPSG:2440 / Beijing 1954 / 3-degree Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:2441",
    label: "EPSG:2441 / Beijing 1954 / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:2442",
    label: "EPSG:2442 / Beijing 1954 / 3-degree Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:2443",
    label: "EPSG:2443 / JGD2000 / Japan Plane Rectangular CS I",
  },
  {
    value: "EPSG:2444",
    label: "EPSG:2444 / JGD2000 / Japan Plane Rectangular CS II",
  },
  {
    value: "EPSG:2445",
    label: "EPSG:2445 / JGD2000 / Japan Plane Rectangular CS III",
  },
  {
    value: "EPSG:2446",
    label: "EPSG:2446 / JGD2000 / Japan Plane Rectangular CS IV",
  },
  {
    value: "EPSG:2447",
    label: "EPSG:2447 / JGD2000 / Japan Plane Rectangular CS V",
  },
  {
    value: "EPSG:2448",
    label: "EPSG:2448 / JGD2000 / Japan Plane Rectangular CS VI",
  },
  {
    value: "EPSG:2449",
    label: "EPSG:2449 / JGD2000 / Japan Plane Rectangular CS VII",
  },
  {
    value: "EPSG:2450",
    label: "EPSG:2450 / JGD2000 / Japan Plane Rectangular CS VIII",
  },
  {
    value: "EPSG:2451",
    label: "EPSG:2451 / JGD2000 / Japan Plane Rectangular CS IX",
  },
  {
    value: "EPSG:2452",
    label: "EPSG:2452 / JGD2000 / Japan Plane Rectangular CS X",
  },
  {
    value: "EPSG:2453",
    label: "EPSG:2453 / JGD2000 / Japan Plane Rectangular CS XI",
  },
  {
    value: "EPSG:2454",
    label: "EPSG:2454 / JGD2000 / Japan Plane Rectangular CS XII",
  },
  {
    value: "EPSG:2455",
    label: "EPSG:2455 / JGD2000 / Japan Plane Rectangular CS XIII",
  },
  {
    value: "EPSG:2456",
    label: "EPSG:2456 / JGD2000 / Japan Plane Rectangular CS XIV",
  },
  {
    value: "EPSG:2457",
    label: "EPSG:2457 / JGD2000 / Japan Plane Rectangular CS XV",
  },
  {
    value: "EPSG:2458",
    label: "EPSG:2458 / JGD2000 / Japan Plane Rectangular CS XVI",
  },
  {
    value: "EPSG:2459",
    label: "EPSG:2459 / JGD2000 / Japan Plane Rectangular CS XVII",
  },
  {
    value: "EPSG:2460",
    label: "EPSG:2460 / JGD2000 / Japan Plane Rectangular CS XVIII",
  },
  {
    value: "EPSG:2461",
    label: "EPSG:2461 / JGD2000 / Japan Plane Rectangular CS XIX",
  },
  {
    value: "EPSG:2462",
    label: "EPSG:2462 / Albanian 1987 / Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:2463",
    label: "EPSG:2463 / Pulkovo 1995 / Gauss-Kruger CM 21E",
  },
  {
    value: "EPSG:2464",
    label: "EPSG:2464 / Pulkovo 1995 / Gauss-Kruger CM 27E",
  },
  {
    value: "EPSG:2465",
    label: "EPSG:2465 / Pulkovo 1995 / Gauss-Kruger CM 33E",
  },
  {
    value: "EPSG:2466",
    label: "EPSG:2466 / Pulkovo 1995 / Gauss-Kruger CM 39E",
  },
  {
    value: "EPSG:2467",
    label: "EPSG:2467 / Pulkovo 1995 / Gauss-Kruger CM 45E",
  },
  {
    value: "EPSG:2468",
    label: "EPSG:2468 / Pulkovo 1995 / Gauss-Kruger CM 51E",
  },
  {
    value: "EPSG:2469",
    label: "EPSG:2469 / Pulkovo 1995 / Gauss-Kruger CM 57E",
  },
  {
    value: "EPSG:2470",
    label: "EPSG:2470 / Pulkovo 1995 / Gauss-Kruger CM 63E",
  },
  {
    value: "EPSG:2471",
    label: "EPSG:2471 / Pulkovo 1995 / Gauss-Kruger CM 69E",
  },
  {
    value: "EPSG:2472",
    label: "EPSG:2472 / Pulkovo 1995 / Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2473",
    label: "EPSG:2473 / Pulkovo 1995 / Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2474",
    label: "EPSG:2474 / Pulkovo 1995 / Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2475",
    label: "EPSG:2475 / Pulkovo 1995 / Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2476",
    label: "EPSG:2476 / Pulkovo 1995 / Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2477",
    label: "EPSG:2477 / Pulkovo 1995 / Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2478",
    label: "EPSG:2478 / Pulkovo 1995 / Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2479",
    label: "EPSG:2479 / Pulkovo 1995 / Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2480",
    label: "EPSG:2480 / Pulkovo 1995 / Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2481",
    label: "EPSG:2481 / Pulkovo 1995 / Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:2482",
    label: "EPSG:2482 / Pulkovo 1995 / Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:2483",
    label: "EPSG:2483 / Pulkovo 1995 / Gauss-Kruger CM 141E",
  },
  {
    value: "EPSG:2484",
    label: "EPSG:2484 / Pulkovo 1995 / Gauss-Kruger CM 147E",
  },
  {
    value: "EPSG:2485",
    label: "EPSG:2485 / Pulkovo 1995 / Gauss-Kruger CM 153E",
  },
  {
    value: "EPSG:2486",
    label: "EPSG:2486 / Pulkovo 1995 / Gauss-Kruger CM 159E",
  },
  {
    value: "EPSG:2487",
    label: "EPSG:2487 / Pulkovo 1995 / Gauss-Kruger CM 165E",
  },
  {
    value: "EPSG:2488",
    label: "EPSG:2488 / Pulkovo 1995 / Gauss-Kruger CM 171E",
  },
  {
    value: "EPSG:2489",
    label: "EPSG:2489 / Pulkovo 1995 / Gauss-Kruger CM 177E",
  },
  {
    value: "EPSG:2490",
    label: "EPSG:2490 / Pulkovo 1995 / Gauss-Kruger CM 177W",
  },
  {
    value: "EPSG:2491",
    label: "EPSG:2491 / Pulkovo 1995 / Gauss-Kruger CM 171W",
  },
  {
    value: "EPSG:2492",
    label: "EPSG:2492 / Pulkovo 1942 / Gauss-Kruger CM 9E",
  },
  {
    value: "EPSG:2493",
    label: "EPSG:2493 / Pulkovo 1942 / Gauss-Kruger CM 15E",
  },
  {
    value: "EPSG:2494",
    label: "EPSG:2494 / Pulkovo 1942 / Gauss-Kruger CM 21E",
  },
  {
    value: "EPSG:2495",
    label: "EPSG:2495 / Pulkovo 1942 / Gauss-Kruger CM 27E",
  },
  {
    value: "EPSG:2496",
    label: "EPSG:2496 / Pulkovo 1942 / Gauss-Kruger CM 33E",
  },
  {
    value: "EPSG:2497",
    label: "EPSG:2497 / Pulkovo 1942 / Gauss-Kruger CM 39E",
  },
  {
    value: "EPSG:2498",
    label: "EPSG:2498 / Pulkovo 1942 / Gauss-Kruger CM 45E",
  },
  {
    value: "EPSG:2499",
    label: "EPSG:2499 / Pulkovo 1942 / Gauss-Kruger CM 51E",
  },
  {
    value: "EPSG:2500",
    label: "EPSG:2500 / Pulkovo 1942 / Gauss-Kruger CM 57E",
  },
  {
    value: "EPSG:2501",
    label: "EPSG:2501 / Pulkovo 1942 / Gauss-Kruger CM 63E",
  },
  {
    value: "EPSG:2502",
    label: "EPSG:2502 / Pulkovo 1942 / Gauss-Kruger CM 69E",
  },
  {
    value: "EPSG:2503",
    label: "EPSG:2503 / Pulkovo 1942 / Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2504",
    label: "EPSG:2504 / Pulkovo 1942 / Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2505",
    label: "EPSG:2505 / Pulkovo 1942 / Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2506",
    label: "EPSG:2506 / Pulkovo 1942 / Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2507",
    label: "EPSG:2507 / Pulkovo 1942 / Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2508",
    label: "EPSG:2508 / Pulkovo 1942 / Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2509",
    label: "EPSG:2509 / Pulkovo 1942 / Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2510",
    label: "EPSG:2510 / Pulkovo 1942 / Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2511",
    label: "EPSG:2511 / Pulkovo 1942 / Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2512",
    label: "EPSG:2512 / Pulkovo 1942 / Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:2513",
    label: "EPSG:2513 / Pulkovo 1942 / Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:2514",
    label: "EPSG:2514 / Pulkovo 1942 / Gauss-Kruger CM 141E",
  },
  {
    value: "EPSG:2515",
    label: "EPSG:2515 / Pulkovo 1942 / Gauss-Kruger CM 147E",
  },
  {
    value: "EPSG:2516",
    label: "EPSG:2516 / Pulkovo 1942 / Gauss-Kruger CM 153E",
  },
  {
    value: "EPSG:2517",
    label: "EPSG:2517 / Pulkovo 1942 / Gauss-Kruger CM 159E",
  },
  {
    value: "EPSG:2518",
    label: "EPSG:2518 / Pulkovo 1942 / Gauss-Kruger CM 165E",
  },
  {
    value: "EPSG:2519",
    label: "EPSG:2519 / Pulkovo 1942 / Gauss-Kruger CM 171E",
  },
  {
    value: "EPSG:2520",
    label: "EPSG:2520 / Pulkovo 1942 / Gauss-Kruger CM 177E",
  },
  {
    value: "EPSG:2521",
    label: "EPSG:2521 / Pulkovo 1942 / Gauss-Kruger CM 177W",
  },
  {
    value: "EPSG:2522",
    label: "EPSG:2522 / Pulkovo 1942 / Gauss-Kruger CM 171W",
  },
  {
    value: "EPSG:2523",
    label: "EPSG:2523 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:2524",
    label: "EPSG:2524 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:2525",
    label: "EPSG:2525 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:2526",
    label: "EPSG:2526 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:2527",
    label: "EPSG:2527 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:2528",
    label: "EPSG:2528 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:2529",
    label: "EPSG:2529 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:2530",
    label: "EPSG:2530 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:2531",
    label: "EPSG:2531 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:2532",
    label: "EPSG:2532 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:2533",
    label: "EPSG:2533 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:2534",
    label: "EPSG:2534 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:2535",
    label: "EPSG:2535 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:2536",
    label: "EPSG:2536 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:2537",
    label: "EPSG:2537 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:2538",
    label: "EPSG:2538 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:2539",
    label: "EPSG:2539 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:2540",
    label: "EPSG:2540 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 24",
  },
  {
    value: "EPSG:2541",
    label: "EPSG:2541 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:2542",
    label: "EPSG:2542 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:2543",
    label: "EPSG:2543 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:2544",
    label: "EPSG:2544 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:2545",
    label: "EPSG:2545 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:2546",
    label: "EPSG:2546 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:2547",
    label: "EPSG:2547 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:2548",
    label: "EPSG:2548 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:2549",
    label: "EPSG:2549 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 33",
  },
  { value: "EPSG:2550", label: "EPSG:2550 / Samboja / UTM zone 50S" },
  {
    value: "EPSG:2551",
    label: "EPSG:2551 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:2552",
    label: "EPSG:2552 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:2553",
    label: "EPSG:2553 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:2554",
    label: "EPSG:2554 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:2555",
    label: "EPSG:2555 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:2556",
    label: "EPSG:2556 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:2557",
    label: "EPSG:2557 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:2558",
    label: "EPSG:2558 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:2559",
    label: "EPSG:2559 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:2560",
    label: "EPSG:2560 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:2561",
    label: "EPSG:2561 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:2562",
    label: "EPSG:2562 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:2563",
    label: "EPSG:2563 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 46",
  },
  {
    value: "EPSG:2564",
    label: "EPSG:2564 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 47",
  },
  {
    value: "EPSG:2565",
    label: "EPSG:2565 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 48",
  },
  {
    value: "EPSG:2566",
    label: "EPSG:2566 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 49",
  },
  {
    value: "EPSG:2567",
    label: "EPSG:2567 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 50",
  },
  {
    value: "EPSG:2568",
    label: "EPSG:2568 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 51",
  },
  {
    value: "EPSG:2569",
    label: "EPSG:2569 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 52",
  },
  {
    value: "EPSG:2570",
    label: "EPSG:2570 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 53",
  },
  {
    value: "EPSG:2571",
    label: "EPSG:2571 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 54",
  },
  {
    value: "EPSG:2572",
    label: "EPSG:2572 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 55",
  },
  {
    value: "EPSG:2573",
    label: "EPSG:2573 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 56",
  },
  {
    value: "EPSG:2574",
    label: "EPSG:2574 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 57",
  },
  {
    value: "EPSG:2575",
    label: "EPSG:2575 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 58",
  },
  {
    value: "EPSG:2576",
    label: "EPSG:2576 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 59",
  },
  {
    value: "EPSG:2577",
    label: "EPSG:2577 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 60",
  },
  {
    value: "EPSG:2578",
    label: "EPSG:2578 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 61",
  },
  {
    value: "EPSG:2579",
    label: "EPSG:2579 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 62",
  },
  {
    value: "EPSG:2580",
    label: "EPSG:2580 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 63",
  },
  {
    value: "EPSG:2581",
    label: "EPSG:2581 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 64",
  },
  {
    value: "EPSG:2582",
    label: "EPSG:2582 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 21E",
  },
  {
    value: "EPSG:2583",
    label: "EPSG:2583 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 24E",
  },
  {
    value: "EPSG:2584",
    label: "EPSG:2584 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 27E",
  },
  {
    value: "EPSG:2585",
    label: "EPSG:2585 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 30E",
  },
  {
    value: "EPSG:2586",
    label: "EPSG:2586 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 33E",
  },
  {
    value: "EPSG:2587",
    label: "EPSG:2587 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 36E",
  },
  {
    value: "EPSG:2588",
    label: "EPSG:2588 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 39E",
  },
  {
    value: "EPSG:2589",
    label: "EPSG:2589 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 42E",
  },
  {
    value: "EPSG:2590",
    label: "EPSG:2590 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 45E",
  },
  {
    value: "EPSG:2591",
    label: "EPSG:2591 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 48E",
  },
  {
    value: "EPSG:2592",
    label: "EPSG:2592 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 51E",
  },
  {
    value: "EPSG:2593",
    label: "EPSG:2593 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 54E",
  },
  {
    value: "EPSG:2594",
    label: "EPSG:2594 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 57E",
  },
  {
    value: "EPSG:2595",
    label: "EPSG:2595 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 60E",
  },
  {
    value: "EPSG:2596",
    label: "EPSG:2596 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 63E",
  },
  {
    value: "EPSG:2597",
    label: "EPSG:2597 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 66E",
  },
  {
    value: "EPSG:2598",
    label: "EPSG:2598 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 69E",
  },
  {
    value: "EPSG:2599",
    label: "EPSG:2599 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 72E",
  },
  { value: "EPSG:2600", label: "EPSG:2600 / Lietuvos Koordinoei Sistema 1994" },
  {
    value: "EPSG:2601",
    label: "EPSG:2601 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2602",
    label: "EPSG:2602 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:2603",
    label: "EPSG:2603 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2604",
    label: "EPSG:2604 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:2605",
    label: "EPSG:2605 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2606",
    label: "EPSG:2606 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:2607",
    label: "EPSG:2607 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2608",
    label: "EPSG:2608 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:2609",
    label: "EPSG:2609 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2610",
    label: "EPSG:2610 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:2611",
    label: "EPSG:2611 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2612",
    label: "EPSG:2612 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:2613",
    label: "EPSG:2613 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2614",
    label: "EPSG:2614 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:2615",
    label: "EPSG:2615 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2616",
    label: "EPSG:2616 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:2617",
    label: "EPSG:2617 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2618",
    label: "EPSG:2618 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:2619",
    label: "EPSG:2619 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:2620",
    label: "EPSG:2620 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:2621",
    label: "EPSG:2621 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:2622",
    label: "EPSG:2622 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 138E",
  },
  {
    value: "EPSG:2623",
    label: "EPSG:2623 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 141E",
  },
  {
    value: "EPSG:2624",
    label: "EPSG:2624 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 144E",
  },
  {
    value: "EPSG:2625",
    label: "EPSG:2625 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 147E",
  },
  {
    value: "EPSG:2626",
    label: "EPSG:2626 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 150E",
  },
  {
    value: "EPSG:2627",
    label: "EPSG:2627 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 153E",
  },
  {
    value: "EPSG:2628",
    label: "EPSG:2628 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 156E",
  },
  {
    value: "EPSG:2629",
    label: "EPSG:2629 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 159E",
  },
  {
    value: "EPSG:2630",
    label: "EPSG:2630 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 162E",
  },
  {
    value: "EPSG:2631",
    label: "EPSG:2631 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 165E",
  },
  {
    value: "EPSG:2632",
    label: "EPSG:2632 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 168E",
  },
  {
    value: "EPSG:2633",
    label: "EPSG:2633 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 171E",
  },
  {
    value: "EPSG:2634",
    label: "EPSG:2634 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 174E",
  },
  {
    value: "EPSG:2635",
    label: "EPSG:2635 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 177E",
  },
  {
    value: "EPSG:2636",
    label: "EPSG:2636 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 180E",
  },
  {
    value: "EPSG:2637",
    label: "EPSG:2637 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 177W",
  },
  {
    value: "EPSG:2638",
    label: "EPSG:2638 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 174W",
  },
  {
    value: "EPSG:2639",
    label: "EPSG:2639 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 171W",
  },
  {
    value: "EPSG:2640",
    label: "EPSG:2640 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 168W",
  },
  {
    value: "EPSG:2641",
    label: "EPSG:2641 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:2642",
    label: "EPSG:2642 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:2643",
    label: "EPSG:2643 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:2644",
    label: "EPSG:2644 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:2645",
    label: "EPSG:2645 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:2646",
    label: "EPSG:2646 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:2647",
    label: "EPSG:2647 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:2648",
    label: "EPSG:2648 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:2649",
    label: "EPSG:2649 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:2650",
    label: "EPSG:2650 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:2651",
    label: "EPSG:2651 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:2652",
    label: "EPSG:2652 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:2653",
    label: "EPSG:2653 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:2654",
    label: "EPSG:2654 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:2655",
    label: "EPSG:2655 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:2656",
    label: "EPSG:2656 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:2657",
    label: "EPSG:2657 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:2658",
    label: "EPSG:2658 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 24",
  },
  {
    value: "EPSG:2659",
    label: "EPSG:2659 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:2660",
    label: "EPSG:2660 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:2661",
    label: "EPSG:2661 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:2662",
    label: "EPSG:2662 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:2663",
    label: "EPSG:2663 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:2664",
    label: "EPSG:2664 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:2665",
    label: "EPSG:2665 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:2666",
    label: "EPSG:2666 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:2667",
    label: "EPSG:2667 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 33",
  },
  {
    value: "EPSG:2668",
    label: "EPSG:2668 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:2669",
    label: "EPSG:2669 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:2670",
    label: "EPSG:2670 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:2671",
    label: "EPSG:2671 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:2672",
    label: "EPSG:2672 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:2673",
    label: "EPSG:2673 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:2674",
    label: "EPSG:2674 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:2675",
    label: "EPSG:2675 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:2676",
    label: "EPSG:2676 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:2677",
    label: "EPSG:2677 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:2678",
    label: "EPSG:2678 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:2679",
    label: "EPSG:2679 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:2680",
    label: "EPSG:2680 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 46",
  },
  {
    value: "EPSG:2681",
    label: "EPSG:2681 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 47",
  },
  {
    value: "EPSG:2682",
    label: "EPSG:2682 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 48",
  },
  {
    value: "EPSG:2683",
    label: "EPSG:2683 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 49",
  },
  {
    value: "EPSG:2684",
    label: "EPSG:2684 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 50",
  },
  {
    value: "EPSG:2685",
    label: "EPSG:2685 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 51",
  },
  {
    value: "EPSG:2686",
    label: "EPSG:2686 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 52",
  },
  {
    value: "EPSG:2687",
    label: "EPSG:2687 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 53",
  },
  {
    value: "EPSG:2688",
    label: "EPSG:2688 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 54",
  },
  {
    value: "EPSG:2689",
    label: "EPSG:2689 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 55",
  },
  {
    value: "EPSG:2690",
    label: "EPSG:2690 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 56",
  },
  {
    value: "EPSG:2691",
    label: "EPSG:2691 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 57",
  },
  {
    value: "EPSG:2692",
    label: "EPSG:2692 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 58",
  },
  {
    value: "EPSG:2693",
    label: "EPSG:2693 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 59",
  },
  {
    value: "EPSG:2694",
    label: "EPSG:2694 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 60",
  },
  {
    value: "EPSG:2695",
    label: "EPSG:2695 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 61",
  },
  {
    value: "EPSG:2696",
    label: "EPSG:2696 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 62",
  },
  {
    value: "EPSG:2697",
    label: "EPSG:2697 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 63",
  },
  {
    value: "EPSG:2698",
    label: "EPSG:2698 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 64",
  },
  {
    value: "EPSG:2699",
    label: "EPSG:2699 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 21E",
  },
  {
    value: "EPSG:2700",
    label: "EPSG:2700 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 24E",
  },
  {
    value: "EPSG:2701",
    label: "EPSG:2701 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 27E",
  },
  {
    value: "EPSG:2702",
    label: "EPSG:2702 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 30E",
  },
  {
    value: "EPSG:2703",
    label: "EPSG:2703 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 33E",
  },
  {
    value: "EPSG:2704",
    label: "EPSG:2704 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 36E",
  },
  {
    value: "EPSG:2705",
    label: "EPSG:2705 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 39E",
  },
  {
    value: "EPSG:2706",
    label: "EPSG:2706 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 42E",
  },
  {
    value: "EPSG:2707",
    label: "EPSG:2707 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 45E",
  },
  {
    value: "EPSG:2708",
    label: "EPSG:2708 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 48E",
  },
  {
    value: "EPSG:2709",
    label: "EPSG:2709 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 51E",
  },
  {
    value: "EPSG:2710",
    label: "EPSG:2710 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 54E",
  },
  {
    value: "EPSG:2711",
    label: "EPSG:2711 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 57E",
  },
  {
    value: "EPSG:2712",
    label: "EPSG:2712 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 60E",
  },
  {
    value: "EPSG:2713",
    label: "EPSG:2713 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 63E",
  },
  {
    value: "EPSG:2714",
    label: "EPSG:2714 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 66E",
  },
  {
    value: "EPSG:2715",
    label: "EPSG:2715 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 69E",
  },
  {
    value: "EPSG:2716",
    label: "EPSG:2716 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 72E",
  },
  {
    value: "EPSG:2717",
    label: "EPSG:2717 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:2718",
    label: "EPSG:2718 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:2719",
    label: "EPSG:2719 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:2720",
    label: "EPSG:2720 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:2721",
    label: "EPSG:2721 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:2722",
    label: "EPSG:2722 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:2723",
    label: "EPSG:2723 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:2724",
    label: "EPSG:2724 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:2725",
    label: "EPSG:2725 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:2726",
    label: "EPSG:2726 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:2727",
    label: "EPSG:2727 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:2728",
    label: "EPSG:2728 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:2729",
    label: "EPSG:2729 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:2730",
    label: "EPSG:2730 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:2731",
    label: "EPSG:2731 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:2732",
    label: "EPSG:2732 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:2733",
    label: "EPSG:2733 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:2734",
    label: "EPSG:2734 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:2735",
    label: "EPSG:2735 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 129E",
  },
  { value: "EPSG:2736", label: "EPSG:2736 / Tete / UTM zone 36S" },
  { value: "EPSG:2737", label: "EPSG:2737 / Tete / UTM zone 37S" },
  {
    value: "EPSG:2738",
    label: "EPSG:2738 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:2739",
    label: "EPSG:2739 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:2740",
    label: "EPSG:2740 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 138E",
  },
  {
    value: "EPSG:2741",
    label: "EPSG:2741 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 141E",
  },
  {
    value: "EPSG:2742",
    label: "EPSG:2742 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 144E",
  },
  {
    value: "EPSG:2743",
    label: "EPSG:2743 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 147E",
  },
  {
    value: "EPSG:2744",
    label: "EPSG:2744 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 150E",
  },
  {
    value: "EPSG:2745",
    label: "EPSG:2745 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 153E",
  },
  {
    value: "EPSG:2746",
    label: "EPSG:2746 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 156E",
  },
  {
    value: "EPSG:2747",
    label: "EPSG:2747 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 159E",
  },
  {
    value: "EPSG:2748",
    label: "EPSG:2748 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 162E",
  },
  {
    value: "EPSG:2749",
    label: "EPSG:2749 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 165E",
  },
  {
    value: "EPSG:2750",
    label: "EPSG:2750 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 168E",
  },
  {
    value: "EPSG:2751",
    label: "EPSG:2751 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 171E",
  },
  {
    value: "EPSG:2752",
    label: "EPSG:2752 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 174E",
  },
  {
    value: "EPSG:2753",
    label: "EPSG:2753 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 177E",
  },
  {
    value: "EPSG:2754",
    label: "EPSG:2754 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 180E",
  },
  {
    value: "EPSG:2755",
    label: "EPSG:2755 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 177W",
  },
  {
    value: "EPSG:2756",
    label: "EPSG:2756 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 174W",
  },
  {
    value: "EPSG:2757",
    label: "EPSG:2757 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 171W",
  },
  {
    value: "EPSG:2758",
    label: "EPSG:2758 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 168W",
  },
  { value: "EPSG:2759", label: "EPSG:2759 / NAD83(HARN) / Alabama East" },
  { value: "EPSG:2760", label: "EPSG:2760 / NAD83(HARN) / Alabama West" },
  { value: "EPSG:2761", label: "EPSG:2761 / NAD83(HARN) / Arizona East" },
  { value: "EPSG:2762", label: "EPSG:2762 / NAD83(HARN) / Arizona Central" },
  { value: "EPSG:2763", label: "EPSG:2763 / NAD83(HARN) / Arizona West" },
  { value: "EPSG:2764", label: "EPSG:2764 / NAD83(HARN) / Arkansas North" },
  { value: "EPSG:2765", label: "EPSG:2765 / NAD83(HARN) / Arkansas South" },
  { value: "EPSG:2766", label: "EPSG:2766 / NAD83(HARN) / California zone 1" },
  { value: "EPSG:2767", label: "EPSG:2767 / NAD83(HARN) / California zone 2" },
  { value: "EPSG:2768", label: "EPSG:2768 / NAD83(HARN) / California zone 3" },
  { value: "EPSG:2769", label: "EPSG:2769 / NAD83(HARN) / California zone 4" },
  { value: "EPSG:2770", label: "EPSG:2770 / NAD83(HARN) / California zone 5" },
  { value: "EPSG:2771", label: "EPSG:2771 / NAD83(HARN) / California zone 6" },
  { value: "EPSG:2772", label: "EPSG:2772 / NAD83(HARN) / Colorado North" },
  { value: "EPSG:2773", label: "EPSG:2773 / NAD83(HARN) / Colorado Central" },
  { value: "EPSG:2774", label: "EPSG:2774 / NAD83(HARN) / Colorado South" },
  { value: "EPSG:2775", label: "EPSG:2775 / NAD83(HARN) / Connecticut" },
  { value: "EPSG:2776", label: "EPSG:2776 / NAD83(HARN) / Delaware" },
  { value: "EPSG:2777", label: "EPSG:2777 / NAD83(HARN) / Florida East" },
  { value: "EPSG:2778", label: "EPSG:2778 / NAD83(HARN) / Florida West" },
  { value: "EPSG:2779", label: "EPSG:2779 / NAD83(HARN) / Florida North" },
  { value: "EPSG:2780", label: "EPSG:2780 / NAD83(HARN) / Georgia East" },
  { value: "EPSG:2781", label: "EPSG:2781 / NAD83(HARN) / Georgia West" },
  { value: "EPSG:2782", label: "EPSG:2782 / NAD83(HARN) / Hawaii zone 1" },
  { value: "EPSG:2783", label: "EPSG:2783 / NAD83(HARN) / Hawaii zone 2" },
  { value: "EPSG:2784", label: "EPSG:2784 / NAD83(HARN) / Hawaii zone 3" },
  { value: "EPSG:2785", label: "EPSG:2785 / NAD83(HARN) / Hawaii zone 4" },
  { value: "EPSG:2786", label: "EPSG:2786 / NAD83(HARN) / Hawaii zone 5" },
  { value: "EPSG:2787", label: "EPSG:2787 / NAD83(HARN) / Idaho East" },
  { value: "EPSG:2788", label: "EPSG:2788 / NAD83(HARN) / Idaho Central" },
  { value: "EPSG:2789", label: "EPSG:2789 / NAD83(HARN) / Idaho West" },
  { value: "EPSG:2790", label: "EPSG:2790 / NAD83(HARN) / Illinois East" },
  { value: "EPSG:2791", label: "EPSG:2791 / NAD83(HARN) / Illinois West" },
  { value: "EPSG:2792", label: "EPSG:2792 / NAD83(HARN) / Indiana East" },
  { value: "EPSG:2793", label: "EPSG:2793 / NAD83(HARN) / Indiana West" },
  { value: "EPSG:2794", label: "EPSG:2794 / NAD83(HARN) / Iowa North" },
  { value: "EPSG:2795", label: "EPSG:2795 / NAD83(HARN) / Iowa South" },
  { value: "EPSG:2796", label: "EPSG:2796 / NAD83(HARN) / Kansas North" },
  { value: "EPSG:2797", label: "EPSG:2797 / NAD83(HARN) / Kansas South" },
  { value: "EPSG:2798", label: "EPSG:2798 / NAD83(HARN) / Kentucky North" },
  { value: "EPSG:2799", label: "EPSG:2799 / NAD83(HARN) / Kentucky South" },
  { value: "EPSG:2800", label: "EPSG:2800 / NAD83(HARN) / Louisiana North" },
  { value: "EPSG:2801", label: "EPSG:2801 / NAD83(HARN) / Louisiana South" },
  { value: "EPSG:2802", label: "EPSG:2802 / NAD83(HARN) / Maine East" },
  { value: "EPSG:2803", label: "EPSG:2803 / NAD83(HARN) / Maine West" },
  { value: "EPSG:2804", label: "EPSG:2804 / NAD83(HARN) / Maryland" },
  {
    value: "EPSG:2805",
    label: "EPSG:2805 / NAD83(HARN) / Massachusetts Mainland",
  },
  {
    value: "EPSG:2806",
    label: "EPSG:2806 / NAD83(HARN) / Massachusetts Island",
  },
  { value: "EPSG:2807", label: "EPSG:2807 / NAD83(HARN) / Michigan North" },
  { value: "EPSG:2808", label: "EPSG:2808 / NAD83(HARN) / Michigan Central" },
  { value: "EPSG:2809", label: "EPSG:2809 / NAD83(HARN) / Michigan South" },
  { value: "EPSG:2810", label: "EPSG:2810 / NAD83(HARN) / Minnesota North" },
  { value: "EPSG:2811", label: "EPSG:2811 / NAD83(HARN) / Minnesota Central" },
  { value: "EPSG:2812", label: "EPSG:2812 / NAD83(HARN) / Minnesota South" },
  { value: "EPSG:2813", label: "EPSG:2813 / NAD83(HARN) / Mississippi East" },
  { value: "EPSG:2814", label: "EPSG:2814 / NAD83(HARN) / Mississippi West" },
  { value: "EPSG:2815", label: "EPSG:2815 / NAD83(HARN) / Missouri East" },
  { value: "EPSG:2816", label: "EPSG:2816 / NAD83(HARN) / Missouri Central" },
  { value: "EPSG:2817", label: "EPSG:2817 / NAD83(HARN) / Missouri West" },
  { value: "EPSG:2818", label: "EPSG:2818 / NAD83(HARN) / Montana" },
  { value: "EPSG:2819", label: "EPSG:2819 / NAD83(HARN) / Nebraska" },
  { value: "EPSG:2820", label: "EPSG:2820 / NAD83(HARN) / Nevada East" },
  { value: "EPSG:2821", label: "EPSG:2821 / NAD83(HARN) / Nevada Central" },
  { value: "EPSG:2822", label: "EPSG:2822 / NAD83(HARN) / Nevada West" },
  { value: "EPSG:2823", label: "EPSG:2823 / NAD83(HARN) / New Hampshire" },
  { value: "EPSG:2824", label: "EPSG:2824 / NAD83(HARN) / New Jersey" },
  { value: "EPSG:2825", label: "EPSG:2825 / NAD83(HARN) / New Mexico East" },
  { value: "EPSG:2826", label: "EPSG:2826 / NAD83(HARN) / New Mexico Central" },
  { value: "EPSG:2827", label: "EPSG:2827 / NAD83(HARN) / New Mexico West" },
  { value: "EPSG:2828", label: "EPSG:2828 / NAD83(HARN) / New York East" },
  { value: "EPSG:2829", label: "EPSG:2829 / NAD83(HARN) / New York Central" },
  { value: "EPSG:2830", label: "EPSG:2830 / NAD83(HARN) / New York West" },
  {
    value: "EPSG:2831",
    label: "EPSG:2831 / NAD83(HARN) / New York Long Island",
  },
  { value: "EPSG:2832", label: "EPSG:2832 / NAD83(HARN) / North Dakota North" },
  { value: "EPSG:2833", label: "EPSG:2833 / NAD83(HARN) / North Dakota South" },
  { value: "EPSG:2834", label: "EPSG:2834 / NAD83(HARN) / Ohio North" },
  { value: "EPSG:2835", label: "EPSG:2835 / NAD83(HARN) / Ohio South" },
  { value: "EPSG:2836", label: "EPSG:2836 / NAD83(HARN) / Oklahoma North" },
  { value: "EPSG:2837", label: "EPSG:2837 / NAD83(HARN) / Oklahoma South" },
  { value: "EPSG:2838", label: "EPSG:2838 / NAD83(HARN) / Oregon North" },
  { value: "EPSG:2839", label: "EPSG:2839 / NAD83(HARN) / Oregon South" },
  { value: "EPSG:2840", label: "EPSG:2840 / NAD83(HARN) / Rhode Island" },
  { value: "EPSG:2841", label: "EPSG:2841 / NAD83(HARN) / South Dakota North" },
  { value: "EPSG:2842", label: "EPSG:2842 / NAD83(HARN) / South Dakota South" },
  { value: "EPSG:2843", label: "EPSG:2843 / NAD83(HARN) / Tennessee" },
  { value: "EPSG:2844", label: "EPSG:2844 / NAD83(HARN) / Texas North" },
  {
    value: "EPSG:2845",
    label: "EPSG:2845 / NAD83(HARN) / Texas North Central",
  },
  { value: "EPSG:2846", label: "EPSG:2846 / NAD83(HARN) / Texas Central" },
  {
    value: "EPSG:2847",
    label: "EPSG:2847 / NAD83(HARN) / Texas South Central",
  },
  { value: "EPSG:2848", label: "EPSG:2848 / NAD83(HARN) / Texas South" },
  { value: "EPSG:2849", label: "EPSG:2849 / NAD83(HARN) / Utah North" },
  { value: "EPSG:2850", label: "EPSG:2850 / NAD83(HARN) / Utah Central" },
  { value: "EPSG:2851", label: "EPSG:2851 / NAD83(HARN) / Utah South" },
  { value: "EPSG:2852", label: "EPSG:2852 / NAD83(HARN) / Vermont" },
  { value: "EPSG:2853", label: "EPSG:2853 / NAD83(HARN) / Virginia North" },
  { value: "EPSG:2854", label: "EPSG:2854 / NAD83(HARN) / Virginia South" },
  { value: "EPSG:2855", label: "EPSG:2855 / NAD83(HARN) / Washington North" },
  { value: "EPSG:2856", label: "EPSG:2856 / NAD83(HARN) / Washington South" },
  {
    value: "EPSG:2857",
    label: "EPSG:2857 / NAD83(HARN) / West Virginia North",
  },
  {
    value: "EPSG:2858",
    label: "EPSG:2858 / NAD83(HARN) / West Virginia South",
  },
  { value: "EPSG:2859", label: "EPSG:2859 / NAD83(HARN) / Wisconsin North" },
  { value: "EPSG:2860", label: "EPSG:2860 / NAD83(HARN) / Wisconsin Central" },
  { value: "EPSG:2861", label: "EPSG:2861 / NAD83(HARN) / Wisconsin South" },
  { value: "EPSG:2862", label: "EPSG:2862 / NAD83(HARN) / Wyoming East" },
  {
    value: "EPSG:2863",
    label: "EPSG:2863 / NAD83(HARN) / Wyoming East Central",
  },
  {
    value: "EPSG:2864",
    label: "EPSG:2864 / NAD83(HARN) / Wyoming West Central",
  },
  { value: "EPSG:2865", label: "EPSG:2865 / NAD83(HARN) / Wyoming West" },
  {
    value: "EPSG:2866",
    label: "EPSG:2866 / NAD83(HARN) / Puerto Rico and Virgin Is.",
  },
  { value: "EPSG:2867", label: "EPSG:2867 / NAD83(HARN) / Arizona East (ft)" },
  {
    value: "EPSG:2868",
    label: "EPSG:2868 / NAD83(HARN) / Arizona Central (ft)",
  },
  { value: "EPSG:2869", label: "EPSG:2869 / NAD83(HARN) / Arizona West (ft)" },
  {
    value: "EPSG:2870",
    label: "EPSG:2870 / NAD83(HARN) / California zone 1 (ftUS)",
  },
  {
    value: "EPSG:2871",
    label: "EPSG:2871 / NAD83(HARN) / California zone 2 (ftUS)",
  },
  {
    value: "EPSG:2872",
    label: "EPSG:2872 / NAD83(HARN) / California zone 3 (ftUS)",
  },
  {
    value: "EPSG:2873",
    label: "EPSG:2873 / NAD83(HARN) / California zone 4 (ftUS)",
  },
  {
    value: "EPSG:2874",
    label: "EPSG:2874 / NAD83(HARN) / California zone 5 (ftUS)",
  },
  {
    value: "EPSG:2875",
    label: "EPSG:2875 / NAD83(HARN) / California zone 6 (ftUS)",
  },
  {
    value: "EPSG:2876",
    label: "EPSG:2876 / NAD83(HARN) / Colorado North (ftUS)",
  },
  {
    value: "EPSG:2877",
    label: "EPSG:2877 / NAD83(HARN) / Colorado Central (ftUS)",
  },
  {
    value: "EPSG:2878",
    label: "EPSG:2878 / NAD83(HARN) / Colorado South (ftUS)",
  },
  { value: "EPSG:2879", label: "EPSG:2879 / NAD83(HARN) / Connecticut (ftUS)" },
  { value: "EPSG:2880", label: "EPSG:2880 / NAD83(HARN) / Delaware (ftUS)" },
  {
    value: "EPSG:2881",
    label: "EPSG:2881 / NAD83(HARN) / Florida East (ftUS)",
  },
  {
    value: "EPSG:2882",
    label: "EPSG:2882 / NAD83(HARN) / Florida West (ftUS)",
  },
  {
    value: "EPSG:2883",
    label: "EPSG:2883 / NAD83(HARN) / Florida North (ftUS)",
  },
  {
    value: "EPSG:2884",
    label: "EPSG:2884 / NAD83(HARN) / Georgia East (ftUS)",
  },
  {
    value: "EPSG:2885",
    label: "EPSG:2885 / NAD83(HARN) / Georgia West (ftUS)",
  },
  { value: "EPSG:2886", label: "EPSG:2886 / NAD83(HARN) / Idaho East (ftUS)" },
  {
    value: "EPSG:2887",
    label: "EPSG:2887 / NAD83(HARN) / Idaho Central (ftUS)",
  },
  { value: "EPSG:2888", label: "EPSG:2888 / NAD83(HARN) / Idaho West (ftUS)" },
  {
    value: "EPSG:2889",
    label: "EPSG:2889 / NAD83(HARN) / Indiana East (ftUS)",
  },
  {
    value: "EPSG:2890",
    label: "EPSG:2890 / NAD83(HARN) / Indiana West (ftUS)",
  },
  {
    value: "EPSG:2891",
    label: "EPSG:2891 / NAD83(HARN) / Kentucky North (ftUS)",
  },
  {
    value: "EPSG:2892",
    label: "EPSG:2892 / NAD83(HARN) / Kentucky South (ftUS)",
  },
  { value: "EPSG:2893", label: "EPSG:2893 / NAD83(HARN) / Maryland (ftUS)" },
  {
    value: "EPSG:2894",
    label: "EPSG:2894 / NAD83(HARN) / Massachusetts Mainland (ftUS)",
  },
  {
    value: "EPSG:2895",
    label: "EPSG:2895 / NAD83(HARN) / Massachusetts Island (ftUS)",
  },
  {
    value: "EPSG:2896",
    label: "EPSG:2896 / NAD83(HARN) / Michigan North (ft)",
  },
  {
    value: "EPSG:2897",
    label: "EPSG:2897 / NAD83(HARN) / Michigan Central (ft)",
  },
  {
    value: "EPSG:2898",
    label: "EPSG:2898 / NAD83(HARN) / Michigan South (ft)",
  },
  {
    value: "EPSG:2899",
    label: "EPSG:2899 / NAD83(HARN) / Mississippi East (ftUS)",
  },
  {
    value: "EPSG:2900",
    label: "EPSG:2900 / NAD83(HARN) / Mississippi West (ftUS)",
  },
  { value: "EPSG:2901", label: "EPSG:2901 / NAD83(HARN) / Montana (ft)" },
  {
    value: "EPSG:2902",
    label: "EPSG:2902 / NAD83(HARN) / New Mexico East (ftUS)",
  },
  {
    value: "EPSG:2903",
    label: "EPSG:2903 / NAD83(HARN) / New Mexico Central (ftUS)",
  },
  {
    value: "EPSG:2904",
    label: "EPSG:2904 / NAD83(HARN) / New Mexico West (ftUS)",
  },
  {
    value: "EPSG:2905",
    label: "EPSG:2905 / NAD83(HARN) / New York East (ftUS)",
  },
  {
    value: "EPSG:2906",
    label: "EPSG:2906 / NAD83(HARN) / New York Central (ftUS)",
  },
  {
    value: "EPSG:2907",
    label: "EPSG:2907 / NAD83(HARN) / New York West (ftUS)",
  },
  {
    value: "EPSG:2908",
    label: "EPSG:2908 / NAD83(HARN) / New York Long Island (ftUS)",
  },
  {
    value: "EPSG:2909",
    label: "EPSG:2909 / NAD83(HARN) / North Dakota North (ft)",
  },
  {
    value: "EPSG:2910",
    label: "EPSG:2910 / NAD83(HARN) / North Dakota South (ft)",
  },
  {
    value: "EPSG:2911",
    label: "EPSG:2911 / NAD83(HARN) / Oklahoma North (ftUS)",
  },
  {
    value: "EPSG:2912",
    label: "EPSG:2912 / NAD83(HARN) / Oklahoma South (ftUS)",
  },
  { value: "EPSG:2913", label: "EPSG:2913 / NAD83(HARN) / Oregon North (ft)" },
  { value: "EPSG:2914", label: "EPSG:2914 / NAD83(HARN) / Oregon South (ft)" },
  { value: "EPSG:2915", label: "EPSG:2915 / NAD83(HARN) / Tennessee (ftUS)" },
  { value: "EPSG:2916", label: "EPSG:2916 / NAD83(HARN) / Texas North (ftUS)" },
  {
    value: "EPSG:2917",
    label: "EPSG:2917 / NAD83(HARN) / Texas North Central (ftUS)",
  },
  {
    value: "EPSG:2918",
    label: "EPSG:2918 / NAD83(HARN) / Texas Central (ftUS)",
  },
  {
    value: "EPSG:2919",
    label: "EPSG:2919 / NAD83(HARN) / Texas South Central (ftUS)",
  },
  { value: "EPSG:2920", label: "EPSG:2920 / NAD83(HARN) / Texas South (ftUS)" },
  { value: "EPSG:2921", label: "EPSG:2921 / NAD83(HARN) / Utah North (ft)" },
  { value: "EPSG:2922", label: "EPSG:2922 / NAD83(HARN) / Utah Central (ft)" },
  { value: "EPSG:2923", label: "EPSG:2923 / NAD83(HARN) / Utah South (ft)" },
  {
    value: "EPSG:2924",
    label: "EPSG:2924 / NAD83(HARN) / Virginia North (ftUS)",
  },
  {
    value: "EPSG:2925",
    label: "EPSG:2925 / NAD83(HARN) / Virginia South (ftUS)",
  },
  {
    value: "EPSG:2926",
    label: "EPSG:2926 / NAD83(HARN) / Washington North (ftUS)",
  },
  {
    value: "EPSG:2927",
    label: "EPSG:2927 / NAD83(HARN) / Washington South (ftUS)",
  },
  {
    value: "EPSG:2928",
    label: "EPSG:2928 / NAD83(HARN) / Wisconsin North (ftUS)",
  },
  {
    value: "EPSG:2929",
    label: "EPSG:2929 / NAD83(HARN) / Wisconsin Central (ftUS)",
  },
  {
    value: "EPSG:2930",
    label: "EPSG:2930 / NAD83(HARN) / Wisconsin South (ftUS)",
  },
  { value: "EPSG:2931", label: "EPSG:2931 / Beduaram / TM 13 NE" },
  { value: "EPSG:2932", label: "EPSG:2932 / QND95 / Qatar National Grid" },
  { value: "EPSG:2933", label: "EPSG:2933 / Segara / UTM zone 50S" },
  { value: "EPSG:2934", label: "EPSG:2934 / Segara (Jakarta) / NEIEZ" },
  { value: "EPSG:2935", label: "EPSG:2935 / Pulkovo 1942 / CS63 zone A1" },
  { value: "EPSG:2936", label: "EPSG:2936 / Pulkovo 1942 / CS63 zone A2" },
  { value: "EPSG:2937", label: "EPSG:2937 / Pulkovo 1942 / CS63 zone A3" },
  { value: "EPSG:2938", label: "EPSG:2938 / Pulkovo 1942 / CS63 zone A4" },
  { value: "EPSG:2939", label: "EPSG:2939 / Pulkovo 1942 / CS63 zone K2" },
  { value: "EPSG:2940", label: "EPSG:2940 / Pulkovo 1942 / CS63 zone K3" },
  { value: "EPSG:2941", label: "EPSG:2941 / Pulkovo 1942 / CS63 zone K4" },
  { value: "EPSG:2942", label: "EPSG:2942 / Porto Santo / UTM zone 28N" },
  { value: "EPSG:2943", label: "EPSG:2943 / Selvagem Grande / UTM zone 28N" },
  { value: "EPSG:2944", label: "EPSG:2944 / NAD83(CSRS) / SCoPQ zone 2" },
  { value: "EPSG:2945", label: "EPSG:2945 / NAD83(CSRS) / MTM zone 3" },
  { value: "EPSG:2946", label: "EPSG:2946 / NAD83(CSRS) / MTM zone 4" },
  { value: "EPSG:2947", label: "EPSG:2947 / NAD83(CSRS) / MTM zone 5" },
  { value: "EPSG:2948", label: "EPSG:2948 / NAD83(CSRS) / MTM zone 6" },
  { value: "EPSG:2949", label: "EPSG:2949 / NAD83(CSRS) / MTM zone 7" },
  { value: "EPSG:2950", label: "EPSG:2950 / NAD83(CSRS) / MTM zone 8" },
  { value: "EPSG:2951", label: "EPSG:2951 / NAD83(CSRS) / MTM zone 9" },
  { value: "EPSG:2952", label: "EPSG:2952 / NAD83(CSRS) / MTM zone 10" },
  {
    value: "EPSG:2953",
    label: "EPSG:2953 / NAD83(CSRS) / New Brunswick Stereographic",
  },
  {
    value: "EPSG:2954",
    label: "EPSG:2954 / NAD83(CSRS) / Prince Edward Isl. Stereographic (NAD83)",
  },
  { value: "EPSG:2955", label: "EPSG:2955 / NAD83(CSRS) / UTM zone 11N" },
  { value: "EPSG:2956", label: "EPSG:2956 / NAD83(CSRS) / UTM zone 12N" },
  { value: "EPSG:2957", label: "EPSG:2957 / NAD83(CSRS) / UTM zone 13N" },
  { value: "EPSG:2958", label: "EPSG:2958 / NAD83(CSRS) / UTM zone 17N" },
  { value: "EPSG:2959", label: "EPSG:2959 / NAD83(CSRS) / UTM zone 18N" },
  { value: "EPSG:2960", label: "EPSG:2960 / NAD83(CSRS) / UTM zone 19N" },
  { value: "EPSG:2961", label: "EPSG:2961 / NAD83(CSRS) / UTM zone 20N" },
  { value: "EPSG:2962", label: "EPSG:2962 / NAD83(CSRS) / UTM zone 21N" },
  {
    value: "EPSG:2963",
    label: "EPSG:2963 / Lisbon 1890 (Lisbon) / Portugal Bonne",
  },
  { value: "EPSG:2964", label: "EPSG:2964 / NAD27 / Alaska Albers" },
  { value: "EPSG:2965", label: "EPSG:2965 / NAD83 / Indiana East (ftUS)" },
  { value: "EPSG:2966", label: "EPSG:2966 / NAD83 / Indiana West (ftUS)" },
  {
    value: "EPSG:2967",
    label: "EPSG:2967 / NAD83(HARN) / Indiana East (ftUS)",
  },
  {
    value: "EPSG:2968",
    label: "EPSG:2968 / NAD83(HARN) / Indiana West (ftUS)",
  },
  { value: "EPSG:2969", label: "EPSG:2969 / Fort Marigot / UTM zone 20N" },
  { value: "EPSG:2970", label: "EPSG:2970 / Guadeloupe 1948 / UTM zone 20N" },
  { value: "EPSG:2971", label: "EPSG:2971 / CSG67 / UTM zone 22N" },
  { value: "EPSG:2972", label: "EPSG:2972 / RGFG95 / UTM zone 22N" },
  { value: "EPSG:2973", label: "EPSG:2973 / Martinique 1938 / UTM zone 20N" },
  { value: "EPSG:2975", label: "EPSG:2975 / RGR92 / UTM zone 40S" },
  { value: "EPSG:2976", label: "EPSG:2976 / Tahiti 52 / UTM zone 6S" },
  { value: "EPSG:2977", label: "EPSG:2977 / Tahaa 54 / UTM zone 5S" },
  { value: "EPSG:2978", label: "EPSG:2978 / IGN72 Nuku Hiva / UTM zone 7S" },
  { value: "EPSG:2979", label: "EPSG:2979 / K0 1949 / UTM zone 42S" },
  { value: "EPSG:2980", label: "EPSG:2980 / Combani 1950 / UTM zone 38S" },
  { value: "EPSG:2981", label: "EPSG:2981 / IGN56 Lifou / UTM zone 58S" },
  { value: "EPSG:2982", label: "EPSG:2982 / IGN72 Grand Terre / UTM zone 58S" },
  { value: "EPSG:2983", label: "EPSG:2983 / ST87 Ouvea / UTM zone 58S" },
  {
    value: "EPSG:2984",
    label: "EPSG:2984 / RGNC 1991 / Lambert New Caledonia",
  },
  {
    value: "EPSG:2985",
    label: "EPSG:2985 / Petrels 1972 / Terre Adelie Polar Stereographic",
  },
  {
    value: "EPSG:2986",
    label: "EPSG:2986 / Perroud 1950 / Terre Adelie Polar Stereographic",
  },
  {
    value: "EPSG:2987",
    label: "EPSG:2987 / Saint Pierre et Miquelon 1950 / UTM zone 21N",
  },
  { value: "EPSG:2988", label: "EPSG:2988 / MOP78 / UTM zone 1S" },
  { value: "EPSG:2989", label: "EPSG:2989 / RRAF 1991 / UTM zone 20N" },
  { value: "EPSG:2990", label: "EPSG:2990 / Reunion 1947 / TM Reunion" },
  { value: "EPSG:2991", label: "EPSG:2991 / NAD83 / Oregon LCC (m)" },
  { value: "EPSG:2992", label: "EPSG:2992 / NAD83 / Oregon GIC Lambert (ft)" },
  { value: "EPSG:2993", label: "EPSG:2993 / NAD83(HARN) / Oregon LCC (m)" },
  {
    value: "EPSG:2994",
    label: "EPSG:2994 / NAD83(HARN) / Oregon GIC Lambert (ft)",
  },
  { value: "EPSG:2995", label: "EPSG:2995 / IGN53 Mare / UTM zone 58S" },
  { value: "EPSG:2996", label: "EPSG:2996 / ST84 Ile des Pins / UTM zone 58S" },
  { value: "EPSG:2997", label: "EPSG:2997 / ST71 Belep / UTM zone 58S" },
  { value: "EPSG:2998", label: "EPSG:2998 / NEA74 Noumea / UTM zone 58S" },
  { value: "EPSG:2999", label: "EPSG:2999 / Grand Comoros / UTM zone 38S" },
  { value: "EPSG:3000", label: "EPSG:3000 / Segara / NEIEZ" },
  { value: "EPSG:3001", label: "EPSG:3001 / Batavia / NEIEZ" },
  { value: "EPSG:3002", label: "EPSG:3002 / Makassar / NEIEZ" },
  { value: "EPSG:3003", label: "EPSG:3003 / Monte Mario / Italy zone 1" },
  { value: "EPSG:3004", label: "EPSG:3004 / Monte Mario / Italy zone 2" },
  { value: "EPSG:3005", label: "EPSG:3005 / NAD83 / BC Albers" },
  { value: "EPSG:3006", label: "EPSG:3006 / SWEREF99 TM" },
  { value: "EPSG:3007", label: "EPSG:3007 / SWEREF99 12 00" },
  { value: "EPSG:3008", label: "EPSG:3008 / SWEREF99 13 30" },
  { value: "EPSG:3009", label: "EPSG:3009 / SWEREF99 15 00" },
  { value: "EPSG:3010", label: "EPSG:3010 / SWEREF99 16 30" },
  { value: "EPSG:3011", label: "EPSG:3011 / SWEREF99 18 00" },
  { value: "EPSG:3012", label: "EPSG:3012 / SWEREF99 14 15" },
  { value: "EPSG:3013", label: "EPSG:3013 / SWEREF99 15 45" },
  { value: "EPSG:3014", label: "EPSG:3014 / SWEREF99 17 15" },
  { value: "EPSG:3015", label: "EPSG:3015 / SWEREF99 18 45" },
  { value: "EPSG:3016", label: "EPSG:3016 / SWEREF99 20 15" },
  { value: "EPSG:3017", label: "EPSG:3017 / SWEREF99 21 45" },
  { value: "EPSG:3018", label: "EPSG:3018 / SWEREF99 23 15" },
  { value: "EPSG:3019", label: "EPSG:3019 / RT90 7.5 gon V" },
  { value: "EPSG:3020", label: "EPSG:3020 / RT90 5 gon V" },
  { value: "EPSG:3021", label: "EPSG:3021 / RT90 2.5 gon V" },
  { value: "EPSG:3022", label: "EPSG:3022 / RT90 0 gon" },
  { value: "EPSG:3023", label: "EPSG:3023 / RT90 2.5 gon O" },
  { value: "EPSG:3024", label: "EPSG:3024 / RT90 5 gon O" },
  { value: "EPSG:3025", label: "EPSG:3025 / RT38 7.5 gon V" },
  { value: "EPSG:3026", label: "EPSG:3026 / RT38 5 gon V" },
  { value: "EPSG:3027", label: "EPSG:3027 / RT38 2.5 gon V" },
  { value: "EPSG:3028", label: "EPSG:3028 / RT38 0 gon" },
  { value: "EPSG:3029", label: "EPSG:3029 / RT38 2.5 gon O" },
  { value: "EPSG:3030", label: "EPSG:3030 / RT38 5 gon O" },
  {
    value: "EPSG:3031",
    label: "EPSG:3031 / WGS 84 / Antarctic Polar Stereographic",
  },
  {
    value: "EPSG:3032",
    label: "EPSG:3032 / WGS 84 / Australian Antarctic Polar Stereographic",
  },
  {
    value: "EPSG:3033",
    label: "EPSG:3033 / WGS 84 / Australian Antarctic Lambert",
  },
  { value: "EPSG:3034", label: "EPSG:3034 / ETRS89-extended / LCC Europe" },
  { value: "EPSG:3035", label: "EPSG:3035 / ETRS89-extended / LAEA Europe" },
  { value: "EPSG:3036", label: "EPSG:3036 / Moznet / UTM zone 36S" },
  { value: "EPSG:3037", label: "EPSG:3037 / Moznet / UTM zone 37S" },
  { value: "EPSG:3038", label: "EPSG:3038 / ETRS89 / TM26" },
  { value: "EPSG:3039", label: "EPSG:3039 / ETRS89 / TM27" },
  { value: "EPSG:3040", label: "EPSG:3040 / ETRS89 / UTM zone 28N (N-E)" },
  { value: "EPSG:3041", label: "EPSG:3041 / ETRS89 / UTM zone 29N (N-E)" },
  { value: "EPSG:3042", label: "EPSG:3042 / ETRS89 / UTM zone 30N (N-E)" },
  { value: "EPSG:3043", label: "EPSG:3043 / ETRS89 / UTM zone 31N (N-E)" },
  { value: "EPSG:3044", label: "EPSG:3044 / ETRS89 / UTM zone 32N (N-E)" },
  { value: "EPSG:3045", label: "EPSG:3045 / ETRS89 / UTM zone 33N (N-E)" },
  { value: "EPSG:3046", label: "EPSG:3046 / ETRS89 / UTM zone 34N (N-E)" },
  { value: "EPSG:3047", label: "EPSG:3047 / ETRS89 / UTM zone 35N (N-E)" },
  { value: "EPSG:3048", label: "EPSG:3048 / ETRS89 / UTM zone 36N (N-E)" },
  { value: "EPSG:3049", label: "EPSG:3049 / ETRS89 / UTM zone 37N (N-E)" },
  { value: "EPSG:3050", label: "EPSG:3050 / ETRS89 / TM38" },
  { value: "EPSG:3051", label: "EPSG:3051 / ETRS89 / TM39" },
  { value: "EPSG:3052", label: "EPSG:3052 / Reykjavik 1900 / Lambert 1900" },
  { value: "EPSG:3053", label: "EPSG:3053 / Hjorsey 1955 / Lambert 1955" },
  { value: "EPSG:3054", label: "EPSG:3054 / Hjorsey 1955 / UTM zone 26N" },
  { value: "EPSG:3055", label: "EPSG:3055 / Hjorsey 1955 / UTM zone 27N" },
  { value: "EPSG:3056", label: "EPSG:3056 / Hjorsey 1955 / UTM zone 28N" },
  { value: "EPSG:3057", label: "EPSG:3057 / ISN93 / Lambert 1993" },
  { value: "EPSG:3058", label: "EPSG:3058 / Helle 1954 / Jan Mayen Grid" },
  { value: "EPSG:3059", label: "EPSG:3059 / LKS92 / Latvia TM" },
  {
    value: "EPSG:3060",
    label: "EPSG:3060 / IGN72 Grande Terre / UTM zone 58S",
  },
  { value: "EPSG:3061", label: "EPSG:3061 / Porto Santo 1995 / UTM zone 28N" },
  {
    value: "EPSG:3062",
    label: "EPSG:3062 / Azores Oriental 1995 / UTM zone 26N",
  },
  {
    value: "EPSG:3063",
    label: "EPSG:3063 / Azores Central 1995 / UTM zone 26N",
  },
  { value: "EPSG:3064", label: "EPSG:3064 / IGM95 / UTM zone 32N" },
  { value: "EPSG:3065", label: "EPSG:3065 / IGM95 / UTM zone 33N" },
  { value: "EPSG:3066", label: "EPSG:3066 / ED50 / Jordan TM" },
  { value: "EPSG:3067", label: "EPSG:3067 / ETRS89 / TM35FIN(E,N)" },
  { value: "EPSG:3068", label: "EPSG:3068 / DHDN / Soldner Berlin" },
  {
    value: "EPSG:3069",
    label: "EPSG:3069 / NAD27 / Wisconsin Transverse Mercator",
  },
  {
    value: "EPSG:3070",
    label: "EPSG:3070 / NAD83 / Wisconsin Transverse Mercator",
  },
  {
    value: "EPSG:3071",
    label: "EPSG:3071 / NAD83(HARN) / Wisconsin Transverse Mercator",
  },
  { value: "EPSG:3072", label: "EPSG:3072 / NAD83 / Maine CS2000 East" },
  { value: "EPSG:3073", label: "EPSG:3073 / NAD83 / Maine CS2000 Central" },
  { value: "EPSG:3074", label: "EPSG:3074 / NAD83 / Maine CS2000 West" },
  { value: "EPSG:3075", label: "EPSG:3075 / NAD83(HARN) / Maine CS2000 East" },
  {
    value: "EPSG:3076",
    label: "EPSG:3076 / NAD83(HARN) / Maine CS2000 Central",
  },
  { value: "EPSG:3077", label: "EPSG:3077 / NAD83(HARN) / Maine CS2000 West" },
  {
    value: "EPSG:3078",
    label: "EPSG:3078 / NAD83 / Michigan Oblique Mercator",
  },
  {
    value: "EPSG:3079",
    label: "EPSG:3079 / NAD83(HARN) / Michigan Oblique Mercator",
  },
  { value: "EPSG:3080", label: "EPSG:3080 / NAD27 / Shackleford" },
  {
    value: "EPSG:3081",
    label: "EPSG:3081 / NAD83 / Texas State Mapping System",
  },
  {
    value: "EPSG:3082",
    label: "EPSG:3082 / NAD83 / Texas Centric Lambert Conformal",
  },
  {
    value: "EPSG:3083",
    label: "EPSG:3083 / NAD83 / Texas Centric Albers Equal Area",
  },
  {
    value: "EPSG:3084",
    label: "EPSG:3084 / NAD83(HARN) / Texas Centric Lambert Conformal",
  },
  {
    value: "EPSG:3085",
    label: "EPSG:3085 / NAD83(HARN) / Texas Centric Albers Equal Area",
  },
  { value: "EPSG:3086", label: "EPSG:3086 / NAD83 / Florida GDL Albers" },
  { value: "EPSG:3087", label: "EPSG:3087 / NAD83(HARN) / Florida GDL Albers" },
  { value: "EPSG:3088", label: "EPSG:3088 / NAD83 / Kentucky Single Zone" },
  {
    value: "EPSG:3089",
    label: "EPSG:3089 / NAD83 / Kentucky Single Zone (ftUS)",
  },
  {
    value: "EPSG:3090",
    label: "EPSG:3090 / NAD83(HARN) / Kentucky Single Zone",
  },
  {
    value: "EPSG:3091",
    label: "EPSG:3091 / NAD83(HARN) / Kentucky Single Zone (ftUS)",
  },
  { value: "EPSG:3092", label: "EPSG:3092 / Tokyo / UTM zone 51N" },
  { value: "EPSG:3093", label: "EPSG:3093 / Tokyo / UTM zone 52N" },
  { value: "EPSG:3094", label: "EPSG:3094 / Tokyo / UTM zone 53N" },
  { value: "EPSG:3095", label: "EPSG:3095 / Tokyo / UTM zone 54N" },
  { value: "EPSG:3096", label: "EPSG:3096 / Tokyo / UTM zone 55N" },
  { value: "EPSG:3097", label: "EPSG:3097 / JGD2000 / UTM zone 51N" },
  { value: "EPSG:3098", label: "EPSG:3098 / JGD2000 / UTM zone 52N" },
  { value: "EPSG:3099", label: "EPSG:3099 / JGD2000 / UTM zone 53N" },
  { value: "EPSG:3100", label: "EPSG:3100 / JGD2000 / UTM zone 54N" },
  { value: "EPSG:3101", label: "EPSG:3101 / JGD2000 / UTM zone 55N" },
  {
    value: "EPSG:3102",
    label: "EPSG:3102 / American Samoa 1962 / American Samoa Lambert",
  },
  { value: "EPSG:3103", label: "EPSG:3103 / Mauritania 1999 / UTM zone 28N" },
  { value: "EPSG:3104", label: "EPSG:3104 / Mauritania 1999 / UTM zone 29N" },
  { value: "EPSG:3105", label: "EPSG:3105 / Mauritania 1999 / UTM zone 30N" },
  { value: "EPSG:3106", label: "EPSG:3106 / Gulshan 303 / TM 90 NE" },
  { value: "EPSG:3107", label: "EPSG:3107 / GDA94 / SA Lambert" },
  { value: "EPSG:3108", label: "EPSG:3108 / ETRS89 / Guernsey Grid" },
  {
    value: "EPSG:3109",
    label: "EPSG:3109 / ETRS89 / Jersey Transverse Mercator",
  },
  { value: "EPSG:3110", label: "EPSG:3110 / AGD66 / Vicgrid66" },
  { value: "EPSG:3111", label: "EPSG:3111 / GDA94 / Vicgrid" },
  {
    value: "EPSG:3112",
    label: "EPSG:3112 / GDA94 / Geoscience Australia Lambert",
  },
  { value: "EPSG:3113", label: "EPSG:3113 / GDA94 / BCSG02" },
  {
    value: "EPSG:3114",
    label: "EPSG:3114 / MAGNA-SIRGAS / Colombia Far West zone",
  },
  {
    value: "EPSG:3115",
    label: "EPSG:3115 / MAGNA-SIRGAS / Colombia West zone",
  },
  {
    value: "EPSG:3116",
    label: "EPSG:3116 / MAGNA-SIRGAS / Colombia Bogota zone",
  },
  {
    value: "EPSG:3117",
    label: "EPSG:3117 / MAGNA-SIRGAS / Colombia East Central zone",
  },
  {
    value: "EPSG:3118",
    label: "EPSG:3118 / MAGNA-SIRGAS / Colombia East zone",
  },
  { value: "EPSG:3119", label: "EPSG:3119 / Douala 1948 / AEF west" },
  { value: "EPSG:3120", label: "EPSG:3120 / Pulkovo 1942(58) / Poland zone I" },
  { value: "EPSG:3121", label: "EPSG:3121 / PRS92 / Philippines zone 1" },
  { value: "EPSG:3122", label: "EPSG:3122 / PRS92 / Philippines zone 2" },
  { value: "EPSG:3123", label: "EPSG:3123 / PRS92 / Philippines zone 3" },
  { value: "EPSG:3124", label: "EPSG:3124 / PRS92 / Philippines zone 4" },
  { value: "EPSG:3125", label: "EPSG:3125 / PRS92 / Philippines zone 5" },
  { value: "EPSG:3126", label: "EPSG:3126 / ETRS89 / ETRS-GK19FIN" },
  { value: "EPSG:3127", label: "EPSG:3127 / ETRS89 / ETRS-GK20FIN" },
  { value: "EPSG:3128", label: "EPSG:3128 / ETRS89 / ETRS-GK21FIN" },
  { value: "EPSG:3129", label: "EPSG:3129 / ETRS89 / ETRS-GK22FIN" },
  { value: "EPSG:3130", label: "EPSG:3130 / ETRS89 / ETRS-GK23FIN" },
  { value: "EPSG:3131", label: "EPSG:3131 / ETRS89 / ETRS-GK24FIN" },
  { value: "EPSG:3132", label: "EPSG:3132 / ETRS89 / ETRS-GK25FIN" },
  { value: "EPSG:3133", label: "EPSG:3133 / ETRS89 / ETRS-GK26FIN" },
  { value: "EPSG:3134", label: "EPSG:3134 / ETRS89 / ETRS-GK27FIN" },
  { value: "EPSG:3135", label: "EPSG:3135 / ETRS89 / ETRS-GK28FIN" },
  { value: "EPSG:3136", label: "EPSG:3136 / ETRS89 / ETRS-GK29FIN" },
  { value: "EPSG:3137", label: "EPSG:3137 / ETRS89 / ETRS-GK30FIN" },
  { value: "EPSG:3138", label: "EPSG:3138 / ETRS89 / ETRS-GK31FIN" },
  {
    value: "EPSG:3139",
    label: "EPSG:3139 / Vanua Levu 1915 / Vanua Levu Grid",
  },
  { value: "EPSG:3140", label: "EPSG:3140 / Viti Levu 1912 / Viti Levu Grid" },
  { value: "EPSG:3141", label: "EPSG:3141 / Fiji 1956 / UTM zone 60S" },
  { value: "EPSG:3142", label: "EPSG:3142 / Fiji 1956 / UTM zone 1S" },
  { value: "EPSG:3143", label: "EPSG:3143 / Fiji 1986 / Fiji Map Grid" },
  { value: "EPSG:3144", label: "EPSG:3144 / FD54 / Faroe Lambert" },
  { value: "EPSG:3145", label: "EPSG:3145 / ETRS89 / Faroe Lambert" },
  {
    value: "EPSG:3146",
    label: "EPSG:3146 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:3147",
    label: "EPSG:3147 / Pulkovo 1942 / 3-degree Gauss-Kruger CM 18E",
  },
  { value: "EPSG:3148", label: "EPSG:3148 / Indian 1960 / UTM zone 48N" },
  { value: "EPSG:3149", label: "EPSG:3149 / Indian 1960 / UTM zone 49N" },
  {
    value: "EPSG:3150",
    label: "EPSG:3150 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:3151",
    label: "EPSG:3151 / Pulkovo 1995 / 3-degree Gauss-Kruger CM 18E",
  },
  { value: "EPSG:3152", label: "EPSG:3152 / ST74" },
  { value: "EPSG:3153", label: "EPSG:3153 / NAD83(CSRS) / BC Albers" },
  { value: "EPSG:3154", label: "EPSG:3154 / NAD83(CSRS) / UTM zone 7N" },
  { value: "EPSG:3155", label: "EPSG:3155 / NAD83(CSRS) / UTM zone 8N" },
  { value: "EPSG:3156", label: "EPSG:3156 / NAD83(CSRS) / UTM zone 9N" },
  { value: "EPSG:3157", label: "EPSG:3157 / NAD83(CSRS) / UTM zone 10N" },
  { value: "EPSG:3158", label: "EPSG:3158 / NAD83(CSRS) / UTM zone 14N" },
  { value: "EPSG:3159", label: "EPSG:3159 / NAD83(CSRS) / UTM zone 15N" },
  { value: "EPSG:3160", label: "EPSG:3160 / NAD83(CSRS) / UTM zone 16N" },
  { value: "EPSG:3161", label: "EPSG:3161 / NAD83 / Ontario MNR Lambert" },
  {
    value: "EPSG:3162",
    label: "EPSG:3162 / NAD83(CSRS) / Ontario MNR Lambert",
  },
  {
    value: "EPSG:3163",
    label: "EPSG:3163 / RGNC91-93 / Lambert New Caledonia",
  },
  { value: "EPSG:3164", label: "EPSG:3164 / ST87 Ouvea / UTM zone 58S" },
  { value: "EPSG:3165", label: "EPSG:3165 / NEA74 Noumea / Noumea Lambert" },
  { value: "EPSG:3166", label: "EPSG:3166 / NEA74 Noumea / Noumea Lambert 2" },
  { value: "EPSG:3167", label: "EPSG:3167 / Kertau (RSO) / RSO Malaya (ch)" },
  { value: "EPSG:3168", label: "EPSG:3168 / Kertau (RSO) / RSO Malaya (m)" },
  { value: "EPSG:3169", label: "EPSG:3169 / RGNC91-93 / UTM zone 57S" },
  { value: "EPSG:3170", label: "EPSG:3170 / RGNC91-93 / UTM zone 58S" },
  { value: "EPSG:3171", label: "EPSG:3171 / RGNC91-93 / UTM zone 59S" },
  { value: "EPSG:3172", label: "EPSG:3172 / IGN53 Mare / UTM zone 59S" },
  { value: "EPSG:3173", label: "EPSG:3173 / fk89 / Faroe Lambert FK89" },
  { value: "EPSG:3174", label: "EPSG:3174 / NAD83 / Great Lakes Albers" },
  {
    value: "EPSG:3175",
    label: "EPSG:3175 / NAD83 / Great Lakes and St Lawrence Albers",
  },
  { value: "EPSG:3176", label: "EPSG:3176 / Indian 1960 / TM 106 NE" },
  { value: "EPSG:3177", label: "EPSG:3177 / LGD2006 / Libya TM" },
  { value: "EPSG:3178", label: "EPSG:3178 / GR96 / UTM zone 18N" },
  { value: "EPSG:3179", label: "EPSG:3179 / GR96 / UTM zone 19N" },
  { value: "EPSG:3180", label: "EPSG:3180 / GR96 / UTM zone 20N" },
  { value: "EPSG:3181", label: "EPSG:3181 / GR96 / UTM zone 21N" },
  { value: "EPSG:3182", label: "EPSG:3182 / GR96 / UTM zone 22N" },
  { value: "EPSG:3183", label: "EPSG:3183 / GR96 / UTM zone 23N" },
  { value: "EPSG:3184", label: "EPSG:3184 / GR96 / UTM zone 24N" },
  { value: "EPSG:3185", label: "EPSG:3185 / GR96 / UTM zone 25N" },
  { value: "EPSG:3186", label: "EPSG:3186 / GR96 / UTM zone 26N" },
  { value: "EPSG:3187", label: "EPSG:3187 / GR96 / UTM zone 27N" },
  { value: "EPSG:3188", label: "EPSG:3188 / GR96 / UTM zone 28N" },
  { value: "EPSG:3189", label: "EPSG:3189 / GR96 / UTM zone 29N" },
  { value: "EPSG:3190", label: "EPSG:3190 / LGD2006 / Libya TM zone 5" },
  { value: "EPSG:3191", label: "EPSG:3191 / LGD2006 / Libya TM zone 6" },
  { value: "EPSG:3192", label: "EPSG:3192 / LGD2006 / Libya TM zone 7" },
  { value: "EPSG:3193", label: "EPSG:3193 / LGD2006 / Libya TM zone 8" },
  { value: "EPSG:3194", label: "EPSG:3194 / LGD2006 / Libya TM zone 9" },
  { value: "EPSG:3195", label: "EPSG:3195 / LGD2006 / Libya TM zone 10" },
  { value: "EPSG:3196", label: "EPSG:3196 / LGD2006 / Libya TM zone 11" },
  { value: "EPSG:3197", label: "EPSG:3197 / LGD2006 / Libya TM zone 12" },
  { value: "EPSG:3198", label: "EPSG:3198 / LGD2006 / Libya TM zone 13" },
  { value: "EPSG:3199", label: "EPSG:3199 / LGD2006 / UTM zone 32N" },
  { value: "EPSG:3200", label: "EPSG:3200 / FD58 / Iraq zone" },
  { value: "EPSG:3201", label: "EPSG:3201 / LGD2006 / UTM zone 33N" },
  { value: "EPSG:3202", label: "EPSG:3202 / LGD2006 / UTM zone 34N" },
  { value: "EPSG:3203", label: "EPSG:3203 / LGD2006 / UTM zone 35N" },
  { value: "EPSG:3204", label: "EPSG:3204 / WGS 84 / SCAR IMW SP19-20" },
  { value: "EPSG:3205", label: "EPSG:3205 / WGS 84 / SCAR IMW SP21-22" },
  { value: "EPSG:3206", label: "EPSG:3206 / WGS 84 / SCAR IMW SP23-24" },
  { value: "EPSG:3207", label: "EPSG:3207 / WGS 84 / SCAR IMW SQ01-02" },
  { value: "EPSG:3208", label: "EPSG:3208 / WGS 84 / SCAR IMW SQ19-20" },
  { value: "EPSG:3209", label: "EPSG:3209 / WGS 84 / SCAR IMW SQ21-22" },
  { value: "EPSG:3210", label: "EPSG:3210 / WGS 84 / SCAR IMW SQ37-38" },
  { value: "EPSG:3211", label: "EPSG:3211 / WGS 84 / SCAR IMW SQ39-40" },
  { value: "EPSG:3212", label: "EPSG:3212 / WGS 84 / SCAR IMW SQ41-42" },
  { value: "EPSG:3213", label: "EPSG:3213 / WGS 84 / SCAR IMW SQ43-44" },
  { value: "EPSG:3214", label: "EPSG:3214 / WGS 84 / SCAR IMW SQ45-46" },
  { value: "EPSG:3215", label: "EPSG:3215 / WGS 84 / SCAR IMW SQ47-48" },
  { value: "EPSG:3216", label: "EPSG:3216 / WGS 84 / SCAR IMW SQ49-50" },
  { value: "EPSG:3217", label: "EPSG:3217 / WGS 84 / SCAR IMW SQ51-52" },
  { value: "EPSG:3218", label: "EPSG:3218 / WGS 84 / SCAR IMW SQ53-54" },
  { value: "EPSG:3219", label: "EPSG:3219 / WGS 84 / SCAR IMW SQ55-56" },
  { value: "EPSG:3220", label: "EPSG:3220 / WGS 84 / SCAR IMW SQ57-58" },
  { value: "EPSG:3221", label: "EPSG:3221 / WGS 84 / SCAR IMW SR13-14" },
  { value: "EPSG:3222", label: "EPSG:3222 / WGS 84 / SCAR IMW SR15-16" },
  { value: "EPSG:3223", label: "EPSG:3223 / WGS 84 / SCAR IMW SR17-18" },
  { value: "EPSG:3224", label: "EPSG:3224 / WGS 84 / SCAR IMW SR19-20" },
  { value: "EPSG:3225", label: "EPSG:3225 / WGS 84 / SCAR IMW SR27-28" },
  { value: "EPSG:3226", label: "EPSG:3226 / WGS 84 / SCAR IMW SR29-30" },
  { value: "EPSG:3227", label: "EPSG:3227 / WGS 84 / SCAR IMW SR31-32" },
  { value: "EPSG:3228", label: "EPSG:3228 / WGS 84 / SCAR IMW SR33-34" },
  { value: "EPSG:3229", label: "EPSG:3229 / WGS 84 / SCAR IMW SR35-36" },
  { value: "EPSG:3230", label: "EPSG:3230 / WGS 84 / SCAR IMW SR37-38" },
  { value: "EPSG:3231", label: "EPSG:3231 / WGS 84 / SCAR IMW SR39-40" },
  { value: "EPSG:3232", label: "EPSG:3232 / WGS 84 / SCAR IMW SR41-42" },
  { value: "EPSG:3233", label: "EPSG:3233 / WGS 84 / SCAR IMW SR43-44" },
  { value: "EPSG:3234", label: "EPSG:3234 / WGS 84 / SCAR IMW SR45-46" },
  { value: "EPSG:3235", label: "EPSG:3235 / WGS 84 / SCAR IMW SR47-48" },
  { value: "EPSG:3236", label: "EPSG:3236 / WGS 84 / SCAR IMW SR49-50" },
  { value: "EPSG:3237", label: "EPSG:3237 / WGS 84 / SCAR IMW SR51-52" },
  { value: "EPSG:3238", label: "EPSG:3238 / WGS 84 / SCAR IMW SR53-54" },
  { value: "EPSG:3239", label: "EPSG:3239 / WGS 84 / SCAR IMW SR55-56" },
  { value: "EPSG:3240", label: "EPSG:3240 / WGS 84 / SCAR IMW SR57-58" },
  { value: "EPSG:3241", label: "EPSG:3241 / WGS 84 / SCAR IMW SR59-60" },
  { value: "EPSG:3242", label: "EPSG:3242 / WGS 84 / SCAR IMW SS04-06" },
  { value: "EPSG:3243", label: "EPSG:3243 / WGS 84 / SCAR IMW SS07-09" },
  { value: "EPSG:3244", label: "EPSG:3244 / WGS 84 / SCAR IMW SS10-12" },
  { value: "EPSG:3245", label: "EPSG:3245 / WGS 84 / SCAR IMW SS13-15" },
  { value: "EPSG:3246", label: "EPSG:3246 / WGS 84 / SCAR IMW SS16-18" },
  { value: "EPSG:3247", label: "EPSG:3247 / WGS 84 / SCAR IMW SS19-21" },
  { value: "EPSG:3248", label: "EPSG:3248 / WGS 84 / SCAR IMW SS25-27" },
  { value: "EPSG:3249", label: "EPSG:3249 / WGS 84 / SCAR IMW SS28-30" },
  { value: "EPSG:3250", label: "EPSG:3250 / WGS 84 / SCAR IMW SS31-33" },
  { value: "EPSG:3251", label: "EPSG:3251 / WGS 84 / SCAR IMW SS34-36" },
  { value: "EPSG:3252", label: "EPSG:3252 / WGS 84 / SCAR IMW SS37-39" },
  { value: "EPSG:3253", label: "EPSG:3253 / WGS 84 / SCAR IMW SS40-42" },
  { value: "EPSG:3254", label: "EPSG:3254 / WGS 84 / SCAR IMW SS43-45" },
  { value: "EPSG:3255", label: "EPSG:3255 / WGS 84 / SCAR IMW SS46-48" },
  { value: "EPSG:3256", label: "EPSG:3256 / WGS 84 / SCAR IMW SS49-51" },
  { value: "EPSG:3257", label: "EPSG:3257 / WGS 84 / SCAR IMW SS52-54" },
  { value: "EPSG:3258", label: "EPSG:3258 / WGS 84 / SCAR IMW SS55-57" },
  { value: "EPSG:3259", label: "EPSG:3259 / WGS 84 / SCAR IMW SS58-60" },
  { value: "EPSG:3260", label: "EPSG:3260 / WGS 84 / SCAR IMW ST01-04" },
  { value: "EPSG:3261", label: "EPSG:3261 / WGS 84 / SCAR IMW ST05-08" },
  { value: "EPSG:3262", label: "EPSG:3262 / WGS 84 / SCAR IMW ST09-12" },
  { value: "EPSG:3263", label: "EPSG:3263 / WGS 84 / SCAR IMW ST13-16" },
  { value: "EPSG:3264", label: "EPSG:3264 / WGS 84 / SCAR IMW ST17-20" },
  { value: "EPSG:3265", label: "EPSG:3265 / WGS 84 / SCAR IMW ST21-24" },
  { value: "EPSG:3266", label: "EPSG:3266 / WGS 84 / SCAR IMW ST25-28" },
  { value: "EPSG:3267", label: "EPSG:3267 / WGS 84 / SCAR IMW ST29-32" },
  { value: "EPSG:3268", label: "EPSG:3268 / WGS 84 / SCAR IMW ST33-36" },
  { value: "EPSG:3269", label: "EPSG:3269 / WGS 84 / SCAR IMW ST37-40" },
  { value: "EPSG:3270", label: "EPSG:3270 / WGS 84 / SCAR IMW ST41-44" },
  { value: "EPSG:3271", label: "EPSG:3271 / WGS 84 / SCAR IMW ST45-48" },
  { value: "EPSG:3272", label: "EPSG:3272 / WGS 84 / SCAR IMW ST49-52" },
  { value: "EPSG:3273", label: "EPSG:3273 / WGS 84 / SCAR IMW ST53-56" },
  { value: "EPSG:3274", label: "EPSG:3274 / WGS 84 / SCAR IMW ST57-60" },
  { value: "EPSG:3275", label: "EPSG:3275 / WGS 84 / SCAR IMW SU01-05" },
  { value: "EPSG:3276", label: "EPSG:3276 / WGS 84 / SCAR IMW SU06-10" },
  { value: "EPSG:3277", label: "EPSG:3277 / WGS 84 / SCAR IMW SU11-15" },
  { value: "EPSG:3278", label: "EPSG:3278 / WGS 84 / SCAR IMW SU16-20" },
  { value: "EPSG:3279", label: "EPSG:3279 / WGS 84 / SCAR IMW SU21-25" },
  { value: "EPSG:3280", label: "EPSG:3280 / WGS 84 / SCAR IMW SU26-30" },
  { value: "EPSG:3281", label: "EPSG:3281 / WGS 84 / SCAR IMW SU31-35" },
  { value: "EPSG:3282", label: "EPSG:3282 / WGS 84 / SCAR IMW SU36-40" },
  { value: "EPSG:3283", label: "EPSG:3283 / WGS 84 / SCAR IMW SU41-45" },
  { value: "EPSG:3284", label: "EPSG:3284 / WGS 84 / SCAR IMW SU46-50" },
  { value: "EPSG:3285", label: "EPSG:3285 / WGS 84 / SCAR IMW SU51-55" },
  { value: "EPSG:3286", label: "EPSG:3286 / WGS 84 / SCAR IMW SU56-60" },
  { value: "EPSG:3287", label: "EPSG:3287 / WGS 84 / SCAR IMW SV01-10" },
  { value: "EPSG:3288", label: "EPSG:3288 / WGS 84 / SCAR IMW SV11-20" },
  { value: "EPSG:3289", label: "EPSG:3289 / WGS 84 / SCAR IMW SV21-30" },
  { value: "EPSG:3290", label: "EPSG:3290 / WGS 84 / SCAR IMW SV31-40" },
  { value: "EPSG:3291", label: "EPSG:3291 / WGS 84 / SCAR IMW SV41-50" },
  { value: "EPSG:3292", label: "EPSG:3292 / WGS 84 / SCAR IMW SV51-60" },
  { value: "EPSG:3293", label: "EPSG:3293 / WGS 84 / SCAR IMW SW01-60" },
  {
    value: "EPSG:3294",
    label: "EPSG:3294 / WGS 84 / USGS Transantarctic Mountains",
  },
  { value: "EPSG:3295", label: "EPSG:3295 / Guam 1963 / Yap Islands" },
  { value: "EPSG:3296", label: "EPSG:3296 / RGPF / UTM zone 5S" },
  { value: "EPSG:3297", label: "EPSG:3297 / RGPF / UTM zone 6S" },
  { value: "EPSG:3298", label: "EPSG:3298 / RGPF / UTM zone 7S" },
  { value: "EPSG:3299", label: "EPSG:3299 / RGPF / UTM zone 8S" },
  {
    value: "EPSG:3300",
    label: "EPSG:3300 / Estonian Coordinate System of 1992",
  },
  {
    value: "EPSG:3301",
    label: "EPSG:3301 / Estonian Coordinate System of 1997",
  },
  { value: "EPSG:3302", label: "EPSG:3302 / IGN63 Hiva Oa / UTM zone 7S" },
  { value: "EPSG:3303", label: "EPSG:3303 / Fatu Iva 72 / UTM zone 7S" },
  { value: "EPSG:3304", label: "EPSG:3304 / Tahiti 79 / UTM zone 6S" },
  { value: "EPSG:3305", label: "EPSG:3305 / Moorea 87 / UTM zone 6S" },
  { value: "EPSG:3306", label: "EPSG:3306 / Maupiti 83 / UTM zone 5S" },
  { value: "EPSG:3307", label: "EPSG:3307 / Nakhl-e Ghanem / UTM zone 39N" },
  { value: "EPSG:3308", label: "EPSG:3308 / GDA94 / NSW Lambert" },
  { value: "EPSG:3309", label: "EPSG:3309 / NAD27 / California Albers" },
  { value: "EPSG:3310", label: "EPSG:3310 / NAD83 / California Albers" },
  { value: "EPSG:3311", label: "EPSG:3311 / NAD83(HARN) / California Albers" },
  { value: "EPSG:3312", label: "EPSG:3312 / CSG67 / UTM zone 21N" },
  { value: "EPSG:3313", label: "EPSG:3313 / RGFG95 / UTM zone 21N" },
  { value: "EPSG:3314", label: "EPSG:3314 / Katanga 1955 / Katanga Lambert" },
  { value: "EPSG:3315", label: "EPSG:3315 / Katanga 1955 / Katanga TM" },
  { value: "EPSG:3316", label: "EPSG:3316 / Kasai 1953 / Congo TM zone 22" },
  { value: "EPSG:3317", label: "EPSG:3317 / Kasai 1953 / Congo TM zone 24" },
  { value: "EPSG:3318", label: "EPSG:3318 / IGC 1962 / Congo TM zone 12" },
  { value: "EPSG:3319", label: "EPSG:3319 / IGC 1962 / Congo TM zone 14" },
  { value: "EPSG:3320", label: "EPSG:3320 / IGC 1962 / Congo TM zone 16" },
  { value: "EPSG:3321", label: "EPSG:3321 / IGC 1962 / Congo TM zone 18" },
  { value: "EPSG:3322", label: "EPSG:3322 / IGC 1962 / Congo TM zone 20" },
  { value: "EPSG:3323", label: "EPSG:3323 / IGC 1962 / Congo TM zone 22" },
  { value: "EPSG:3324", label: "EPSG:3324 / IGC 1962 / Congo TM zone 24" },
  { value: "EPSG:3325", label: "EPSG:3325 / IGC 1962 / Congo TM zone 26" },
  { value: "EPSG:3326", label: "EPSG:3326 / IGC 1962 / Congo TM zone 28" },
  { value: "EPSG:3327", label: "EPSG:3327 / IGC 1962 / Congo TM zone 30" },
  { value: "EPSG:3328", label: "EPSG:3328 / Pulkovo 1942(58) / GUGiK-80" },
  {
    value: "EPSG:3329",
    label: "EPSG:3329 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5",
  },
  {
    value: "EPSG:3330",
    label: "EPSG:3330 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:3331",
    label: "EPSG:3331 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:3332",
    label: "EPSG:3332 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:3333",
    label: "EPSG:3333 / Pulkovo 1942(58) / Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:3334",
    label: "EPSG:3334 / Pulkovo 1942(58) / Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:3335",
    label: "EPSG:3335 / Pulkovo 1942(58) / Gauss-Kruger zone 5",
  },
  {
    value: "EPSG:3336",
    label: "EPSG:3336 / IGN 1962 Kerguelen / UTM zone 42S",
  },
  { value: "EPSG:3337", label: "EPSG:3337 / Le Pouce 1934 / Mauritius Grid" },
  { value: "EPSG:3338", label: "EPSG:3338 / NAD83 / Alaska Albers" },
  { value: "EPSG:3339", label: "EPSG:3339 / IGCB 1955 / Congo TM zone 12" },
  { value: "EPSG:3340", label: "EPSG:3340 / IGCB 1955 / Congo TM zone 14" },
  { value: "EPSG:3341", label: "EPSG:3341 / IGCB 1955 / Congo TM zone 16" },
  { value: "EPSG:3342", label: "EPSG:3342 / IGCB 1955 / UTM zone 33S" },
  { value: "EPSG:3343", label: "EPSG:3343 / Mauritania 1999 / UTM zone 28N" },
  { value: "EPSG:3344", label: "EPSG:3344 / Mauritania 1999 / UTM zone 29N" },
  { value: "EPSG:3345", label: "EPSG:3345 / Mauritania 1999 / UTM zone 30N" },
  { value: "EPSG:3346", label: "EPSG:3346 / LKS94 / Lithuania TM" },
  {
    value: "EPSG:3347",
    label: "EPSG:3347 / NAD83 / Statistics Canada Lambert",
  },
  {
    value: "EPSG:3348",
    label: "EPSG:3348 / NAD83(CSRS) / Statistics Canada Lambert",
  },
  { value: "EPSG:3349", label: "EPSG:3349 / WGS 84 / PDC Mercator" },
  { value: "EPSG:3350", label: "EPSG:3350 / Pulkovo 1942 / CS63 zone C0" },
  { value: "EPSG:3351", label: "EPSG:3351 / Pulkovo 1942 / CS63 zone C1" },
  { value: "EPSG:3352", label: "EPSG:3352 / Pulkovo 1942 / CS63 zone C2" },
  { value: "EPSG:3353", label: "EPSG:3353 / Mhast (onshore) / UTM zone 32S" },
  { value: "EPSG:3354", label: "EPSG:3354 / Mhast (offshore) / UTM zone 32S" },
  {
    value: "EPSG:3355",
    label: "EPSG:3355 / Egypt Gulf of Suez S-650 TL / Red Belt",
  },
  { value: "EPSG:3356", label: "EPSG:3356 / Grand Cayman 1959 / UTM zone 17N" },
  {
    value: "EPSG:3357",
    label: "EPSG:3357 / Little Cayman 1961 / UTM zone 17N",
  },
  { value: "EPSG:3358", label: "EPSG:3358 / NAD83(HARN) / North Carolina" },
  {
    value: "EPSG:3359",
    label: "EPSG:3359 / NAD83(HARN) / North Carolina (ftUS)",
  },
  { value: "EPSG:3360", label: "EPSG:3360 / NAD83(HARN) / South Carolina" },
  {
    value: "EPSG:3361",
    label: "EPSG:3361 / NAD83(HARN) / South Carolina (ft)",
  },
  { value: "EPSG:3362", label: "EPSG:3362 / NAD83(HARN) / Pennsylvania North" },
  {
    value: "EPSG:3363",
    label: "EPSG:3363 / NAD83(HARN) / Pennsylvania North (ftUS)",
  },
  { value: "EPSG:3364", label: "EPSG:3364 / NAD83(HARN) / Pennsylvania South" },
  {
    value: "EPSG:3365",
    label: "EPSG:3365 / NAD83(HARN) / Pennsylvania South (ftUS)",
  },
  { value: "EPSG:3366", label: "EPSG:3366 / Hong Kong 1963 Grid System" },
  { value: "EPSG:3367", label: "EPSG:3367 / IGN Astro 1960 / UTM zone 28N" },
  { value: "EPSG:3368", label: "EPSG:3368 / IGN Astro 1960 / UTM zone 29N" },
  { value: "EPSG:3369", label: "EPSG:3369 / IGN Astro 1960 / UTM zone 30N" },
  { value: "EPSG:3370", label: "EPSG:3370 / NAD27 / UTM zone 59N" },
  { value: "EPSG:3371", label: "EPSG:3371 / NAD27 / UTM zone 60N" },
  { value: "EPSG:3372", label: "EPSG:3372 / NAD83 / UTM zone 59N" },
  { value: "EPSG:3373", label: "EPSG:3373 / NAD83 / UTM zone 60N" },
  { value: "EPSG:3374", label: "EPSG:3374 / FD54 / UTM zone 29N" },
  { value: "EPSG:3375", label: "EPSG:3375 / GDM2000 / Peninsula RSO" },
  { value: "EPSG:3376", label: "EPSG:3376 / GDM2000 / East Malaysia BRSO" },
  { value: "EPSG:3377", label: "EPSG:3377 / GDM2000 / Johor Grid" },
  {
    value: "EPSG:3378",
    label: "EPSG:3378 / GDM2000 / Sembilan and Melaka Grid",
  },
  { value: "EPSG:3379", label: "EPSG:3379 / GDM2000 / Pahang Grid" },
  { value: "EPSG:3380", label: "EPSG:3380 / GDM2000 / Selangor Grid" },
  { value: "EPSG:3381", label: "EPSG:3381 / GDM2000 / Terengganu Grid" },
  { value: "EPSG:3382", label: "EPSG:3382 / GDM2000 / Pinang Grid" },
  { value: "EPSG:3383", label: "EPSG:3383 / GDM2000 / Kedah and Perlis Grid" },
  { value: "EPSG:3384", label: "EPSG:3384 / GDM2000 / Perak Grid" },
  { value: "EPSG:3385", label: "EPSG:3385 / GDM2000 / Kelantan Grid" },
  { value: "EPSG:3386", label: "EPSG:3386 / KKJ / Finland zone 0" },
  { value: "EPSG:3387", label: "EPSG:3387 / KKJ / Finland zone 5" },
  {
    value: "EPSG:3388",
    label: "EPSG:3388 / Pulkovo 1942 / Caspian Sea Mercator",
  },
  {
    value: "EPSG:3389",
    label: "EPSG:3389 / Pulkovo 1942 / 3-degree Gauss-Kruger zone 60",
  },
  {
    value: "EPSG:3390",
    label: "EPSG:3390 / Pulkovo 1995 / 3-degree Gauss-Kruger zone 60",
  },
  { value: "EPSG:3391", label: "EPSG:3391 / Karbala 1979 / UTM zone 37N" },
  { value: "EPSG:3392", label: "EPSG:3392 / Karbala 1979 / UTM zone 38N" },
  { value: "EPSG:3393", label: "EPSG:3393 / Karbala 1979 / UTM zone 39N" },
  { value: "EPSG:3394", label: "EPSG:3394 / Nahrwan 1934 / Iraq zone" },
  { value: "EPSG:3395", label: "EPSG:3395 / WGS 84 / World Mercator" },
  {
    value: "EPSG:3396",
    label: "EPSG:3396 / PD/83 / 3-degree Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:3397",
    label: "EPSG:3397 / PD/83 / 3-degree Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:3398",
    label: "EPSG:3398 / RD/83 / 3-degree Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:3399",
    label: "EPSG:3399 / RD/83 / 3-degree Gauss-Kruger zone 5",
  },
  { value: "EPSG:3400", label: "EPSG:3400 / NAD83 / Alberta 10-TM (Forest)" },
  { value: "EPSG:3401", label: "EPSG:3401 / NAD83 / Alberta 10-TM (Resource)" },
  {
    value: "EPSG:3402",
    label: "EPSG:3402 / NAD83(CSRS) / Alberta 10-TM (Forest)",
  },
  {
    value: "EPSG:3403",
    label: "EPSG:3403 / NAD83(CSRS) / Alberta 10-TM (Resource)",
  },
  {
    value: "EPSG:3404",
    label: "EPSG:3404 / NAD83(HARN) / North Carolina (ftUS)",
  },
  { value: "EPSG:3405", label: "EPSG:3405 / VN-2000 / UTM zone 48N" },
  { value: "EPSG:3406", label: "EPSG:3406 / VN-2000 / UTM zone 49N" },
  { value: "EPSG:3407", label: "EPSG:3407 / Hong Kong 1963 Grid System" },
  { value: "EPSG:3408", label: "EPSG:3408 / NSIDC EASE-Grid North" },
  { value: "EPSG:3409", label: "EPSG:3409 / NSIDC EASE-Grid South" },
  { value: "EPSG:3410", label: "EPSG:3410 / NSIDC EASE-Grid Global" },
  {
    value: "EPSG:3411",
    label: "EPSG:3411 / NSIDC Sea Ice Polar Stereographic North",
  },
  {
    value: "EPSG:3412",
    label: "EPSG:3412 / NSIDC Sea Ice Polar Stereographic South",
  },
  {
    value: "EPSG:3413",
    label: "EPSG:3413 / WGS 84 / NSIDC Sea Ice Polar Stereographic North",
  },
  { value: "EPSG:3414", label: "EPSG:3414 / SVY21 / Singapore TM" },
  {
    value: "EPSG:3415",
    label: "EPSG:3415 / WGS 72BE / South China Sea Lambert",
  },
  { value: "EPSG:3416", label: "EPSG:3416 / ETRS89 / Austria Lambert" },
  { value: "EPSG:3417", label: "EPSG:3417 / NAD83 / Iowa North (ftUS)" },
  { value: "EPSG:3418", label: "EPSG:3418 / NAD83 / Iowa South (ftUS)" },
  { value: "EPSG:3419", label: "EPSG:3419 / NAD83 / Kansas North (ftUS)" },
  { value: "EPSG:3420", label: "EPSG:3420 / NAD83 / Kansas South (ftUS)" },
  { value: "EPSG:3421", label: "EPSG:3421 / NAD83 / Nevada East (ftUS)" },
  { value: "EPSG:3422", label: "EPSG:3422 / NAD83 / Nevada Central (ftUS)" },
  { value: "EPSG:3423", label: "EPSG:3423 / NAD83 / Nevada West (ftUS)" },
  { value: "EPSG:3424", label: "EPSG:3424 / NAD83 / New Jersey (ftUS)" },
  { value: "EPSG:3425", label: "EPSG:3425 / NAD83(HARN) / Iowa North (ftUS)" },
  { value: "EPSG:3426", label: "EPSG:3426 / NAD83(HARN) / Iowa South (ftUS)" },
  {
    value: "EPSG:3427",
    label: "EPSG:3427 / NAD83(HARN) / Kansas North (ftUS)",
  },
  {
    value: "EPSG:3428",
    label: "EPSG:3428 / NAD83(HARN) / Kansas South (ftUS)",
  },
  { value: "EPSG:3429", label: "EPSG:3429 / NAD83(HARN) / Nevada East (ftUS)" },
  {
    value: "EPSG:3430",
    label: "EPSG:3430 / NAD83(HARN) / Nevada Central (ftUS)",
  },
  { value: "EPSG:3431", label: "EPSG:3431 / NAD83(HARN) / Nevada West (ftUS)" },
  { value: "EPSG:3432", label: "EPSG:3432 / NAD83(HARN) / New Jersey (ftUS)" },
  { value: "EPSG:3433", label: "EPSG:3433 / NAD83 / Arkansas North (ftUS)" },
  { value: "EPSG:3434", label: "EPSG:3434 / NAD83 / Arkansas South (ftUS)" },
  { value: "EPSG:3435", label: "EPSG:3435 / NAD83 / Illinois East (ftUS)" },
  { value: "EPSG:3436", label: "EPSG:3436 / NAD83 / Illinois West (ftUS)" },
  { value: "EPSG:3437", label: "EPSG:3437 / NAD83 / New Hampshire (ftUS)" },
  { value: "EPSG:3438", label: "EPSG:3438 / NAD83 / Rhode Island (ftUS)" },
  { value: "EPSG:3439", label: "EPSG:3439 / PSD93 / UTM zone 39N" },
  { value: "EPSG:3440", label: "EPSG:3440 / PSD93 / UTM zone 40N" },
  {
    value: "EPSG:3441",
    label: "EPSG:3441 / NAD83(HARN) / Arkansas North (ftUS)",
  },
  {
    value: "EPSG:3442",
    label: "EPSG:3442 / NAD83(HARN) / Arkansas South (ftUS)",
  },
  {
    value: "EPSG:3443",
    label: "EPSG:3443 / NAD83(HARN) / Illinois East (ftUS)",
  },
  {
    value: "EPSG:3444",
    label: "EPSG:3444 / NAD83(HARN) / Illinois West (ftUS)",
  },
  {
    value: "EPSG:3445",
    label: "EPSG:3445 / NAD83(HARN) / New Hampshire (ftUS)",
  },
  {
    value: "EPSG:3446",
    label: "EPSG:3446 / NAD83(HARN) / Rhode Island (ftUS)",
  },
  { value: "EPSG:3447", label: "EPSG:3447 / ETRS89 / Belgian Lambert 2005" },
  { value: "EPSG:3448", label: "EPSG:3448 / JAD2001 / Jamaica Metric Grid" },
  { value: "EPSG:3449", label: "EPSG:3449 / JAD2001 / UTM zone 17N" },
  { value: "EPSG:3450", label: "EPSG:3450 / JAD2001 / UTM zone 18N" },
  { value: "EPSG:3451", label: "EPSG:3451 / NAD83 / Louisiana North (ftUS)" },
  { value: "EPSG:3452", label: "EPSG:3452 / NAD83 / Louisiana South (ftUS)" },
  {
    value: "EPSG:3453",
    label: "EPSG:3453 / NAD83 / Louisiana Offshore (ftUS)",
  },
  {
    value: "EPSG:3454",
    label: "EPSG:3454 / NAD83 / South Dakota North (ftUS)",
  },
  {
    value: "EPSG:3455",
    label: "EPSG:3455 / NAD83 / South Dakota South (ftUS)",
  },
  {
    value: "EPSG:3456",
    label: "EPSG:3456 / NAD83(HARN) / Louisiana North (ftUS)",
  },
  {
    value: "EPSG:3457",
    label: "EPSG:3457 / NAD83(HARN) / Louisiana South (ftUS)",
  },
  {
    value: "EPSG:3458",
    label: "EPSG:3458 / NAD83(HARN) / South Dakota North (ftUS)",
  },
  {
    value: "EPSG:3459",
    label: "EPSG:3459 / NAD83(HARN) / South Dakota South (ftUS)",
  },
  { value: "EPSG:3460", label: "EPSG:3460 / Fiji 1986 / Fiji Map Grid" },
  { value: "EPSG:3461", label: "EPSG:3461 / Dabola 1981 / UTM zone 28N" },
  { value: "EPSG:3462", label: "EPSG:3462 / Dabola 1981 / UTM zone 29N" },
  { value: "EPSG:3463", label: "EPSG:3463 / NAD83 / Maine CS2000 Central" },
  {
    value: "EPSG:3464",
    label: "EPSG:3464 / NAD83(HARN) / Maine CS2000 Central",
  },
  { value: "EPSG:3465", label: "EPSG:3465 / NAD83(NSRS2007) / Alabama East" },
  { value: "EPSG:3466", label: "EPSG:3466 / NAD83(NSRS2007) / Alabama West" },
  { value: "EPSG:3467", label: "EPSG:3467 / NAD83(NSRS2007) / Alaska Albers" },
  { value: "EPSG:3468", label: "EPSG:3468 / NAD83(NSRS2007) / Alaska zone 1" },
  { value: "EPSG:3469", label: "EPSG:3469 / NAD83(NSRS2007) / Alaska zone 2" },
  { value: "EPSG:3470", label: "EPSG:3470 / NAD83(NSRS2007) / Alaska zone 3" },
  { value: "EPSG:3471", label: "EPSG:3471 / NAD83(NSRS2007) / Alaska zone 4" },
  { value: "EPSG:3472", label: "EPSG:3472 / NAD83(NSRS2007) / Alaska zone 5" },
  { value: "EPSG:3473", label: "EPSG:3473 / NAD83(NSRS2007) / Alaska zone 6" },
  { value: "EPSG:3474", label: "EPSG:3474 / NAD83(NSRS2007) / Alaska zone 7" },
  { value: "EPSG:3475", label: "EPSG:3475 / NAD83(NSRS2007) / Alaska zone 8" },
  { value: "EPSG:3476", label: "EPSG:3476 / NAD83(NSRS2007) / Alaska zone 9" },
  { value: "EPSG:3477", label: "EPSG:3477 / NAD83(NSRS2007) / Alaska zone 10" },
  {
    value: "EPSG:3478",
    label: "EPSG:3478 / NAD83(NSRS2007) / Arizona Central",
  },
  {
    value: "EPSG:3479",
    label: "EPSG:3479 / NAD83(NSRS2007) / Arizona Central (ft)",
  },
  { value: "EPSG:3480", label: "EPSG:3480 / NAD83(NSRS2007) / Arizona East" },
  {
    value: "EPSG:3481",
    label: "EPSG:3481 / NAD83(NSRS2007) / Arizona East (ft)",
  },
  { value: "EPSG:3482", label: "EPSG:3482 / NAD83(NSRS2007) / Arizona West" },
  {
    value: "EPSG:3483",
    label: "EPSG:3483 / NAD83(NSRS2007) / Arizona West (ft)",
  },
  { value: "EPSG:3484", label: "EPSG:3484 / NAD83(NSRS2007) / Arkansas North" },
  {
    value: "EPSG:3485",
    label: "EPSG:3485 / NAD83(NSRS2007) / Arkansas North (ftUS)",
  },
  { value: "EPSG:3486", label: "EPSG:3486 / NAD83(NSRS2007) / Arkansas South" },
  {
    value: "EPSG:3487",
    label: "EPSG:3487 / NAD83(NSRS2007) / Arkansas South (ftUS)",
  },
  {
    value: "EPSG:3488",
    label: "EPSG:3488 / NAD83(NSRS2007) / California Albers",
  },
  {
    value: "EPSG:3489",
    label: "EPSG:3489 / NAD83(NSRS2007) / California zone 1",
  },
  {
    value: "EPSG:3490",
    label: "EPSG:3490 / NAD83(NSRS2007) / California zone 1 (ftUS)",
  },
  {
    value: "EPSG:3491",
    label: "EPSG:3491 / NAD83(NSRS2007) / California zone 2",
  },
  {
    value: "EPSG:3492",
    label: "EPSG:3492 / NAD83(NSRS2007) / California zone 2 (ftUS)",
  },
  {
    value: "EPSG:3493",
    label: "EPSG:3493 / NAD83(NSRS2007) / California zone 3",
  },
  {
    value: "EPSG:3494",
    label: "EPSG:3494 / NAD83(NSRS2007) / California zone 3 (ftUS)",
  },
  {
    value: "EPSG:3495",
    label: "EPSG:3495 / NAD83(NSRS2007) / California zone 4",
  },
  {
    value: "EPSG:3496",
    label: "EPSG:3496 / NAD83(NSRS2007) / California zone 4 (ftUS)",
  },
  {
    value: "EPSG:3497",
    label: "EPSG:3497 / NAD83(NSRS2007) / California zone 5",
  },
  {
    value: "EPSG:3498",
    label: "EPSG:3498 / NAD83(NSRS2007) / California zone 5 (ftUS)",
  },
  {
    value: "EPSG:3499",
    label: "EPSG:3499 / NAD83(NSRS2007) / California zone 6",
  },
  {
    value: "EPSG:3500",
    label: "EPSG:3500 / NAD83(NSRS2007) / California zone 6 (ftUS)",
  },
  {
    value: "EPSG:3501",
    label: "EPSG:3501 / NAD83(NSRS2007) / Colorado Central",
  },
  {
    value: "EPSG:3502",
    label: "EPSG:3502 / NAD83(NSRS2007) / Colorado Central (ftUS)",
  },
  { value: "EPSG:3503", label: "EPSG:3503 / NAD83(NSRS2007) / Colorado North" },
  {
    value: "EPSG:3504",
    label: "EPSG:3504 / NAD83(NSRS2007) / Colorado North (ftUS)",
  },
  { value: "EPSG:3505", label: "EPSG:3505 / NAD83(NSRS2007) / Colorado South" },
  {
    value: "EPSG:3506",
    label: "EPSG:3506 / NAD83(NSRS2007) / Colorado South (ftUS)",
  },
  { value: "EPSG:3507", label: "EPSG:3507 / NAD83(NSRS2007) / Connecticut" },
  {
    value: "EPSG:3508",
    label: "EPSG:3508 / NAD83(NSRS2007) / Connecticut (ftUS)",
  },
  { value: "EPSG:3509", label: "EPSG:3509 / NAD83(NSRS2007) / Delaware" },
  {
    value: "EPSG:3510",
    label: "EPSG:3510 / NAD83(NSRS2007) / Delaware (ftUS)",
  },
  { value: "EPSG:3511", label: "EPSG:3511 / NAD83(NSRS2007) / Florida East" },
  {
    value: "EPSG:3512",
    label: "EPSG:3512 / NAD83(NSRS2007) / Florida East (ftUS)",
  },
  {
    value: "EPSG:3513",
    label: "EPSG:3513 / NAD83(NSRS2007) / Florida GDL Albers",
  },
  { value: "EPSG:3514", label: "EPSG:3514 / NAD83(NSRS2007) / Florida North" },
  {
    value: "EPSG:3515",
    label: "EPSG:3515 / NAD83(NSRS2007) / Florida North (ftUS)",
  },
  { value: "EPSG:3516", label: "EPSG:3516 / NAD83(NSRS2007) / Florida West" },
  {
    value: "EPSG:3517",
    label: "EPSG:3517 / NAD83(NSRS2007) / Florida West (ftUS)",
  },
  { value: "EPSG:3518", label: "EPSG:3518 / NAD83(NSRS2007) / Georgia East" },
  {
    value: "EPSG:3519",
    label: "EPSG:3519 / NAD83(NSRS2007) / Georgia East (ftUS)",
  },
  { value: "EPSG:3520", label: "EPSG:3520 / NAD83(NSRS2007) / Georgia West" },
  {
    value: "EPSG:3521",
    label: "EPSG:3521 / NAD83(NSRS2007) / Georgia West (ftUS)",
  },
  { value: "EPSG:3522", label: "EPSG:3522 / NAD83(NSRS2007) / Idaho Central" },
  {
    value: "EPSG:3523",
    label: "EPSG:3523 / NAD83(NSRS2007) / Idaho Central (ftUS)",
  },
  { value: "EPSG:3524", label: "EPSG:3524 / NAD83(NSRS2007) / Idaho East" },
  {
    value: "EPSG:3525",
    label: "EPSG:3525 / NAD83(NSRS2007) / Idaho East (ftUS)",
  },
  { value: "EPSG:3526", label: "EPSG:3526 / NAD83(NSRS2007) / Idaho West" },
  {
    value: "EPSG:3527",
    label: "EPSG:3527 / NAD83(NSRS2007) / Idaho West (ftUS)",
  },
  { value: "EPSG:3528", label: "EPSG:3528 / NAD83(NSRS2007) / Illinois East" },
  {
    value: "EPSG:3529",
    label: "EPSG:3529 / NAD83(NSRS2007) / Illinois East (ftUS)",
  },
  { value: "EPSG:3530", label: "EPSG:3530 / NAD83(NSRS2007) / Illinois West" },
  {
    value: "EPSG:3531",
    label: "EPSG:3531 / NAD83(NSRS2007) / Illinois West (ftUS)",
  },
  { value: "EPSG:3532", label: "EPSG:3532 / NAD83(NSRS2007) / Indiana East" },
  {
    value: "EPSG:3533",
    label: "EPSG:3533 / NAD83(NSRS2007) / Indiana East (ftUS)",
  },
  { value: "EPSG:3534", label: "EPSG:3534 / NAD83(NSRS2007) / Indiana West" },
  {
    value: "EPSG:3535",
    label: "EPSG:3535 / NAD83(NSRS2007) / Indiana West (ftUS)",
  },
  { value: "EPSG:3536", label: "EPSG:3536 / NAD83(NSRS2007) / Iowa North" },
  {
    value: "EPSG:3537",
    label: "EPSG:3537 / NAD83(NSRS2007) / Iowa North (ftUS)",
  },
  { value: "EPSG:3538", label: "EPSG:3538 / NAD83(NSRS2007) / Iowa South" },
  {
    value: "EPSG:3539",
    label: "EPSG:3539 / NAD83(NSRS2007) / Iowa South (ftUS)",
  },
  { value: "EPSG:3540", label: "EPSG:3540 / NAD83(NSRS2007) / Kansas North" },
  {
    value: "EPSG:3541",
    label: "EPSG:3541 / NAD83(NSRS2007) / Kansas North (ftUS)",
  },
  { value: "EPSG:3542", label: "EPSG:3542 / NAD83(NSRS2007) / Kansas South" },
  {
    value: "EPSG:3543",
    label: "EPSG:3543 / NAD83(NSRS2007) / Kansas South (ftUS)",
  },
  { value: "EPSG:3544", label: "EPSG:3544 / NAD83(NSRS2007) / Kentucky North" },
  {
    value: "EPSG:3545",
    label: "EPSG:3545 / NAD83(NSRS2007) / Kentucky North (ftUS)",
  },
  {
    value: "EPSG:3546",
    label: "EPSG:3546 / NAD83(NSRS2007) / Kentucky Single Zone",
  },
  {
    value: "EPSG:3547",
    label: "EPSG:3547 / NAD83(NSRS2007) / Kentucky Single Zone (ftUS)",
  },
  { value: "EPSG:3548", label: "EPSG:3548 / NAD83(NSRS2007) / Kentucky South" },
  {
    value: "EPSG:3549",
    label: "EPSG:3549 / NAD83(NSRS2007) / Kentucky South (ftUS)",
  },
  {
    value: "EPSG:3550",
    label: "EPSG:3550 / NAD83(NSRS2007) / Louisiana North",
  },
  {
    value: "EPSG:3551",
    label: "EPSG:3551 / NAD83(NSRS2007) / Louisiana North (ftUS)",
  },
  {
    value: "EPSG:3552",
    label: "EPSG:3552 / NAD83(NSRS2007) / Louisiana South",
  },
  {
    value: "EPSG:3553",
    label: "EPSG:3553 / NAD83(NSRS2007) / Louisiana South (ftUS)",
  },
  {
    value: "EPSG:3554",
    label: "EPSG:3554 / NAD83(NSRS2007) / Maine CS2000 Central",
  },
  {
    value: "EPSG:3555",
    label: "EPSG:3555 / NAD83(NSRS2007) / Maine CS2000 East",
  },
  {
    value: "EPSG:3556",
    label: "EPSG:3556 / NAD83(NSRS2007) / Maine CS2000 West",
  },
  { value: "EPSG:3557", label: "EPSG:3557 / NAD83(NSRS2007) / Maine East" },
  { value: "EPSG:3558", label: "EPSG:3558 / NAD83(NSRS2007) / Maine West" },
  { value: "EPSG:3559", label: "EPSG:3559 / NAD83(NSRS2007) / Maryland" },
  { value: "EPSG:3560", label: "EPSG:3560 / NAD83 / Utah North (ftUS)" },
  { value: "EPSG:3561", label: "EPSG:3561 / Old Hawaiian / Hawaii zone 1" },
  { value: "EPSG:3562", label: "EPSG:3562 / Old Hawaiian / Hawaii zone 2" },
  { value: "EPSG:3563", label: "EPSG:3563 / Old Hawaiian / Hawaii zone 3" },
  { value: "EPSG:3564", label: "EPSG:3564 / Old Hawaiian / Hawaii zone 4" },
  { value: "EPSG:3565", label: "EPSG:3565 / Old Hawaiian / Hawaii zone 5" },
  { value: "EPSG:3566", label: "EPSG:3566 / NAD83 / Utah Central (ftUS)" },
  { value: "EPSG:3567", label: "EPSG:3567 / NAD83 / Utah South (ftUS)" },
  { value: "EPSG:3568", label: "EPSG:3568 / NAD83(HARN) / Utah North (ftUS)" },
  {
    value: "EPSG:3569",
    label: "EPSG:3569 / NAD83(HARN) / Utah Central (ftUS)",
  },
  { value: "EPSG:3570", label: "EPSG:3570 / NAD83(HARN) / Utah South (ftUS)" },
  {
    value: "EPSG:3571",
    label: "EPSG:3571 / WGS 84 / North Pole LAEA Bering Sea",
  },
  { value: "EPSG:3572", label: "EPSG:3572 / WGS 84 / North Pole LAEA Alaska" },
  { value: "EPSG:3573", label: "EPSG:3573 / WGS 84 / North Pole LAEA Canada" },
  {
    value: "EPSG:3574",
    label: "EPSG:3574 / WGS 84 / North Pole LAEA Atlantic",
  },
  { value: "EPSG:3575", label: "EPSG:3575 / WGS 84 / North Pole LAEA Europe" },
  { value: "EPSG:3576", label: "EPSG:3576 / WGS 84 / North Pole LAEA Russia" },
  { value: "EPSG:3577", label: "EPSG:3577 / GDA94 / Australian Albers" },
  { value: "EPSG:3578", label: "EPSG:3578 / NAD83 / Yukon Albers" },
  { value: "EPSG:3579", label: "EPSG:3579 / NAD83(CSRS) / Yukon Albers" },
  { value: "EPSG:3580", label: "EPSG:3580 / NAD83 / NWT Lambert" },
  { value: "EPSG:3581", label: "EPSG:3581 / NAD83(CSRS) / NWT Lambert" },
  {
    value: "EPSG:3582",
    label: "EPSG:3582 / NAD83(NSRS2007) / Maryland (ftUS)",
  },
  {
    value: "EPSG:3583",
    label: "EPSG:3583 / NAD83(NSRS2007) / Massachusetts Island",
  },
  {
    value: "EPSG:3584",
    label: "EPSG:3584 / NAD83(NSRS2007) / Massachusetts Island (ftUS)",
  },
  {
    value: "EPSG:3585",
    label: "EPSG:3585 / NAD83(NSRS2007) / Massachusetts Mainland",
  },
  {
    value: "EPSG:3586",
    label: "EPSG:3586 / NAD83(NSRS2007) / Massachusetts Mainland (ftUS)",
  },
  {
    value: "EPSG:3587",
    label: "EPSG:3587 / NAD83(NSRS2007) / Michigan Central",
  },
  {
    value: "EPSG:3588",
    label: "EPSG:3588 / NAD83(NSRS2007) / Michigan Central (ft)",
  },
  { value: "EPSG:3589", label: "EPSG:3589 / NAD83(NSRS2007) / Michigan North" },
  {
    value: "EPSG:3590",
    label: "EPSG:3590 / NAD83(NSRS2007) / Michigan North (ft)",
  },
  {
    value: "EPSG:3591",
    label: "EPSG:3591 / NAD83(NSRS2007) / Michigan Oblique Mercator",
  },
  { value: "EPSG:3592", label: "EPSG:3592 / NAD83(NSRS2007) / Michigan South" },
  {
    value: "EPSG:3593",
    label: "EPSG:3593 / NAD83(NSRS2007) / Michigan South (ft)",
  },
  {
    value: "EPSG:3594",
    label: "EPSG:3594 / NAD83(NSRS2007) / Minnesota Central",
  },
  {
    value: "EPSG:3595",
    label: "EPSG:3595 / NAD83(NSRS2007) / Minnesota North",
  },
  {
    value: "EPSG:3596",
    label: "EPSG:3596 / NAD83(NSRS2007) / Minnesota South",
  },
  {
    value: "EPSG:3597",
    label: "EPSG:3597 / NAD83(NSRS2007) / Mississippi East",
  },
  {
    value: "EPSG:3598",
    label: "EPSG:3598 / NAD83(NSRS2007) / Mississippi East (ftUS)",
  },
  {
    value: "EPSG:3599",
    label: "EPSG:3599 / NAD83(NSRS2007) / Mississippi West",
  },
  {
    value: "EPSG:3600",
    label: "EPSG:3600 / NAD83(NSRS2007) / Mississippi West (ftUS)",
  },
  {
    value: "EPSG:3601",
    label: "EPSG:3601 / NAD83(NSRS2007) / Missouri Central",
  },
  { value: "EPSG:3602", label: "EPSG:3602 / NAD83(NSRS2007) / Missouri East" },
  { value: "EPSG:3603", label: "EPSG:3603 / NAD83(NSRS2007) / Missouri West" },
  { value: "EPSG:3604", label: "EPSG:3604 / NAD83(NSRS2007) / Montana" },
  { value: "EPSG:3605", label: "EPSG:3605 / NAD83(NSRS2007) / Montana (ft)" },
  { value: "EPSG:3606", label: "EPSG:3606 / NAD83(NSRS2007) / Nebraska" },
  { value: "EPSG:3607", label: "EPSG:3607 / NAD83(NSRS2007) / Nevada Central" },
  {
    value: "EPSG:3608",
    label: "EPSG:3608 / NAD83(NSRS2007) / Nevada Central (ftUS)",
  },
  { value: "EPSG:3609", label: "EPSG:3609 / NAD83(NSRS2007) / Nevada East" },
  {
    value: "EPSG:3610",
    label: "EPSG:3610 / NAD83(NSRS2007) / Nevada East (ftUS)",
  },
  { value: "EPSG:3611", label: "EPSG:3611 / NAD83(NSRS2007) / Nevada West" },
  {
    value: "EPSG:3612",
    label: "EPSG:3612 / NAD83(NSRS2007) / Nevada West (ftUS)",
  },
  { value: "EPSG:3613", label: "EPSG:3613 / NAD83(NSRS2007) / New Hampshire" },
  {
    value: "EPSG:3614",
    label: "EPSG:3614 / NAD83(NSRS2007) / New Hampshire (ftUS)",
  },
  { value: "EPSG:3615", label: "EPSG:3615 / NAD83(NSRS2007) / New Jersey" },
  {
    value: "EPSG:3616",
    label: "EPSG:3616 / NAD83(NSRS2007) / New Jersey (ftUS)",
  },
  {
    value: "EPSG:3617",
    label: "EPSG:3617 / NAD83(NSRS2007) / New Mexico Central",
  },
  {
    value: "EPSG:3618",
    label: "EPSG:3618 / NAD83(NSRS2007) / New Mexico Central (ftUS)",
  },
  {
    value: "EPSG:3619",
    label: "EPSG:3619 / NAD83(NSRS2007) / New Mexico East",
  },
  {
    value: "EPSG:3620",
    label: "EPSG:3620 / NAD83(NSRS2007) / New Mexico East (ftUS)",
  },
  {
    value: "EPSG:3621",
    label: "EPSG:3621 / NAD83(NSRS2007) / New Mexico West",
  },
  {
    value: "EPSG:3622",
    label: "EPSG:3622 / NAD83(NSRS2007) / New Mexico West (ftUS)",
  },
  {
    value: "EPSG:3623",
    label: "EPSG:3623 / NAD83(NSRS2007) / New York Central",
  },
  {
    value: "EPSG:3624",
    label: "EPSG:3624 / NAD83(NSRS2007) / New York Central (ftUS)",
  },
  { value: "EPSG:3625", label: "EPSG:3625 / NAD83(NSRS2007) / New York East" },
  {
    value: "EPSG:3626",
    label: "EPSG:3626 / NAD83(NSRS2007) / New York East (ftUS)",
  },
  {
    value: "EPSG:3627",
    label: "EPSG:3627 / NAD83(NSRS2007) / New York Long Island",
  },
  {
    value: "EPSG:3628",
    label: "EPSG:3628 / NAD83(NSRS2007) / New York Long Island (ftUS)",
  },
  { value: "EPSG:3629", label: "EPSG:3629 / NAD83(NSRS2007) / New York West" },
  {
    value: "EPSG:3630",
    label: "EPSG:3630 / NAD83(NSRS2007) / New York West (ftUS)",
  },
  { value: "EPSG:3631", label: "EPSG:3631 / NAD83(NSRS2007) / North Carolina" },
  {
    value: "EPSG:3632",
    label: "EPSG:3632 / NAD83(NSRS2007) / North Carolina (ftUS)",
  },
  {
    value: "EPSG:3633",
    label: "EPSG:3633 / NAD83(NSRS2007) / North Dakota North",
  },
  {
    value: "EPSG:3634",
    label: "EPSG:3634 / NAD83(NSRS2007) / North Dakota North (ft)",
  },
  {
    value: "EPSG:3635",
    label: "EPSG:3635 / NAD83(NSRS2007) / North Dakota South",
  },
  {
    value: "EPSG:3636",
    label: "EPSG:3636 / NAD83(NSRS2007) / North Dakota South (ft)",
  },
  { value: "EPSG:3637", label: "EPSG:3637 / NAD83(NSRS2007) / Ohio North" },
  { value: "EPSG:3638", label: "EPSG:3638 / NAD83(NSRS2007) / Ohio South" },
  { value: "EPSG:3639", label: "EPSG:3639 / NAD83(NSRS2007) / Oklahoma North" },
  {
    value: "EPSG:3640",
    label: "EPSG:3640 / NAD83(NSRS2007) / Oklahoma North (ftUS)",
  },
  { value: "EPSG:3641", label: "EPSG:3641 / NAD83(NSRS2007) / Oklahoma South" },
  {
    value: "EPSG:3642",
    label: "EPSG:3642 / NAD83(NSRS2007) / Oklahoma South (ftUS)",
  },
  { value: "EPSG:3643", label: "EPSG:3643 / NAD83(NSRS2007) / Oregon LCC (m)" },
  {
    value: "EPSG:3644",
    label: "EPSG:3644 / NAD83(NSRS2007) / Oregon GIC Lambert (ft)",
  },
  { value: "EPSG:3645", label: "EPSG:3645 / NAD83(NSRS2007) / Oregon North" },
  {
    value: "EPSG:3646",
    label: "EPSG:3646 / NAD83(NSRS2007) / Oregon North (ft)",
  },
  { value: "EPSG:3647", label: "EPSG:3647 / NAD83(NSRS2007) / Oregon South" },
  {
    value: "EPSG:3648",
    label: "EPSG:3648 / NAD83(NSRS2007) / Oregon South (ft)",
  },
  {
    value: "EPSG:3649",
    label: "EPSG:3649 / NAD83(NSRS2007) / Pennsylvania North",
  },
  {
    value: "EPSG:3650",
    label: "EPSG:3650 / NAD83(NSRS2007) / Pennsylvania North (ftUS)",
  },
  {
    value: "EPSG:3651",
    label: "EPSG:3651 / NAD83(NSRS2007) / Pennsylvania South",
  },
  {
    value: "EPSG:3652",
    label: "EPSG:3652 / NAD83(NSRS2007) / Pennsylvania South (ftUS)",
  },
  { value: "EPSG:3653", label: "EPSG:3653 / NAD83(NSRS2007) / Rhode Island" },
  {
    value: "EPSG:3654",
    label: "EPSG:3654 / NAD83(NSRS2007) / Rhode Island (ftUS)",
  },
  { value: "EPSG:3655", label: "EPSG:3655 / NAD83(NSRS2007) / South Carolina" },
  {
    value: "EPSG:3656",
    label: "EPSG:3656 / NAD83(NSRS2007) / South Carolina (ft)",
  },
  {
    value: "EPSG:3657",
    label: "EPSG:3657 / NAD83(NSRS2007) / South Dakota North",
  },
  {
    value: "EPSG:3658",
    label: "EPSG:3658 / NAD83(NSRS2007) / South Dakota North (ftUS)",
  },
  {
    value: "EPSG:3659",
    label: "EPSG:3659 / NAD83(NSRS2007) / South Dakota South",
  },
  {
    value: "EPSG:3660",
    label: "EPSG:3660 / NAD83(NSRS2007) / South Dakota South (ftUS)",
  },
  { value: "EPSG:3661", label: "EPSG:3661 / NAD83(NSRS2007) / Tennessee" },
  {
    value: "EPSG:3662",
    label: "EPSG:3662 / NAD83(NSRS2007) / Tennessee (ftUS)",
  },
  { value: "EPSG:3663", label: "EPSG:3663 / NAD83(NSRS2007) / Texas Central" },
  {
    value: "EPSG:3664",
    label: "EPSG:3664 / NAD83(NSRS2007) / Texas Central (ftUS)",
  },
  {
    value: "EPSG:3665",
    label: "EPSG:3665 / NAD83(NSRS2007) / Texas Centric Albers Equal Area",
  },
  {
    value: "EPSG:3666",
    label: "EPSG:3666 / NAD83(NSRS2007) / Texas Centric Lambert Conformal",
  },
  { value: "EPSG:3667", label: "EPSG:3667 / NAD83(NSRS2007) / Texas North" },
  {
    value: "EPSG:3668",
    label: "EPSG:3668 / NAD83(NSRS2007) / Texas North (ftUS)",
  },
  {
    value: "EPSG:3669",
    label: "EPSG:3669 / NAD83(NSRS2007) / Texas North Central",
  },
  {
    value: "EPSG:3670",
    label: "EPSG:3670 / NAD83(NSRS2007) / Texas North Central (ftUS)",
  },
  { value: "EPSG:3671", label: "EPSG:3671 / NAD83(NSRS2007) / Texas South" },
  {
    value: "EPSG:3672",
    label: "EPSG:3672 / NAD83(NSRS2007) / Texas South (ftUS)",
  },
  {
    value: "EPSG:3673",
    label: "EPSG:3673 / NAD83(NSRS2007) / Texas South Central",
  },
  {
    value: "EPSG:3674",
    label: "EPSG:3674 / NAD83(NSRS2007) / Texas South Central (ftUS)",
  },
  { value: "EPSG:3675", label: "EPSG:3675 / NAD83(NSRS2007) / Utah Central" },
  {
    value: "EPSG:3676",
    label: "EPSG:3676 / NAD83(NSRS2007) / Utah Central (ft)",
  },
  {
    value: "EPSG:3677",
    label: "EPSG:3677 / NAD83(NSRS2007) / Utah Central (ftUS)",
  },
  { value: "EPSG:3678", label: "EPSG:3678 / NAD83(NSRS2007) / Utah North" },
  {
    value: "EPSG:3679",
    label: "EPSG:3679 / NAD83(NSRS2007) / Utah North (ft)",
  },
  {
    value: "EPSG:3680",
    label: "EPSG:3680 / NAD83(NSRS2007) / Utah North (ftUS)",
  },
  { value: "EPSG:3681", label: "EPSG:3681 / NAD83(NSRS2007) / Utah South" },
  {
    value: "EPSG:3682",
    label: "EPSG:3682 / NAD83(NSRS2007) / Utah South (ft)",
  },
  {
    value: "EPSG:3683",
    label: "EPSG:3683 / NAD83(NSRS2007) / Utah South (ftUS)",
  },
  { value: "EPSG:3684", label: "EPSG:3684 / NAD83(NSRS2007) / Vermont" },
  { value: "EPSG:3685", label: "EPSG:3685 / NAD83(NSRS2007) / Virginia North" },
  {
    value: "EPSG:3686",
    label: "EPSG:3686 / NAD83(NSRS2007) / Virginia North (ftUS)",
  },
  { value: "EPSG:3687", label: "EPSG:3687 / NAD83(NSRS2007) / Virginia South" },
  {
    value: "EPSG:3688",
    label: "EPSG:3688 / NAD83(NSRS2007) / Virginia South (ftUS)",
  },
  {
    value: "EPSG:3689",
    label: "EPSG:3689 / NAD83(NSRS2007) / Washington North",
  },
  {
    value: "EPSG:3690",
    label: "EPSG:3690 / NAD83(NSRS2007) / Washington North (ftUS)",
  },
  {
    value: "EPSG:3691",
    label: "EPSG:3691 / NAD83(NSRS2007) / Washington South",
  },
  {
    value: "EPSG:3692",
    label: "EPSG:3692 / NAD83(NSRS2007) / Washington South (ftUS)",
  },
  {
    value: "EPSG:3693",
    label: "EPSG:3693 / NAD83(NSRS2007) / West Virginia North",
  },
  {
    value: "EPSG:3694",
    label: "EPSG:3694 / NAD83(NSRS2007) / West Virginia South",
  },
  {
    value: "EPSG:3695",
    label: "EPSG:3695 / NAD83(NSRS2007) / Wisconsin Central",
  },
  {
    value: "EPSG:3696",
    label: "EPSG:3696 / NAD83(NSRS2007) / Wisconsin Central (ftUS)",
  },
  {
    value: "EPSG:3697",
    label: "EPSG:3697 / NAD83(NSRS2007) / Wisconsin North",
  },
  {
    value: "EPSG:3698",
    label: "EPSG:3698 / NAD83(NSRS2007) / Wisconsin North (ftUS)",
  },
  {
    value: "EPSG:3699",
    label: "EPSG:3699 / NAD83(NSRS2007) / Wisconsin South",
  },
  {
    value: "EPSG:3700",
    label: "EPSG:3700 / NAD83(NSRS2007) / Wisconsin South (ftUS)",
  },
  {
    value: "EPSG:3701",
    label: "EPSG:3701 / NAD83(NSRS2007) / Wisconsin Transverse Mercator",
  },
  { value: "EPSG:3702", label: "EPSG:3702 / NAD83(NSRS2007) / Wyoming East" },
  {
    value: "EPSG:3703",
    label: "EPSG:3703 / NAD83(NSRS2007) / Wyoming East Central",
  },
  {
    value: "EPSG:3704",
    label: "EPSG:3704 / NAD83(NSRS2007) / Wyoming West Central",
  },
  { value: "EPSG:3705", label: "EPSG:3705 / NAD83(NSRS2007) / Wyoming West" },
  { value: "EPSG:3706", label: "EPSG:3706 / NAD83(NSRS2007) / UTM zone 59N" },
  { value: "EPSG:3707", label: "EPSG:3707 / NAD83(NSRS2007) / UTM zone 60N" },
  { value: "EPSG:3708", label: "EPSG:3708 / NAD83(NSRS2007) / UTM zone 1N" },
  { value: "EPSG:3709", label: "EPSG:3709 / NAD83(NSRS2007) / UTM zone 2N" },
  { value: "EPSG:3710", label: "EPSG:3710 / NAD83(NSRS2007) / UTM zone 3N" },
  { value: "EPSG:3711", label: "EPSG:3711 / NAD83(NSRS2007) / UTM zone 4N" },
  { value: "EPSG:3712", label: "EPSG:3712 / NAD83(NSRS2007) / UTM zone 5N" },
  { value: "EPSG:3713", label: "EPSG:3713 / NAD83(NSRS2007) / UTM zone 6N" },
  { value: "EPSG:3714", label: "EPSG:3714 / NAD83(NSRS2007) / UTM zone 7N" },
  { value: "EPSG:3715", label: "EPSG:3715 / NAD83(NSRS2007) / UTM zone 8N" },
  { value: "EPSG:3716", label: "EPSG:3716 / NAD83(NSRS2007) / UTM zone 9N" },
  { value: "EPSG:3717", label: "EPSG:3717 / NAD83(NSRS2007) / UTM zone 10N" },
  { value: "EPSG:3718", label: "EPSG:3718 / NAD83(NSRS2007) / UTM zone 11N" },
  { value: "EPSG:3719", label: "EPSG:3719 / NAD83(NSRS2007) / UTM zone 12N" },
  { value: "EPSG:3720", label: "EPSG:3720 / NAD83(NSRS2007) / UTM zone 13N" },
  { value: "EPSG:3721", label: "EPSG:3721 / NAD83(NSRS2007) / UTM zone 14N" },
  { value: "EPSG:3722", label: "EPSG:3722 / NAD83(NSRS2007) / UTM zone 15N" },
  { value: "EPSG:3723", label: "EPSG:3723 / NAD83(NSRS2007) / UTM zone 16N" },
  { value: "EPSG:3724", label: "EPSG:3724 / NAD83(NSRS2007) / UTM zone 17N" },
  { value: "EPSG:3725", label: "EPSG:3725 / NAD83(NSRS2007) / UTM zone 18N" },
  { value: "EPSG:3726", label: "EPSG:3726 / NAD83(NSRS2007) / UTM zone 19N" },
  { value: "EPSG:3727", label: "EPSG:3727 / Reunion 1947 / TM Reunion" },
  {
    value: "EPSG:3728",
    label: "EPSG:3728 / NAD83(NSRS2007) / Ohio North (ftUS)",
  },
  {
    value: "EPSG:3729",
    label: "EPSG:3729 / NAD83(NSRS2007) / Ohio South (ftUS)",
  },
  {
    value: "EPSG:3730",
    label: "EPSG:3730 / NAD83(NSRS2007) / Wyoming East (ftUS)",
  },
  {
    value: "EPSG:3731",
    label: "EPSG:3731 / NAD83(NSRS2007) / Wyoming East Central (ftUS)",
  },
  {
    value: "EPSG:3732",
    label: "EPSG:3732 / NAD83(NSRS2007) / Wyoming West Central (ftUS)",
  },
  {
    value: "EPSG:3733",
    label: "EPSG:3733 / NAD83(NSRS2007) / Wyoming West (ftUS)",
  },
  { value: "EPSG:3734", label: "EPSG:3734 / NAD83 / Ohio North (ftUS)" },
  { value: "EPSG:3735", label: "EPSG:3735 / NAD83 / Ohio South (ftUS)" },
  { value: "EPSG:3736", label: "EPSG:3736 / NAD83 / Wyoming East (ftUS)" },
  {
    value: "EPSG:3737",
    label: "EPSG:3737 / NAD83 / Wyoming East Central (ftUS)",
  },
  {
    value: "EPSG:3738",
    label: "EPSG:3738 / NAD83 / Wyoming West Central (ftUS)",
  },
  { value: "EPSG:3739", label: "EPSG:3739 / NAD83 / Wyoming West (ftUS)" },
  { value: "EPSG:3740", label: "EPSG:3740 / NAD83(HARN) / UTM zone 10N" },
  { value: "EPSG:3741", label: "EPSG:3741 / NAD83(HARN) / UTM zone 11N" },
  { value: "EPSG:3742", label: "EPSG:3742 / NAD83(HARN) / UTM zone 12N" },
  { value: "EPSG:3743", label: "EPSG:3743 / NAD83(HARN) / UTM zone 13N" },
  { value: "EPSG:3744", label: "EPSG:3744 / NAD83(HARN) / UTM zone 14N" },
  { value: "EPSG:3745", label: "EPSG:3745 / NAD83(HARN) / UTM zone 15N" },
  { value: "EPSG:3746", label: "EPSG:3746 / NAD83(HARN) / UTM zone 16N" },
  { value: "EPSG:3747", label: "EPSG:3747 / NAD83(HARN) / UTM zone 17N" },
  { value: "EPSG:3748", label: "EPSG:3748 / NAD83(HARN) / UTM zone 18N" },
  { value: "EPSG:3749", label: "EPSG:3749 / NAD83(HARN) / UTM zone 19N" },
  { value: "EPSG:3750", label: "EPSG:3750 / NAD83(HARN) / UTM zone 4N" },
  { value: "EPSG:3751", label: "EPSG:3751 / NAD83(HARN) / UTM zone 5N" },
  { value: "EPSG:3752", label: "EPSG:3752 / WGS 84 / Mercator 41" },
  { value: "EPSG:3753", label: "EPSG:3753 / NAD83(HARN) / Ohio North (ftUS)" },
  { value: "EPSG:3754", label: "EPSG:3754 / NAD83(HARN) / Ohio South (ftUS)" },
  {
    value: "EPSG:3755",
    label: "EPSG:3755 / NAD83(HARN) / Wyoming East (ftUS)",
  },
  {
    value: "EPSG:3756",
    label: "EPSG:3756 / NAD83(HARN) / Wyoming East Central (ftUS)",
  },
  {
    value: "EPSG:3757",
    label: "EPSG:3757 / NAD83(HARN) / Wyoming West Central (ftUS)",
  },
  {
    value: "EPSG:3758",
    label: "EPSG:3758 / NAD83(HARN) / Wyoming West (ftUS)",
  },
  { value: "EPSG:3759", label: "EPSG:3759 / NAD83 / Hawaii zone 3 (ftUS)" },
  {
    value: "EPSG:3760",
    label: "EPSG:3760 / NAD83(HARN) / Hawaii zone 3 (ftUS)",
  },
  { value: "EPSG:3761", label: "EPSG:3761 / NAD83(CSRS) / UTM zone 22N" },
  { value: "EPSG:3762", label: "EPSG:3762 / WGS 84 / South Georgia Lambert" },
  { value: "EPSG:3763", label: "EPSG:3763 / ETRS89 / Portugal TM06" },
  {
    value: "EPSG:3764",
    label: "EPSG:3764 / NZGD2000 / Chatham Island Circuit 2000",
  },
  { value: "EPSG:3765", label: "EPSG:3765 / HTRS96 / Croatia TM" },
  { value: "EPSG:3766", label: "EPSG:3766 / HTRS96 / Croatia LCC" },
  { value: "EPSG:3767", label: "EPSG:3767 / HTRS96 / UTM zone 33N" },
  { value: "EPSG:3768", label: "EPSG:3768 / HTRS96 / UTM zone 34N" },
  { value: "EPSG:3769", label: "EPSG:3769 / Bermuda 1957 / UTM zone 20N" },
  {
    value: "EPSG:3770",
    label: "EPSG:3770 / BDA2000 / Bermuda 2000 National Grid",
  },
  {
    value: "EPSG:3771",
    label: "EPSG:3771 / NAD27 / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:3772",
    label: "EPSG:3772 / NAD27 / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:3773",
    label: "EPSG:3773 / NAD27 / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:3774",
    label: "EPSG:3774 / NAD27 / Alberta 3TM ref merid 120 W",
  },
  {
    value: "EPSG:3775",
    label: "EPSG:3775 / NAD83 / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:3776",
    label: "EPSG:3776 / NAD83 / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:3777",
    label: "EPSG:3777 / NAD83 / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:3778",
    label: "EPSG:3778 / NAD83 / Alberta 3TM ref merid 120 W",
  },
  {
    value: "EPSG:3779",
    label: "EPSG:3779 / NAD83(CSRS) / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:3780",
    label: "EPSG:3780 / NAD83(CSRS) / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:3781",
    label: "EPSG:3781 / NAD83(CSRS) / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:3782",
    label: "EPSG:3782 / NAD83(CSRS) / Alberta 3TM ref merid 120 W",
  },
  { value: "EPSG:3783", label: "EPSG:3783 / Pitcairn 2006 / Pitcairn TM 2006" },
  { value: "EPSG:3784", label: "EPSG:3784 / Pitcairn 1967 / UTM zone 9S" },
  {
    value: "EPSG:3785",
    label: "EPSG:3785 / Popular Visualisation CRS / Mercator",
  },
  {
    value: "EPSG:3786",
    label: "EPSG:3786 / World Equidistant Cylindrical (Sphere)",
  },
  { value: "EPSG:3787", label: "EPSG:3787 / MGI / Slovene National Grid" },
  {
    value: "EPSG:3788",
    label: "EPSG:3788 / NZGD2000 / Auckland Islands TM 2000",
  },
  {
    value: "EPSG:3789",
    label: "EPSG:3789 / NZGD2000 / Campbell Island TM 2000",
  },
  {
    value: "EPSG:3790",
    label: "EPSG:3790 / NZGD2000 / Antipodes Islands TM 2000",
  },
  { value: "EPSG:3791", label: "EPSG:3791 / NZGD2000 / Raoul Island TM 2000" },
  {
    value: "EPSG:3793",
    label: "EPSG:3793 / NZGD2000 / Chatham Islands TM 2000",
  },
  {
    value: "EPSG:3794",
    label: "EPSG:3794 / Slovenia 1996 / Slovene National Grid",
  },
  { value: "EPSG:3795", label: "EPSG:3795 / NAD27 / Cuba Norte" },
  { value: "EPSG:3796", label: "EPSG:3796 / NAD27 / Cuba Sur" },
  { value: "EPSG:3797", label: "EPSG:3797 / NAD27 / MTQ Lambert" },
  { value: "EPSG:3798", label: "EPSG:3798 / NAD83 / MTQ Lambert" },
  { value: "EPSG:3799", label: "EPSG:3799 / NAD83(CSRS) / MTQ Lambert" },
  {
    value: "EPSG:3800",
    label: "EPSG:3800 / NAD27 / Alberta 3TM ref merid 120 W",
  },
  {
    value: "EPSG:3801",
    label: "EPSG:3801 / NAD83 / Alberta 3TM ref merid 120 W",
  },
  {
    value: "EPSG:3802",
    label: "EPSG:3802 / NAD83(CSRS) / Alberta 3TM ref merid 120 W",
  },
  { value: "EPSG:3812", label: "EPSG:3812 / ETRS89 / Belgian Lambert 2008" },
  { value: "EPSG:3814", label: "EPSG:3814 / NAD83 / Mississippi TM" },
  { value: "EPSG:3815", label: "EPSG:3815 / NAD83(HARN) / Mississippi TM" },
  { value: "EPSG:3816", label: "EPSG:3816 / NAD83(NSRS2007) / Mississippi TM" },
  { value: "EPSG:3825", label: "EPSG:3825 / TWD97 / TM2 zone 119" },
  { value: "EPSG:3826", label: "EPSG:3826 / TWD97 / TM2 zone 121" },
  { value: "EPSG:3827", label: "EPSG:3827 / TWD67 / TM2 zone 119" },
  { value: "EPSG:3828", label: "EPSG:3828 / TWD67 / TM2 zone 121" },
  { value: "EPSG:3829", label: "EPSG:3829 / Hu Tzu Shan 1950 / UTM zone 51N" },
  { value: "EPSG:3832", label: "EPSG:3832 / WGS 84 / PDC Mercator" },
  {
    value: "EPSG:3833",
    label: "EPSG:3833 / Pulkovo 1942(58) / Gauss-Kruger zone 2",
  },
  {
    value: "EPSG:3834",
    label: "EPSG:3834 / Pulkovo 1942(83) / Gauss-Kruger zone 2",
  },
  {
    value: "EPSG:3835",
    label: "EPSG:3835 / Pulkovo 1942(83) / Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:3836",
    label: "EPSG:3836 / Pulkovo 1942(83) / Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:3837",
    label: "EPSG:3837 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:3838",
    label: "EPSG:3838 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:3839",
    label: "EPSG:3839 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:3840",
    label: "EPSG:3840 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:3841",
    label: "EPSG:3841 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:3842",
    label: "EPSG:3842 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:3843",
    label: "EPSG:3843 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 8",
  },
  { value: "EPSG:3844", label: "EPSG:3844 / Pulkovo 1942(58) / Stereo70" },
  {
    value: "EPSG:3845",
    label: "EPSG:3845 / SWEREF99 / RT90 7.5 gon V emulation",
  },
  {
    value: "EPSG:3846",
    label: "EPSG:3846 / SWEREF99 / RT90 5 gon V emulation",
  },
  {
    value: "EPSG:3847",
    label: "EPSG:3847 / SWEREF99 / RT90 2.5 gon V emulation",
  },
  { value: "EPSG:3848", label: "EPSG:3848 / SWEREF99 / RT90 0 gon emulation" },
  {
    value: "EPSG:3849",
    label: "EPSG:3849 / SWEREF99 / RT90 2.5 gon O emulation",
  },
  {
    value: "EPSG:3850",
    label: "EPSG:3850 / SWEREF99 / RT90 5 gon O emulation",
  },
  { value: "EPSG:3851", label: "EPSG:3851 / NZGD2000 / NZCS2000" },
  { value: "EPSG:3852", label: "EPSG:3852 / RSRGD2000 / DGLC2000" },
  { value: "EPSG:3854", label: "EPSG:3854 / County ST74" },
  { value: "EPSG:3857", label: "EPSG:3857 / WGS 84 / Pseudo-Mercator" },
  { value: "EPSG:3873", label: "EPSG:3873 / ETRS89 / GK19FIN" },
  { value: "EPSG:3874", label: "EPSG:3874 / ETRS89 / GK20FIN" },
  { value: "EPSG:3875", label: "EPSG:3875 / ETRS89 / GK21FIN" },
  { value: "EPSG:3876", label: "EPSG:3876 / ETRS89 / GK22FIN" },
  { value: "EPSG:3877", label: "EPSG:3877 / ETRS89 / GK23FIN" },
  { value: "EPSG:3878", label: "EPSG:3878 / ETRS89 / GK24FIN" },
  { value: "EPSG:3879", label: "EPSG:3879 / ETRS89 / GK25FIN" },
  { value: "EPSG:3880", label: "EPSG:3880 / ETRS89 / GK26FIN" },
  { value: "EPSG:3881", label: "EPSG:3881 / ETRS89 / GK27FIN" },
  { value: "EPSG:3882", label: "EPSG:3882 / ETRS89 / GK28FIN" },
  { value: "EPSG:3883", label: "EPSG:3883 / ETRS89 / GK29FIN" },
  { value: "EPSG:3884", label: "EPSG:3884 / ETRS89 / GK30FIN" },
  { value: "EPSG:3885", label: "EPSG:3885 / ETRS89 / GK31FIN" },
  { value: "EPSG:3890", label: "EPSG:3890 / IGRS / UTM zone 37N" },
  { value: "EPSG:3891", label: "EPSG:3891 / IGRS / UTM zone 38N" },
  { value: "EPSG:3892", label: "EPSG:3892 / IGRS / UTM zone 39N" },
  { value: "EPSG:3893", label: "EPSG:3893 / ED50 / Iraq National Grid" },
  { value: "EPSG:3907", label: "EPSG:3907 / MGI 1901 / Balkans zone 5" },
  { value: "EPSG:3908", label: "EPSG:3908 / MGI 1901 / Balkans zone 6" },
  { value: "EPSG:3909", label: "EPSG:3909 / MGI 1901 / Balkans zone 7" },
  { value: "EPSG:3910", label: "EPSG:3910 / MGI 1901 / Balkans zone 8" },
  { value: "EPSG:3911", label: "EPSG:3911 / MGI 1901 / Slovenia Grid" },
  { value: "EPSG:3912", label: "EPSG:3912 / MGI 1901 / Slovene National Grid" },
  { value: "EPSG:3920", label: "EPSG:3920 / Puerto Rico / UTM zone 20N" },
  { value: "EPSG:3942", label: "EPSG:3942 / RGF93 v1 / CC42" },
  { value: "EPSG:3943", label: "EPSG:3943 / RGF93 v1 / CC43" },
  { value: "EPSG:3944", label: "EPSG:3944 / RGF93 v1 / CC44" },
  { value: "EPSG:3945", label: "EPSG:3945 / RGF93 v1 / CC45" },
  { value: "EPSG:3946", label: "EPSG:3946 / RGF93 v1 / CC46" },
  { value: "EPSG:3947", label: "EPSG:3947 / RGF93 v1 / CC47" },
  { value: "EPSG:3948", label: "EPSG:3948 / RGF93 v1 / CC48" },
  { value: "EPSG:3949", label: "EPSG:3949 / RGF93 v1 / CC49" },
  { value: "EPSG:3950", label: "EPSG:3950 / RGF93 v1 / CC50" },
  { value: "EPSG:3968", label: "EPSG:3968 / NAD83 / Virginia Lambert" },
  { value: "EPSG:3969", label: "EPSG:3969 / NAD83(HARN) / Virginia Lambert" },
  {
    value: "EPSG:3970",
    label: "EPSG:3970 / NAD83(NSRS2007) / Virginia Lambert",
  },
  { value: "EPSG:3973", label: "EPSG:3973 / WGS 84 / NSIDC EASE-Grid North" },
  { value: "EPSG:3974", label: "EPSG:3974 / WGS 84 / NSIDC EASE-Grid South" },
  { value: "EPSG:3975", label: "EPSG:3975 / WGS 84 / NSIDC EASE-Grid Global" },
  {
    value: "EPSG:3976",
    label: "EPSG:3976 / WGS 84 / NSIDC Sea Ice Polar Stereographic South",
  },
  { value: "EPSG:3978", label: "EPSG:3978 / NAD83 / Canada Atlas Lambert" },
  {
    value: "EPSG:3979",
    label: "EPSG:3979 / NAD83(CSRS) / Canada Atlas Lambert",
  },
  { value: "EPSG:3985", label: "EPSG:3985 / Katanga 1955 / Katanga Lambert" },
  {
    value: "EPSG:3986",
    label: "EPSG:3986 / Katanga 1955 / Katanga Gauss zone A",
  },
  {
    value: "EPSG:3987",
    label: "EPSG:3987 / Katanga 1955 / Katanga Gauss zone B",
  },
  {
    value: "EPSG:3988",
    label: "EPSG:3988 / Katanga 1955 / Katanga Gauss zone C",
  },
  {
    value: "EPSG:3989",
    label: "EPSG:3989 / Katanga 1955 / Katanga Gauss zone D",
  },
  {
    value: "EPSG:3991",
    label: "EPSG:3991 / Puerto Rico State Plane CS of 1927",
  },
  { value: "EPSG:3992", label: "EPSG:3992 / Puerto Rico / St. Croix" },
  { value: "EPSG:3993", label: "EPSG:3993 / Guam 1963 / Guam SPCS" },
  { value: "EPSG:3994", label: "EPSG:3994 / WGS 84 / Mercator 41" },
  {
    value: "EPSG:3995",
    label: "EPSG:3995 / WGS 84 / Arctic Polar Stereographic",
  },
  {
    value: "EPSG:3996",
    label: "EPSG:3996 / WGS 84 / IBCAO Polar Stereographic",
  },
  { value: "EPSG:3997", label: "EPSG:3997 / WGS 84 / Dubai Local TM" },
  { value: "EPSG:4026", label: "EPSG:4026 / MOLDREF99 / Moldova TM" },
  { value: "EPSG:4037", label: "EPSG:4037 / WGS 84 / TMzn35N" },
  { value: "EPSG:4038", label: "EPSG:4038 / WGS 84 / TMzn36N" },
  { value: "EPSG:4048", label: "EPSG:4048 / RGRDC 2005 / Congo TM zone 12" },
  { value: "EPSG:4049", label: "EPSG:4049 / RGRDC 2005 / Congo TM zone 14" },
  { value: "EPSG:4050", label: "EPSG:4050 / RGRDC 2005 / Congo TM zone 16" },
  { value: "EPSG:4051", label: "EPSG:4051 / RGRDC 2005 / Congo TM zone 18" },
  { value: "EPSG:4056", label: "EPSG:4056 / RGRDC 2005 / Congo TM zone 20" },
  { value: "EPSG:4057", label: "EPSG:4057 / RGRDC 2005 / Congo TM zone 22" },
  { value: "EPSG:4058", label: "EPSG:4058 / RGRDC 2005 / Congo TM zone 24" },
  { value: "EPSG:4059", label: "EPSG:4059 / RGRDC 2005 / Congo TM zone 26" },
  { value: "EPSG:4060", label: "EPSG:4060 / RGRDC 2005 / Congo TM zone 28" },
  { value: "EPSG:4061", label: "EPSG:4061 / RGRDC 2005 / UTM zone 33S" },
  { value: "EPSG:4062", label: "EPSG:4062 / RGRDC 2005 / UTM zone 34S" },
  { value: "EPSG:4063", label: "EPSG:4063 / RGRDC 2005 / UTM zone 35S" },
  { value: "EPSG:4071", label: "EPSG:4071 / Chua / UTM zone 23S" },
  { value: "EPSG:4082", label: "EPSG:4082 / REGCAN95 / UTM zone 27N" },
  { value: "EPSG:4083", label: "EPSG:4083 / REGCAN95 / UTM zone 28N" },
  {
    value: "EPSG:4087",
    label: "EPSG:4087 / WGS 84 / World Equidistant Cylindrical",
  },
  {
    value: "EPSG:4088",
    label: "EPSG:4088 / World Equidistant Cylindrical (Sphere)",
  },
  { value: "EPSG:4093", label: "EPSG:4093 / ETRS89 / DKTM1" },
  { value: "EPSG:4094", label: "EPSG:4094 / ETRS89 / DKTM2" },
  { value: "EPSG:4095", label: "EPSG:4095 / ETRS89 / DKTM3" },
  { value: "EPSG:4096", label: "EPSG:4096 / ETRS89 / DKTM4" },
  { value: "EPSG:4217", label: "EPSG:4217 / NAD83 / BLM 59N (ftUS)" },
  { value: "EPSG:4390", label: "EPSG:4390 / Kertau 1968 / Johor Grid" },
  {
    value: "EPSG:4391",
    label: "EPSG:4391 / Kertau 1968 / Sembilan and Melaka Grid",
  },
  { value: "EPSG:4392", label: "EPSG:4392 / Kertau 1968 / Pahang Grid" },
  { value: "EPSG:4393", label: "EPSG:4393 / Kertau 1968 / Selangor Grid" },
  { value: "EPSG:4394", label: "EPSG:4394 / Kertau 1968 / Terengganu Grid" },
  { value: "EPSG:4395", label: "EPSG:4395 / Kertau 1968 / Pinang Grid" },
  {
    value: "EPSG:4396",
    label: "EPSG:4396 / Kertau 1968 / Kedah and Perlis Grid",
  },
  { value: "EPSG:4397", label: "EPSG:4397 / Kertau 1968 / Perak Revised Grid" },
  { value: "EPSG:4398", label: "EPSG:4398 / Kertau 1968 / Kelantan Grid" },
  { value: "EPSG:4399", label: "EPSG:4399 / NAD27 / BLM 59N (ftUS)" },
  { value: "EPSG:4400", label: "EPSG:4400 / NAD27 / BLM 60N (ftUS)" },
  { value: "EPSG:4401", label: "EPSG:4401 / NAD27 / BLM 1N (ftUS)" },
  { value: "EPSG:4402", label: "EPSG:4402 / NAD27 / BLM 2N (ftUS)" },
  { value: "EPSG:4403", label: "EPSG:4403 / NAD27 / BLM 3N (ftUS)" },
  { value: "EPSG:4404", label: "EPSG:4404 / NAD27 / BLM 4N (ftUS)" },
  { value: "EPSG:4405", label: "EPSG:4405 / NAD27 / BLM 5N (ftUS)" },
  { value: "EPSG:4406", label: "EPSG:4406 / NAD27 / BLM 6N (ftUS)" },
  { value: "EPSG:4407", label: "EPSG:4407 / NAD27 / BLM 7N (ftUS)" },
  { value: "EPSG:4408", label: "EPSG:4408 / NAD27 / BLM 8N (ftUS)" },
  { value: "EPSG:4409", label: "EPSG:4409 / NAD27 / BLM 9N (ftUS)" },
  { value: "EPSG:4410", label: "EPSG:4410 / NAD27 / BLM 10N (ftUS)" },
  { value: "EPSG:4411", label: "EPSG:4411 / NAD27 / BLM 11N (ftUS)" },
  { value: "EPSG:4412", label: "EPSG:4412 / NAD27 / BLM 12N (ftUS)" },
  { value: "EPSG:4413", label: "EPSG:4413 / NAD27 / BLM 13N (ftUS)" },
  { value: "EPSG:4414", label: "EPSG:4414 / NAD83(HARN) / Guam Map Grid" },
  { value: "EPSG:4415", label: "EPSG:4415 / Katanga 1955 / Katanga Lambert" },
  {
    value: "EPSG:4417",
    label: "EPSG:4417 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 7",
  },
  { value: "EPSG:4418", label: "EPSG:4418 / NAD27 / BLM 18N (ftUS)" },
  { value: "EPSG:4419", label: "EPSG:4419 / NAD27 / BLM 19N (ftUS)" },
  { value: "EPSG:4420", label: "EPSG:4420 / NAD83 / BLM 60N (ftUS)" },
  { value: "EPSG:4421", label: "EPSG:4421 / NAD83 / BLM 1N (ftUS)" },
  { value: "EPSG:4422", label: "EPSG:4422 / NAD83 / BLM 2N (ftUS)" },
  { value: "EPSG:4423", label: "EPSG:4423 / NAD83 / BLM 3N (ftUS)" },
  { value: "EPSG:4424", label: "EPSG:4424 / NAD83 / BLM 4N (ftUS)" },
  { value: "EPSG:4425", label: "EPSG:4425 / NAD83 / BLM 5N (ftUS)" },
  { value: "EPSG:4426", label: "EPSG:4426 / NAD83 / BLM 6N (ftUS)" },
  { value: "EPSG:4427", label: "EPSG:4427 / NAD83 / BLM 7N (ftUS)" },
  { value: "EPSG:4428", label: "EPSG:4428 / NAD83 / BLM 8N (ftUS)" },
  { value: "EPSG:4429", label: "EPSG:4429 / NAD83 / BLM 9N (ftUS)" },
  { value: "EPSG:4430", label: "EPSG:4430 / NAD83 / BLM 10N (ftUS)" },
  { value: "EPSG:4431", label: "EPSG:4431 / NAD83 / BLM 11N (ftUS)" },
  { value: "EPSG:4432", label: "EPSG:4432 / NAD83 / BLM 12N (ftUS)" },
  { value: "EPSG:4433", label: "EPSG:4433 / NAD83 / BLM 13N (ftUS)" },
  {
    value: "EPSG:4434",
    label: "EPSG:4434 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:4437",
    label: "EPSG:4437 / NAD83(NSRS2007) / Puerto Rico and Virgin Is.",
  },
  { value: "EPSG:4438", label: "EPSG:4438 / NAD83 / BLM 18N (ftUS)" },
  { value: "EPSG:4439", label: "EPSG:4439 / NAD83 / BLM 19N (ftUS)" },
  { value: "EPSG:4455", label: "EPSG:4455 / NAD27 / Pennsylvania South" },
  { value: "EPSG:4456", label: "EPSG:4456 / NAD27 / New York Long Island" },
  {
    value: "EPSG:4457",
    label: "EPSG:4457 / NAD83 / South Dakota North (ftUS)",
  },
  {
    value: "EPSG:4462",
    label: "EPSG:4462 / WGS 84 / Australian Centre for Remote Sensing Lambert",
  },
  { value: "EPSG:4467", label: "EPSG:4467 / RGSPM06 / UTM zone 21N" },
  { value: "EPSG:4471", label: "EPSG:4471 / RGM04 / UTM zone 38S" },
  { value: "EPSG:4474", label: "EPSG:4474 / Cadastre 1997 / UTM zone 38S" },
  { value: "EPSG:4484", label: "EPSG:4484 / Mexico ITRF92 / UTM zone 11N" },
  { value: "EPSG:4485", label: "EPSG:4485 / Mexico ITRF92 / UTM zone 12N" },
  { value: "EPSG:4486", label: "EPSG:4486 / Mexico ITRF92 / UTM zone 13N" },
  { value: "EPSG:4487", label: "EPSG:4487 / Mexico ITRF92 / UTM zone 14N" },
  { value: "EPSG:4488", label: "EPSG:4488 / Mexico ITRF92 / UTM zone 15N" },
  { value: "EPSG:4489", label: "EPSG:4489 / Mexico ITRF92 / UTM zone 16N" },
  { value: "EPSG:4491", label: "EPSG:4491 / CGCS2000 / Gauss-Kruger zone 13" },
  { value: "EPSG:4492", label: "EPSG:4492 / CGCS2000 / Gauss-Kruger zone 14" },
  { value: "EPSG:4493", label: "EPSG:4493 / CGCS2000 / Gauss-Kruger zone 15" },
  { value: "EPSG:4494", label: "EPSG:4494 / CGCS2000 / Gauss-Kruger zone 16" },
  { value: "EPSG:4495", label: "EPSG:4495 / CGCS2000 / Gauss-Kruger zone 17" },
  { value: "EPSG:4496", label: "EPSG:4496 / CGCS2000 / Gauss-Kruger zone 18" },
  { value: "EPSG:4497", label: "EPSG:4497 / CGCS2000 / Gauss-Kruger zone 19" },
  { value: "EPSG:4498", label: "EPSG:4498 / CGCS2000 / Gauss-Kruger zone 20" },
  { value: "EPSG:4499", label: "EPSG:4499 / CGCS2000 / Gauss-Kruger zone 21" },
  { value: "EPSG:4500", label: "EPSG:4500 / CGCS2000 / Gauss-Kruger zone 22" },
  { value: "EPSG:4501", label: "EPSG:4501 / CGCS2000 / Gauss-Kruger zone 23" },
  { value: "EPSG:4502", label: "EPSG:4502 / CGCS2000 / Gauss-Kruger CM 75E" },
  { value: "EPSG:4503", label: "EPSG:4503 / CGCS2000 / Gauss-Kruger CM 81E" },
  { value: "EPSG:4504", label: "EPSG:4504 / CGCS2000 / Gauss-Kruger CM 87E" },
  { value: "EPSG:4505", label: "EPSG:4505 / CGCS2000 / Gauss-Kruger CM 93E" },
  { value: "EPSG:4506", label: "EPSG:4506 / CGCS2000 / Gauss-Kruger CM 99E" },
  { value: "EPSG:4507", label: "EPSG:4507 / CGCS2000 / Gauss-Kruger CM 105E" },
  { value: "EPSG:4508", label: "EPSG:4508 / CGCS2000 / Gauss-Kruger CM 111E" },
  { value: "EPSG:4509", label: "EPSG:4509 / CGCS2000 / Gauss-Kruger CM 117E" },
  { value: "EPSG:4510", label: "EPSG:4510 / CGCS2000 / Gauss-Kruger CM 123E" },
  { value: "EPSG:4511", label: "EPSG:4511 / CGCS2000 / Gauss-Kruger CM 129E" },
  { value: "EPSG:4512", label: "EPSG:4512 / CGCS2000 / Gauss-Kruger CM 135E" },
  {
    value: "EPSG:4513",
    label: "EPSG:4513 / CGCS2000 / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:4514",
    label: "EPSG:4514 / CGCS2000 / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:4515",
    label: "EPSG:4515 / CGCS2000 / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:4516",
    label: "EPSG:4516 / CGCS2000 / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:4517",
    label: "EPSG:4517 / CGCS2000 / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:4518",
    label: "EPSG:4518 / CGCS2000 / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:4519",
    label: "EPSG:4519 / CGCS2000 / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:4520",
    label: "EPSG:4520 / CGCS2000 / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:4521",
    label: "EPSG:4521 / CGCS2000 / 3-degree Gauss-Kruger zone 33",
  },
  {
    value: "EPSG:4522",
    label: "EPSG:4522 / CGCS2000 / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:4523",
    label: "EPSG:4523 / CGCS2000 / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:4524",
    label: "EPSG:4524 / CGCS2000 / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:4525",
    label: "EPSG:4525 / CGCS2000 / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:4526",
    label: "EPSG:4526 / CGCS2000 / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:4527",
    label: "EPSG:4527 / CGCS2000 / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:4528",
    label: "EPSG:4528 / CGCS2000 / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:4529",
    label: "EPSG:4529 / CGCS2000 / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:4530",
    label: "EPSG:4530 / CGCS2000 / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:4531",
    label: "EPSG:4531 / CGCS2000 / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:4532",
    label: "EPSG:4532 / CGCS2000 / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:4533",
    label: "EPSG:4533 / CGCS2000 / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:4534",
    label: "EPSG:4534 / CGCS2000 / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:4535",
    label: "EPSG:4535 / CGCS2000 / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:4536",
    label: "EPSG:4536 / CGCS2000 / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:4537",
    label: "EPSG:4537 / CGCS2000 / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:4538",
    label: "EPSG:4538 / CGCS2000 / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:4539",
    label: "EPSG:4539 / CGCS2000 / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:4540",
    label: "EPSG:4540 / CGCS2000 / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:4541",
    label: "EPSG:4541 / CGCS2000 / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:4542",
    label: "EPSG:4542 / CGCS2000 / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:4543",
    label: "EPSG:4543 / CGCS2000 / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:4544",
    label: "EPSG:4544 / CGCS2000 / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:4545",
    label: "EPSG:4545 / CGCS2000 / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:4546",
    label: "EPSG:4546 / CGCS2000 / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:4547",
    label: "EPSG:4547 / CGCS2000 / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:4548",
    label: "EPSG:4548 / CGCS2000 / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:4549",
    label: "EPSG:4549 / CGCS2000 / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:4550",
    label: "EPSG:4550 / CGCS2000 / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:4551",
    label: "EPSG:4551 / CGCS2000 / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:4552",
    label: "EPSG:4552 / CGCS2000 / 3-degree Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:4553",
    label: "EPSG:4553 / CGCS2000 / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:4554",
    label: "EPSG:4554 / CGCS2000 / 3-degree Gauss-Kruger CM 135E",
  },
  { value: "EPSG:4559", label: "EPSG:4559 / RRAF 1991 / UTM zone 20N" },
  {
    value: "EPSG:4568",
    label: "EPSG:4568 / New Beijing / Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:4569",
    label: "EPSG:4569 / New Beijing / Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:4570",
    label: "EPSG:4570 / New Beijing / Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:4571",
    label: "EPSG:4571 / New Beijing / Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:4572",
    label: "EPSG:4572 / New Beijing / Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:4573",
    label: "EPSG:4573 / New Beijing / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:4574",
    label: "EPSG:4574 / New Beijing / Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:4575",
    label: "EPSG:4575 / New Beijing / Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:4576",
    label: "EPSG:4576 / New Beijing / Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:4577",
    label: "EPSG:4577 / New Beijing / Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:4578",
    label: "EPSG:4578 / New Beijing / Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:4579",
    label: "EPSG:4579 / New Beijing / Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:4580",
    label: "EPSG:4580 / New Beijing / Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:4581",
    label: "EPSG:4581 / New Beijing / Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:4582",
    label: "EPSG:4582 / New Beijing / Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:4583",
    label: "EPSG:4583 / New Beijing / Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:4584",
    label: "EPSG:4584 / New Beijing / Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:4585",
    label: "EPSG:4585 / New Beijing / Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:4586",
    label: "EPSG:4586 / New Beijing / Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:4587",
    label: "EPSG:4587 / New Beijing / Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:4588",
    label: "EPSG:4588 / New Beijing / Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:4589",
    label: "EPSG:4589 / New Beijing / Gauss-Kruger CM 135E",
  },
  { value: "EPSG:4647", label: "EPSG:4647 / ETRS89 / UTM zone 32N (zE-N)" },
  {
    value: "EPSG:4652",
    label: "EPSG:4652 / New Beijing / 3-degree Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:4653",
    label: "EPSG:4653 / New Beijing / 3-degree Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:4654",
    label: "EPSG:4654 / New Beijing / 3-degree Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:4655",
    label: "EPSG:4655 / New Beijing / 3-degree Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:4656",
    label: "EPSG:4656 / New Beijing / 3-degree Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:4766",
    label: "EPSG:4766 / New Beijing / 3-degree Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:4767",
    label: "EPSG:4767 / New Beijing / 3-degree Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:4768",
    label: "EPSG:4768 / New Beijing / 3-degree Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:4769",
    label: "EPSG:4769 / New Beijing / 3-degree Gauss-Kruger zone 33",
  },
  {
    value: "EPSG:4770",
    label: "EPSG:4770 / New Beijing / 3-degree Gauss-Kruger zone 34",
  },
  {
    value: "EPSG:4771",
    label: "EPSG:4771 / New Beijing / 3-degree Gauss-Kruger zone 35",
  },
  {
    value: "EPSG:4772",
    label: "EPSG:4772 / New Beijing / 3-degree Gauss-Kruger zone 36",
  },
  {
    value: "EPSG:4773",
    label: "EPSG:4773 / New Beijing / 3-degree Gauss-Kruger zone 37",
  },
  {
    value: "EPSG:4774",
    label: "EPSG:4774 / New Beijing / 3-degree Gauss-Kruger zone 38",
  },
  {
    value: "EPSG:4775",
    label: "EPSG:4775 / New Beijing / 3-degree Gauss-Kruger zone 39",
  },
  {
    value: "EPSG:4776",
    label: "EPSG:4776 / New Beijing / 3-degree Gauss-Kruger zone 40",
  },
  {
    value: "EPSG:4777",
    label: "EPSG:4777 / New Beijing / 3-degree Gauss-Kruger zone 41",
  },
  {
    value: "EPSG:4778",
    label: "EPSG:4778 / New Beijing / 3-degree Gauss-Kruger zone 42",
  },
  {
    value: "EPSG:4779",
    label: "EPSG:4779 / New Beijing / 3-degree Gauss-Kruger zone 43",
  },
  {
    value: "EPSG:4780",
    label: "EPSG:4780 / New Beijing / 3-degree Gauss-Kruger zone 44",
  },
  {
    value: "EPSG:4781",
    label: "EPSG:4781 / New Beijing / 3-degree Gauss-Kruger zone 45",
  },
  {
    value: "EPSG:4782",
    label: "EPSG:4782 / New Beijing / 3-degree Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:4783",
    label: "EPSG:4783 / New Beijing / 3-degree Gauss-Kruger CM 78E",
  },
  {
    value: "EPSG:4784",
    label: "EPSG:4784 / New Beijing / 3-degree Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:4785",
    label: "EPSG:4785 / New Beijing / 3-degree Gauss-Kruger CM 84E",
  },
  {
    value: "EPSG:4786",
    label: "EPSG:4786 / New Beijing / 3-degree Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:4787",
    label: "EPSG:4787 / New Beijing / 3-degree Gauss-Kruger CM 90E",
  },
  {
    value: "EPSG:4788",
    label: "EPSG:4788 / New Beijing / 3-degree Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:4789",
    label: "EPSG:4789 / New Beijing / 3-degree Gauss-Kruger CM 96E",
  },
  {
    value: "EPSG:4790",
    label: "EPSG:4790 / New Beijing / 3-degree Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:4791",
    label: "EPSG:4791 / New Beijing / 3-degree Gauss-Kruger CM 102E",
  },
  {
    value: "EPSG:4792",
    label: "EPSG:4792 / New Beijing / 3-degree Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:4793",
    label: "EPSG:4793 / New Beijing / 3-degree Gauss-Kruger CM 108E",
  },
  {
    value: "EPSG:4794",
    label: "EPSG:4794 / New Beijing / 3-degree Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:4795",
    label: "EPSG:4795 / New Beijing / 3-degree Gauss-Kruger CM 114E",
  },
  {
    value: "EPSG:4796",
    label: "EPSG:4796 / New Beijing / 3-degree Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:4797",
    label: "EPSG:4797 / New Beijing / 3-degree Gauss-Kruger CM 120E",
  },
  {
    value: "EPSG:4798",
    label: "EPSG:4798 / New Beijing / 3-degree Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:4799",
    label: "EPSG:4799 / New Beijing / 3-degree Gauss-Kruger CM 126E",
  },
  {
    value: "EPSG:4800",
    label: "EPSG:4800 / New Beijing / 3-degree Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:4812",
    label: "EPSG:4812 / New Beijing / 3-degree Gauss-Kruger CM 132E",
  },
  {
    value: "EPSG:4822",
    label: "EPSG:4822 / New Beijing / 3-degree Gauss-Kruger CM 135E",
  },
  { value: "EPSG:4826", label: "EPSG:4826 / WGS 84 / Cape Verde National" },
  { value: "EPSG:4839", label: "EPSG:4839 / ETRS89 / LCC Germany (N-E)" },
  { value: "EPSG:4855", label: "EPSG:4855 / ETRS89 / NTM zone 5" },
  { value: "EPSG:4856", label: "EPSG:4856 / ETRS89 / NTM zone 6" },
  { value: "EPSG:4857", label: "EPSG:4857 / ETRS89 / NTM zone 7" },
  { value: "EPSG:4858", label: "EPSG:4858 / ETRS89 / NTM zone 8" },
  { value: "EPSG:4859", label: "EPSG:4859 / ETRS89 / NTM zone 9" },
  { value: "EPSG:4860", label: "EPSG:4860 / ETRS89 / NTM zone 10" },
  { value: "EPSG:4861", label: "EPSG:4861 / ETRS89 / NTM zone 11" },
  { value: "EPSG:4862", label: "EPSG:4862 / ETRS89 / NTM zone 12" },
  { value: "EPSG:4863", label: "EPSG:4863 / ETRS89 / NTM zone 13" },
  { value: "EPSG:4864", label: "EPSG:4864 / ETRS89 / NTM zone 14" },
  { value: "EPSG:4865", label: "EPSG:4865 / ETRS89 / NTM zone 15" },
  { value: "EPSG:4866", label: "EPSG:4866 / ETRS89 / NTM zone 16" },
  { value: "EPSG:4867", label: "EPSG:4867 / ETRS89 / NTM zone 17" },
  { value: "EPSG:4868", label: "EPSG:4868 / ETRS89 / NTM zone 18" },
  { value: "EPSG:4869", label: "EPSG:4869 / ETRS89 / NTM zone 19" },
  { value: "EPSG:4870", label: "EPSG:4870 / ETRS89 / NTM zone 20" },
  { value: "EPSG:4871", label: "EPSG:4871 / ETRS89 / NTM zone 21" },
  { value: "EPSG:4872", label: "EPSG:4872 / ETRS89 / NTM zone 22" },
  { value: "EPSG:4873", label: "EPSG:4873 / ETRS89 / NTM zone 23" },
  { value: "EPSG:4874", label: "EPSG:4874 / ETRS89 / NTM zone 24" },
  { value: "EPSG:4875", label: "EPSG:4875 / ETRS89 / NTM zone 25" },
  { value: "EPSG:4876", label: "EPSG:4876 / ETRS89 / NTM zone 26" },
  { value: "EPSG:4877", label: "EPSG:4877 / ETRS89 / NTM zone 27" },
  { value: "EPSG:4878", label: "EPSG:4878 / ETRS89 / NTM zone 28" },
  { value: "EPSG:4879", label: "EPSG:4879 / ETRS89 / NTM zone 29" },
  { value: "EPSG:4880", label: "EPSG:4880 / ETRS89 / NTM zone 30" },
  { value: "EPSG:5014", label: "EPSG:5014 / PTRA08 / UTM zone 25N" },
  { value: "EPSG:5015", label: "EPSG:5015 / PTRA08 / UTM zone 26N" },
  { value: "EPSG:5016", label: "EPSG:5016 / PTRA08 / UTM zone 28N" },
  { value: "EPSG:5017", label: "EPSG:5017 / Lisbon 1890 / Portugal Bonne New" },
  { value: "EPSG:5018", label: "EPSG:5018 / Lisbon / Portuguese Grid New" },
  { value: "EPSG:5041", label: "EPSG:5041 / WGS 84 / UPS North (E,N)" },
  { value: "EPSG:5042", label: "EPSG:5042 / WGS 84 / UPS South (E,N)" },
  { value: "EPSG:5048", label: "EPSG:5048 / ETRS89 / TM35FIN(N,E)" },
  { value: "EPSG:5069", label: "EPSG:5069 / NAD27 / Conus Albers" },
  { value: "EPSG:5070", label: "EPSG:5070 / NAD83 / Conus Albers" },
  { value: "EPSG:5071", label: "EPSG:5071 / NAD83(HARN) / Conus Albers" },
  { value: "EPSG:5072", label: "EPSG:5072 / NAD83(NSRS2007) / Conus Albers" },
  { value: "EPSG:5105", label: "EPSG:5105 / ETRS89 / NTM zone 5" },
  { value: "EPSG:5106", label: "EPSG:5106 / ETRS89 / NTM zone 6" },
  { value: "EPSG:5107", label: "EPSG:5107 / ETRS89 / NTM zone 7" },
  { value: "EPSG:5108", label: "EPSG:5108 / ETRS89 / NTM zone 8" },
  { value: "EPSG:5109", label: "EPSG:5109 / ETRS89 / NTM zone 9" },
  { value: "EPSG:5110", label: "EPSG:5110 / ETRS89 / NTM zone 10" },
  { value: "EPSG:5111", label: "EPSG:5111 / ETRS89 / NTM zone 11" },
  { value: "EPSG:5112", label: "EPSG:5112 / ETRS89 / NTM zone 12" },
  { value: "EPSG:5113", label: "EPSG:5113 / ETRS89 / NTM zone 13" },
  { value: "EPSG:5114", label: "EPSG:5114 / ETRS89 / NTM zone 14" },
  { value: "EPSG:5115", label: "EPSG:5115 / ETRS89 / NTM zone 15" },
  { value: "EPSG:5116", label: "EPSG:5116 / ETRS89 / NTM zone 16" },
  { value: "EPSG:5117", label: "EPSG:5117 / ETRS89 / NTM zone 17" },
  { value: "EPSG:5118", label: "EPSG:5118 / ETRS89 / NTM zone 18" },
  { value: "EPSG:5119", label: "EPSG:5119 / ETRS89 / NTM zone 19" },
  { value: "EPSG:5120", label: "EPSG:5120 / ETRS89 / NTM zone 20" },
  { value: "EPSG:5121", label: "EPSG:5121 / ETRS89 / NTM zone 21" },
  { value: "EPSG:5122", label: "EPSG:5122 / ETRS89 / NTM zone 22" },
  { value: "EPSG:5123", label: "EPSG:5123 / ETRS89 / NTM zone 23" },
  { value: "EPSG:5124", label: "EPSG:5124 / ETRS89 / NTM zone 24" },
  { value: "EPSG:5125", label: "EPSG:5125 / ETRS89 / NTM zone 25" },
  { value: "EPSG:5126", label: "EPSG:5126 / ETRS89 / NTM zone 26" },
  { value: "EPSG:5127", label: "EPSG:5127 / ETRS89 / NTM zone 27" },
  { value: "EPSG:5128", label: "EPSG:5128 / ETRS89 / NTM zone 28" },
  { value: "EPSG:5129", label: "EPSG:5129 / ETRS89 / NTM zone 29" },
  { value: "EPSG:5130", label: "EPSG:5130 / ETRS89 / NTM zone 30" },
  { value: "EPSG:5167", label: "EPSG:5167 / Korean 1985 / East Sea Belt" },
  { value: "EPSG:5168", label: "EPSG:5168 / Korean 1985 / Central Belt Jeju" },
  { value: "EPSG:5169", label: "EPSG:5169 / Tokyo 1892 / Korea West Belt" },
  { value: "EPSG:5170", label: "EPSG:5170 / Tokyo 1892 / Korea Central Belt" },
  { value: "EPSG:5171", label: "EPSG:5171 / Tokyo 1892 / Korea East Belt" },
  { value: "EPSG:5172", label: "EPSG:5172 / Tokyo 1892 / Korea East Sea Belt" },
  { value: "EPSG:5173", label: "EPSG:5173 / Korean 1985 / Modified West Belt" },
  {
    value: "EPSG:5174",
    label: "EPSG:5174 / Korean 1985 / Modified Central Belt",
  },
  {
    value: "EPSG:5175",
    label: "EPSG:5175 / Korean 1985 / Modified Central Belt Jeju",
  },
  { value: "EPSG:5176", label: "EPSG:5176 / Korean 1985 / Modified East Belt" },
  {
    value: "EPSG:5177",
    label: "EPSG:5177 / Korean 1985 / Modified East Sea Belt",
  },
  { value: "EPSG:5178", label: "EPSG:5178 / Korean 1985 / Unified CS" },
  { value: "EPSG:5179", label: "EPSG:5179 / Korea 2000 / Unified CS" },
  { value: "EPSG:5180", label: "EPSG:5180 / Korea 2000 / West Belt" },
  { value: "EPSG:5181", label: "EPSG:5181 / Korea 2000 / Central Belt" },
  { value: "EPSG:5182", label: "EPSG:5182 / Korea 2000 / Central Belt Jeju" },
  { value: "EPSG:5183", label: "EPSG:5183 / Korea 2000 / East Belt" },
  { value: "EPSG:5184", label: "EPSG:5184 / Korea 2000 / East Sea Belt" },
  { value: "EPSG:5185", label: "EPSG:5185 / Korea 2000 / West Belt 2010" },
  { value: "EPSG:5186", label: "EPSG:5186 / Korea 2000 / Central Belt 2010" },
  { value: "EPSG:5187", label: "EPSG:5187 / Korea 2000 / East Belt 2010" },
  { value: "EPSG:5188", label: "EPSG:5188 / Korea 2000 / East Sea Belt 2010" },
  {
    value: "EPSG:5221",
    label: "EPSG:5221 / S-JTSK (Ferro) / Krovak East North",
  },
  { value: "EPSG:5223", label: "EPSG:5223 / WGS 84 / Gabon TM" },
  {
    value: "EPSG:5224",
    label: "EPSG:5224 / S-JTSK/05 (Ferro) / Modified Krovak",
  },
  {
    value: "EPSG:5225",
    label: "EPSG:5225 / S-JTSK/05 (Ferro) / Modified Krovak East North",
  },
  { value: "EPSG:5234", label: "EPSG:5234 / Kandawala / Sri Lanka Grid" },
  { value: "EPSG:5235", label: "EPSG:5235 / SLD99 / Sri Lanka Grid 1999" },
  { value: "EPSG:5243", label: "EPSG:5243 / ETRS89 / LCC Germany (E-N)" },
  { value: "EPSG:5247", label: "EPSG:5247 / GDBD2009 / Brunei BRSO" },
  { value: "EPSG:5253", label: "EPSG:5253 / TUREF / TM27" },
  { value: "EPSG:5254", label: "EPSG:5254 / TUREF / TM30" },
  { value: "EPSG:5255", label: "EPSG:5255 / TUREF / TM33" },
  { value: "EPSG:5256", label: "EPSG:5256 / TUREF / TM36" },
  { value: "EPSG:5257", label: "EPSG:5257 / TUREF / TM39" },
  { value: "EPSG:5258", label: "EPSG:5258 / TUREF / TM42" },
  { value: "EPSG:5259", label: "EPSG:5259 / TUREF / TM45" },
  {
    value: "EPSG:5266",
    label: "EPSG:5266 / DRUKREF 03 / Bhutan National Grid",
  },
  {
    value: "EPSG:5269",
    label: "EPSG:5269 / TUREF / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:5270",
    label: "EPSG:5270 / TUREF / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:5271",
    label: "EPSG:5271 / TUREF / 3-degree Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:5272",
    label: "EPSG:5272 / TUREF / 3-degree Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:5273",
    label: "EPSG:5273 / TUREF / 3-degree Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:5274",
    label: "EPSG:5274 / TUREF / 3-degree Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:5275",
    label: "EPSG:5275 / TUREF / 3-degree Gauss-Kruger zone 15",
  },
  { value: "EPSG:5292", label: "EPSG:5292 / DRUKREF 03 / Bumthang TM" },
  { value: "EPSG:5293", label: "EPSG:5293 / DRUKREF 03 / Chhukha TM" },
  { value: "EPSG:5294", label: "EPSG:5294 / DRUKREF 03 / Dagana TM" },
  { value: "EPSG:5295", label: "EPSG:5295 / DRUKREF 03 / Gasa TM" },
  { value: "EPSG:5296", label: "EPSG:5296 / DRUKREF 03 / Ha TM" },
  { value: "EPSG:5297", label: "EPSG:5297 / DRUKREF 03 / Lhuentse TM" },
  { value: "EPSG:5298", label: "EPSG:5298 / DRUKREF 03 / Mongar TM" },
  { value: "EPSG:5299", label: "EPSG:5299 / DRUKREF 03 / Paro TM" },
  { value: "EPSG:5300", label: "EPSG:5300 / DRUKREF 03 / Pemagatshel TM" },
  { value: "EPSG:5301", label: "EPSG:5301 / DRUKREF 03 / Punakha TM" },
  { value: "EPSG:5302", label: "EPSG:5302 / DRUKREF 03 / Samdrup Jongkhar TM" },
  { value: "EPSG:5303", label: "EPSG:5303 / DRUKREF 03 / Samtse TM" },
  { value: "EPSG:5304", label: "EPSG:5304 / DRUKREF 03 / Sarpang TM" },
  { value: "EPSG:5305", label: "EPSG:5305 / DRUKREF 03 / Thimphu TM" },
  { value: "EPSG:5306", label: "EPSG:5306 / DRUKREF 03 / Trashigang TM" },
  { value: "EPSG:5307", label: "EPSG:5307 / DRUKREF 03 / Trongsa TM" },
  { value: "EPSG:5308", label: "EPSG:5308 / DRUKREF 03 / Tsirang TM" },
  { value: "EPSG:5309", label: "EPSG:5309 / DRUKREF 03 / Wangdue Phodrang TM" },
  { value: "EPSG:5310", label: "EPSG:5310 / DRUKREF 03 / Yangtse TM" },
  { value: "EPSG:5311", label: "EPSG:5311 / DRUKREF 03 / Zhemgang TM" },
  { value: "EPSG:5316", label: "EPSG:5316 / ETRS89 / Faroe TM" },
  { value: "EPSG:5320", label: "EPSG:5320 / NAD83 / Teranet Ontario Lambert" },
  {
    value: "EPSG:5321",
    label: "EPSG:5321 / NAD83(CSRS) / Teranet Ontario Lambert",
  },
  { value: "EPSG:5325", label: "EPSG:5325 / ISN2004 / Lambert 2004" },
  { value: "EPSG:5329", label: "EPSG:5329 / Segara (Jakarta) / NEIEZ" },
  { value: "EPSG:5330", label: "EPSG:5330 / Batavia (Jakarta) / NEIEZ" },
  { value: "EPSG:5331", label: "EPSG:5331 / Makassar (Jakarta) / NEIEZ" },
  { value: "EPSG:5337", label: "EPSG:5337 / Aratu / UTM zone 25S" },
  { value: "EPSG:5343", label: "EPSG:5343 / POSGAR 2007 / Argentina 1" },
  { value: "EPSG:5344", label: "EPSG:5344 / POSGAR 2007 / Argentina 2" },
  { value: "EPSG:5345", label: "EPSG:5345 / POSGAR 2007 / Argentina 3" },
  { value: "EPSG:5346", label: "EPSG:5346 / POSGAR 2007 / Argentina 4" },
  { value: "EPSG:5347", label: "EPSG:5347 / POSGAR 2007 / Argentina 5" },
  { value: "EPSG:5348", label: "EPSG:5348 / POSGAR 2007 / Argentina 6" },
  { value: "EPSG:5349", label: "EPSG:5349 / POSGAR 2007 / Argentina 7" },
  { value: "EPSG:5355", label: "EPSG:5355 / MARGEN / UTM zone 20S" },
  { value: "EPSG:5356", label: "EPSG:5356 / MARGEN / UTM zone 19S" },
  { value: "EPSG:5357", label: "EPSG:5357 / MARGEN / UTM zone 21S" },
  { value: "EPSG:5361", label: "EPSG:5361 / SIRGAS-Chile 2002 / UTM zone 19S" },
  { value: "EPSG:5362", label: "EPSG:5362 / SIRGAS-Chile 2002 / UTM zone 18S" },
  { value: "EPSG:5367", label: "EPSG:5367 / CR05 / CRTM05" },
  { value: "EPSG:5382", label: "EPSG:5382 / SIRGAS-ROU98 / UTM zone 21S" },
  { value: "EPSG:5383", label: "EPSG:5383 / SIRGAS-ROU98 / UTM zone 22S" },
  { value: "EPSG:5387", label: "EPSG:5387 / Peru96 / UTM zone 18S" },
  { value: "EPSG:5388", label: "EPSG:5388 / Peru96 / UTM zone 17S" },
  { value: "EPSG:5389", label: "EPSG:5389 / Peru96 / UTM zone 19S" },
  { value: "EPSG:5396", label: "EPSG:5396 / SIRGAS 2000 / UTM zone 26S" },
  {
    value: "EPSG:5456",
    label: "EPSG:5456 / Ocotepeque 1935 / Costa Rica Norte",
  },
  { value: "EPSG:5457", label: "EPSG:5457 / Ocotepeque 1935 / Costa Rica Sur" },
  {
    value: "EPSG:5458",
    label: "EPSG:5458 / Ocotepeque 1935 / Guatemala Norte",
  },
  { value: "EPSG:5459", label: "EPSG:5459 / Ocotepeque 1935 / Guatemala Sur" },
  {
    value: "EPSG:5460",
    label: "EPSG:5460 / Ocotepeque 1935 / El Salvador Lambert",
  },
  {
    value: "EPSG:5461",
    label: "EPSG:5461 / Ocotepeque 1935 / Nicaragua Norte",
  },
  { value: "EPSG:5462", label: "EPSG:5462 / Ocotepeque 1935 / Nicaragua Sur" },
  { value: "EPSG:5463", label: "EPSG:5463 / SAD69 / UTM zone 17N" },
  { value: "EPSG:5466", label: "EPSG:5466 / Sibun Gorge 1922 / Colony Grid" },
  {
    value: "EPSG:5469",
    label: "EPSG:5469 / Panama-Colon 1911 / Panama Lambert",
  },
  {
    value: "EPSG:5472",
    label: "EPSG:5472 / Panama-Colon 1911 / Panama Polyconic",
  },
  { value: "EPSG:5479", label: "EPSG:5479 / RSRGD2000 / MSLC2000" },
  { value: "EPSG:5480", label: "EPSG:5480 / RSRGD2000 / BCLC2000" },
  { value: "EPSG:5481", label: "EPSG:5481 / RSRGD2000 / PCLC2000" },
  { value: "EPSG:5482", label: "EPSG:5482 / RSRGD2000 / RSPS2000" },
  { value: "EPSG:5490", label: "EPSG:5490 / RGAF09 / UTM zone 20N" },
  { value: "EPSG:5513", label: "EPSG:5513 / S-JTSK / Krovak" },
  { value: "EPSG:5514", label: "EPSG:5514 / S-JTSK / Krovak East North" },
  { value: "EPSG:5515", label: "EPSG:5515 / S-JTSK/05 / Modified Krovak" },
  {
    value: "EPSG:5516",
    label: "EPSG:5516 / S-JTSK/05 / Modified Krovak East North",
  },
  {
    value: "EPSG:5518",
    label: "EPSG:5518 / CI1971 / Chatham Islands Map Grid",
  },
  {
    value: "EPSG:5519",
    label: "EPSG:5519 / CI1979 / Chatham Islands Map Grid",
  },
  {
    value: "EPSG:5520",
    label: "EPSG:5520 / DHDN / 3-degree Gauss-Kruger zone 1",
  },
  { value: "EPSG:5523", label: "EPSG:5523 / WGS 84 / Gabon TM 2011" },
  { value: "EPSG:5530", label: "EPSG:5530 / SAD69(96) / Brazil Polyconic" },
  { value: "EPSG:5531", label: "EPSG:5531 / SAD69(96) / UTM zone 21S" },
  { value: "EPSG:5532", label: "EPSG:5532 / SAD69(96) / UTM zone 22S" },
  { value: "EPSG:5533", label: "EPSG:5533 / SAD69(96) / UTM zone 23S" },
  { value: "EPSG:5534", label: "EPSG:5534 / SAD69(96) / UTM zone 24S" },
  { value: "EPSG:5535", label: "EPSG:5535 / SAD69(96) / UTM zone 25S" },
  {
    value: "EPSG:5536",
    label: "EPSG:5536 / Corrego Alegre 1961 / UTM zone 21S",
  },
  {
    value: "EPSG:5537",
    label: "EPSG:5537 / Corrego Alegre 1961 / UTM zone 22S",
  },
  {
    value: "EPSG:5538",
    label: "EPSG:5538 / Corrego Alegre 1961 / UTM zone 23S",
  },
  {
    value: "EPSG:5539",
    label: "EPSG:5539 / Corrego Alegre 1961 / UTM zone 24S",
  },
  { value: "EPSG:5550", label: "EPSG:5550 / PNG94 / PNGMG94 zone 54" },
  { value: "EPSG:5551", label: "EPSG:5551 / PNG94 / PNGMG94 zone 55" },
  { value: "EPSG:5552", label: "EPSG:5552 / PNG94 / PNGMG94 zone 56" },
  {
    value: "EPSG:5559",
    label: "EPSG:5559 / Ocotepeque 1935 / Guatemala Norte",
  },
  { value: "EPSG:5562", label: "EPSG:5562 / UCS-2000 / Gauss-Kruger zone 4" },
  { value: "EPSG:5563", label: "EPSG:5563 / UCS-2000 / Gauss-Kruger zone 5" },
  { value: "EPSG:5564", label: "EPSG:5564 / UCS-2000 / Gauss-Kruger zone 6" },
  { value: "EPSG:5565", label: "EPSG:5565 / UCS-2000 / Gauss-Kruger zone 7" },
  { value: "EPSG:5566", label: "EPSG:5566 / UCS-2000 / Gauss-Kruger CM 21E" },
  { value: "EPSG:5567", label: "EPSG:5567 / UCS-2000 / Gauss-Kruger CM 27E" },
  { value: "EPSG:5568", label: "EPSG:5568 / UCS-2000 / Gauss-Kruger CM 33E" },
  { value: "EPSG:5569", label: "EPSG:5569 / UCS-2000 / Gauss-Kruger CM 39E" },
  {
    value: "EPSG:5570",
    label: "EPSG:5570 / UCS-2000 / 3-degree Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:5571",
    label: "EPSG:5571 / UCS-2000 / 3-degree Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:5572",
    label: "EPSG:5572 / UCS-2000 / 3-degree Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:5573",
    label: "EPSG:5573 / UCS-2000 / 3-degree Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:5574",
    label: "EPSG:5574 / UCS-2000 / 3-degree Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:5575",
    label: "EPSG:5575 / UCS-2000 / 3-degree Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:5576",
    label: "EPSG:5576 / UCS-2000 / 3-degree Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:5577",
    label: "EPSG:5577 / UCS-2000 / 3-degree Gauss-Kruger CM 21E",
  },
  {
    value: "EPSG:5578",
    label: "EPSG:5578 / UCS-2000 / 3-degree Gauss-Kruger CM 24E",
  },
  {
    value: "EPSG:5579",
    label: "EPSG:5579 / UCS-2000 / 3-degree Gauss-Kruger CM 27E",
  },
  {
    value: "EPSG:5580",
    label: "EPSG:5580 / UCS-2000 / 3-degree Gauss-Kruger CM 30E",
  },
  {
    value: "EPSG:5581",
    label: "EPSG:5581 / UCS-2000 / 3-degree Gauss-Kruger CM 33E",
  },
  {
    value: "EPSG:5582",
    label: "EPSG:5582 / UCS-2000 / 3-degree Gauss-Kruger CM 36E",
  },
  {
    value: "EPSG:5583",
    label: "EPSG:5583 / UCS-2000 / 3-degree Gauss-Kruger CM 39E",
  },
  {
    value: "EPSG:5588",
    label: "EPSG:5588 / NAD27 / New Brunswick Stereographic (NAD27)",
  },
  { value: "EPSG:5589", label: "EPSG:5589 / Sibun Gorge 1922 / Colony Grid" },
  { value: "EPSG:5596", label: "EPSG:5596 / FEH2010 / Fehmarnbelt TM" },
  { value: "EPSG:5623", label: "EPSG:5623 / NAD27 / Michigan East" },
  { value: "EPSG:5624", label: "EPSG:5624 / NAD27 / Michigan Old Central" },
  { value: "EPSG:5625", label: "EPSG:5625 / NAD27 / Michigan West" },
  { value: "EPSG:5627", label: "EPSG:5627 / ED50 / TM 6 NE" },
  { value: "EPSG:5629", label: "EPSG:5629 / Moznet / UTM zone 38S" },
  {
    value: "EPSG:5631",
    label: "EPSG:5631 / Pulkovo 1942(58) / Gauss-Kruger zone 2 (E-N)",
  },
  { value: "EPSG:5632", label: "EPSG:5632 / PTRA08 / LCC Europe" },
  { value: "EPSG:5633", label: "EPSG:5633 / PTRA08 / LAEA Europe" },
  { value: "EPSG:5634", label: "EPSG:5634 / REGCAN95 / LCC Europe" },
  { value: "EPSG:5635", label: "EPSG:5635 / REGCAN95 / LAEA Europe" },
  { value: "EPSG:5636", label: "EPSG:5636 / TUREF / LAEA Europe" },
  { value: "EPSG:5637", label: "EPSG:5637 / TUREF / LCC Europe" },
  { value: "EPSG:5638", label: "EPSG:5638 / ISN2004 / LAEA Europe" },
  { value: "EPSG:5639", label: "EPSG:5639 / ISN2004 / LCC Europe" },
  { value: "EPSG:5641", label: "EPSG:5641 / SIRGAS 2000 / Brazil Mercator" },
  { value: "EPSG:5643", label: "EPSG:5643 / ED50 / SPBA LCC" },
  { value: "EPSG:5644", label: "EPSG:5644 / RGR92 / UTM zone 39S" },
  { value: "EPSG:5646", label: "EPSG:5646 / NAD83 / Vermont (ftUS)" },
  { value: "EPSG:5649", label: "EPSG:5649 / ETRS89 / UTM zone 31N (zE-N)" },
  { value: "EPSG:5650", label: "EPSG:5650 / ETRS89 / UTM zone 33N (zE-N)" },
  { value: "EPSG:5651", label: "EPSG:5651 / ETRS89 / UTM zone 31N (N-zE)" },
  { value: "EPSG:5652", label: "EPSG:5652 / ETRS89 / UTM zone 32N (N-zE)" },
  { value: "EPSG:5653", label: "EPSG:5653 / ETRS89 / UTM zone 33N (N-zE)" },
  { value: "EPSG:5654", label: "EPSG:5654 / NAD83(HARN) / Vermont (ftUS)" },
  { value: "EPSG:5655", label: "EPSG:5655 / NAD83(NSRS2007) / Vermont (ftUS)" },
  { value: "EPSG:5659", label: "EPSG:5659 / Monte Mario / TM Emilia-Romagna" },
  {
    value: "EPSG:5663",
    label: "EPSG:5663 / Pulkovo 1942(58) / Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5664",
    label: "EPSG:5664 / Pulkovo 1942(83) / Gauss-Kruger zone 2 (E-N)",
  },
  {
    value: "EPSG:5665",
    label: "EPSG:5665 / Pulkovo 1942(83) / Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5666",
    label: "EPSG:5666 / PD/83 / 3-degree Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5667",
    label: "EPSG:5667 / PD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5668",
    label: "EPSG:5668 / RD/83 / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5669",
    label: "EPSG:5669 / RD/83 / 3-degree Gauss-Kruger zone 5 (E-N)",
  },
  {
    value: "EPSG:5670",
    label: "EPSG:5670 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5671",
    label: "EPSG:5671 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5672",
    label: "EPSG:5672 / Pulkovo 1942(58) / 3-degree Gauss-Kruger zone 5 (E-N)",
  },
  {
    value: "EPSG:5673",
    label: "EPSG:5673 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5674",
    label: "EPSG:5674 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5675",
    label: "EPSG:5675 / Pulkovo 1942(83) / 3-degree Gauss-Kruger zone 5 (E-N)",
  },
  {
    value: "EPSG:5676",
    label: "EPSG:5676 / DHDN / 3-degree Gauss-Kruger zone 2 (E-N)",
  },
  {
    value: "EPSG:5677",
    label: "EPSG:5677 / DHDN / 3-degree Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5678",
    label: "EPSG:5678 / DHDN / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5679",
    label: "EPSG:5679 / DHDN / 3-degree Gauss-Kruger zone 5 (E-N)",
  },
  {
    value: "EPSG:5680",
    label: "EPSG:5680 / DHDN / 3-degree Gauss-Kruger zone 1 (E-N)",
  },
  {
    value: "EPSG:5682",
    label: "EPSG:5682 / DB_REF / 3-degree Gauss-Kruger zone 2 (E-N)",
  },
  {
    value: "EPSG:5683",
    label: "EPSG:5683 / DB_REF / 3-degree Gauss-Kruger zone 3 (E-N)",
  },
  {
    value: "EPSG:5684",
    label: "EPSG:5684 / DB_REF / 3-degree Gauss-Kruger zone 4 (E-N)",
  },
  {
    value: "EPSG:5685",
    label: "EPSG:5685 / DB_REF / 3-degree Gauss-Kruger zone 5 (E-N)",
  },
  { value: "EPSG:5700", label: "EPSG:5700 / NZGD2000 / UTM zone 1S" },
  { value: "EPSG:5825", label: "EPSG:5825 / AGD66 / ACT Standard Grid" },
  { value: "EPSG:5836", label: "EPSG:5836 / Yemen NGN96 / UTM zone 37N" },
  { value: "EPSG:5837", label: "EPSG:5837 / Yemen NGN96 / UTM zone 40N" },
  { value: "EPSG:5839", label: "EPSG:5839 / Peru96 / UTM zone 17S" },
  { value: "EPSG:5842", label: "EPSG:5842 / WGS 84 / TM 12 SE" },
  { value: "EPSG:5844", label: "EPSG:5844 / RGRDC 2005 / Congo TM zone 30" },
  { value: "EPSG:5858", label: "EPSG:5858 / SAD69(96) / UTM zone 22S" },
  { value: "EPSG:5875", label: "EPSG:5875 / SAD69(96) / UTM zone 18S" },
  { value: "EPSG:5876", label: "EPSG:5876 / SAD69(96) / UTM zone 19S" },
  { value: "EPSG:5877", label: "EPSG:5877 / SAD69(96) / UTM zone 20S" },
  { value: "EPSG:5879", label: "EPSG:5879 / Cadastre 1997 / UTM zone 38S" },
  { value: "EPSG:5880", label: "EPSG:5880 / SIRGAS 2000 / Brazil Polyconic" },
  { value: "EPSG:5887", label: "EPSG:5887 / TGD2005 / Tonga Map Grid" },
  {
    value: "EPSG:5890",
    label: "EPSG:5890 / JAXA Snow Depth Polar Stereographic North",
  },
  { value: "EPSG:5896", label: "EPSG:5896 / VN-2000 / TM-3 zone 481" },
  { value: "EPSG:5897", label: "EPSG:5897 / VN-2000 / TM-3 zone 482" },
  { value: "EPSG:5898", label: "EPSG:5898 / VN-2000 / TM-3 zone 491" },
  { value: "EPSG:5899", label: "EPSG:5899 / VN-2000 / TM-3 107-45" },
  {
    value: "EPSG:5921",
    label: "EPSG:5921 / WGS 84 / EPSG Arctic Regional zone A1",
  },
  {
    value: "EPSG:5922",
    label: "EPSG:5922 / WGS 84 / EPSG Arctic Regional zone A2",
  },
  {
    value: "EPSG:5923",
    label: "EPSG:5923 / WGS 84 / EPSG Arctic Regional zone A3",
  },
  {
    value: "EPSG:5924",
    label: "EPSG:5924 / WGS 84 / EPSG Arctic Regional zone A4",
  },
  {
    value: "EPSG:5925",
    label: "EPSG:5925 / WGS 84 / EPSG Arctic Regional zone A5",
  },
  {
    value: "EPSG:5926",
    label: "EPSG:5926 / WGS 84 / EPSG Arctic Regional zone B1",
  },
  {
    value: "EPSG:5927",
    label: "EPSG:5927 / WGS 84 / EPSG Arctic Regional zone B2",
  },
  {
    value: "EPSG:5928",
    label: "EPSG:5928 / WGS 84 / EPSG Arctic Regional zone B3",
  },
  {
    value: "EPSG:5929",
    label: "EPSG:5929 / WGS 84 / EPSG Arctic Regional zone B4",
  },
  {
    value: "EPSG:5930",
    label: "EPSG:5930 / WGS 84 / EPSG Arctic Regional zone B5",
  },
  {
    value: "EPSG:5931",
    label: "EPSG:5931 / WGS 84 / EPSG Arctic Regional zone C1",
  },
  {
    value: "EPSG:5932",
    label: "EPSG:5932 / WGS 84 / EPSG Arctic Regional zone C2",
  },
  {
    value: "EPSG:5933",
    label: "EPSG:5933 / WGS 84 / EPSG Arctic Regional zone C3",
  },
  {
    value: "EPSG:5934",
    label: "EPSG:5934 / WGS 84 / EPSG Arctic Regional zone C4",
  },
  {
    value: "EPSG:5935",
    label: "EPSG:5935 / WGS 84 / EPSG Arctic Regional zone C5",
  },
  {
    value: "EPSG:5936",
    label: "EPSG:5936 / WGS 84 / EPSG Alaska Polar Stereographic",
  },
  {
    value: "EPSG:5937",
    label: "EPSG:5937 / WGS 84 / EPSG Canada Polar Stereographic",
  },
  {
    value: "EPSG:5938",
    label: "EPSG:5938 / WGS 84 / EPSG Greenland Polar Stereographic",
  },
  {
    value: "EPSG:5939",
    label: "EPSG:5939 / WGS 84 / EPSG Norway Polar Stereographic",
  },
  {
    value: "EPSG:5940",
    label: "EPSG:5940 / WGS 84 / EPSG Russia Polar Stereographic",
  },
  { value: "EPSG:6050", label: "EPSG:6050 / GR96 / EPSG Arctic zone 1-25" },
  { value: "EPSG:6051", label: "EPSG:6051 / GR96 / EPSG Arctic zone 2-18" },
  { value: "EPSG:6052", label: "EPSG:6052 / GR96 / EPSG Arctic zone 2-20" },
  { value: "EPSG:6053", label: "EPSG:6053 / GR96 / EPSG Arctic zone 3-29" },
  { value: "EPSG:6054", label: "EPSG:6054 / GR96 / EPSG Arctic zone 3-31" },
  { value: "EPSG:6055", label: "EPSG:6055 / GR96 / EPSG Arctic zone 3-33" },
  { value: "EPSG:6056", label: "EPSG:6056 / GR96 / EPSG Arctic zone 4-20" },
  { value: "EPSG:6057", label: "EPSG:6057 / GR96 / EPSG Arctic zone 4-22" },
  { value: "EPSG:6058", label: "EPSG:6058 / GR96 / EPSG Arctic zone 4-24" },
  { value: "EPSG:6059", label: "EPSG:6059 / GR96 / EPSG Arctic zone 5-41" },
  { value: "EPSG:6060", label: "EPSG:6060 / GR96 / EPSG Arctic zone 5-43" },
  { value: "EPSG:6061", label: "EPSG:6061 / GR96 / EPSG Arctic zone 5-45" },
  { value: "EPSG:6062", label: "EPSG:6062 / GR96 / EPSG Arctic zone 6-26" },
  { value: "EPSG:6063", label: "EPSG:6063 / GR96 / EPSG Arctic zone 6-28" },
  { value: "EPSG:6064", label: "EPSG:6064 / GR96 / EPSG Arctic zone 6-30" },
  { value: "EPSG:6065", label: "EPSG:6065 / GR96 / EPSG Arctic zone 7-11" },
  { value: "EPSG:6066", label: "EPSG:6066 / GR96 / EPSG Arctic zone 7-13" },
  { value: "EPSG:6067", label: "EPSG:6067 / GR96 / EPSG Arctic zone 8-20" },
  { value: "EPSG:6068", label: "EPSG:6068 / GR96 / EPSG Arctic zone 8-22" },
  { value: "EPSG:6069", label: "EPSG:6069 / ETRS89 / EPSG Arctic zone 2-22" },
  { value: "EPSG:6070", label: "EPSG:6070 / ETRS89 / EPSG Arctic zone 3-11" },
  { value: "EPSG:6071", label: "EPSG:6071 / ETRS89 / EPSG Arctic zone 4-26" },
  { value: "EPSG:6072", label: "EPSG:6072 / ETRS89 / EPSG Arctic zone 4-28" },
  { value: "EPSG:6073", label: "EPSG:6073 / ETRS89 / EPSG Arctic zone 5-11" },
  { value: "EPSG:6074", label: "EPSG:6074 / ETRS89 / EPSG Arctic zone 5-13" },
  { value: "EPSG:6075", label: "EPSG:6075 / WGS 84 / EPSG Arctic zone 2-24" },
  { value: "EPSG:6076", label: "EPSG:6076 / WGS 84 / EPSG Arctic zone 2-26" },
  { value: "EPSG:6077", label: "EPSG:6077 / WGS 84 / EPSG Arctic zone 3-13" },
  { value: "EPSG:6078", label: "EPSG:6078 / WGS 84 / EPSG Arctic zone 3-15" },
  { value: "EPSG:6079", label: "EPSG:6079 / WGS 84 / EPSG Arctic zone 3-17" },
  { value: "EPSG:6080", label: "EPSG:6080 / WGS 84 / EPSG Arctic zone 3-19" },
  { value: "EPSG:6081", label: "EPSG:6081 / WGS 84 / EPSG Arctic zone 4-30" },
  { value: "EPSG:6082", label: "EPSG:6082 / WGS 84 / EPSG Arctic zone 4-32" },
  { value: "EPSG:6083", label: "EPSG:6083 / WGS 84 / EPSG Arctic zone 4-34" },
  { value: "EPSG:6084", label: "EPSG:6084 / WGS 84 / EPSG Arctic zone 4-36" },
  { value: "EPSG:6085", label: "EPSG:6085 / WGS 84 / EPSG Arctic zone 4-38" },
  { value: "EPSG:6086", label: "EPSG:6086 / WGS 84 / EPSG Arctic zone 4-40" },
  { value: "EPSG:6087", label: "EPSG:6087 / WGS 84 / EPSG Arctic zone 5-15" },
  { value: "EPSG:6088", label: "EPSG:6088 / WGS 84 / EPSG Arctic zone 5-17" },
  { value: "EPSG:6089", label: "EPSG:6089 / WGS 84 / EPSG Arctic zone 5-19" },
  { value: "EPSG:6090", label: "EPSG:6090 / WGS 84 / EPSG Arctic zone 5-21" },
  { value: "EPSG:6091", label: "EPSG:6091 / WGS 84 / EPSG Arctic zone 5-23" },
  { value: "EPSG:6092", label: "EPSG:6092 / WGS 84 / EPSG Arctic zone 5-25" },
  { value: "EPSG:6093", label: "EPSG:6093 / WGS 84 / EPSG Arctic zone 5-27" },
  {
    value: "EPSG:6094",
    label: "EPSG:6094 / NAD83(NSRS2007) / EPSG Arctic zone 5-29",
  },
  {
    value: "EPSG:6095",
    label: "EPSG:6095 / NAD83(NSRS2007) / EPSG Arctic zone 5-31",
  },
  {
    value: "EPSG:6096",
    label: "EPSG:6096 / NAD83(NSRS2007) / EPSG Arctic zone 6-14",
  },
  {
    value: "EPSG:6097",
    label: "EPSG:6097 / NAD83(NSRS2007) / EPSG Arctic zone 6-16",
  },
  {
    value: "EPSG:6098",
    label: "EPSG:6098 / NAD83(CSRS) / EPSG Arctic zone 1-23",
  },
  {
    value: "EPSG:6099",
    label: "EPSG:6099 / NAD83(CSRS) / EPSG Arctic zone 2-14",
  },
  {
    value: "EPSG:6100",
    label: "EPSG:6100 / NAD83(CSRS) / EPSG Arctic zone 2-16",
  },
  {
    value: "EPSG:6101",
    label: "EPSG:6101 / NAD83(CSRS) / EPSG Arctic zone 3-25",
  },
  {
    value: "EPSG:6102",
    label: "EPSG:6102 / NAD83(CSRS) / EPSG Arctic zone 3-27",
  },
  {
    value: "EPSG:6103",
    label: "EPSG:6103 / NAD83(CSRS) / EPSG Arctic zone 3-29",
  },
  {
    value: "EPSG:6104",
    label: "EPSG:6104 / NAD83(CSRS) / EPSG Arctic zone 4-14",
  },
  {
    value: "EPSG:6105",
    label: "EPSG:6105 / NAD83(CSRS) / EPSG Arctic zone 4-16",
  },
  {
    value: "EPSG:6106",
    label: "EPSG:6106 / NAD83(CSRS) / EPSG Arctic zone 4-18",
  },
  {
    value: "EPSG:6107",
    label: "EPSG:6107 / NAD83(CSRS) / EPSG Arctic zone 5-33",
  },
  {
    value: "EPSG:6108",
    label: "EPSG:6108 / NAD83(CSRS) / EPSG Arctic zone 5-35",
  },
  {
    value: "EPSG:6109",
    label: "EPSG:6109 / NAD83(CSRS) / EPSG Arctic zone 5-37",
  },
  {
    value: "EPSG:6110",
    label: "EPSG:6110 / NAD83(CSRS) / EPSG Arctic zone 5-39",
  },
  {
    value: "EPSG:6111",
    label: "EPSG:6111 / NAD83(CSRS) / EPSG Arctic zone 6-18",
  },
  {
    value: "EPSG:6112",
    label: "EPSG:6112 / NAD83(CSRS) / EPSG Arctic zone 6-20",
  },
  {
    value: "EPSG:6113",
    label: "EPSG:6113 / NAD83(CSRS) / EPSG Arctic zone 6-22",
  },
  {
    value: "EPSG:6114",
    label: "EPSG:6114 / NAD83(CSRS) / EPSG Arctic zone 6-24",
  },
  { value: "EPSG:6115", label: "EPSG:6115 / WGS 84 / EPSG Arctic zone 1-27" },
  { value: "EPSG:6116", label: "EPSG:6116 / WGS 84 / EPSG Arctic zone 1-29" },
  { value: "EPSG:6117", label: "EPSG:6117 / WGS 84 / EPSG Arctic zone 1-31" },
  { value: "EPSG:6118", label: "EPSG:6118 / WGS 84 / EPSG Arctic zone 1-21" },
  { value: "EPSG:6119", label: "EPSG:6119 / WGS 84 / EPSG Arctic zone 2-28" },
  { value: "EPSG:6120", label: "EPSG:6120 / WGS 84 / EPSG Arctic zone 2-10" },
  { value: "EPSG:6121", label: "EPSG:6121 / WGS 84 / EPSG Arctic zone 2-12" },
  { value: "EPSG:6122", label: "EPSG:6122 / WGS 84 / EPSG Arctic zone 3-21" },
  { value: "EPSG:6123", label: "EPSG:6123 / WGS 84 / EPSG Arctic zone 3-23" },
  { value: "EPSG:6124", label: "EPSG:6124 / WGS 84 / EPSG Arctic zone 4-12" },
  { value: "EPSG:6125", label: "EPSG:6125 / ETRS89 / EPSG Arctic zone 5-47" },
  { value: "EPSG:6128", label: "EPSG:6128 / Grand Cayman National Grid 1959" },
  {
    value: "EPSG:6129",
    label: "EPSG:6129 / Sister Islands National Grid 1961",
  },
  {
    value: "EPSG:6141",
    label: "EPSG:6141 / Cayman Islands National Grid 2011",
  },
  { value: "EPSG:6200", label: "EPSG:6200 / NAD27 / Michigan North" },
  { value: "EPSG:6201", label: "EPSG:6201 / NAD27 / Michigan Central" },
  { value: "EPSG:6202", label: "EPSG:6202 / NAD27 / Michigan South" },
  {
    value: "EPSG:6204",
    label: "EPSG:6204 / Macedonia State Coordinate System",
  },
  { value: "EPSG:6210", label: "EPSG:6210 / SIRGAS 2000 / UTM zone 23N" },
  { value: "EPSG:6211", label: "EPSG:6211 / SIRGAS 2000 / UTM zone 24N" },
  { value: "EPSG:6244", label: "EPSG:6244 / MAGNA-SIRGAS / Arauca urban grid" },
  {
    value: "EPSG:6245",
    label: "EPSG:6245 / MAGNA-SIRGAS / Armenia urban grid",
  },
  {
    value: "EPSG:6246",
    label: "EPSG:6246 / MAGNA-SIRGAS / Barranquilla urban grid",
  },
  { value: "EPSG:6247", label: "EPSG:6247 / MAGNA-SIRGAS / Bogota urban grid" },
  {
    value: "EPSG:6248",
    label: "EPSG:6248 / MAGNA-SIRGAS / Bucaramanga urban grid",
  },
  { value: "EPSG:6249", label: "EPSG:6249 / MAGNA-SIRGAS / Cali urban grid" },
  {
    value: "EPSG:6250",
    label: "EPSG:6250 / MAGNA-SIRGAS / Cartagena urban grid",
  },
  { value: "EPSG:6251", label: "EPSG:6251 / MAGNA-SIRGAS / Cucuta urban grid" },
  {
    value: "EPSG:6252",
    label: "EPSG:6252 / MAGNA-SIRGAS / Florencia urban grid",
  },
  { value: "EPSG:6253", label: "EPSG:6253 / MAGNA-SIRGAS / Ibague urban grid" },
  {
    value: "EPSG:6254",
    label: "EPSG:6254 / MAGNA-SIRGAS / Inirida urban grid",
  },
  {
    value: "EPSG:6255",
    label: "EPSG:6255 / MAGNA-SIRGAS / Leticia urban grid",
  },
  {
    value: "EPSG:6256",
    label: "EPSG:6256 / MAGNA-SIRGAS / Manizales urban grid",
  },
  {
    value: "EPSG:6257",
    label: "EPSG:6257 / MAGNA-SIRGAS / Medellin urban grid",
  },
  { value: "EPSG:6258", label: "EPSG:6258 / MAGNA-SIRGAS / Mitu urban grid" },
  { value: "EPSG:6259", label: "EPSG:6259 / MAGNA-SIRGAS / Mocoa urban grid" },
  {
    value: "EPSG:6260",
    label: "EPSG:6260 / MAGNA-SIRGAS / Monteria urban grid",
  },
  { value: "EPSG:6261", label: "EPSG:6261 / MAGNA-SIRGAS / Neiva urban grid" },
  { value: "EPSG:6262", label: "EPSG:6262 / MAGNA-SIRGAS / Pasto urban grid" },
  {
    value: "EPSG:6263",
    label: "EPSG:6263 / MAGNA-SIRGAS / Pereira urban grid",
  },
  {
    value: "EPSG:6264",
    label: "EPSG:6264 / MAGNA-SIRGAS / Popayan urban grid",
  },
  {
    value: "EPSG:6265",
    label: "EPSG:6265 / MAGNA-SIRGAS / Puerto Carreno urban grid",
  },
  { value: "EPSG:6266", label: "EPSG:6266 / MAGNA-SIRGAS / Quibdo urban grid" },
  {
    value: "EPSG:6267",
    label: "EPSG:6267 / MAGNA-SIRGAS / Riohacha urban grid",
  },
  {
    value: "EPSG:6268",
    label: "EPSG:6268 / MAGNA-SIRGAS / San Andres urban grid",
  },
  {
    value: "EPSG:6269",
    label: "EPSG:6269 / MAGNA-SIRGAS / San Jose del Guaviare urban grid",
  },
  {
    value: "EPSG:6270",
    label: "EPSG:6270 / MAGNA-SIRGAS / Santa Marta urban grid",
  },
  { value: "EPSG:6271", label: "EPSG:6271 / MAGNA-SIRGAS / Sucre urban grid" },
  { value: "EPSG:6272", label: "EPSG:6272 / MAGNA-SIRGAS / Tunja urban grid" },
  {
    value: "EPSG:6273",
    label: "EPSG:6273 / MAGNA-SIRGAS / Valledupar urban grid",
  },
  {
    value: "EPSG:6274",
    label: "EPSG:6274 / MAGNA-SIRGAS / Villavicencio urban grid",
  },
  { value: "EPSG:6275", label: "EPSG:6275 / MAGNA-SIRGAS / Yopal urban grid" },
  {
    value: "EPSG:6307",
    label: "EPSG:6307 / NAD83(CORS96) / Puerto Rico and Virgin Is.",
  },
  {
    value: "EPSG:6312",
    label: "EPSG:6312 / CGRS93 / Cyprus Local Transverse Mercator",
  },
  { value: "EPSG:6316", label: "EPSG:6316 / MGI 1901 / Balkans zone 7" },
  { value: "EPSG:6328", label: "EPSG:6328 / NAD83(2011) / UTM zone 59N" },
  { value: "EPSG:6329", label: "EPSG:6329 / NAD83(2011) / UTM zone 60N" },
  { value: "EPSG:6330", label: "EPSG:6330 / NAD83(2011) / UTM zone 1N" },
  { value: "EPSG:6331", label: "EPSG:6331 / NAD83(2011) / UTM zone 2N" },
  { value: "EPSG:6332", label: "EPSG:6332 / NAD83(2011) / UTM zone 3N" },
  { value: "EPSG:6333", label: "EPSG:6333 / NAD83(2011) / UTM zone 4N" },
  { value: "EPSG:6334", label: "EPSG:6334 / NAD83(2011) / UTM zone 5N" },
  { value: "EPSG:6335", label: "EPSG:6335 / NAD83(2011) / UTM zone 6N" },
  { value: "EPSG:6336", label: "EPSG:6336 / NAD83(2011) / UTM zone 7N" },
  { value: "EPSG:6337", label: "EPSG:6337 / NAD83(2011) / UTM zone 8N" },
  { value: "EPSG:6338", label: "EPSG:6338 / NAD83(2011) / UTM zone 9N" },
  { value: "EPSG:6339", label: "EPSG:6339 / NAD83(2011) / UTM zone 10N" },
  { value: "EPSG:6340", label: "EPSG:6340 / NAD83(2011) / UTM zone 11N" },
  { value: "EPSG:6341", label: "EPSG:6341 / NAD83(2011) / UTM zone 12N" },
  { value: "EPSG:6342", label: "EPSG:6342 / NAD83(2011) / UTM zone 13N" },
  { value: "EPSG:6343", label: "EPSG:6343 / NAD83(2011) / UTM zone 14N" },
  { value: "EPSG:6344", label: "EPSG:6344 / NAD83(2011) / UTM zone 15N" },
  { value: "EPSG:6345", label: "EPSG:6345 / NAD83(2011) / UTM zone 16N" },
  { value: "EPSG:6346", label: "EPSG:6346 / NAD83(2011) / UTM zone 17N" },
  { value: "EPSG:6347", label: "EPSG:6347 / NAD83(2011) / UTM zone 18N" },
  { value: "EPSG:6348", label: "EPSG:6348 / NAD83(2011) / UTM zone 19N" },
  { value: "EPSG:6350", label: "EPSG:6350 / NAD83(2011) / Conus Albers" },
  {
    value: "EPSG:6351",
    label: "EPSG:6351 / NAD83(2011) / EPSG Arctic zone 5-29",
  },
  {
    value: "EPSG:6352",
    label: "EPSG:6352 / NAD83(2011) / EPSG Arctic zone 5-31",
  },
  {
    value: "EPSG:6353",
    label: "EPSG:6353 / NAD83(2011) / EPSG Arctic zone 6-14",
  },
  {
    value: "EPSG:6354",
    label: "EPSG:6354 / NAD83(2011) / EPSG Arctic zone 6-16",
  },
  { value: "EPSG:6355", label: "EPSG:6355 / NAD83(2011) / Alabama East" },
  { value: "EPSG:6356", label: "EPSG:6356 / NAD83(2011) / Alabama West" },
  { value: "EPSG:6362", label: "EPSG:6362 / Mexico ITRF92 / LCC" },
  { value: "EPSG:6366", label: "EPSG:6366 / Mexico ITRF2008 / UTM zone 11N" },
  { value: "EPSG:6367", label: "EPSG:6367 / Mexico ITRF2008 / UTM zone 12N" },
  { value: "EPSG:6368", label: "EPSG:6368 / Mexico ITRF2008 / UTM zone 13N" },
  { value: "EPSG:6369", label: "EPSG:6369 / Mexico ITRF2008 / UTM zone 14N" },
  { value: "EPSG:6370", label: "EPSG:6370 / Mexico ITRF2008 / UTM zone 15N" },
  { value: "EPSG:6371", label: "EPSG:6371 / Mexico ITRF2008 / UTM zone 16N" },
  { value: "EPSG:6372", label: "EPSG:6372 / Mexico ITRF2008 / LCC" },
  { value: "EPSG:6381", label: "EPSG:6381 / UCS-2000 / Ukraine TM zone 7" },
  { value: "EPSG:6382", label: "EPSG:6382 / UCS-2000 / Ukraine TM zone 8" },
  { value: "EPSG:6383", label: "EPSG:6383 / UCS-2000 / Ukraine TM zone 9" },
  { value: "EPSG:6384", label: "EPSG:6384 / UCS-2000 / Ukraine TM zone 10" },
  { value: "EPSG:6385", label: "EPSG:6385 / UCS-2000 / Ukraine TM zone 11" },
  { value: "EPSG:6386", label: "EPSG:6386 / UCS-2000 / Ukraine TM zone 12" },
  { value: "EPSG:6387", label: "EPSG:6387 / UCS-2000 / Ukraine TM zone 13" },
  {
    value: "EPSG:6391",
    label: "EPSG:6391 / Cayman Islands National Grid 2011",
  },
  { value: "EPSG:6393", label: "EPSG:6393 / NAD83(2011) / Alaska Albers" },
  { value: "EPSG:6394", label: "EPSG:6394 / NAD83(2011) / Alaska zone 1" },
  { value: "EPSG:6395", label: "EPSG:6395 / NAD83(2011) / Alaska zone 2" },
  { value: "EPSG:6396", label: "EPSG:6396 / NAD83(2011) / Alaska zone 3" },
  { value: "EPSG:6397", label: "EPSG:6397 / NAD83(2011) / Alaska zone 4" },
  { value: "EPSG:6398", label: "EPSG:6398 / NAD83(2011) / Alaska zone 5" },
  { value: "EPSG:6399", label: "EPSG:6399 / NAD83(2011) / Alaska zone 6" },
  { value: "EPSG:6400", label: "EPSG:6400 / NAD83(2011) / Alaska zone 7" },
  { value: "EPSG:6401", label: "EPSG:6401 / NAD83(2011) / Alaska zone 8" },
  { value: "EPSG:6402", label: "EPSG:6402 / NAD83(2011) / Alaska zone 9" },
  { value: "EPSG:6403", label: "EPSG:6403 / NAD83(2011) / Alaska zone 10" },
  { value: "EPSG:6404", label: "EPSG:6404 / NAD83(2011) / Arizona Central" },
  {
    value: "EPSG:6405",
    label: "EPSG:6405 / NAD83(2011) / Arizona Central (ft)",
  },
  { value: "EPSG:6406", label: "EPSG:6406 / NAD83(2011) / Arizona East" },
  { value: "EPSG:6407", label: "EPSG:6407 / NAD83(2011) / Arizona East (ft)" },
  { value: "EPSG:6408", label: "EPSG:6408 / NAD83(2011) / Arizona West" },
  { value: "EPSG:6409", label: "EPSG:6409 / NAD83(2011) / Arizona West (ft)" },
  { value: "EPSG:6410", label: "EPSG:6410 / NAD83(2011) / Arkansas North" },
  {
    value: "EPSG:6411",
    label: "EPSG:6411 / NAD83(2011) / Arkansas North (ftUS)",
  },
  { value: "EPSG:6412", label: "EPSG:6412 / NAD83(2011) / Arkansas South" },
  {
    value: "EPSG:6413",
    label: "EPSG:6413 / NAD83(2011) / Arkansas South (ftUS)",
  },
  { value: "EPSG:6414", label: "EPSG:6414 / NAD83(2011) / California Albers" },
  { value: "EPSG:6415", label: "EPSG:6415 / NAD83(2011) / California zone 1" },
  {
    value: "EPSG:6416",
    label: "EPSG:6416 / NAD83(2011) / California zone 1 (ftUS)",
  },
  { value: "EPSG:6417", label: "EPSG:6417 / NAD83(2011) / California zone 2" },
  {
    value: "EPSG:6418",
    label: "EPSG:6418 / NAD83(2011) / California zone 2 (ftUS)",
  },
  { value: "EPSG:6419", label: "EPSG:6419 / NAD83(2011) / California zone 3" },
  {
    value: "EPSG:6420",
    label: "EPSG:6420 / NAD83(2011) / California zone 3 (ftUS)",
  },
  { value: "EPSG:6421", label: "EPSG:6421 / NAD83(2011) / California zone 4" },
  {
    value: "EPSG:6422",
    label: "EPSG:6422 / NAD83(2011) / California zone 4 (ftUS)",
  },
  { value: "EPSG:6423", label: "EPSG:6423 / NAD83(2011) / California zone 5" },
  {
    value: "EPSG:6424",
    label: "EPSG:6424 / NAD83(2011) / California zone 5 (ftUS)",
  },
  { value: "EPSG:6425", label: "EPSG:6425 / NAD83(2011) / California zone 6" },
  {
    value: "EPSG:6426",
    label: "EPSG:6426 / NAD83(2011) / California zone 6 (ftUS)",
  },
  { value: "EPSG:6427", label: "EPSG:6427 / NAD83(2011) / Colorado Central" },
  {
    value: "EPSG:6428",
    label: "EPSG:6428 / NAD83(2011) / Colorado Central (ftUS)",
  },
  { value: "EPSG:6429", label: "EPSG:6429 / NAD83(2011) / Colorado North" },
  {
    value: "EPSG:6430",
    label: "EPSG:6430 / NAD83(2011) / Colorado North (ftUS)",
  },
  { value: "EPSG:6431", label: "EPSG:6431 / NAD83(2011) / Colorado South" },
  {
    value: "EPSG:6432",
    label: "EPSG:6432 / NAD83(2011) / Colorado South (ftUS)",
  },
  { value: "EPSG:6433", label: "EPSG:6433 / NAD83(2011) / Connecticut" },
  { value: "EPSG:6434", label: "EPSG:6434 / NAD83(2011) / Connecticut (ftUS)" },
  { value: "EPSG:6435", label: "EPSG:6435 / NAD83(2011) / Delaware" },
  { value: "EPSG:6436", label: "EPSG:6436 / NAD83(2011) / Delaware (ftUS)" },
  { value: "EPSG:6437", label: "EPSG:6437 / NAD83(2011) / Florida East" },
  {
    value: "EPSG:6438",
    label: "EPSG:6438 / NAD83(2011) / Florida East (ftUS)",
  },
  { value: "EPSG:6439", label: "EPSG:6439 / NAD83(2011) / Florida GDL Albers" },
  { value: "EPSG:6440", label: "EPSG:6440 / NAD83(2011) / Florida North" },
  {
    value: "EPSG:6441",
    label: "EPSG:6441 / NAD83(2011) / Florida North (ftUS)",
  },
  { value: "EPSG:6442", label: "EPSG:6442 / NAD83(2011) / Florida West" },
  {
    value: "EPSG:6443",
    label: "EPSG:6443 / NAD83(2011) / Florida West (ftUS)",
  },
  { value: "EPSG:6444", label: "EPSG:6444 / NAD83(2011) / Georgia East" },
  {
    value: "EPSG:6445",
    label: "EPSG:6445 / NAD83(2011) / Georgia East (ftUS)",
  },
  { value: "EPSG:6446", label: "EPSG:6446 / NAD83(2011) / Georgia West" },
  {
    value: "EPSG:6447",
    label: "EPSG:6447 / NAD83(2011) / Georgia West (ftUS)",
  },
  { value: "EPSG:6448", label: "EPSG:6448 / NAD83(2011) / Idaho Central" },
  {
    value: "EPSG:6449",
    label: "EPSG:6449 / NAD83(2011) / Idaho Central (ftUS)",
  },
  { value: "EPSG:6450", label: "EPSG:6450 / NAD83(2011) / Idaho East" },
  { value: "EPSG:6451", label: "EPSG:6451 / NAD83(2011) / Idaho East (ftUS)" },
  { value: "EPSG:6452", label: "EPSG:6452 / NAD83(2011) / Idaho West" },
  { value: "EPSG:6453", label: "EPSG:6453 / NAD83(2011) / Idaho West (ftUS)" },
  { value: "EPSG:6454", label: "EPSG:6454 / NAD83(2011) / Illinois East" },
  {
    value: "EPSG:6455",
    label: "EPSG:6455 / NAD83(2011) / Illinois East (ftUS)",
  },
  { value: "EPSG:6456", label: "EPSG:6456 / NAD83(2011) / Illinois West" },
  {
    value: "EPSG:6457",
    label: "EPSG:6457 / NAD83(2011) / Illinois West (ftUS)",
  },
  { value: "EPSG:6458", label: "EPSG:6458 / NAD83(2011) / Indiana East" },
  {
    value: "EPSG:6459",
    label: "EPSG:6459 / NAD83(2011) / Indiana East (ftUS)",
  },
  { value: "EPSG:6460", label: "EPSG:6460 / NAD83(2011) / Indiana West" },
  {
    value: "EPSG:6461",
    label: "EPSG:6461 / NAD83(2011) / Indiana West (ftUS)",
  },
  { value: "EPSG:6462", label: "EPSG:6462 / NAD83(2011) / Iowa North" },
  { value: "EPSG:6463", label: "EPSG:6463 / NAD83(2011) / Iowa North (ftUS)" },
  { value: "EPSG:6464", label: "EPSG:6464 / NAD83(2011) / Iowa South" },
  { value: "EPSG:6465", label: "EPSG:6465 / NAD83(2011) / Iowa South (ftUS)" },
  { value: "EPSG:6466", label: "EPSG:6466 / NAD83(2011) / Kansas North" },
  {
    value: "EPSG:6467",
    label: "EPSG:6467 / NAD83(2011) / Kansas North (ftUS)",
  },
  { value: "EPSG:6468", label: "EPSG:6468 / NAD83(2011) / Kansas South" },
  {
    value: "EPSG:6469",
    label: "EPSG:6469 / NAD83(2011) / Kansas South (ftUS)",
  },
  { value: "EPSG:6470", label: "EPSG:6470 / NAD83(2011) / Kentucky North" },
  {
    value: "EPSG:6471",
    label: "EPSG:6471 / NAD83(2011) / Kentucky North (ftUS)",
  },
  {
    value: "EPSG:6472",
    label: "EPSG:6472 / NAD83(2011) / Kentucky Single Zone",
  },
  {
    value: "EPSG:6473",
    label: "EPSG:6473 / NAD83(2011) / Kentucky Single Zone (ftUS)",
  },
  { value: "EPSG:6474", label: "EPSG:6474 / NAD83(2011) / Kentucky South" },
  {
    value: "EPSG:6475",
    label: "EPSG:6475 / NAD83(2011) / Kentucky South (ftUS)",
  },
  { value: "EPSG:6476", label: "EPSG:6476 / NAD83(2011) / Louisiana North" },
  {
    value: "EPSG:6477",
    label: "EPSG:6477 / NAD83(2011) / Louisiana North (ftUS)",
  },
  { value: "EPSG:6478", label: "EPSG:6478 / NAD83(2011) / Louisiana South" },
  {
    value: "EPSG:6479",
    label: "EPSG:6479 / NAD83(2011) / Louisiana South (ftUS)",
  },
  {
    value: "EPSG:6480",
    label: "EPSG:6480 / NAD83(2011) / Maine CS2000 Central",
  },
  { value: "EPSG:6481", label: "EPSG:6481 / NAD83(2011) / Maine CS2000 East" },
  { value: "EPSG:6482", label: "EPSG:6482 / NAD83(2011) / Maine CS2000 West" },
  { value: "EPSG:6483", label: "EPSG:6483 / NAD83(2011) / Maine East" },
  { value: "EPSG:6484", label: "EPSG:6484 / NAD83(2011) / Maine East (ftUS)" },
  { value: "EPSG:6485", label: "EPSG:6485 / NAD83(2011) / Maine West" },
  { value: "EPSG:6486", label: "EPSG:6486 / NAD83(2011) / Maine West (ftUS)" },
  { value: "EPSG:6487", label: "EPSG:6487 / NAD83(2011) / Maryland" },
  { value: "EPSG:6488", label: "EPSG:6488 / NAD83(2011) / Maryland (ftUS)" },
  {
    value: "EPSG:6489",
    label: "EPSG:6489 / NAD83(2011) / Massachusetts Island",
  },
  {
    value: "EPSG:6490",
    label: "EPSG:6490 / NAD83(2011) / Massachusetts Island (ftUS)",
  },
  {
    value: "EPSG:6491",
    label: "EPSG:6491 / NAD83(2011) / Massachusetts Mainland",
  },
  {
    value: "EPSG:6492",
    label: "EPSG:6492 / NAD83(2011) / Massachusetts Mainland (ftUS)",
  },
  { value: "EPSG:6493", label: "EPSG:6493 / NAD83(2011) / Michigan Central" },
  {
    value: "EPSG:6494",
    label: "EPSG:6494 / NAD83(2011) / Michigan Central (ft)",
  },
  { value: "EPSG:6495", label: "EPSG:6495 / NAD83(2011) / Michigan North" },
  {
    value: "EPSG:6496",
    label: "EPSG:6496 / NAD83(2011) / Michigan North (ft)",
  },
  {
    value: "EPSG:6497",
    label: "EPSG:6497 / NAD83(2011) / Michigan Oblique Mercator",
  },
  { value: "EPSG:6498", label: "EPSG:6498 / NAD83(2011) / Michigan South" },
  {
    value: "EPSG:6499",
    label: "EPSG:6499 / NAD83(2011) / Michigan South (ft)",
  },
  { value: "EPSG:6500", label: "EPSG:6500 / NAD83(2011) / Minnesota Central" },
  {
    value: "EPSG:6501",
    label: "EPSG:6501 / NAD83(2011) / Minnesota Central (ftUS)",
  },
  { value: "EPSG:6502", label: "EPSG:6502 / NAD83(2011) / Minnesota North" },
  {
    value: "EPSG:6503",
    label: "EPSG:6503 / NAD83(2011) / Minnesota North (ftUS)",
  },
  { value: "EPSG:6504", label: "EPSG:6504 / NAD83(2011) / Minnesota South" },
  {
    value: "EPSG:6505",
    label: "EPSG:6505 / NAD83(2011) / Minnesota South (ftUS)",
  },
  { value: "EPSG:6506", label: "EPSG:6506 / NAD83(2011) / Mississippi East" },
  {
    value: "EPSG:6507",
    label: "EPSG:6507 / NAD83(2011) / Mississippi East (ftUS)",
  },
  { value: "EPSG:6508", label: "EPSG:6508 / NAD83(2011) / Mississippi TM" },
  { value: "EPSG:6509", label: "EPSG:6509 / NAD83(2011) / Mississippi West" },
  {
    value: "EPSG:6510",
    label: "EPSG:6510 / NAD83(2011) / Mississippi West (ftUS)",
  },
  { value: "EPSG:6511", label: "EPSG:6511 / NAD83(2011) / Missouri Central" },
  { value: "EPSG:6512", label: "EPSG:6512 / NAD83(2011) / Missouri East" },
  { value: "EPSG:6513", label: "EPSG:6513 / NAD83(2011) / Missouri West" },
  { value: "EPSG:6514", label: "EPSG:6514 / NAD83(2011) / Montana" },
  { value: "EPSG:6515", label: "EPSG:6515 / NAD83(2011) / Montana (ft)" },
  { value: "EPSG:6516", label: "EPSG:6516 / NAD83(2011) / Nebraska" },
  { value: "EPSG:6517", label: "EPSG:6517 / NAD83(2011) / Nebraska (ftUS)" },
  { value: "EPSG:6518", label: "EPSG:6518 / NAD83(2011) / Nevada Central" },
  {
    value: "EPSG:6519",
    label: "EPSG:6519 / NAD83(2011) / Nevada Central (ftUS)",
  },
  { value: "EPSG:6520", label: "EPSG:6520 / NAD83(2011) / Nevada East" },
  { value: "EPSG:6521", label: "EPSG:6521 / NAD83(2011) / Nevada East (ftUS)" },
  { value: "EPSG:6522", label: "EPSG:6522 / NAD83(2011) / Nevada West" },
  { value: "EPSG:6523", label: "EPSG:6523 / NAD83(2011) / Nevada West (ftUS)" },
  { value: "EPSG:6524", label: "EPSG:6524 / NAD83(2011) / New Hampshire" },
  {
    value: "EPSG:6525",
    label: "EPSG:6525 / NAD83(2011) / New Hampshire (ftUS)",
  },
  { value: "EPSG:6526", label: "EPSG:6526 / NAD83(2011) / New Jersey" },
  { value: "EPSG:6527", label: "EPSG:6527 / NAD83(2011) / New Jersey (ftUS)" },
  { value: "EPSG:6528", label: "EPSG:6528 / NAD83(2011) / New Mexico Central" },
  {
    value: "EPSG:6529",
    label: "EPSG:6529 / NAD83(2011) / New Mexico Central (ftUS)",
  },
  { value: "EPSG:6530", label: "EPSG:6530 / NAD83(2011) / New Mexico East" },
  {
    value: "EPSG:6531",
    label: "EPSG:6531 / NAD83(2011) / New Mexico East (ftUS)",
  },
  { value: "EPSG:6532", label: "EPSG:6532 / NAD83(2011) / New Mexico West" },
  {
    value: "EPSG:6533",
    label: "EPSG:6533 / NAD83(2011) / New Mexico West (ftUS)",
  },
  { value: "EPSG:6534", label: "EPSG:6534 / NAD83(2011) / New York Central" },
  {
    value: "EPSG:6535",
    label: "EPSG:6535 / NAD83(2011) / New York Central (ftUS)",
  },
  { value: "EPSG:6536", label: "EPSG:6536 / NAD83(2011) / New York East" },
  {
    value: "EPSG:6537",
    label: "EPSG:6537 / NAD83(2011) / New York East (ftUS)",
  },
  {
    value: "EPSG:6538",
    label: "EPSG:6538 / NAD83(2011) / New York Long Island",
  },
  {
    value: "EPSG:6539",
    label: "EPSG:6539 / NAD83(2011) / New York Long Island (ftUS)",
  },
  { value: "EPSG:6540", label: "EPSG:6540 / NAD83(2011) / New York West" },
  {
    value: "EPSG:6541",
    label: "EPSG:6541 / NAD83(2011) / New York West (ftUS)",
  },
  { value: "EPSG:6542", label: "EPSG:6542 / NAD83(2011) / North Carolina" },
  {
    value: "EPSG:6543",
    label: "EPSG:6543 / NAD83(2011) / North Carolina (ftUS)",
  },
  { value: "EPSG:6544", label: "EPSG:6544 / NAD83(2011) / North Dakota North" },
  {
    value: "EPSG:6545",
    label: "EPSG:6545 / NAD83(2011) / North Dakota North (ft)",
  },
  { value: "EPSG:6546", label: "EPSG:6546 / NAD83(2011) / North Dakota South" },
  {
    value: "EPSG:6547",
    label: "EPSG:6547 / NAD83(2011) / North Dakota South (ft)",
  },
  { value: "EPSG:6548", label: "EPSG:6548 / NAD83(2011) / Ohio North" },
  { value: "EPSG:6549", label: "EPSG:6549 / NAD83(2011) / Ohio North (ftUS)" },
  { value: "EPSG:6550", label: "EPSG:6550 / NAD83(2011) / Ohio South" },
  { value: "EPSG:6551", label: "EPSG:6551 / NAD83(2011) / Ohio South (ftUS)" },
  { value: "EPSG:6552", label: "EPSG:6552 / NAD83(2011) / Oklahoma North" },
  {
    value: "EPSG:6553",
    label: "EPSG:6553 / NAD83(2011) / Oklahoma North (ftUS)",
  },
  { value: "EPSG:6554", label: "EPSG:6554 / NAD83(2011) / Oklahoma South" },
  {
    value: "EPSG:6555",
    label: "EPSG:6555 / NAD83(2011) / Oklahoma South (ftUS)",
  },
  { value: "EPSG:6556", label: "EPSG:6556 / NAD83(2011) / Oregon LCC (m)" },
  {
    value: "EPSG:6557",
    label: "EPSG:6557 / NAD83(2011) / Oregon GIC Lambert (ft)",
  },
  { value: "EPSG:6558", label: "EPSG:6558 / NAD83(2011) / Oregon North" },
  { value: "EPSG:6559", label: "EPSG:6559 / NAD83(2011) / Oregon North (ft)" },
  { value: "EPSG:6560", label: "EPSG:6560 / NAD83(2011) / Oregon South" },
  { value: "EPSG:6561", label: "EPSG:6561 / NAD83(2011) / Oregon South (ft)" },
  { value: "EPSG:6562", label: "EPSG:6562 / NAD83(2011) / Pennsylvania North" },
  {
    value: "EPSG:6563",
    label: "EPSG:6563 / NAD83(2011) / Pennsylvania North (ftUS)",
  },
  { value: "EPSG:6564", label: "EPSG:6564 / NAD83(2011) / Pennsylvania South" },
  {
    value: "EPSG:6565",
    label: "EPSG:6565 / NAD83(2011) / Pennsylvania South (ftUS)",
  },
  {
    value: "EPSG:6566",
    label: "EPSG:6566 / NAD83(2011) / Puerto Rico and Virgin Is.",
  },
  { value: "EPSG:6567", label: "EPSG:6567 / NAD83(2011) / Rhode Island" },
  {
    value: "EPSG:6568",
    label: "EPSG:6568 / NAD83(2011) / Rhode Island (ftUS)",
  },
  { value: "EPSG:6569", label: "EPSG:6569 / NAD83(2011) / South Carolina" },
  {
    value: "EPSG:6570",
    label: "EPSG:6570 / NAD83(2011) / South Carolina (ft)",
  },
  { value: "EPSG:6571", label: "EPSG:6571 / NAD83(2011) / South Dakota North" },
  {
    value: "EPSG:6572",
    label: "EPSG:6572 / NAD83(2011) / South Dakota North (ftUS)",
  },
  { value: "EPSG:6573", label: "EPSG:6573 / NAD83(2011) / South Dakota South" },
  {
    value: "EPSG:6574",
    label: "EPSG:6574 / NAD83(2011) / South Dakota South (ftUS)",
  },
  { value: "EPSG:6575", label: "EPSG:6575 / NAD83(2011) / Tennessee" },
  { value: "EPSG:6576", label: "EPSG:6576 / NAD83(2011) / Tennessee (ftUS)" },
  { value: "EPSG:6577", label: "EPSG:6577 / NAD83(2011) / Texas Central" },
  {
    value: "EPSG:6578",
    label: "EPSG:6578 / NAD83(2011) / Texas Central (ftUS)",
  },
  {
    value: "EPSG:6579",
    label: "EPSG:6579 / NAD83(2011) / Texas Centric Albers Equal Area",
  },
  {
    value: "EPSG:6580",
    label: "EPSG:6580 / NAD83(2011) / Texas Centric Lambert Conformal",
  },
  { value: "EPSG:6581", label: "EPSG:6581 / NAD83(2011) / Texas North" },
  { value: "EPSG:6582", label: "EPSG:6582 / NAD83(2011) / Texas North (ftUS)" },
  {
    value: "EPSG:6583",
    label: "EPSG:6583 / NAD83(2011) / Texas North Central",
  },
  {
    value: "EPSG:6584",
    label: "EPSG:6584 / NAD83(2011) / Texas North Central (ftUS)",
  },
  { value: "EPSG:6585", label: "EPSG:6585 / NAD83(2011) / Texas South" },
  { value: "EPSG:6586", label: "EPSG:6586 / NAD83(2011) / Texas South (ftUS)" },
  {
    value: "EPSG:6587",
    label: "EPSG:6587 / NAD83(2011) / Texas South Central",
  },
  {
    value: "EPSG:6588",
    label: "EPSG:6588 / NAD83(2011) / Texas South Central (ftUS)",
  },
  { value: "EPSG:6589", label: "EPSG:6589 / NAD83(2011) / Vermont" },
  { value: "EPSG:6590", label: "EPSG:6590 / NAD83(2011) / Vermont (ftUS)" },
  { value: "EPSG:6591", label: "EPSG:6591 / NAD83(2011) / Virginia Lambert" },
  { value: "EPSG:6592", label: "EPSG:6592 / NAD83(2011) / Virginia North" },
  {
    value: "EPSG:6593",
    label: "EPSG:6593 / NAD83(2011) / Virginia North (ftUS)",
  },
  { value: "EPSG:6594", label: "EPSG:6594 / NAD83(2011) / Virginia South" },
  {
    value: "EPSG:6595",
    label: "EPSG:6595 / NAD83(2011) / Virginia South (ftUS)",
  },
  { value: "EPSG:6596", label: "EPSG:6596 / NAD83(2011) / Washington North" },
  {
    value: "EPSG:6597",
    label: "EPSG:6597 / NAD83(2011) / Washington North (ftUS)",
  },
  { value: "EPSG:6598", label: "EPSG:6598 / NAD83(2011) / Washington South" },
  {
    value: "EPSG:6599",
    label: "EPSG:6599 / NAD83(2011) / Washington South (ftUS)",
  },
  {
    value: "EPSG:6600",
    label: "EPSG:6600 / NAD83(2011) / West Virginia North",
  },
  {
    value: "EPSG:6601",
    label: "EPSG:6601 / NAD83(2011) / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:6602",
    label: "EPSG:6602 / NAD83(2011) / West Virginia South",
  },
  {
    value: "EPSG:6603",
    label: "EPSG:6603 / NAD83(2011) / West Virginia South (ftUS)",
  },
  { value: "EPSG:6604", label: "EPSG:6604 / NAD83(2011) / Wisconsin Central" },
  {
    value: "EPSG:6605",
    label: "EPSG:6605 / NAD83(2011) / Wisconsin Central (ftUS)",
  },
  { value: "EPSG:6606", label: "EPSG:6606 / NAD83(2011) / Wisconsin North" },
  {
    value: "EPSG:6607",
    label: "EPSG:6607 / NAD83(2011) / Wisconsin North (ftUS)",
  },
  { value: "EPSG:6608", label: "EPSG:6608 / NAD83(2011) / Wisconsin South" },
  {
    value: "EPSG:6609",
    label: "EPSG:6609 / NAD83(2011) / Wisconsin South (ftUS)",
  },
  {
    value: "EPSG:6610",
    label: "EPSG:6610 / NAD83(2011) / Wisconsin Transverse Mercator",
  },
  { value: "EPSG:6611", label: "EPSG:6611 / NAD83(2011) / Wyoming East" },
  {
    value: "EPSG:6612",
    label: "EPSG:6612 / NAD83(2011) / Wyoming East (ftUS)",
  },
  {
    value: "EPSG:6613",
    label: "EPSG:6613 / NAD83(2011) / Wyoming East Central",
  },
  {
    value: "EPSG:6614",
    label: "EPSG:6614 / NAD83(2011) / Wyoming East Central (ftUS)",
  },
  { value: "EPSG:6615", label: "EPSG:6615 / NAD83(2011) / Wyoming West" },
  {
    value: "EPSG:6616",
    label: "EPSG:6616 / NAD83(2011) / Wyoming West (ftUS)",
  },
  {
    value: "EPSG:6617",
    label: "EPSG:6617 / NAD83(2011) / Wyoming West Central",
  },
  {
    value: "EPSG:6618",
    label: "EPSG:6618 / NAD83(2011) / Wyoming West Central (ftUS)",
  },
  { value: "EPSG:6619", label: "EPSG:6619 / NAD83(2011) / Utah Central" },
  { value: "EPSG:6620", label: "EPSG:6620 / NAD83(2011) / Utah North" },
  { value: "EPSG:6621", label: "EPSG:6621 / NAD83(2011) / Utah South" },
  { value: "EPSG:6622", label: "EPSG:6622 / NAD83(CSRS) / Quebec Lambert" },
  { value: "EPSG:6623", label: "EPSG:6623 / NAD83 / Quebec Albers" },
  { value: "EPSG:6624", label: "EPSG:6624 / NAD83(CSRS) / Quebec Albers" },
  {
    value: "EPSG:6625",
    label: "EPSG:6625 / NAD83(2011) / Utah Central (ftUS)",
  },
  { value: "EPSG:6626", label: "EPSG:6626 / NAD83(2011) / Utah North (ftUS)" },
  { value: "EPSG:6627", label: "EPSG:6627 / NAD83(2011) / Utah South (ftUS)" },
  { value: "EPSG:6628", label: "EPSG:6628 / NAD83(PA11) / Hawaii zone 1" },
  { value: "EPSG:6629", label: "EPSG:6629 / NAD83(PA11) / Hawaii zone 2" },
  { value: "EPSG:6630", label: "EPSG:6630 / NAD83(PA11) / Hawaii zone 3" },
  { value: "EPSG:6631", label: "EPSG:6631 / NAD83(PA11) / Hawaii zone 4" },
  { value: "EPSG:6632", label: "EPSG:6632 / NAD83(PA11) / Hawaii zone 5" },
  {
    value: "EPSG:6633",
    label: "EPSG:6633 / NAD83(PA11) / Hawaii zone 3 (ftUS)",
  },
  { value: "EPSG:6634", label: "EPSG:6634 / NAD83(PA11) / UTM zone 4N" },
  { value: "EPSG:6635", label: "EPSG:6635 / NAD83(PA11) / UTM zone 5N" },
  { value: "EPSG:6636", label: "EPSG:6636 / NAD83(PA11) / UTM zone 2S" },
  { value: "EPSG:6637", label: "EPSG:6637 / NAD83(MA11) / Guam Map Grid" },
  {
    value: "EPSG:6646",
    label: "EPSG:6646 / Karbala 1979 / Iraq National Grid",
  },
  {
    value: "EPSG:6669",
    label: "EPSG:6669 / JGD2011 / Japan Plane Rectangular CS I",
  },
  {
    value: "EPSG:6670",
    label: "EPSG:6670 / JGD2011 / Japan Plane Rectangular CS II",
  },
  {
    value: "EPSG:6671",
    label: "EPSG:6671 / JGD2011 / Japan Plane Rectangular CS III",
  },
  {
    value: "EPSG:6672",
    label: "EPSG:6672 / JGD2011 / Japan Plane Rectangular CS IV",
  },
  {
    value: "EPSG:6673",
    label: "EPSG:6673 / JGD2011 / Japan Plane Rectangular CS V",
  },
  {
    value: "EPSG:6674",
    label: "EPSG:6674 / JGD2011 / Japan Plane Rectangular CS VI",
  },
  {
    value: "EPSG:6675",
    label: "EPSG:6675 / JGD2011 / Japan Plane Rectangular CS VII",
  },
  {
    value: "EPSG:6676",
    label: "EPSG:6676 / JGD2011 / Japan Plane Rectangular CS VIII",
  },
  {
    value: "EPSG:6677",
    label: "EPSG:6677 / JGD2011 / Japan Plane Rectangular CS IX",
  },
  {
    value: "EPSG:6678",
    label: "EPSG:6678 / JGD2011 / Japan Plane Rectangular CS X",
  },
  {
    value: "EPSG:6679",
    label: "EPSG:6679 / JGD2011 / Japan Plane Rectangular CS XI",
  },
  {
    value: "EPSG:6680",
    label: "EPSG:6680 / JGD2011 / Japan Plane Rectangular CS XII",
  },
  {
    value: "EPSG:6681",
    label: "EPSG:6681 / JGD2011 / Japan Plane Rectangular CS XIII",
  },
  {
    value: "EPSG:6682",
    label: "EPSG:6682 / JGD2011 / Japan Plane Rectangular CS XIV",
  },
  {
    value: "EPSG:6683",
    label: "EPSG:6683 / JGD2011 / Japan Plane Rectangular CS XV",
  },
  {
    value: "EPSG:6684",
    label: "EPSG:6684 / JGD2011 / Japan Plane Rectangular CS XVI",
  },
  {
    value: "EPSG:6685",
    label: "EPSG:6685 / JGD2011 / Japan Plane Rectangular CS XVII",
  },
  {
    value: "EPSG:6686",
    label: "EPSG:6686 / JGD2011 / Japan Plane Rectangular CS XVIII",
  },
  {
    value: "EPSG:6687",
    label: "EPSG:6687 / JGD2011 / Japan Plane Rectangular CS XIX",
  },
  { value: "EPSG:6688", label: "EPSG:6688 / JGD2011 / UTM zone 51N" },
  { value: "EPSG:6689", label: "EPSG:6689 / JGD2011 / UTM zone 52N" },
  { value: "EPSG:6690", label: "EPSG:6690 / JGD2011 / UTM zone 53N" },
  { value: "EPSG:6691", label: "EPSG:6691 / JGD2011 / UTM zone 54N" },
  { value: "EPSG:6692", label: "EPSG:6692 / JGD2011 / UTM zone 55N" },
  { value: "EPSG:6703", label: "EPSG:6703 / WGS 84 / TM 60 SW" },
  { value: "EPSG:6707", label: "EPSG:6707 / RDN2008 / UTM zone 32N (N-E)" },
  { value: "EPSG:6708", label: "EPSG:6708 / RDN2008 / UTM zone 33N (N-E)" },
  { value: "EPSG:6709", label: "EPSG:6709 / RDN2008 / UTM zone 34N (N-E)" },
  { value: "EPSG:6720", label: "EPSG:6720 / WGS 84 / CIG92" },
  { value: "EPSG:6721", label: "EPSG:6721 / GDA94 / CIG94" },
  { value: "EPSG:6722", label: "EPSG:6722 / WGS 84 / CKIG92" },
  { value: "EPSG:6723", label: "EPSG:6723 / GDA94 / CKIG94" },
  { value: "EPSG:6732", label: "EPSG:6732 / GDA94 / MGA zone 41" },
  { value: "EPSG:6733", label: "EPSG:6733 / GDA94 / MGA zone 42" },
  { value: "EPSG:6734", label: "EPSG:6734 / GDA94 / MGA zone 43" },
  { value: "EPSG:6735", label: "EPSG:6735 / GDA94 / MGA zone 44" },
  { value: "EPSG:6736", label: "EPSG:6736 / GDA94 / MGA zone 46" },
  { value: "EPSG:6737", label: "EPSG:6737 / GDA94 / MGA zone 47" },
  { value: "EPSG:6738", label: "EPSG:6738 / GDA94 / MGA zone 59" },
  {
    value: "EPSG:6784",
    label: "EPSG:6784 / NAD83(CORS96) / Oregon Baker zone (m)",
  },
  {
    value: "EPSG:6785",
    label: "EPSG:6785 / NAD83(CORS96) / Oregon Baker zone (ft)",
  },
  {
    value: "EPSG:6786",
    label: "EPSG:6786 / NAD83(2011) / Oregon Baker zone (m)",
  },
  {
    value: "EPSG:6787",
    label: "EPSG:6787 / NAD83(2011) / Oregon Baker zone (ft)",
  },
  {
    value: "EPSG:6788",
    label: "EPSG:6788 / NAD83(CORS96) / Oregon Bend-Klamath Falls zone (m)",
  },
  {
    value: "EPSG:6789",
    label: "EPSG:6789 / NAD83(CORS96) / Oregon Bend-Klamath Falls zone (ft)",
  },
  {
    value: "EPSG:6790",
    label: "EPSG:6790 / NAD83(2011) / Oregon Bend-Klamath Falls zone (m)",
  },
  {
    value: "EPSG:6791",
    label: "EPSG:6791 / NAD83(2011) / Oregon Bend-Klamath Falls zone (ft)",
  },
  {
    value: "EPSG:6792",
    label:
      "EPSG:6792 / NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (m)",
  },
  {
    value: "EPSG:6793",
    label:
      "EPSG:6793 / NAD83(CORS96) / Oregon Bend-Redmond-Prineville zone (ft)",
  },
  {
    value: "EPSG:6794",
    label: "EPSG:6794 / NAD83(2011) / Oregon Bend-Redmond-Prineville zone (m)",
  },
  {
    value: "EPSG:6795",
    label: "EPSG:6795 / NAD83(2011) / Oregon Bend-Redmond-Prineville zone (ft)",
  },
  {
    value: "EPSG:6796",
    label: "EPSG:6796 / NAD83(CORS96) / Oregon Bend-Burns zone (m)",
  },
  {
    value: "EPSG:6797",
    label: "EPSG:6797 / NAD83(CORS96) / Oregon Bend-Burns zone (ft)",
  },
  {
    value: "EPSG:6798",
    label: "EPSG:6798 / NAD83(2011) / Oregon Bend-Burns zone (m)",
  },
  {
    value: "EPSG:6799",
    label: "EPSG:6799 / NAD83(2011) / Oregon Bend-Burns zone (ft)",
  },
  {
    value: "EPSG:6800",
    label:
      "EPSG:6800 / NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (m)",
  },
  {
    value: "EPSG:6801",
    label:
      "EPSG:6801 / NAD83(CORS96) / Oregon Canyonville-Grants Pass zone (ft)",
  },
  {
    value: "EPSG:6802",
    label: "EPSG:6802 / NAD83(2011) / Oregon Canyonville-Grants Pass zone (m)",
  },
  {
    value: "EPSG:6803",
    label: "EPSG:6803 / NAD83(2011) / Oregon Canyonville-Grants Pass zone (ft)",
  },
  {
    value: "EPSG:6804",
    label: "EPSG:6804 / NAD83(CORS96) / Oregon Columbia River East zone (m)",
  },
  {
    value: "EPSG:6805",
    label: "EPSG:6805 / NAD83(CORS96) / Oregon Columbia River East zone (ft)",
  },
  {
    value: "EPSG:6806",
    label: "EPSG:6806 / NAD83(2011) / Oregon Columbia River East zone (m)",
  },
  {
    value: "EPSG:6807",
    label: "EPSG:6807 / NAD83(2011) / Oregon Columbia River East zone (ft)",
  },
  {
    value: "EPSG:6808",
    label: "EPSG:6808 / NAD83(CORS96) / Oregon Columbia River West zone (m)",
  },
  {
    value: "EPSG:6809",
    label: "EPSG:6809 / NAD83(CORS96) / Oregon Columbia River West zone (ft)",
  },
  {
    value: "EPSG:6810",
    label: "EPSG:6810 / NAD83(2011) / Oregon Columbia River West zone (m)",
  },
  {
    value: "EPSG:6811",
    label: "EPSG:6811 / NAD83(2011) / Oregon Columbia River West zone (ft)",
  },
  {
    value: "EPSG:6812",
    label:
      "EPSG:6812 / NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (m)",
  },
  {
    value: "EPSG:6813",
    label:
      "EPSG:6813 / NAD83(CORS96) / Oregon Cottage Grove-Canyonville zone (ft)",
  },
  {
    value: "EPSG:6814",
    label:
      "EPSG:6814 / NAD83(2011) / Oregon Cottage Grove-Canyonville zone (m)",
  },
  {
    value: "EPSG:6815",
    label:
      "EPSG:6815 / NAD83(2011) / Oregon Cottage Grove-Canyonville zone (ft)",
  },
  {
    value: "EPSG:6816",
    label: "EPSG:6816 / NAD83(CORS96) / Oregon Dufur-Madras zone (m)",
  },
  {
    value: "EPSG:6817",
    label: "EPSG:6817 / NAD83(CORS96) / Oregon Dufur-Madras zone (ft)",
  },
  {
    value: "EPSG:6818",
    label: "EPSG:6818 / NAD83(2011) / Oregon Dufur-Madras zone (m)",
  },
  {
    value: "EPSG:6819",
    label: "EPSG:6819 / NAD83(2011) / Oregon Dufur-Madras zone (ft)",
  },
  {
    value: "EPSG:6820",
    label: "EPSG:6820 / NAD83(CORS96) / Oregon Eugene zone (m)",
  },
  {
    value: "EPSG:6821",
    label: "EPSG:6821 / NAD83(CORS96) / Oregon Eugene zone (ft)",
  },
  {
    value: "EPSG:6822",
    label: "EPSG:6822 / NAD83(2011) / Oregon Eugene zone (m)",
  },
  {
    value: "EPSG:6823",
    label: "EPSG:6823 / NAD83(2011) / Oregon Eugene zone (ft)",
  },
  {
    value: "EPSG:6824",
    label: "EPSG:6824 / NAD83(CORS96) / Oregon Grants Pass-Ashland zone (m)",
  },
  {
    value: "EPSG:6825",
    label: "EPSG:6825 / NAD83(CORS96) / Oregon Grants Pass-Ashland zone (ft)",
  },
  {
    value: "EPSG:6826",
    label: "EPSG:6826 / NAD83(2011) / Oregon Grants Pass-Ashland zone (m)",
  },
  {
    value: "EPSG:6827",
    label: "EPSG:6827 / NAD83(2011) / Oregon Grants Pass-Ashland zone (ft)",
  },
  {
    value: "EPSG:6828",
    label: "EPSG:6828 / NAD83(CORS96) / Oregon Gresham-Warm Springs zone (m)",
  },
  {
    value: "EPSG:6829",
    label: "EPSG:6829 / NAD83(CORS96) / Oregon Gresham-Warm Springs zone (ft)",
  },
  {
    value: "EPSG:6830",
    label: "EPSG:6830 / NAD83(2011) / Oregon Gresham-Warm Springs zone (m)",
  },
  {
    value: "EPSG:6831",
    label: "EPSG:6831 / NAD83(2011) / Oregon Gresham-Warm Springs zone (ft)",
  },
  {
    value: "EPSG:6832",
    label: "EPSG:6832 / NAD83(CORS96) / Oregon La Grande zone (m)",
  },
  {
    value: "EPSG:6833",
    label: "EPSG:6833 / NAD83(CORS96) / Oregon La Grande zone (ft)",
  },
  {
    value: "EPSG:6834",
    label: "EPSG:6834 / NAD83(2011) / Oregon La Grande zone (m)",
  },
  {
    value: "EPSG:6835",
    label: "EPSG:6835 / NAD83(2011) / Oregon La Grande zone (ft)",
  },
  {
    value: "EPSG:6836",
    label: "EPSG:6836 / NAD83(CORS96) / Oregon Ontario zone (m)",
  },
  {
    value: "EPSG:6837",
    label: "EPSG:6837 / NAD83(CORS96) / Oregon Ontario zone (ft)",
  },
  {
    value: "EPSG:6838",
    label: "EPSG:6838 / NAD83(2011) / Oregon Ontario zone (m)",
  },
  {
    value: "EPSG:6839",
    label: "EPSG:6839 / NAD83(2011) / Oregon Ontario zone (ft)",
  },
  {
    value: "EPSG:6840",
    label: "EPSG:6840 / NAD83(CORS96) / Oregon Coast zone (m)",
  },
  {
    value: "EPSG:6841",
    label: "EPSG:6841 / NAD83(CORS96) / Oregon Coast zone (ft)",
  },
  {
    value: "EPSG:6842",
    label: "EPSG:6842 / NAD83(2011) / Oregon Coast zone (m)",
  },
  {
    value: "EPSG:6843",
    label: "EPSG:6843 / NAD83(2011) / Oregon Coast zone (ft)",
  },
  {
    value: "EPSG:6844",
    label: "EPSG:6844 / NAD83(CORS96) / Oregon Pendleton zone (m)",
  },
  {
    value: "EPSG:6845",
    label: "EPSG:6845 / NAD83(CORS96) / Oregon Pendleton zone (ft)",
  },
  {
    value: "EPSG:6846",
    label: "EPSG:6846 / NAD83(2011) / Oregon Pendleton zone (m)",
  },
  {
    value: "EPSG:6847",
    label: "EPSG:6847 / NAD83(2011) / Oregon Pendleton zone (ft)",
  },
  {
    value: "EPSG:6848",
    label: "EPSG:6848 / NAD83(CORS96) / Oregon Pendleton-La Grande zone (m)",
  },
  {
    value: "EPSG:6849",
    label: "EPSG:6849 / NAD83(CORS96) / Oregon Pendleton-La Grande zone (ft)",
  },
  {
    value: "EPSG:6850",
    label: "EPSG:6850 / NAD83(2011) / Oregon Pendleton-La Grande zone (m)",
  },
  {
    value: "EPSG:6851",
    label: "EPSG:6851 / NAD83(2011) / Oregon Pendleton-La Grande zone (ft)",
  },
  {
    value: "EPSG:6852",
    label: "EPSG:6852 / NAD83(CORS96) / Oregon Portland zone (m)",
  },
  {
    value: "EPSG:6853",
    label: "EPSG:6853 / NAD83(CORS96) / Oregon Portland zone (ft)",
  },
  {
    value: "EPSG:6854",
    label: "EPSG:6854 / NAD83(2011) / Oregon Portland zone (m)",
  },
  {
    value: "EPSG:6855",
    label: "EPSG:6855 / NAD83(2011) / Oregon Portland zone (ft)",
  },
  {
    value: "EPSG:6856",
    label: "EPSG:6856 / NAD83(CORS96) / Oregon Salem zone (m)",
  },
  {
    value: "EPSG:6857",
    label: "EPSG:6857 / NAD83(CORS96) / Oregon Salem zone (ft)",
  },
  {
    value: "EPSG:6858",
    label: "EPSG:6858 / NAD83(2011) / Oregon Salem zone (m)",
  },
  {
    value: "EPSG:6859",
    label: "EPSG:6859 / NAD83(2011) / Oregon Salem zone (ft)",
  },
  {
    value: "EPSG:6860",
    label: "EPSG:6860 / NAD83(CORS96) / Oregon Santiam Pass zone (m)",
  },
  {
    value: "EPSG:6861",
    label: "EPSG:6861 / NAD83(CORS96) / Oregon Santiam Pass zone (ft)",
  },
  {
    value: "EPSG:6862",
    label: "EPSG:6862 / NAD83(2011) / Oregon Santiam Pass zone (m)",
  },
  {
    value: "EPSG:6863",
    label: "EPSG:6863 / NAD83(2011) / Oregon Santiam Pass zone (ft)",
  },
  { value: "EPSG:6867", label: "EPSG:6867 / NAD83(CORS96) / Oregon LCC (m)" },
  {
    value: "EPSG:6868",
    label: "EPSG:6868 / NAD83(CORS96) / Oregon GIC Lambert (ft)",
  },
  { value: "EPSG:6870", label: "EPSG:6870 / ETRS89 / Albania TM 2010" },
  { value: "EPSG:6875", label: "EPSG:6875 / RDN2008 / Italy zone (N-E)" },
  { value: "EPSG:6876", label: "EPSG:6876 / RDN2008 / Zone 12 (N-E)" },
  { value: "EPSG:6879", label: "EPSG:6879 / NAD83(2011) / Wisconsin Central" },
  { value: "EPSG:6880", label: "EPSG:6880 / NAD83(2011) / Nebraska (ftUS)" },
  { value: "EPSG:6884", label: "EPSG:6884 / NAD83(CORS96) / Oregon North" },
  {
    value: "EPSG:6885",
    label: "EPSG:6885 / NAD83(CORS96) / Oregon North (ft)",
  },
  { value: "EPSG:6886", label: "EPSG:6886 / NAD83(CORS96) / Oregon South" },
  {
    value: "EPSG:6887",
    label: "EPSG:6887 / NAD83(CORS96) / Oregon South (ft)",
  },
  {
    value: "EPSG:6915",
    label: "EPSG:6915 / South East Island 1943 / UTM zone 40N",
  },
  { value: "EPSG:6922", label: "EPSG:6922 / NAD83 / Kansas LCC" },
  { value: "EPSG:6923", label: "EPSG:6923 / NAD83 / Kansas LCC (ftUS)" },
  { value: "EPSG:6924", label: "EPSG:6924 / NAD83(2011) / Kansas LCC" },
  { value: "EPSG:6925", label: "EPSG:6925 / NAD83(2011) / Kansas LCC (ftUS)" },
  {
    value: "EPSG:6931",
    label: "EPSG:6931 / WGS 84 / NSIDC EASE-Grid 2.0 North",
  },
  {
    value: "EPSG:6932",
    label: "EPSG:6932 / WGS 84 / NSIDC EASE-Grid 2.0 South",
  },
  {
    value: "EPSG:6933",
    label: "EPSG:6933 / WGS 84 / NSIDC EASE-Grid 2.0 Global",
  },
  { value: "EPSG:6956", label: "EPSG:6956 / VN-2000 / TM-3 zone 481" },
  { value: "EPSG:6957", label: "EPSG:6957 / VN-2000 / TM-3 zone 482" },
  { value: "EPSG:6958", label: "EPSG:6958 / VN-2000 / TM-3 zone 491" },
  { value: "EPSG:6959", label: "EPSG:6959 / VN-2000 / TM-3 Da Nang zone" },
  { value: "EPSG:6962", label: "EPSG:6962 / ETRS89 / Albania LCC 2010" },
  { value: "EPSG:6966", label: "EPSG:6966 / NAD27 / Michigan North" },
  { value: "EPSG:6984", label: "EPSG:6984 / Israeli Grid 05" },
  { value: "EPSG:6991", label: "EPSG:6991 / Israeli Grid 05/12" },
  { value: "EPSG:6996", label: "EPSG:6996 / NAD83(2011) / San Francisco CS13" },
  {
    value: "EPSG:6997",
    label: "EPSG:6997 / NAD83(2011) / San Francisco CS13 (ftUS)",
  },
  { value: "EPSG:7005", label: "EPSG:7005 / Nahrwan 1934 / UTM zone 37N" },
  { value: "EPSG:7006", label: "EPSG:7006 / Nahrwan 1934 / UTM zone 38N" },
  { value: "EPSG:7007", label: "EPSG:7007 / Nahrwan 1934 / UTM zone 39N" },
  { value: "EPSG:7057", label: "EPSG:7057 / NAD83(2011) / IaRCS zone 1" },
  { value: "EPSG:7058", label: "EPSG:7058 / NAD83(2011) / IaRCS zone 2" },
  { value: "EPSG:7059", label: "EPSG:7059 / NAD83(2011) / IaRCS zone 3" },
  { value: "EPSG:7060", label: "EPSG:7060 / NAD83(2011) / IaRCS zone 4" },
  { value: "EPSG:7061", label: "EPSG:7061 / NAD83(2011) / IaRCS zone 5" },
  { value: "EPSG:7062", label: "EPSG:7062 / NAD83(2011) / IaRCS zone 6" },
  { value: "EPSG:7063", label: "EPSG:7063 / NAD83(2011) / IaRCS zone 7" },
  { value: "EPSG:7064", label: "EPSG:7064 / NAD83(2011) / IaRCS zone 8" },
  { value: "EPSG:7065", label: "EPSG:7065 / NAD83(2011) / IaRCS zone 9" },
  { value: "EPSG:7066", label: "EPSG:7066 / NAD83(2011) / IaRCS zone 10" },
  { value: "EPSG:7067", label: "EPSG:7067 / NAD83(2011) / IaRCS zone 11" },
  { value: "EPSG:7068", label: "EPSG:7068 / NAD83(2011) / IaRCS zone 12" },
  { value: "EPSG:7069", label: "EPSG:7069 / NAD83(2011) / IaRCS zone 13" },
  { value: "EPSG:7070", label: "EPSG:7070 / NAD83(2011) / IaRCS zone 14" },
  { value: "EPSG:7074", label: "EPSG:7074 / RGTAAF07 / UTM zone 37S" },
  { value: "EPSG:7075", label: "EPSG:7075 / RGTAAF07 / UTM zone 38S" },
  { value: "EPSG:7076", label: "EPSG:7076 / RGTAAF07 / UTM zone 39S" },
  { value: "EPSG:7077", label: "EPSG:7077 / RGTAAF07 / UTM zone 40S" },
  { value: "EPSG:7078", label: "EPSG:7078 / RGTAAF07 / UTM zone 41S" },
  { value: "EPSG:7079", label: "EPSG:7079 / RGTAAF07 / UTM zone 42S" },
  { value: "EPSG:7080", label: "EPSG:7080 / RGTAAF07 / UTM zone 43S" },
  { value: "EPSG:7081", label: "EPSG:7081 / RGTAAF07 / UTM zone 44S" },
  {
    value: "EPSG:7082",
    label: "EPSG:7082 / RGTAAF07 / Terre Adelie Polar Stereographic",
  },
  { value: "EPSG:7109", label: "EPSG:7109 / NAD83(2011) / RMTCRS St Mary (m)" },
  {
    value: "EPSG:7110",
    label: "EPSG:7110 / NAD83(2011) / RMTCRS Blackfeet (m)",
  },
  {
    value: "EPSG:7111",
    label: "EPSG:7111 / NAD83(2011) / RMTCRS Milk River (m)",
  },
  {
    value: "EPSG:7112",
    label: "EPSG:7112 / NAD83(2011) / RMTCRS Fort Belknap (m)",
  },
  {
    value: "EPSG:7113",
    label: "EPSG:7113 / NAD83(2011) / RMTCRS Fort Peck Assiniboine (m)",
  },
  {
    value: "EPSG:7114",
    label: "EPSG:7114 / NAD83(2011) / RMTCRS Fort Peck Sioux (m)",
  },
  { value: "EPSG:7115", label: "EPSG:7115 / NAD83(2011) / RMTCRS Crow (m)" },
  { value: "EPSG:7116", label: "EPSG:7116 / NAD83(2011) / RMTCRS Bobcat (m)" },
  {
    value: "EPSG:7117",
    label: "EPSG:7117 / NAD83(2011) / RMTCRS Billings (m)",
  },
  {
    value: "EPSG:7118",
    label: "EPSG:7118 / NAD83(2011) / RMTCRS Wind River (m)",
  },
  {
    value: "EPSG:7119",
    label: "EPSG:7119 / NAD83(2011) / RMTCRS St Mary (ft)",
  },
  {
    value: "EPSG:7120",
    label: "EPSG:7120 / NAD83(2011) / RMTCRS Blackfeet (ft)",
  },
  {
    value: "EPSG:7121",
    label: "EPSG:7121 / NAD83(2011) / RMTCRS Milk River (ft)",
  },
  {
    value: "EPSG:7122",
    label: "EPSG:7122 / NAD83(2011) / RMTCRS Fort Belknap (ft)",
  },
  {
    value: "EPSG:7123",
    label: "EPSG:7123 / NAD83(2011) / RMTCRS Fort Peck Assiniboine (ft)",
  },
  {
    value: "EPSG:7124",
    label: "EPSG:7124 / NAD83(2011) / RMTCRS Fort Peck Sioux (ft)",
  },
  { value: "EPSG:7125", label: "EPSG:7125 / NAD83(2011) / RMTCRS Crow (ft)" },
  { value: "EPSG:7126", label: "EPSG:7126 / NAD83(2011) / RMTCRS Bobcat (ft)" },
  {
    value: "EPSG:7127",
    label: "EPSG:7127 / NAD83(2011) / RMTCRS Billings (ft)",
  },
  {
    value: "EPSG:7128",
    label: "EPSG:7128 / NAD83(2011) / RMTCRS Wind River (ftUS)",
  },
  { value: "EPSG:7131", label: "EPSG:7131 / NAD83(2011) / San Francisco CS13" },
  {
    value: "EPSG:7132",
    label: "EPSG:7132 / NAD83(2011) / San Francisco CS13 (ftUS)",
  },
  {
    value: "EPSG:7142",
    label: "EPSG:7142 / Palestine 1923 / Palestine Grid modified",
  },
  { value: "EPSG:7257", label: "EPSG:7257 / NAD83(2011) / InGCS Adams (m)" },
  { value: "EPSG:7258", label: "EPSG:7258 / NAD83(2011) / InGCS Adams (ftUS)" },
  { value: "EPSG:7259", label: "EPSG:7259 / NAD83(2011) / InGCS Allen (m)" },
  { value: "EPSG:7260", label: "EPSG:7260 / NAD83(2011) / InGCS Allen (ftUS)" },
  {
    value: "EPSG:7261",
    label: "EPSG:7261 / NAD83(2011) / InGCS Bartholomew (m)",
  },
  {
    value: "EPSG:7262",
    label: "EPSG:7262 / NAD83(2011) / InGCS Bartholomew (ftUS)",
  },
  { value: "EPSG:7263", label: "EPSG:7263 / NAD83(2011) / InGCS Benton (m)" },
  {
    value: "EPSG:7264",
    label: "EPSG:7264 / NAD83(2011) / InGCS Benton (ftUS)",
  },
  {
    value: "EPSG:7265",
    label: "EPSG:7265 / NAD83(2011) / InGCS Blackford-Delaware (m)",
  },
  {
    value: "EPSG:7266",
    label: "EPSG:7266 / NAD83(2011) / InGCS Blackford-Delaware (ftUS)",
  },
  {
    value: "EPSG:7267",
    label: "EPSG:7267 / NAD83(2011) / InGCS Boone-Hendricks (m)",
  },
  {
    value: "EPSG:7268",
    label: "EPSG:7268 / NAD83(2011) / InGCS Boone-Hendricks (ftUS)",
  },
  { value: "EPSG:7269", label: "EPSG:7269 / NAD83(2011) / InGCS Brown (m)" },
  { value: "EPSG:7270", label: "EPSG:7270 / NAD83(2011) / InGCS Brown (ftUS)" },
  { value: "EPSG:7271", label: "EPSG:7271 / NAD83(2011) / InGCS Carroll (m)" },
  {
    value: "EPSG:7272",
    label: "EPSG:7272 / NAD83(2011) / InGCS Carroll (ftUS)",
  },
  { value: "EPSG:7273", label: "EPSG:7273 / NAD83(2011) / InGCS Cass (m)" },
  { value: "EPSG:7274", label: "EPSG:7274 / NAD83(2011) / InGCS Cass (ftUS)" },
  {
    value: "EPSG:7275",
    label: "EPSG:7275 / NAD83(2011) / InGCS Clark-Floyd-Scott (m)",
  },
  {
    value: "EPSG:7276",
    label: "EPSG:7276 / NAD83(2011) / InGCS Clark-Floyd-Scott (ftUS)",
  },
  { value: "EPSG:7277", label: "EPSG:7277 / NAD83(2011) / InGCS Clay (m)" },
  { value: "EPSG:7278", label: "EPSG:7278 / NAD83(2011) / InGCS Clay (ftUS)" },
  { value: "EPSG:7279", label: "EPSG:7279 / NAD83(2011) / InGCS Clinton (m)" },
  {
    value: "EPSG:7280",
    label: "EPSG:7280 / NAD83(2011) / InGCS Clinton (ftUS)",
  },
  {
    value: "EPSG:7281",
    label: "EPSG:7281 / NAD83(2011) / InGCS Crawford-Lawrence-Orange (m)",
  },
  {
    value: "EPSG:7282",
    label: "EPSG:7282 / NAD83(2011) / InGCS Crawford-Lawrence-Orange (ftUS)",
  },
  {
    value: "EPSG:7283",
    label: "EPSG:7283 / NAD83(2011) / InGCS Daviess-Greene (m)",
  },
  {
    value: "EPSG:7284",
    label: "EPSG:7284 / NAD83(2011) / InGCS Daviess-Greene (ftUS)",
  },
  {
    value: "EPSG:7285",
    label: "EPSG:7285 / NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (m)",
  },
  {
    value: "EPSG:7286",
    label: "EPSG:7286 / NAD83(2011) / InGCS Dearborn-Ohio-Switzerland (ftUS)",
  },
  {
    value: "EPSG:7287",
    label: "EPSG:7287 / NAD83(2011) / InGCS Decatur-Rush (m)",
  },
  {
    value: "EPSG:7288",
    label: "EPSG:7288 / NAD83(2011) / InGCS Decatur-Rush (ftUS)",
  },
  { value: "EPSG:7289", label: "EPSG:7289 / NAD83(2011) / InGCS DeKalb (m)" },
  {
    value: "EPSG:7290",
    label: "EPSG:7290 / NAD83(2011) / InGCS DeKalb (ftUS)",
  },
  {
    value: "EPSG:7291",
    label: "EPSG:7291 / NAD83(2011) / InGCS Dubois-Martin (m)",
  },
  {
    value: "EPSG:7292",
    label: "EPSG:7292 / NAD83(2011) / InGCS Dubois-Martin (ftUS)",
  },
  {
    value: "EPSG:7293",
    label: "EPSG:7293 / NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (m)",
  },
  {
    value: "EPSG:7294",
    label: "EPSG:7294 / NAD83(2011) / InGCS Elkhart-Kosciusko-Wabash (ftUS)",
  },
  {
    value: "EPSG:7295",
    label: "EPSG:7295 / NAD83(2011) / InGCS Fayette-Franklin-Union (m)",
  },
  {
    value: "EPSG:7296",
    label: "EPSG:7296 / NAD83(2011) / InGCS Fayette-Franklin-Union (ftUS)",
  },
  {
    value: "EPSG:7297",
    label: "EPSG:7297 / NAD83(2011) / InGCS Fountain-Warren (m)",
  },
  {
    value: "EPSG:7298",
    label: "EPSG:7298 / NAD83(2011) / InGCS Fountain-Warren (ftUS)",
  },
  {
    value: "EPSG:7299",
    label: "EPSG:7299 / NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (m)",
  },
  {
    value: "EPSG:7300",
    label: "EPSG:7300 / NAD83(2011) / InGCS Fulton-Marshall-St. Joseph (ftUS)",
  },
  { value: "EPSG:7301", label: "EPSG:7301 / NAD83(2011) / InGCS Gibson (m)" },
  {
    value: "EPSG:7302",
    label: "EPSG:7302 / NAD83(2011) / InGCS Gibson (ftUS)",
  },
  { value: "EPSG:7303", label: "EPSG:7303 / NAD83(2011) / InGCS Grant (m)" },
  { value: "EPSG:7304", label: "EPSG:7304 / NAD83(2011) / InGCS Grant (ftUS)" },
  {
    value: "EPSG:7305",
    label: "EPSG:7305 / NAD83(2011) / InGCS Hamilton-Tipton (m)",
  },
  {
    value: "EPSG:7306",
    label: "EPSG:7306 / NAD83(2011) / InGCS Hamilton-Tipton (ftUS)",
  },
  {
    value: "EPSG:7307",
    label: "EPSG:7307 / NAD83(2011) / InGCS Hancock-Madison (m)",
  },
  {
    value: "EPSG:7308",
    label: "EPSG:7308 / NAD83(2011) / InGCS Hancock-Madison (ftUS)",
  },
  {
    value: "EPSG:7309",
    label: "EPSG:7309 / NAD83(2011) / InGCS Harrison-Washington (m)",
  },
  {
    value: "EPSG:7310",
    label: "EPSG:7310 / NAD83(2011) / InGCS Harrison-Washington (ftUS)",
  },
  { value: "EPSG:7311", label: "EPSG:7311 / NAD83(2011) / InGCS Henry (m)" },
  { value: "EPSG:7312", label: "EPSG:7312 / NAD83(2011) / InGCS Henry (ftUS)" },
  {
    value: "EPSG:7313",
    label: "EPSG:7313 / NAD83(2011) / InGCS Howard-Miami (m)",
  },
  {
    value: "EPSG:7314",
    label: "EPSG:7314 / NAD83(2011) / InGCS Howard-Miami (ftUS)",
  },
  {
    value: "EPSG:7315",
    label: "EPSG:7315 / NAD83(2011) / InGCS Huntington-Whitley (m)",
  },
  {
    value: "EPSG:7316",
    label: "EPSG:7316 / NAD83(2011) / InGCS Huntington-Whitley (ftUS)",
  },
  { value: "EPSG:7317", label: "EPSG:7317 / NAD83(2011) / InGCS Jackson (m)" },
  {
    value: "EPSG:7318",
    label: "EPSG:7318 / NAD83(2011) / InGCS Jackson (ftUS)",
  },
  {
    value: "EPSG:7319",
    label: "EPSG:7319 / NAD83(2011) / InGCS Jasper-Porter (m)",
  },
  {
    value: "EPSG:7320",
    label: "EPSG:7320 / NAD83(2011) / InGCS Jasper-Porter (ftUS)",
  },
  { value: "EPSG:7321", label: "EPSG:7321 / NAD83(2011) / InGCS Jay (m)" },
  { value: "EPSG:7322", label: "EPSG:7322 / NAD83(2011) / InGCS Jay (ftUS)" },
  {
    value: "EPSG:7323",
    label: "EPSG:7323 / NAD83(2011) / InGCS Jefferson (m)",
  },
  {
    value: "EPSG:7324",
    label: "EPSG:7324 / NAD83(2011) / InGCS Jefferson (ftUS)",
  },
  { value: "EPSG:7325", label: "EPSG:7325 / NAD83(2011) / InGCS Jennings (m)" },
  {
    value: "EPSG:7326",
    label: "EPSG:7326 / NAD83(2011) / InGCS Jennings (ftUS)",
  },
  {
    value: "EPSG:7327",
    label: "EPSG:7327 / NAD83(2011) / InGCS Johnson-Marion (m)",
  },
  {
    value: "EPSG:7328",
    label: "EPSG:7328 / NAD83(2011) / InGCS Johnson-Marion (ftUS)",
  },
  { value: "EPSG:7329", label: "EPSG:7329 / NAD83(2011) / InGCS Knox (m)" },
  { value: "EPSG:7330", label: "EPSG:7330 / NAD83(2011) / InGCS Knox (ftUS)" },
  {
    value: "EPSG:7331",
    label: "EPSG:7331 / NAD83(2011) / InGCS LaGrange-Noble (m)",
  },
  {
    value: "EPSG:7332",
    label: "EPSG:7332 / NAD83(2011) / InGCS LaGrange-Noble (ftUS)",
  },
  {
    value: "EPSG:7333",
    label: "EPSG:7333 / NAD83(2011) / InGCS Lake-Newton (m)",
  },
  {
    value: "EPSG:7334",
    label: "EPSG:7334 / NAD83(2011) / InGCS Lake-Newton (ftUS)",
  },
  {
    value: "EPSG:7335",
    label: "EPSG:7335 / NAD83(2011) / InGCS LaPorte-Pulaski-Starke (m)",
  },
  {
    value: "EPSG:7336",
    label: "EPSG:7336 / NAD83(2011) / InGCS LaPorte-Pulaski-Starke (ftUS)",
  },
  {
    value: "EPSG:7337",
    label: "EPSG:7337 / NAD83(2011) / InGCS Monroe-Morgan (m)",
  },
  {
    value: "EPSG:7338",
    label: "EPSG:7338 / NAD83(2011) / InGCS Monroe-Morgan (ftUS)",
  },
  {
    value: "EPSG:7339",
    label: "EPSG:7339 / NAD83(2011) / InGCS Montgomery-Putnam (m)",
  },
  {
    value: "EPSG:7340",
    label: "EPSG:7340 / NAD83(2011) / InGCS Montgomery-Putnam (ftUS)",
  },
  { value: "EPSG:7341", label: "EPSG:7341 / NAD83(2011) / InGCS Owen (m)" },
  { value: "EPSG:7342", label: "EPSG:7342 / NAD83(2011) / InGCS Owen (ftUS)" },
  {
    value: "EPSG:7343",
    label: "EPSG:7343 / NAD83(2011) / InGCS Parke-Vermillion (m)",
  },
  {
    value: "EPSG:7344",
    label: "EPSG:7344 / NAD83(2011) / InGCS Parke-Vermillion (ftUS)",
  },
  { value: "EPSG:7345", label: "EPSG:7345 / NAD83(2011) / InGCS Perry (m)" },
  { value: "EPSG:7346", label: "EPSG:7346 / NAD83(2011) / InGCS Perry (ftUS)" },
  {
    value: "EPSG:7347",
    label: "EPSG:7347 / NAD83(2011) / InGCS Pike-Warrick (m)",
  },
  {
    value: "EPSG:7348",
    label: "EPSG:7348 / NAD83(2011) / InGCS Pike-Warrick (ftUS)",
  },
  { value: "EPSG:7349", label: "EPSG:7349 / NAD83(2011) / InGCS Posey (m)" },
  { value: "EPSG:7350", label: "EPSG:7350 / NAD83(2011) / InGCS Posey (ftUS)" },
  {
    value: "EPSG:7351",
    label: "EPSG:7351 / NAD83(2011) / InGCS Randolph-Wayne (m)",
  },
  {
    value: "EPSG:7352",
    label: "EPSG:7352 / NAD83(2011) / InGCS Randolph-Wayne (ftUS)",
  },
  { value: "EPSG:7353", label: "EPSG:7353 / NAD83(2011) / InGCS Ripley (m)" },
  {
    value: "EPSG:7354",
    label: "EPSG:7354 / NAD83(2011) / InGCS Ripley (ftUS)",
  },
  { value: "EPSG:7355", label: "EPSG:7355 / NAD83(2011) / InGCS Shelby (m)" },
  {
    value: "EPSG:7356",
    label: "EPSG:7356 / NAD83(2011) / InGCS Shelby (ftUS)",
  },
  { value: "EPSG:7357", label: "EPSG:7357 / NAD83(2011) / InGCS Spencer (m)" },
  {
    value: "EPSG:7358",
    label: "EPSG:7358 / NAD83(2011) / InGCS Spencer (ftUS)",
  },
  { value: "EPSG:7359", label: "EPSG:7359 / NAD83(2011) / InGCS Steuben (m)" },
  {
    value: "EPSG:7360",
    label: "EPSG:7360 / NAD83(2011) / InGCS Steuben (ftUS)",
  },
  { value: "EPSG:7361", label: "EPSG:7361 / NAD83(2011) / InGCS Sullivan (m)" },
  {
    value: "EPSG:7362",
    label: "EPSG:7362 / NAD83(2011) / InGCS Sullivan (ftUS)",
  },
  {
    value: "EPSG:7363",
    label: "EPSG:7363 / NAD83(2011) / InGCS Tippecanoe-White (m)",
  },
  {
    value: "EPSG:7364",
    label: "EPSG:7364 / NAD83(2011) / InGCS Tippecanoe-White (ftUS)",
  },
  {
    value: "EPSG:7365",
    label: "EPSG:7365 / NAD83(2011) / InGCS Vanderburgh (m)",
  },
  {
    value: "EPSG:7366",
    label: "EPSG:7366 / NAD83(2011) / InGCS Vanderburgh (ftUS)",
  },
  { value: "EPSG:7367", label: "EPSG:7367 / NAD83(2011) / InGCS Vigo (m)" },
  { value: "EPSG:7368", label: "EPSG:7368 / NAD83(2011) / InGCS Vigo (ftUS)" },
  { value: "EPSG:7369", label: "EPSG:7369 / NAD83(2011) / InGCS Wells (m)" },
  { value: "EPSG:7370", label: "EPSG:7370 / NAD83(2011) / InGCS Wells (ftUS)" },
  { value: "EPSG:7374", label: "EPSG:7374 / ONGD14 / UTM zone 39N" },
  { value: "EPSG:7375", label: "EPSG:7375 / ONGD14 / UTM zone 40N" },
  { value: "EPSG:7376", label: "EPSG:7376 / ONGD14 / UTM zone 41N" },
  {
    value: "EPSG:7528",
    label: "EPSG:7528 / NAD83(2011) / WISCRS Adams and Juneau (m)",
  },
  { value: "EPSG:7529", label: "EPSG:7529 / NAD83(2011) / WISCRS Ashland (m)" },
  { value: "EPSG:7530", label: "EPSG:7530 / NAD83(2011) / WISCRS Barron (m)" },
  {
    value: "EPSG:7531",
    label: "EPSG:7531 / NAD83(2011) / WISCRS Bayfield (m)",
  },
  { value: "EPSG:7532", label: "EPSG:7532 / NAD83(2011) / WISCRS Brown (m)" },
  { value: "EPSG:7533", label: "EPSG:7533 / NAD83(2011) / WISCRS Buffalo (m)" },
  { value: "EPSG:7534", label: "EPSG:7534 / NAD83(2011) / WISCRS Burnett (m)" },
  {
    value: "EPSG:7535",
    label:
      "EPSG:7535 / NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (m)",
  },
  {
    value: "EPSG:7536",
    label: "EPSG:7536 / NAD83(2011) / WISCRS Chippewa (m)",
  },
  { value: "EPSG:7537", label: "EPSG:7537 / NAD83(2011) / WISCRS Clark (m)" },
  {
    value: "EPSG:7538",
    label: "EPSG:7538 / NAD83(2011) / WISCRS Columbia (m)",
  },
  {
    value: "EPSG:7539",
    label: "EPSG:7539 / NAD83(2011) / WISCRS Crawford (m)",
  },
  { value: "EPSG:7540", label: "EPSG:7540 / NAD83(2011) / WISCRS Dane (m)" },
  {
    value: "EPSG:7541",
    label: "EPSG:7541 / NAD83(2011) / WISCRS Dodge and Jefferson (m)",
  },
  { value: "EPSG:7542", label: "EPSG:7542 / NAD83(2011) / WISCRS Door (m)" },
  { value: "EPSG:7543", label: "EPSG:7543 / NAD83(2011) / WISCRS Douglas (m)" },
  { value: "EPSG:7544", label: "EPSG:7544 / NAD83(2011) / WISCRS Dunn (m)" },
  {
    value: "EPSG:7545",
    label: "EPSG:7545 / NAD83(2011) / WISCRS Eau Claire (m)",
  },
  {
    value: "EPSG:7546",
    label: "EPSG:7546 / NAD83(2011) / WISCRS Florence (m)",
  },
  { value: "EPSG:7547", label: "EPSG:7547 / NAD83(2011) / WISCRS Forest (m)" },
  { value: "EPSG:7548", label: "EPSG:7548 / NAD83(2011) / WISCRS Grant (m)" },
  {
    value: "EPSG:7549",
    label: "EPSG:7549 / NAD83(2011) / WISCRS Green and Lafayette (m)",
  },
  {
    value: "EPSG:7550",
    label: "EPSG:7550 / NAD83(2011) / WISCRS Green Lake and Marquette (m)",
  },
  { value: "EPSG:7551", label: "EPSG:7551 / NAD83(2011) / WISCRS Iowa (m)" },
  { value: "EPSG:7552", label: "EPSG:7552 / NAD83(2011) / WISCRS Iron (m)" },
  { value: "EPSG:7553", label: "EPSG:7553 / NAD83(2011) / WISCRS Jackson (m)" },
  {
    value: "EPSG:7554",
    label:
      "EPSG:7554 / NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (m)",
  },
  {
    value: "EPSG:7555",
    label:
      "EPSG:7555 / NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (m)",
  },
  {
    value: "EPSG:7556",
    label: "EPSG:7556 / NAD83(2011) / WISCRS La Crosse (m)",
  },
  {
    value: "EPSG:7557",
    label: "EPSG:7557 / NAD83(2011) / WISCRS Langlade (m)",
  },
  { value: "EPSG:7558", label: "EPSG:7558 / NAD83(2011) / WISCRS Lincoln (m)" },
  {
    value: "EPSG:7559",
    label: "EPSG:7559 / NAD83(2011) / WISCRS Marathon (m)",
  },
  {
    value: "EPSG:7560",
    label: "EPSG:7560 / NAD83(2011) / WISCRS Marinette (m)",
  },
  {
    value: "EPSG:7561",
    label: "EPSG:7561 / NAD83(2011) / WISCRS Menominee (m)",
  },
  { value: "EPSG:7562", label: "EPSG:7562 / NAD83(2011) / WISCRS Monroe (m)" },
  { value: "EPSG:7563", label: "EPSG:7563 / NAD83(2011) / WISCRS Oconto (m)" },
  { value: "EPSG:7564", label: "EPSG:7564 / NAD83(2011) / WISCRS Oneida (m)" },
  {
    value: "EPSG:7565",
    label: "EPSG:7565 / NAD83(2011) / WISCRS Pepin and Pierce (m)",
  },
  { value: "EPSG:7566", label: "EPSG:7566 / NAD83(2011) / WISCRS Polk (m)" },
  { value: "EPSG:7567", label: "EPSG:7567 / NAD83(2011) / WISCRS Portage (m)" },
  { value: "EPSG:7568", label: "EPSG:7568 / NAD83(2011) / WISCRS Price (m)" },
  {
    value: "EPSG:7569",
    label: "EPSG:7569 / NAD83(2011) / WISCRS Richland (m)",
  },
  { value: "EPSG:7570", label: "EPSG:7570 / NAD83(2011) / WISCRS Rock (m)" },
  { value: "EPSG:7571", label: "EPSG:7571 / NAD83(2011) / WISCRS Rusk (m)" },
  { value: "EPSG:7572", label: "EPSG:7572 / NAD83(2011) / WISCRS Sauk (m)" },
  { value: "EPSG:7573", label: "EPSG:7573 / NAD83(2011) / WISCRS Sawyer (m)" },
  { value: "EPSG:7574", label: "EPSG:7574 / NAD83(2011) / WISCRS Shawano (m)" },
  {
    value: "EPSG:7575",
    label: "EPSG:7575 / NAD83(2011) / WISCRS St. Croix (m)",
  },
  { value: "EPSG:7576", label: "EPSG:7576 / NAD83(2011) / WISCRS Taylor (m)" },
  {
    value: "EPSG:7577",
    label: "EPSG:7577 / NAD83(2011) / WISCRS Trempealeau (m)",
  },
  { value: "EPSG:7578", label: "EPSG:7578 / NAD83(2011) / WISCRS Vernon (m)" },
  { value: "EPSG:7579", label: "EPSG:7579 / NAD83(2011) / WISCRS Vilas (m)" },
  {
    value: "EPSG:7580",
    label: "EPSG:7580 / NAD83(2011) / WISCRS Walworth (m)",
  },
  {
    value: "EPSG:7581",
    label: "EPSG:7581 / NAD83(2011) / WISCRS Washburn (m)",
  },
  {
    value: "EPSG:7582",
    label: "EPSG:7582 / NAD83(2011) / WISCRS Washington (m)",
  },
  {
    value: "EPSG:7583",
    label: "EPSG:7583 / NAD83(2011) / WISCRS Waukesha (m)",
  },
  { value: "EPSG:7584", label: "EPSG:7584 / NAD83(2011) / WISCRS Waupaca (m)" },
  {
    value: "EPSG:7585",
    label: "EPSG:7585 / NAD83(2011) / WISCRS Waushara (m)",
  },
  { value: "EPSG:7586", label: "EPSG:7586 / NAD83(2011) / WISCRS Wood (m)" },
  {
    value: "EPSG:7587",
    label: "EPSG:7587 / NAD83(2011) / WISCRS Adams and Juneau (ftUS)",
  },
  {
    value: "EPSG:7588",
    label: "EPSG:7588 / NAD83(2011) / WISCRS Ashland (ftUS)",
  },
  {
    value: "EPSG:7589",
    label: "EPSG:7589 / NAD83(2011) / WISCRS Barron (ftUS)",
  },
  {
    value: "EPSG:7590",
    label: "EPSG:7590 / NAD83(2011) / WISCRS Bayfield (ftUS)",
  },
  {
    value: "EPSG:7591",
    label: "EPSG:7591 / NAD83(2011) / WISCRS Brown (ftUS)",
  },
  {
    value: "EPSG:7592",
    label: "EPSG:7592 / NAD83(2011) / WISCRS Buffalo (ftUS)",
  },
  {
    value: "EPSG:7593",
    label: "EPSG:7593 / NAD83(2011) / WISCRS Burnett (ftUS)",
  },
  {
    value: "EPSG:7594",
    label:
      "EPSG:7594 / NAD83(2011) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (ftUS)",
  },
  {
    value: "EPSG:7595",
    label: "EPSG:7595 / NAD83(2011) / WISCRS Chippewa (ftUS)",
  },
  {
    value: "EPSG:7596",
    label: "EPSG:7596 / NAD83(2011) / WISCRS Clark (ftUS)",
  },
  {
    value: "EPSG:7597",
    label: "EPSG:7597 / NAD83(2011) / WISCRS Columbia (ftUS)",
  },
  {
    value: "EPSG:7598",
    label: "EPSG:7598 / NAD83(2011) / WISCRS Crawford (ftUS)",
  },
  { value: "EPSG:7599", label: "EPSG:7599 / NAD83(2011) / WISCRS Dane (ftUS)" },
  {
    value: "EPSG:7600",
    label: "EPSG:7600 / NAD83(2011) / WISCRS Dodge and Jefferson (ftUS)",
  },
  { value: "EPSG:7601", label: "EPSG:7601 / NAD83(2011) / WISCRS Door (ftUS)" },
  {
    value: "EPSG:7602",
    label: "EPSG:7602 / NAD83(2011) / WISCRS Douglas (ftUS)",
  },
  { value: "EPSG:7603", label: "EPSG:7603 / NAD83(2011) / WISCRS Dunn (ftUS)" },
  {
    value: "EPSG:7604",
    label: "EPSG:7604 / NAD83(2011) / WISCRS Eau Claire (ftUS)",
  },
  {
    value: "EPSG:7605",
    label: "EPSG:7605 / NAD83(2011) / WISCRS Florence (ftUS)",
  },
  {
    value: "EPSG:7606",
    label: "EPSG:7606 / NAD83(2011) / WISCRS Forest (ftUS)",
  },
  {
    value: "EPSG:7607",
    label: "EPSG:7607 / NAD83(2011) / WISCRS Grant (ftUS)",
  },
  {
    value: "EPSG:7608",
    label: "EPSG:7608 / NAD83(2011) / WISCRS Green and Lafayette (ftUS)",
  },
  {
    value: "EPSG:7609",
    label: "EPSG:7609 / NAD83(2011) / WISCRS Green Lake and Marquette (ftUS)",
  },
  { value: "EPSG:7610", label: "EPSG:7610 / NAD83(2011) / WISCRS Iowa (ftUS)" },
  { value: "EPSG:7611", label: "EPSG:7611 / NAD83(2011) / WISCRS Iron (ftUS)" },
  {
    value: "EPSG:7612",
    label: "EPSG:7612 / NAD83(2011) / WISCRS Jackson (ftUS)",
  },
  {
    value: "EPSG:7613",
    label:
      "EPSG:7613 / NAD83(2011) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (ftUS)",
  },
  {
    value: "EPSG:7614",
    label:
      "EPSG:7614 / NAD83(2011) / WISCRS Kewaunee, Manitowoc and Sheboygan (ftUS)",
  },
  {
    value: "EPSG:7615",
    label: "EPSG:7615 / NAD83(2011) / WISCRS La Crosse (ftUS)",
  },
  {
    value: "EPSG:7616",
    label: "EPSG:7616 / NAD83(2011) / WISCRS Langlade (ftUS)",
  },
  {
    value: "EPSG:7617",
    label: "EPSG:7617 / NAD83(2011) / WISCRS Lincoln (ftUS)",
  },
  {
    value: "EPSG:7618",
    label: "EPSG:7618 / NAD83(2011) / WISCRS Marathon (ftUS)",
  },
  {
    value: "EPSG:7619",
    label: "EPSG:7619 / NAD83(2011) / WISCRS Marinette (ftUS)",
  },
  {
    value: "EPSG:7620",
    label: "EPSG:7620 / NAD83(2011) / WISCRS Menominee (ftUS)",
  },
  {
    value: "EPSG:7621",
    label: "EPSG:7621 / NAD83(2011) / WISCRS Monroe (ftUS)",
  },
  {
    value: "EPSG:7622",
    label: "EPSG:7622 / NAD83(2011) / WISCRS Oconto (ftUS)",
  },
  {
    value: "EPSG:7623",
    label: "EPSG:7623 / NAD83(2011) / WISCRS Oneida (ftUS)",
  },
  {
    value: "EPSG:7624",
    label: "EPSG:7624 / NAD83(2011) / WISCRS Pepin and Pierce (ftUS)",
  },
  { value: "EPSG:7625", label: "EPSG:7625 / NAD83(2011) / WISCRS Polk (ftUS)" },
  {
    value: "EPSG:7626",
    label: "EPSG:7626 / NAD83(2011) / WISCRS Portage (ftUS)",
  },
  {
    value: "EPSG:7627",
    label: "EPSG:7627 / NAD83(2011) / WISCRS Price (ftUS)",
  },
  {
    value: "EPSG:7628",
    label: "EPSG:7628 / NAD83(2011) / WISCRS Richland (ftUS)",
  },
  { value: "EPSG:7629", label: "EPSG:7629 / NAD83(2011) / WISCRS Rock (ftUS)" },
  { value: "EPSG:7630", label: "EPSG:7630 / NAD83(2011) / WISCRS Rusk (ftUS)" },
  { value: "EPSG:7631", label: "EPSG:7631 / NAD83(2011) / WISCRS Sauk (ftUS)" },
  {
    value: "EPSG:7632",
    label: "EPSG:7632 / NAD83(2011) / WISCRS Sawyer (ftUS)",
  },
  {
    value: "EPSG:7633",
    label: "EPSG:7633 / NAD83(2011) / WISCRS Shawano (ftUS)",
  },
  {
    value: "EPSG:7634",
    label: "EPSG:7634 / NAD83(2011) / WISCRS St. Croix (ftUS)",
  },
  {
    value: "EPSG:7635",
    label: "EPSG:7635 / NAD83(2011) / WISCRS Taylor (ftUS)",
  },
  {
    value: "EPSG:7636",
    label: "EPSG:7636 / NAD83(2011) / WISCRS Trempealeau (ftUS)",
  },
  {
    value: "EPSG:7637",
    label: "EPSG:7637 / NAD83(2011) / WISCRS Vernon (ftUS)",
  },
  {
    value: "EPSG:7638",
    label: "EPSG:7638 / NAD83(2011) / WISCRS Vilas (ftUS)",
  },
  {
    value: "EPSG:7639",
    label: "EPSG:7639 / NAD83(2011) / WISCRS Walworth (ftUS)",
  },
  {
    value: "EPSG:7640",
    label: "EPSG:7640 / NAD83(2011) / WISCRS Washburn (ftUS)",
  },
  {
    value: "EPSG:7641",
    label: "EPSG:7641 / NAD83(2011) / WISCRS Washington (ftUS)",
  },
  {
    value: "EPSG:7642",
    label: "EPSG:7642 / NAD83(2011) / WISCRS Waukesha (ftUS)",
  },
  {
    value: "EPSG:7643",
    label: "EPSG:7643 / NAD83(2011) / WISCRS Waupaca (ftUS)",
  },
  {
    value: "EPSG:7644",
    label: "EPSG:7644 / NAD83(2011) / WISCRS Waushara (ftUS)",
  },
  { value: "EPSG:7645", label: "EPSG:7645 / NAD83(2011) / WISCRS Wood (ftUS)" },
  { value: "EPSG:7692", label: "EPSG:7692 / Kyrg-06 / zone 1" },
  { value: "EPSG:7693", label: "EPSG:7693 / Kyrg-06 / zone 2" },
  { value: "EPSG:7694", label: "EPSG:7694 / Kyrg-06 / zone 3" },
  { value: "EPSG:7695", label: "EPSG:7695 / Kyrg-06 / zone 4" },
  { value: "EPSG:7696", label: "EPSG:7696 / Kyrg-06 / zone 5" },
  { value: "EPSG:7755", label: "EPSG:7755 / WGS 84 / India NSF LCC" },
  { value: "EPSG:7756", label: "EPSG:7756 / WGS 84 / Andhra Pradesh" },
  { value: "EPSG:7757", label: "EPSG:7757 / WGS 84 / Arunachal Pradesh" },
  { value: "EPSG:7758", label: "EPSG:7758 / WGS 84 / Assam" },
  { value: "EPSG:7759", label: "EPSG:7759 / WGS 84 / Bihar" },
  { value: "EPSG:7760", label: "EPSG:7760 / WGS 84 / Delhi" },
  { value: "EPSG:7761", label: "EPSG:7761 / WGS 84 / Gujarat" },
  { value: "EPSG:7762", label: "EPSG:7762 / WGS 84 / Haryana" },
  { value: "EPSG:7763", label: "EPSG:7763 / WGS 84 / Himachal Pradesh" },
  { value: "EPSG:7764", label: "EPSG:7764 / WGS 84 / Jammu and Kashmir" },
  { value: "EPSG:7765", label: "EPSG:7765 / WGS 84 / Jharkhand" },
  { value: "EPSG:7766", label: "EPSG:7766 / WGS 84 / Madhya Pradesh" },
  { value: "EPSG:7767", label: "EPSG:7767 / WGS 84 / Maharashtra" },
  { value: "EPSG:7768", label: "EPSG:7768 / WGS 84 / Manipur" },
  { value: "EPSG:7769", label: "EPSG:7769 / WGS 84 / Meghalaya" },
  { value: "EPSG:7770", label: "EPSG:7770 / WGS 84 / Nagaland" },
  { value: "EPSG:7771", label: "EPSG:7771 / WGS 84 / India Northeast" },
  { value: "EPSG:7772", label: "EPSG:7772 / WGS 84 / Orissa" },
  { value: "EPSG:7773", label: "EPSG:7773 / WGS 84 / Punjab" },
  { value: "EPSG:7774", label: "EPSG:7774 / WGS 84 / Rajasthan" },
  { value: "EPSG:7775", label: "EPSG:7775 / WGS 84 / Uttar Pradesh" },
  { value: "EPSG:7776", label: "EPSG:7776 / WGS 84 / Uttaranchal" },
  { value: "EPSG:7777", label: "EPSG:7777 / WGS 84 / Andaman and Nicobar" },
  { value: "EPSG:7778", label: "EPSG:7778 / WGS 84 / Chhattisgarh" },
  { value: "EPSG:7779", label: "EPSG:7779 / WGS 84 / Goa" },
  { value: "EPSG:7780", label: "EPSG:7780 / WGS 84 / Karnataka" },
  { value: "EPSG:7781", label: "EPSG:7781 / WGS 84 / Kerala" },
  { value: "EPSG:7782", label: "EPSG:7782 / WGS 84 / Lakshadweep" },
  { value: "EPSG:7783", label: "EPSG:7783 / WGS 84 / Mizoram" },
  { value: "EPSG:7784", label: "EPSG:7784 / WGS 84 / Sikkim" },
  { value: "EPSG:7785", label: "EPSG:7785 / WGS 84 / Tamil Nadu" },
  { value: "EPSG:7786", label: "EPSG:7786 / WGS 84 / Tripura" },
  { value: "EPSG:7787", label: "EPSG:7787 / WGS 84 / West Bengal" },
  { value: "EPSG:7791", label: "EPSG:7791 / RDN2008 / UTM zone 32N" },
  { value: "EPSG:7792", label: "EPSG:7792 / RDN2008 / UTM zone 33N" },
  { value: "EPSG:7793", label: "EPSG:7793 / RDN2008 / UTM zone 34N" },
  { value: "EPSG:7794", label: "EPSG:7794 / RDN2008 / Italy zone (E-N)" },
  { value: "EPSG:7795", label: "EPSG:7795 / RDN2008 / Zone 12 (E-N)" },
  { value: "EPSG:7799", label: "EPSG:7799 / BGS2005 / UTM zone 34N (N-E)" },
  { value: "EPSG:7800", label: "EPSG:7800 / BGS2005 / UTM zone 35N (N-E)" },
  { value: "EPSG:7801", label: "EPSG:7801 / BGS2005 / CCS2005" },
  { value: "EPSG:7803", label: "EPSG:7803 / BGS2005 / UTM zone 34N" },
  { value: "EPSG:7804", label: "EPSG:7804 / BGS2005 / UTM zone 35N" },
  { value: "EPSG:7805", label: "EPSG:7805 / BGS2005 / UTM zone 36N" },
  { value: "EPSG:7825", label: "EPSG:7825 / Pulkovo 1942 / CS63 zone X1" },
  { value: "EPSG:7826", label: "EPSG:7826 / Pulkovo 1942 / CS63 zone X2" },
  { value: "EPSG:7827", label: "EPSG:7827 / Pulkovo 1942 / CS63 zone X3" },
  { value: "EPSG:7828", label: "EPSG:7828 / Pulkovo 1942 / CS63 zone X4" },
  { value: "EPSG:7829", label: "EPSG:7829 / Pulkovo 1942 / CS63 zone X5" },
  { value: "EPSG:7830", label: "EPSG:7830 / Pulkovo 1942 / CS63 zone X6" },
  { value: "EPSG:7831", label: "EPSG:7831 / Pulkovo 1942 / CS63 zone X7" },
  { value: "EPSG:7845", label: "EPSG:7845 / GDA2020 / GA LCC" },
  { value: "EPSG:7846", label: "EPSG:7846 / GDA2020 / MGA zone 46" },
  { value: "EPSG:7847", label: "EPSG:7847 / GDA2020 / MGA zone 47" },
  { value: "EPSG:7848", label: "EPSG:7848 / GDA2020 / MGA zone 48" },
  { value: "EPSG:7849", label: "EPSG:7849 / GDA2020 / MGA zone 49" },
  { value: "EPSG:7850", label: "EPSG:7850 / GDA2020 / MGA zone 50" },
  { value: "EPSG:7851", label: "EPSG:7851 / GDA2020 / MGA zone 51" },
  { value: "EPSG:7852", label: "EPSG:7852 / GDA2020 / MGA zone 52" },
  { value: "EPSG:7853", label: "EPSG:7853 / GDA2020 / MGA zone 53" },
  { value: "EPSG:7854", label: "EPSG:7854 / GDA2020 / MGA zone 54" },
  { value: "EPSG:7855", label: "EPSG:7855 / GDA2020 / MGA zone 55" },
  { value: "EPSG:7856", label: "EPSG:7856 / GDA2020 / MGA zone 56" },
  { value: "EPSG:7857", label: "EPSG:7857 / GDA2020 / MGA zone 57" },
  { value: "EPSG:7858", label: "EPSG:7858 / GDA2020 / MGA zone 58" },
  { value: "EPSG:7859", label: "EPSG:7859 / GDA2020 / MGA zone 59" },
  { value: "EPSG:7877", label: "EPSG:7877 / Astro DOS 71 / SHLG71" },
  { value: "EPSG:7878", label: "EPSG:7878 / Astro DOS 71 / UTM zone 30S" },
  { value: "EPSG:7882", label: "EPSG:7882 / St. Helena Tritan / SHLG(Tritan)" },
  { value: "EPSG:7883", label: "EPSG:7883 / St. Helena Tritan / UTM zone 30S" },
  { value: "EPSG:7887", label: "EPSG:7887 / SHMG2015" },
  { value: "EPSG:7899", label: "EPSG:7899 / GDA2020 / Vicgrid" },
  { value: "EPSG:7991", label: "EPSG:7991 / NAD27 / MTM zone 10" },
  { value: "EPSG:7992", label: "EPSG:7992 / Malongo 1987 / UTM zone 33S" },
  { value: "EPSG:8013", label: "EPSG:8013 / GDA2020 / ALB2020" },
  { value: "EPSG:8014", label: "EPSG:8014 / GDA2020 / BIO2020" },
  { value: "EPSG:8015", label: "EPSG:8015 / GDA2020 / BRO2020" },
  { value: "EPSG:8016", label: "EPSG:8016 / GDA2020 / BCG2020" },
  { value: "EPSG:8017", label: "EPSG:8017 / GDA2020 / CARN2020" },
  { value: "EPSG:8018", label: "EPSG:8018 / GDA2020 / CIG2020" },
  { value: "EPSG:8019", label: "EPSG:8019 / GDA2020 / CKIG2020" },
  { value: "EPSG:8020", label: "EPSG:8020 / GDA2020 / COL2020" },
  { value: "EPSG:8021", label: "EPSG:8021 / GDA2020 / ESP2020" },
  { value: "EPSG:8022", label: "EPSG:8022 / GDA2020 / EXM2020" },
  { value: "EPSG:8023", label: "EPSG:8023 / GDA2020 / GCG2020" },
  { value: "EPSG:8024", label: "EPSG:8024 / GDA2020 / GOLD2020" },
  { value: "EPSG:8025", label: "EPSG:8025 / GDA2020 / JCG2020" },
  { value: "EPSG:8026", label: "EPSG:8026 / GDA2020 / KALB2020" },
  { value: "EPSG:8027", label: "EPSG:8027 / GDA2020 / KAR2020" },
  { value: "EPSG:8028", label: "EPSG:8028 / GDA2020 / KUN2020" },
  { value: "EPSG:8029", label: "EPSG:8029 / GDA2020 / LCG2020" },
  { value: "EPSG:8030", label: "EPSG:8030 / GDA2020 / MRCG2020" },
  { value: "EPSG:8031", label: "EPSG:8031 / GDA2020 / PCG2020" },
  { value: "EPSG:8032", label: "EPSG:8032 / GDA2020 / PHG2020" },
  { value: "EPSG:8035", label: "EPSG:8035 / WGS 84 / TM Zone 20N (ftUS)" },
  { value: "EPSG:8036", label: "EPSG:8036 / WGS 84 / TM Zone 21N (ftUS)" },
  { value: "EPSG:8044", label: "EPSG:8044 / Gusterberg Grid (Ferro)" },
  { value: "EPSG:8045", label: "EPSG:8045 / St. Stephen Grid (Ferro)" },
  { value: "EPSG:8058", label: "EPSG:8058 / GDA2020 / NSW Lambert" },
  { value: "EPSG:8059", label: "EPSG:8059 / GDA2020 / SA Lambert" },
  { value: "EPSG:8065", label: "EPSG:8065 / NAD83(2011) / PCCS zone 1 (ft)" },
  { value: "EPSG:8066", label: "EPSG:8066 / NAD83(2011) / PCCS zone 2 (ft)" },
  { value: "EPSG:8067", label: "EPSG:8067 / NAD83(2011) / PCCS zone 3 (ft)" },
  { value: "EPSG:8068", label: "EPSG:8068 / NAD83(2011) / PCCS zone 4 (ft)" },
  {
    value: "EPSG:8082",
    label: "EPSG:8082 / NAD83(CSRS)v6 / MTM NS 2010 zone 4",
  },
  {
    value: "EPSG:8083",
    label: "EPSG:8083 / NAD83(CSRS)v6 / MTM NS 2010 zone 5",
  },
  { value: "EPSG:8088", label: "EPSG:8088 / ISN2016 / Lambert 2016" },
  {
    value: "EPSG:8090",
    label: "EPSG:8090 / NAD83(HARN) / WISCRS Florence (m)",
  },
  {
    value: "EPSG:8091",
    label: "EPSG:8091 / NAD83(HARN) / WISCRS Florence (ftUS)",
  },
  {
    value: "EPSG:8092",
    label: "EPSG:8092 / NAD83(HARN) / WISCRS Eau Claire (m)",
  },
  {
    value: "EPSG:8093",
    label: "EPSG:8093 / NAD83(HARN) / WISCRS Eau Claire (ftUS)",
  },
  { value: "EPSG:8095", label: "EPSG:8095 / NAD83(HARN) / WISCRS Wood (m)" },
  { value: "EPSG:8096", label: "EPSG:8096 / NAD83(HARN) / WISCRS Wood (ftUS)" },
  {
    value: "EPSG:8097",
    label: "EPSG:8097 / NAD83(HARN) / WISCRS Waushara (m)",
  },
  {
    value: "EPSG:8098",
    label: "EPSG:8098 / NAD83(HARN) / WISCRS Waushara (ftUS)",
  },
  { value: "EPSG:8099", label: "EPSG:8099 / NAD83(HARN) / WISCRS Waupaca (m)" },
  {
    value: "EPSG:8100",
    label: "EPSG:8100 / NAD83(HARN) / WISCRS Waupaca (ftUS)",
  },
  {
    value: "EPSG:8101",
    label: "EPSG:8101 / NAD83(HARN) / WISCRS Waukesha (m)",
  },
  {
    value: "EPSG:8102",
    label: "EPSG:8102 / NAD83(HARN) / WISCRS Waukesha (ftUS)",
  },
  {
    value: "EPSG:8103",
    label: "EPSG:8103 / NAD83(HARN) / WISCRS Washington (m)",
  },
  {
    value: "EPSG:8104",
    label: "EPSG:8104 / NAD83(HARN) / WISCRS Washington (ftUS)",
  },
  {
    value: "EPSG:8105",
    label: "EPSG:8105 / NAD83(HARN) / WISCRS Washburn (m)",
  },
  {
    value: "EPSG:8106",
    label: "EPSG:8106 / NAD83(HARN) / WISCRS Washburn (ftUS)",
  },
  {
    value: "EPSG:8107",
    label: "EPSG:8107 / NAD83(HARN) / WISCRS Walworth (m)",
  },
  {
    value: "EPSG:8108",
    label: "EPSG:8108 / NAD83(HARN) / WISCRS Walworth (ftUS)",
  },
  { value: "EPSG:8109", label: "EPSG:8109 / NAD83(HARN) / WISCRS Vilas (m)" },
  {
    value: "EPSG:8110",
    label: "EPSG:8110 / NAD83(HARN) / WISCRS Vilas (ftUS)",
  },
  { value: "EPSG:8111", label: "EPSG:8111 / NAD83(HARN) / WISCRS Vernon (m)" },
  {
    value: "EPSG:8112",
    label: "EPSG:8112 / NAD83(HARN) / WISCRS Vernon (ftUS)",
  },
  {
    value: "EPSG:8113",
    label: "EPSG:8113 / NAD83(HARN) / WISCRS Trempealeau (m)",
  },
  {
    value: "EPSG:8114",
    label: "EPSG:8114 / NAD83(HARN) / WISCRS Trempealeau (ftUS)",
  },
  { value: "EPSG:8115", label: "EPSG:8115 / NAD83(HARN) / WISCRS Taylor (m)" },
  {
    value: "EPSG:8116",
    label: "EPSG:8116 / NAD83(HARN) / WISCRS Taylor (ftUS)",
  },
  {
    value: "EPSG:8117",
    label: "EPSG:8117 / NAD83(HARN) / WISCRS St. Croix (m)",
  },
  {
    value: "EPSG:8118",
    label: "EPSG:8118 / NAD83(HARN) / WISCRS St. Croix (ftUS)",
  },
  { value: "EPSG:8119", label: "EPSG:8119 / NAD83(HARN) / WISCRS Shawano (m)" },
  {
    value: "EPSG:8120",
    label: "EPSG:8120 / NAD83(HARN) / WISCRS Shawano (ftUS)",
  },
  { value: "EPSG:8121", label: "EPSG:8121 / NAD83(HARN) / WISCRS Sawyer (m)" },
  {
    value: "EPSG:8122",
    label: "EPSG:8122 / NAD83(HARN) / WISCRS Sawyer (ftUS)",
  },
  { value: "EPSG:8123", label: "EPSG:8123 / NAD83(HARN) / WISCRS Sauk (m)" },
  { value: "EPSG:8124", label: "EPSG:8124 / NAD83(HARN) / WISCRS Sauk (ftUS)" },
  { value: "EPSG:8125", label: "EPSG:8125 / NAD83(HARN) / WISCRS Rusk (m)" },
  { value: "EPSG:8126", label: "EPSG:8126 / NAD83(HARN) / WISCRS Rusk (ftUS)" },
  { value: "EPSG:8127", label: "EPSG:8127 / NAD83(HARN) / WISCRS Rock (m)" },
  { value: "EPSG:8128", label: "EPSG:8128 / NAD83(HARN) / WISCRS Rock (ftUS)" },
  {
    value: "EPSG:8129",
    label: "EPSG:8129 / NAD83(HARN) / WISCRS Richland (m)",
  },
  {
    value: "EPSG:8130",
    label: "EPSG:8130 / NAD83(HARN) / WISCRS Richland (ftUS)",
  },
  { value: "EPSG:8131", label: "EPSG:8131 / NAD83(HARN) / WISCRS Price (m)" },
  {
    value: "EPSG:8132",
    label: "EPSG:8132 / NAD83(HARN) / WISCRS Price (ftUS)",
  },
  { value: "EPSG:8133", label: "EPSG:8133 / NAD83(HARN) / WISCRS Portage (m)" },
  {
    value: "EPSG:8134",
    label: "EPSG:8134 / NAD83(HARN) / WISCRS Portage (ftUS)",
  },
  { value: "EPSG:8135", label: "EPSG:8135 / NAD83(HARN) / WISCRS Polk (m)" },
  { value: "EPSG:8136", label: "EPSG:8136 / NAD83(HARN) / WISCRS Polk (ftUS)" },
  {
    value: "EPSG:8137",
    label: "EPSG:8137 / NAD83(HARN) / WISCRS Pepin and Pierce (m)",
  },
  {
    value: "EPSG:8138",
    label: "EPSG:8138 / NAD83(HARN) / WISCRS Pepin and Pierce (ftUS)",
  },
  { value: "EPSG:8139", label: "EPSG:8139 / NAD83(HARN) / WISCRS Oneida (m)" },
  {
    value: "EPSG:8140",
    label: "EPSG:8140 / NAD83(HARN) / WISCRS Oneida (ftUS)",
  },
  { value: "EPSG:8141", label: "EPSG:8141 / NAD83(HARN) / WISCRS Oconto (m)" },
  {
    value: "EPSG:8142",
    label: "EPSG:8142 / NAD83(HARN) / WISCRS Oconto (ftUS)",
  },
  { value: "EPSG:8143", label: "EPSG:8143 / NAD83(HARN) / WISCRS Monroe (m)" },
  {
    value: "EPSG:8144",
    label: "EPSG:8144 / NAD83(HARN) / WISCRS Monroe (ftUS)",
  },
  {
    value: "EPSG:8145",
    label: "EPSG:8145 / NAD83(HARN) / WISCRS Menominee (m)",
  },
  {
    value: "EPSG:8146",
    label: "EPSG:8146 / NAD83(HARN) / WISCRS Menominee (ftUS)",
  },
  {
    value: "EPSG:8147",
    label: "EPSG:8147 / NAD83(HARN) / WISCRS Marinette (m)",
  },
  {
    value: "EPSG:8148",
    label: "EPSG:8148 / NAD83(HARN) / WISCRS Marinette (ftUS)",
  },
  {
    value: "EPSG:8149",
    label: "EPSG:8149 / NAD83(HARN) / WISCRS Marathon (m)",
  },
  {
    value: "EPSG:8150",
    label: "EPSG:8150 / NAD83(HARN) / WISCRS Marathon (ftUS)",
  },
  { value: "EPSG:8151", label: "EPSG:8151 / NAD83(HARN) / WISCRS Lincoln (m)" },
  {
    value: "EPSG:8152",
    label: "EPSG:8152 / NAD83(HARN) / WISCRS Lincoln (ftUS)",
  },
  {
    value: "EPSG:8153",
    label: "EPSG:8153 / NAD83(HARN) / WISCRS Langlade (m)",
  },
  {
    value: "EPSG:8154",
    label: "EPSG:8154 / NAD83(HARN) / WISCRS Langlade (ftUS)",
  },
  {
    value: "EPSG:8155",
    label: "EPSG:8155 / NAD83(HARN) / WISCRS La Crosse (m)",
  },
  {
    value: "EPSG:8156",
    label: "EPSG:8156 / NAD83(HARN) / WISCRS La Crosse (ftUS)",
  },
  {
    value: "EPSG:8157",
    label:
      "EPSG:8157 / NAD83(HARN) / WISCRS Kewaunee, Manitowoc and Sheboygan (m)",
  },
  {
    value: "EPSG:8158",
    label:
      "EPSG:8158 / NAD83(HARN) / WISCRS Kewaunee, Manitowoc and Sheboygan (ftUS)",
  },
  {
    value: "EPSG:8159",
    label:
      "EPSG:8159 / NAD83(HARN) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (m)",
  },
  {
    value: "EPSG:8160",
    label:
      "EPSG:8160 / NAD83(HARN) / WISCRS Kenosha, Milwaukee, Ozaukee and Racine (ftUS)",
  },
  { value: "EPSG:8161", label: "EPSG:8161 / NAD83(HARN) / WISCRS Jackson (m)" },
  {
    value: "EPSG:8162",
    label: "EPSG:8162 / NAD83(HARN) / WISCRS Jackson (ftUS)",
  },
  { value: "EPSG:8163", label: "EPSG:8163 / NAD83(HARN) / WISCRS Iron (m)" },
  { value: "EPSG:8164", label: "EPSG:8164 / NAD83(HARN) / WISCRS Iron (ftUS)" },
  { value: "EPSG:8165", label: "EPSG:8165 / NAD83(HARN) / WISCRS Iowa (m)" },
  { value: "EPSG:8166", label: "EPSG:8166 / NAD83(HARN) / WISCRS Iowa (ftUS)" },
  {
    value: "EPSG:8167",
    label: "EPSG:8167 / NAD83(HARN) / WISCRS Green Lake and Marquette (m)",
  },
  {
    value: "EPSG:8168",
    label: "EPSG:8168 / NAD83(HARN) / WISCRS Green Lake and Marquette (ftUS)",
  },
  {
    value: "EPSG:8169",
    label: "EPSG:8169 / NAD83(HARN) / WISCRS Green and Lafayette (m)",
  },
  {
    value: "EPSG:8170",
    label: "EPSG:8170 / NAD83(HARN) / WISCRS Green and Lafayette (ftUS)",
  },
  { value: "EPSG:8171", label: "EPSG:8171 / NAD83(HARN) / WISCRS Grant (m)" },
  {
    value: "EPSG:8172",
    label: "EPSG:8172 / NAD83(HARN) / WISCRS Grant (ftUS)",
  },
  { value: "EPSG:8173", label: "EPSG:8173 / NAD83(HARN) / WISCRS Forest (m)" },
  {
    value: "EPSG:8177",
    label: "EPSG:8177 / NAD83(HARN) / WISCRS Forest (ftUS)",
  },
  { value: "EPSG:8179", label: "EPSG:8179 / NAD83(HARN) / WISCRS Dunn (m)" },
  { value: "EPSG:8180", label: "EPSG:8180 / NAD83(HARN) / WISCRS Dunn (ftUS)" },
  { value: "EPSG:8181", label: "EPSG:8181 / NAD83(HARN) / WISCRS Douglas (m)" },
  {
    value: "EPSG:8182",
    label: "EPSG:8182 / NAD83(HARN) / WISCRS Douglas (ftUS)",
  },
  { value: "EPSG:8184", label: "EPSG:8184 / NAD83(HARN) / WISCRS Door (m)" },
  { value: "EPSG:8185", label: "EPSG:8185 / NAD83(HARN) / WISCRS Door (ftUS)" },
  {
    value: "EPSG:8187",
    label: "EPSG:8187 / NAD83(HARN) / WISCRS Dodge and Jefferson (m)",
  },
  {
    value: "EPSG:8189",
    label: "EPSG:8189 / NAD83(HARN) / WISCRS Dodge and Jefferson (ftUS)",
  },
  { value: "EPSG:8191", label: "EPSG:8191 / NAD83(HARN) / WISCRS Dane (m)" },
  { value: "EPSG:8193", label: "EPSG:8193 / NAD83(HARN) / WISCRS Dane (ftUS)" },
  {
    value: "EPSG:8196",
    label: "EPSG:8196 / NAD83(HARN) / WISCRS Crawford (m)",
  },
  {
    value: "EPSG:8197",
    label: "EPSG:8197 / NAD83(HARN) / WISCRS Crawford (ftUS)",
  },
  {
    value: "EPSG:8198",
    label: "EPSG:8198 / NAD83(HARN) / WISCRS Columbia (m)",
  },
  {
    value: "EPSG:8200",
    label: "EPSG:8200 / NAD83(HARN) / WISCRS Columbia (ftUS)",
  },
  { value: "EPSG:8201", label: "EPSG:8201 / NAD83(HARN) / WISCRS Clark (m)" },
  {
    value: "EPSG:8202",
    label: "EPSG:8202 / NAD83(HARN) / WISCRS Clark (ftUS)",
  },
  {
    value: "EPSG:8203",
    label: "EPSG:8203 / NAD83(HARN) / WISCRS Chippewa (m)",
  },
  {
    value: "EPSG:8204",
    label: "EPSG:8204 / NAD83(HARN) / WISCRS Chippewa (ftUS)",
  },
  {
    value: "EPSG:8205",
    label:
      "EPSG:8205 / NAD83(HARN) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (m)",
  },
  {
    value: "EPSG:8206",
    label:
      "EPSG:8206 / NAD83(HARN) / WISCRS Calumet, Fond du Lac, Outagamie and Winnebago (ftUS)",
  },
  { value: "EPSG:8207", label: "EPSG:8207 / NAD83(HARN) / WISCRS Burnett (m)" },
  {
    value: "EPSG:8208",
    label: "EPSG:8208 / NAD83(HARN) / WISCRS Burnett (ftUS)",
  },
  { value: "EPSG:8209", label: "EPSG:8209 / NAD83(HARN) / WISCRS Buffalo (m)" },
  {
    value: "EPSG:8210",
    label: "EPSG:8210 / NAD83(HARN) / WISCRS Buffalo (ftUS)",
  },
  { value: "EPSG:8212", label: "EPSG:8212 / NAD83(HARN) / WISCRS Brown (m)" },
  {
    value: "EPSG:8213",
    label: "EPSG:8213 / NAD83(HARN) / WISCRS Brown (ftUS)",
  },
  {
    value: "EPSG:8214",
    label: "EPSG:8214 / NAD83(HARN) / WISCRS Bayfield (m)",
  },
  {
    value: "EPSG:8216",
    label: "EPSG:8216 / NAD83(HARN) / WISCRS Bayfield (ftUS)",
  },
  { value: "EPSG:8218", label: "EPSG:8218 / NAD83(HARN) / WISCRS Barron (m)" },
  {
    value: "EPSG:8220",
    label: "EPSG:8220 / NAD83(HARN) / WISCRS Barron (ftUS)",
  },
  { value: "EPSG:8222", label: "EPSG:8222 / NAD83(HARN) / WISCRS Ashland (m)" },
  {
    value: "EPSG:8224",
    label: "EPSG:8224 / NAD83(HARN) / WISCRS Ashland (ftUS)",
  },
  {
    value: "EPSG:8225",
    label: "EPSG:8225 / NAD83(HARN) / WISCRS Adams and Juneau (m)",
  },
  {
    value: "EPSG:8226",
    label: "EPSG:8226 / NAD83(HARN) / WISCRS Adams and Juneau (ftUS)",
  },
  {
    value: "EPSG:8311",
    label: "EPSG:8311 / NAD83(2011) / Oregon Burns-Harper zone (m)",
  },
  {
    value: "EPSG:8312",
    label: "EPSG:8312 / NAD83(2011) / Oregon Burns-Harper zone (ft)",
  },
  {
    value: "EPSG:8313",
    label: "EPSG:8313 / NAD83(2011) / Oregon Canyon City-Burns zone (m)",
  },
  {
    value: "EPSG:8314",
    label: "EPSG:8314 / NAD83(2011) / Oregon Canyon City-Burns zone (ft)",
  },
  {
    value: "EPSG:8315",
    label: "EPSG:8315 / NAD83(2011) / Oregon Coast Range North zone (m)",
  },
  {
    value: "EPSG:8316",
    label: "EPSG:8316 / NAD83(2011) / Oregon Coast Range North zone (ft)",
  },
  {
    value: "EPSG:8317",
    label: "EPSG:8317 / NAD83(2011) / Oregon Dayville-Prairie City zone (m)",
  },
  {
    value: "EPSG:8318",
    label: "EPSG:8318 / NAD83(2011) / Oregon Dayville-Prairie City zone (ft)",
  },
  {
    value: "EPSG:8319",
    label: "EPSG:8319 / NAD83(2011) / Oregon Denio-Burns zone (m)",
  },
  {
    value: "EPSG:8320",
    label: "EPSG:8320 / NAD83(2011) / Oregon Denio-Burns zone (ft)",
  },
  {
    value: "EPSG:8321",
    label: "EPSG:8321 / NAD83(2011) / Oregon Halfway zone (m)",
  },
  {
    value: "EPSG:8322",
    label: "EPSG:8322 / NAD83(2011) / Oregon Halfway zone (ft)",
  },
  {
    value: "EPSG:8323",
    label: "EPSG:8323 / NAD83(2011) / Oregon Medford-Diamond Lake zone (m)",
  },
  {
    value: "EPSG:8324",
    label: "EPSG:8324 / NAD83(2011) / Oregon Medford-Diamond Lake zone (ft)",
  },
  {
    value: "EPSG:8325",
    label: "EPSG:8325 / NAD83(2011) / Oregon Mitchell zone (m)",
  },
  {
    value: "EPSG:8326",
    label: "EPSG:8326 / NAD83(2011) / Oregon Mitchell zone (ft)",
  },
  {
    value: "EPSG:8327",
    label: "EPSG:8327 / NAD83(2011) / Oregon North Central zone (m)",
  },
  {
    value: "EPSG:8328",
    label: "EPSG:8328 / NAD83(2011) / Oregon North Central zone (ft)",
  },
  {
    value: "EPSG:8329",
    label: "EPSG:8329 / NAD83(2011) / Oregon Ochoco Summit zone (m)",
  },
  {
    value: "EPSG:8330",
    label: "EPSG:8330 / NAD83(2011) / Oregon Ochoco Summit zone (ft)",
  },
  {
    value: "EPSG:8331",
    label: "EPSG:8331 / NAD83(2011) / Oregon Owyhee zone (m)",
  },
  {
    value: "EPSG:8332",
    label: "EPSG:8332 / NAD83(2011) / Oregon Owyhee zone (ft)",
  },
  {
    value: "EPSG:8333",
    label: "EPSG:8333 / NAD83(2011) / Oregon Pilot Rock-Ukiah zone (m)",
  },
  {
    value: "EPSG:8334",
    label: "EPSG:8334 / NAD83(2011) / Oregon Pilot Rock-Ukiah zone (ft)",
  },
  {
    value: "EPSG:8335",
    label: "EPSG:8335 / NAD83(2011) / Oregon Prairie City-Brogan zone (m)",
  },
  {
    value: "EPSG:8336",
    label: "EPSG:8336 / NAD83(2011) / Oregon Prairie City-Brogan zone (ft)",
  },
  {
    value: "EPSG:8337",
    label: "EPSG:8337 / NAD83(2011) / Oregon Riley-Lakeview zone (m)",
  },
  {
    value: "EPSG:8338",
    label: "EPSG:8338 / NAD83(2011) / Oregon Riley-Lakeview zone (ft)",
  },
  {
    value: "EPSG:8339",
    label: "EPSG:8339 / NAD83(2011) / Oregon Siskiyou Pass zone (m)",
  },
  {
    value: "EPSG:8340",
    label: "EPSG:8340 / NAD83(2011) / Oregon Siskiyou Pass zone (ft)",
  },
  {
    value: "EPSG:8341",
    label: "EPSG:8341 / NAD83(2011) / Oregon Ukiah-Fox zone (m)",
  },
  {
    value: "EPSG:8342",
    label: "EPSG:8342 / NAD83(2011) / Oregon Ukiah-Fox zone (ft)",
  },
  {
    value: "EPSG:8343",
    label: "EPSG:8343 / NAD83(2011) / Oregon Wallowa zone (m)",
  },
  {
    value: "EPSG:8344",
    label: "EPSG:8344 / NAD83(2011) / Oregon Wallowa zone (ft)",
  },
  {
    value: "EPSG:8345",
    label: "EPSG:8345 / NAD83(2011) / Oregon Warner Highway zone (m)",
  },
  {
    value: "EPSG:8346",
    label: "EPSG:8346 / NAD83(2011) / Oregon Warner Highway zone (ft)",
  },
  {
    value: "EPSG:8347",
    label: "EPSG:8347 / NAD83(2011) / Oregon Willamette Pass zone (m)",
  },
  {
    value: "EPSG:8348",
    label: "EPSG:8348 / NAD83(2011) / Oregon Willamette Pass zone (ft)",
  },
  { value: "EPSG:8352", label: "EPSG:8352 / S-JTSK [JTSK03] / Krovak" },
  {
    value: "EPSG:8353",
    label: "EPSG:8353 / S-JTSK [JTSK03] / Krovak East North",
  },
  { value: "EPSG:8379", label: "EPSG:8379 / NAD83 / NCRS Las Vegas (m)" },
  { value: "EPSG:8380", label: "EPSG:8380 / NAD83 / NCRS Las Vegas (ftUS)" },
  { value: "EPSG:8381", label: "EPSG:8381 / NAD83 / NCRS Las Vegas high (m)" },
  {
    value: "EPSG:8382",
    label: "EPSG:8382 / NAD83 / NCRS Las Vegas high (ftUS)",
  },
  { value: "EPSG:8383", label: "EPSG:8383 / NAD83(2011) / NCRS Las Vegas (m)" },
  {
    value: "EPSG:8384",
    label: "EPSG:8384 / NAD83(2011) / NCRS Las Vegas (ftUS)",
  },
  {
    value: "EPSG:8385",
    label: "EPSG:8385 / NAD83(2011) / NCRS Las Vegas high (m)",
  },
  {
    value: "EPSG:8387",
    label: "EPSG:8387 / NAD83(2011) / NCRS Las Vegas high (ftUS)",
  },
  { value: "EPSG:8391", label: "EPSG:8391 / GDA94 / WEIPA94" },
  { value: "EPSG:8395", label: "EPSG:8395 / ETRS89 / Gauss-Kruger CM 9E" },
  { value: "EPSG:8433", label: "EPSG:8433 / Macao 1920 / Macao Grid" },
  { value: "EPSG:8441", label: "EPSG:8441 / Tananarive / Laborde Grid" },
  { value: "EPSG:8455", label: "EPSG:8455 / RGTAAF07 / UTM zone 53S" },
  { value: "EPSG:8456", label: "EPSG:8456 / RGTAAF07 / UTM zone 54S" },
  { value: "EPSG:8518", label: "EPSG:8518 / NAD83(2011) / KS RCS zone 1" },
  { value: "EPSG:8519", label: "EPSG:8519 / NAD83(2011) / KS RCS zone 2" },
  { value: "EPSG:8520", label: "EPSG:8520 / NAD83(2011) / KS RCS zone 3" },
  { value: "EPSG:8521", label: "EPSG:8521 / NAD83(2011) / KS RCS zone 4" },
  { value: "EPSG:8522", label: "EPSG:8522 / NAD83(2011) / KS RCS zone 5" },
  { value: "EPSG:8523", label: "EPSG:8523 / NAD83(2011) / KS RCS zone 6" },
  { value: "EPSG:8524", label: "EPSG:8524 / NAD83(2011) / KS RCS zone 7" },
  { value: "EPSG:8525", label: "EPSG:8525 / NAD83(2011) / KS RCS zone 8" },
  { value: "EPSG:8526", label: "EPSG:8526 / NAD83(2011) / KS RCS zone 9" },
  { value: "EPSG:8527", label: "EPSG:8527 / NAD83(2011) / KS RCS zone 10" },
  { value: "EPSG:8528", label: "EPSG:8528 / NAD83(2011) / KS RCS zone 11" },
  { value: "EPSG:8529", label: "EPSG:8529 / NAD83(2011) / KS RCS zone 12" },
  { value: "EPSG:8531", label: "EPSG:8531 / NAD83(2011) / KS RCS zone 13" },
  { value: "EPSG:8533", label: "EPSG:8533 / NAD83(2011) / KS RCS zone 14" },
  { value: "EPSG:8534", label: "EPSG:8534 / NAD83(2011) / KS RCS zone 15" },
  { value: "EPSG:8535", label: "EPSG:8535 / NAD83(2011) / KS RCS zone 16" },
  { value: "EPSG:8536", label: "EPSG:8536 / NAD83(2011) / KS RCS zone 17" },
  { value: "EPSG:8538", label: "EPSG:8538 / NAD83(2011) / KS RCS zone 18" },
  { value: "EPSG:8539", label: "EPSG:8539 / NAD83(2011) / KS RCS zone 19" },
  { value: "EPSG:8540", label: "EPSG:8540 / NAD83(2011) / KS RCS zone 20" },
  { value: "EPSG:8677", label: "EPSG:8677 / MGI 1901 / Balkans zone 5" },
  { value: "EPSG:8678", label: "EPSG:8678 / MGI 1901 / Balkans zone 6" },
  { value: "EPSG:8679", label: "EPSG:8679 / MGI 1901 / Balkans zone 8" },
  { value: "EPSG:8682", label: "EPSG:8682 / SRB_ETRS89 / UTM zone 34N" },
  { value: "EPSG:8686", label: "EPSG:8686 / MGI 1901 / Slovenia Grid" },
  { value: "EPSG:8687", label: "EPSG:8687 / Slovenia 1996 / UTM zone 33N" },
  { value: "EPSG:8692", label: "EPSG:8692 / NAD83(MA11) / UTM zone 54N" },
  { value: "EPSG:8693", label: "EPSG:8693 / NAD83(MA11) / UTM zone 55N" },
  {
    value: "EPSG:8826",
    label: "EPSG:8826 / NAD83 / Idaho Transverse Mercator",
  },
  { value: "EPSG:8836", label: "EPSG:8836 / MTRF-2000 / UTM zone 36N" },
  { value: "EPSG:8837", label: "EPSG:8837 / MTRF-2000 / UTM zone 37N" },
  { value: "EPSG:8838", label: "EPSG:8838 / MTRF-2000 / UTM zone 38N" },
  { value: "EPSG:8839", label: "EPSG:8839 / MTRF-2000 / UTM zone 39N" },
  { value: "EPSG:8840", label: "EPSG:8840 / MTRF-2000 / UTM zone 40N" },
  { value: "EPSG:8857", label: "EPSG:8857 / WGS 84 / Equal Earth Greenwich" },
  { value: "EPSG:8858", label: "EPSG:8858 / WGS 84 / Equal Earth Americas" },
  {
    value: "EPSG:8859",
    label: "EPSG:8859 / WGS 84 / Equal Earth Asia-Pacific",
  },
  { value: "EPSG:8903", label: "EPSG:8903 / RGWF96 / UTM zone 1S" },
  { value: "EPSG:8908", label: "EPSG:8908 / CR-SIRGAS / CRTM05" },
  { value: "EPSG:8909", label: "EPSG:8909 / CR-SIRGAS / UTM zone 16N" },
  { value: "EPSG:8910", label: "EPSG:8910 / CR-SIRGAS / UTM zone 17N" },
  { value: "EPSG:8950", label: "EPSG:8950 / SIRGAS-Chile 2010 / UTM zone 18S" },
  { value: "EPSG:8951", label: "EPSG:8951 / SIRGAS-Chile 2010 / UTM zone 19S" },
  { value: "EPSG:9039", label: "EPSG:9039 / ISN2016 / LAEA Europe" },
  { value: "EPSG:9040", label: "EPSG:9040 / ISN2016 / LCC Europe" },
  { value: "EPSG:9141", label: "EPSG:9141 / KOSOVAREF01 / Balkans zone 7" },
  { value: "EPSG:9149", label: "EPSG:9149 / SIRGAS-Chile 2013 / UTM zone 18S" },
  { value: "EPSG:9150", label: "EPSG:9150 / SIRGAS-Chile 2013 / UTM zone 19S" },
  { value: "EPSG:9154", label: "EPSG:9154 / SIRGAS-Chile 2016 / UTM zone 18S" },
  { value: "EPSG:9155", label: "EPSG:9155 / SIRGAS-Chile 2016 / UTM zone 19S" },
  { value: "EPSG:9156", label: "EPSG:9156 / RSAO13 / UTM zone 32S" },
  { value: "EPSG:9157", label: "EPSG:9157 / RSAO13 / UTM zone 33S" },
  { value: "EPSG:9158", label: "EPSG:9158 / RSAO13 / UTM zone 34S" },
  { value: "EPSG:9159", label: "EPSG:9159 / RSAO13 / TM 12 SE" },
  { value: "EPSG:9191", label: "EPSG:9191 / WGS 84 / NIWA Albers" },
  { value: "EPSG:9205", label: "EPSG:9205 / VN-2000 / TM-3 103-00" },
  { value: "EPSG:9206", label: "EPSG:9206 / VN-2000 / TM-3 104-00" },
  { value: "EPSG:9207", label: "EPSG:9207 / VN-2000 / TM-3 104-30" },
  { value: "EPSG:9208", label: "EPSG:9208 / VN-2000 / TM-3 104-45" },
  { value: "EPSG:9209", label: "EPSG:9209 / VN-2000 / TM-3 105-30" },
  { value: "EPSG:9210", label: "EPSG:9210 / VN-2000 / TM-3 105-45" },
  { value: "EPSG:9211", label: "EPSG:9211 / VN-2000 / TM-3 106-00" },
  { value: "EPSG:9212", label: "EPSG:9212 / VN-2000 / TM-3 106-15" },
  { value: "EPSG:9213", label: "EPSG:9213 / VN-2000 / TM-3 106-30" },
  { value: "EPSG:9214", label: "EPSG:9214 / VN-2000 / TM-3 107-00" },
  { value: "EPSG:9215", label: "EPSG:9215 / VN-2000 / TM-3 107-15" },
  { value: "EPSG:9216", label: "EPSG:9216 / VN-2000 / TM-3 107-30" },
  { value: "EPSG:9217", label: "EPSG:9217 / VN-2000 / TM-3 108-15" },
  { value: "EPSG:9218", label: "EPSG:9218 / VN-2000 / TM-3 108-30" },
  {
    value: "EPSG:9221",
    label: "EPSG:9221 / Hartebeesthoek94 / ZAF BSU Albers 25E",
  },
  {
    value: "EPSG:9222",
    label: "EPSG:9222 / Hartebeesthoek94 / ZAF BSU Albers 44E",
  },
  { value: "EPSG:9249", label: "EPSG:9249 / Tapi Aike / Argentina 1" },
  { value: "EPSG:9250", label: "EPSG:9250 / Tapi Aike / Argentina 2" },
  { value: "EPSG:9252", label: "EPSG:9252 / MMN / Argentina 2" },
  { value: "EPSG:9254", label: "EPSG:9254 / MMS / Argentina 2" },
  { value: "EPSG:9265", label: "EPSG:9265 / POSGAR 2007 / UTM zone 19S" },
  { value: "EPSG:9271", label: "EPSG:9271 / MGI / Austria West" },
  { value: "EPSG:9272", label: "EPSG:9272 / MGI / Austria Central" },
  { value: "EPSG:9273", label: "EPSG:9273 / MGI / Austria East" },
  { value: "EPSG:9284", label: "EPSG:9284 / Pampa del Castillo / Argentina 1" },
  { value: "EPSG:9285", label: "EPSG:9285 / Pampa del Castillo / Argentina 3" },
  { value: "EPSG:9295", label: "EPSG:9295 / ONGD17 / UTM zone 39N" },
  { value: "EPSG:9296", label: "EPSG:9296 / ONGD17 / UTM zone 40N" },
  { value: "EPSG:9297", label: "EPSG:9297 / ONGD17 / UTM zone 41N" },
  { value: "EPSG:9300", label: "EPSG:9300 / HS2 Survey Grid" },
  {
    value: "EPSG:9311",
    label: "EPSG:9311 / NAD27 / US National Atlas Equal Area",
  },
  {
    value: "EPSG:9354",
    label: "EPSG:9354 / WGS 84 / IBCSO Polar Stereographic",
  },
  { value: "EPSG:9356", label: "EPSG:9356 / KSA-GRF17 / UTM zone 36N" },
  { value: "EPSG:9357", label: "EPSG:9357 / KSA-GRF17 / UTM zone 37N" },
  { value: "EPSG:9358", label: "EPSG:9358 / KSA-GRF17 / UTM zone 38N" },
  { value: "EPSG:9359", label: "EPSG:9359 / KSA-GRF17 / UTM zone 39N" },
  { value: "EPSG:9360", label: "EPSG:9360 / KSA-GRF17 / UTM zone 40N" },
  { value: "EPSG:9367", label: "EPSG:9367 / TPEN11 Grid" },
  { value: "EPSG:9373", label: "EPSG:9373 / MML07 Grid" },
  { value: "EPSG:9377", label: "EPSG:9377 / MAGNA-SIRGAS / Origen-Nacional" },
  { value: "EPSG:9387", label: "EPSG:9387 / AbInvA96_2020 Grid" },
  { value: "EPSG:9391", label: "EPSG:9391 / BGS2005 / UTM zone 35N" },
  { value: "EPSG:9404", label: "EPSG:9404 / PN68 / UTM zone 27N" },
  { value: "EPSG:9405", label: "EPSG:9405 / PN68 / UTM zone 28N" },
  { value: "EPSG:9406", label: "EPSG:9406 / PN84 / UTM zone 27N" },
  { value: "EPSG:9407", label: "EPSG:9407 / PN84 / UTM zone 28N" },
  { value: "EPSG:9456", label: "EPSG:9456 / GBK19 Grid" },
  { value: "EPSG:9473", label: "EPSG:9473 / GDA2020 / Australian Albers" },
  { value: "EPSG:9476", label: "EPSG:9476 / SRGI2013 / UTM zone 46N" },
  { value: "EPSG:9477", label: "EPSG:9477 / SRGI2013 / UTM zone 47N" },
  { value: "EPSG:9478", label: "EPSG:9478 / SRGI2013 / UTM zone 48N" },
  { value: "EPSG:9479", label: "EPSG:9479 / SRGI2013 / UTM zone 49N" },
  { value: "EPSG:9480", label: "EPSG:9480 / SRGI2013 / UTM zone 50N" },
  { value: "EPSG:9481", label: "EPSG:9481 / SRGI2013 / UTM zone 51N" },
  { value: "EPSG:9482", label: "EPSG:9482 / SRGI2013 / UTM zone 52N" },
  { value: "EPSG:9487", label: "EPSG:9487 / SRGI2013 / UTM zone 47S" },
  { value: "EPSG:9488", label: "EPSG:9488 / SRGI2013 / UTM zone 48S" },
  { value: "EPSG:9489", label: "EPSG:9489 / SRGI2013 / UTM zone 49S" },
  { value: "EPSG:9490", label: "EPSG:9490 / SRGI2013 / UTM zone 50S" },
  { value: "EPSG:9491", label: "EPSG:9491 / SRGI2013 / UTM zone 51S" },
  { value: "EPSG:9492", label: "EPSG:9492 / SRGI2013 / UTM zone 52S" },
  { value: "EPSG:9493", label: "EPSG:9493 / SRGI2013 / UTM zone 53S" },
  { value: "EPSG:9494", label: "EPSG:9494 / SRGI2013 / UTM zone 54S" },
  { value: "EPSG:9498", label: "EPSG:9498 / POSGAR 2007 / CABA 2019" },
  { value: "EPSG:9674", label: "EPSG:9674 / NAD83 / USFS R6 Albers" },
  {
    value: "EPSG:9678",
    label: "EPSG:9678 / Gulshan 303 / Bangladesh Transverse Mercator",
  },
  { value: "EPSG:9680", label: "EPSG:9680 / WGS 84 / TM 90 NE" },
  { value: "EPSG:9697", label: "EPSG:9697 / REDGEOMIN / UTM zone 12S" },
  { value: "EPSG:9698", label: "EPSG:9698 / REDGEOMIN / UTM zone 18S" },
  { value: "EPSG:9699", label: "EPSG:9699 / REDGEOMIN / UTM zone 19S" },
  { value: "EPSG:9709", label: "EPSG:9709 / NAD83(CSRS) / UTM zone 23N" },
  { value: "EPSG:9712", label: "EPSG:9712 / NAD83 / UTM zone 24N" },
  { value: "EPSG:9713", label: "EPSG:9713 / NAD83(CSRS) / UTM zone 24N" },
  { value: "EPSG:9716", label: "EPSG:9716 / IGM95 / UTM zone 34N" },
  { value: "EPSG:9741", label: "EPSG:9741 / EOS21 Grid" },
  {
    value: "EPSG:9748",
    label: "EPSG:9748 / NAD83(2011) / Alabama East (ftUS)",
  },
  {
    value: "EPSG:9749",
    label: "EPSG:9749 / NAD83(2011) / Alabama West (ftUS)",
  },
  { value: "EPSG:9761", label: "EPSG:9761 / ECML14_NB Grid" },
  { value: "EPSG:9766", label: "EPSG:9766 / EWR2 Grid" },
  { value: "EPSG:9793", label: "EPSG:9793 / RGF93 v2 / Lambert-93" },
  { value: "EPSG:9794", label: "EPSG:9794 / RGF93 v2b / Lambert-93" },
  { value: "EPSG:9821", label: "EPSG:9821 / UCS-2000 / LCS-32 Kyiv region" },
  { value: "EPSG:9822", label: "EPSG:9822 / RGF93 v2 / CC42" },
  { value: "EPSG:9823", label: "EPSG:9823 / RGF93 v2 / CC43" },
  { value: "EPSG:9824", label: "EPSG:9824 / RGF93 v2 / CC44" },
  { value: "EPSG:9825", label: "EPSG:9825 / RGF93 v2 / CC45" },
  { value: "EPSG:9826", label: "EPSG:9826 / RGF93 v2 / CC46" },
  { value: "EPSG:9827", label: "EPSG:9827 / RGF93 v2 / CC47" },
  { value: "EPSG:9828", label: "EPSG:9828 / RGF93 v2 / CC48" },
  { value: "EPSG:9829", label: "EPSG:9829 / RGF93 v2 / CC49" },
  { value: "EPSG:9830", label: "EPSG:9830 / RGF93 v2 / CC50" },
  { value: "EPSG:9831", label: "EPSG:9831 / UCS-2000 / LCS-01 Crimea" },
  { value: "EPSG:9832", label: "EPSG:9832 / UCS-2000 / LCS-05 Vinnytsia" },
  { value: "EPSG:9833", label: "EPSG:9833 / UCS-2000 / LCS-07 Volyn" },
  { value: "EPSG:9834", label: "EPSG:9834 / UCS-2000 / LCS-12 Dnipropetrovsk" },
  { value: "EPSG:9835", label: "EPSG:9835 / UCS-2000 / LCS-14 Donetsk" },
  { value: "EPSG:9836", label: "EPSG:9836 / UCS-2000 / LCS-18 Zhytomyr" },
  { value: "EPSG:9837", label: "EPSG:9837 / UCS-2000 / LCS-21 Zakarpattia" },
  { value: "EPSG:9838", label: "EPSG:9838 / UCS-2000 / LCS-23 Zaporizhzhia" },
  {
    value: "EPSG:9839",
    label: "EPSG:9839 / UCS-2000 / LCS-26 Ivano-Frankivsk",
  },
  { value: "EPSG:9840", label: "EPSG:9840 / UCS-2000 / LCS-35 Kirovohrad" },
  { value: "EPSG:9841", label: "EPSG:9841 / UCS-2000 / LCS-44 Luhansk" },
  { value: "EPSG:9842", label: "EPSG:9842 / RGF93 v2b / CC42" },
  { value: "EPSG:9843", label: "EPSG:9843 / RGF93 v2b / CC43" },
  { value: "EPSG:9844", label: "EPSG:9844 / RGF93 v2b / CC44" },
  { value: "EPSG:9845", label: "EPSG:9845 / RGF93 v2b / CC45" },
  { value: "EPSG:9846", label: "EPSG:9846 / RGF93 v2b / CC46" },
  { value: "EPSG:9847", label: "EPSG:9847 / RGF93 v2b / CC47" },
  { value: "EPSG:9848", label: "EPSG:9848 / RGF93 v2b / CC48" },
  { value: "EPSG:9849", label: "EPSG:9849 / RGF93 v2b / CC49" },
  { value: "EPSG:9850", label: "EPSG:9850 / RGF93 v2b / CC50" },
  { value: "EPSG:9851", label: "EPSG:9851 / UCS-2000 / LCS-46 Lviv" },
  { value: "EPSG:9852", label: "EPSG:9852 / UCS-2000 / LCS-48 Mykolaiv" },
  { value: "EPSG:9853", label: "EPSG:9853 / UCS-2000 / LCS-51 Odessa" },
  { value: "EPSG:9854", label: "EPSG:9854 / UCS-2000 / LCS-53 Poltava" },
  { value: "EPSG:9855", label: "EPSG:9855 / UCS-2000 / LCS-56 Rivne" },
  { value: "EPSG:9856", label: "EPSG:9856 / UCS-2000 / LCS-59 Sumy" },
  { value: "EPSG:9857", label: "EPSG:9857 / UCS-2000 / LCS-61 Ternopil" },
  { value: "EPSG:9858", label: "EPSG:9858 / UCS-2000 / LCS-63 Kharkiv" },
  { value: "EPSG:9859", label: "EPSG:9859 / UCS-2000 / LCS-65 Kherson" },
  { value: "EPSG:9860", label: "EPSG:9860 / UCS-2000 / LCS-68 Khmelnytsky" },
  { value: "EPSG:9861", label: "EPSG:9861 / UCS-2000 / LCS-71 Cherkasy" },
  { value: "EPSG:9862", label: "EPSG:9862 / UCS-2000 / LCS-73 Chernivtsi" },
  { value: "EPSG:9863", label: "EPSG:9863 / UCS-2000 / LCS-74 Chernihiv" },
  { value: "EPSG:9864", label: "EPSG:9864 / UCS-2000 / LCS-80 Kyiv city" },
  { value: "EPSG:9865", label: "EPSG:9865 / UCS-2000 / LCS-85 Sevastopol" },
  { value: "EPSG:9869", label: "EPSG:9869 / MRH21 Grid" },
  { value: "EPSG:9874", label: "EPSG:9874 / PNG94 / PNGMG94 zone 57" },
  { value: "EPSG:9875", label: "EPSG:9875 / PNG94 / PNGMG94 zone 58" },
  { value: "EPSG:9880", label: "EPSG:9880 / MOLDOR11 Grid" },
  { value: "EPSG:9895", label: "EPSG:9895 / LUREF / Luxembourg TM (3D)" },
  { value: "EPSG:9943", label: "EPSG:9943 / EBBWV14 Grid" },
  {
    value: "EPSG:9945",
    label: "EPSG:9945 / Macedonia State Coordinate System truncated",
  },
  { value: "EPSG:9947", label: "EPSG:9947 / ISN2004 / LAEA Iceland" },
  { value: "EPSG:9967", label: "EPSG:9967 / HULLEE13 Grid" },
  { value: "EPSG:9972", label: "EPSG:9972 / SCM22 Grid" },
  { value: "EPSG:9977", label: "EPSG:9977 / FNL22 Grid" },
  { value: "EPSG:20002", label: "EPSG:20002 / MWC18 Grid" },
  {
    value: "EPSG:20004",
    label: "EPSG:20004 / Pulkovo 1995 / Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:20005",
    label: "EPSG:20005 / Pulkovo 1995 / Gauss-Kruger zone 5",
  },
  {
    value: "EPSG:20006",
    label: "EPSG:20006 / Pulkovo 1995 / Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:20007",
    label: "EPSG:20007 / Pulkovo 1995 / Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:20008",
    label: "EPSG:20008 / Pulkovo 1995 / Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:20009",
    label: "EPSG:20009 / Pulkovo 1995 / Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:20010",
    label: "EPSG:20010 / Pulkovo 1995 / Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:20011",
    label: "EPSG:20011 / Pulkovo 1995 / Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:20012",
    label: "EPSG:20012 / Pulkovo 1995 / Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:20013",
    label: "EPSG:20013 / Pulkovo 1995 / Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:20014",
    label: "EPSG:20014 / Pulkovo 1995 / Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:20015",
    label: "EPSG:20015 / Pulkovo 1995 / Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:20016",
    label: "EPSG:20016 / Pulkovo 1995 / Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:20017",
    label: "EPSG:20017 / Pulkovo 1995 / Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:20018",
    label: "EPSG:20018 / Pulkovo 1995 / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:20019",
    label: "EPSG:20019 / Pulkovo 1995 / Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:20020",
    label: "EPSG:20020 / Pulkovo 1995 / Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:20021",
    label: "EPSG:20021 / Pulkovo 1995 / Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:20022",
    label: "EPSG:20022 / Pulkovo 1995 / Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:20023",
    label: "EPSG:20023 / Pulkovo 1995 / Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:20024",
    label: "EPSG:20024 / Pulkovo 1995 / Gauss-Kruger zone 24",
  },
  {
    value: "EPSG:20025",
    label: "EPSG:20025 / Pulkovo 1995 / Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:20026",
    label: "EPSG:20026 / Pulkovo 1995 / Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:20027",
    label: "EPSG:20027 / Pulkovo 1995 / Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:20028",
    label: "EPSG:20028 / Pulkovo 1995 / Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:20029",
    label: "EPSG:20029 / Pulkovo 1995 / Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:20030",
    label: "EPSG:20030 / Pulkovo 1995 / Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:20031",
    label: "EPSG:20031 / Pulkovo 1995 / Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:20032",
    label: "EPSG:20032 / Pulkovo 1995 / Gauss-Kruger zone 32",
  },
  {
    value: "EPSG:20042",
    label: "EPSG:20042 / SIRGAS-Chile 2021 / UTM zone 12S",
  },
  {
    value: "EPSG:20048",
    label: "EPSG:20048 / SIRGAS-Chile 2021 / UTM zone 18S",
  },
  {
    value: "EPSG:20049",
    label: "EPSG:20049 / SIRGAS-Chile 2021 / UTM zone 19S",
  },
  { value: "EPSG:20064", label: "EPSG:20064 / Pulkovo 1995 / Gauss-Kruger 4N" },
  { value: "EPSG:20065", label: "EPSG:20065 / Pulkovo 1995 / Gauss-Kruger 5N" },
  { value: "EPSG:20066", label: "EPSG:20066 / Pulkovo 1995 / Gauss-Kruger 6N" },
  { value: "EPSG:20067", label: "EPSG:20067 / Pulkovo 1995 / Gauss-Kruger 7N" },
  { value: "EPSG:20068", label: "EPSG:20068 / Pulkovo 1995 / Gauss-Kruger 8N" },
  { value: "EPSG:20069", label: "EPSG:20069 / Pulkovo 1995 / Gauss-Kruger 9N" },
  {
    value: "EPSG:20070",
    label: "EPSG:20070 / Pulkovo 1995 / Gauss-Kruger 10N",
  },
  {
    value: "EPSG:20071",
    label: "EPSG:20071 / Pulkovo 1995 / Gauss-Kruger 11N",
  },
  {
    value: "EPSG:20072",
    label: "EPSG:20072 / Pulkovo 1995 / Gauss-Kruger 12N",
  },
  {
    value: "EPSG:20073",
    label: "EPSG:20073 / Pulkovo 1995 / Gauss-Kruger 13N",
  },
  {
    value: "EPSG:20074",
    label: "EPSG:20074 / Pulkovo 1995 / Gauss-Kruger 14N",
  },
  {
    value: "EPSG:20075",
    label: "EPSG:20075 / Pulkovo 1995 / Gauss-Kruger 15N",
  },
  {
    value: "EPSG:20076",
    label: "EPSG:20076 / Pulkovo 1995 / Gauss-Kruger 16N",
  },
  {
    value: "EPSG:20077",
    label: "EPSG:20077 / Pulkovo 1995 / Gauss-Kruger 17N",
  },
  {
    value: "EPSG:20078",
    label: "EPSG:20078 / Pulkovo 1995 / Gauss-Kruger 18N",
  },
  {
    value: "EPSG:20079",
    label: "EPSG:20079 / Pulkovo 1995 / Gauss-Kruger 19N",
  },
  {
    value: "EPSG:20080",
    label: "EPSG:20080 / Pulkovo 1995 / Gauss-Kruger 20N",
  },
  {
    value: "EPSG:20081",
    label: "EPSG:20081 / Pulkovo 1995 / Gauss-Kruger 21N",
  },
  {
    value: "EPSG:20082",
    label: "EPSG:20082 / Pulkovo 1995 / Gauss-Kruger 22N",
  },
  {
    value: "EPSG:20083",
    label: "EPSG:20083 / Pulkovo 1995 / Gauss-Kruger 23N",
  },
  {
    value: "EPSG:20084",
    label: "EPSG:20084 / Pulkovo 1995 / Gauss-Kruger 24N",
  },
  {
    value: "EPSG:20085",
    label: "EPSG:20085 / Pulkovo 1995 / Gauss-Kruger 25N",
  },
  {
    value: "EPSG:20086",
    label: "EPSG:20086 / Pulkovo 1995 / Gauss-Kruger 26N",
  },
  {
    value: "EPSG:20087",
    label: "EPSG:20087 / Pulkovo 1995 / Gauss-Kruger 27N",
  },
  {
    value: "EPSG:20088",
    label: "EPSG:20088 / Pulkovo 1995 / Gauss-Kruger 28N",
  },
  {
    value: "EPSG:20089",
    label: "EPSG:20089 / Pulkovo 1995 / Gauss-Kruger 29N",
  },
  {
    value: "EPSG:20090",
    label: "EPSG:20090 / Pulkovo 1995 / Gauss-Kruger 30N",
  },
  {
    value: "EPSG:20091",
    label: "EPSG:20091 / Pulkovo 1995 / Gauss-Kruger 31N",
  },
  {
    value: "EPSG:20092",
    label: "EPSG:20092 / Pulkovo 1995 / Gauss-Kruger 32N",
  },
  { value: "EPSG:20135", label: "EPSG:20135 / Adindan / UTM zone 35N" },
  { value: "EPSG:20136", label: "EPSG:20136 / Adindan / UTM zone 36N" },
  { value: "EPSG:20137", label: "EPSG:20137 / Adindan / UTM zone 37N" },
  { value: "EPSG:20138", label: "EPSG:20138 / Adindan / UTM zone 38N" },
  { value: "EPSG:20248", label: "EPSG:20248 / AGD66 / AMG zone 48" },
  { value: "EPSG:20249", label: "EPSG:20249 / AGD66 / AMG zone 49" },
  { value: "EPSG:20250", label: "EPSG:20250 / AGD66 / AMG zone 50" },
  { value: "EPSG:20251", label: "EPSG:20251 / AGD66 / AMG zone 51" },
  { value: "EPSG:20252", label: "EPSG:20252 / AGD66 / AMG zone 52" },
  { value: "EPSG:20253", label: "EPSG:20253 / AGD66 / AMG zone 53" },
  { value: "EPSG:20254", label: "EPSG:20254 / AGD66 / AMG zone 54" },
  { value: "EPSG:20255", label: "EPSG:20255 / AGD66 / AMG zone 55" },
  { value: "EPSG:20256", label: "EPSG:20256 / AGD66 / AMG zone 56" },
  { value: "EPSG:20257", label: "EPSG:20257 / AGD66 / AMG zone 57" },
  { value: "EPSG:20258", label: "EPSG:20258 / AGD66 / AMG zone 58" },
  { value: "EPSG:20348", label: "EPSG:20348 / AGD84 / AMG zone 48" },
  { value: "EPSG:20349", label: "EPSG:20349 / AGD84 / AMG zone 49" },
  { value: "EPSG:20350", label: "EPSG:20350 / AGD84 / AMG zone 50" },
  { value: "EPSG:20351", label: "EPSG:20351 / AGD84 / AMG zone 51" },
  { value: "EPSG:20352", label: "EPSG:20352 / AGD84 / AMG zone 52" },
  { value: "EPSG:20353", label: "EPSG:20353 / AGD84 / AMG zone 53" },
  { value: "EPSG:20354", label: "EPSG:20354 / AGD84 / AMG zone 54" },
  { value: "EPSG:20355", label: "EPSG:20355 / AGD84 / AMG zone 55" },
  { value: "EPSG:20356", label: "EPSG:20356 / AGD84 / AMG zone 56" },
  { value: "EPSG:20357", label: "EPSG:20357 / AGD84 / AMG zone 57" },
  { value: "EPSG:20358", label: "EPSG:20358 / AGD84 / AMG zone 58" },
  { value: "EPSG:20436", label: "EPSG:20436 / Ain el Abd / UTM zone 36N" },
  { value: "EPSG:20437", label: "EPSG:20437 / Ain el Abd / UTM zone 37N" },
  { value: "EPSG:20438", label: "EPSG:20438 / Ain el Abd / UTM zone 38N" },
  { value: "EPSG:20439", label: "EPSG:20439 / Ain el Abd / UTM zone 39N" },
  { value: "EPSG:20440", label: "EPSG:20440 / Ain el Abd / UTM zone 40N" },
  { value: "EPSG:20499", label: "EPSG:20499 / Ain el Abd / Bahrain Grid" },
  { value: "EPSG:20538", label: "EPSG:20538 / Afgooye / UTM zone 38N" },
  { value: "EPSG:20539", label: "EPSG:20539 / Afgooye / UTM zone 39N" },
  {
    value: "EPSG:20790",
    label: "EPSG:20790 / Lisbon (Lisbon) / Portuguese National Grid",
  },
  {
    value: "EPSG:20791",
    label: "EPSG:20791 / Lisbon (Lisbon) / Portuguese Grid",
  },
  { value: "EPSG:20822", label: "EPSG:20822 / Aratu / UTM zone 22S" },
  { value: "EPSG:20823", label: "EPSG:20823 / Aratu / UTM zone 23S" },
  { value: "EPSG:20824", label: "EPSG:20824 / Aratu / UTM zone 24S" },
  { value: "EPSG:20904", label: "EPSG:20904 / GSK-2011 / Gauss-Kruger zone 4" },
  { value: "EPSG:20905", label: "EPSG:20905 / GSK-2011 / Gauss-Kruger zone 5" },
  { value: "EPSG:20906", label: "EPSG:20906 / GSK-2011 / Gauss-Kruger zone 6" },
  { value: "EPSG:20907", label: "EPSG:20907 / GSK-2011 / Gauss-Kruger zone 7" },
  { value: "EPSG:20908", label: "EPSG:20908 / GSK-2011 / Gauss-Kruger zone 8" },
  { value: "EPSG:20909", label: "EPSG:20909 / GSK-2011 / Gauss-Kruger zone 9" },
  {
    value: "EPSG:20910",
    label: "EPSG:20910 / GSK-2011 / Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:20911",
    label: "EPSG:20911 / GSK-2011 / Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:20912",
    label: "EPSG:20912 / GSK-2011 / Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:20913",
    label: "EPSG:20913 / GSK-2011 / Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:20914",
    label: "EPSG:20914 / GSK-2011 / Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:20915",
    label: "EPSG:20915 / GSK-2011 / Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:20916",
    label: "EPSG:20916 / GSK-2011 / Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:20917",
    label: "EPSG:20917 / GSK-2011 / Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:20918",
    label: "EPSG:20918 / GSK-2011 / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:20919",
    label: "EPSG:20919 / GSK-2011 / Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:20920",
    label: "EPSG:20920 / GSK-2011 / Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:20921",
    label: "EPSG:20921 / GSK-2011 / Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:20922",
    label: "EPSG:20922 / GSK-2011 / Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:20923",
    label: "EPSG:20923 / GSK-2011 / Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:20924",
    label: "EPSG:20924 / GSK-2011 / Gauss-Kruger zone 24",
  },
  {
    value: "EPSG:20925",
    label: "EPSG:20925 / GSK-2011 / Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:20926",
    label: "EPSG:20926 / GSK-2011 / Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:20927",
    label: "EPSG:20927 / GSK-2011 / Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:20928",
    label: "EPSG:20928 / GSK-2011 / Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:20929",
    label: "EPSG:20929 / GSK-2011 / Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:20930",
    label: "EPSG:20930 / GSK-2011 / Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:20931",
    label: "EPSG:20931 / GSK-2011 / Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:20932",
    label: "EPSG:20932 / GSK-2011 / Gauss-Kruger zone 32",
  },
  { value: "EPSG:20934", label: "EPSG:20934 / Arc 1950 / UTM zone 34S" },
  { value: "EPSG:20935", label: "EPSG:20935 / Arc 1950 / UTM zone 35S" },
  { value: "EPSG:20936", label: "EPSG:20936 / Arc 1950 / UTM zone 36S" },
  { value: "EPSG:21004", label: "EPSG:21004 / GSK-2011 / Gauss-Kruger CM 21E" },
  { value: "EPSG:21005", label: "EPSG:21005 / GSK-2011 / Gauss-Kruger CM 27E" },
  { value: "EPSG:21006", label: "EPSG:21006 / GSK-2011 / Gauss-Kruger CM 33E" },
  { value: "EPSG:21007", label: "EPSG:21007 / GSK-2011 / Gauss-Kruger CM 39E" },
  { value: "EPSG:21008", label: "EPSG:21008 / GSK-2011 / Gauss-Kruger CM 45E" },
  { value: "EPSG:21009", label: "EPSG:21009 / GSK-2011 / Gauss-Kruger CM 51E" },
  { value: "EPSG:21010", label: "EPSG:21010 / GSK-2011 / Gauss-Kruger CM 57E" },
  { value: "EPSG:21011", label: "EPSG:21011 / GSK-2011 / Gauss-Kruger CM 63E" },
  { value: "EPSG:21012", label: "EPSG:21012 / GSK-2011 / Gauss-Kruger CM 69E" },
  { value: "EPSG:21013", label: "EPSG:21013 / GSK-2011 / Gauss-Kruger CM 75E" },
  { value: "EPSG:21014", label: "EPSG:21014 / GSK-2011 / Gauss-Kruger CM 81E" },
  { value: "EPSG:21015", label: "EPSG:21015 / GSK-2011 / Gauss-Kruger CM 87E" },
  { value: "EPSG:21016", label: "EPSG:21016 / GSK-2011 / Gauss-Kruger CM 93E" },
  { value: "EPSG:21017", label: "EPSG:21017 / GSK-2011 / Gauss-Kruger CM 99E" },
  {
    value: "EPSG:21018",
    label: "EPSG:21018 / GSK-2011 / Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:21019",
    label: "EPSG:21019 / GSK-2011 / Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:21020",
    label: "EPSG:21020 / GSK-2011 / Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:21021",
    label: "EPSG:21021 / GSK-2011 / Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:21022",
    label: "EPSG:21022 / GSK-2011 / Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:21023",
    label: "EPSG:21023 / GSK-2011 / Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:21024",
    label: "EPSG:21024 / GSK-2011 / Gauss-Kruger CM 141E",
  },
  {
    value: "EPSG:21025",
    label: "EPSG:21025 / GSK-2011 / Gauss-Kruger CM 147E",
  },
  {
    value: "EPSG:21026",
    label: "EPSG:21026 / GSK-2011 / Gauss-Kruger CM 153E",
  },
  {
    value: "EPSG:21027",
    label: "EPSG:21027 / GSK-2011 / Gauss-Kruger CM 159E",
  },
  {
    value: "EPSG:21028",
    label: "EPSG:21028 / GSK-2011 / Gauss-Kruger CM 165E",
  },
  {
    value: "EPSG:21029",
    label: "EPSG:21029 / GSK-2011 / Gauss-Kruger CM 171E",
  },
  {
    value: "EPSG:21030",
    label: "EPSG:21030 / GSK-2011 / Gauss-Kruger CM 177E",
  },
  {
    value: "EPSG:21031",
    label: "EPSG:21031 / GSK-2011 / Gauss-Kruger CM 177W",
  },
  {
    value: "EPSG:21032",
    label: "EPSG:21032 / GSK-2011 / Gauss-Kruger CM 171W",
  },
  { value: "EPSG:21035", label: "EPSG:21035 / Arc 1960 / UTM zone 35S" },
  { value: "EPSG:21036", label: "EPSG:21036 / Arc 1960 / UTM zone 36S" },
  { value: "EPSG:21037", label: "EPSG:21037 / Arc 1960 / UTM zone 37S" },
  { value: "EPSG:21095", label: "EPSG:21095 / Arc 1960 / UTM zone 35N" },
  { value: "EPSG:21096", label: "EPSG:21096 / Arc 1960 / UTM zone 36N" },
  { value: "EPSG:21097", label: "EPSG:21097 / Arc 1960 / UTM zone 37N" },
  { value: "EPSG:21100", label: "EPSG:21100 / Batavia (Jakarta) / NEIEZ" },
  { value: "EPSG:21148", label: "EPSG:21148 / Batavia / UTM zone 48S" },
  { value: "EPSG:21149", label: "EPSG:21149 / Batavia / UTM zone 49S" },
  { value: "EPSG:21150", label: "EPSG:21150 / Batavia / UTM zone 50S" },
  { value: "EPSG:21207", label: "EPSG:21207 / GSK-2011 / GSK 3GK zone 7" },
  { value: "EPSG:21208", label: "EPSG:21208 / GSK-2011 / GSK 3GK zone 8" },
  { value: "EPSG:21209", label: "EPSG:21209 / GSK-2011 / GSK 3GK zone 9" },
  { value: "EPSG:21210", label: "EPSG:21210 / GSK-2011 / GSK 3GK zone 10" },
  { value: "EPSG:21211", label: "EPSG:21211 / GSK-2011 / GSK 3GK zone 11" },
  { value: "EPSG:21212", label: "EPSG:21212 / GSK-2011 / GSK 3GK zone 12" },
  { value: "EPSG:21213", label: "EPSG:21213 / GSK-2011 / GSK 3GK zone 13" },
  { value: "EPSG:21214", label: "EPSG:21214 / GSK-2011 / GSK 3GK zone 14" },
  { value: "EPSG:21215", label: "EPSG:21215 / GSK-2011 / GSK 3GK zone 15" },
  { value: "EPSG:21216", label: "EPSG:21216 / GSK-2011 / GSK 3GK zone 16" },
  { value: "EPSG:21217", label: "EPSG:21217 / GSK-2011 / GSK 3GK zone 17" },
  { value: "EPSG:21218", label: "EPSG:21218 / GSK-2011 / GSK 3GK zone 18" },
  { value: "EPSG:21219", label: "EPSG:21219 / GSK-2011 / GSK 3GK zone 19" },
  { value: "EPSG:21220", label: "EPSG:21220 / GSK-2011 / GSK 3GK zone 20" },
  { value: "EPSG:21221", label: "EPSG:21221 / GSK-2011 / GSK 3GK zone 21" },
  { value: "EPSG:21222", label: "EPSG:21222 / GSK-2011 / GSK 3GK zone 22" },
  { value: "EPSG:21223", label: "EPSG:21223 / GSK-2011 / GSK 3GK zone 23" },
  { value: "EPSG:21224", label: "EPSG:21224 / GSK-2011 / GSK 3GK zone 24" },
  { value: "EPSG:21225", label: "EPSG:21225 / GSK-2011 / GSK 3GK zone 25" },
  { value: "EPSG:21226", label: "EPSG:21226 / GSK-2011 / GSK 3GK zone 26" },
  { value: "EPSG:21227", label: "EPSG:21227 / GSK-2011 / GSK 3GK zone 27" },
  { value: "EPSG:21228", label: "EPSG:21228 / GSK-2011 / GSK 3GK zone 28" },
  { value: "EPSG:21229", label: "EPSG:21229 / GSK-2011 / GSK 3GK zone 29" },
  { value: "EPSG:21230", label: "EPSG:21230 / GSK-2011 / GSK 3GK zone 30" },
  { value: "EPSG:21231", label: "EPSG:21231 / GSK-2011 / GSK 3GK zone 31" },
  { value: "EPSG:21232", label: "EPSG:21232 / GSK-2011 / GSK 3GK zone 32" },
  { value: "EPSG:21233", label: "EPSG:21233 / GSK-2011 / GSK 3GK zone 33" },
  { value: "EPSG:21234", label: "EPSG:21234 / GSK-2011 / GSK 3GK zone 34" },
  { value: "EPSG:21235", label: "EPSG:21235 / GSK-2011 / GSK 3GK zone 35" },
  { value: "EPSG:21236", label: "EPSG:21236 / GSK-2011 / GSK 3GK zone 36" },
  { value: "EPSG:21237", label: "EPSG:21237 / GSK-2011 / GSK 3GK zone 37" },
  { value: "EPSG:21238", label: "EPSG:21238 / GSK-2011 / GSK 3GK zone 38" },
  { value: "EPSG:21239", label: "EPSG:21239 / GSK-2011 / GSK 3GK zone 39" },
  { value: "EPSG:21240", label: "EPSG:21240 / GSK-2011 / GSK 3GK zone 40" },
  { value: "EPSG:21241", label: "EPSG:21241 / GSK-2011 / GSK 3GK zone 41" },
  { value: "EPSG:21242", label: "EPSG:21242 / GSK-2011 / GSK 3GK zone 42" },
  { value: "EPSG:21243", label: "EPSG:21243 / GSK-2011 / GSK 3GK zone 43" },
  { value: "EPSG:21244", label: "EPSG:21244 / GSK-2011 / GSK 3GK zone 44" },
  { value: "EPSG:21245", label: "EPSG:21245 / GSK-2011 / GSK 3GK zone 45" },
  { value: "EPSG:21246", label: "EPSG:21246 / GSK-2011 / GSK 3GK zone 46" },
  { value: "EPSG:21247", label: "EPSG:21247 / GSK-2011 / GSK 3GK zone 47" },
  { value: "EPSG:21248", label: "EPSG:21248 / GSK-2011 / GSK 3GK zone 48" },
  { value: "EPSG:21249", label: "EPSG:21249 / GSK-2011 / GSK 3GK zone 49" },
  { value: "EPSG:21250", label: "EPSG:21250 / GSK-2011 / GSK 3GK zone 50" },
  { value: "EPSG:21251", label: "EPSG:21251 / GSK-2011 / GSK 3GK zone 51" },
  { value: "EPSG:21252", label: "EPSG:21252 / GSK-2011 / GSK 3GK zone 52" },
  { value: "EPSG:21253", label: "EPSG:21253 / GSK-2011 / GSK 3GK zone 53" },
  { value: "EPSG:21254", label: "EPSG:21254 / GSK-2011 / GSK 3GK zone 54" },
  { value: "EPSG:21255", label: "EPSG:21255 / GSK-2011 / GSK 3GK zone 55" },
  { value: "EPSG:21256", label: "EPSG:21256 / GSK-2011 / GSK 3GK zone 56" },
  { value: "EPSG:21257", label: "EPSG:21257 / GSK-2011 / GSK 3GK zone 57" },
  { value: "EPSG:21258", label: "EPSG:21258 / GSK-2011 / GSK 3GK zone 58" },
  { value: "EPSG:21259", label: "EPSG:21259 / GSK-2011 / GSK 3GK zone 59" },
  { value: "EPSG:21260", label: "EPSG:21260 / GSK-2011 / GSK 3GK zone 60" },
  { value: "EPSG:21261", label: "EPSG:21261 / GSK-2011 / GSK 3GK zone 61" },
  { value: "EPSG:21262", label: "EPSG:21262 / GSK-2011 / GSK 3GK zone 62" },
  { value: "EPSG:21263", label: "EPSG:21263 / GSK-2011 / GSK 3GK zone 63" },
  { value: "EPSG:21264", label: "EPSG:21264 / GSK-2011 / GSK 3GK zone 64" },
  {
    value: "EPSG:21291",
    label: "EPSG:21291 / Barbados 1938 / British West Indies Grid",
  },
  {
    value: "EPSG:21292",
    label: "EPSG:21292 / Barbados 1938 / Barbados National Grid",
  },
  { value: "EPSG:21307", label: "EPSG:21307 / GSK-2011 / GSK 3GK CM 21E" },
  { value: "EPSG:21308", label: "EPSG:21308 / GSK-2011 / GSK 3GK CM 24E" },
  { value: "EPSG:21309", label: "EPSG:21309 / GSK-2011 / GSK 3GK CM 27E" },
  { value: "EPSG:21310", label: "EPSG:21310 / GSK-2011 / GSK 3GK CM 30E" },
  { value: "EPSG:21311", label: "EPSG:21311 / GSK-2011 / GSK 3GK CM 33E" },
  { value: "EPSG:21312", label: "EPSG:21312 / GSK-2011 / GSK 3GK CM 36E" },
  { value: "EPSG:21313", label: "EPSG:21313 / GSK-2011 / GSK 3GK CM 39E" },
  { value: "EPSG:21314", label: "EPSG:21314 / GSK-2011 / GSK 3GK CM 42E" },
  { value: "EPSG:21315", label: "EPSG:21315 / GSK-2011 / GSK 3GK CM 45E" },
  { value: "EPSG:21316", label: "EPSG:21316 / GSK-2011 / GSK 3GK CM 48E" },
  { value: "EPSG:21317", label: "EPSG:21317 / GSK-2011 / GSK 3GK CM 51E" },
  { value: "EPSG:21318", label: "EPSG:21318 / GSK-2011 / GSK 3GK CM 54E" },
  { value: "EPSG:21319", label: "EPSG:21319 / GSK-2011 / GSK 3GK CM 57E" },
  { value: "EPSG:21320", label: "EPSG:21320 / GSK-2011 / GSK 3GK CM 60E" },
  { value: "EPSG:21321", label: "EPSG:21321 / GSK-2011 / GSK 3GK CM 63E" },
  { value: "EPSG:21322", label: "EPSG:21322 / GSK-2011 / GSK 3GK CM 66E" },
  { value: "EPSG:21323", label: "EPSG:21323 / GSK-2011 / GSK 3GK CM 69E" },
  { value: "EPSG:21324", label: "EPSG:21324 / GSK-2011 / GSK 3GK CM 72E" },
  { value: "EPSG:21325", label: "EPSG:21325 / GSK-2011 / GSK 3GK CM 75E" },
  { value: "EPSG:21326", label: "EPSG:21326 / GSK-2011 / GSK 3GK CM 78E" },
  { value: "EPSG:21327", label: "EPSG:21327 / GSK-2011 / GSK 3GK CM 81E" },
  { value: "EPSG:21328", label: "EPSG:21328 / GSK-2011 / GSK 3GK CM 84E" },
  { value: "EPSG:21329", label: "EPSG:21329 / GSK-2011 / GSK 3GK CM 87E" },
  { value: "EPSG:21330", label: "EPSG:21330 / GSK-2011 / GSK 3GK CM 90E" },
  { value: "EPSG:21331", label: "EPSG:21331 / GSK-2011 / GSK 3GK CM 93E" },
  { value: "EPSG:21332", label: "EPSG:21332 / GSK-2011 / GSK 3GK CM 96E" },
  { value: "EPSG:21333", label: "EPSG:21333 / GSK-2011 / GSK 3GK CM 99E" },
  { value: "EPSG:21334", label: "EPSG:21334 / GSK-2011 / GSK 3GK CM 102E" },
  { value: "EPSG:21335", label: "EPSG:21335 / GSK-2011 / GSK 3GK CM 105E" },
  { value: "EPSG:21336", label: "EPSG:21336 / GSK-2011 / GSK 3GK CM 108E" },
  { value: "EPSG:21337", label: "EPSG:21337 / GSK-2011 / GSK 3GK CM 111E" },
  { value: "EPSG:21338", label: "EPSG:21338 / GSK-2011 / GSK 3GK CM 114E" },
  { value: "EPSG:21339", label: "EPSG:21339 / GSK-2011 / GSK 3GK CM 117E" },
  { value: "EPSG:21340", label: "EPSG:21340 / GSK-2011 / GSK 3GK CM 120E" },
  { value: "EPSG:21341", label: "EPSG:21341 / GSK-2011 / GSK 3GK CM 123E" },
  { value: "EPSG:21342", label: "EPSG:21342 / GSK-2011 / GSK 3GK CM 126E" },
  { value: "EPSG:21343", label: "EPSG:21343 / GSK-2011 / GSK 3GK CM 129E" },
  { value: "EPSG:21344", label: "EPSG:21344 / GSK-2011 / GSK 3GK CM 132E" },
  { value: "EPSG:21345", label: "EPSG:21345 / GSK-2011 / GSK 3GK CM 135E" },
  { value: "EPSG:21346", label: "EPSG:21346 / GSK-2011 / GSK 3GK CM 138E" },
  { value: "EPSG:21347", label: "EPSG:21347 / GSK-2011 / GSK 3GK CM 141E" },
  { value: "EPSG:21348", label: "EPSG:21348 / GSK-2011 / GSK 3GK CM 144E" },
  { value: "EPSG:21349", label: "EPSG:21349 / GSK-2011 / GSK 3GK CM 147E" },
  { value: "EPSG:21350", label: "EPSG:21350 / GSK-2011 / GSK 3GK CM 150E" },
  { value: "EPSG:21351", label: "EPSG:21351 / GSK-2011 / GSK 3GK CM 153E" },
  { value: "EPSG:21352", label: "EPSG:21352 / GSK-2011 / GSK 3GK CM 156E" },
  { value: "EPSG:21353", label: "EPSG:21353 / GSK-2011 / GSK 3GK CM 159E" },
  { value: "EPSG:21354", label: "EPSG:21354 / GSK-2011 / GSK 3GK CM 162E" },
  { value: "EPSG:21355", label: "EPSG:21355 / GSK-2011 / GSK 3GK CM 165E" },
  { value: "EPSG:21356", label: "EPSG:21356 / GSK-2011 / GSK 3GK CM 168E" },
  { value: "EPSG:21357", label: "EPSG:21357 / GSK-2011 / GSK 3GK CM 171E" },
  { value: "EPSG:21358", label: "EPSG:21358 / GSK-2011 / GSK 3GK CM 174E" },
  { value: "EPSG:21359", label: "EPSG:21359 / GSK-2011 / GSK 3GK CM 177E" },
  { value: "EPSG:21360", label: "EPSG:21360 / GSK-2011 / GSK 3GK CM 180E" },
  { value: "EPSG:21361", label: "EPSG:21361 / GSK-2011 / GSK 3GK CM 177W" },
  { value: "EPSG:21362", label: "EPSG:21362 / GSK-2011 / GSK 3GK CM 174W" },
  { value: "EPSG:21363", label: "EPSG:21363 / GSK-2011 / GSK 3GK CM 171W" },
  { value: "EPSG:21364", label: "EPSG:21364 / GSK-2011 / GSK 3GK CM 168W" },
  {
    value: "EPSG:21413",
    label: "EPSG:21413 / Beijing 1954 / Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:21414",
    label: "EPSG:21414 / Beijing 1954 / Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:21415",
    label: "EPSG:21415 / Beijing 1954 / Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:21416",
    label: "EPSG:21416 / Beijing 1954 / Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:21417",
    label: "EPSG:21417 / Beijing 1954 / Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:21418",
    label: "EPSG:21418 / Beijing 1954 / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:21419",
    label: "EPSG:21419 / Beijing 1954 / Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:21420",
    label: "EPSG:21420 / Beijing 1954 / Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:21421",
    label: "EPSG:21421 / Beijing 1954 / Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:21422",
    label: "EPSG:21422 / Beijing 1954 / Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:21423",
    label: "EPSG:21423 / Beijing 1954 / Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:21453",
    label: "EPSG:21453 / Beijing 1954 / Gauss-Kruger CM 75E",
  },
  {
    value: "EPSG:21454",
    label: "EPSG:21454 / Beijing 1954 / Gauss-Kruger CM 81E",
  },
  {
    value: "EPSG:21455",
    label: "EPSG:21455 / Beijing 1954 / Gauss-Kruger CM 87E",
  },
  {
    value: "EPSG:21456",
    label: "EPSG:21456 / Beijing 1954 / Gauss-Kruger CM 93E",
  },
  {
    value: "EPSG:21457",
    label: "EPSG:21457 / Beijing 1954 / Gauss-Kruger CM 99E",
  },
  {
    value: "EPSG:21458",
    label: "EPSG:21458 / Beijing 1954 / Gauss-Kruger CM 105E",
  },
  {
    value: "EPSG:21459",
    label: "EPSG:21459 / Beijing 1954 / Gauss-Kruger CM 111E",
  },
  {
    value: "EPSG:21460",
    label: "EPSG:21460 / Beijing 1954 / Gauss-Kruger CM 117E",
  },
  {
    value: "EPSG:21461",
    label: "EPSG:21461 / Beijing 1954 / Gauss-Kruger CM 123E",
  },
  {
    value: "EPSG:21462",
    label: "EPSG:21462 / Beijing 1954 / Gauss-Kruger CM 129E",
  },
  {
    value: "EPSG:21463",
    label: "EPSG:21463 / Beijing 1954 / Gauss-Kruger CM 135E",
  },
  {
    value: "EPSG:21473",
    label: "EPSG:21473 / Beijing 1954 / Gauss-Kruger 13N",
  },
  {
    value: "EPSG:21474",
    label: "EPSG:21474 / Beijing 1954 / Gauss-Kruger 14N",
  },
  {
    value: "EPSG:21475",
    label: "EPSG:21475 / Beijing 1954 / Gauss-Kruger 15N",
  },
  {
    value: "EPSG:21476",
    label: "EPSG:21476 / Beijing 1954 / Gauss-Kruger 16N",
  },
  {
    value: "EPSG:21477",
    label: "EPSG:21477 / Beijing 1954 / Gauss-Kruger 17N",
  },
  {
    value: "EPSG:21478",
    label: "EPSG:21478 / Beijing 1954 / Gauss-Kruger 18N",
  },
  {
    value: "EPSG:21479",
    label: "EPSG:21479 / Beijing 1954 / Gauss-Kruger 19N",
  },
  {
    value: "EPSG:21480",
    label: "EPSG:21480 / Beijing 1954 / Gauss-Kruger 20N",
  },
  {
    value: "EPSG:21481",
    label: "EPSG:21481 / Beijing 1954 / Gauss-Kruger 21N",
  },
  {
    value: "EPSG:21482",
    label: "EPSG:21482 / Beijing 1954 / Gauss-Kruger 22N",
  },
  {
    value: "EPSG:21483",
    label: "EPSG:21483 / Beijing 1954 / Gauss-Kruger 23N",
  },
  {
    value: "EPSG:21500",
    label: "EPSG:21500 / BD50 (Brussels) / Belge Lambert 50",
  },
  { value: "EPSG:21780", label: "EPSG:21780 / Bern 1898 (Bern) / LV03C" },
  { value: "EPSG:21781", label: "EPSG:21781 / CH1903 / LV03" },
  { value: "EPSG:21782", label: "EPSG:21782 / CH1903 / LV03C-G" },
  { value: "EPSG:21817", label: "EPSG:21817 / Bogota 1975 / UTM zone 17N" },
  { value: "EPSG:21818", label: "EPSG:21818 / Bogota 1975 / UTM zone 18N" },
  {
    value: "EPSG:21891",
    label: "EPSG:21891 / Bogota 1975 / Colombia West zone",
  },
  {
    value: "EPSG:21892",
    label: "EPSG:21892 / Bogota 1975 / Colombia Bogota zone",
  },
  {
    value: "EPSG:21893",
    label: "EPSG:21893 / Bogota 1975 / Colombia East Central zone",
  },
  { value: "EPSG:21894", label: "EPSG:21894 / Bogota 1975 / Colombia East" },
  {
    value: "EPSG:21896",
    label: "EPSG:21896 / Bogota 1975 / Colombia West zone",
  },
  {
    value: "EPSG:21897",
    label: "EPSG:21897 / Bogota 1975 / Colombia Bogota zone",
  },
  {
    value: "EPSG:21898",
    label: "EPSG:21898 / Bogota 1975 / Colombia East Central zone",
  },
  {
    value: "EPSG:21899",
    label: "EPSG:21899 / Bogota 1975 / Colombia East zone",
  },
  { value: "EPSG:22032", label: "EPSG:22032 / Camacupa 1948 / UTM zone 32S" },
  { value: "EPSG:22033", label: "EPSG:22033 / Camacupa 1948 / UTM zone 33S" },
  { value: "EPSG:22091", label: "EPSG:22091 / Camacupa 1948 / TM 11.30 SE" },
  { value: "EPSG:22092", label: "EPSG:22092 / Camacupa 1948 / TM 12 SE" },
  { value: "EPSG:22171", label: "EPSG:22171 / POSGAR 98 / Argentina 1" },
  { value: "EPSG:22172", label: "EPSG:22172 / POSGAR 98 / Argentina 2" },
  { value: "EPSG:22173", label: "EPSG:22173 / POSGAR 98 / Argentina 3" },
  { value: "EPSG:22174", label: "EPSG:22174 / POSGAR 98 / Argentina 4" },
  { value: "EPSG:22175", label: "EPSG:22175 / POSGAR 98 / Argentina 5" },
  { value: "EPSG:22176", label: "EPSG:22176 / POSGAR 98 / Argentina 6" },
  { value: "EPSG:22177", label: "EPSG:22177 / POSGAR 98 / Argentina 7" },
  { value: "EPSG:22181", label: "EPSG:22181 / POSGAR 94 / Argentina 1" },
  { value: "EPSG:22182", label: "EPSG:22182 / POSGAR 94 / Argentina 2" },
  { value: "EPSG:22183", label: "EPSG:22183 / POSGAR 94 / Argentina 3" },
  { value: "EPSG:22184", label: "EPSG:22184 / POSGAR 94 / Argentina 4" },
  { value: "EPSG:22185", label: "EPSG:22185 / POSGAR 94 / Argentina 5" },
  { value: "EPSG:22186", label: "EPSG:22186 / POSGAR 94 / Argentina 6" },
  { value: "EPSG:22187", label: "EPSG:22187 / POSGAR 94 / Argentina 7" },
  { value: "EPSG:22191", label: "EPSG:22191 / Campo Inchauspe / Argentina 1" },
  { value: "EPSG:22192", label: "EPSG:22192 / Campo Inchauspe / Argentina 2" },
  { value: "EPSG:22193", label: "EPSG:22193 / Campo Inchauspe / Argentina 3" },
  { value: "EPSG:22194", label: "EPSG:22194 / Campo Inchauspe / Argentina 4" },
  { value: "EPSG:22195", label: "EPSG:22195 / Campo Inchauspe / Argentina 5" },
  { value: "EPSG:22196", label: "EPSG:22196 / Campo Inchauspe / Argentina 6" },
  { value: "EPSG:22197", label: "EPSG:22197 / Campo Inchauspe / Argentina 7" },
  { value: "EPSG:22207", label: "EPSG:22207 / NAD83(CSRS)v2 / UTM zone 7N" },
  { value: "EPSG:22208", label: "EPSG:22208 / NAD83(CSRS)v2 / UTM zone 8N" },
  { value: "EPSG:22209", label: "EPSG:22209 / NAD83(CSRS)v2 / UTM zone 9N" },
  { value: "EPSG:22210", label: "EPSG:22210 / NAD83(CSRS)v2 / UTM zone 10N" },
  { value: "EPSG:22211", label: "EPSG:22211 / NAD83(CSRS)v2 / UTM zone 11N" },
  { value: "EPSG:22212", label: "EPSG:22212 / NAD83(CSRS)v2 / UTM zone 12N" },
  { value: "EPSG:22213", label: "EPSG:22213 / NAD83(CSRS)v2 / UTM zone 13N" },
  { value: "EPSG:22214", label: "EPSG:22214 / NAD83(CSRS)v2 / UTM zone 14N" },
  { value: "EPSG:22215", label: "EPSG:22215 / NAD83(CSRS)v2 / UTM zone 15N" },
  { value: "EPSG:22216", label: "EPSG:22216 / NAD83(CSRS)v2 / UTM zone 16N" },
  { value: "EPSG:22217", label: "EPSG:22217 / NAD83(CSRS)v2 / UTM zone 17N" },
  { value: "EPSG:22218", label: "EPSG:22218 / NAD83(CSRS)v2 / UTM zone 18N" },
  { value: "EPSG:22219", label: "EPSG:22219 / NAD83(CSRS)v2 / UTM zone 19N" },
  { value: "EPSG:22220", label: "EPSG:22220 / NAD83(CSRS)v2 / UTM zone 20N" },
  { value: "EPSG:22221", label: "EPSG:22221 / NAD83(CSRS)v2 / UTM zone 21N" },
  { value: "EPSG:22222", label: "EPSG:22222 / NAD83(CSRS)v2 / UTM zone 22N" },
  { value: "EPSG:22234", label: "EPSG:22234 / Cape / UTM zone 34S" },
  { value: "EPSG:22235", label: "EPSG:22235 / Cape / UTM zone 35S" },
  { value: "EPSG:22236", label: "EPSG:22236 / Cape / UTM zone 36S" },
  {
    value: "EPSG:22239",
    label: "EPSG:22239 / NAD83(CSRS)v2 / PEI Stereographic",
  },
  {
    value: "EPSG:22240",
    label: "EPSG:22240 / NAD83(CSRS)v2 / NB Stereographic",
  },
  { value: "EPSG:22243", label: "EPSG:22243 / NAD83(CSRS)v2 / SCoPQ zone 3" },
  { value: "EPSG:22244", label: "EPSG:22244 / NAD83(CSRS)v2 / SCoPQ zone 4" },
  { value: "EPSG:22245", label: "EPSG:22245 / NAD83(CSRS)v2 / SCoPQ zone 5" },
  { value: "EPSG:22246", label: "EPSG:22246 / NAD83(CSRS)v2 / SCoPQ zone 6" },
  { value: "EPSG:22247", label: "EPSG:22247 / NAD83(CSRS)v2 / SCoPQ zone 7" },
  { value: "EPSG:22248", label: "EPSG:22248 / NAD83(CSRS)v2 / SCoPQ zone 8" },
  { value: "EPSG:22249", label: "EPSG:22249 / NAD83(CSRS)v2 / SCoPQ zone 9" },
  { value: "EPSG:22250", label: "EPSG:22250 / NAD83(CSRS)v2 / SCoPQ zone 10" },
  {
    value: "EPSG:22262",
    label: "EPSG:22262 / NAD83(CSRS)v2 / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:22263",
    label: "EPSG:22263 / NAD83(CSRS)v2 / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:22264",
    label: "EPSG:22264 / NAD83(CSRS)v2 / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:22265",
    label: "EPSG:22265 / NAD83(CSRS)v2 / Alberta 3TM ref merid 120 W",
  },
  { value: "EPSG:22275", label: "EPSG:22275 / Cape / Lo15" },
  { value: "EPSG:22277", label: "EPSG:22277 / Cape / Lo17" },
  { value: "EPSG:22279", label: "EPSG:22279 / Cape / Lo19" },
  { value: "EPSG:22281", label: "EPSG:22281 / Cape / Lo21" },
  { value: "EPSG:22283", label: "EPSG:22283 / Cape / Lo23" },
  { value: "EPSG:22285", label: "EPSG:22285 / Cape / Lo25" },
  { value: "EPSG:22287", label: "EPSG:22287 / Cape / Lo27" },
  { value: "EPSG:22289", label: "EPSG:22289 / Cape / Lo29" },
  { value: "EPSG:22291", label: "EPSG:22291 / Cape / Lo31" },
  { value: "EPSG:22293", label: "EPSG:22293 / Cape / Lo33" },
  {
    value: "EPSG:22300",
    label: "EPSG:22300 / Carthage (Paris) / Tunisia Mining Grid",
  },
  { value: "EPSG:22307", label: "EPSG:22307 / NAD83(CSRS)v3 / UTM zone 7N" },
  { value: "EPSG:22308", label: "EPSG:22308 / NAD83(CSRS)v3 / UTM zone 8N" },
  { value: "EPSG:22309", label: "EPSG:22309 / NAD83(CSRS)v3 / UTM zone 9N" },
  { value: "EPSG:22310", label: "EPSG:22310 / NAD83(CSRS)v3 / UTM zone 10N" },
  { value: "EPSG:22311", label: "EPSG:22311 / NAD83(CSRS)v3 / UTM zone 11N" },
  { value: "EPSG:22312", label: "EPSG:22312 / NAD83(CSRS)v3 / UTM zone 12N" },
  { value: "EPSG:22313", label: "EPSG:22313 / NAD83(CSRS)v3 / UTM zone 13N" },
  { value: "EPSG:22314", label: "EPSG:22314 / NAD83(CSRS)v3 / UTM zone 14N" },
  { value: "EPSG:22315", label: "EPSG:22315 / NAD83(CSRS)v3 / UTM zone 15N" },
  { value: "EPSG:22316", label: "EPSG:22316 / NAD83(CSRS)v3 / UTM zone 16N" },
  { value: "EPSG:22317", label: "EPSG:22317 / NAD83(CSRS)v3 / UTM zone 17N" },
  { value: "EPSG:22318", label: "EPSG:22318 / NAD83(CSRS)v3 / UTM zone 18N" },
  { value: "EPSG:22319", label: "EPSG:22319 / NAD83(CSRS)v3 / UTM zone 19N" },
  { value: "EPSG:22320", label: "EPSG:22320 / NAD83(CSRS)v3 / UTM zone 20N" },
  { value: "EPSG:22321", label: "EPSG:22321 / NAD83(CSRS)v3 / UTM zone 21N" },
  { value: "EPSG:22322", label: "EPSG:22322 / NAD83(CSRS)v3 / UTM zone 22N" },
  { value: "EPSG:22332", label: "EPSG:22332 / Carthage / UTM zone 32N" },
  {
    value: "EPSG:22337",
    label: "EPSG:22337 / NAD83(CSRS)v3 / MTM NS 1997 zone 5",
  },
  {
    value: "EPSG:22338",
    label: "EPSG:22338 / NAD83(CSRS)v3 / MTM NS 1997 zone 4",
  },
  { value: "EPSG:22348", label: "EPSG:22348 / NAD83(CSRS)v3 / MTM zone 8" },
  { value: "EPSG:22349", label: "EPSG:22349 / NAD83(CSRS)v3 / MTM zone 9" },
  { value: "EPSG:22350", label: "EPSG:22350 / NAD83(CSRS)v3 / MTM zone 10" },
  { value: "EPSG:22351", label: "EPSG:22351 / NAD83(CSRS)v3 / MTM zone 11" },
  { value: "EPSG:22352", label: "EPSG:22352 / NAD83(CSRS)v3 / MTM zone 12" },
  { value: "EPSG:22353", label: "EPSG:22353 / NAD83(CSRS)v3 / MTM zone 13" },
  { value: "EPSG:22354", label: "EPSG:22354 / NAD83(CSRS)v3 / MTM zone 14" },
  { value: "EPSG:22355", label: "EPSG:22355 / NAD83(CSRS)v3 / MTM zone 15" },
  { value: "EPSG:22356", label: "EPSG:22356 / NAD83(CSRS)v3 / MTM zone 16" },
  { value: "EPSG:22357", label: "EPSG:22357 / NAD83(CSRS)v3 / MTM zone 17" },
  { value: "EPSG:22391", label: "EPSG:22391 / Carthage / Nord Tunisie" },
  { value: "EPSG:22392", label: "EPSG:22392 / Carthage / Sud Tunisie" },
  { value: "EPSG:22407", label: "EPSG:22407 / NAD83(CSRS)v4 / UTM zone 7N" },
  { value: "EPSG:22408", label: "EPSG:22408 / NAD83(CSRS)v4 / UTM zone 8N" },
  { value: "EPSG:22409", label: "EPSG:22409 / NAD83(CSRS)v4 / UTM zone 9N" },
  { value: "EPSG:22410", label: "EPSG:22410 / NAD83(CSRS)v4 / UTM zone 10N" },
  { value: "EPSG:22411", label: "EPSG:22411 / NAD83(CSRS)v4 / UTM zone 11N" },
  { value: "EPSG:22412", label: "EPSG:22412 / NAD83(CSRS)v4 / UTM zone 12N" },
  { value: "EPSG:22413", label: "EPSG:22413 / NAD83(CSRS)v4 / UTM zone 13N" },
  { value: "EPSG:22414", label: "EPSG:22414 / NAD83(CSRS)v4 / UTM zone 14N" },
  { value: "EPSG:22415", label: "EPSG:22415 / NAD83(CSRS)v4 / UTM zone 15N" },
  { value: "EPSG:22416", label: "EPSG:22416 / NAD83(CSRS)v4 / UTM zone 16N" },
  { value: "EPSG:22417", label: "EPSG:22417 / NAD83(CSRS)v4 / UTM zone 17N" },
  { value: "EPSG:22418", label: "EPSG:22418 / NAD83(CSRS)v4 / UTM zone 18N" },
  { value: "EPSG:22419", label: "EPSG:22419 / NAD83(CSRS)v4 / UTM zone 19N" },
  { value: "EPSG:22420", label: "EPSG:22420 / NAD83(CSRS)v4 / UTM zone 20N" },
  { value: "EPSG:22421", label: "EPSG:22421 / NAD83(CSRS)v4 / UTM zone 21N" },
  { value: "EPSG:22422", label: "EPSG:22422 / NAD83(CSRS)v4 / UTM zone 22N" },
  {
    value: "EPSG:22462",
    label: "EPSG:22462 / NAD83(CSRS)v4 / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:22463",
    label: "EPSG:22463 / NAD83(CSRS)v4 / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:22464",
    label: "EPSG:22464 / NAD83(CSRS)v4 / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:22465",
    label: "EPSG:22465 / NAD83(CSRS)v4 / Alberta 3TM ref merid 120 W",
  },
  {
    value: "EPSG:22521",
    label: "EPSG:22521 / Corrego Alegre 1970-72 / UTM zone 21S",
  },
  {
    value: "EPSG:22522",
    label: "EPSG:22522 / Corrego Alegre 1970-72 / UTM zone 22S",
  },
  {
    value: "EPSG:22523",
    label: "EPSG:22523 / Corrego Alegre 1970-72 / UTM zone 23S",
  },
  {
    value: "EPSG:22524",
    label: "EPSG:22524 / Corrego Alegre 1970-72 / UTM zone 24S",
  },
  {
    value: "EPSG:22525",
    label: "EPSG:22525 / Corrego Alegre 1970-72 / UTM zone 25S",
  },
  { value: "EPSG:22607", label: "EPSG:22607 / NAD83(CSRS)v6 / UTM zone 7N" },
  { value: "EPSG:22608", label: "EPSG:22608 / NAD83(CSRS)v6 / UTM zone 8N" },
  { value: "EPSG:22609", label: "EPSG:22609 / NAD83(CSRS)v6 / UTM zone 9N" },
  { value: "EPSG:22610", label: "EPSG:22610 / NAD83(CSRS)v6 / UTM zone 10N" },
  { value: "EPSG:22611", label: "EPSG:22611 / NAD83(CSRS)v6 / UTM zone 11N" },
  { value: "EPSG:22612", label: "EPSG:22612 / NAD83(CSRS)v6 / UTM zone 12N" },
  { value: "EPSG:22613", label: "EPSG:22613 / NAD83(CSRS)v6 / UTM zone 13N" },
  { value: "EPSG:22614", label: "EPSG:22614 / NAD83(CSRS)v6 / UTM zone 14N" },
  { value: "EPSG:22615", label: "EPSG:22615 / NAD83(CSRS)v6 / UTM zone 15N" },
  { value: "EPSG:22616", label: "EPSG:22616 / NAD83(CSRS)v6 / UTM zone 16N" },
  { value: "EPSG:22617", label: "EPSG:22617 / NAD83(CSRS)v6 / UTM zone 17N" },
  { value: "EPSG:22618", label: "EPSG:22618 / NAD83(CSRS)v6 / UTM zone 18N" },
  { value: "EPSG:22619", label: "EPSG:22619 / NAD83(CSRS)v6 / UTM zone 19N" },
  { value: "EPSG:22620", label: "EPSG:22620 / NAD83(CSRS)v6 / UTM zone 20N" },
  { value: "EPSG:22621", label: "EPSG:22621 / NAD83(CSRS)v6 / UTM zone 21N" },
  { value: "EPSG:22622", label: "EPSG:22622 / NAD83(CSRS)v6 / UTM zone 22N" },
  {
    value: "EPSG:22639",
    label: "EPSG:22639 / NAD83(CSRS)v6 / PEI Stereographic",
  },
  { value: "EPSG:22641", label: "EPSG:22641 / NAD83(CSRS)v6 / MTM zone 1" },
  { value: "EPSG:22642", label: "EPSG:22642 / NAD83(CSRS)v6 / MTM zone 2" },
  { value: "EPSG:22643", label: "EPSG:22643 / NAD83(CSRS)v6 / MTM zone 3" },
  { value: "EPSG:22644", label: "EPSG:22644 / NAD83(CSRS)v6 / MTM zone 4" },
  { value: "EPSG:22645", label: "EPSG:22645 / NAD83(CSRS)v6 / MTM zone 5" },
  { value: "EPSG:22646", label: "EPSG:22646 / NAD83(CSRS)v6 / MTM zone 6" },
  { value: "EPSG:22648", label: "EPSG:22648 / NAD83(CSRS)v6 / MTM zone 8" },
  { value: "EPSG:22649", label: "EPSG:22649 / NAD83(CSRS)v6 / MTM zone 9" },
  { value: "EPSG:22650", label: "EPSG:22650 / NAD83(CSRS)v6 / MTM zone 10" },
  { value: "EPSG:22651", label: "EPSG:22651 / NAD83(CSRS)v6 / MTM zone 11" },
  { value: "EPSG:22652", label: "EPSG:22652 / NAD83(CSRS)v6 / MTM zone 12" },
  { value: "EPSG:22653", label: "EPSG:22653 / NAD83(CSRS)v6 / MTM zone 13" },
  { value: "EPSG:22654", label: "EPSG:22654 / NAD83(CSRS)v6 / MTM zone 14" },
  { value: "EPSG:22655", label: "EPSG:22655 / NAD83(CSRS)v6 / MTM zone 15" },
  { value: "EPSG:22656", label: "EPSG:22656 / NAD83(CSRS)v6 / MTM zone 16" },
  { value: "EPSG:22657", label: "EPSG:22657 / NAD83(CSRS)v6 / MTM zone 17" },
  { value: "EPSG:22700", label: "EPSG:22700 / Deir ez Zor / Levant Zone" },
  { value: "EPSG:22707", label: "EPSG:22707 / NAD83(CSRS)v7 / UTM zone 7N" },
  { value: "EPSG:22708", label: "EPSG:22708 / NAD83(CSRS)v7 / UTM zone 8N" },
  { value: "EPSG:22709", label: "EPSG:22709 / NAD83(CSRS)v7 / UTM zone 9N" },
  { value: "EPSG:22710", label: "EPSG:22710 / NAD83(CSRS)v7 / UTM zone 10N" },
  { value: "EPSG:22711", label: "EPSG:22711 / NAD83(CSRS)v7 / UTM zone 11N" },
  { value: "EPSG:22712", label: "EPSG:22712 / NAD83(CSRS)v7 / UTM zone 12N" },
  { value: "EPSG:22713", label: "EPSG:22713 / NAD83(CSRS)v7 / UTM zone 13N" },
  { value: "EPSG:22714", label: "EPSG:22714 / NAD83(CSRS)v7 / UTM zone 14N" },
  { value: "EPSG:22715", label: "EPSG:22715 / NAD83(CSRS)v7 / UTM zone 15N" },
  { value: "EPSG:22716", label: "EPSG:22716 / NAD83(CSRS)v7 / UTM zone 16N" },
  { value: "EPSG:22717", label: "EPSG:22717 / NAD83(CSRS)v7 / UTM zone 17N" },
  { value: "EPSG:22718", label: "EPSG:22718 / NAD83(CSRS)v7 / UTM zone 18N" },
  { value: "EPSG:22719", label: "EPSG:22719 / NAD83(CSRS)v7 / UTM zone 19N" },
  { value: "EPSG:22720", label: "EPSG:22720 / NAD83(CSRS)v7 / UTM zone 20N" },
  { value: "EPSG:22721", label: "EPSG:22721 / NAD83(CSRS)v7 / UTM zone 21N" },
  { value: "EPSG:22722", label: "EPSG:22722 / NAD83(CSRS)v7 / UTM zone 22N" },
  {
    value: "EPSG:22739",
    label: "EPSG:22739 / NAD83(CSRS)v7 / PEI Stereographic",
  },
  {
    value: "EPSG:22762",
    label: "EPSG:22762 / NAD83(CSRS)v7 / Alberta 3TM ref merid 111 W",
  },
  {
    value: "EPSG:22763",
    label: "EPSG:22763 / NAD83(CSRS)v7 / Alberta 3TM ref merid 114 W",
  },
  {
    value: "EPSG:22764",
    label: "EPSG:22764 / NAD83(CSRS)v7 / Alberta 3TM ref merid 117 W",
  },
  {
    value: "EPSG:22765",
    label: "EPSG:22765 / NAD83(CSRS)v7 / Alberta 3TM ref merid 120 W",
  },
  { value: "EPSG:22770", label: "EPSG:22770 / Deir ez Zor / Syria Lambert" },
  {
    value: "EPSG:22780",
    label: "EPSG:22780 / Deir ez Zor / Levant Stereographic",
  },
  { value: "EPSG:22832", label: "EPSG:22832 / Douala / UTM zone 32N" },
  { value: "EPSG:22991", label: "EPSG:22991 / Egypt 1907 / Blue Belt" },
  { value: "EPSG:22992", label: "EPSG:22992 / Egypt 1907 / Red Belt" },
  { value: "EPSG:22993", label: "EPSG:22993 / Egypt 1907 / Purple Belt" },
  {
    value: "EPSG:22994",
    label: "EPSG:22994 / Egypt 1907 / Extended Purple Belt",
  },
  { value: "EPSG:23028", label: "EPSG:23028 / ED50 / UTM zone 28N" },
  { value: "EPSG:23029", label: "EPSG:23029 / ED50 / UTM zone 29N" },
  { value: "EPSG:23030", label: "EPSG:23030 / ED50 / UTM zone 30N" },
  { value: "EPSG:23031", label: "EPSG:23031 / ED50 / UTM zone 31N" },
  { value: "EPSG:23032", label: "EPSG:23032 / ED50 / UTM zone 32N" },
  { value: "EPSG:23033", label: "EPSG:23033 / ED50 / UTM zone 33N" },
  { value: "EPSG:23034", label: "EPSG:23034 / ED50 / UTM zone 34N" },
  { value: "EPSG:23035", label: "EPSG:23035 / ED50 / UTM zone 35N" },
  { value: "EPSG:23036", label: "EPSG:23036 / ED50 / UTM zone 36N" },
  { value: "EPSG:23037", label: "EPSG:23037 / ED50 / UTM zone 37N" },
  { value: "EPSG:23038", label: "EPSG:23038 / ED50 / UTM zone 38N" },
  { value: "EPSG:23090", label: "EPSG:23090 / ED50 / TM 0 N" },
  { value: "EPSG:23095", label: "EPSG:23095 / ED50 / TM 5 NE" },
  { value: "EPSG:23239", label: "EPSG:23239 / Fahud / UTM zone 39N" },
  { value: "EPSG:23240", label: "EPSG:23240 / Fahud / UTM zone 40N" },
  { value: "EPSG:23433", label: "EPSG:23433 / Garoua / UTM zone 33N" },
  { value: "EPSG:23700", label: "EPSG:23700 / HD72 / EOV" },
  {
    value: "EPSG:23830",
    label: "EPSG:23830 / DGN95 / Indonesia TM-3 zone 46.2",
  },
  {
    value: "EPSG:23831",
    label: "EPSG:23831 / DGN95 / Indonesia TM-3 zone 47.1",
  },
  {
    value: "EPSG:23832",
    label: "EPSG:23832 / DGN95 / Indonesia TM-3 zone 47.2",
  },
  {
    value: "EPSG:23833",
    label: "EPSG:23833 / DGN95 / Indonesia TM-3 zone 48.1",
  },
  {
    value: "EPSG:23834",
    label: "EPSG:23834 / DGN95 / Indonesia TM-3 zone 48.2",
  },
  {
    value: "EPSG:23835",
    label: "EPSG:23835 / DGN95 / Indonesia TM-3 zone 49.1",
  },
  {
    value: "EPSG:23836",
    label: "EPSG:23836 / DGN95 / Indonesia TM-3 zone 49.2",
  },
  {
    value: "EPSG:23837",
    label: "EPSG:23837 / DGN95 / Indonesia TM-3 zone 50.1",
  },
  {
    value: "EPSG:23838",
    label: "EPSG:23838 / DGN95 / Indonesia TM-3 zone 50.2",
  },
  {
    value: "EPSG:23839",
    label: "EPSG:23839 / DGN95 / Indonesia TM-3 zone 51.1",
  },
  {
    value: "EPSG:23840",
    label: "EPSG:23840 / DGN95 / Indonesia TM-3 zone 51.2",
  },
  {
    value: "EPSG:23841",
    label: "EPSG:23841 / DGN95 / Indonesia TM-3 zone 52.1",
  },
  {
    value: "EPSG:23842",
    label: "EPSG:23842 / DGN95 / Indonesia TM-3 zone 52.2",
  },
  {
    value: "EPSG:23843",
    label: "EPSG:23843 / DGN95 / Indonesia TM-3 zone 53.1",
  },
  {
    value: "EPSG:23844",
    label: "EPSG:23844 / DGN95 / Indonesia TM-3 zone 53.2",
  },
  {
    value: "EPSG:23845",
    label: "EPSG:23845 / DGN95 / Indonesia TM-3 zone 54.1",
  },
  { value: "EPSG:23846", label: "EPSG:23846 / ID74 / UTM zone 46N" },
  { value: "EPSG:23847", label: "EPSG:23847 / ID74 / UTM zone 47N" },
  { value: "EPSG:23848", label: "EPSG:23848 / ID74 / UTM zone 48N" },
  { value: "EPSG:23849", label: "EPSG:23849 / ID74 / UTM zone 49N" },
  { value: "EPSG:23850", label: "EPSG:23850 / ID74 / UTM zone 50N" },
  { value: "EPSG:23851", label: "EPSG:23851 / ID74 / UTM zone 51N" },
  { value: "EPSG:23852", label: "EPSG:23852 / ID74 / UTM zone 52N" },
  { value: "EPSG:23853", label: "EPSG:23853 / ID74 / UTM zone 53N" },
  { value: "EPSG:23866", label: "EPSG:23866 / DGN95 / UTM zone 46N" },
  { value: "EPSG:23867", label: "EPSG:23867 / DGN95 / UTM zone 47N" },
  { value: "EPSG:23868", label: "EPSG:23868 / DGN95 / UTM zone 48N" },
  { value: "EPSG:23869", label: "EPSG:23869 / DGN95 / UTM zone 49N" },
  { value: "EPSG:23870", label: "EPSG:23870 / DGN95 / UTM zone 50N" },
  { value: "EPSG:23871", label: "EPSG:23871 / DGN95 / UTM zone 51N" },
  { value: "EPSG:23872", label: "EPSG:23872 / DGN95 / UTM zone 52N" },
  { value: "EPSG:23877", label: "EPSG:23877 / DGN95 / UTM zone 47S" },
  { value: "EPSG:23878", label: "EPSG:23878 / DGN95 / UTM zone 48S" },
  { value: "EPSG:23879", label: "EPSG:23879 / DGN95 / UTM zone 49S" },
  { value: "EPSG:23880", label: "EPSG:23880 / DGN95 / UTM zone 50S" },
  { value: "EPSG:23881", label: "EPSG:23881 / DGN95 / UTM zone 51S" },
  { value: "EPSG:23882", label: "EPSG:23882 / DGN95 / UTM zone 52S" },
  { value: "EPSG:23883", label: "EPSG:23883 / DGN95 / UTM zone 53S" },
  { value: "EPSG:23884", label: "EPSG:23884 / DGN95 / UTM zone 54S" },
  { value: "EPSG:23886", label: "EPSG:23886 / ID74 / UTM zone 46S" },
  { value: "EPSG:23887", label: "EPSG:23887 / ID74 / UTM zone 47S" },
  { value: "EPSG:23888", label: "EPSG:23888 / ID74 / UTM zone 48S" },
  { value: "EPSG:23889", label: "EPSG:23889 / ID74 / UTM zone 49S" },
  { value: "EPSG:23890", label: "EPSG:23890 / ID74 / UTM zone 50S" },
  { value: "EPSG:23891", label: "EPSG:23891 / ID74 / UTM zone 51S" },
  { value: "EPSG:23892", label: "EPSG:23892 / ID74 / UTM zone 52S" },
  { value: "EPSG:23893", label: "EPSG:23893 / ID74 / UTM zone 53S" },
  { value: "EPSG:23894", label: "EPSG:23894 / ID74 / UTM zone 54S" },
  { value: "EPSG:23946", label: "EPSG:23946 / Indian 1954 / UTM zone 46N" },
  { value: "EPSG:23947", label: "EPSG:23947 / Indian 1954 / UTM zone 47N" },
  { value: "EPSG:23948", label: "EPSG:23948 / Indian 1954 / UTM zone 48N" },
  { value: "EPSG:24047", label: "EPSG:24047 / Indian 1975 / UTM zone 47N" },
  { value: "EPSG:24048", label: "EPSG:24048 / Indian 1975 / UTM zone 48N" },
  {
    value: "EPSG:24100",
    label: "EPSG:24100 / Jamaica 1875 / Jamaica (Old Grid)",
  },
  { value: "EPSG:24200", label: "EPSG:24200 / JAD69 / Jamaica National Grid" },
  { value: "EPSG:24305", label: "EPSG:24305 / Kalianpur 1937 / UTM zone 45N" },
  { value: "EPSG:24306", label: "EPSG:24306 / Kalianpur 1937 / UTM zone 46N" },
  { value: "EPSG:24311", label: "EPSG:24311 / Kalianpur 1962 / UTM zone 41N" },
  { value: "EPSG:24312", label: "EPSG:24312 / Kalianpur 1962 / UTM zone 42N" },
  { value: "EPSG:24313", label: "EPSG:24313 / Kalianpur 1962 / UTM zone 43N" },
  { value: "EPSG:24342", label: "EPSG:24342 / Kalianpur 1975 / UTM zone 42N" },
  { value: "EPSG:24343", label: "EPSG:24343 / Kalianpur 1975 / UTM zone 43N" },
  { value: "EPSG:24344", label: "EPSG:24344 / Kalianpur 1975 / UTM zone 44N" },
  { value: "EPSG:24345", label: "EPSG:24345 / Kalianpur 1975 / UTM zone 45N" },
  { value: "EPSG:24346", label: "EPSG:24346 / Kalianpur 1975 / UTM zone 46N" },
  { value: "EPSG:24347", label: "EPSG:24347 / Kalianpur 1975 / UTM zone 47N" },
  { value: "EPSG:24370", label: "EPSG:24370 / Kalianpur 1880 / India zone 0" },
  { value: "EPSG:24371", label: "EPSG:24371 / Kalianpur 1880 / India zone I" },
  {
    value: "EPSG:24372",
    label: "EPSG:24372 / Kalianpur 1880 / India zone IIa",
  },
  {
    value: "EPSG:24373",
    label: "EPSG:24373 / Kalianpur 1880 / India zone IIIa",
  },
  {
    value: "EPSG:24374",
    label: "EPSG:24374 / Kalianpur 1880 / India zone IVa",
  },
  {
    value: "EPSG:24375",
    label: "EPSG:24375 / Kalianpur 1937 / India zone IIb",
  },
  { value: "EPSG:24376", label: "EPSG:24376 / Kalianpur 1962 / India zone I" },
  {
    value: "EPSG:24377",
    label: "EPSG:24377 / Kalianpur 1962 / India zone IIa",
  },
  { value: "EPSG:24378", label: "EPSG:24378 / Kalianpur 1975 / India zone I" },
  {
    value: "EPSG:24379",
    label: "EPSG:24379 / Kalianpur 1975 / India zone IIa",
  },
  {
    value: "EPSG:24380",
    label: "EPSG:24380 / Kalianpur 1975 / India zone IIb",
  },
  {
    value: "EPSG:24381",
    label: "EPSG:24381 / Kalianpur 1975 / India zone IIIa",
  },
  {
    value: "EPSG:24382",
    label: "EPSG:24382 / Kalianpur 1880 / India zone IIb",
  },
  {
    value: "EPSG:24383",
    label: "EPSG:24383 / Kalianpur 1975 / India zone IVa",
  },
  { value: "EPSG:24500", label: "EPSG:24500 / Kertau 1968 / Singapore Grid" },
  { value: "EPSG:24547", label: "EPSG:24547 / Kertau 1968 / UTM zone 47N" },
  { value: "EPSG:24548", label: "EPSG:24548 / Kertau 1968 / UTM zone 48N" },
  { value: "EPSG:24571", label: "EPSG:24571 / Kertau / R.S.O. Malaya (ch)" },
  { value: "EPSG:24600", label: "EPSG:24600 / KOC Lambert" },
  { value: "EPSG:24718", label: "EPSG:24718 / La Canoa / UTM zone 18N" },
  { value: "EPSG:24719", label: "EPSG:24719 / La Canoa / UTM zone 19N" },
  { value: "EPSG:24720", label: "EPSG:24720 / La Canoa / UTM zone 20N" },
  { value: "EPSG:24817", label: "EPSG:24817 / PSAD56 / UTM zone 17N" },
  { value: "EPSG:24818", label: "EPSG:24818 / PSAD56 / UTM zone 18N" },
  { value: "EPSG:24819", label: "EPSG:24819 / PSAD56 / UTM zone 19N" },
  { value: "EPSG:24820", label: "EPSG:24820 / PSAD56 / UTM zone 20N" },
  { value: "EPSG:24821", label: "EPSG:24821 / PSAD56 / UTM zone 21N" },
  { value: "EPSG:24877", label: "EPSG:24877 / PSAD56 / UTM zone 17S" },
  { value: "EPSG:24878", label: "EPSG:24878 / PSAD56 / UTM zone 18S" },
  { value: "EPSG:24879", label: "EPSG:24879 / PSAD56 / UTM zone 19S" },
  { value: "EPSG:24880", label: "EPSG:24880 / PSAD56 / UTM zone 20S" },
  { value: "EPSG:24881", label: "EPSG:24881 / PSAD56 / UTM zone 21S" },
  { value: "EPSG:24882", label: "EPSG:24882 / PSAD56 / UTM zone 22S" },
  { value: "EPSG:24891", label: "EPSG:24891 / PSAD56 / Peru west zone" },
  { value: "EPSG:24892", label: "EPSG:24892 / PSAD56 / Peru central zone" },
  { value: "EPSG:24893", label: "EPSG:24893 / PSAD56 / Peru east zone" },
  { value: "EPSG:25000", label: "EPSG:25000 / Leigon / Ghana Metre Grid" },
  { value: "EPSG:25231", label: "EPSG:25231 / Lome / UTM zone 31N" },
  {
    value: "EPSG:25391",
    label: "EPSG:25391 / Luzon 1911 / Philippines zone I",
  },
  {
    value: "EPSG:25392",
    label: "EPSG:25392 / Luzon 1911 / Philippines zone II",
  },
  {
    value: "EPSG:25393",
    label: "EPSG:25393 / Luzon 1911 / Philippines zone III",
  },
  {
    value: "EPSG:25394",
    label: "EPSG:25394 / Luzon 1911 / Philippines zone IV",
  },
  {
    value: "EPSG:25395",
    label: "EPSG:25395 / Luzon 1911 / Philippines zone V",
  },
  { value: "EPSG:25700", label: "EPSG:25700 / Makassar (Jakarta) / NEIEZ" },
  { value: "EPSG:25828", label: "EPSG:25828 / ETRS89 / UTM zone 28N" },
  { value: "EPSG:25829", label: "EPSG:25829 / ETRS89 / UTM zone 29N" },
  { value: "EPSG:25830", label: "EPSG:25830 / ETRS89 / UTM zone 30N" },
  { value: "EPSG:25831", label: "EPSG:25831 / ETRS89 / UTM zone 31N" },
  { value: "EPSG:25832", label: "EPSG:25832 / ETRS89 / UTM zone 32N" },
  { value: "EPSG:25833", label: "EPSG:25833 / ETRS89 / UTM zone 33N" },
  { value: "EPSG:25834", label: "EPSG:25834 / ETRS89 / UTM zone 34N" },
  { value: "EPSG:25835", label: "EPSG:25835 / ETRS89 / UTM zone 35N" },
  { value: "EPSG:25836", label: "EPSG:25836 / ETRS89 / UTM zone 36N" },
  { value: "EPSG:25837", label: "EPSG:25837 / ETRS89 / UTM zone 37N" },
  { value: "EPSG:25838", label: "EPSG:25838 / ETRS89 / UTM zone 38N" },
  { value: "EPSG:25884", label: "EPSG:25884 / ETRS89 / TM Baltic93" },
  { value: "EPSG:25932", label: "EPSG:25932 / Malongo 1987 / UTM zone 32S" },
  { value: "EPSG:26191", label: "EPSG:26191 / Merchich / Nord Maroc" },
  { value: "EPSG:26192", label: "EPSG:26192 / Merchich / Sud Maroc" },
  { value: "EPSG:26193", label: "EPSG:26193 / Merchich / Sahara" },
  { value: "EPSG:26194", label: "EPSG:26194 / Merchich / Sahara Nord" },
  { value: "EPSG:26195", label: "EPSG:26195 / Merchich / Sahara Sud" },
  { value: "EPSG:26237", label: "EPSG:26237 / Massawa / UTM zone 37N" },
  { value: "EPSG:26331", label: "EPSG:26331 / Minna / UTM zone 31N" },
  { value: "EPSG:26332", label: "EPSG:26332 / Minna / UTM zone 32N" },
  { value: "EPSG:26391", label: "EPSG:26391 / Minna / Nigeria West Belt" },
  { value: "EPSG:26392", label: "EPSG:26392 / Minna / Nigeria Mid Belt" },
  { value: "EPSG:26393", label: "EPSG:26393 / Minna / Nigeria East Belt" },
  { value: "EPSG:26432", label: "EPSG:26432 / Mhast / UTM zone 32S" },
  {
    value: "EPSG:26591",
    label: "EPSG:26591 / Monte Mario (Rome) / Italy zone 1",
  },
  {
    value: "EPSG:26592",
    label: "EPSG:26592 / Monte Mario (Rome) / Italy zone 2",
  },
  { value: "EPSG:26632", label: "EPSG:26632 / M'poraloko / UTM zone 32N" },
  { value: "EPSG:26692", label: "EPSG:26692 / M'poraloko / UTM zone 32S" },
  { value: "EPSG:26701", label: "EPSG:26701 / NAD27 / UTM zone 1N" },
  { value: "EPSG:26702", label: "EPSG:26702 / NAD27 / UTM zone 2N" },
  { value: "EPSG:26703", label: "EPSG:26703 / NAD27 / UTM zone 3N" },
  { value: "EPSG:26704", label: "EPSG:26704 / NAD27 / UTM zone 4N" },
  { value: "EPSG:26705", label: "EPSG:26705 / NAD27 / UTM zone 5N" },
  { value: "EPSG:26706", label: "EPSG:26706 / NAD27 / UTM zone 6N" },
  { value: "EPSG:26707", label: "EPSG:26707 / NAD27 / UTM zone 7N" },
  { value: "EPSG:26708", label: "EPSG:26708 / NAD27 / UTM zone 8N" },
  { value: "EPSG:26709", label: "EPSG:26709 / NAD27 / UTM zone 9N" },
  { value: "EPSG:26710", label: "EPSG:26710 / NAD27 / UTM zone 10N" },
  { value: "EPSG:26711", label: "EPSG:26711 / NAD27 / UTM zone 11N" },
  { value: "EPSG:26712", label: "EPSG:26712 / NAD27 / UTM zone 12N" },
  { value: "EPSG:26713", label: "EPSG:26713 / NAD27 / UTM zone 13N" },
  { value: "EPSG:26714", label: "EPSG:26714 / NAD27 / UTM zone 14N" },
  { value: "EPSG:26715", label: "EPSG:26715 / NAD27 / UTM zone 15N" },
  { value: "EPSG:26716", label: "EPSG:26716 / NAD27 / UTM zone 16N" },
  { value: "EPSG:26717", label: "EPSG:26717 / NAD27 / UTM zone 17N" },
  { value: "EPSG:26718", label: "EPSG:26718 / NAD27 / UTM zone 18N" },
  { value: "EPSG:26719", label: "EPSG:26719 / NAD27 / UTM zone 19N" },
  { value: "EPSG:26720", label: "EPSG:26720 / NAD27 / UTM zone 20N" },
  { value: "EPSG:26721", label: "EPSG:26721 / NAD27 / UTM zone 21N" },
  { value: "EPSG:26722", label: "EPSG:26722 / NAD27 / UTM zone 22N" },
  { value: "EPSG:26729", label: "EPSG:26729 / NAD27 / Alabama East" },
  { value: "EPSG:26730", label: "EPSG:26730 / NAD27 / Alabama West" },
  { value: "EPSG:26731", label: "EPSG:26731 / NAD27 / Alaska zone 1" },
  { value: "EPSG:26732", label: "EPSG:26732 / NAD27 / Alaska zone 2" },
  { value: "EPSG:26733", label: "EPSG:26733 / NAD27 / Alaska zone 3" },
  { value: "EPSG:26734", label: "EPSG:26734 / NAD27 / Alaska zone 4" },
  { value: "EPSG:26735", label: "EPSG:26735 / NAD27 / Alaska zone 5" },
  { value: "EPSG:26736", label: "EPSG:26736 / NAD27 / Alaska zone 6" },
  { value: "EPSG:26737", label: "EPSG:26737 / NAD27 / Alaska zone 7" },
  { value: "EPSG:26738", label: "EPSG:26738 / NAD27 / Alaska zone 8" },
  { value: "EPSG:26739", label: "EPSG:26739 / NAD27 / Alaska zone 9" },
  { value: "EPSG:26740", label: "EPSG:26740 / NAD27 / Alaska zone 10" },
  { value: "EPSG:26741", label: "EPSG:26741 / NAD27 / California zone I" },
  { value: "EPSG:26742", label: "EPSG:26742 / NAD27 / California zone II" },
  { value: "EPSG:26743", label: "EPSG:26743 / NAD27 / California zone III" },
  { value: "EPSG:26744", label: "EPSG:26744 / NAD27 / California zone IV" },
  { value: "EPSG:26745", label: "EPSG:26745 / NAD27 / California zone V" },
  { value: "EPSG:26746", label: "EPSG:26746 / NAD27 / California zone VI" },
  { value: "EPSG:26747", label: "EPSG:26747 / NAD27 / California zone VII" },
  { value: "EPSG:26748", label: "EPSG:26748 / NAD27 / Arizona East" },
  { value: "EPSG:26749", label: "EPSG:26749 / NAD27 / Arizona Central" },
  { value: "EPSG:26750", label: "EPSG:26750 / NAD27 / Arizona West" },
  { value: "EPSG:26751", label: "EPSG:26751 / NAD27 / Arkansas North" },
  { value: "EPSG:26752", label: "EPSG:26752 / NAD27 / Arkansas South" },
  { value: "EPSG:26753", label: "EPSG:26753 / NAD27 / Colorado North" },
  { value: "EPSG:26754", label: "EPSG:26754 / NAD27 / Colorado Central" },
  { value: "EPSG:26755", label: "EPSG:26755 / NAD27 / Colorado South" },
  { value: "EPSG:26756", label: "EPSG:26756 / NAD27 / Connecticut" },
  { value: "EPSG:26757", label: "EPSG:26757 / NAD27 / Delaware" },
  { value: "EPSG:26758", label: "EPSG:26758 / NAD27 / Florida East" },
  { value: "EPSG:26759", label: "EPSG:26759 / NAD27 / Florida West" },
  { value: "EPSG:26760", label: "EPSG:26760 / NAD27 / Florida North" },
  { value: "EPSG:26766", label: "EPSG:26766 / NAD27 / Georgia East" },
  { value: "EPSG:26767", label: "EPSG:26767 / NAD27 / Georgia West" },
  { value: "EPSG:26768", label: "EPSG:26768 / NAD27 / Idaho East" },
  { value: "EPSG:26769", label: "EPSG:26769 / NAD27 / Idaho Central" },
  { value: "EPSG:26770", label: "EPSG:26770 / NAD27 / Idaho West" },
  { value: "EPSG:26771", label: "EPSG:26771 / NAD27 / Illinois East" },
  { value: "EPSG:26772", label: "EPSG:26772 / NAD27 / Illinois West" },
  { value: "EPSG:26773", label: "EPSG:26773 / NAD27 / Indiana East" },
  { value: "EPSG:26774", label: "EPSG:26774 / NAD27 / Indiana West" },
  { value: "EPSG:26775", label: "EPSG:26775 / NAD27 / Iowa North" },
  { value: "EPSG:26776", label: "EPSG:26776 / NAD27 / Iowa South" },
  { value: "EPSG:26777", label: "EPSG:26777 / NAD27 / Kansas North" },
  { value: "EPSG:26778", label: "EPSG:26778 / NAD27 / Kansas South" },
  { value: "EPSG:26779", label: "EPSG:26779 / NAD27 / Kentucky North" },
  { value: "EPSG:26780", label: "EPSG:26780 / NAD27 / Kentucky South" },
  { value: "EPSG:26781", label: "EPSG:26781 / NAD27 / Louisiana North" },
  { value: "EPSG:26782", label: "EPSG:26782 / NAD27 / Louisiana South" },
  { value: "EPSG:26783", label: "EPSG:26783 / NAD27 / Maine East" },
  { value: "EPSG:26784", label: "EPSG:26784 / NAD27 / Maine West" },
  { value: "EPSG:26785", label: "EPSG:26785 / NAD27 / Maryland" },
  { value: "EPSG:26786", label: "EPSG:26786 / NAD27 / Massachusetts Mainland" },
  { value: "EPSG:26787", label: "EPSG:26787 / NAD27 / Massachusetts Island" },
  { value: "EPSG:26791", label: "EPSG:26791 / NAD27 / Minnesota North" },
  { value: "EPSG:26792", label: "EPSG:26792 / NAD27 / Minnesota Central" },
  { value: "EPSG:26793", label: "EPSG:26793 / NAD27 / Minnesota South" },
  { value: "EPSG:26794", label: "EPSG:26794 / NAD27 / Mississippi East" },
  { value: "EPSG:26795", label: "EPSG:26795 / NAD27 / Mississippi West" },
  { value: "EPSG:26796", label: "EPSG:26796 / NAD27 / Missouri East" },
  { value: "EPSG:26797", label: "EPSG:26797 / NAD27 / Missouri Central" },
  { value: "EPSG:26798", label: "EPSG:26798 / NAD27 / Missouri West" },
  { value: "EPSG:26799", label: "EPSG:26799 / NAD27 / California zone VII" },
  { value: "EPSG:26801", label: "EPSG:26801 / NAD Michigan / Michigan East" },
  {
    value: "EPSG:26802",
    label: "EPSG:26802 / NAD Michigan / Michigan Old Central",
  },
  { value: "EPSG:26803", label: "EPSG:26803 / NAD Michigan / Michigan West" },
  { value: "EPSG:26811", label: "EPSG:26811 / NAD Michigan / Michigan North" },
  {
    value: "EPSG:26812",
    label: "EPSG:26812 / NAD Michigan / Michigan Central",
  },
  { value: "EPSG:26813", label: "EPSG:26813 / NAD Michigan / Michigan South" },
  { value: "EPSG:26814", label: "EPSG:26814 / NAD83 / Maine East (ftUS)" },
  { value: "EPSG:26815", label: "EPSG:26815 / NAD83 / Maine West (ftUS)" },
  { value: "EPSG:26819", label: "EPSG:26819 / NAD83 / Minnesota North (ftUS)" },
  {
    value: "EPSG:26820",
    label: "EPSG:26820 / NAD83 / Minnesota Central (ftUS)",
  },
  { value: "EPSG:26821", label: "EPSG:26821 / NAD83 / Minnesota South (ftUS)" },
  { value: "EPSG:26822", label: "EPSG:26822 / NAD83 / Nebraska (ftUS)" },
  {
    value: "EPSG:26823",
    label: "EPSG:26823 / NAD83 / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26824",
    label: "EPSG:26824 / NAD83 / West Virginia South (ftUS)",
  },
  {
    value: "EPSG:26825",
    label: "EPSG:26825 / NAD83(HARN) / Maine East (ftUS)",
  },
  {
    value: "EPSG:26826",
    label: "EPSG:26826 / NAD83(HARN) / Maine West (ftUS)",
  },
  {
    value: "EPSG:26830",
    label: "EPSG:26830 / NAD83(HARN) / Minnesota North (ftUS)",
  },
  {
    value: "EPSG:26831",
    label: "EPSG:26831 / NAD83(HARN) / Minnesota Central (ftUS)",
  },
  {
    value: "EPSG:26832",
    label: "EPSG:26832 / NAD83(HARN) / Minnesota South (ftUS)",
  },
  { value: "EPSG:26833", label: "EPSG:26833 / NAD83(HARN) / Nebraska (ftUS)" },
  {
    value: "EPSG:26834",
    label: "EPSG:26834 / NAD83(HARN) / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26835",
    label: "EPSG:26835 / NAD83(HARN) / West Virginia South (ftUS)",
  },
  {
    value: "EPSG:26836",
    label: "EPSG:26836 / NAD83(NSRS2007) / Maine East (ftUS)",
  },
  {
    value: "EPSG:26837",
    label: "EPSG:26837 / NAD83(NSRS2007) / Maine West (ftUS)",
  },
  {
    value: "EPSG:26841",
    label: "EPSG:26841 / NAD83(NSRS2007) / Minnesota North (ftUS)",
  },
  {
    value: "EPSG:26842",
    label: "EPSG:26842 / NAD83(NSRS2007) / Minnesota Central (ftUS)",
  },
  {
    value: "EPSG:26843",
    label: "EPSG:26843 / NAD83(NSRS2007) / Minnesota South (ftUS)",
  },
  {
    value: "EPSG:26844",
    label: "EPSG:26844 / NAD83(NSRS2007) / Nebraska (ftUS)",
  },
  {
    value: "EPSG:26845",
    label: "EPSG:26845 / NAD83(NSRS2007) / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26846",
    label: "EPSG:26846 / NAD83(NSRS2007) / West Virginia South (ftUS)",
  },
  { value: "EPSG:26847", label: "EPSG:26847 / NAD83 / Maine East (ftUS)" },
  { value: "EPSG:26848", label: "EPSG:26848 / NAD83 / Maine West (ftUS)" },
  { value: "EPSG:26849", label: "EPSG:26849 / NAD83 / Minnesota North (ftUS)" },
  {
    value: "EPSG:26850",
    label: "EPSG:26850 / NAD83 / Minnesota Central (ftUS)",
  },
  { value: "EPSG:26851", label: "EPSG:26851 / NAD83 / Minnesota South (ftUS)" },
  { value: "EPSG:26852", label: "EPSG:26852 / NAD83 / Nebraska (ftUS)" },
  {
    value: "EPSG:26853",
    label: "EPSG:26853 / NAD83 / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26854",
    label: "EPSG:26854 / NAD83 / West Virginia South (ftUS)",
  },
  {
    value: "EPSG:26855",
    label: "EPSG:26855 / NAD83(HARN) / Maine East (ftUS)",
  },
  {
    value: "EPSG:26856",
    label: "EPSG:26856 / NAD83(HARN) / Maine West (ftUS)",
  },
  {
    value: "EPSG:26857",
    label: "EPSG:26857 / NAD83(HARN) / Minnesota North (ftUS)",
  },
  {
    value: "EPSG:26858",
    label: "EPSG:26858 / NAD83(HARN) / Minnesota Central (ftUS)",
  },
  {
    value: "EPSG:26859",
    label: "EPSG:26859 / NAD83(HARN) / Minnesota South (ftUS)",
  },
  { value: "EPSG:26860", label: "EPSG:26860 / NAD83(HARN) / Nebraska (ftUS)" },
  {
    value: "EPSG:26861",
    label: "EPSG:26861 / NAD83(HARN) / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26862",
    label: "EPSG:26862 / NAD83(HARN) / West Virginia South (ftUS)",
  },
  {
    value: "EPSG:26863",
    label: "EPSG:26863 / NAD83(NSRS2007) / Maine East (ftUS)",
  },
  {
    value: "EPSG:26864",
    label: "EPSG:26864 / NAD83(NSRS2007) / Maine West (ftUS)",
  },
  {
    value: "EPSG:26865",
    label: "EPSG:26865 / NAD83(NSRS2007) / Minnesota North (ftUS)",
  },
  {
    value: "EPSG:26866",
    label: "EPSG:26866 / NAD83(NSRS2007) / Minnesota Central (ftUS)",
  },
  {
    value: "EPSG:26867",
    label: "EPSG:26867 / NAD83(NSRS2007) / Minnesota South (ftUS)",
  },
  {
    value: "EPSG:26868",
    label: "EPSG:26868 / NAD83(NSRS2007) / Nebraska (ftUS)",
  },
  {
    value: "EPSG:26869",
    label: "EPSG:26869 / NAD83(NSRS2007) / West Virginia North (ftUS)",
  },
  {
    value: "EPSG:26870",
    label: "EPSG:26870 / NAD83(NSRS2007) / West Virginia South (ftUS)",
  },
  { value: "EPSG:26891", label: "EPSG:26891 / NAD83(CSRS) / MTM zone 11" },
  { value: "EPSG:26892", label: "EPSG:26892 / NAD83(CSRS) / MTM zone 12" },
  { value: "EPSG:26893", label: "EPSG:26893 / NAD83(CSRS) / MTM zone 13" },
  { value: "EPSG:26894", label: "EPSG:26894 / NAD83(CSRS) / MTM zone 14" },
  { value: "EPSG:26895", label: "EPSG:26895 / NAD83(CSRS) / MTM zone 15" },
  { value: "EPSG:26896", label: "EPSG:26896 / NAD83(CSRS) / MTM zone 16" },
  { value: "EPSG:26897", label: "EPSG:26897 / NAD83(CSRS) / MTM zone 17" },
  { value: "EPSG:26898", label: "EPSG:26898 / NAD83(CSRS) / MTM zone 1" },
  { value: "EPSG:26899", label: "EPSG:26899 / NAD83(CSRS) / MTM zone 2" },
  { value: "EPSG:26901", label: "EPSG:26901 / NAD83 / UTM zone 1N" },
  { value: "EPSG:26902", label: "EPSG:26902 / NAD83 / UTM zone 2N" },
  { value: "EPSG:26903", label: "EPSG:26903 / NAD83 / UTM zone 3N" },
  { value: "EPSG:26904", label: "EPSG:26904 / NAD83 / UTM zone 4N" },
  { value: "EPSG:26905", label: "EPSG:26905 / NAD83 / UTM zone 5N" },
  { value: "EPSG:26906", label: "EPSG:26906 / NAD83 / UTM zone 6N" },
  { value: "EPSG:26907", label: "EPSG:26907 / NAD83 / UTM zone 7N" },
  { value: "EPSG:26908", label: "EPSG:26908 / NAD83 / UTM zone 8N" },
  { value: "EPSG:26909", label: "EPSG:26909 / NAD83 / UTM zone 9N" },
  { value: "EPSG:26910", label: "EPSG:26910 / NAD83 / UTM zone 10N" },
  { value: "EPSG:26911", label: "EPSG:26911 / NAD83 / UTM zone 11N" },
  { value: "EPSG:26912", label: "EPSG:26912 / NAD83 / UTM zone 12N" },
  { value: "EPSG:26913", label: "EPSG:26913 / NAD83 / UTM zone 13N" },
  { value: "EPSG:26914", label: "EPSG:26914 / NAD83 / UTM zone 14N" },
  { value: "EPSG:26915", label: "EPSG:26915 / NAD83 / UTM zone 15N" },
  { value: "EPSG:26916", label: "EPSG:26916 / NAD83 / UTM zone 16N" },
  { value: "EPSG:26917", label: "EPSG:26917 / NAD83 / UTM zone 17N" },
  { value: "EPSG:26918", label: "EPSG:26918 / NAD83 / UTM zone 18N" },
  { value: "EPSG:26919", label: "EPSG:26919 / NAD83 / UTM zone 19N" },
  { value: "EPSG:26920", label: "EPSG:26920 / NAD83 / UTM zone 20N" },
  { value: "EPSG:26921", label: "EPSG:26921 / NAD83 / UTM zone 21N" },
  { value: "EPSG:26922", label: "EPSG:26922 / NAD83 / UTM zone 22N" },
  { value: "EPSG:26923", label: "EPSG:26923 / NAD83 / UTM zone 23N" },
  { value: "EPSG:26929", label: "EPSG:26929 / NAD83 / Alabama East" },
  { value: "EPSG:26930", label: "EPSG:26930 / NAD83 / Alabama West" },
  { value: "EPSG:26931", label: "EPSG:26931 / NAD83 / Alaska zone 1" },
  { value: "EPSG:26932", label: "EPSG:26932 / NAD83 / Alaska zone 2" },
  { value: "EPSG:26933", label: "EPSG:26933 / NAD83 / Alaska zone 3" },
  { value: "EPSG:26934", label: "EPSG:26934 / NAD83 / Alaska zone 4" },
  { value: "EPSG:26935", label: "EPSG:26935 / NAD83 / Alaska zone 5" },
  { value: "EPSG:26936", label: "EPSG:26936 / NAD83 / Alaska zone 6" },
  { value: "EPSG:26937", label: "EPSG:26937 / NAD83 / Alaska zone 7" },
  { value: "EPSG:26938", label: "EPSG:26938 / NAD83 / Alaska zone 8" },
  { value: "EPSG:26939", label: "EPSG:26939 / NAD83 / Alaska zone 9" },
  { value: "EPSG:26940", label: "EPSG:26940 / NAD83 / Alaska zone 10" },
  { value: "EPSG:26941", label: "EPSG:26941 / NAD83 / California zone 1" },
  { value: "EPSG:26942", label: "EPSG:26942 / NAD83 / California zone 2" },
  { value: "EPSG:26943", label: "EPSG:26943 / NAD83 / California zone 3" },
  { value: "EPSG:26944", label: "EPSG:26944 / NAD83 / California zone 4" },
  { value: "EPSG:26945", label: "EPSG:26945 / NAD83 / California zone 5" },
  { value: "EPSG:26946", label: "EPSG:26946 / NAD83 / California zone 6" },
  { value: "EPSG:26948", label: "EPSG:26948 / NAD83 / Arizona East" },
  { value: "EPSG:26949", label: "EPSG:26949 / NAD83 / Arizona Central" },
  { value: "EPSG:26950", label: "EPSG:26950 / NAD83 / Arizona West" },
  { value: "EPSG:26951", label: "EPSG:26951 / NAD83 / Arkansas North" },
  { value: "EPSG:26952", label: "EPSG:26952 / NAD83 / Arkansas South" },
  { value: "EPSG:26953", label: "EPSG:26953 / NAD83 / Colorado North" },
  { value: "EPSG:26954", label: "EPSG:26954 / NAD83 / Colorado Central" },
  { value: "EPSG:26955", label: "EPSG:26955 / NAD83 / Colorado South" },
  { value: "EPSG:26956", label: "EPSG:26956 / NAD83 / Connecticut" },
  { value: "EPSG:26957", label: "EPSG:26957 / NAD83 / Delaware" },
  { value: "EPSG:26958", label: "EPSG:26958 / NAD83 / Florida East" },
  { value: "EPSG:26959", label: "EPSG:26959 / NAD83 / Florida West" },
  { value: "EPSG:26960", label: "EPSG:26960 / NAD83 / Florida North" },
  { value: "EPSG:26961", label: "EPSG:26961 / NAD83 / Hawaii zone 1" },
  { value: "EPSG:26962", label: "EPSG:26962 / NAD83 / Hawaii zone 2" },
  { value: "EPSG:26963", label: "EPSG:26963 / NAD83 / Hawaii zone 3" },
  { value: "EPSG:26964", label: "EPSG:26964 / NAD83 / Hawaii zone 4" },
  { value: "EPSG:26965", label: "EPSG:26965 / NAD83 / Hawaii zone 5" },
  { value: "EPSG:26966", label: "EPSG:26966 / NAD83 / Georgia East" },
  { value: "EPSG:26967", label: "EPSG:26967 / NAD83 / Georgia West" },
  { value: "EPSG:26968", label: "EPSG:26968 / NAD83 / Idaho East" },
  { value: "EPSG:26969", label: "EPSG:26969 / NAD83 / Idaho Central" },
  { value: "EPSG:26970", label: "EPSG:26970 / NAD83 / Idaho West" },
  { value: "EPSG:26971", label: "EPSG:26971 / NAD83 / Illinois East" },
  { value: "EPSG:26972", label: "EPSG:26972 / NAD83 / Illinois West" },
  { value: "EPSG:26973", label: "EPSG:26973 / NAD83 / Indiana East" },
  { value: "EPSG:26974", label: "EPSG:26974 / NAD83 / Indiana West" },
  { value: "EPSG:26975", label: "EPSG:26975 / NAD83 / Iowa North" },
  { value: "EPSG:26976", label: "EPSG:26976 / NAD83 / Iowa South" },
  { value: "EPSG:26977", label: "EPSG:26977 / NAD83 / Kansas North" },
  { value: "EPSG:26978", label: "EPSG:26978 / NAD83 / Kansas South" },
  { value: "EPSG:26979", label: "EPSG:26979 / NAD83 / Kentucky North" },
  { value: "EPSG:26980", label: "EPSG:26980 / NAD83 / Kentucky South" },
  { value: "EPSG:26981", label: "EPSG:26981 / NAD83 / Louisiana North" },
  { value: "EPSG:26982", label: "EPSG:26982 / NAD83 / Louisiana South" },
  { value: "EPSG:26983", label: "EPSG:26983 / NAD83 / Maine East" },
  { value: "EPSG:26984", label: "EPSG:26984 / NAD83 / Maine West" },
  { value: "EPSG:26985", label: "EPSG:26985 / NAD83 / Maryland" },
  { value: "EPSG:26986", label: "EPSG:26986 / NAD83 / Massachusetts Mainland" },
  { value: "EPSG:26987", label: "EPSG:26987 / NAD83 / Massachusetts Island" },
  { value: "EPSG:26988", label: "EPSG:26988 / NAD83 / Michigan North" },
  { value: "EPSG:26989", label: "EPSG:26989 / NAD83 / Michigan Central" },
  { value: "EPSG:26990", label: "EPSG:26990 / NAD83 / Michigan South" },
  { value: "EPSG:26991", label: "EPSG:26991 / NAD83 / Minnesota North" },
  { value: "EPSG:26992", label: "EPSG:26992 / NAD83 / Minnesota Central" },
  { value: "EPSG:26993", label: "EPSG:26993 / NAD83 / Minnesota South" },
  { value: "EPSG:26994", label: "EPSG:26994 / NAD83 / Mississippi East" },
  { value: "EPSG:26995", label: "EPSG:26995 / NAD83 / Mississippi West" },
  { value: "EPSG:26996", label: "EPSG:26996 / NAD83 / Missouri East" },
  { value: "EPSG:26997", label: "EPSG:26997 / NAD83 / Missouri Central" },
  { value: "EPSG:26998", label: "EPSG:26998 / NAD83 / Missouri West" },
  { value: "EPSG:27037", label: "EPSG:27037 / Nahrwan 1967 / UTM zone 37N" },
  { value: "EPSG:27038", label: "EPSG:27038 / Nahrwan 1967 / UTM zone 38N" },
  { value: "EPSG:27039", label: "EPSG:27039 / Nahrwan 1967 / UTM zone 39N" },
  { value: "EPSG:27040", label: "EPSG:27040 / Nahrwan 1967 / UTM zone 40N" },
  { value: "EPSG:27120", label: "EPSG:27120 / Naparima 1972 / UTM zone 20N" },
  { value: "EPSG:27200", label: "EPSG:27200 / NZGD49 / New Zealand Map Grid" },
  { value: "EPSG:27205", label: "EPSG:27205 / NZGD49 / Mount Eden Circuit" },
  { value: "EPSG:27206", label: "EPSG:27206 / NZGD49 / Bay of Plenty Circuit" },
  { value: "EPSG:27207", label: "EPSG:27207 / NZGD49 / Poverty Bay Circuit" },
  { value: "EPSG:27208", label: "EPSG:27208 / NZGD49 / Hawkes Bay Circuit" },
  { value: "EPSG:27209", label: "EPSG:27209 / NZGD49 / Taranaki Circuit" },
  { value: "EPSG:27210", label: "EPSG:27210 / NZGD49 / Tuhirangi Circuit" },
  { value: "EPSG:27211", label: "EPSG:27211 / NZGD49 / Wanganui Circuit" },
  { value: "EPSG:27212", label: "EPSG:27212 / NZGD49 / Wairarapa Circuit" },
  { value: "EPSG:27213", label: "EPSG:27213 / NZGD49 / Wellington Circuit" },
  { value: "EPSG:27214", label: "EPSG:27214 / NZGD49 / Collingwood Circuit" },
  { value: "EPSG:27215", label: "EPSG:27215 / NZGD49 / Nelson Circuit" },
  { value: "EPSG:27216", label: "EPSG:27216 / NZGD49 / Karamea Circuit" },
  { value: "EPSG:27217", label: "EPSG:27217 / NZGD49 / Buller Circuit" },
  { value: "EPSG:27218", label: "EPSG:27218 / NZGD49 / Grey Circuit" },
  { value: "EPSG:27219", label: "EPSG:27219 / NZGD49 / Amuri Circuit" },
  { value: "EPSG:27220", label: "EPSG:27220 / NZGD49 / Marlborough Circuit" },
  { value: "EPSG:27221", label: "EPSG:27221 / NZGD49 / Hokitika Circuit" },
  { value: "EPSG:27222", label: "EPSG:27222 / NZGD49 / Okarito Circuit" },
  { value: "EPSG:27223", label: "EPSG:27223 / NZGD49 / Jacksons Bay Circuit" },
  {
    value: "EPSG:27224",
    label: "EPSG:27224 / NZGD49 / Mount Pleasant Circuit",
  },
  { value: "EPSG:27225", label: "EPSG:27225 / NZGD49 / Gawler Circuit" },
  { value: "EPSG:27226", label: "EPSG:27226 / NZGD49 / Timaru Circuit" },
  { value: "EPSG:27227", label: "EPSG:27227 / NZGD49 / Lindis Peak Circuit" },
  {
    value: "EPSG:27228",
    label: "EPSG:27228 / NZGD49 / Mount Nicholas Circuit",
  },
  { value: "EPSG:27229", label: "EPSG:27229 / NZGD49 / Mount York Circuit" },
  {
    value: "EPSG:27230",
    label: "EPSG:27230 / NZGD49 / Observation Point Circuit",
  },
  { value: "EPSG:27231", label: "EPSG:27231 / NZGD49 / North Taieri Circuit" },
  { value: "EPSG:27232", label: "EPSG:27232 / NZGD49 / Bluff Circuit" },
  { value: "EPSG:27258", label: "EPSG:27258 / NZGD49 / UTM zone 58S" },
  { value: "EPSG:27259", label: "EPSG:27259 / NZGD49 / UTM zone 59S" },
  { value: "EPSG:27260", label: "EPSG:27260 / NZGD49 / UTM zone 60S" },
  { value: "EPSG:27291", label: "EPSG:27291 / NZGD49 / North Island Grid" },
  { value: "EPSG:27292", label: "EPSG:27292 / NZGD49 / South Island Grid" },
  { value: "EPSG:27391", label: "EPSG:27391 / NGO 1948 (Oslo) / NGO zone I" },
  { value: "EPSG:27392", label: "EPSG:27392 / NGO 1948 (Oslo) / NGO zone II" },
  { value: "EPSG:27393", label: "EPSG:27393 / NGO 1948 (Oslo) / NGO zone III" },
  { value: "EPSG:27394", label: "EPSG:27394 / NGO 1948 (Oslo) / NGO zone IV" },
  { value: "EPSG:27395", label: "EPSG:27395 / NGO 1948 (Oslo) / NGO zone V" },
  { value: "EPSG:27396", label: "EPSG:27396 / NGO 1948 (Oslo) / NGO zone VI" },
  { value: "EPSG:27397", label: "EPSG:27397 / NGO 1948 (Oslo) / NGO zone VII" },
  {
    value: "EPSG:27398",
    label: "EPSG:27398 / NGO 1948 (Oslo) / NGO zone VIII",
  },
  { value: "EPSG:27429", label: "EPSG:27429 / Datum 73 / UTM zone 29N" },
  {
    value: "EPSG:27492",
    label: "EPSG:27492 / Datum 73 / Modified Portuguese Grid",
  },
  {
    value: "EPSG:27493",
    label: "EPSG:27493 / Datum 73 / Modified Portuguese Grid",
  },
  { value: "EPSG:27500", label: "EPSG:27500 / ATF (Paris) / Nord de Guerre" },
  {
    value: "EPSG:27561",
    label: "EPSG:27561 / NTF (Paris) / Lambert Nord France",
  },
  {
    value: "EPSG:27562",
    label: "EPSG:27562 / NTF (Paris) / Lambert Centre France",
  },
  {
    value: "EPSG:27563",
    label: "EPSG:27563 / NTF (Paris) / Lambert Sud France",
  },
  { value: "EPSG:27564", label: "EPSG:27564 / NTF (Paris) / Lambert Corse" },
  { value: "EPSG:27571", label: "EPSG:27571 / NTF (Paris) / Lambert zone I" },
  { value: "EPSG:27572", label: "EPSG:27572 / NTF (Paris) / Lambert zone II" },
  { value: "EPSG:27573", label: "EPSG:27573 / NTF (Paris) / Lambert zone III" },
  { value: "EPSG:27574", label: "EPSG:27574 / NTF (Paris) / Lambert zone IV" },
  { value: "EPSG:27581", label: "EPSG:27581 / NTF (Paris) / France I" },
  { value: "EPSG:27582", label: "EPSG:27582 / NTF (Paris) / France II" },
  { value: "EPSG:27583", label: "EPSG:27583 / NTF (Paris) / France III" },
  { value: "EPSG:27584", label: "EPSG:27584 / NTF (Paris) / France IV" },
  { value: "EPSG:27591", label: "EPSG:27591 / NTF (Paris) / Nord France" },
  { value: "EPSG:27592", label: "EPSG:27592 / NTF (Paris) / Centre France" },
  { value: "EPSG:27593", label: "EPSG:27593 / NTF (Paris) / Sud France" },
  { value: "EPSG:27594", label: "EPSG:27594 / NTF (Paris) / Corse" },
  { value: "EPSG:27700", label: "EPSG:27700 / OSGB36 / British National Grid" },
  {
    value: "EPSG:28191",
    label: "EPSG:28191 / Palestine 1923 / Palestine Grid",
  },
  {
    value: "EPSG:28192",
    label: "EPSG:28192 / Palestine 1923 / Palestine Belt",
  },
  {
    value: "EPSG:28193",
    label: "EPSG:28193 / Palestine 1923 / Israeli CS Grid",
  },
  { value: "EPSG:28232", label: "EPSG:28232 / Pointe Noire / UTM zone 32S" },
  { value: "EPSG:28348", label: "EPSG:28348 / GDA94 / MGA zone 48" },
  { value: "EPSG:28349", label: "EPSG:28349 / GDA94 / MGA zone 49" },
  { value: "EPSG:28350", label: "EPSG:28350 / GDA94 / MGA zone 50" },
  { value: "EPSG:28351", label: "EPSG:28351 / GDA94 / MGA zone 51" },
  { value: "EPSG:28352", label: "EPSG:28352 / GDA94 / MGA zone 52" },
  { value: "EPSG:28353", label: "EPSG:28353 / GDA94 / MGA zone 53" },
  { value: "EPSG:28354", label: "EPSG:28354 / GDA94 / MGA zone 54" },
  { value: "EPSG:28355", label: "EPSG:28355 / GDA94 / MGA zone 55" },
  { value: "EPSG:28356", label: "EPSG:28356 / GDA94 / MGA zone 56" },
  { value: "EPSG:28357", label: "EPSG:28357 / GDA94 / MGA zone 57" },
  { value: "EPSG:28358", label: "EPSG:28358 / GDA94 / MGA zone 58" },
  {
    value: "EPSG:28402",
    label: "EPSG:28402 / Pulkovo 1942 / Gauss-Kruger zone 2",
  },
  {
    value: "EPSG:28403",
    label: "EPSG:28403 / Pulkovo 1942 / Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:28404",
    label: "EPSG:28404 / Pulkovo 1942 / Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:28405",
    label: "EPSG:28405 / Pulkovo 1942 / Gauss-Kruger zone 5",
  },
  {
    value: "EPSG:28406",
    label: "EPSG:28406 / Pulkovo 1942 / Gauss-Kruger zone 6",
  },
  {
    value: "EPSG:28407",
    label: "EPSG:28407 / Pulkovo 1942 / Gauss-Kruger zone 7",
  },
  {
    value: "EPSG:28408",
    label: "EPSG:28408 / Pulkovo 1942 / Gauss-Kruger zone 8",
  },
  {
    value: "EPSG:28409",
    label: "EPSG:28409 / Pulkovo 1942 / Gauss-Kruger zone 9",
  },
  {
    value: "EPSG:28410",
    label: "EPSG:28410 / Pulkovo 1942 / Gauss-Kruger zone 10",
  },
  {
    value: "EPSG:28411",
    label: "EPSG:28411 / Pulkovo 1942 / Gauss-Kruger zone 11",
  },
  {
    value: "EPSG:28412",
    label: "EPSG:28412 / Pulkovo 1942 / Gauss-Kruger zone 12",
  },
  {
    value: "EPSG:28413",
    label: "EPSG:28413 / Pulkovo 1942 / Gauss-Kruger zone 13",
  },
  {
    value: "EPSG:28414",
    label: "EPSG:28414 / Pulkovo 1942 / Gauss-Kruger zone 14",
  },
  {
    value: "EPSG:28415",
    label: "EPSG:28415 / Pulkovo 1942 / Gauss-Kruger zone 15",
  },
  {
    value: "EPSG:28416",
    label: "EPSG:28416 / Pulkovo 1942 / Gauss-Kruger zone 16",
  },
  {
    value: "EPSG:28417",
    label: "EPSG:28417 / Pulkovo 1942 / Gauss-Kruger zone 17",
  },
  {
    value: "EPSG:28418",
    label: "EPSG:28418 / Pulkovo 1942 / Gauss-Kruger zone 18",
  },
  {
    value: "EPSG:28419",
    label: "EPSG:28419 / Pulkovo 1942 / Gauss-Kruger zone 19",
  },
  {
    value: "EPSG:28420",
    label: "EPSG:28420 / Pulkovo 1942 / Gauss-Kruger zone 20",
  },
  {
    value: "EPSG:28421",
    label: "EPSG:28421 / Pulkovo 1942 / Gauss-Kruger zone 21",
  },
  {
    value: "EPSG:28422",
    label: "EPSG:28422 / Pulkovo 1942 / Gauss-Kruger zone 22",
  },
  {
    value: "EPSG:28423",
    label: "EPSG:28423 / Pulkovo 1942 / Gauss-Kruger zone 23",
  },
  {
    value: "EPSG:28424",
    label: "EPSG:28424 / Pulkovo 1942 / Gauss-Kruger zone 24",
  },
  {
    value: "EPSG:28425",
    label: "EPSG:28425 / Pulkovo 1942 / Gauss-Kruger zone 25",
  },
  {
    value: "EPSG:28426",
    label: "EPSG:28426 / Pulkovo 1942 / Gauss-Kruger zone 26",
  },
  {
    value: "EPSG:28427",
    label: "EPSG:28427 / Pulkovo 1942 / Gauss-Kruger zone 27",
  },
  {
    value: "EPSG:28428",
    label: "EPSG:28428 / Pulkovo 1942 / Gauss-Kruger zone 28",
  },
  {
    value: "EPSG:28429",
    label: "EPSG:28429 / Pulkovo 1942 / Gauss-Kruger zone 29",
  },
  {
    value: "EPSG:28430",
    label: "EPSG:28430 / Pulkovo 1942 / Gauss-Kruger zone 30",
  },
  {
    value: "EPSG:28431",
    label: "EPSG:28431 / Pulkovo 1942 / Gauss-Kruger zone 31",
  },
  {
    value: "EPSG:28432",
    label: "EPSG:28432 / Pulkovo 1942 / Gauss-Kruger zone 32",
  },
  { value: "EPSG:28462", label: "EPSG:28462 / Pulkovo 1942 / Gauss-Kruger 2N" },
  { value: "EPSG:28463", label: "EPSG:28463 / Pulkovo 1942 / Gauss-Kruger 3N" },
  { value: "EPSG:28464", label: "EPSG:28464 / Pulkovo 1942 / Gauss-Kruger 4N" },
  { value: "EPSG:28465", label: "EPSG:28465 / Pulkovo 1942 / Gauss-Kruger 5N" },
  { value: "EPSG:28466", label: "EPSG:28466 / Pulkovo 1942 / Gauss-Kruger 6N" },
  { value: "EPSG:28467", label: "EPSG:28467 / Pulkovo 1942 / Gauss-Kruger 7N" },
  { value: "EPSG:28468", label: "EPSG:28468 / Pulkovo 1942 / Gauss-Kruger 8N" },
  { value: "EPSG:28469", label: "EPSG:28469 / Pulkovo 1942 / Gauss-Kruger 9N" },
  {
    value: "EPSG:28470",
    label: "EPSG:28470 / Pulkovo 1942 / Gauss-Kruger 10N",
  },
  {
    value: "EPSG:28471",
    label: "EPSG:28471 / Pulkovo 1942 / Gauss-Kruger 11N",
  },
  {
    value: "EPSG:28472",
    label: "EPSG:28472 / Pulkovo 1942 / Gauss-Kruger 12N",
  },
  {
    value: "EPSG:28473",
    label: "EPSG:28473 / Pulkovo 1942 / Gauss-Kruger 13N",
  },
  {
    value: "EPSG:28474",
    label: "EPSG:28474 / Pulkovo 1942 / Gauss-Kruger 14N",
  },
  {
    value: "EPSG:28475",
    label: "EPSG:28475 / Pulkovo 1942 / Gauss-Kruger 15N",
  },
  {
    value: "EPSG:28476",
    label: "EPSG:28476 / Pulkovo 1942 / Gauss-Kruger 16N",
  },
  {
    value: "EPSG:28477",
    label: "EPSG:28477 / Pulkovo 1942 / Gauss-Kruger 17N",
  },
  {
    value: "EPSG:28478",
    label: "EPSG:28478 / Pulkovo 1942 / Gauss-Kruger 18N",
  },
  {
    value: "EPSG:28479",
    label: "EPSG:28479 / Pulkovo 1942 / Gauss-Kruger 19N",
  },
  {
    value: "EPSG:28480",
    label: "EPSG:28480 / Pulkovo 1942 / Gauss-Kruger 20N",
  },
  {
    value: "EPSG:28481",
    label: "EPSG:28481 / Pulkovo 1942 / Gauss-Kruger 21N",
  },
  {
    value: "EPSG:28482",
    label: "EPSG:28482 / Pulkovo 1942 / Gauss-Kruger 22N",
  },
  {
    value: "EPSG:28483",
    label: "EPSG:28483 / Pulkovo 1942 / Gauss-Kruger 23N",
  },
  {
    value: "EPSG:28484",
    label: "EPSG:28484 / Pulkovo 1942 / Gauss-Kruger 24N",
  },
  {
    value: "EPSG:28485",
    label: "EPSG:28485 / Pulkovo 1942 / Gauss-Kruger 25N",
  },
  {
    value: "EPSG:28486",
    label: "EPSG:28486 / Pulkovo 1942 / Gauss-Kruger 26N",
  },
  {
    value: "EPSG:28487",
    label: "EPSG:28487 / Pulkovo 1942 / Gauss-Kruger 27N",
  },
  {
    value: "EPSG:28488",
    label: "EPSG:28488 / Pulkovo 1942 / Gauss-Kruger 28N",
  },
  {
    value: "EPSG:28489",
    label: "EPSG:28489 / Pulkovo 1942 / Gauss-Kruger 29N",
  },
  {
    value: "EPSG:28490",
    label: "EPSG:28490 / Pulkovo 1942 / Gauss-Kruger 30N",
  },
  {
    value: "EPSG:28491",
    label: "EPSG:28491 / Pulkovo 1942 / Gauss-Kruger 31N",
  },
  {
    value: "EPSG:28492",
    label: "EPSG:28492 / Pulkovo 1942 / Gauss-Kruger 32N",
  },
  {
    value: "EPSG:28600",
    label: "EPSG:28600 / Qatar 1974 / Qatar National Grid",
  },
  { value: "EPSG:28991", label: "EPSG:28991 / Amersfoort / RD Old" },
  { value: "EPSG:28992", label: "EPSG:28992 / Amersfoort / RD New" },
  { value: "EPSG:29100", label: "EPSG:29100 / SAD69 / Brazil Polyconic" },
  { value: "EPSG:29101", label: "EPSG:29101 / SAD69 / Brazil Polyconic" },
  { value: "EPSG:29118", label: "EPSG:29118 / SAD69 / UTM zone 18N" },
  { value: "EPSG:29119", label: "EPSG:29119 / SAD69 / UTM zone 19N" },
  { value: "EPSG:29120", label: "EPSG:29120 / SAD69 / UTM zone 20N" },
  { value: "EPSG:29121", label: "EPSG:29121 / SAD69 / UTM zone 21N" },
  { value: "EPSG:29122", label: "EPSG:29122 / SAD69 / UTM zone 22N" },
  { value: "EPSG:29168", label: "EPSG:29168 / SAD69 / UTM zone 18N" },
  { value: "EPSG:29169", label: "EPSG:29169 / SAD69 / UTM zone 19N" },
  { value: "EPSG:29170", label: "EPSG:29170 / SAD69 / UTM zone 20N" },
  { value: "EPSG:29171", label: "EPSG:29171 / SAD69 / UTM zone 21N" },
  { value: "EPSG:29172", label: "EPSG:29172 / SAD69 / UTM zone 22N" },
  { value: "EPSG:29177", label: "EPSG:29177 / SAD69 / UTM zone 17S" },
  { value: "EPSG:29178", label: "EPSG:29178 / SAD69 / UTM zone 18S" },
  { value: "EPSG:29179", label: "EPSG:29179 / SAD69 / UTM zone 19S" },
  { value: "EPSG:29180", label: "EPSG:29180 / SAD69 / UTM zone 20S" },
  { value: "EPSG:29181", label: "EPSG:29181 / SAD69 / UTM zone 21S" },
  { value: "EPSG:29182", label: "EPSG:29182 / SAD69 / UTM zone 22S" },
  { value: "EPSG:29183", label: "EPSG:29183 / SAD69 / UTM zone 23S" },
  { value: "EPSG:29184", label: "EPSG:29184 / SAD69 / UTM zone 24S" },
  { value: "EPSG:29185", label: "EPSG:29185 / SAD69 / UTM zone 25S" },
  { value: "EPSG:29187", label: "EPSG:29187 / SAD69 / UTM zone 17S" },
  { value: "EPSG:29188", label: "EPSG:29188 / SAD69 / UTM zone 18S" },
  { value: "EPSG:29189", label: "EPSG:29189 / SAD69 / UTM zone 19S" },
  { value: "EPSG:29190", label: "EPSG:29190 / SAD69 / UTM zone 20S" },
  { value: "EPSG:29191", label: "EPSG:29191 / SAD69 / UTM zone 21S" },
  { value: "EPSG:29192", label: "EPSG:29192 / SAD69 / UTM zone 22S" },
  { value: "EPSG:29193", label: "EPSG:29193 / SAD69 / UTM zone 23S" },
  { value: "EPSG:29194", label: "EPSG:29194 / SAD69 / UTM zone 24S" },
  { value: "EPSG:29195", label: "EPSG:29195 / SAD69 / UTM zone 25S" },
  {
    value: "EPSG:29220",
    label: "EPSG:29220 / Sapper Hill 1943 / UTM zone 20S",
  },
  {
    value: "EPSG:29221",
    label: "EPSG:29221 / Sapper Hill 1943 / UTM zone 21S",
  },
  { value: "EPSG:29333", label: "EPSG:29333 / Schwarzeck / UTM zone 33S" },
  { value: "EPSG:29371", label: "EPSG:29371 / Schwarzeck / Lo22/11" },
  { value: "EPSG:29373", label: "EPSG:29373 / Schwarzeck / Lo22/13" },
  { value: "EPSG:29375", label: "EPSG:29375 / Schwarzeck / Lo22/15" },
  { value: "EPSG:29377", label: "EPSG:29377 / Schwarzeck / Lo22/17" },
  { value: "EPSG:29379", label: "EPSG:29379 / Schwarzeck / Lo22/19" },
  { value: "EPSG:29381", label: "EPSG:29381 / Schwarzeck / Lo22/21" },
  { value: "EPSG:29383", label: "EPSG:29383 / Schwarzeck / Lo22/23" },
  { value: "EPSG:29385", label: "EPSG:29385 / Schwarzeck / Lo22/25" },
  { value: "EPSG:29635", label: "EPSG:29635 / Sudan / UTM zone 35N" },
  { value: "EPSG:29636", label: "EPSG:29636 / Sudan / UTM zone 36N" },
  {
    value: "EPSG:29700",
    label: "EPSG:29700 / Tananarive (Paris) / Laborde Grid",
  },
  {
    value: "EPSG:29701",
    label: "EPSG:29701 / Tananarive (Paris) / Laborde Grid",
  },
  {
    value: "EPSG:29702",
    label: "EPSG:29702 / Tananarive (Paris) / Laborde Grid approximation",
  },
  { value: "EPSG:29738", label: "EPSG:29738 / Tananarive / UTM zone 38S" },
  { value: "EPSG:29739", label: "EPSG:29739 / Tananarive / UTM zone 39S" },
  { value: "EPSG:29849", label: "EPSG:29849 / Timbalai 1948 / UTM zone 49N" },
  { value: "EPSG:29850", label: "EPSG:29850 / Timbalai 1948 / UTM zone 50N" },
  {
    value: "EPSG:29871",
    label: "EPSG:29871 / Timbalai 1948 / RSO Borneo (ch)",
  },
  {
    value: "EPSG:29872",
    label: "EPSG:29872 / Timbalai 1948 / RSO Borneo (ftSe)",
  },
  { value: "EPSG:29873", label: "EPSG:29873 / Timbalai 1948 / RSO Borneo (m)" },
  {
    value: "EPSG:29874",
    label: "EPSG:29874 / Timbalai 1948 / RSO Sarawak LSD (m)",
  },
  { value: "EPSG:29900", label: "EPSG:29900 / TM65 / Irish National Grid" },
  {
    value: "EPSG:29901",
    label: "EPSG:29901 / OSNI 1952 / Irish National Grid",
  },
  { value: "EPSG:29902", label: "EPSG:29902 / TM65 / Irish Grid" },
  { value: "EPSG:29903", label: "EPSG:29903 / TM75 / Irish Grid" },
  {
    value: "EPSG:30161",
    label: "EPSG:30161 / Tokyo / Japan Plane Rectangular CS I",
  },
  {
    value: "EPSG:30162",
    label: "EPSG:30162 / Tokyo / Japan Plane Rectangular CS II",
  },
  {
    value: "EPSG:30163",
    label: "EPSG:30163 / Tokyo / Japan Plane Rectangular CS III",
  },
  {
    value: "EPSG:30164",
    label: "EPSG:30164 / Tokyo / Japan Plane Rectangular CS IV",
  },
  {
    value: "EPSG:30165",
    label: "EPSG:30165 / Tokyo / Japan Plane Rectangular CS V",
  },
  {
    value: "EPSG:30166",
    label: "EPSG:30166 / Tokyo / Japan Plane Rectangular CS VI",
  },
  {
    value: "EPSG:30167",
    label: "EPSG:30167 / Tokyo / Japan Plane Rectangular CS VII",
  },
  {
    value: "EPSG:30168",
    label: "EPSG:30168 / Tokyo / Japan Plane Rectangular CS VIII",
  },
  {
    value: "EPSG:30169",
    label: "EPSG:30169 / Tokyo / Japan Plane Rectangular CS IX",
  },
  {
    value: "EPSG:30170",
    label: "EPSG:30170 / Tokyo / Japan Plane Rectangular CS X",
  },
  {
    value: "EPSG:30171",
    label: "EPSG:30171 / Tokyo / Japan Plane Rectangular CS XI",
  },
  {
    value: "EPSG:30172",
    label: "EPSG:30172 / Tokyo / Japan Plane Rectangular CS XII",
  },
  {
    value: "EPSG:30173",
    label: "EPSG:30173 / Tokyo / Japan Plane Rectangular CS XIII",
  },
  {
    value: "EPSG:30174",
    label: "EPSG:30174 / Tokyo / Japan Plane Rectangular CS XIV",
  },
  {
    value: "EPSG:30175",
    label: "EPSG:30175 / Tokyo / Japan Plane Rectangular CS XV",
  },
  {
    value: "EPSG:30176",
    label: "EPSG:30176 / Tokyo / Japan Plane Rectangular CS XVI",
  },
  {
    value: "EPSG:30177",
    label: "EPSG:30177 / Tokyo / Japan Plane Rectangular CS XVII",
  },
  {
    value: "EPSG:30178",
    label: "EPSG:30178 / Tokyo / Japan Plane Rectangular CS XVIII",
  },
  {
    value: "EPSG:30179",
    label: "EPSG:30179 / Tokyo / Japan Plane Rectangular CS XIX",
  },
  { value: "EPSG:30200", label: "EPSG:30200 / Trinidad 1903 / Trinidad Grid" },
  { value: "EPSG:30339", label: "EPSG:30339 / TC(1948) / UTM zone 39N" },
  { value: "EPSG:30340", label: "EPSG:30340 / TC(1948) / UTM zone 40N" },
  {
    value: "EPSG:30491",
    label: "EPSG:30491 / Voirol 1875 / Nord Algerie (ancienne)",
  },
  {
    value: "EPSG:30492",
    label: "EPSG:30492 / Voirol 1875 / Sud Algerie (ancienne)",
  },
  {
    value: "EPSG:30493",
    label: "EPSG:30493 / Voirol 1879 / Nord Algerie (ancienne)",
  },
  {
    value: "EPSG:30494",
    label: "EPSG:30494 / Voirol 1879 / Sud Algerie (ancienne)",
  },
  {
    value: "EPSG:30729",
    label: "EPSG:30729 / Nord Sahara 1959 / UTM zone 29N",
  },
  {
    value: "EPSG:30730",
    label: "EPSG:30730 / Nord Sahara 1959 / UTM zone 30N",
  },
  {
    value: "EPSG:30731",
    label: "EPSG:30731 / Nord Sahara 1959 / UTM zone 31N",
  },
  {
    value: "EPSG:30732",
    label: "EPSG:30732 / Nord Sahara 1959 / UTM zone 32N",
  },
  {
    value: "EPSG:30791",
    label: "EPSG:30791 / Nord Sahara 1959 / Nord Algerie",
  },
  { value: "EPSG:30792", label: "EPSG:30792 / Nord Sahara 1959 / Sud Algerie" },
  { value: "EPSG:30800", label: "EPSG:30800 / RT38 2.5 gon W" },
  { value: "EPSG:31028", label: "EPSG:31028 / Yoff / UTM zone 28N" },
  { value: "EPSG:31121", label: "EPSG:31121 / Zanderij / UTM zone 21N" },
  { value: "EPSG:31154", label: "EPSG:31154 / Zanderij / TM 54 NW" },
  { value: "EPSG:31170", label: "EPSG:31170 / Zanderij / Suriname Old TM" },
  { value: "EPSG:31171", label: "EPSG:31171 / Zanderij / Suriname TM" },
  {
    value: "EPSG:31251",
    label: "EPSG:31251 / MGI (Ferro) / Austria GK West Zone",
  },
  {
    value: "EPSG:31252",
    label: "EPSG:31252 / MGI (Ferro) / Austria GK Central Zone",
  },
  {
    value: "EPSG:31253",
    label: "EPSG:31253 / MGI (Ferro) / Austria GK East Zone",
  },
  { value: "EPSG:31254", label: "EPSG:31254 / MGI / Austria GK West" },
  { value: "EPSG:31255", label: "EPSG:31255 / MGI / Austria GK Central" },
  { value: "EPSG:31256", label: "EPSG:31256 / MGI / Austria GK East" },
  { value: "EPSG:31257", label: "EPSG:31257 / MGI / Austria GK M28" },
  { value: "EPSG:31258", label: "EPSG:31258 / MGI / Austria GK M31" },
  { value: "EPSG:31259", label: "EPSG:31259 / MGI / Austria GK M34" },
  { value: "EPSG:31265", label: "EPSG:31265 / MGI / 3-degree Gauss zone 5" },
  { value: "EPSG:31266", label: "EPSG:31266 / MGI / 3-degree Gauss zone 6" },
  { value: "EPSG:31267", label: "EPSG:31267 / MGI / 3-degree Gauss zone 7" },
  { value: "EPSG:31268", label: "EPSG:31268 / MGI / 3-degree Gauss zone 8" },
  { value: "EPSG:31275", label: "EPSG:31275 / MGI / Balkans zone 5" },
  { value: "EPSG:31276", label: "EPSG:31276 / MGI / Balkans zone 6" },
  { value: "EPSG:31277", label: "EPSG:31277 / MGI / Balkans zone 7" },
  { value: "EPSG:31278", label: "EPSG:31278 / MGI / Balkans zone 8" },
  { value: "EPSG:31279", label: "EPSG:31279 / MGI / Balkans zone 8" },
  {
    value: "EPSG:31281",
    label: "EPSG:31281 / MGI (Ferro) / Austria West Zone",
  },
  {
    value: "EPSG:31282",
    label: "EPSG:31282 / MGI (Ferro) / Austria Central Zone",
  },
  {
    value: "EPSG:31283",
    label: "EPSG:31283 / MGI (Ferro) / Austria East Zone",
  },
  { value: "EPSG:31284", label: "EPSG:31284 / MGI / Austria M28" },
  { value: "EPSG:31285", label: "EPSG:31285 / MGI / Austria M31" },
  { value: "EPSG:31286", label: "EPSG:31286 / MGI / Austria M34" },
  { value: "EPSG:31287", label: "EPSG:31287 / MGI / Austria Lambert" },
  { value: "EPSG:31288", label: "EPSG:31288 / MGI (Ferro) / Austria zone M28" },
  { value: "EPSG:31289", label: "EPSG:31289 / MGI (Ferro) / Austria zone M31" },
  { value: "EPSG:31290", label: "EPSG:31290 / MGI (Ferro) / Austria zone M34" },
  {
    value: "EPSG:31291",
    label: "EPSG:31291 / MGI (Ferro) / Austria West Zone",
  },
  {
    value: "EPSG:31292",
    label: "EPSG:31292 / MGI (Ferro) / Austria Central Zone",
  },
  {
    value: "EPSG:31293",
    label: "EPSG:31293 / MGI (Ferro) / Austria East Zone",
  },
  { value: "EPSG:31294", label: "EPSG:31294 / MGI / M28" },
  { value: "EPSG:31295", label: "EPSG:31295 / MGI / M31" },
  { value: "EPSG:31296", label: "EPSG:31296 / MGI / M34" },
  { value: "EPSG:31297", label: "EPSG:31297 / MGI / Austria Lambert" },
  { value: "EPSG:31300", label: "EPSG:31300 / BD72 / Belge Lambert 72" },
  { value: "EPSG:31370", label: "EPSG:31370 / BD72 / Belgian Lambert 72" },
  { value: "EPSG:31461", label: "EPSG:31461 / DHDN / 3-degree Gauss zone 1" },
  { value: "EPSG:31462", label: "EPSG:31462 / DHDN / 3-degree Gauss zone 2" },
  { value: "EPSG:31463", label: "EPSG:31463 / DHDN / 3-degree Gauss zone 3" },
  { value: "EPSG:31464", label: "EPSG:31464 / DHDN / 3-degree Gauss zone 4" },
  { value: "EPSG:31465", label: "EPSG:31465 / DHDN / 3-degree Gauss zone 5" },
  {
    value: "EPSG:31466",
    label: "EPSG:31466 / DHDN / 3-degree Gauss-Kruger zone 2",
  },
  {
    value: "EPSG:31467",
    label: "EPSG:31467 / DHDN / 3-degree Gauss-Kruger zone 3",
  },
  {
    value: "EPSG:31468",
    label: "EPSG:31468 / DHDN / 3-degree Gauss-Kruger zone 4",
  },
  {
    value: "EPSG:31469",
    label: "EPSG:31469 / DHDN / 3-degree Gauss-Kruger zone 5",
  },
  { value: "EPSG:31528", label: "EPSG:31528 / Conakry 1905 / UTM zone 28N" },
  { value: "EPSG:31529", label: "EPSG:31529 / Conakry 1905 / UTM zone 29N" },
  {
    value: "EPSG:31600",
    label: "EPSG:31600 / Dealul Piscului 1930 / Stereo 33",
  },
  {
    value: "EPSG:31700",
    label: "EPSG:31700 / Dealul Piscului 1970/ Stereo 70",
  },
  { value: "EPSG:31838", label: "EPSG:31838 / NGN / UTM zone 38N" },
  { value: "EPSG:31839", label: "EPSG:31839 / NGN / UTM zone 39N" },
  { value: "EPSG:31900", label: "EPSG:31900 / KUDAMS / KTM" },
  { value: "EPSG:31901", label: "EPSG:31901 / KUDAMS / KTM" },
  { value: "EPSG:31965", label: "EPSG:31965 / SIRGAS 2000 / UTM zone 11N" },
  { value: "EPSG:31966", label: "EPSG:31966 / SIRGAS 2000 / UTM zone 12N" },
  { value: "EPSG:31967", label: "EPSG:31967 / SIRGAS 2000 / UTM zone 13N" },
  { value: "EPSG:31968", label: "EPSG:31968 / SIRGAS 2000 / UTM zone 14N" },
  { value: "EPSG:31969", label: "EPSG:31969 / SIRGAS 2000 / UTM zone 15N" },
  { value: "EPSG:31970", label: "EPSG:31970 / SIRGAS 2000 / UTM zone 16N" },
  { value: "EPSG:31971", label: "EPSG:31971 / SIRGAS 2000 / UTM zone 17N" },
  { value: "EPSG:31972", label: "EPSG:31972 / SIRGAS 2000 / UTM zone 18N" },
  { value: "EPSG:31973", label: "EPSG:31973 / SIRGAS 2000 / UTM zone 19N" },
  { value: "EPSG:31974", label: "EPSG:31974 / SIRGAS 2000 / UTM zone 20N" },
  { value: "EPSG:31975", label: "EPSG:31975 / SIRGAS 2000 / UTM zone 21N" },
  { value: "EPSG:31976", label: "EPSG:31976 / SIRGAS 2000 / UTM zone 22N" },
  { value: "EPSG:31977", label: "EPSG:31977 / SIRGAS 2000 / UTM zone 17S" },
  { value: "EPSG:31978", label: "EPSG:31978 / SIRGAS 2000 / UTM zone 18S" },
  { value: "EPSG:31979", label: "EPSG:31979 / SIRGAS 2000 / UTM zone 19S" },
  { value: "EPSG:31980", label: "EPSG:31980 / SIRGAS 2000 / UTM zone 20S" },
  { value: "EPSG:31981", label: "EPSG:31981 / SIRGAS 2000 / UTM zone 21S" },
  { value: "EPSG:31982", label: "EPSG:31982 / SIRGAS 2000 / UTM zone 22S" },
  { value: "EPSG:31983", label: "EPSG:31983 / SIRGAS 2000 / UTM zone 23S" },
  { value: "EPSG:31984", label: "EPSG:31984 / SIRGAS 2000 / UTM zone 24S" },
  { value: "EPSG:31985", label: "EPSG:31985 / SIRGAS 2000 / UTM zone 25S" },
  { value: "EPSG:31986", label: "EPSG:31986 / SIRGAS 1995 / UTM zone 17N" },
  { value: "EPSG:31987", label: "EPSG:31987 / SIRGAS 1995 / UTM zone 18N" },
  { value: "EPSG:31988", label: "EPSG:31988 / SIRGAS 1995 / UTM zone 19N" },
  { value: "EPSG:31989", label: "EPSG:31989 / SIRGAS 1995 / UTM zone 20N" },
  { value: "EPSG:31990", label: "EPSG:31990 / SIRGAS 1995 / UTM zone 21N" },
  { value: "EPSG:31991", label: "EPSG:31991 / SIRGAS 1995 / UTM zone 22N" },
  { value: "EPSG:31992", label: "EPSG:31992 / SIRGAS 1995 / UTM zone 17S" },
  { value: "EPSG:31993", label: "EPSG:31993 / SIRGAS 1995 / UTM zone 18S" },
  { value: "EPSG:31994", label: "EPSG:31994 / SIRGAS 1995 / UTM zone 19S" },
  { value: "EPSG:31995", label: "EPSG:31995 / SIRGAS 1995 / UTM zone 20S" },
  { value: "EPSG:31996", label: "EPSG:31996 / SIRGAS 1995 / UTM zone 21S" },
  { value: "EPSG:31997", label: "EPSG:31997 / SIRGAS 1995 / UTM zone 22S" },
  { value: "EPSG:31998", label: "EPSG:31998 / SIRGAS 1995 / UTM zone 23S" },
  { value: "EPSG:31999", label: "EPSG:31999 / SIRGAS 1995 / UTM zone 24S" },
  { value: "EPSG:32000", label: "EPSG:32000 / SIRGAS 1995 / UTM zone 25S" },
  { value: "EPSG:32001", label: "EPSG:32001 / NAD27 / Montana North" },
  { value: "EPSG:32002", label: "EPSG:32002 / NAD27 / Montana Central" },
  { value: "EPSG:32003", label: "EPSG:32003 / NAD27 / Montana South" },
  { value: "EPSG:32005", label: "EPSG:32005 / NAD27 / Nebraska North" },
  { value: "EPSG:32006", label: "EPSG:32006 / NAD27 / Nebraska South" },
  { value: "EPSG:32007", label: "EPSG:32007 / NAD27 / Nevada East" },
  { value: "EPSG:32008", label: "EPSG:32008 / NAD27 / Nevada Central" },
  { value: "EPSG:32009", label: "EPSG:32009 / NAD27 / Nevada West" },
  { value: "EPSG:32010", label: "EPSG:32010 / NAD27 / New Hampshire" },
  { value: "EPSG:32011", label: "EPSG:32011 / NAD27 / New Jersey" },
  { value: "EPSG:32012", label: "EPSG:32012 / NAD27 / New Mexico East" },
  { value: "EPSG:32013", label: "EPSG:32013 / NAD27 / New Mexico Central" },
  { value: "EPSG:32014", label: "EPSG:32014 / NAD27 / New Mexico West" },
  { value: "EPSG:32015", label: "EPSG:32015 / NAD27 / New York East" },
  { value: "EPSG:32016", label: "EPSG:32016 / NAD27 / New York Central" },
  { value: "EPSG:32017", label: "EPSG:32017 / NAD27 / New York West" },
  { value: "EPSG:32018", label: "EPSG:32018 / NAD27 / New York Long Island" },
  { value: "EPSG:32019", label: "EPSG:32019 / NAD27 / North Carolina" },
  { value: "EPSG:32020", label: "EPSG:32020 / NAD27 / North Dakota North" },
  { value: "EPSG:32021", label: "EPSG:32021 / NAD27 / North Dakota South" },
  { value: "EPSG:32022", label: "EPSG:32022 / NAD27 / Ohio North" },
  { value: "EPSG:32023", label: "EPSG:32023 / NAD27 / Ohio South" },
  { value: "EPSG:32024", label: "EPSG:32024 / NAD27 / Oklahoma North" },
  { value: "EPSG:32025", label: "EPSG:32025 / NAD27 / Oklahoma South" },
  { value: "EPSG:32026", label: "EPSG:32026 / NAD27 / Oregon North" },
  { value: "EPSG:32027", label: "EPSG:32027 / NAD27 / Oregon South" },
  { value: "EPSG:32028", label: "EPSG:32028 / NAD27 / Pennsylvania North" },
  { value: "EPSG:32029", label: "EPSG:32029 / NAD27 / Pennsylvania South" },
  { value: "EPSG:32030", label: "EPSG:32030 / NAD27 / Rhode Island" },
  { value: "EPSG:32031", label: "EPSG:32031 / NAD27 / South Carolina North" },
  { value: "EPSG:32033", label: "EPSG:32033 / NAD27 / South Carolina South" },
  { value: "EPSG:32034", label: "EPSG:32034 / NAD27 / South Dakota North" },
  { value: "EPSG:32035", label: "EPSG:32035 / NAD27 / South Dakota South" },
  { value: "EPSG:32036", label: "EPSG:32036 / NAD27 / Tennessee" },
  { value: "EPSG:32037", label: "EPSG:32037 / NAD27 / Texas North" },
  { value: "EPSG:32038", label: "EPSG:32038 / NAD27 / Texas North Central" },
  { value: "EPSG:32039", label: "EPSG:32039 / NAD27 / Texas Central" },
  { value: "EPSG:32040", label: "EPSG:32040 / NAD27 / Texas South Central" },
  { value: "EPSG:32041", label: "EPSG:32041 / NAD27 / Texas South" },
  { value: "EPSG:32042", label: "EPSG:32042 / NAD27 / Utah North" },
  { value: "EPSG:32043", label: "EPSG:32043 / NAD27 / Utah Central" },
  { value: "EPSG:32044", label: "EPSG:32044 / NAD27 / Utah South" },
  { value: "EPSG:32045", label: "EPSG:32045 / NAD27 / Vermont" },
  { value: "EPSG:32046", label: "EPSG:32046 / NAD27 / Virginia North" },
  { value: "EPSG:32047", label: "EPSG:32047 / NAD27 / Virginia South" },
  { value: "EPSG:32048", label: "EPSG:32048 / NAD27 / Washington North" },
  { value: "EPSG:32049", label: "EPSG:32049 / NAD27 / Washington South" },
  { value: "EPSG:32050", label: "EPSG:32050 / NAD27 / West Virginia North" },
  { value: "EPSG:32051", label: "EPSG:32051 / NAD27 / West Virginia South" },
  { value: "EPSG:32052", label: "EPSG:32052 / NAD27 / Wisconsin North" },
  { value: "EPSG:32053", label: "EPSG:32053 / NAD27 / Wisconsin Central" },
  { value: "EPSG:32054", label: "EPSG:32054 / NAD27 / Wisconsin South" },
  { value: "EPSG:32055", label: "EPSG:32055 / NAD27 / Wyoming East" },
  { value: "EPSG:32056", label: "EPSG:32056 / NAD27 / Wyoming East Central" },
  { value: "EPSG:32057", label: "EPSG:32057 / NAD27 / Wyoming West Central" },
  { value: "EPSG:32058", label: "EPSG:32058 / NAD27 / Wyoming West" },
  { value: "EPSG:32061", label: "EPSG:32061 / NAD27 / Guatemala Norte" },
  { value: "EPSG:32062", label: "EPSG:32062 / NAD27 / Guatemala Sur" },
  { value: "EPSG:32064", label: "EPSG:32064 / NAD27 / BLM 14N (ftUS)" },
  { value: "EPSG:32065", label: "EPSG:32065 / NAD27 / BLM 15N (ftUS)" },
  { value: "EPSG:32066", label: "EPSG:32066 / NAD27 / BLM 16N (ftUS)" },
  { value: "EPSG:32067", label: "EPSG:32067 / NAD27 / BLM 17N (ftUS)" },
  { value: "EPSG:32074", label: "EPSG:32074 / NAD27 / BLM 14N (feet)" },
  { value: "EPSG:32075", label: "EPSG:32075 / NAD27 / BLM 15N (feet)" },
  { value: "EPSG:32076", label: "EPSG:32076 / NAD27 / BLM 16N (feet)" },
  { value: "EPSG:32077", label: "EPSG:32077 / NAD27 / BLM 17N (feet)" },
  { value: "EPSG:32081", label: "EPSG:32081 / NAD27 / MTM zone 1" },
  { value: "EPSG:32082", label: "EPSG:32082 / NAD27 / MTM zone 2" },
  { value: "EPSG:32083", label: "EPSG:32083 / NAD27 / MTM zone 3" },
  { value: "EPSG:32084", label: "EPSG:32084 / NAD27 / MTM zone 4" },
  { value: "EPSG:32085", label: "EPSG:32085 / NAD27 / MTM zone 5" },
  { value: "EPSG:32086", label: "EPSG:32086 / NAD27 / MTM zone 6" },
  { value: "EPSG:32098", label: "EPSG:32098 / NAD27 / Quebec Lambert" },
  { value: "EPSG:32099", label: "EPSG:32099 / NAD27 / Louisiana Offshore" },
  { value: "EPSG:32100", label: "EPSG:32100 / NAD83 / Montana" },
  { value: "EPSG:32104", label: "EPSG:32104 / NAD83 / Nebraska" },
  { value: "EPSG:32107", label: "EPSG:32107 / NAD83 / Nevada East" },
  { value: "EPSG:32108", label: "EPSG:32108 / NAD83 / Nevada Central" },
  { value: "EPSG:32109", label: "EPSG:32109 / NAD83 / Nevada West" },
  { value: "EPSG:32110", label: "EPSG:32110 / NAD83 / New Hampshire" },
  { value: "EPSG:32111", label: "EPSG:32111 / NAD83 / New Jersey" },
  { value: "EPSG:32112", label: "EPSG:32112 / NAD83 / New Mexico East" },
  { value: "EPSG:32113", label: "EPSG:32113 / NAD83 / New Mexico Central" },
  { value: "EPSG:32114", label: "EPSG:32114 / NAD83 / New Mexico West" },
  { value: "EPSG:32115", label: "EPSG:32115 / NAD83 / New York East" },
  { value: "EPSG:32116", label: "EPSG:32116 / NAD83 / New York Central" },
  { value: "EPSG:32117", label: "EPSG:32117 / NAD83 / New York West" },
  { value: "EPSG:32118", label: "EPSG:32118 / NAD83 / New York Long Island" },
  { value: "EPSG:32119", label: "EPSG:32119 / NAD83 / North Carolina" },
  { value: "EPSG:32120", label: "EPSG:32120 / NAD83 / North Dakota North" },
  { value: "EPSG:32121", label: "EPSG:32121 / NAD83 / North Dakota South" },
  { value: "EPSG:32122", label: "EPSG:32122 / NAD83 / Ohio North" },
  { value: "EPSG:32123", label: "EPSG:32123 / NAD83 / Ohio South" },
  { value: "EPSG:32124", label: "EPSG:32124 / NAD83 / Oklahoma North" },
  { value: "EPSG:32125", label: "EPSG:32125 / NAD83 / Oklahoma South" },
  { value: "EPSG:32126", label: "EPSG:32126 / NAD83 / Oregon North" },
  { value: "EPSG:32127", label: "EPSG:32127 / NAD83 / Oregon South" },
  { value: "EPSG:32128", label: "EPSG:32128 / NAD83 / Pennsylvania North" },
  { value: "EPSG:32129", label: "EPSG:32129 / NAD83 / Pennsylvania South" },
  { value: "EPSG:32130", label: "EPSG:32130 / NAD83 / Rhode Island" },
  { value: "EPSG:32133", label: "EPSG:32133 / NAD83 / South Carolina" },
  { value: "EPSG:32134", label: "EPSG:32134 / NAD83 / South Dakota North" },
  { value: "EPSG:32135", label: "EPSG:32135 / NAD83 / South Dakota South" },
  { value: "EPSG:32136", label: "EPSG:32136 / NAD83 / Tennessee" },
  { value: "EPSG:32137", label: "EPSG:32137 / NAD83 / Texas North" },
  { value: "EPSG:32138", label: "EPSG:32138 / NAD83 / Texas North Central" },
  { value: "EPSG:32139", label: "EPSG:32139 / NAD83 / Texas Central" },
  { value: "EPSG:32140", label: "EPSG:32140 / NAD83 / Texas South Central" },
  { value: "EPSG:32141", label: "EPSG:32141 / NAD83 / Texas South" },
  { value: "EPSG:32142", label: "EPSG:32142 / NAD83 / Utah North" },
  { value: "EPSG:32143", label: "EPSG:32143 / NAD83 / Utah Central" },
  { value: "EPSG:32144", label: "EPSG:32144 / NAD83 / Utah South" },
  { value: "EPSG:32145", label: "EPSG:32145 / NAD83 / Vermont" },
  { value: "EPSG:32146", label: "EPSG:32146 / NAD83 / Virginia North" },
  { value: "EPSG:32147", label: "EPSG:32147 / NAD83 / Virginia South" },
  { value: "EPSG:32148", label: "EPSG:32148 / NAD83 / Washington North" },
  { value: "EPSG:32149", label: "EPSG:32149 / NAD83 / Washington South" },
  { value: "EPSG:32150", label: "EPSG:32150 / NAD83 / West Virginia North" },
  { value: "EPSG:32151", label: "EPSG:32151 / NAD83 / West Virginia South" },
  { value: "EPSG:32152", label: "EPSG:32152 / NAD83 / Wisconsin North" },
  { value: "EPSG:32153", label: "EPSG:32153 / NAD83 / Wisconsin Central" },
  { value: "EPSG:32154", label: "EPSG:32154 / NAD83 / Wisconsin South" },
  { value: "EPSG:32155", label: "EPSG:32155 / NAD83 / Wyoming East" },
  { value: "EPSG:32156", label: "EPSG:32156 / NAD83 / Wyoming East Central" },
  { value: "EPSG:32157", label: "EPSG:32157 / NAD83 / Wyoming West Central" },
  { value: "EPSG:32158", label: "EPSG:32158 / NAD83 / Wyoming West" },
  { value: "EPSG:32159", label: "EPSG:32159 / NAD83 / Wyoming Lambert" },
  {
    value: "EPSG:32161",
    label: "EPSG:32161 / NAD83 / Puerto Rico & Virgin Is.",
  },
  { value: "EPSG:32164", label: "EPSG:32164 / NAD83 / BLM 14N (ftUS)" },
  { value: "EPSG:32165", label: "EPSG:32165 / NAD83 / BLM 15N (ftUS)" },
  { value: "EPSG:32166", label: "EPSG:32166 / NAD83 / BLM 16N (ftUS)" },
  { value: "EPSG:32167", label: "EPSG:32167 / NAD83 / BLM 17N (ftUS)" },
  { value: "EPSG:32180", label: "EPSG:32180 / NAD83 / SCoPQ zone 2" },
  { value: "EPSG:32181", label: "EPSG:32181 / NAD83 / MTM zone 1" },
  { value: "EPSG:32182", label: "EPSG:32182 / NAD83 / MTM zone 2" },
  { value: "EPSG:32183", label: "EPSG:32183 / NAD83 / MTM zone 3" },
  { value: "EPSG:32184", label: "EPSG:32184 / NAD83 / MTM zone 4" },
  { value: "EPSG:32185", label: "EPSG:32185 / NAD83 / MTM zone 5" },
  { value: "EPSG:32186", label: "EPSG:32186 / NAD83 / MTM zone 6" },
  { value: "EPSG:32187", label: "EPSG:32187 / NAD83 / MTM zone 7" },
  { value: "EPSG:32188", label: "EPSG:32188 / NAD83 / MTM zone 8" },
  { value: "EPSG:32189", label: "EPSG:32189 / NAD83 / MTM zone 9" },
  { value: "EPSG:32190", label: "EPSG:32190 / NAD83 / MTM zone 10" },
  { value: "EPSG:32191", label: "EPSG:32191 / NAD83 / MTM zone 11" },
  { value: "EPSG:32192", label: "EPSG:32192 / NAD83 / MTM zone 12" },
  { value: "EPSG:32193", label: "EPSG:32193 / NAD83 / MTM zone 13" },
  { value: "EPSG:32194", label: "EPSG:32194 / NAD83 / MTM zone 14" },
  { value: "EPSG:32195", label: "EPSG:32195 / NAD83 / MTM zone 15" },
  { value: "EPSG:32196", label: "EPSG:32196 / NAD83 / MTM zone 16" },
  { value: "EPSG:32197", label: "EPSG:32197 / NAD83 / MTM zone 17" },
  { value: "EPSG:32198", label: "EPSG:32198 / NAD83 / Quebec Lambert" },
  { value: "EPSG:32199", label: "EPSG:32199 / NAD83 / Louisiana Offshore" },
  { value: "EPSG:32201", label: "EPSG:32201 / WGS 72 / UTM zone 1N" },
  { value: "EPSG:32202", label: "EPSG:32202 / WGS 72 / UTM zone 2N" },
  { value: "EPSG:32203", label: "EPSG:32203 / WGS 72 / UTM zone 3N" },
  { value: "EPSG:32204", label: "EPSG:32204 / WGS 72 / UTM zone 4N" },
  { value: "EPSG:32205", label: "EPSG:32205 / WGS 72 / UTM zone 5N" },
  { value: "EPSG:32206", label: "EPSG:32206 / WGS 72 / UTM zone 6N" },
  { value: "EPSG:32207", label: "EPSG:32207 / WGS 72 / UTM zone 7N" },
  { value: "EPSG:32208", label: "EPSG:32208 / WGS 72 / UTM zone 8N" },
  { value: "EPSG:32209", label: "EPSG:32209 / WGS 72 / UTM zone 9N" },
  { value: "EPSG:32210", label: "EPSG:32210 / WGS 72 / UTM zone 10N" },
  { value: "EPSG:32211", label: "EPSG:32211 / WGS 72 / UTM zone 11N" },
  { value: "EPSG:32212", label: "EPSG:32212 / WGS 72 / UTM zone 12N" },
  { value: "EPSG:32213", label: "EPSG:32213 / WGS 72 / UTM zone 13N" },
  { value: "EPSG:32214", label: "EPSG:32214 / WGS 72 / UTM zone 14N" },
  { value: "EPSG:32215", label: "EPSG:32215 / WGS 72 / UTM zone 15N" },
  { value: "EPSG:32216", label: "EPSG:32216 / WGS 72 / UTM zone 16N" },
  { value: "EPSG:32217", label: "EPSG:32217 / WGS 72 / UTM zone 17N" },
  { value: "EPSG:32218", label: "EPSG:32218 / WGS 72 / UTM zone 18N" },
  { value: "EPSG:32219", label: "EPSG:32219 / WGS 72 / UTM zone 19N" },
  { value: "EPSG:32220", label: "EPSG:32220 / WGS 72 / UTM zone 20N" },
  { value: "EPSG:32221", label: "EPSG:32221 / WGS 72 / UTM zone 21N" },
  { value: "EPSG:32222", label: "EPSG:32222 / WGS 72 / UTM zone 22N" },
  { value: "EPSG:32223", label: "EPSG:32223 / WGS 72 / UTM zone 23N" },
  { value: "EPSG:32224", label: "EPSG:32224 / WGS 72 / UTM zone 24N" },
  { value: "EPSG:32225", label: "EPSG:32225 / WGS 72 / UTM zone 25N" },
  { value: "EPSG:32226", label: "EPSG:32226 / WGS 72 / UTM zone 26N" },
  { value: "EPSG:32227", label: "EPSG:32227 / WGS 72 / UTM zone 27N" },
  { value: "EPSG:32228", label: "EPSG:32228 / WGS 72 / UTM zone 28N" },
  { value: "EPSG:32229", label: "EPSG:32229 / WGS 72 / UTM zone 29N" },
  { value: "EPSG:32230", label: "EPSG:32230 / WGS 72 / UTM zone 30N" },
  { value: "EPSG:32231", label: "EPSG:32231 / WGS 72 / UTM zone 31N" },
  { value: "EPSG:32232", label: "EPSG:32232 / WGS 72 / UTM zone 32N" },
  { value: "EPSG:32233", label: "EPSG:32233 / WGS 72 / UTM zone 33N" },
  { value: "EPSG:32234", label: "EPSG:32234 / WGS 72 / UTM zone 34N" },
  { value: "EPSG:32235", label: "EPSG:32235 / WGS 72 / UTM zone 35N" },
  { value: "EPSG:32236", label: "EPSG:32236 / WGS 72 / UTM zone 36N" },
  { value: "EPSG:32237", label: "EPSG:32237 / WGS 72 / UTM zone 37N" },
  { value: "EPSG:32238", label: "EPSG:32238 / WGS 72 / UTM zone 38N" },
  { value: "EPSG:32239", label: "EPSG:32239 / WGS 72 / UTM zone 39N" },
  { value: "EPSG:32240", label: "EPSG:32240 / WGS 72 / UTM zone 40N" },
  { value: "EPSG:32241", label: "EPSG:32241 / WGS 72 / UTM zone 41N" },
  { value: "EPSG:32242", label: "EPSG:32242 / WGS 72 / UTM zone 42N" },
  { value: "EPSG:32243", label: "EPSG:32243 / WGS 72 / UTM zone 43N" },
  { value: "EPSG:32244", label: "EPSG:32244 / WGS 72 / UTM zone 44N" },
  { value: "EPSG:32245", label: "EPSG:32245 / WGS 72 / UTM zone 45N" },
  { value: "EPSG:32246", label: "EPSG:32246 / WGS 72 / UTM zone 46N" },
  { value: "EPSG:32247", label: "EPSG:32247 / WGS 72 / UTM zone 47N" },
  { value: "EPSG:32248", label: "EPSG:32248 / WGS 72 / UTM zone 48N" },
  { value: "EPSG:32249", label: "EPSG:32249 / WGS 72 / UTM zone 49N" },
  { value: "EPSG:32250", label: "EPSG:32250 / WGS 72 / UTM zone 50N" },
  { value: "EPSG:32251", label: "EPSG:32251 / WGS 72 / UTM zone 51N" },
  { value: "EPSG:32252", label: "EPSG:32252 / WGS 72 / UTM zone 52N" },
  { value: "EPSG:32253", label: "EPSG:32253 / WGS 72 / UTM zone 53N" },
  { value: "EPSG:32254", label: "EPSG:32254 / WGS 72 / UTM zone 54N" },
  { value: "EPSG:32255", label: "EPSG:32255 / WGS 72 / UTM zone 55N" },
  { value: "EPSG:32256", label: "EPSG:32256 / WGS 72 / UTM zone 56N" },
  { value: "EPSG:32257", label: "EPSG:32257 / WGS 72 / UTM zone 57N" },
  { value: "EPSG:32258", label: "EPSG:32258 / WGS 72 / UTM zone 58N" },
  { value: "EPSG:32259", label: "EPSG:32259 / WGS 72 / UTM zone 59N" },
  { value: "EPSG:32260", label: "EPSG:32260 / WGS 72 / UTM zone 60N" },
  { value: "EPSG:32301", label: "EPSG:32301 / WGS 72 / UTM zone 1S" },
  { value: "EPSG:32302", label: "EPSG:32302 / WGS 72 / UTM zone 2S" },
  { value: "EPSG:32303", label: "EPSG:32303 / WGS 72 / UTM zone 3S" },
  { value: "EPSG:32304", label: "EPSG:32304 / WGS 72 / UTM zone 4S" },
  { value: "EPSG:32305", label: "EPSG:32305 / WGS 72 / UTM zone 5S" },
  { value: "EPSG:32306", label: "EPSG:32306 / WGS 72 / UTM zone 6S" },
  { value: "EPSG:32307", label: "EPSG:32307 / WGS 72 / UTM zone 7S" },
  { value: "EPSG:32308", label: "EPSG:32308 / WGS 72 / UTM zone 8S" },
  { value: "EPSG:32309", label: "EPSG:32309 / WGS 72 / UTM zone 9S" },
  { value: "EPSG:32310", label: "EPSG:32310 / WGS 72 / UTM zone 10S" },
  { value: "EPSG:32311", label: "EPSG:32311 / WGS 72 / UTM zone 11S" },
  { value: "EPSG:32312", label: "EPSG:32312 / WGS 72 / UTM zone 12S" },
  { value: "EPSG:32313", label: "EPSG:32313 / WGS 72 / UTM zone 13S" },
  { value: "EPSG:32314", label: "EPSG:32314 / WGS 72 / UTM zone 14S" },
  { value: "EPSG:32315", label: "EPSG:32315 / WGS 72 / UTM zone 15S" },
  { value: "EPSG:32316", label: "EPSG:32316 / WGS 72 / UTM zone 16S" },
  { value: "EPSG:32317", label: "EPSG:32317 / WGS 72 / UTM zone 17S" },
  { value: "EPSG:32318", label: "EPSG:32318 / WGS 72 / UTM zone 18S" },
  { value: "EPSG:32319", label: "EPSG:32319 / WGS 72 / UTM zone 19S" },
  { value: "EPSG:32320", label: "EPSG:32320 / WGS 72 / UTM zone 20S" },
  { value: "EPSG:32321", label: "EPSG:32321 / WGS 72 / UTM zone 21S" },
  { value: "EPSG:32322", label: "EPSG:32322 / WGS 72 / UTM zone 22S" },
  { value: "EPSG:32323", label: "EPSG:32323 / WGS 72 / UTM zone 23S" },
  { value: "EPSG:32324", label: "EPSG:32324 / WGS 72 / UTM zone 24S" },
  { value: "EPSG:32325", label: "EPSG:32325 / WGS 72 / UTM zone 25S" },
  { value: "EPSG:32326", label: "EPSG:32326 / WGS 72 / UTM zone 26S" },
  { value: "EPSG:32327", label: "EPSG:32327 / WGS 72 / UTM zone 27S" },
  { value: "EPSG:32328", label: "EPSG:32328 / WGS 72 / UTM zone 28S" },
  { value: "EPSG:32329", label: "EPSG:32329 / WGS 72 / UTM zone 29S" },
  { value: "EPSG:32330", label: "EPSG:32330 / WGS 72 / UTM zone 30S" },
  { value: "EPSG:32331", label: "EPSG:32331 / WGS 72 / UTM zone 31S" },
  { value: "EPSG:32332", label: "EPSG:32332 / WGS 72 / UTM zone 32S" },
  { value: "EPSG:32333", label: "EPSG:32333 / WGS 72 / UTM zone 33S" },
  { value: "EPSG:32334", label: "EPSG:32334 / WGS 72 / UTM zone 34S" },
  { value: "EPSG:32335", label: "EPSG:32335 / WGS 72 / UTM zone 35S" },
  { value: "EPSG:32336", label: "EPSG:32336 / WGS 72 / UTM zone 36S" },
  { value: "EPSG:32337", label: "EPSG:32337 / WGS 72 / UTM zone 37S" },
  { value: "EPSG:32338", label: "EPSG:32338 / WGS 72 / UTM zone 38S" },
  { value: "EPSG:32339", label: "EPSG:32339 / WGS 72 / UTM zone 39S" },
  { value: "EPSG:32340", label: "EPSG:32340 / WGS 72 / UTM zone 40S" },
  { value: "EPSG:32341", label: "EPSG:32341 / WGS 72 / UTM zone 41S" },
  { value: "EPSG:32342", label: "EPSG:32342 / WGS 72 / UTM zone 42S" },
  { value: "EPSG:32343", label: "EPSG:32343 / WGS 72 / UTM zone 43S" },
  { value: "EPSG:32344", label: "EPSG:32344 / WGS 72 / UTM zone 44S" },
  { value: "EPSG:32345", label: "EPSG:32345 / WGS 72 / UTM zone 45S" },
  { value: "EPSG:32346", label: "EPSG:32346 / WGS 72 / UTM zone 46S" },
  { value: "EPSG:32347", label: "EPSG:32347 / WGS 72 / UTM zone 47S" },
  { value: "EPSG:32348", label: "EPSG:32348 / WGS 72 / UTM zone 48S" },
  { value: "EPSG:32349", label: "EPSG:32349 / WGS 72 / UTM zone 49S" },
  { value: "EPSG:32350", label: "EPSG:32350 / WGS 72 / UTM zone 50S" },
  { value: "EPSG:32351", label: "EPSG:32351 / WGS 72 / UTM zone 51S" },
  { value: "EPSG:32352", label: "EPSG:32352 / WGS 72 / UTM zone 52S" },
  { value: "EPSG:32353", label: "EPSG:32353 / WGS 72 / UTM zone 53S" },
  { value: "EPSG:32354", label: "EPSG:32354 / WGS 72 / UTM zone 54S" },
  { value: "EPSG:32355", label: "EPSG:32355 / WGS 72 / UTM zone 55S" },
  { value: "EPSG:32356", label: "EPSG:32356 / WGS 72 / UTM zone 56S" },
  { value: "EPSG:32357", label: "EPSG:32357 / WGS 72 / UTM zone 57S" },
  { value: "EPSG:32358", label: "EPSG:32358 / WGS 72 / UTM zone 58S" },
  { value: "EPSG:32359", label: "EPSG:32359 / WGS 72 / UTM zone 59S" },
  { value: "EPSG:32360", label: "EPSG:32360 / WGS 72 / UTM zone 60S" },
  { value: "EPSG:32401", label: "EPSG:32401 / WGS 72BE / UTM zone 1N" },
  { value: "EPSG:32402", label: "EPSG:32402 / WGS 72BE / UTM zone 2N" },
  { value: "EPSG:32403", label: "EPSG:32403 / WGS 72BE / UTM zone 3N" },
  { value: "EPSG:32404", label: "EPSG:32404 / WGS 72BE / UTM zone 4N" },
  { value: "EPSG:32405", label: "EPSG:32405 / WGS 72BE / UTM zone 5N" },
  { value: "EPSG:32406", label: "EPSG:32406 / WGS 72BE / UTM zone 6N" },
  { value: "EPSG:32407", label: "EPSG:32407 / WGS 72BE / UTM zone 7N" },
  { value: "EPSG:32408", label: "EPSG:32408 / WGS 72BE / UTM zone 8N" },
  { value: "EPSG:32409", label: "EPSG:32409 / WGS 72BE / UTM zone 9N" },
  { value: "EPSG:32410", label: "EPSG:32410 / WGS 72BE / UTM zone 10N" },
  { value: "EPSG:32411", label: "EPSG:32411 / WGS 72BE / UTM zone 11N" },
  { value: "EPSG:32412", label: "EPSG:32412 / WGS 72BE / UTM zone 12N" },
  { value: "EPSG:32413", label: "EPSG:32413 / WGS 72BE / UTM zone 13N" },
  { value: "EPSG:32414", label: "EPSG:32414 / WGS 72BE / UTM zone 14N" },
  { value: "EPSG:32415", label: "EPSG:32415 / WGS 72BE / UTM zone 15N" },
  { value: "EPSG:32416", label: "EPSG:32416 / WGS 72BE / UTM zone 16N" },
  { value: "EPSG:32417", label: "EPSG:32417 / WGS 72BE / UTM zone 17N" },
  { value: "EPSG:32418", label: "EPSG:32418 / WGS 72BE / UTM zone 18N" },
  { value: "EPSG:32419", label: "EPSG:32419 / WGS 72BE / UTM zone 19N" },
  { value: "EPSG:32420", label: "EPSG:32420 / WGS 72BE / UTM zone 20N" },
  { value: "EPSG:32421", label: "EPSG:32421 / WGS 72BE / UTM zone 21N" },
  { value: "EPSG:32422", label: "EPSG:32422 / WGS 72BE / UTM zone 22N" },
  { value: "EPSG:32423", label: "EPSG:32423 / WGS 72BE / UTM zone 23N" },
  { value: "EPSG:32424", label: "EPSG:32424 / WGS 72BE / UTM zone 24N" },
  { value: "EPSG:32425", label: "EPSG:32425 / WGS 72BE / UTM zone 25N" },
  { value: "EPSG:32426", label: "EPSG:32426 / WGS 72BE / UTM zone 26N" },
  { value: "EPSG:32427", label: "EPSG:32427 / WGS 72BE / UTM zone 27N" },
  { value: "EPSG:32428", label: "EPSG:32428 / WGS 72BE / UTM zone 28N" },
  { value: "EPSG:32429", label: "EPSG:32429 / WGS 72BE / UTM zone 29N" },
  { value: "EPSG:32430", label: "EPSG:32430 / WGS 72BE / UTM zone 30N" },
  { value: "EPSG:32431", label: "EPSG:32431 / WGS 72BE / UTM zone 31N" },
  { value: "EPSG:32432", label: "EPSG:32432 / WGS 72BE / UTM zone 32N" },
  { value: "EPSG:32433", label: "EPSG:32433 / WGS 72BE / UTM zone 33N" },
  { value: "EPSG:32434", label: "EPSG:32434 / WGS 72BE / UTM zone 34N" },
  { value: "EPSG:32435", label: "EPSG:32435 / WGS 72BE / UTM zone 35N" },
  { value: "EPSG:32436", label: "EPSG:32436 / WGS 72BE / UTM zone 36N" },
  { value: "EPSG:32437", label: "EPSG:32437 / WGS 72BE / UTM zone 37N" },
  { value: "EPSG:32438", label: "EPSG:32438 / WGS 72BE / UTM zone 38N" },
  { value: "EPSG:32439", label: "EPSG:32439 / WGS 72BE / UTM zone 39N" },
  { value: "EPSG:32440", label: "EPSG:32440 / WGS 72BE / UTM zone 40N" },
  { value: "EPSG:32441", label: "EPSG:32441 / WGS 72BE / UTM zone 41N" },
  { value: "EPSG:32442", label: "EPSG:32442 / WGS 72BE / UTM zone 42N" },
  { value: "EPSG:32443", label: "EPSG:32443 / WGS 72BE / UTM zone 43N" },
  { value: "EPSG:32444", label: "EPSG:32444 / WGS 72BE / UTM zone 44N" },
  { value: "EPSG:32445", label: "EPSG:32445 / WGS 72BE / UTM zone 45N" },
  { value: "EPSG:32446", label: "EPSG:32446 / WGS 72BE / UTM zone 46N" },
  { value: "EPSG:32447", label: "EPSG:32447 / WGS 72BE / UTM zone 47N" },
  { value: "EPSG:32448", label: "EPSG:32448 / WGS 72BE / UTM zone 48N" },
  { value: "EPSG:32449", label: "EPSG:32449 / WGS 72BE / UTM zone 49N" },
  { value: "EPSG:32450", label: "EPSG:32450 / WGS 72BE / UTM zone 50N" },
  { value: "EPSG:32451", label: "EPSG:32451 / WGS 72BE / UTM zone 51N" },
  { value: "EPSG:32452", label: "EPSG:32452 / WGS 72BE / UTM zone 52N" },
  { value: "EPSG:32453", label: "EPSG:32453 / WGS 72BE / UTM zone 53N" },
  { value: "EPSG:32454", label: "EPSG:32454 / WGS 72BE / UTM zone 54N" },
  { value: "EPSG:32455", label: "EPSG:32455 / WGS 72BE / UTM zone 55N" },
  { value: "EPSG:32456", label: "EPSG:32456 / WGS 72BE / UTM zone 56N" },
  { value: "EPSG:32457", label: "EPSG:32457 / WGS 72BE / UTM zone 57N" },
  { value: "EPSG:32458", label: "EPSG:32458 / WGS 72BE / UTM zone 58N" },
  { value: "EPSG:32459", label: "EPSG:32459 / WGS 72BE / UTM zone 59N" },
  { value: "EPSG:32460", label: "EPSG:32460 / WGS 72BE / UTM zone 60N" },
  { value: "EPSG:32501", label: "EPSG:32501 / WGS 72BE / UTM zone 1S" },
  { value: "EPSG:32502", label: "EPSG:32502 / WGS 72BE / UTM zone 2S" },
  { value: "EPSG:32503", label: "EPSG:32503 / WGS 72BE / UTM zone 3S" },
  { value: "EPSG:32504", label: "EPSG:32504 / WGS 72BE / UTM zone 4S" },
  { value: "EPSG:32505", label: "EPSG:32505 / WGS 72BE / UTM zone 5S" },
  { value: "EPSG:32506", label: "EPSG:32506 / WGS 72BE / UTM zone 6S" },
  { value: "EPSG:32507", label: "EPSG:32507 / WGS 72BE / UTM zone 7S" },
  { value: "EPSG:32508", label: "EPSG:32508 / WGS 72BE / UTM zone 8S" },
  { value: "EPSG:32509", label: "EPSG:32509 / WGS 72BE / UTM zone 9S" },
  { value: "EPSG:32510", label: "EPSG:32510 / WGS 72BE / UTM zone 10S" },
  { value: "EPSG:32511", label: "EPSG:32511 / WGS 72BE / UTM zone 11S" },
  { value: "EPSG:32512", label: "EPSG:32512 / WGS 72BE / UTM zone 12S" },
  { value: "EPSG:32513", label: "EPSG:32513 / WGS 72BE / UTM zone 13S" },
  { value: "EPSG:32514", label: "EPSG:32514 / WGS 72BE / UTM zone 14S" },
  { value: "EPSG:32515", label: "EPSG:32515 / WGS 72BE / UTM zone 15S" },
  { value: "EPSG:32516", label: "EPSG:32516 / WGS 72BE / UTM zone 16S" },
  { value: "EPSG:32517", label: "EPSG:32517 / WGS 72BE / UTM zone 17S" },
  { value: "EPSG:32518", label: "EPSG:32518 / WGS 72BE / UTM zone 18S" },
  { value: "EPSG:32519", label: "EPSG:32519 / WGS 72BE / UTM zone 19S" },
  { value: "EPSG:32520", label: "EPSG:32520 / WGS 72BE / UTM zone 20S" },
  { value: "EPSG:32521", label: "EPSG:32521 / WGS 72BE / UTM zone 21S" },
  { value: "EPSG:32522", label: "EPSG:32522 / WGS 72BE / UTM zone 22S" },
  { value: "EPSG:32523", label: "EPSG:32523 / WGS 72BE / UTM zone 23S" },
  { value: "EPSG:32524", label: "EPSG:32524 / WGS 72BE / UTM zone 24S" },
  { value: "EPSG:32525", label: "EPSG:32525 / WGS 72BE / UTM zone 25S" },
  { value: "EPSG:32526", label: "EPSG:32526 / WGS 72BE / UTM zone 26S" },
  { value: "EPSG:32527", label: "EPSG:32527 / WGS 72BE / UTM zone 27S" },
  { value: "EPSG:32528", label: "EPSG:32528 / WGS 72BE / UTM zone 28S" },
  { value: "EPSG:32529", label: "EPSG:32529 / WGS 72BE / UTM zone 29S" },
  { value: "EPSG:32530", label: "EPSG:32530 / WGS 72BE / UTM zone 30S" },
  { value: "EPSG:32531", label: "EPSG:32531 / WGS 72BE / UTM zone 31S" },
  { value: "EPSG:32532", label: "EPSG:32532 / WGS 72BE / UTM zone 32S" },
  { value: "EPSG:32533", label: "EPSG:32533 / WGS 72BE / UTM zone 33S" },
  { value: "EPSG:32534", label: "EPSG:32534 / WGS 72BE / UTM zone 34S" },
  { value: "EPSG:32535", label: "EPSG:32535 / WGS 72BE / UTM zone 35S" },
  { value: "EPSG:32536", label: "EPSG:32536 / WGS 72BE / UTM zone 36S" },
  { value: "EPSG:32537", label: "EPSG:32537 / WGS 72BE / UTM zone 37S" },
  { value: "EPSG:32538", label: "EPSG:32538 / WGS 72BE / UTM zone 38S" },
  { value: "EPSG:32539", label: "EPSG:32539 / WGS 72BE / UTM zone 39S" },
  { value: "EPSG:32540", label: "EPSG:32540 / WGS 72BE / UTM zone 40S" },
  { value: "EPSG:32541", label: "EPSG:32541 / WGS 72BE / UTM zone 41S" },
  { value: "EPSG:32542", label: "EPSG:32542 / WGS 72BE / UTM zone 42S" },
  { value: "EPSG:32543", label: "EPSG:32543 / WGS 72BE / UTM zone 43S" },
  { value: "EPSG:32544", label: "EPSG:32544 / WGS 72BE / UTM zone 44S" },
  { value: "EPSG:32545", label: "EPSG:32545 / WGS 72BE / UTM zone 45S" },
  { value: "EPSG:32546", label: "EPSG:32546 / WGS 72BE / UTM zone 46S" },
  { value: "EPSG:32547", label: "EPSG:32547 / WGS 72BE / UTM zone 47S" },
  { value: "EPSG:32548", label: "EPSG:32548 / WGS 72BE / UTM zone 48S" },
  { value: "EPSG:32549", label: "EPSG:32549 / WGS 72BE / UTM zone 49S" },
  { value: "EPSG:32550", label: "EPSG:32550 / WGS 72BE / UTM zone 50S" },
  { value: "EPSG:32551", label: "EPSG:32551 / WGS 72BE / UTM zone 51S" },
  { value: "EPSG:32552", label: "EPSG:32552 / WGS 72BE / UTM zone 52S" },
  { value: "EPSG:32553", label: "EPSG:32553 / WGS 72BE / UTM zone 53S" },
  { value: "EPSG:32554", label: "EPSG:32554 / WGS 72BE / UTM zone 54S" },
  { value: "EPSG:32555", label: "EPSG:32555 / WGS 72BE / UTM zone 55S" },
  { value: "EPSG:32556", label: "EPSG:32556 / WGS 72BE / UTM zone 56S" },
  { value: "EPSG:32557", label: "EPSG:32557 / WGS 72BE / UTM zone 57S" },
  { value: "EPSG:32558", label: "EPSG:32558 / WGS 72BE / UTM zone 58S" },
  { value: "EPSG:32559", label: "EPSG:32559 / WGS 72BE / UTM zone 59S" },
  { value: "EPSG:32560", label: "EPSG:32560 / WGS 72BE / UTM zone 60S" },
  {
    value: "EPSG:32600",
    label: "EPSG:32600 / WGS 84 / UTM grid system (northern hemisphere)",
  },
  { value: "EPSG:32601", label: "EPSG:32601 / WGS 84 / UTM zone 1N" },
  { value: "EPSG:32602", label: "EPSG:32602 / WGS 84 / UTM zone 2N" },
  { value: "EPSG:32603", label: "EPSG:32603 / WGS 84 / UTM zone 3N" },
  { value: "EPSG:32604", label: "EPSG:32604 / WGS 84 / UTM zone 4N" },
  { value: "EPSG:32605", label: "EPSG:32605 / WGS 84 / UTM zone 5N" },
  { value: "EPSG:32606", label: "EPSG:32606 / WGS 84 / UTM zone 6N" },
  { value: "EPSG:32607", label: "EPSG:32607 / WGS 84 / UTM zone 7N" },
  { value: "EPSG:32608", label: "EPSG:32608 / WGS 84 / UTM zone 8N" },
  { value: "EPSG:32609", label: "EPSG:32609 / WGS 84 / UTM zone 9N" },
  { value: "EPSG:32610", label: "EPSG:32610 / WGS 84 / UTM zone 10N" },
  { value: "EPSG:32611", label: "EPSG:32611 / WGS 84 / UTM zone 11N" },
  { value: "EPSG:32612", label: "EPSG:32612 / WGS 84 / UTM zone 12N" },
  { value: "EPSG:32613", label: "EPSG:32613 / WGS 84 / UTM zone 13N" },
  { value: "EPSG:32614", label: "EPSG:32614 / WGS 84 / UTM zone 14N" },
  { value: "EPSG:32615", label: "EPSG:32615 / WGS 84 / UTM zone 15N" },
  { value: "EPSG:32616", label: "EPSG:32616 / WGS 84 / UTM zone 16N" },
  { value: "EPSG:32617", label: "EPSG:32617 / WGS 84 / UTM zone 17N" },
  { value: "EPSG:32618", label: "EPSG:32618 / WGS 84 / UTM zone 18N" },
  { value: "EPSG:32619", label: "EPSG:32619 / WGS 84 / UTM zone 19N" },
  { value: "EPSG:32620", label: "EPSG:32620 / WGS 84 / UTM zone 20N" },
  { value: "EPSG:32621", label: "EPSG:32621 / WGS 84 / UTM zone 21N" },
  { value: "EPSG:32622", label: "EPSG:32622 / WGS 84 / UTM zone 22N" },
  { value: "EPSG:32623", label: "EPSG:32623 / WGS 84 / UTM zone 23N" },
  { value: "EPSG:32624", label: "EPSG:32624 / WGS 84 / UTM zone 24N" },
  { value: "EPSG:32625", label: "EPSG:32625 / WGS 84 / UTM zone 25N" },
  { value: "EPSG:32626", label: "EPSG:32626 / WGS 84 / UTM zone 26N" },
  { value: "EPSG:32627", label: "EPSG:32627 / WGS 84 / UTM zone 27N" },
  { value: "EPSG:32628", label: "EPSG:32628 / WGS 84 / UTM zone 28N" },
  { value: "EPSG:32629", label: "EPSG:32629 / WGS 84 / UTM zone 29N" },
  { value: "EPSG:32630", label: "EPSG:32630 / WGS 84 / UTM zone 30N" },
  { value: "EPSG:32631", label: "EPSG:32631 / WGS 84 / UTM zone 31N" },
  { value: "EPSG:32632", label: "EPSG:32632 / WGS 84 / UTM zone 32N" },
  { value: "EPSG:32633", label: "EPSG:32633 / WGS 84 / UTM zone 33N" },
  { value: "EPSG:32634", label: "EPSG:32634 / WGS 84 / UTM zone 34N" },
  { value: "EPSG:32635", label: "EPSG:32635 / WGS 84 / UTM zone 35N" },
  { value: "EPSG:32636", label: "EPSG:32636 / WGS 84 / UTM zone 36N" },
  { value: "EPSG:32637", label: "EPSG:32637 / WGS 84 / UTM zone 37N" },
  { value: "EPSG:32638", label: "EPSG:32638 / WGS 84 / UTM zone 38N" },
  { value: "EPSG:32639", label: "EPSG:32639 / WGS 84 / UTM zone 39N" },
  { value: "EPSG:32640", label: "EPSG:32640 / WGS 84 / UTM zone 40N" },
  { value: "EPSG:32641", label: "EPSG:32641 / WGS 84 / UTM zone 41N" },
  { value: "EPSG:32642", label: "EPSG:32642 / WGS 84 / UTM zone 42N" },
  { value: "EPSG:32643", label: "EPSG:32643 / WGS 84 / UTM zone 43N" },
  { value: "EPSG:32644", label: "EPSG:32644 / WGS 84 / UTM zone 44N" },
  { value: "EPSG:32645", label: "EPSG:32645 / WGS 84 / UTM zone 45N" },
  { value: "EPSG:32646", label: "EPSG:32646 / WGS 84 / UTM zone 46N" },
  { value: "EPSG:32647", label: "EPSG:32647 / WGS 84 / UTM zone 47N" },
  { value: "EPSG:32648", label: "EPSG:32648 / WGS 84 / UTM zone 48N" },
  { value: "EPSG:32649", label: "EPSG:32649 / WGS 84 / UTM zone 49N" },
  { value: "EPSG:32650", label: "EPSG:32650 / WGS 84 / UTM zone 50N" },
  { value: "EPSG:32651", label: "EPSG:32651 / WGS 84 / UTM zone 51N" },
  { value: "EPSG:32652", label: "EPSG:32652 / WGS 84 / UTM zone 52N" },
  { value: "EPSG:32653", label: "EPSG:32653 / WGS 84 / UTM zone 53N" },
  { value: "EPSG:32654", label: "EPSG:32654 / WGS 84 / UTM zone 54N" },
  { value: "EPSG:32655", label: "EPSG:32655 / WGS 84 / UTM zone 55N" },
  { value: "EPSG:32656", label: "EPSG:32656 / WGS 84 / UTM zone 56N" },
  { value: "EPSG:32657", label: "EPSG:32657 / WGS 84 / UTM zone 57N" },
  { value: "EPSG:32658", label: "EPSG:32658 / WGS 84 / UTM zone 58N" },
  { value: "EPSG:32659", label: "EPSG:32659 / WGS 84 / UTM zone 59N" },
  { value: "EPSG:32660", label: "EPSG:32660 / WGS 84 / UTM zone 60N" },
  { value: "EPSG:32661", label: "EPSG:32661 / WGS 84 / UPS North (N,E)" },
  { value: "EPSG:32662", label: "EPSG:32662 / WGS 84 / Plate Carree" },
  {
    value: "EPSG:32663",
    label: "EPSG:32663 / WGS 84 / World Equidistant Cylindrical",
  },
  { value: "EPSG:32664", label: "EPSG:32664 / WGS 84 / BLM 14N (ftUS)" },
  { value: "EPSG:32665", label: "EPSG:32665 / WGS 84 / BLM 15N (ftUS)" },
  { value: "EPSG:32666", label: "EPSG:32666 / WGS 84 / BLM 16N (ftUS)" },
  { value: "EPSG:32667", label: "EPSG:32667 / WGS 84 / BLM 17N (ftUS)" },
  {
    value: "EPSG:32700",
    label: "EPSG:32700 / WGS 84 / UTM grid system (southern hemisphere)",
  },
  { value: "EPSG:32701", label: "EPSG:32701 / WGS 84 / UTM zone 1S" },
  { value: "EPSG:32702", label: "EPSG:32702 / WGS 84 / UTM zone 2S" },
  { value: "EPSG:32703", label: "EPSG:32703 / WGS 84 / UTM zone 3S" },
  { value: "EPSG:32704", label: "EPSG:32704 / WGS 84 / UTM zone 4S" },
  { value: "EPSG:32705", label: "EPSG:32705 / WGS 84 / UTM zone 5S" },
  { value: "EPSG:32706", label: "EPSG:32706 / WGS 84 / UTM zone 6S" },
  { value: "EPSG:32707", label: "EPSG:32707 / WGS 84 / UTM zone 7S" },
  { value: "EPSG:32708", label: "EPSG:32708 / WGS 84 / UTM zone 8S" },
  { value: "EPSG:32709", label: "EPSG:32709 / WGS 84 / UTM zone 9S" },
  { value: "EPSG:32710", label: "EPSG:32710 / WGS 84 / UTM zone 10S" },
  { value: "EPSG:32711", label: "EPSG:32711 / WGS 84 / UTM zone 11S" },
  { value: "EPSG:32712", label: "EPSG:32712 / WGS 84 / UTM zone 12S" },
  { value: "EPSG:32713", label: "EPSG:32713 / WGS 84 / UTM zone 13S" },
  { value: "EPSG:32714", label: "EPSG:32714 / WGS 84 / UTM zone 14S" },
  { value: "EPSG:32715", label: "EPSG:32715 / WGS 84 / UTM zone 15S" },
  { value: "EPSG:32716", label: "EPSG:32716 / WGS 84 / UTM zone 16S" },
  { value: "EPSG:32717", label: "EPSG:32717 / WGS 84 / UTM zone 17S" },
  { value: "EPSG:32718", label: "EPSG:32718 / WGS 84 / UTM zone 18S" },
  { value: "EPSG:32719", label: "EPSG:32719 / WGS 84 / UTM zone 19S" },
  { value: "EPSG:32720", label: "EPSG:32720 / WGS 84 / UTM zone 20S" },
  { value: "EPSG:32721", label: "EPSG:32721 / WGS 84 / UTM zone 21S" },
  { value: "EPSG:32722", label: "EPSG:32722 / WGS 84 / UTM zone 22S" },
  { value: "EPSG:32723", label: "EPSG:32723 / WGS 84 / UTM zone 23S" },
  { value: "EPSG:32724", label: "EPSG:32724 / WGS 84 / UTM zone 24S" },
  { value: "EPSG:32725", label: "EPSG:32725 / WGS 84 / UTM zone 25S" },
  { value: "EPSG:32726", label: "EPSG:32726 / WGS 84 / UTM zone 26S" },
  { value: "EPSG:32727", label: "EPSG:32727 / WGS 84 / UTM zone 27S" },
  { value: "EPSG:32728", label: "EPSG:32728 / WGS 84 / UTM zone 28S" },
  { value: "EPSG:32729", label: "EPSG:32729 / WGS 84 / UTM zone 29S" },
  { value: "EPSG:32730", label: "EPSG:32730 / WGS 84 / UTM zone 30S" },
  { value: "EPSG:32731", label: "EPSG:32731 / WGS 84 / UTM zone 31S" },
  { value: "EPSG:32732", label: "EPSG:32732 / WGS 84 / UTM zone 32S" },
  { value: "EPSG:32733", label: "EPSG:32733 / WGS 84 / UTM zone 33S" },
  { value: "EPSG:32734", label: "EPSG:32734 / WGS 84 / UTM zone 34S" },
  { value: "EPSG:32735", label: "EPSG:32735 / WGS 84 / UTM zone 35S" },
  { value: "EPSG:32736", label: "EPSG:32736 / WGS 84 / UTM zone 36S" },
  { value: "EPSG:32737", label: "EPSG:32737 / WGS 84 / UTM zone 37S" },
  { value: "EPSG:32738", label: "EPSG:32738 / WGS 84 / UTM zone 38S" },
  { value: "EPSG:32739", label: "EPSG:32739 / WGS 84 / UTM zone 39S" },
  { value: "EPSG:32740", label: "EPSG:32740 / WGS 84 / UTM zone 40S" },
  { value: "EPSG:32741", label: "EPSG:32741 / WGS 84 / UTM zone 41S" },
  { value: "EPSG:32742", label: "EPSG:32742 / WGS 84 / UTM zone 42S" },
  { value: "EPSG:32743", label: "EPSG:32743 / WGS 84 / UTM zone 43S" },
  { value: "EPSG:32744", label: "EPSG:32744 / WGS 84 / UTM zone 44S" },
  { value: "EPSG:32745", label: "EPSG:32745 / WGS 84 / UTM zone 45S" },
  { value: "EPSG:32746", label: "EPSG:32746 / WGS 84 / UTM zone 46S" },
  { value: "EPSG:32747", label: "EPSG:32747 / WGS 84 / UTM zone 47S" },
  { value: "EPSG:32748", label: "EPSG:32748 / WGS 84 / UTM zone 48S" },
  { value: "EPSG:32749", label: "EPSG:32749 / WGS 84 / UTM zone 49S" },
  { value: "EPSG:32750", label: "EPSG:32750 / WGS 84 / UTM zone 50S" },
  { value: "EPSG:32751", label: "EPSG:32751 / WGS 84 / UTM zone 51S" },
  { value: "EPSG:32752", label: "EPSG:32752 / WGS 84 / UTM zone 52S" },
  { value: "EPSG:32753", label: "EPSG:32753 / WGS 84 / UTM zone 53S" },
  { value: "EPSG:32754", label: "EPSG:32754 / WGS 84 / UTM zone 54S" },
  { value: "EPSG:32755", label: "EPSG:32755 / WGS 84 / UTM zone 55S" },
  { value: "EPSG:32756", label: "EPSG:32756 / WGS 84 / UTM zone 56S" },
  { value: "EPSG:32757", label: "EPSG:32757 / WGS 84 / UTM zone 57S" },
  { value: "EPSG:32758", label: "EPSG:32758 / WGS 84 / UTM zone 58S" },
  { value: "EPSG:32759", label: "EPSG:32759 / WGS 84 / UTM zone 59S" },
  { value: "EPSG:32760", label: "EPSG:32760 / WGS 84 / UTM zone 60S" },
  { value: "EPSG:32761", label: "EPSG:32761 / WGS 84 / UPS South (N,E)" },
  { value: "EPSG:32766", label: "EPSG:32766 / WGS 84 / TM 36 SE" },
  { value: "EPSG:900913", label: "EPSG:900913 / Google Maps Global Mercator" },
  { value: "ESRI:2181", label: "ESRI:2181 / ED_1950_Turkey_9" },
  { value: "ESRI:2182", label: "ESRI:2182 / ED_1950_Turkey_10" },
  { value: "ESRI:2183", label: "ESRI:2183 / ED_1950_Turkey_11" },
  { value: "ESRI:2184", label: "ESRI:2184 / ED_1950_Turkey_12" },
  { value: "ESRI:2185", label: "ESRI:2185 / ED_1950_Turkey_13" },
  { value: "ESRI:2186", label: "ESRI:2186 / ED_1950_Turkey_14" },
  { value: "ESRI:2187", label: "ESRI:2187 / ED_1950_Turkey_15" },
  { value: "ESRI:9709", label: "ESRI:9709 / NAD_1983_CSRS_UTM_Zone_23N" },
  { value: "ESRI:9712", label: "ESRI:9712 / NAD_1983_UTM_Zone_24N" },
  { value: "ESRI:9713", label: "ESRI:9713 / NAD_1983_CSRS_UTM_Zone_24N" },
  { value: "ESRI:9716", label: "ESRI:9716 / IGM95_UTM_Zone_34N" },
  { value: "ESRI:9741", label: "ESRI:9741 / EOS21_Grid" },
  {
    value: "ESRI:9748",
    label: "ESRI:9748 / NAD_1983_2011_StatePlane_Alabama_East_(ftUS)",
  },
  {
    value: "ESRI:9749",
    label: "ESRI:9749 / NAD_1983_2011_StatePlane_Alabama_West_(ftUS)",
  },
  { value: "ESRI:9761", label: "ESRI:9761 / ECML14_NB_Grid" },
  { value: "ESRI:9766", label: "ESRI:9766 / EWR2_Grid" },
  { value: "ESRI:20002", label: "ESRI:20002 / Pulkovo_1995_GK_Zone_2" },
  { value: "ESRI:20003", label: "ESRI:20003 / Pulkovo_1995_GK_Zone_3" },
  { value: "ESRI:20062", label: "ESRI:20062 / Pulkovo_1995_GK_Zone_2N" },
  { value: "ESRI:20063", label: "ESRI:20063 / Pulkovo_1995_GK_Zone_3N" },
  { value: "ESRI:20904", label: "ESRI:20904 / GSK-2011_Gauss-Kruger_zone_4" },
  { value: "ESRI:20905", label: "ESRI:20905 / GSK-2011_Gauss-Kruger_zone_5" },
  { value: "ESRI:20906", label: "ESRI:20906 / GSK-2011_Gauss-Kruger_zone_6" },
  { value: "ESRI:20907", label: "ESRI:20907 / GSK-2011_Gauss-Kruger_zone_7" },
  { value: "ESRI:20908", label: "ESRI:20908 / GSK-2011_Gauss-Kruger_zone_8" },
  { value: "ESRI:20909", label: "ESRI:20909 / GSK-2011_Gauss-Kruger_zone_9" },
  { value: "ESRI:20910", label: "ESRI:20910 / GSK-2011_Gauss-Kruger_zone_10" },
  { value: "ESRI:20911", label: "ESRI:20911 / GSK-2011_Gauss-Kruger_zone_11" },
  { value: "ESRI:20912", label: "ESRI:20912 / GSK-2011_Gauss-Kruger_zone_12" },
  { value: "ESRI:20913", label: "ESRI:20913 / GSK-2011_Gauss-Kruger_zone_13" },
  { value: "ESRI:20914", label: "ESRI:20914 / GSK-2011_Gauss-Kruger_zone_14" },
  { value: "ESRI:20915", label: "ESRI:20915 / GSK-2011_Gauss-Kruger_zone_15" },
  { value: "ESRI:20916", label: "ESRI:20916 / GSK-2011_Gauss-Kruger_zone_16" },
  { value: "ESRI:20917", label: "ESRI:20917 / GSK-2011_Gauss-Kruger_zone_17" },
  { value: "ESRI:20918", label: "ESRI:20918 / GSK-2011_Gauss-Kruger_zone_18" },
  { value: "ESRI:20919", label: "ESRI:20919 / GSK-2011_Gauss-Kruger_zone_19" },
  { value: "ESRI:20920", label: "ESRI:20920 / GSK-2011_Gauss-Kruger_zone_20" },
  { value: "ESRI:20921", label: "ESRI:20921 / GSK-2011_Gauss-Kruger_zone_21" },
  { value: "ESRI:20922", label: "ESRI:20922 / GSK-2011_Gauss-Kruger_zone_22" },
  { value: "ESRI:20923", label: "ESRI:20923 / GSK-2011_Gauss-Kruger_zone_23" },
  { value: "ESRI:20924", label: "ESRI:20924 / GSK-2011_Gauss-Kruger_zone_24" },
  { value: "ESRI:20925", label: "ESRI:20925 / GSK-2011_Gauss-Kruger_zone_25" },
  { value: "ESRI:20926", label: "ESRI:20926 / GSK-2011_Gauss-Kruger_zone_26" },
  { value: "ESRI:20927", label: "ESRI:20927 / GSK-2011_Gauss-Kruger_zone_27" },
  { value: "ESRI:20928", label: "ESRI:20928 / GSK-2011_Gauss-Kruger_zone_28" },
  { value: "ESRI:20929", label: "ESRI:20929 / GSK-2011_Gauss-Kruger_zone_29" },
  { value: "ESRI:20930", label: "ESRI:20930 / GSK-2011_Gauss-Kruger_zone_30" },
  { value: "ESRI:20931", label: "ESRI:20931 / GSK-2011_Gauss-Kruger_zone_31" },
  { value: "ESRI:20932", label: "ESRI:20932 / GSK-2011_Gauss-Kruger_zone_32" },
  { value: "ESRI:21004", label: "ESRI:21004 / GSK-2011_Gauss-Kruger_CM_21E" },
  { value: "ESRI:21005", label: "ESRI:21005 / GSK-2011_Gauss-Kruger_CM_27E" },
  { value: "ESRI:21006", label: "ESRI:21006 / GSK-2011_Gauss-Kruger_CM_33E" },
  { value: "ESRI:21007", label: "ESRI:21007 / GSK-2011_Gauss-Kruger_CM_39E" },
  { value: "ESRI:21008", label: "ESRI:21008 / GSK-2011_Gauss-Kruger_CM_45E" },
  { value: "ESRI:21009", label: "ESRI:21009 / GSK-2011_Gauss-Kruger_CM_51E" },
  { value: "ESRI:21010", label: "ESRI:21010 / GSK-2011_Gauss-Kruger_CM_57E" },
  { value: "ESRI:21011", label: "ESRI:21011 / GSK-2011_Gauss-Kruger_CM_63E" },
  { value: "ESRI:21012", label: "ESRI:21012 / GSK-2011_Gauss-Kruger_CM_69E" },
  { value: "ESRI:21013", label: "ESRI:21013 / GSK-2011_Gauss-Kruger_CM_75E" },
  { value: "ESRI:21014", label: "ESRI:21014 / GSK-2011_Gauss-Kruger_CM_81E" },
  { value: "ESRI:21015", label: "ESRI:21015 / GSK-2011_Gauss-Kruger_CM_87E" },
  { value: "ESRI:21016", label: "ESRI:21016 / GSK-2011_Gauss-Kruger_CM_93E" },
  { value: "ESRI:21017", label: "ESRI:21017 / GSK-2011_Gauss-Kruger_CM_99E" },
  { value: "ESRI:21018", label: "ESRI:21018 / GSK-2011_Gauss-Kruger_CM_105E" },
  { value: "ESRI:21019", label: "ESRI:21019 / GSK-2011_Gauss-Kruger_CM_111E" },
  { value: "ESRI:21020", label: "ESRI:21020 / GSK-2011_Gauss-Kruger_CM_117E" },
  { value: "ESRI:21021", label: "ESRI:21021 / GSK-2011_Gauss-Kruger_CM_123E" },
  { value: "ESRI:21022", label: "ESRI:21022 / GSK-2011_Gauss-Kruger_CM_129E" },
  { value: "ESRI:21023", label: "ESRI:21023 / GSK-2011_Gauss-Kruger_CM_135E" },
  { value: "ESRI:21024", label: "ESRI:21024 / GSK-2011_Gauss-Kruger_CM_141E" },
  { value: "ESRI:21025", label: "ESRI:21025 / GSK-2011_Gauss-Kruger_CM_147E" },
  { value: "ESRI:21026", label: "ESRI:21026 / GSK-2011_Gauss-Kruger_CM_153E" },
  { value: "ESRI:21027", label: "ESRI:21027 / GSK-2011_Gauss-Kruger_CM_159E" },
  { value: "ESRI:21028", label: "ESRI:21028 / GSK-2011_Gauss-Kruger_CM_165E" },
  { value: "ESRI:21029", label: "ESRI:21029 / GSK-2011_Gauss-Kruger_CM_171E" },
  { value: "ESRI:21030", label: "ESRI:21030 / GSK-2011_Gauss-Kruger_CM_177E" },
  { value: "ESRI:21031", label: "ESRI:21031 / GSK-2011_Gauss-Kruger_CM_177W" },
  { value: "ESRI:21032", label: "ESRI:21032 / GSK-2011_Gauss-Kruger_CM_171W" },
  { value: "ESRI:21207", label: "ESRI:21207 / GSK-2011_GSK_3GK_zone_7" },
  { value: "ESRI:21208", label: "ESRI:21208 / GSK-2011_GSK_3GK_zone_8" },
  { value: "ESRI:21209", label: "ESRI:21209 / GSK-2011_GSK_3GK_zone_9" },
  { value: "ESRI:21210", label: "ESRI:21210 / GSK-2011_GSK_3GK_zone_10" },
  { value: "ESRI:21211", label: "ESRI:21211 / GSK-2011_GSK_3GK_zone_11" },
  { value: "ESRI:21212", label: "ESRI:21212 / GSK-2011_GSK_3GK_zone_12" },
  { value: "ESRI:21213", label: "ESRI:21213 / GSK-2011_GSK_3GK_zone_13" },
  { value: "ESRI:21214", label: "ESRI:21214 / GSK-2011_GSK_3GK_zone_14" },
  { value: "ESRI:21215", label: "ESRI:21215 / GSK-2011_GSK_3GK_zone_15" },
  { value: "ESRI:21216", label: "ESRI:21216 / GSK-2011_GSK_3GK_zone_16" },
  { value: "ESRI:21217", label: "ESRI:21217 / GSK-2011_GSK_3GK_zone_17" },
  { value: "ESRI:21218", label: "ESRI:21218 / GSK-2011_GSK_3GK_zone_18" },
  { value: "ESRI:21219", label: "ESRI:21219 / GSK-2011_GSK_3GK_zone_19" },
  { value: "ESRI:21220", label: "ESRI:21220 / GSK-2011_GSK_3GK_zone_20" },
  { value: "ESRI:21221", label: "ESRI:21221 / GSK-2011_GSK_3GK_zone_21" },
  { value: "ESRI:21222", label: "ESRI:21222 / GSK-2011_GSK_3GK_zone_22" },
  { value: "ESRI:21223", label: "ESRI:21223 / GSK-2011_GSK_3GK_zone_23" },
  { value: "ESRI:21224", label: "ESRI:21224 / GSK-2011_GSK_3GK_zone_24" },
  { value: "ESRI:21225", label: "ESRI:21225 / GSK-2011_GSK_3GK_zone_25" },
  { value: "ESRI:21226", label: "ESRI:21226 / GSK-2011_GSK_3GK_zone_26" },
  { value: "ESRI:21227", label: "ESRI:21227 / GSK-2011_GSK_3GK_zone_27" },
  { value: "ESRI:21228", label: "ESRI:21228 / GSK-2011_GSK_3GK_zone_28" },
  { value: "ESRI:21229", label: "ESRI:21229 / GSK-2011_GSK_3GK_zone_29" },
  { value: "ESRI:21230", label: "ESRI:21230 / GSK-2011_GSK_3GK_zone_30" },
  { value: "ESRI:21231", label: "ESRI:21231 / GSK-2011_GSK_3GK_zone_31" },
  { value: "ESRI:21232", label: "ESRI:21232 / GSK-2011_GSK_3GK_zone_32" },
  { value: "ESRI:21233", label: "ESRI:21233 / GSK-2011_GSK_3GK_zone_33" },
  { value: "ESRI:21234", label: "ESRI:21234 / GSK-2011_GSK_3GK_zone_34" },
  { value: "ESRI:21235", label: "ESRI:21235 / GSK-2011_GSK_3GK_zone_35" },
  { value: "ESRI:21236", label: "ESRI:21236 / GSK-2011_GSK_3GK_zone_36" },
  { value: "ESRI:21237", label: "ESRI:21237 / GSK-2011_GSK_3GK_zone_37" },
  { value: "ESRI:21238", label: "ESRI:21238 / GSK-2011_GSK_3GK_zone_38" },
  { value: "ESRI:21239", label: "ESRI:21239 / GSK-2011_GSK_3GK_zone_39" },
  { value: "ESRI:21240", label: "ESRI:21240 / GSK-2011_GSK_3GK_zone_40" },
  { value: "ESRI:21241", label: "ESRI:21241 / GSK-2011_GSK_3GK_zone_41" },
  { value: "ESRI:21242", label: "ESRI:21242 / GSK-2011_GSK_3GK_zone_42" },
  { value: "ESRI:21243", label: "ESRI:21243 / GSK-2011_GSK_3GK_zone_43" },
  { value: "ESRI:21244", label: "ESRI:21244 / GSK-2011_GSK_3GK_zone_44" },
  { value: "ESRI:21245", label: "ESRI:21245 / GSK-2011_GSK_3GK_zone_45" },
  { value: "ESRI:21246", label: "ESRI:21246 / GSK-2011_GSK_3GK_zone_46" },
  { value: "ESRI:21247", label: "ESRI:21247 / GSK-2011_GSK_3GK_zone_47" },
  { value: "ESRI:21248", label: "ESRI:21248 / GSK-2011_GSK_3GK_zone_48" },
  { value: "ESRI:21249", label: "ESRI:21249 / GSK-2011_GSK_3GK_zone_49" },
  { value: "ESRI:21250", label: "ESRI:21250 / GSK-2011_GSK_3GK_zone_50" },
  { value: "ESRI:21251", label: "ESRI:21251 / GSK-2011_GSK_3GK_zone_51" },
  { value: "ESRI:21252", label: "ESRI:21252 / GSK-2011_GSK_3GK_zone_52" },
  { value: "ESRI:21253", label: "ESRI:21253 / GSK-2011_GSK_3GK_zone_53" },
  { value: "ESRI:21254", label: "ESRI:21254 / GSK-2011_GSK_3GK_zone_54" },
  { value: "ESRI:21255", label: "ESRI:21255 / GSK-2011_GSK_3GK_zone_55" },
  { value: "ESRI:21256", label: "ESRI:21256 / GSK-2011_GSK_3GK_zone_56" },
  { value: "ESRI:21257", label: "ESRI:21257 / GSK-2011_GSK_3GK_zone_57" },
  { value: "ESRI:21258", label: "ESRI:21258 / GSK-2011_GSK_3GK_zone_58" },
  { value: "ESRI:21259", label: "ESRI:21259 / GSK-2011_GSK_3GK_zone_59" },
  { value: "ESRI:21260", label: "ESRI:21260 / GSK-2011_GSK_3GK_zone_60" },
  { value: "ESRI:21261", label: "ESRI:21261 / GSK-2011_GSK_3GK_zone_61" },
  { value: "ESRI:21262", label: "ESRI:21262 / GSK-2011_GSK_3GK_zone_62" },
  { value: "ESRI:21263", label: "ESRI:21263 / GSK-2011_GSK_3GK_zone_63" },
  { value: "ESRI:21264", label: "ESRI:21264 / GSK-2011_GSK_3GK_zone_64" },
  { value: "ESRI:21307", label: "ESRI:21307 / GSK-2011_GSK_3GK_CM_21E" },
  { value: "ESRI:21308", label: "ESRI:21308 / GSK-2011_GSK_3GK_CM_24E" },
  { value: "ESRI:21309", label: "ESRI:21309 / GSK-2011_GSK_3GK_CM_27E" },
  { value: "ESRI:21310", label: "ESRI:21310 / GSK-2011_GSK_3GK_CM_30E" },
  { value: "ESRI:21311", label: "ESRI:21311 / GSK-2011_GSK_3GK_CM_33E" },
  { value: "ESRI:21312", label: "ESRI:21312 / GSK-2011_GSK_3GK_CM_36E" },
  { value: "ESRI:21313", label: "ESRI:21313 / GSK-2011_GSK_3GK_CM_39E" },
  { value: "ESRI:21314", label: "ESRI:21314 / GSK-2011_GSK_3GK_CM_42E" },
  { value: "ESRI:21315", label: "ESRI:21315 / GSK-2011_GSK_3GK_CM_45E" },
  { value: "ESRI:21316", label: "ESRI:21316 / GSK-2011_GSK_3GK_CM_48E" },
  { value: "ESRI:21317", label: "ESRI:21317 / GSK-2011_GSK_3GK_CM_51E" },
  { value: "ESRI:21318", label: "ESRI:21318 / GSK-2011_GSK_3GK_CM_54E" },
  { value: "ESRI:21319", label: "ESRI:21319 / GSK-2011_GSK_3GK_CM_57E" },
  { value: "ESRI:21320", label: "ESRI:21320 / GSK-2011_GSK_3GK_CM_60E" },
  { value: "ESRI:21321", label: "ESRI:21321 / GSK-2011_GSK_3GK_CM_63E" },
  { value: "ESRI:21322", label: "ESRI:21322 / GSK-2011_GSK_3GK_CM_66E" },
  { value: "ESRI:21323", label: "ESRI:21323 / GSK-2011_GSK_3GK_CM_69E" },
  { value: "ESRI:21324", label: "ESRI:21324 / GSK-2011_GSK_3GK_CM_72E" },
  { value: "ESRI:21325", label: "ESRI:21325 / GSK-2011_GSK_3GK_CM_75E" },
  { value: "ESRI:21326", label: "ESRI:21326 / GSK-2011_GSK_3GK_CM_78E" },
  { value: "ESRI:21327", label: "ESRI:21327 / GSK-2011_GSK_3GK_CM_81E" },
  { value: "ESRI:21328", label: "ESRI:21328 / GSK-2011_GSK_3GK_CM_84E" },
  { value: "ESRI:21329", label: "ESRI:21329 / GSK-2011_GSK_3GK_CM_87E" },
  { value: "ESRI:21330", label: "ESRI:21330 / GSK-2011_GSK_3GK_CM_90E" },
  { value: "ESRI:21331", label: "ESRI:21331 / GSK-2011_GSK_3GK_CM_93E" },
  { value: "ESRI:21332", label: "ESRI:21332 / GSK-2011_GSK_3GK_CM_96E" },
  { value: "ESRI:21333", label: "ESRI:21333 / GSK-2011_GSK_3GK_CM_99E" },
  { value: "ESRI:21334", label: "ESRI:21334 / GSK-2011_GSK_3GK_CM_102E" },
  { value: "ESRI:21335", label: "ESRI:21335 / GSK-2011_GSK_3GK_CM_105E" },
  { value: "ESRI:21336", label: "ESRI:21336 / GSK-2011_GSK_3GK_CM_108E" },
  { value: "ESRI:21337", label: "ESRI:21337 / GSK-2011_GSK_3GK_CM_111E" },
  { value: "ESRI:21338", label: "ESRI:21338 / GSK-2011_GSK_3GK_CM_114E" },
  { value: "ESRI:21339", label: "ESRI:21339 / GSK-2011_GSK_3GK_CM_117E" },
  { value: "ESRI:21340", label: "ESRI:21340 / GSK-2011_GSK_3GK_CM_120E" },
  { value: "ESRI:21341", label: "ESRI:21341 / GSK-2011_GSK_3GK_CM_123E" },
  { value: "ESRI:21342", label: "ESRI:21342 / GSK-2011_GSK_3GK_CM_126E" },
  { value: "ESRI:21343", label: "ESRI:21343 / GSK-2011_GSK_3GK_CM_129E" },
  { value: "ESRI:21344", label: "ESRI:21344 / GSK-2011_GSK_3GK_CM_132E" },
  { value: "ESRI:21345", label: "ESRI:21345 / GSK-2011_GSK_3GK_CM_135E" },
  { value: "ESRI:21346", label: "ESRI:21346 / GSK-2011_GSK_3GK_CM_138E" },
  { value: "ESRI:21347", label: "ESRI:21347 / GSK-2011_GSK_3GK_CM_141E" },
  { value: "ESRI:21348", label: "ESRI:21348 / GSK-2011_GSK_3GK_CM_144E" },
  { value: "ESRI:21349", label: "ESRI:21349 / GSK-2011_GSK_3GK_CM_147E" },
  { value: "ESRI:21350", label: "ESRI:21350 / GSK-2011_GSK_3GK_CM_150E" },
  { value: "ESRI:21351", label: "ESRI:21351 / GSK-2011_GSK_3GK_CM_153E" },
  { value: "ESRI:21352", label: "ESRI:21352 / GSK-2011_GSK_3GK_CM_156E" },
  { value: "ESRI:21353", label: "ESRI:21353 / GSK-2011_GSK_3GK_CM_159E" },
  { value: "ESRI:21354", label: "ESRI:21354 / GSK-2011_GSK_3GK_CM_162E" },
  { value: "ESRI:21355", label: "ESRI:21355 / GSK-2011_GSK_3GK_CM_165E" },
  { value: "ESRI:21356", label: "ESRI:21356 / GSK-2011_GSK_3GK_CM_168E" },
  { value: "ESRI:21357", label: "ESRI:21357 / GSK-2011_GSK_3GK_CM_171E" },
  { value: "ESRI:21358", label: "ESRI:21358 / GSK-2011_GSK_3GK_CM_174E" },
  { value: "ESRI:21359", label: "ESRI:21359 / GSK-2011_GSK_3GK_CM_177E" },
  { value: "ESRI:21360", label: "ESRI:21360 / GSK-2011_GSK_3GK_CM_180E" },
  { value: "ESRI:21361", label: "ESRI:21361 / GSK-2011_GSK_3GK_CM_177W" },
  { value: "ESRI:21362", label: "ESRI:21362 / GSK-2011_GSK_3GK_CM_174W" },
  { value: "ESRI:21363", label: "ESRI:21363 / GSK-2011_GSK_3GK_CM_171W" },
  { value: "ESRI:21364", label: "ESRI:21364 / GSK-2011_GSK_3GK_CM_168W" },
  { value: "ESRI:24721", label: "ESRI:24721 / La_Canoa_UTM_Zone_21N" },
  {
    value: "ESRI:26761",
    label: "ESRI:26761 / NAD_1927_StatePlane_Hawaii_1_FIPS_5101",
  },
  {
    value: "ESRI:26762",
    label: "ESRI:26762 / NAD_1927_StatePlane_Hawaii_2_FIPS_5102",
  },
  {
    value: "ESRI:26763",
    label: "ESRI:26763 / NAD_1927_StatePlane_Hawaii_3_FIPS_5103",
  },
  {
    value: "ESRI:26764",
    label: "ESRI:26764 / NAD_1927_StatePlane_Hawaii_4_FIPS_5104",
  },
  {
    value: "ESRI:26765",
    label: "ESRI:26765 / NAD_1927_StatePlane_Hawaii_5_FIPS_5105",
  },
  {
    value: "ESRI:26788",
    label: "ESRI:26788 / NAD_1927_StatePlane_Michigan_North_FIPS_2111",
  },
  {
    value: "ESRI:26789",
    label: "ESRI:26789 / NAD_1927_StatePlane_Michigan_Central_FIPS_2112",
  },
  {
    value: "ESRI:26790",
    label: "ESRI:26790 / NAD_1927_StatePlane_Michigan_South_FIPS_2113",
  },
  { value: "ESRI:30591", label: "ESRI:30591 / Nord_Algerie" },
  { value: "ESRI:30592", label: "ESRI:30592 / Sud_Algerie" },
  { value: "ESRI:31491", label: "ESRI:31491 / Germany_Zone_1" },
  { value: "ESRI:31492", label: "ESRI:31492 / Germany_Zone_2" },
  { value: "ESRI:31493", label: "ESRI:31493 / Germany_Zone_3" },
  { value: "ESRI:31494", label: "ESRI:31494 / Germany_Zone_4" },
  { value: "ESRI:31495", label: "ESRI:31495 / Germany_Zone_5" },
  { value: "ESRI:31917", label: "ESRI:31917 / SIRGAS_UTM_Zone_17N" },
  { value: "ESRI:31918", label: "ESRI:31918 / SIRGAS_UTM_Zone_18N" },
  { value: "ESRI:31919", label: "ESRI:31919 / SIRGAS_UTM_Zone_19N" },
  { value: "ESRI:31920", label: "ESRI:31920 / SIRGAS_UTM_Zone_20N" },
  { value: "ESRI:31921", label: "ESRI:31921 / SIRGAS_UTM_Zone_21N" },
  { value: "ESRI:31922", label: "ESRI:31922 / SIRGAS_UTM_Zone_22N" },
  {
    value: "ESRI:32059",
    label: "ESRI:32059 / NAD_1927_StatePlane_Puerto_Rico_FIPS_5201",
  },
  {
    value: "ESRI:32060",
    label: "ESRI:32060 / NAD_1927_StatePlane_Virgin_Islands_St_Croix_FIPS_5202",
  },
  { value: "ESRI:53001", label: "ESRI:53001 / Sphere_Plate_Carree" },
  { value: "ESRI:53002", label: "ESRI:53002 / Sphere_Equidistant_Cylindrical" },
  { value: "ESRI:53003", label: "ESRI:53003 / Sphere_Miller_Cylindrical" },
  { value: "ESRI:53004", label: "ESRI:53004 / Sphere_Mercator" },
  { value: "ESRI:53008", label: "ESRI:53008 / Sphere_Sinusoidal" },
  { value: "ESRI:53009", label: "ESRI:53009 / Sphere_Mollweide" },
  { value: "ESRI:53010", label: "ESRI:53010 / Sphere_Eckert_VI" },
  { value: "ESRI:53011", label: "ESRI:53011 / Sphere_Eckert_V" },
  { value: "ESRI:53012", label: "ESRI:53012 / Sphere_Eckert_IV" },
  { value: "ESRI:53013", label: "ESRI:53013 / Sphere_Eckert_III" },
  { value: "ESRI:53014", label: "ESRI:53014 / Sphere_Eckert_II" },
  { value: "ESRI:53015", label: "ESRI:53015 / Sphere_Eckert_I" },
  { value: "ESRI:53016", label: "ESRI:53016 / Sphere_Gall_Stereographic" },
  { value: "ESRI:53017", label: "ESRI:53017 / Sphere_Behrmann" },
  { value: "ESRI:53018", label: "ESRI:53018 / Sphere_Winkel_I" },
  { value: "ESRI:53019", label: "ESRI:53019 / Sphere_Winkel_II" },
  { value: "ESRI:53021", label: "ESRI:53021 / Sphere_Polyconic" },
  { value: "ESRI:53022", label: "ESRI:53022 / Sphere_Quartic_Authalic" },
  { value: "ESRI:53023", label: "ESRI:53023 / Sphere_Loximuthal" },
  { value: "ESRI:53024", label: "ESRI:53024 / Sphere_Bonne" },
  { value: "ESRI:53025", label: "ESRI:53025 / Sphere_Hotine" },
  { value: "ESRI:53026", label: "ESRI:53026 / Sphere_Stereographic" },
  { value: "ESRI:53027", label: "ESRI:53027 / Sphere_Equidistant_Conic" },
  { value: "ESRI:53028", label: "ESRI:53028 / Sphere_Cassini" },
  { value: "ESRI:53029", label: "ESRI:53029 / Sphere_Van_der_Grinten_I" },
  { value: "ESRI:53030", label: "ESRI:53030 / Sphere_Robinson" },
  { value: "ESRI:53031", label: "ESRI:53031 / Sphere_Two_Point_Equidistant" },
  { value: "ESRI:53032", label: "ESRI:53032 / Sphere_Azimuthal_Equidistant" },
  { value: "ESRI:53034", label: "ESRI:53034 / Sphere_Cylindrical_Equal_Area" },
  { value: "ESRI:53035", label: "ESRI:53035 / Sphere_Equal_Earth_Greenwich" },
  { value: "ESRI:53036", label: "ESRI:53036 / Sphere_Equal_Earth_Americas" },
  {
    value: "ESRI:53037",
    label: "ESRI:53037 / Sphere_Equal_Earth_Asia_Pacific",
  },
  { value: "ESRI:53042", label: "ESRI:53042 / Sphere_Winkel_Tripel_NGS" },
  { value: "ESRI:53043", label: "ESRI:53043 / Sphere_Aitoff" },
  { value: "ESRI:53044", label: "ESRI:53044 / Sphere_Hammer_Aitoff" },
  { value: "ESRI:53045", label: "ESRI:53045 / Sphere_Flat_Polar_Quartic" },
  { value: "ESRI:53046", label: "ESRI:53046 / Sphere_Craster_Parabolic" },
  { value: "ESRI:53048", label: "ESRI:53048 / Sphere_Times" },
  { value: "ESRI:53049", label: "ESRI:53049 / Sphere_Vertical_Perspective" },
  { value: "ESRI:53074", label: "ESRI:53074 / Sphere_Wagner_IV" },
  { value: "ESRI:53075", label: "ESRI:53075 / Sphere_Wagner_V" },
  { value: "ESRI:53076", label: "ESRI:53076 / Sphere_Wagner_VII" },
  { value: "ESRI:53077", label: "ESRI:53077 / Sphere_Natural_Earth" },
  { value: "ESRI:53078", label: "ESRI:53078 / Sphere_Natural_Earth_II" },
  { value: "ESRI:53079", label: "ESRI:53079 / Sphere_Patterson" },
  { value: "ESRI:53080", label: "ESRI:53080 / Sphere_Compact_Miller" },
  { value: "ESRI:54001", label: "ESRI:54001 / World_Plate_Carree" },
  { value: "ESRI:54002", label: "ESRI:54002 / World_Equidistant_Cylindrical" },
  { value: "ESRI:54003", label: "ESRI:54003 / World_Miller_Cylindrical" },
  { value: "ESRI:54004", label: "ESRI:54004 / World_Mercator" },
  { value: "ESRI:54008", label: "ESRI:54008 / World_Sinusoidal" },
  { value: "ESRI:54009", label: "ESRI:54009 / World_Mollweide" },
  { value: "ESRI:54010", label: "ESRI:54010 / World_Eckert_VI" },
  { value: "ESRI:54011", label: "ESRI:54011 / World_Eckert_V" },
  { value: "ESRI:54012", label: "ESRI:54012 / World_Eckert_IV" },
  { value: "ESRI:54013", label: "ESRI:54013 / World_Eckert_III" },
  { value: "ESRI:54014", label: "ESRI:54014 / World_Eckert_II" },
  { value: "ESRI:54015", label: "ESRI:54015 / World_Eckert_I" },
  { value: "ESRI:54016", label: "ESRI:54016 / World_Gall_Stereographic" },
  { value: "ESRI:54017", label: "ESRI:54017 / World_Behrmann" },
  { value: "ESRI:54018", label: "ESRI:54018 / World_Winkel_I" },
  { value: "ESRI:54019", label: "ESRI:54019 / World_Winkel_II" },
  { value: "ESRI:54021", label: "ESRI:54021 / World_Polyconic" },
  { value: "ESRI:54022", label: "ESRI:54022 / World_Quartic_Authalic" },
  { value: "ESRI:54023", label: "ESRI:54023 / World_Loximuthal" },
  { value: "ESRI:54024", label: "ESRI:54024 / World_Bonne" },
  { value: "ESRI:54025", label: "ESRI:54025 / World_Hotine" },
  { value: "ESRI:54026", label: "ESRI:54026 / World_Stereographic" },
  { value: "ESRI:54027", label: "ESRI:54027 / World_Equidistant_Conic" },
  { value: "ESRI:54028", label: "ESRI:54028 / World_Cassini" },
  { value: "ESRI:54029", label: "ESRI:54029 / World_Van_der_Grinten_I" },
  { value: "ESRI:54030", label: "ESRI:54030 / World_Robinson" },
  { value: "ESRI:54031", label: "ESRI:54031 / World_Two_Point_Equidistant" },
  { value: "ESRI:54032", label: "ESRI:54032 / World_Azimuthal_Equidistant" },
  { value: "ESRI:54034", label: "ESRI:54034 / World_Cylindrical_Equal_Area" },
  { value: "ESRI:54035", label: "ESRI:54035 / WGS_1984_Equal_Earth_Greenwich" },
  { value: "ESRI:54036", label: "ESRI:54036 / WGS_1984_Equal_Earth_Americas" },
  {
    value: "ESRI:54037",
    label: "ESRI:54037 / WGS_1984_Equal_Earth_Asia_Pacific",
  },
  { value: "ESRI:54042", label: "ESRI:54042 / World_Winkel_Tripel_NGS" },
  { value: "ESRI:54043", label: "ESRI:54043 / World_Aitoff" },
  { value: "ESRI:54044", label: "ESRI:54044 / World_Hammer_Aitoff" },
  { value: "ESRI:54045", label: "ESRI:54045 / World_Flat_Polar_Quartic" },
  { value: "ESRI:54046", label: "ESRI:54046 / World_Craster_Parabolic" },
  { value: "ESRI:54048", label: "ESRI:54048 / World_Times" },
  { value: "ESRI:54049", label: "ESRI:54049 / World_Vertical_Perspective" },
  { value: "ESRI:54050", label: "ESRI:54050 / World_Fuller" },
  { value: "ESRI:54051", label: "ESRI:54051 / World_Cube" },
  { value: "ESRI:54052", label: "ESRI:54052 / World_Goode_Homolosine_Land" },
  { value: "ESRI:54053", label: "ESRI:54053 / World_Goode_Homolosine_Ocean" },
  { value: "ESRI:54074", label: "ESRI:54074 / World_Wagner_IV" },
  { value: "ESRI:54075", label: "ESRI:54075 / World_Wagner_V" },
  { value: "ESRI:54076", label: "ESRI:54076 / World_Wagner_VII" },
  { value: "ESRI:54077", label: "ESRI:54077 / World_Natural_Earth" },
  { value: "ESRI:54078", label: "ESRI:54078 / World_Natural_Earth_II" },
  { value: "ESRI:54079", label: "ESRI:54079 / World_Patterson" },
  { value: "ESRI:54080", label: "ESRI:54080 / World_Compact_Miller" },
  {
    value: "ESRI:54090",
    label: "ESRI:54090 / WGS_1984_Peirce_quincuncial_North_Pole_square",
  },
  {
    value: "ESRI:54091",
    label: "ESRI:54091 / WGS_1984_Peirce_quincuncial_North_Pole_diamond",
  },
  { value: "ESRI:54098", label: "ESRI:54098 / WGS_1984_Adams_Square_II" },
  {
    value: "ESRI:54099",
    label: "ESRI:54099 / WGS_1984_Spilhaus_Ocean_Map_in_Square",
  },
  { value: "ESRI:54100", label: "ESRI:54100 / WGS_1984_Tobler_Cylindrical_I" },
  { value: "ESRI:54101", label: "ESRI:54101 / WGS_1984_Tobler_Cylindrical_II" },
  {
    value: "ESRI:65061",
    label: "ESRI:65061 / NAD_1927_StatePlane_Guam_FIPS_5400",
  },
  {
    value: "ESRI:65062",
    label:
      "ESRI:65062 / American_Samoa_1962_StatePlane_American_Samoa_FIPS_5300",
  },
  {
    value: "ESRI:65161",
    label: "ESRI:65161 / NAD_1983_StatePlane_Guam_FIPS_5400",
  },
  {
    value: "ESRI:65163",
    label: "ESRI:65163 / NAD_1983_StatePlane_Kentucky_FIPS_1600",
  },
  {
    value: "ESRI:102001",
    label: "ESRI:102001 / Canada_Albers_Equal_Area_Conic",
  },
  {
    value: "ESRI:102002",
    label: "ESRI:102002 / Canada_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102003",
    label: "ESRI:102003 / USA_Contiguous_Albers_Equal_Area_Conic",
  },
  {
    value: "ESRI:102004",
    label: "ESRI:102004 / USA_Contiguous_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102005",
    label: "ESRI:102005 / USA_Contiguous_Equidistant_Conic",
  },
  { value: "ESRI:102006", label: "ESRI:102006 / NAD_1983_Alaska_Albers" },
  {
    value: "ESRI:102007",
    label: "ESRI:102007 / Hawaii_Albers_Equal_Area_Conic",
  },
  {
    value: "ESRI:102008",
    label: "ESRI:102008 / North_America_Albers_Equal_Area_Conic",
  },
  {
    value: "ESRI:102009",
    label: "ESRI:102009 / North_America_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102010",
    label: "ESRI:102010 / North_America_Equidistant_Conic",
  },
  { value: "ESRI:102011", label: "ESRI:102011 / Africa_Sinusoidal" },
  { value: "ESRI:102012", label: "ESRI:102012 / Asia_Lambert_Conformal_Conic" },
  {
    value: "ESRI:102013",
    label: "ESRI:102013 / Europe_Albers_Equal_Area_Conic",
  },
  {
    value: "ESRI:102014",
    label: "ESRI:102014 / Europe_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102015",
    label: "ESRI:102015 / South_America_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102016",
    label: "ESRI:102016 / North_Pole_Azimuthal_Equidistant",
  },
  {
    value: "ESRI:102017",
    label: "ESRI:102017 / North_Pole_Lambert_Azimuthal_Equal_Area",
  },
  { value: "ESRI:102018", label: "ESRI:102018 / North_Pole_Stereographic" },
  {
    value: "ESRI:102019",
    label: "ESRI:102019 / South_Pole_Azimuthal_Equidistant",
  },
  {
    value: "ESRI:102020",
    label: "ESRI:102020 / South_Pole_Lambert_Azimuthal_Equal_Area",
  },
  { value: "ESRI:102021", label: "ESRI:102021 / South_Pole_Stereographic" },
  {
    value: "ESRI:102022",
    label: "ESRI:102022 / Africa_Albers_Equal_Area_Conic",
  },
  { value: "ESRI:102023", label: "ESRI:102023 / Africa_Equidistant_Conic" },
  {
    value: "ESRI:102024",
    label: "ESRI:102024 / Africa_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102025",
    label: "ESRI:102025 / Asia_North_Albers_Equal_Area_Conic",
  },
  { value: "ESRI:102026", label: "ESRI:102026 / Asia_North_Equidistant_Conic" },
  {
    value: "ESRI:102027",
    label: "ESRI:102027 / Asia_North_Lambert_Conformal_Conic",
  },
  {
    value: "ESRI:102028",
    label: "ESRI:102028 / Asia_South_Albers_Equal_Area_Conic",
  },
  { value: "ESRI:102029", label: "ESRI:102029 / Asia_South_Equidistant_Conic" },
  {
    value: "ESRI:102030",
    label: "ESRI:102030 / Asia_South_Lambert_Conformal_Conic",
  },
  { value: "ESRI:102031", label: "ESRI:102031 / Europe_Equidistant_Conic" },
  {
    value: "ESRI:102032",
    label: "ESRI:102032 / South_America_Equidistant_Conic",
  },
  {
    value: "ESRI:102033",
    label: "ESRI:102033 / South_America_Albers_Equal_Area_Conic",
  },
  { value: "ESRI:102034", label: "ESRI:102034 / North_Pole_Gnomonic" },
  { value: "ESRI:102035", label: "ESRI:102035 / North_Pole_Orthographic" },
  { value: "ESRI:102036", label: "ESRI:102036 / South_Pole_Gnomonic" },
  { value: "ESRI:102037", label: "ESRI:102037 / South_Pole_Orthographic" },
  { value: "ESRI:102038", label: "ESRI:102038 / The_World_From_Space" },
  {
    value: "ESRI:102039",
    label: "ESRI:102039 / USA_Contiguous_Albers_Equal_Area_Conic_USGS_version",
  },
  {
    value: "ESRI:102040",
    label: "ESRI:102040 / Korean_1985_Korea_Unified_Coordinate_System",
  },
  { value: "ESRI:102041", label: "ESRI:102041 / COB_NAD83_2007" },
  { value: "ESRI:102042", label: "ESRI:102042 / NAD_1983_USFS_R9_Albers" },
  { value: "ESRI:102043", label: "ESRI:102043 / NAD_1983_CORS96_UTM_Zone_20N" },
  {
    value: "ESRI:102044",
    label: "ESRI:102044 / NAD_1983_NSRS2007_UTM_Zone_20N",
  },
  { value: "ESRI:102045", label: "ESRI:102045 / NAD_1983_2011_UTM_Zone_20N" },
  { value: "ESRI:102046", label: "ESRI:102046 / NAD_1983_2011_UTM_Zone_59N" },
  { value: "ESRI:102047", label: "ESRI:102047 / NAD_1983_2011_UTM_Zone_60N" },
  { value: "ESRI:102048", label: "ESRI:102048 / NAD_1983_2011_UTM_Zone_1N" },
  { value: "ESRI:102049", label: "ESRI:102049 / NAD_1983_2011_UTM_Zone_2N" },
  { value: "ESRI:102050", label: "ESRI:102050 / NAD_1983_2011_UTM_Zone_3N" },
  { value: "ESRI:102051", label: "ESRI:102051 / NAD_1983_2011_UTM_Zone_4N" },
  { value: "ESRI:102052", label: "ESRI:102052 / NAD_1983_2011_UTM_Zone_5N" },
  { value: "ESRI:102053", label: "ESRI:102053 / NAD_1983_2011_UTM_Zone_6N" },
  { value: "ESRI:102054", label: "ESRI:102054 / NAD_1983_2011_UTM_Zone_7N" },
  { value: "ESRI:102055", label: "ESRI:102055 / NAD_1983_2011_UTM_Zone_8N" },
  { value: "ESRI:102056", label: "ESRI:102056 / NAD_1983_2011_UTM_Zone_9N" },
  { value: "ESRI:102057", label: "ESRI:102057 / NAD_1983_2011_UTM_Zone_10N" },
  { value: "ESRI:102058", label: "ESRI:102058 / NAD_1983_2011_UTM_Zone_11N" },
  { value: "ESRI:102059", label: "ESRI:102059 / NAD_1983_2011_UTM_Zone_12N" },
  { value: "ESRI:102060", label: "ESRI:102060 / D48_Slovenia_TM" },
  {
    value: "ESRI:102061",
    label: "ESRI:102061 / Everest_Modified_1969_RSO_Malaya_Meters",
  },
  { value: "ESRI:102062", label: "ESRI:102062 / Kertau_RSO_Malaya_Meters" },
  { value: "ESRI:102063", label: "ESRI:102063 / Kandawala_Ceylon_Belt_Meters" },
  {
    value: "ESRI:102064",
    label: "ESRI:102064 / Kandawala_Ceylon_Belt_Indian_Yards_1937",
  },
  { value: "ESRI:102065", label: "ESRI:102065 / S-JTSK_Krovak" },
  {
    value: "ESRI:102066",
    label: "ESRI:102066 / S-JTSK_Ferro_Krovak_East_North",
  },
  { value: "ESRI:102067", label: "ESRI:102067 / S-JTSK_Krovak_East_North" },
  { value: "ESRI:102068", label: "ESRI:102068 / EMEP_50_Kilometer_Grid" },
  { value: "ESRI:102069", label: "ESRI:102069 / EMEP_150_Kilometer_Grid" },
  { value: "ESRI:102070", label: "ESRI:102070 / Guernsey_Grid" },
  { value: "ESRI:102071", label: "ESRI:102071 / AGD_1966_ACT_Grid_AGC_Zone" },
  { value: "ESRI:102072", label: "ESRI:102072 / AGD_1966_ISG_54_2" },
  { value: "ESRI:102073", label: "ESRI:102073 / AGD_1966_ISG_54_3" },
  { value: "ESRI:102074", label: "ESRI:102074 / AGD_1966_ISG_55_1" },
  { value: "ESRI:102075", label: "ESRI:102075 / AGD_1966_ISG_55_2" },
  { value: "ESRI:102076", label: "ESRI:102076 / AGD_1966_ISG_55_3" },
  { value: "ESRI:102077", label: "ESRI:102077 / AGD_1966_ISG_56_1" },
  { value: "ESRI:102078", label: "ESRI:102078 / AGD_1966_ISG_56_2" },
  { value: "ESRI:102079", label: "ESRI:102079 / AGD_1966_ISG_56_3" },
  {
    value: "ESRI:102080",
    label: "ESRI:102080 / Korea_2000_Korea_Unified_Coordinate_System",
  },
  {
    value: "ESRI:102081",
    label: "ESRI:102081 / Korea_2000_Korea_West_Belt_2010",
  },
  {
    value: "ESRI:102082",
    label: "ESRI:102082 / Korea_2000_Korea_Central_Belt_2010",
  },
  {
    value: "ESRI:102083",
    label: "ESRI:102083 / Korea_2000_Korea_East_Belt_2010",
  },
  {
    value: "ESRI:102084",
    label: "ESRI:102084 / Korea_2000_Korea_East_Sea_Belt_2010",
  },
  {
    value: "ESRI:102085",
    label: "ESRI:102085 / Korean_1985_Modified_Korea_West_Belt",
  },
  {
    value: "ESRI:102086",
    label: "ESRI:102086 / Korean_1985_Modified_Korea_Central_Belt",
  },
  {
    value: "ESRI:102087",
    label: "ESRI:102087 / Korean_1985_Modified_Korea_Central_Belt_Jeju",
  },
  {
    value: "ESRI:102088",
    label: "ESRI:102088 / Korean_1985_Modified_Korea_East_Belt",
  },
  {
    value: "ESRI:102089",
    label: "ESRI:102089 / Korean_1985_Modified_Korea_East_Sea_Belt",
  },
  { value: "ESRI:102090", label: "ESRI:102090 / Bermuda_2000_National_Grid" },
  { value: "ESRI:102091", label: "ESRI:102091 / Monte_Mario_Italy_1" },
  { value: "ESRI:102092", label: "ESRI:102092 / Monte_Mario_Italy_2" },
  { value: "ESRI:102093", label: "ESRI:102093 / Roma_1940_Gauss_Boaga_Est" },
  { value: "ESRI:102094", label: "ESRI:102094 / Roma_1940_Gauss_Boaga_Ovest" },
  { value: "ESRI:102095", label: "ESRI:102095 / JAD_2001_Jamaica_Grid" },
  {
    value: "ESRI:102096",
    label: "ESRI:102096 / Bab_South_Palau_Azimuthal_Equidistant",
  },
  { value: "ESRI:102097", label: "ESRI:102097 / ETRS_1989_UTM_Zone_26N" },
  { value: "ESRI:102098", label: "ESRI:102098 / ETRS_1989_UTM_Zone_27N" },
  { value: "ESRI:102099", label: "ESRI:102099 / ETRS_1989_UTM_Zone_39N" },
  {
    value: "ESRI:102100",
    label: "ESRI:102100 / WGS_1984_Web_Mercator_Auxiliary_Sphere",
  },
  { value: "ESRI:102101", label: "ESRI:102101 / NGO_1948_Norway_Zone_1" },
  { value: "ESRI:102102", label: "ESRI:102102 / NGO_1948_Norway_Zone_2" },
  { value: "ESRI:102103", label: "ESRI:102103 / NGO_1948_Norway_Zone_3" },
  { value: "ESRI:102104", label: "ESRI:102104 / NGO_1948_Norway_Zone_4" },
  { value: "ESRI:102105", label: "ESRI:102105 / NGO_1948_Norway_Zone_5" },
  { value: "ESRI:102106", label: "ESRI:102106 / NGO_1948_Norway_Zone_6" },
  { value: "ESRI:102107", label: "ESRI:102107 / NGO_1948_Norway_Zone_7" },
  { value: "ESRI:102108", label: "ESRI:102108 / NGO_1948_Norway_Zone_8" },
  { value: "ESRI:102109", label: "ESRI:102109 / ETRS_1989_Slovenia_TM" },
  { value: "ESRI:102110", label: "ESRI:102110 / RGF_1993_Lambert_93" },
  {
    value: "ESRI:102111",
    label: "ESRI:102111 / Chatham_Islands_1979_Map_Grid",
  },
  {
    value: "ESRI:102112",
    label: "ESRI:102112 / NZGD_2000_Chatham_Island_Circuit",
  },
  { value: "ESRI:102113", label: "ESRI:102113 / WGS_1984_Web_Mercator" },
  { value: "ESRI:102114", label: "ESRI:102114 / Old_Hawaiian_UTM_Zone_4N" },
  { value: "ESRI:102115", label: "ESRI:102115 / Old_Hawaiian_UTM_Zone_5N" },
  {
    value: "ESRI:102116",
    label: "ESRI:102116 / American_Samoa_1962_UTM_Zone_2S",
  },
  {
    value: "ESRI:102117",
    label: "ESRI:102117 / NAD_1927_Alaska_Albers_Meters",
  },
  {
    value: "ESRI:102118",
    label: "ESRI:102118 / NAD_1927_Georgia_Statewide_Albers",
  },
  {
    value: "ESRI:102119",
    label: "ESRI:102119 / NAD_1927_Texas_Statewide_Mapping_System",
  },
  {
    value: "ESRI:102120",
    label: "ESRI:102120 / NAD_1927_Michigan_GeoRef_Feet_US",
  },
  {
    value: "ESRI:102121",
    label: "ESRI:102121 / NAD_1983_Michigan_GeoRef_Feet_US",
  },
  {
    value: "ESRI:102122",
    label: "ESRI:102122 / NAD_1927_Michigan_GeoRef_Meters",
  },
  {
    value: "ESRI:102123",
    label: "ESRI:102123 / NAD_1983_Michigan_GeoRef_Meters",
  },
  { value: "ESRI:102124", label: "ESRI:102124 / NAD_1927_UTM_Zone_1N" },
  { value: "ESRI:102125", label: "ESRI:102125 / NAD_1927_UTM_Zone_2N" },
  { value: "ESRI:102126", label: "ESRI:102126 / NAD_1927_UTM_Zone_59N" },
  { value: "ESRI:102127", label: "ESRI:102127 / NAD_1927_UTM_Zone_60N" },
  { value: "ESRI:102128", label: "ESRI:102128 / NAD_1983_UTM_Zone_1N" },
  { value: "ESRI:102129", label: "ESRI:102129 / NAD_1983_UTM_Zone_2N" },
  { value: "ESRI:102130", label: "ESRI:102130 / NAD_1983_UTM_Zone_59N" },
  { value: "ESRI:102131", label: "ESRI:102131 / NAD_1983_UTM_Zone_60N" },
  { value: "ESRI:102132", label: "ESRI:102132 / NGO_1948_UTM_Zone_32N" },
  { value: "ESRI:102133", label: "ESRI:102133 / NGO_1948_UTM_Zone_33N" },
  { value: "ESRI:102134", label: "ESRI:102134 / NGO_1948_UTM_Zone_34N" },
  { value: "ESRI:102135", label: "ESRI:102135 / NGO_1948_UTM_Zone_35N" },
  { value: "ESRI:102136", label: "ESRI:102136 / NGO_1948_Baerum_Kommune" },
  { value: "ESRI:102137", label: "ESRI:102137 / NGO_1948_Bergenhalvoen" },
  { value: "ESRI:102138", label: "ESRI:102138 / NGO_1948_Oslo_Kommune" },
  { value: "ESRI:102139", label: "ESRI:102139 / EUREF_FIN_TM35FIN" },
  { value: "ESRI:102140", label: "ESRI:102140 / Hong_Kong_1980_Grid" },
  { value: "ESRI:102141", label: "ESRI:102141 / Hong_Kong_1980_UTM_Zone_49N" },
  { value: "ESRI:102142", label: "ESRI:102142 / Hong_Kong_1980_UTM_Zone_50N" },
  { value: "ESRI:102143", label: "ESRI:102143 / QND_1995_UTM_39N" },
  { value: "ESRI:102144", label: "ESRI:102144 / Merchich_Degree_UTM_Zone_28N" },
  { value: "ESRI:102145", label: "ESRI:102145 / JGD_2000_UTM_Zone_51N" },
  { value: "ESRI:102146", label: "ESRI:102146 / JGD_2000_UTM_Zone_52N" },
  { value: "ESRI:102147", label: "ESRI:102147 / JGD_2000_UTM_Zone_53N" },
  { value: "ESRI:102148", label: "ESRI:102148 / JGD_2000_UTM_Zone_54N" },
  { value: "ESRI:102149", label: "ESRI:102149 / JGD_2000_UTM_Zone_55N" },
  { value: "ESRI:102150", label: "ESRI:102150 / JGD_2000_UTM_Zone_56N" },
  { value: "ESRI:102151", label: "ESRI:102151 / Tokyo_UTM_Zone_51N" },
  { value: "ESRI:102152", label: "ESRI:102152 / Tokyo_UTM_Zone_52N" },
  { value: "ESRI:102153", label: "ESRI:102153 / Tokyo_UTM_Zone_53N" },
  { value: "ESRI:102154", label: "ESRI:102154 / Tokyo_UTM_Zone_54N" },
  { value: "ESRI:102155", label: "ESRI:102155 / Tokyo_UTM_Zone_55N" },
  { value: "ESRI:102156", label: "ESRI:102156 / Tokyo_UTM_Zone_56N" },
  { value: "ESRI:102157", label: "ESRI:102157 / ETRS_1989_Kosovo_Grid" },
  { value: "ESRI:102158", label: "ESRI:102158 / Jordan_JTM" },
  {
    value: "ESRI:102159",
    label: "ESRI:102159 / Observatorio_Meteorologico_1965_Macau_Grid",
  },
  { value: "ESRI:102160", label: "ESRI:102160 / Datum_73_Hayford_Gauss_IGeoE" },
  { value: "ESRI:102161", label: "ESRI:102161 / Datum_73_Hayford_Gauss_IPCC" },
  {
    value: "ESRI:102162",
    label: "ESRI:102162 / Graciosa_Base_SW_1948_UTM_Zone_26N",
  },
  { value: "ESRI:102163", label: "ESRI:102163 / Lisboa_Bessel_Bonne" },
  { value: "ESRI:102164", label: "ESRI:102164 / Lisboa_Hayford_Gauss_IGeoE" },
  { value: "ESRI:102165", label: "ESRI:102165 / Lisboa_Hayford_Gauss_IPCC" },
  {
    value: "ESRI:102166",
    label: "ESRI:102166 / Observatorio_Meteorologico_1939_UTM_Zone_25N",
  },
  {
    value: "ESRI:102167",
    label: "ESRI:102167 / Porto_Santo_1936_UTM_Zone_28N",
  },
  { value: "ESRI:102168", label: "ESRI:102168 / Sao_Braz_UTM_Zone_26N" },
  {
    value: "ESRI:102169",
    label: "ESRI:102169 / Selvagem_Grande_1938_UTM_Zone_28N",
  },
  { value: "ESRI:102170", label: "ESRI:102170 / AGD_1966_VICGRID" },
  { value: "ESRI:102171", label: "ESRI:102171 / GDA_1994_VICGRID94" },
  {
    value: "ESRI:102172",
    label: "ESRI:102172 / GDA_1994_South_Australia_Lambert",
  },
  { value: "ESRI:102173", label: "ESRI:102173 / ETRS_1989_UWPP_1992" },
  { value: "ESRI:102174", label: "ESRI:102174 / ETRS_1989_UWPP_2000_PAS_5" },
  { value: "ESRI:102175", label: "ESRI:102175 / ETRS_1989_UWPP_2000_PAS_6" },
  { value: "ESRI:102176", label: "ESRI:102176 / ETRS_1989_UWPP_2000_PAS_7" },
  { value: "ESRI:102177", label: "ESRI:102177 / ETRS_1989_UWPP_2000_PAS_8" },
  { value: "ESRI:102178", label: "ESRI:102178 / NAD_1927_10TM_AEP_Forest" },
  { value: "ESRI:102179", label: "ESRI:102179 / NAD_1927_10TM_AEP_Resource" },
  { value: "ESRI:102180", label: "ESRI:102180 / NAD_1927_3TM_111" },
  { value: "ESRI:102181", label: "ESRI:102181 / NAD_1927_3TM_114" },
  { value: "ESRI:102182", label: "ESRI:102182 / NAD_1927_3TM_117" },
  { value: "ESRI:102183", label: "ESRI:102183 / NAD_1927_3TM_120" },
  { value: "ESRI:102184", label: "ESRI:102184 / NAD_1983_10TM_AEP_Forest" },
  { value: "ESRI:102185", label: "ESRI:102185 / NAD_1983_10TM_AEP_Resource" },
  { value: "ESRI:102186", label: "ESRI:102186 / NAD_1983_3TM_111" },
  { value: "ESRI:102187", label: "ESRI:102187 / NAD_1983_3TM_114" },
  { value: "ESRI:102188", label: "ESRI:102188 / NAD_1983_3TM_117" },
  { value: "ESRI:102189", label: "ESRI:102189 / NAD_1983_3TM_120" },
  {
    value: "ESRI:102190",
    label: "ESRI:102190 / NAD_1983_BC_Environment_Albers",
  },
  { value: "ESRI:102191", label: "ESRI:102191 / Nord_Maroc_Degree" },
  { value: "ESRI:102192", label: "ESRI:102192 / Sud_Maroc_Degree" },
  { value: "ESRI:102193", label: "ESRI:102193 / Sahara_Degree" },
  { value: "ESRI:102194", label: "ESRI:102194 / UWPP_1992" },
  { value: "ESRI:102195", label: "ESRI:102195 / UWPP_2000_PAS_5" },
  { value: "ESRI:102196", label: "ESRI:102196 / UWPP_2000_PAS_6" },
  { value: "ESRI:102197", label: "ESRI:102197 / UWPP_2000_PAS_7" },
  { value: "ESRI:102198", label: "ESRI:102198 / UWPP_2000_PAS_8" },
  { value: "ESRI:102199", label: "ESRI:102199 / Belge_Lambert_2008" },
  { value: "ESRI:102200", label: "ESRI:102200 / NAD_1983_HARN_UTM_Zone_2S" },
  { value: "ESRI:102201", label: "ESRI:102201 / NAD_1983_HARN_Guam_Map_Grid" },
  { value: "ESRI:102202", label: "ESRI:102202 / NAD_1983_HARN_UTM_Zone_4N" },
  { value: "ESRI:102203", label: "ESRI:102203 / NAD_1983_HARN_UTM_Zone_5N" },
  {
    value: "ESRI:102204",
    label: "ESRI:102204 / Ain_el_Abd_1970_Aramco_Lambert_2",
  },
  { value: "ESRI:102205", label: "ESRI:102205 / NAD_1983_HARN_UTM_Zone_11N" },
  { value: "ESRI:102206", label: "ESRI:102206 / NAD_1983_HARN_UTM_Zone_12N" },
  { value: "ESRI:102207", label: "ESRI:102207 / NAD_1983_HARN_UTM_Zone_13N" },
  {
    value: "ESRI:102208",
    label: "ESRI:102208 / NAD_1983_HARN_Maine_2000_East_Zone",
  },
  {
    value: "ESRI:102209",
    label: "ESRI:102209 / NAD_1983_HARN_Maine_2000_Central_Zone",
  },
  {
    value: "ESRI:102210",
    label: "ESRI:102210 / NAD_1983_HARN_Maine_2000_West_Zone",
  },
  { value: "ESRI:102211", label: "ESRI:102211 / NAD_1983_HARN_UTM_Zone_18N" },
  { value: "ESRI:102212", label: "ESRI:102212 / NAD_1983_WyLAM" },
  { value: "ESRI:102213", label: "ESRI:102213 / NAD_1983_UTM_Zone_58N" },
  { value: "ESRI:102214", label: "ESRI:102214 / WGS_1984_Cape_Verde_Grid" },
  { value: "ESRI:102215", label: "ESRI:102215 / WGS_1984_Canada_Atlas_LCC" },
  {
    value: "ESRI:102216",
    label: "ESRI:102216 / GDA_1994_Perth_Coastal_Grid_1994",
  },
  {
    value: "ESRI:102217",
    label: "ESRI:102217 / NAD_1983_NSRS2007_Wisconsin_TM_US_Ft",
  },
  { value: "ESRI:102218", label: "ESRI:102218 / NAD_1983_USFS_R6_Albers" },
  { value: "ESRI:102219", label: "ESRI:102219 / NAD_1983_Wisconsin_TM_US_Ft" },
  {
    value: "ESRI:102220",
    label: "ESRI:102220 / NAD_1983_HARN_Wisconsin_TM_US_Ft",
  },
  {
    value: "ESRI:102221",
    label: "ESRI:102221 / Ocotepeque_1935_Costa_Rica_Lambert_Norte",
  },
  {
    value: "ESRI:102222",
    label: "ESRI:102222 / Ocotepeque_1935_Costa_Rica_Lambert_Sur",
  },
  { value: "ESRI:102223", label: "ESRI:102223 / WGS_1984_Costa_Rica_TM_90" },
  { value: "ESRI:102224", label: "ESRI:102224 / MONREF_1997_UTM_Zone_46N" },
  { value: "ESRI:102225", label: "ESRI:102225 / MONREF_1997_UTM_Zone_47N" },
  { value: "ESRI:102226", label: "ESRI:102226 / MONREF_1997_UTM_Zone_48N" },
  { value: "ESRI:102227", label: "ESRI:102227 / MONREF_1997_UTM_Zone_49N" },
  { value: "ESRI:102228", label: "ESRI:102228 / MONREF_1997_UTM_Zone_50N" },
  {
    value: "ESRI:102229",
    label: "ESRI:102229 / NAD_1983_HARN_StatePlane_Alabama_East_FIPS_0101",
  },
  {
    value: "ESRI:102230",
    label: "ESRI:102230 / NAD_1983_HARN_StatePlane_Alabama_West_FIPS_0102",
  },
  { value: "ESRI:102231", label: "ESRI:102231 / Colombia_West_West_Zone" },
  { value: "ESRI:102232", label: "ESRI:102232 / Bogota_Ciudad_Bogota" },
  { value: "ESRI:102233", label: "ESRI:102233 / MAGNA_Ciudad_Bogota" },
  { value: "ESRI:102234", label: "ESRI:102234 / NAD_1983_CSRS_UTM_Zone_14N" },
  { value: "ESRI:102235", label: "ESRI:102235 / NAD_1983_CSRS_UTM_Zone_15N" },
  { value: "ESRI:102236", label: "ESRI:102236 / NAD_1983_CSRS_UTM_Zone_16N" },
  { value: "ESRI:102237", label: "ESRI:102237 / Pohnpei_Az_Eq_1971" },
  { value: "ESRI:102238", label: "ESRI:102238 / Saipan_Az_Eq_1969" },
  {
    value: "ESRI:102239",
    label: "ESRI:102239 / Guam_Geodetic_Triangulation_Network_1963",
  },
  { value: "ESRI:102240", label: "ESRI:102240 / Guam_Geodetic_Network_1993" },
  {
    value: "ESRI:102241",
    label: "ESRI:102241 / NAD_1983_HARN_StatePlane_California_I_FIPS_0401",
  },
  {
    value: "ESRI:102242",
    label: "ESRI:102242 / NAD_1983_HARN_StatePlane_California_II_FIPS_0402",
  },
  {
    value: "ESRI:102243",
    label: "ESRI:102243 / NAD_1983_HARN_StatePlane_California_III_FIPS_0403",
  },
  {
    value: "ESRI:102244",
    label: "ESRI:102244 / NAD_1983_HARN_StatePlane_California_IV_FIPS_0404",
  },
  {
    value: "ESRI:102245",
    label: "ESRI:102245 / NAD_1983_HARN_StatePlane_California_V_FIPS_0405",
  },
  {
    value: "ESRI:102246",
    label: "ESRI:102246 / NAD_1983_HARN_StatePlane_California_VI_FIPS_0406",
  },
  {
    value: "ESRI:102247",
    label: "ESRI:102247 / NAD_1983_CORS96_Alaska_Albers",
  },
  {
    value: "ESRI:102248",
    label: "ESRI:102248 / NAD_1983_HARN_StatePlane_Arizona_East_FIPS_0201",
  },
  {
    value: "ESRI:102249",
    label: "ESRI:102249 / NAD_1983_HARN_StatePlane_Arizona_Central_FIPS_0202",
  },
  {
    value: "ESRI:102250",
    label: "ESRI:102250 / NAD_1983_HARN_StatePlane_Arizona_West_FIPS_0203",
  },
  {
    value: "ESRI:102251",
    label: "ESRI:102251 / NAD_1983_HARN_StatePlane_Arkansas_North_FIPS_0301",
  },
  {
    value: "ESRI:102252",
    label: "ESRI:102252 / NAD_1983_HARN_StatePlane_Arkansas_South_FIPS_0302",
  },
  {
    value: "ESRI:102253",
    label: "ESRI:102253 / NAD_1983_HARN_StatePlane_Colorado_North_FIPS_0501",
  },
  {
    value: "ESRI:102254",
    label: "ESRI:102254 / NAD_1983_HARN_StatePlane_Colorado_Central_FIPS_0502",
  },
  {
    value: "ESRI:102255",
    label: "ESRI:102255 / NAD_1983_HARN_StatePlane_Colorado_South_FIPS_0503",
  },
  {
    value: "ESRI:102256",
    label: "ESRI:102256 / NAD_1983_HARN_StatePlane_Connecticut_FIPS_0600",
  },
  {
    value: "ESRI:102257",
    label: "ESRI:102257 / NAD_1983_HARN_StatePlane_Delaware_FIPS_0700",
  },
  {
    value: "ESRI:102258",
    label: "ESRI:102258 / NAD_1983_HARN_StatePlane_Florida_East_FIPS_0901",
  },
  {
    value: "ESRI:102259",
    label: "ESRI:102259 / NAD_1983_HARN_StatePlane_Florida_West_FIPS_0902",
  },
  {
    value: "ESRI:102260",
    label: "ESRI:102260 / NAD_1983_HARN_StatePlane_Florida_North_FIPS_0903",
  },
  {
    value: "ESRI:102261",
    label: "ESRI:102261 / NAD_1983_HARN_StatePlane_Hawaii_1_FIPS_5101",
  },
  {
    value: "ESRI:102262",
    label: "ESRI:102262 / NAD_1983_HARN_StatePlane_Hawaii_2_FIPS_5102",
  },
  {
    value: "ESRI:102263",
    label: "ESRI:102263 / NAD_1983_HARN_StatePlane_Hawaii_3_FIPS_5103",
  },
  {
    value: "ESRI:102264",
    label: "ESRI:102264 / NAD_1983_HARN_StatePlane_Hawaii_4_FIPS_5104",
  },
  {
    value: "ESRI:102265",
    label: "ESRI:102265 / NAD_1983_HARN_StatePlane_Hawaii_5_FIPS_5105",
  },
  {
    value: "ESRI:102266",
    label: "ESRI:102266 / NAD_1983_HARN_StatePlane_Georgia_East_FIPS_1001",
  },
  {
    value: "ESRI:102267",
    label: "ESRI:102267 / NAD_1983_HARN_StatePlane_Georgia_West_FIPS_1002",
  },
  {
    value: "ESRI:102268",
    label: "ESRI:102268 / NAD_1983_HARN_StatePlane_Idaho_East_FIPS_1101",
  },
  {
    value: "ESRI:102269",
    label: "ESRI:102269 / NAD_1983_HARN_StatePlane_Idaho_Central_FIPS_1102",
  },
  {
    value: "ESRI:102270",
    label: "ESRI:102270 / NAD_1983_HARN_StatePlane_Idaho_West_FIPS_1103",
  },
  {
    value: "ESRI:102271",
    label: "ESRI:102271 / NAD_1983_HARN_StatePlane_Illinois_East_FIPS_1201",
  },
  {
    value: "ESRI:102272",
    label: "ESRI:102272 / NAD_1983_HARN_StatePlane_Illinois_West_FIPS_1202",
  },
  {
    value: "ESRI:102273",
    label: "ESRI:102273 / NAD_1983_HARN_StatePlane_Indiana_East_FIPS_1301",
  },
  {
    value: "ESRI:102274",
    label: "ESRI:102274 / NAD_1983_HARN_StatePlane_Indiana_West_FIPS_1302",
  },
  {
    value: "ESRI:102275",
    label: "ESRI:102275 / NAD_1983_HARN_StatePlane_Iowa_North_FIPS_1401",
  },
  {
    value: "ESRI:102276",
    label: "ESRI:102276 / NAD_1983_HARN_StatePlane_Iowa_South_FIPS_1402",
  },
  {
    value: "ESRI:102277",
    label: "ESRI:102277 / NAD_1983_HARN_StatePlane_Kansas_North_FIPS_1501",
  },
  {
    value: "ESRI:102278",
    label: "ESRI:102278 / NAD_1983_HARN_StatePlane_Kansas_South_FIPS_1502",
  },
  {
    value: "ESRI:102279",
    label: "ESRI:102279 / NAD_1983_HARN_StatePlane_Kentucky_North_FIPS_1601",
  },
  {
    value: "ESRI:102280",
    label: "ESRI:102280 / NAD_1983_HARN_StatePlane_Kentucky_South_FIPS_1602",
  },
  {
    value: "ESRI:102281",
    label: "ESRI:102281 / NAD_1983_HARN_StatePlane_Louisiana_North_FIPS_1701",
  },
  {
    value: "ESRI:102282",
    label: "ESRI:102282 / NAD_1983_HARN_StatePlane_Louisiana_South_FIPS_1702",
  },
  {
    value: "ESRI:102283",
    label: "ESRI:102283 / NAD_1983_HARN_StatePlane_Maine_East_FIPS_1801",
  },
  {
    value: "ESRI:102284",
    label: "ESRI:102284 / NAD_1983_HARN_StatePlane_Maine_West_FIPS_1802",
  },
  {
    value: "ESRI:102285",
    label: "ESRI:102285 / NAD_1983_HARN_StatePlane_Maryland_FIPS_1900",
  },
  {
    value: "ESRI:102286",
    label:
      "ESRI:102286 / NAD_1983_HARN_StatePlane_Massachusetts_Mainland_FIPS_2001",
  },
  {
    value: "ESRI:102287",
    label:
      "ESRI:102287 / NAD_1983_HARN_StatePlane_Massachusetts_Island_FIPS_2002",
  },
  {
    value: "ESRI:102288",
    label: "ESRI:102288 / NAD_1983_HARN_StatePlane_Michigan_North_FIPS_2111",
  },
  {
    value: "ESRI:102289",
    label: "ESRI:102289 / NAD_1983_HARN_StatePlane_Michigan_Central_FIPS_2112",
  },
  {
    value: "ESRI:102290",
    label: "ESRI:102290 / NAD_1983_HARN_StatePlane_Michigan_South_FIPS_2113",
  },
  {
    value: "ESRI:102291",
    label: "ESRI:102291 / NAD_1983_HARN_StatePlane_Minnesota_North_FIPS_2201",
  },
  {
    value: "ESRI:102292",
    label: "ESRI:102292 / NAD_1983_HARN_StatePlane_Minnesota_Central_FIPS_2202",
  },
  {
    value: "ESRI:102293",
    label: "ESRI:102293 / NAD_1983_HARN_StatePlane_Minnesota_South_FIPS_2203",
  },
  {
    value: "ESRI:102294",
    label: "ESRI:102294 / NAD_1983_HARN_StatePlane_Mississippi_East_FIPS_2301",
  },
  {
    value: "ESRI:102295",
    label: "ESRI:102295 / NAD_1983_HARN_StatePlane_Mississippi_West_FIPS_2302",
  },
  {
    value: "ESRI:102296",
    label: "ESRI:102296 / NAD_1983_HARN_StatePlane_Missouri_East_FIPS_2401",
  },
  {
    value: "ESRI:102297",
    label: "ESRI:102297 / NAD_1983_HARN_StatePlane_Missouri_Central_FIPS_2402",
  },
  {
    value: "ESRI:102298",
    label: "ESRI:102298 / NAD_1983_HARN_StatePlane_Missouri_West_FIPS_2403",
  },
  { value: "ESRI:102299", label: "ESRI:102299 / Berghaus_Star_AAG" },
  {
    value: "ESRI:102300",
    label: "ESRI:102300 / NAD_1983_HARN_StatePlane_Montana_FIPS_2500",
  },
  {
    value: "ESRI:102304",
    label: "ESRI:102304 / NAD_1983_HARN_StatePlane_Nebraska_FIPS_2600",
  },
  { value: "ESRI:102305", label: "ESRI:102305 / CRTM05" },
  { value: "ESRI:102306", label: "ESRI:102306 / Nepal_Nagarkot_TM" },
  {
    value: "ESRI:102307",
    label: "ESRI:102307 / NAD_1983_HARN_StatePlane_Nevada_East_FIPS_2701",
  },
  {
    value: "ESRI:102308",
    label: "ESRI:102308 / NAD_1983_HARN_StatePlane_Nevada_Central_FIPS_2702",
  },
  {
    value: "ESRI:102309",
    label: "ESRI:102309 / NAD_1983_HARN_StatePlane_Nevada_West_FIPS_2703",
  },
  {
    value: "ESRI:102310",
    label: "ESRI:102310 / NAD_1983_HARN_StatePlane_New_Hampshire_FIPS_2800",
  },
  {
    value: "ESRI:102311",
    label: "ESRI:102311 / NAD_1983_HARN_StatePlane_New_Jersey_FIPS_2900",
  },
  {
    value: "ESRI:102312",
    label: "ESRI:102312 / NAD_1983_HARN_StatePlane_New_Mexico_East_FIPS_3001",
  },
  {
    value: "ESRI:102313",
    label:
      "ESRI:102313 / NAD_1983_HARN_StatePlane_New_Mexico_Central_FIPS_3002",
  },
  {
    value: "ESRI:102314",
    label: "ESRI:102314 / NAD_1983_HARN_StatePlane_New_Mexico_West_FIPS_3003",
  },
  {
    value: "ESRI:102315",
    label: "ESRI:102315 / NAD_1983_HARN_StatePlane_New_York_East_FIPS_3101",
  },
  {
    value: "ESRI:102316",
    label: "ESRI:102316 / NAD_1983_HARN_StatePlane_New_York_Central_FIPS_3102",
  },
  {
    value: "ESRI:102317",
    label: "ESRI:102317 / NAD_1983_HARN_StatePlane_New_York_West_FIPS_3103",
  },
  {
    value: "ESRI:102318",
    label:
      "ESRI:102318 / NAD_1983_HARN_StatePlane_New_York_Long_Island_FIPS_3104",
  },
  { value: "ESRI:102319", label: "ESRI:102319 / CGRS_1993_LTM" },
  {
    value: "ESRI:102320",
    label:
      "ESRI:102320 / NAD_1983_HARN_StatePlane_North_Dakota_North_FIPS_3301",
  },
  {
    value: "ESRI:102321",
    label:
      "ESRI:102321 / NAD_1983_HARN_StatePlane_North_Dakota_South_FIPS_3302",
  },
  {
    value: "ESRI:102322",
    label: "ESRI:102322 / NAD_1983_HARN_StatePlane_Ohio_North_FIPS_3401",
  },
  {
    value: "ESRI:102323",
    label: "ESRI:102323 / NAD_1983_HARN_StatePlane_Ohio_South_FIPS_3402",
  },
  {
    value: "ESRI:102324",
    label: "ESRI:102324 / NAD_1983_HARN_StatePlane_Oklahoma_North_FIPS_3501",
  },
  {
    value: "ESRI:102325",
    label: "ESRI:102325 / NAD_1983_HARN_StatePlane_Oklahoma_South_FIPS_3502",
  },
  {
    value: "ESRI:102326",
    label: "ESRI:102326 / NAD_1983_HARN_StatePlane_Oregon_North_FIPS_3601",
  },
  {
    value: "ESRI:102327",
    label: "ESRI:102327 / NAD_1983_HARN_StatePlane_Oregon_South_FIPS_3602",
  },
  {
    value: "ESRI:102328",
    label: "ESRI:102328 / ETRS_1989_UTM_Zone_32N_7stellen",
  },
  {
    value: "ESRI:102329",
    label: "ESRI:102329 / ETRS_1989_UTM_Zone_32N_8stellen",
  },
  {
    value: "ESRI:102330",
    label: "ESRI:102330 / NAD_1983_HARN_StatePlane_Rhode_Island_FIPS_3800",
  },
  { value: "ESRI:102331", label: "ESRI:102331 / PTRA08_UTM_Zone_25N" },
  { value: "ESRI:102332", label: "ESRI:102332 / PTRA08_UTM_Zone_26N" },
  { value: "ESRI:102333", label: "ESRI:102333 / PTRA08_UTM_Zone_28N" },
  {
    value: "ESRI:102334",
    label:
      "ESRI:102334 / NAD_1983_HARN_StatePlane_South_Dakota_North_FIPS_4001",
  },
  {
    value: "ESRI:102335",
    label:
      "ESRI:102335 / NAD_1983_HARN_StatePlane_South_Dakota_South_FIPS_4002",
  },
  {
    value: "ESRI:102336",
    label: "ESRI:102336 / NAD_1983_HARN_StatePlane_Tennessee_FIPS_4100",
  },
  {
    value: "ESRI:102337",
    label: "ESRI:102337 / NAD_1983_HARN_StatePlane_Texas_North_FIPS_4201",
  },
  {
    value: "ESRI:102338",
    label:
      "ESRI:102338 / NAD_1983_HARN_StatePlane_Texas_North_Central_FIPS_4202",
  },
  {
    value: "ESRI:102339",
    label: "ESRI:102339 / NAD_1983_HARN_StatePlane_Texas_Central_FIPS_4203",
  },
  {
    value: "ESRI:102340",
    label:
      "ESRI:102340 / NAD_1983_HARN_StatePlane_Texas_South_Central_FIPS_4204",
  },
  {
    value: "ESRI:102341",
    label: "ESRI:102341 / NAD_1983_HARN_StatePlane_Texas_South_FIPS_4205",
  },
  {
    value: "ESRI:102342",
    label: "ESRI:102342 / NAD_1983_HARN_StatePlane_Utah_North_FIPS_4301",
  },
  {
    value: "ESRI:102343",
    label: "ESRI:102343 / NAD_1983_HARN_StatePlane_Utah_Central_FIPS_4302",
  },
  {
    value: "ESRI:102344",
    label: "ESRI:102344 / NAD_1983_HARN_StatePlane_Utah_South_FIPS_4303",
  },
  {
    value: "ESRI:102345",
    label: "ESRI:102345 / NAD_1983_HARN_StatePlane_Vermont_FIPS_4400",
  },
  {
    value: "ESRI:102346",
    label: "ESRI:102346 / NAD_1983_HARN_StatePlane_Virginia_North_FIPS_4501",
  },
  {
    value: "ESRI:102347",
    label: "ESRI:102347 / NAD_1983_HARN_StatePlane_Virginia_South_FIPS_4502",
  },
  {
    value: "ESRI:102348",
    label: "ESRI:102348 / NAD_1983_HARN_StatePlane_Washington_North_FIPS_4601",
  },
  {
    value: "ESRI:102349",
    label: "ESRI:102349 / NAD_1983_HARN_StatePlane_Washington_South_FIPS_4602",
  },
  {
    value: "ESRI:102350",
    label:
      "ESRI:102350 / NAD_1983_HARN_StatePlane_West_Virginia_North_FIPS_4701",
  },
  {
    value: "ESRI:102351",
    label:
      "ESRI:102351 / NAD_1983_HARN_StatePlane_West_Virginia_South_FIPS_4702",
  },
  {
    value: "ESRI:102352",
    label: "ESRI:102352 / NAD_1983_HARN_StatePlane_Wisconsin_North_FIPS_4801",
  },
  {
    value: "ESRI:102353",
    label: "ESRI:102353 / NAD_1983_HARN_StatePlane_Wisconsin_Central_FIPS_4802",
  },
  {
    value: "ESRI:102354",
    label: "ESRI:102354 / NAD_1983_HARN_StatePlane_Wisconsin_South_FIPS_4803",
  },
  {
    value: "ESRI:102355",
    label: "ESRI:102355 / NAD_1983_HARN_StatePlane_Wyoming_East_FIPS_4901",
  },
  {
    value: "ESRI:102356",
    label:
      "ESRI:102356 / NAD_1983_HARN_StatePlane_Wyoming_East_Central_FIPS_4902",
  },
  {
    value: "ESRI:102357",
    label:
      "ESRI:102357 / NAD_1983_HARN_StatePlane_Wyoming_West_Central_FIPS_4903",
  },
  {
    value: "ESRI:102358",
    label: "ESRI:102358 / NAD_1983_HARN_StatePlane_Wyoming_West_FIPS_4904",
  },
  {
    value: "ESRI:102359",
    label: "ESRI:102359 / ETRS_1989_UTM_Zone_33N_7stellen",
  },
  {
    value: "ESRI:102360",
    label: "ESRI:102360 / ETRS_1989_UTM_Zone_33N_8stellen",
  },
  {
    value: "ESRI:102361",
    label:
      "ESRI:102361 / NAD_1983_HARN_StatePlane_Puerto_Rico_Virgin_Islands_FIPS_5200",
  },
  { value: "ESRI:102362", label: "ESRI:102362 / ETRS_1989_UTM_Zone_N32" },
  {
    value: "ESRI:102363",
    label: "ESRI:102363 / NAD_1983_HARN_StatePlane_Kentucky_FIPS_1600",
  },
  { value: "ESRI:102364", label: "ESRI:102364 / NAD_1983_CORS96_UTM_Zone_59N" },
  { value: "ESRI:102365", label: "ESRI:102365 / NAD_1983_CORS96_UTM_Zone_60N" },
  {
    value: "ESRI:102366",
    label: "ESRI:102366 / NAD_1983_CORS96_StatePlane_Alaska_1_FIPS_5001",
  },
  {
    value: "ESRI:102367",
    label: "ESRI:102367 / NAD_1983_CORS96_StatePlane_Alaska_2_FIPS_5002",
  },
  {
    value: "ESRI:102368",
    label: "ESRI:102368 / NAD_1983_CORS96_StatePlane_Alaska_3_FIPS_5003",
  },
  {
    value: "ESRI:102369",
    label: "ESRI:102369 / NAD_1983_CORS96_StatePlane_Alaska_4_FIPS_5004",
  },
  {
    value: "ESRI:102370",
    label: "ESRI:102370 / NAD_1983_CORS96_StatePlane_Alaska_5_FIPS_5005",
  },
  {
    value: "ESRI:102371",
    label: "ESRI:102371 / NAD_1983_CORS96_StatePlane_Alaska_6_FIPS_5006",
  },
  {
    value: "ESRI:102372",
    label: "ESRI:102372 / NAD_1983_CORS96_StatePlane_Alaska_7_FIPS_5007",
  },
  {
    value: "ESRI:102373",
    label: "ESRI:102373 / NAD_1983_CORS96_StatePlane_Alaska_8_FIPS_5008",
  },
  {
    value: "ESRI:102374",
    label: "ESRI:102374 / NAD_1983_CORS96_StatePlane_Alaska_9_FIPS_5009",
  },
  {
    value: "ESRI:102375",
    label: "ESRI:102375 / NAD_1983_CORS96_StatePlane_Alaska_10_FIPS_5010",
  },
  {
    value: "ESRI:102376",
    label: "ESRI:102376 / NAD_1983_CORS96_StatePlane_Oregon_North_FIPS_3601",
  },
  {
    value: "ESRI:102377",
    label: "ESRI:102377 / NAD_1983_CORS96_StatePlane_Oregon_South_FIPS_3602",
  },
  {
    value: "ESRI:102378",
    label:
      "ESRI:102378 / NAD_1983_CORS96_StatePlane_Oregon_North_FIPS_3601_Ft_Intl",
  },
  {
    value: "ESRI:102379",
    label:
      "ESRI:102379 / NAD_1983_CORS96_StatePlane_Oregon_South_FIPS_3602_Ft_Intl",
  },
  {
    value: "ESRI:102380",
    label: "ESRI:102380 / NAD_1983_CORS96_Oregon_Statewide_Lambert",
  },
  {
    value: "ESRI:102381",
    label: "ESRI:102381 / NAD_1983_CORS96_Oregon_Statewide_Lambert_Ft_Intl",
  },
  { value: "ESRI:102382", label: "ESRI:102382 / NAD_1983_2011_UTM_Zone_13N" },
  { value: "ESRI:102383", label: "ESRI:102383 / NAD_1983_2011_UTM_Zone_14N" },
  { value: "ESRI:102384", label: "ESRI:102384 / NAD_1983_2011_UTM_Zone_15N" },
  { value: "ESRI:102385", label: "ESRI:102385 / NAD_1983_2011_UTM_Zone_16N" },
  { value: "ESRI:102386", label: "ESRI:102386 / NAD_1983_2011_UTM_Zone_17N" },
  { value: "ESRI:102387", label: "ESRI:102387 / NAD_1983_2011_UTM_Zone_18N" },
  { value: "ESRI:102388", label: "ESRI:102388 / NAD_1983_2011_UTM_Zone_19N" },
  {
    value: "ESRI:102389",
    label: "ESRI:102389 / NAD_1983_Fargo_Ground_Coordinate_System",
  },
  {
    value: "ESRI:102390",
    label: "ESRI:102390 / NAD_1983_HARN_Fargo_Ground_Coordinate_System",
  },
  {
    value: "ESRI:102391",
    label: "ESRI:102391 / NAD_1983_2011_Fargo_Ground_Coordinate_System",
  },
  {
    value: "ESRI:102392",
    label: "ESRI:102392 / NAD_1983_2011_StatePlane_Alaska_4_FIPS_5004_Feet",
  },
  {
    value: "ESRI:102393",
    label: "ESRI:102393 / NAD_1983_2011_StatePlane_Alaska_5_FIPS_5005_Feet",
  },
  {
    value: "ESRI:102394",
    label: "ESRI:102394 / NAD_1983_2011_StatePlane_Alaska_6_FIPS_5006_Feet",
  },
  {
    value: "ESRI:102395",
    label: "ESRI:102395 / NAD_1983_2011_StatePlane_Alaska_7_FIPS_5007_Feet",
  },
  {
    value: "ESRI:102396",
    label: "ESRI:102396 / NAD_1983_2011_StatePlane_Alaska_8_FIPS_5008_Feet",
  },
  {
    value: "ESRI:102397",
    label: "ESRI:102397 / NAD_1983_2011_StatePlane_Alaska_9_FIPS_5009_Feet",
  },
  {
    value: "ESRI:102398",
    label: "ESRI:102398 / NAD_1983_2011_StatePlane_Alaska_10_FIPS_5010_Feet",
  },
  { value: "ESRI:102399", label: "ESRI:102399 / NAD_1983_Albers_BLM_MT_ND_SD" },
  { value: "ESRI:102400", label: "ESRI:102400 / London_Survey_Grid" },
  { value: "ESRI:102401", label: "ESRI:102401 / NAD_1983_CORS96_UTM_Zone_1N" },
  { value: "ESRI:102402", label: "ESRI:102402 / NAD_1983_CORS96_UTM_Zone_2N" },
  { value: "ESRI:102403", label: "ESRI:102403 / NAD_1983_CORS96_UTM_Zone_3N" },
  { value: "ESRI:102404", label: "ESRI:102404 / NAD_1983_CORS96_UTM_Zone_4N" },
  { value: "ESRI:102405", label: "ESRI:102405 / NAD_1983_CORS96_UTM_Zone_5N" },
  { value: "ESRI:102406", label: "ESRI:102406 / NAD_1983_CORS96_UTM_Zone_6N" },
  { value: "ESRI:102407", label: "ESRI:102407 / NAD_1983_CORS96_UTM_Zone_7N" },
  { value: "ESRI:102408", label: "ESRI:102408 / NAD_1983_CORS96_UTM_Zone_8N" },
  { value: "ESRI:102409", label: "ESRI:102409 / NAD_1983_CORS96_UTM_Zone_9N" },
  { value: "ESRI:102410", label: "ESRI:102410 / NAD_1983_CORS96_UTM_Zone_10N" },
  { value: "ESRI:102411", label: "ESRI:102411 / NAD_1983_CORS96_UTM_Zone_11N" },
  { value: "ESRI:102412", label: "ESRI:102412 / NAD_1983_CORS96_UTM_Zone_12N" },
  { value: "ESRI:102413", label: "ESRI:102413 / NAD_1983_CORS96_UTM_Zone_13N" },
  { value: "ESRI:102414", label: "ESRI:102414 / NAD_1983_CORS96_UTM_Zone_14N" },
  { value: "ESRI:102415", label: "ESRI:102415 / NAD_1983_CORS96_UTM_Zone_15N" },
  { value: "ESRI:102416", label: "ESRI:102416 / NAD_1983_CORS96_UTM_Zone_16N" },
  { value: "ESRI:102417", label: "ESRI:102417 / NAD_1983_CORS96_UTM_Zone_17N" },
  { value: "ESRI:102418", label: "ESRI:102418 / NAD_1983_CORS96_UTM_Zone_18N" },
  { value: "ESRI:102419", label: "ESRI:102419 / NAD_1983_CORS96_UTM_Zone_19N" },
  { value: "ESRI:102420", label: "ESRI:102420 / ISN_2004_Lambert_2004" },
  { value: "ESRI:102421", label: "ESRI:102421 / WGS_1984_ARC_System_Zone_01" },
  { value: "ESRI:102422", label: "ESRI:102422 / WGS_1984_ARC_System_Zone_02" },
  { value: "ESRI:102423", label: "ESRI:102423 / WGS_1984_ARC_System_Zone_03" },
  { value: "ESRI:102424", label: "ESRI:102424 / WGS_1984_ARC_System_Zone_04" },
  { value: "ESRI:102425", label: "ESRI:102425 / WGS_1984_ARC_System_Zone_05" },
  { value: "ESRI:102426", label: "ESRI:102426 / WGS_1984_ARC_System_Zone_06" },
  { value: "ESRI:102427", label: "ESRI:102427 / WGS_1984_ARC_System_Zone_07" },
  { value: "ESRI:102428", label: "ESRI:102428 / WGS_1984_ARC_System_Zone_08" },
  { value: "ESRI:102429", label: "ESRI:102429 / WGS_1984_ARC_System_Zone_09" },
  { value: "ESRI:102430", label: "ESRI:102430 / WGS_1984_ARC_System_Zone_10" },
  { value: "ESRI:102431", label: "ESRI:102431 / WGS_1984_ARC_System_Zone_11" },
  { value: "ESRI:102432", label: "ESRI:102432 / WGS_1984_ARC_System_Zone_12" },
  { value: "ESRI:102433", label: "ESRI:102433 / WGS_1984_ARC_System_Zone_13" },
  { value: "ESRI:102434", label: "ESRI:102434 / WGS_1984_ARC_System_Zone_14" },
  { value: "ESRI:102435", label: "ESRI:102435 / WGS_1984_ARC_System_Zone_15" },
  { value: "ESRI:102436", label: "ESRI:102436 / WGS_1984_ARC_System_Zone_16" },
  { value: "ESRI:102437", label: "ESRI:102437 / WGS_1984_ARC_System_Zone_17" },
  { value: "ESRI:102438", label: "ESRI:102438 / WGS_1984_ARC_System_Zone_18" },
  {
    value: "ESRI:102439",
    label:
      "ESRI:102439 / WGS_1984_Australian_Centre_for_Remote_Sensing_Lambert",
  },
  { value: "ESRI:102440", label: "ESRI:102440 / LKS_1992_Latvia_TM_0" },
  { value: "ESRI:102441", label: "ESRI:102441 / TWD_1967_TM_Taiwan" },
  { value: "ESRI:102442", label: "ESRI:102442 / TWD_1967_TM_Penghu" },
  { value: "ESRI:102443", label: "ESRI:102443 / TWD_1997_TM_Taiwan" },
  { value: "ESRI:102444", label: "ESRI:102444 / TWD_1997_TM_Penghu" },
  {
    value: "ESRI:102445",
    label: "ESRI:102445 / NAD_1983_2011_StatePlane_Alaska_1_FIPS_5001_Feet",
  },
  {
    value: "ESRI:102446",
    label: "ESRI:102446 / NAD_1983_2011_StatePlane_Alaska_2_FIPS_5002_Feet",
  },
  {
    value: "ESRI:102447",
    label: "ESRI:102447 / NAD_1983_2011_StatePlane_Alaska_3_FIPS_5003_Feet",
  },
  { value: "ESRI:102448", label: "ESRI:102448 / Macao_2008_Macao_Grid" },
  { value: "ESRI:102449", label: "ESRI:102449 / NAD_1983_MA11_UTM_Zone_55N" },
  { value: "ESRI:102450", label: "ESRI:102450 / NGO_1948_Oslo_Baerum_Kommune" },
  { value: "ESRI:102451", label: "ESRI:102451 / NGO_1948_Oslo_Bergenhalvoen" },
  { value: "ESRI:102452", label: "ESRI:102452 / NGO_1948_Oslo_Oslo_Kommune" },
  { value: "ESRI:102453", label: "ESRI:102453 / Luzon_1911_UTM_Zone_50N" },
  { value: "ESRI:102454", label: "ESRI:102454 / Luzon_1911_UTM_Zone_51N" },
  { value: "ESRI:102455", label: "ESRI:102455 / Luzon_1911_UTM_Zone_52N" },
  { value: "ESRI:102456", label: "ESRI:102456 / PRS_1992_UTM_Zone_50N" },
  { value: "ESRI:102457", label: "ESRI:102457 / PRS_1992_UTM_Zone_51N" },
  { value: "ESRI:102458", label: "ESRI:102458 / PRS_1992_UTM_Zone_52N" },
  { value: "ESRI:102459", label: "ESRI:102459 / NAD_1983_Idaho-Ada_County" },
  { value: "ESRI:102460", label: "ESRI:102460 / HJAIA_AirportGrid_2Mar10" },
  {
    value: "ESRI:102461",
    label: "ESRI:102461 / NAD_1983_HARN_StatePlane_Hawaii_1_FIPS_5101_Feet",
  },
  {
    value: "ESRI:102462",
    label: "ESRI:102462 / NAD_1983_HARN_StatePlane_Hawaii_2_FIPS_5102_Feet",
  },
  {
    value: "ESRI:102463",
    label: "ESRI:102463 / NAD_1983_HARN_StatePlane_Hawaii_3_FIPS_5103_Feet",
  },
  {
    value: "ESRI:102464",
    label: "ESRI:102464 / NAD_1983_HARN_StatePlane_Hawaii_4_FIPS_5104_Feet",
  },
  {
    value: "ESRI:102465",
    label: "ESRI:102465 / NAD_1983_HARN_StatePlane_Hawaii_5_FIPS_5105_Feet",
  },
  {
    value: "ESRI:102466",
    label:
      "ESRI:102466 / NAD_1983_HARN_StatePlane_Minnesota_North_FIPS_2201_Feet",
  },
  {
    value: "ESRI:102467",
    label:
      "ESRI:102467 / NAD_1983_HARN_StatePlane_Minnesota_Central_FIPS_2202_Feet",
  },
  {
    value: "ESRI:102468",
    label:
      "ESRI:102468 / NAD_1983_HARN_StatePlane_Minnesota_South_FIPS_2203_Feet",
  },
  { value: "ESRI:102469", label: "ESRI:102469 / NAD_1983_HARN_Mississippi_TM" },
  { value: "ESRI:102470", label: "ESRI:102470 / Cape_Lo15" },
  { value: "ESRI:102471", label: "ESRI:102471 / Cape_Lo17" },
  { value: "ESRI:102472", label: "ESRI:102472 / Cape_Lo19" },
  { value: "ESRI:102473", label: "ESRI:102473 / Cape_Lo21" },
  { value: "ESRI:102474", label: "ESRI:102474 / Cape_Lo23" },
  { value: "ESRI:102475", label: "ESRI:102475 / Cape_Lo25" },
  { value: "ESRI:102476", label: "ESRI:102476 / Cape_Lo27" },
  { value: "ESRI:102477", label: "ESRI:102477 / Cape_Lo29" },
  { value: "ESRI:102478", label: "ESRI:102478 / Cape_Lo31" },
  { value: "ESRI:102479", label: "ESRI:102479 / Cape_Lo33" },
  { value: "ESRI:102480", label: "ESRI:102480 / Hartebeesthoek94_Lo15" },
  { value: "ESRI:102481", label: "ESRI:102481 / Hartebeesthoek94_Lo17" },
  { value: "ESRI:102482", label: "ESRI:102482 / Hartebeesthoek94_Lo19" },
  { value: "ESRI:102483", label: "ESRI:102483 / Hartebeesthoek94_Lo21" },
  { value: "ESRI:102484", label: "ESRI:102484 / Hartebeesthoek94_Lo23" },
  { value: "ESRI:102485", label: "ESRI:102485 / Hartebeesthoek94_Lo25" },
  { value: "ESRI:102486", label: "ESRI:102486 / Hartebeesthoek94_Lo27" },
  { value: "ESRI:102487", label: "ESRI:102487 / Hartebeesthoek94_Lo29" },
  { value: "ESRI:102488", label: "ESRI:102488 / Hartebeesthoek94_Lo31" },
  { value: "ESRI:102489", label: "ESRI:102489 / Hartebeesthoek94_Lo33" },
  { value: "ESRI:102490", label: "ESRI:102490 / GDBD2009_GEORSO" },
  { value: "ESRI:102491", label: "ESRI:102491 / Nord_Algerie_Ancienne_Degree" },
  { value: "ESRI:102492", label: "ESRI:102492 / Sud_Algerie_Ancienne_Degree" },
  { value: "ESRI:102493", label: "ESRI:102493 / NAD_1983_PA11_UTM_Zone_4N" },
  { value: "ESRI:102494", label: "ESRI:102494 / NAD_1983_PA11_UTM_Zone_5N" },
  { value: "ESRI:102495", label: "ESRI:102495 / NAD_1983_MA11_Guam_Map_Grid" },
  { value: "ESRI:102496", label: "ESRI:102496 / NAD_1983_PA11_UTM_Zone_2S" },
  {
    value: "ESRI:102497",
    label: "ESRI:102497 / GOES-16_East_ABI_Fixed_Grid_ITRF2000_incorrect_GCS",
  },
  {
    value: "ESRI:102498",
    label: "ESRI:102498 / GOES-16_East_ABI_Fixed_Grid_ITRF2008",
  },
  { value: "ESRI:102499", label: "ESRI:102499 / Belge_Lambert_1972_bad_FE_FN" },
  {
    value: "ESRI:102500",
    label: "ESRI:102500 / OCRS_Baker_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102501",
    label: "ESRI:102501 / OCRS_Bend-Burns_NAD_1983_CORS96_LCC_Feet_Intl",
  },
  {
    value: "ESRI:102502",
    label: "ESRI:102502 / OCRS_Bend-Klamath_Falls_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102503",
    label:
      "ESRI:102503 / OCRS_Bend-Redmond-Prineville_NAD_1983_CORS96_LCC_Feet_Intl",
  },
  {
    value: "ESRI:102504",
    label:
      "ESRI:102504 / OCRS_Canyonville-Grants_Pass_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102505",
    label:
      "ESRI:102505 / OCRS_Columbia_River_East_NAD_1983_CORS96_LCC_Feet_Intl",
  },
  {
    value: "ESRI:102506",
    label:
      "ESRI:102506 / OCRS_Columbia_River_West_NAD_1983_CORS96_OM_Feet_Intl",
  },
  {
    value: "ESRI:102507",
    label:
      "ESRI:102507 / OCRS_Cottage_Grove-Canyonville_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102508",
    label: "ESRI:102508 / OCRS_Dufur-Madras_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102509",
    label: "ESRI:102509 / OCRS_Eugene_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102510",
    label:
      "ESRI:102510 / OCRS_Grants_Pass-Ashland_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102511",
    label:
      "ESRI:102511 / OCRS_Gresham-Warm_Springs_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102512",
    label: "ESRI:102512 / OCRS_La_Grande_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102513",
    label: "ESRI:102513 / OCRS_Ontario_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102514",
    label: "ESRI:102514 / OCRS_Oregon_Coast_NAD_1983_CORS96_OM_Feet_Intl",
  },
  {
    value: "ESRI:102515",
    label:
      "ESRI:102515 / OCRS_Pendleton-La_Grande_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102516",
    label: "ESRI:102516 / OCRS_Pendleton_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102517",
    label: "ESRI:102517 / OCRS_Portland_NAD_1983_CORS96_LCC_Feet_Intl",
  },
  {
    value: "ESRI:102518",
    label: "ESRI:102518 / OCRS_Salem_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102519",
    label: "ESRI:102519 / OCRS_Santiam_Pass_NAD_1983_CORS96_TM_Feet_Intl",
  },
  {
    value: "ESRI:102520",
    label: "ESRI:102520 / NAD_1983_PA11_StatePlane_Hawaii_1_FIPS_5101",
  },
  {
    value: "ESRI:102521",
    label: "ESRI:102521 / NAD_1983_PA11_StatePlane_Hawaii_2_FIPS_5102",
  },
  {
    value: "ESRI:102522",
    label: "ESRI:102522 / NAD_1983_PA11_StatePlane_Hawaii_3_FIPS_5103",
  },
  {
    value: "ESRI:102523",
    label: "ESRI:102523 / NAD_1983_PA11_StatePlane_Hawaii_4_FIPS_5104",
  },
  {
    value: "ESRI:102524",
    label: "ESRI:102524 / NAD_1983_PA11_StatePlane_Hawaii_5_FIPS_5105",
  },
  {
    value: "ESRI:102525",
    label: "ESRI:102525 / NAD_1983_PA11_StatePlane_Hawaii_1_FIPS_5101_Feet",
  },
  {
    value: "ESRI:102526",
    label: "ESRI:102526 / NAD_1983_PA11_StatePlane_Hawaii_2_FIPS_5102_Feet",
  },
  {
    value: "ESRI:102527",
    label: "ESRI:102527 / NAD_1983_PA11_StatePlane_Hawaii_3_FIPS_5103_Feet",
  },
  {
    value: "ESRI:102528",
    label: "ESRI:102528 / NAD_1983_PA11_StatePlane_Hawaii_4_FIPS_5104_Feet",
  },
  {
    value: "ESRI:102529",
    label: "ESRI:102529 / NAD_1983_PA11_StatePlane_Hawaii_5_FIPS_5105_Feet",
  },
  {
    value: "ESRI:102530",
    label: "ESRI:102530 / OCRS_Baker_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102531",
    label: "ESRI:102531 / OCRS_Bend-Burns_NAD_1983_CORS96_LCC_Meters",
  },
  {
    value: "ESRI:102532",
    label: "ESRI:102532 / OCRS_Bend-Klamath_Falls_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102533",
    label:
      "ESRI:102533 / OCRS_Bend-Redmond-Prineville_NAD_1983_CORS96_LCC_Meters",
  },
  {
    value: "ESRI:102534",
    label:
      "ESRI:102534 / OCRS_Canyonville-Grants_Pass_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102535",
    label: "ESRI:102535 / OCRS_Columbia_River_East_NAD_1983_CORS96_LCC_Meters",
  },
  {
    value: "ESRI:102536",
    label: "ESRI:102536 / OCRS_Columbia_River_West_NAD_1983_CORS96_OM_Meters",
  },
  {
    value: "ESRI:102537",
    label:
      "ESRI:102537 / OCRS_Cottage_Grove-Canyonville_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102538",
    label: "ESRI:102538 / OCRS_Dufur-Madras_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102539",
    label: "ESRI:102539 / OCRS_Eugene_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102540",
    label: "ESRI:102540 / OCRS_Grants_Pass-Ashland_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102541",
    label: "ESRI:102541 / OCRS_Gresham-Warm_Springs_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102542",
    label: "ESRI:102542 / OCRS_La_Grande_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102543",
    label: "ESRI:102543 / OCRS_Ontario_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102544",
    label: "ESRI:102544 / OCRS_Oregon_Coast_NAD_1983_CORS96_OM_Meters",
  },
  {
    value: "ESRI:102545",
    label: "ESRI:102545 / OCRS_Pendleton-La_Grande_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102546",
    label: "ESRI:102546 / OCRS_Pendleton_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102547",
    label: "ESRI:102547 / OCRS_Portland_NAD_1983_CORS96_LCC_Meters",
  },
  {
    value: "ESRI:102548",
    label: "ESRI:102548 / OCRS_Salem_NAD_1983_CORS96_TM_Meters",
  },
  {
    value: "ESRI:102549",
    label: "ESRI:102549 / OCRS_Santiam_Pass_NAD_1983_CORS96_TM_Meters",
  },
  { value: "ESRI:102550", label: "ESRI:102550 / ED_1950_Turkey_9" },
  { value: "ESRI:102551", label: "ESRI:102551 / ED_1950_Turkey_10" },
  { value: "ESRI:102552", label: "ESRI:102552 / ED_1950_Turkey_11" },
  { value: "ESRI:102553", label: "ESRI:102553 / ED_1950_Turkey_12" },
  { value: "ESRI:102554", label: "ESRI:102554 / ED_1950_Turkey_13" },
  { value: "ESRI:102555", label: "ESRI:102555 / ED_1950_Turkey_14" },
  { value: "ESRI:102556", label: "ESRI:102556 / ED_1950_Turkey_15" },
  { value: "ESRI:102557", label: "ESRI:102557 / Kyrg-06_TM_Zone_1" },
  { value: "ESRI:102558", label: "ESRI:102558 / Kyrg-06_TM_Zone_2" },
  { value: "ESRI:102559", label: "ESRI:102559 / Kyrg-06_TM_Zone_3" },
  { value: "ESRI:102560", label: "ESRI:102560 / Kyrg-06_TM_Zone_4" },
  { value: "ESRI:102561", label: "ESRI:102561 / Kyrg-06_TM_Zone_5" },
  { value: "ESRI:102562", label: "ESRI:102562 / Hartebeesthoek94_Lo19_(E-N)" },
  { value: "ESRI:102563", label: "ESRI:102563 / Hartebeesthoek94_Lo21_(E-N)" },
  { value: "ESRI:102564", label: "ESRI:102564 / Hartebeesthoek94_Lo23_(E-N)" },
  { value: "ESRI:102565", label: "ESRI:102565 / Hartebeesthoek94_Lo25_(E-N)" },
  { value: "ESRI:102566", label: "ESRI:102566 / Hartebeesthoek94_Lo27_(E-N)" },
  { value: "ESRI:102567", label: "ESRI:102567 / Hartebeesthoek94_Lo29_(E-N)" },
  { value: "ESRI:102568", label: "ESRI:102568 / Hartebeesthoek94_Lo31_(E-N)" },
  {
    value: "ESRI:102569",
    label: "ESRI:102569 / New_Beijing_3_Degree_Gauss_Kruger_CM_132E",
  },
  {
    value: "ESRI:102570",
    label: "ESRI:102570 / WGS_1984_Complex_UTM_Zone_20N",
  },
  {
    value: "ESRI:102571",
    label: "ESRI:102571 / WGS_1984_Complex_UTM_Zone_21N",
  },
  {
    value: "ESRI:102572",
    label: "ESRI:102572 / WGS_1984_Complex_UTM_Zone_22N",
  },
  {
    value: "ESRI:102573",
    label: "ESRI:102573 / WGS_1984_Complex_UTM_Zone_23N",
  },
  {
    value: "ESRI:102574",
    label: "ESRI:102574 / WGS_1984_Complex_UTM_Zone_24N",
  },
  {
    value: "ESRI:102575",
    label: "ESRI:102575 / WGS_1984_Complex_UTM_Zone_25N",
  },
  {
    value: "ESRI:102576",
    label: "ESRI:102576 / WGS_1984_Complex_UTM_Zone_26N",
  },
  {
    value: "ESRI:102577",
    label: "ESRI:102577 / WGS_1984_Complex_UTM_Zone_27N",
  },
  {
    value: "ESRI:102578",
    label: "ESRI:102578 / WGS_1984_Complex_UTM_Zone_28N",
  },
  {
    value: "ESRI:102579",
    label: "ESRI:102579 / WGS_1984_Complex_UTM_Zone_29N",
  },
  {
    value: "ESRI:102580",
    label: "ESRI:102580 / WGS_1984_Complex_UTM_Zone_30N",
  },
  { value: "ESRI:102581", label: "ESRI:102581 / NTF_France_I_degrees" },
  { value: "ESRI:102582", label: "ESRI:102582 / NTF_France_II_degrees" },
  { value: "ESRI:102583", label: "ESRI:102583 / NTF_France_III_degrees" },
  { value: "ESRI:102584", label: "ESRI:102584 / NTF_France_IV_degrees" },
  { value: "ESRI:102585", label: "ESRI:102585 / NTF_Lambert_Zone_I" },
  { value: "ESRI:102586", label: "ESRI:102586 / NTF_Lambert_Zone_II" },
  { value: "ESRI:102587", label: "ESRI:102587 / NTF_Lambert_Zone_III" },
  { value: "ESRI:102588", label: "ESRI:102588 / NTF_Lambert_Zone_IV" },
  { value: "ESRI:102589", label: "ESRI:102589 / Panhandle_Energy_Albers" },
  { value: "ESRI:102590", label: "ESRI:102590 / Tananarive_1925_Laborde_Grid" },
  { value: "ESRI:102591", label: "ESRI:102591 / Nord_Algerie_Degree" },
  { value: "ESRI:102592", label: "ESRI:102592 / Sud_Algerie_Degree" },
  { value: "ESRI:102593", label: "ESRI:102593 / JGD_2011_UTM_Zone_51N" },
  { value: "ESRI:102594", label: "ESRI:102594 / JGD_2011_UTM_Zone_52N" },
  { value: "ESRI:102595", label: "ESRI:102595 / JGD_2011_UTM_Zone_53N" },
  { value: "ESRI:102596", label: "ESRI:102596 / JGD_2011_UTM_Zone_54N" },
  { value: "ESRI:102597", label: "ESRI:102597 / JGD_2011_UTM_Zone_55N" },
  { value: "ESRI:102598", label: "ESRI:102598 / JGD_2011_UTM_Zone_56N" },
  {
    value: "ESRI:102599",
    label: "ESRI:102599 / WGS_1984_California_Teale_Albers_FtUS",
  },
  {
    value: "ESRI:102600",
    label: "ESRI:102600 / NAD_1983_California_Teale_Albers_FtUS",
  },
  {
    value: "ESRI:102601",
    label: "ESRI:102601 / NAD_1983_Texas_Centric_Mapping_System_Albers",
  },
  {
    value: "ESRI:102602",
    label: "ESRI:102602 / NAD_1983_Texas_Centric_Mapping_System_Lambert",
  },
  {
    value: "ESRI:102603",
    label: "ESRI:102603 / NAD_1983_Texas_Statewide_Mapping_System",
  },
  {
    value: "ESRI:102604",
    label: "ESRI:102604 / NAD_1983_Georgia_Statewide_Lambert",
  },
  { value: "ESRI:102605", label: "ESRI:102605 / NAD_1983_Idaho_TM" },
  {
    value: "ESRI:102606",
    label: "ESRI:102606 / NAD_1983_Maine_2000_East_Zone",
  },
  {
    value: "ESRI:102607",
    label: "ESRI:102607 / NAD_1983_Maine_2000_Central_Zone",
  },
  {
    value: "ESRI:102608",
    label: "ESRI:102608 / NAD_1983_Maine_2000_West_Zone",
  },
  { value: "ESRI:102609", label: "ESRI:102609 / NAD_1983_Mississippi_TM" },
  { value: "ESRI:102610", label: "ESRI:102610 / JGD_2011_Japan_Zone_1" },
  { value: "ESRI:102611", label: "ESRI:102611 / JGD_2011_Japan_Zone_2" },
  { value: "ESRI:102612", label: "ESRI:102612 / JGD_2011_Japan_Zone_3" },
  { value: "ESRI:102613", label: "ESRI:102613 / JGD_2011_Japan_Zone_4" },
  { value: "ESRI:102614", label: "ESRI:102614 / JGD_2011_Japan_Zone_5" },
  { value: "ESRI:102615", label: "ESRI:102615 / JGD_2011_Japan_Zone_6" },
  { value: "ESRI:102616", label: "ESRI:102616 / JGD_2011_Japan_Zone_7" },
  { value: "ESRI:102617", label: "ESRI:102617 / JGD_2011_Japan_Zone_8" },
  { value: "ESRI:102618", label: "ESRI:102618 / JGD_2011_Japan_Zone_9" },
  { value: "ESRI:102619", label: "ESRI:102619 / JGD_2011_Japan_Zone_10" },
  { value: "ESRI:102620", label: "ESRI:102620 / JGD_2011_Japan_Zone_11" },
  { value: "ESRI:102621", label: "ESRI:102621 / JGD_2011_Japan_Zone_12" },
  { value: "ESRI:102622", label: "ESRI:102622 / JGD_2011_Japan_Zone_13" },
  { value: "ESRI:102623", label: "ESRI:102623 / JGD_2011_Japan_Zone_14" },
  { value: "ESRI:102624", label: "ESRI:102624 / JGD_2011_Japan_Zone_15" },
  { value: "ESRI:102625", label: "ESRI:102625 / JGD_2011_Japan_Zone_16" },
  { value: "ESRI:102626", label: "ESRI:102626 / JGD_2011_Japan_Zone_17" },
  { value: "ESRI:102627", label: "ESRI:102627 / JGD_2011_Japan_Zone_18" },
  { value: "ESRI:102628", label: "ESRI:102628 / JGD_2011_Japan_Zone_19" },
  {
    value: "ESRI:102629",
    label: "ESRI:102629 / NAD_1983_StatePlane_Alabama_East_FIPS_0101_Feet",
  },
  {
    value: "ESRI:102630",
    label: "ESRI:102630 / NAD_1983_StatePlane_Alabama_West_FIPS_0102_Feet",
  },
  {
    value: "ESRI:102631",
    label: "ESRI:102631 / NAD_1983_StatePlane_Alaska_1_FIPS_5001_Feet",
  },
  {
    value: "ESRI:102632",
    label: "ESRI:102632 / NAD_1983_StatePlane_Alaska_2_FIPS_5002_Feet",
  },
  {
    value: "ESRI:102633",
    label: "ESRI:102633 / NAD_1983_StatePlane_Alaska_3_FIPS_5003_Feet",
  },
  {
    value: "ESRI:102634",
    label: "ESRI:102634 / NAD_1983_StatePlane_Alaska_4_FIPS_5004_Feet",
  },
  {
    value: "ESRI:102635",
    label: "ESRI:102635 / NAD_1983_StatePlane_Alaska_5_FIPS_5005_Feet",
  },
  {
    value: "ESRI:102636",
    label: "ESRI:102636 / NAD_1983_StatePlane_Alaska_6_FIPS_5006_Feet",
  },
  {
    value: "ESRI:102637",
    label: "ESRI:102637 / NAD_1983_StatePlane_Alaska_7_FIPS_5007_Feet",
  },
  {
    value: "ESRI:102638",
    label: "ESRI:102638 / NAD_1983_StatePlane_Alaska_8_FIPS_5008_Feet",
  },
  {
    value: "ESRI:102639",
    label: "ESRI:102639 / NAD_1983_StatePlane_Alaska_9_FIPS_5009_Feet",
  },
  {
    value: "ESRI:102640",
    label: "ESRI:102640 / NAD_1983_StatePlane_Alaska_10_FIPS_5010_Feet",
  },
  {
    value: "ESRI:102641",
    label: "ESRI:102641 / NAD_1983_StatePlane_California_I_FIPS_0401_Feet",
  },
  {
    value: "ESRI:102642",
    label: "ESRI:102642 / NAD_1983_StatePlane_California_II_FIPS_0402_Feet",
  },
  {
    value: "ESRI:102643",
    label: "ESRI:102643 / NAD_1983_StatePlane_California_III_FIPS_0403_Feet",
  },
  {
    value: "ESRI:102644",
    label: "ESRI:102644 / NAD_1983_StatePlane_California_IV_FIPS_0404_Feet",
  },
  {
    value: "ESRI:102645",
    label: "ESRI:102645 / NAD_1983_StatePlane_California_V_FIPS_0405_Feet",
  },
  {
    value: "ESRI:102646",
    label: "ESRI:102646 / NAD_1983_StatePlane_California_VI_FIPS_0406_Feet",
  },
  {
    value: "ESRI:102647",
    label:
      "ESRI:102647 / NAD_1983_NSRS2007_StatePlane_Puerto_Rico_Virgin_Isls_FIPS_5200",
  },
  {
    value: "ESRI:102648",
    label: "ESRI:102648 / NAD_1983_StatePlane_Arizona_East_FIPS_0201_Feet",
  },
  {
    value: "ESRI:102649",
    label: "ESRI:102649 / NAD_1983_StatePlane_Arizona_Central_FIPS_0202_Feet",
  },
  {
    value: "ESRI:102650",
    label: "ESRI:102650 / NAD_1983_StatePlane_Arizona_West_FIPS_0203_Feet",
  },
  {
    value: "ESRI:102651",
    label: "ESRI:102651 / NAD_1983_StatePlane_Arkansas_North_FIPS_0301_Feet",
  },
  {
    value: "ESRI:102652",
    label: "ESRI:102652 / NAD_1983_StatePlane_Arkansas_South_FIPS_0302_Feet",
  },
  {
    value: "ESRI:102653",
    label: "ESRI:102653 / NAD_1983_StatePlane_Colorado_North_FIPS_0501_Feet",
  },
  {
    value: "ESRI:102654",
    label: "ESRI:102654 / NAD_1983_StatePlane_Colorado_Central_FIPS_0502_Feet",
  },
  {
    value: "ESRI:102655",
    label: "ESRI:102655 / NAD_1983_StatePlane_Colorado_South_FIPS_0503_Feet",
  },
  {
    value: "ESRI:102656",
    label: "ESRI:102656 / NAD_1983_StatePlane_Connecticut_FIPS_0600_Feet",
  },
  {
    value: "ESRI:102657",
    label: "ESRI:102657 / NAD_1983_StatePlane_Delaware_FIPS_0700_Feet",
  },
  {
    value: "ESRI:102658",
    label: "ESRI:102658 / NAD_1983_StatePlane_Florida_East_FIPS_0901_Feet",
  },
  {
    value: "ESRI:102659",
    label: "ESRI:102659 / NAD_1983_StatePlane_Florida_West_FIPS_0902_Feet",
  },
  {
    value: "ESRI:102660",
    label: "ESRI:102660 / NAD_1983_StatePlane_Florida_North_FIPS_0903_Feet",
  },
  {
    value: "ESRI:102661",
    label: "ESRI:102661 / NAD_1983_StatePlane_Hawaii_1_FIPS_5101_Feet",
  },
  {
    value: "ESRI:102662",
    label: "ESRI:102662 / NAD_1983_StatePlane_Hawaii_2_FIPS_5102_Feet",
  },
  {
    value: "ESRI:102663",
    label: "ESRI:102663 / NAD_1983_StatePlane_Hawaii_3_FIPS_5103_Feet",
  },
  {
    value: "ESRI:102664",
    label: "ESRI:102664 / NAD_1983_StatePlane_Hawaii_4_FIPS_5104_Feet",
  },
  {
    value: "ESRI:102665",
    label: "ESRI:102665 / NAD_1983_StatePlane_Hawaii_5_FIPS_5105_Feet",
  },
  {
    value: "ESRI:102666",
    label: "ESRI:102666 / NAD_1983_StatePlane_Georgia_East_FIPS_1001_Feet",
  },
  {
    value: "ESRI:102667",
    label: "ESRI:102667 / NAD_1983_StatePlane_Georgia_West_FIPS_1002_Feet",
  },
  {
    value: "ESRI:102668",
    label: "ESRI:102668 / NAD_1983_StatePlane_Idaho_East_FIPS_1101_Feet",
  },
  {
    value: "ESRI:102669",
    label: "ESRI:102669 / NAD_1983_StatePlane_Idaho_Central_FIPS_1102_Feet",
  },
  {
    value: "ESRI:102670",
    label: "ESRI:102670 / NAD_1983_StatePlane_Idaho_West_FIPS_1103_Feet",
  },
  {
    value: "ESRI:102671",
    label: "ESRI:102671 / NAD_1983_StatePlane_Illinois_East_FIPS_1201_Feet",
  },
  {
    value: "ESRI:102672",
    label: "ESRI:102672 / NAD_1983_StatePlane_Illinois_West_FIPS_1202_Feet",
  },
  {
    value: "ESRI:102673",
    label: "ESRI:102673 / NAD_1983_StatePlane_Indiana_East_FIPS_1301_Feet",
  },
  {
    value: "ESRI:102674",
    label: "ESRI:102674 / NAD_1983_StatePlane_Indiana_West_FIPS_1302_Feet",
  },
  {
    value: "ESRI:102675",
    label: "ESRI:102675 / NAD_1983_StatePlane_Iowa_North_FIPS_1401_Feet",
  },
  {
    value: "ESRI:102676",
    label: "ESRI:102676 / NAD_1983_StatePlane_Iowa_South_FIPS_1402_Feet",
  },
  {
    value: "ESRI:102677",
    label: "ESRI:102677 / NAD_1983_StatePlane_Kansas_North_FIPS_1501_Feet",
  },
  {
    value: "ESRI:102678",
    label: "ESRI:102678 / NAD_1983_StatePlane_Kansas_South_FIPS_1502_Feet",
  },
  {
    value: "ESRI:102679",
    label: "ESRI:102679 / NAD_1983_StatePlane_Kentucky_North_FIPS_1601_Feet",
  },
  {
    value: "ESRI:102680",
    label: "ESRI:102680 / NAD_1983_StatePlane_Kentucky_South_FIPS_1602_Feet",
  },
  {
    value: "ESRI:102681",
    label: "ESRI:102681 / NAD_1983_StatePlane_Louisiana_North_FIPS_1701_Feet",
  },
  {
    value: "ESRI:102682",
    label: "ESRI:102682 / NAD_1983_StatePlane_Louisiana_South_FIPS_1702_Feet",
  },
  {
    value: "ESRI:102683",
    label: "ESRI:102683 / NAD_1983_StatePlane_Maine_East_FIPS_1801_Feet",
  },
  {
    value: "ESRI:102684",
    label: "ESRI:102684 / NAD_1983_StatePlane_Maine_West_FIPS_1802_Feet",
  },
  {
    value: "ESRI:102685",
    label: "ESRI:102685 / NAD_1983_StatePlane_Maryland_FIPS_1900_Feet",
  },
  {
    value: "ESRI:102686",
    label:
      "ESRI:102686 / NAD_1983_StatePlane_Massachusetts_Mainland_FIPS_2001_Feet",
  },
  {
    value: "ESRI:102687",
    label:
      "ESRI:102687 / NAD_1983_StatePlane_Massachusetts_Island_FIPS_2002_Feet",
  },
  {
    value: "ESRI:102688",
    label: "ESRI:102688 / NAD_1983_StatePlane_Michigan_North_FIPS_2111_Feet",
  },
  {
    value: "ESRI:102689",
    label: "ESRI:102689 / NAD_1983_StatePlane_Michigan_Central_FIPS_2112_Feet",
  },
  {
    value: "ESRI:102690",
    label: "ESRI:102690 / NAD_1983_StatePlane_Michigan_South_FIPS_2113_Feet",
  },
  {
    value: "ESRI:102691",
    label: "ESRI:102691 / NAD_1983_StatePlane_Minnesota_North_FIPS_2201_Feet",
  },
  {
    value: "ESRI:102692",
    label: "ESRI:102692 / NAD_1983_StatePlane_Minnesota_Central_FIPS_2202_Feet",
  },
  {
    value: "ESRI:102693",
    label: "ESRI:102693 / NAD_1983_StatePlane_Minnesota_South_FIPS_2203_Feet",
  },
  {
    value: "ESRI:102694",
    label: "ESRI:102694 / NAD_1983_StatePlane_Mississippi_East_FIPS_2301_Feet",
  },
  {
    value: "ESRI:102695",
    label: "ESRI:102695 / NAD_1983_StatePlane_Mississippi_West_FIPS_2302_Feet",
  },
  {
    value: "ESRI:102696",
    label: "ESRI:102696 / NAD_1983_StatePlane_Missouri_East_FIPS_2401_Feet",
  },
  {
    value: "ESRI:102697",
    label: "ESRI:102697 / NAD_1983_StatePlane_Missouri_Central_FIPS_2402_Feet",
  },
  {
    value: "ESRI:102698",
    label: "ESRI:102698 / NAD_1983_StatePlane_Missouri_West_FIPS_2403_Feet",
  },
  {
    value: "ESRI:102699",
    label: "ESRI:102699 / NAD_1927_StatePlane_California_V_Ventura",
  },
  {
    value: "ESRI:102700",
    label: "ESRI:102700 / NAD_1983_StatePlane_Montana_FIPS_2500_Feet",
  },
  { value: "ESRI:102701", label: "ESRI:102701 / NAD_1983_PACP00_UTM_Zone_4N" },
  { value: "ESRI:102702", label: "ESRI:102702 / NAD_1983_PACP00_UTM_Zone_5N" },
  { value: "ESRI:102703", label: "ESRI:102703 / NAD_1983_PACP00_UTM_Zone_2S" },
  {
    value: "ESRI:102704",
    label: "ESRI:102704 / NAD_1983_StatePlane_Nebraska_FIPS_2600_Feet",
  },
  {
    value: "ESRI:102705",
    label: "ESRI:102705 / NAD_1983_Nebraska_Lancaster_County_FtUS",
  },
  {
    value: "ESRI:102706",
    label: "ESRI:102706 / Palestine_1923_Palestine_Grid_TM",
  },
  {
    value: "ESRI:102707",
    label: "ESRI:102707 / NAD_1983_StatePlane_Nevada_East_FIPS_2701_Feet",
  },
  {
    value: "ESRI:102708",
    label: "ESRI:102708 / NAD_1983_StatePlane_Nevada_Central_FIPS_2702_Feet",
  },
  {
    value: "ESRI:102709",
    label: "ESRI:102709 / NAD_1983_StatePlane_Nevada_West_FIPS_2703_Feet",
  },
  {
    value: "ESRI:102710",
    label: "ESRI:102710 / NAD_1983_StatePlane_New_Hampshire_FIPS_2800_Feet",
  },
  {
    value: "ESRI:102711",
    label: "ESRI:102711 / NAD_1983_StatePlane_New_Jersey_FIPS_2900_Feet",
  },
  {
    value: "ESRI:102712",
    label: "ESRI:102712 / NAD_1983_StatePlane_New_Mexico_East_FIPS_3001_Feet",
  },
  {
    value: "ESRI:102713",
    label:
      "ESRI:102713 / NAD_1983_StatePlane_New_Mexico_Central_FIPS_3002_Feet",
  },
  {
    value: "ESRI:102714",
    label: "ESRI:102714 / NAD_1983_StatePlane_New_Mexico_West_FIPS_3003_Feet",
  },
  {
    value: "ESRI:102715",
    label: "ESRI:102715 / NAD_1983_StatePlane_New_York_East_FIPS_3101_Feet",
  },
  {
    value: "ESRI:102716",
    label: "ESRI:102716 / NAD_1983_StatePlane_New_York_Central_FIPS_3102_Feet",
  },
  {
    value: "ESRI:102717",
    label: "ESRI:102717 / NAD_1983_StatePlane_New_York_West_FIPS_3103_Feet",
  },
  {
    value: "ESRI:102718",
    label:
      "ESRI:102718 / NAD_1983_StatePlane_New_York_Long_Island_FIPS_3104_Feet",
  },
  {
    value: "ESRI:102719",
    label: "ESRI:102719 / NAD_1983_StatePlane_North_Carolina_FIPS_3200_Feet",
  },
  {
    value: "ESRI:102720",
    label:
      "ESRI:102720 / NAD_1983_StatePlane_North_Dakota_North_FIPS_3301_Feet",
  },
  {
    value: "ESRI:102721",
    label:
      "ESRI:102721 / NAD_1983_StatePlane_North_Dakota_South_FIPS_3302_Feet",
  },
  {
    value: "ESRI:102722",
    label: "ESRI:102722 / NAD_1983_StatePlane_Ohio_North_FIPS_3401_Feet",
  },
  {
    value: "ESRI:102723",
    label: "ESRI:102723 / NAD_1983_StatePlane_Ohio_South_FIPS_3402_Feet",
  },
  {
    value: "ESRI:102724",
    label: "ESRI:102724 / NAD_1983_StatePlane_Oklahoma_North_FIPS_3501_Feet",
  },
  {
    value: "ESRI:102725",
    label: "ESRI:102725 / NAD_1983_StatePlane_Oklahoma_South_FIPS_3502_Feet",
  },
  {
    value: "ESRI:102726",
    label: "ESRI:102726 / NAD_1983_StatePlane_Oregon_North_FIPS_3601_Feet",
  },
  {
    value: "ESRI:102727",
    label: "ESRI:102727 / NAD_1983_StatePlane_Oregon_South_FIPS_3602_Feet",
  },
  {
    value: "ESRI:102728",
    label:
      "ESRI:102728 / NAD_1983_StatePlane_Pennsylvania_North_FIPS_3701_Feet",
  },
  {
    value: "ESRI:102729",
    label:
      "ESRI:102729 / NAD_1983_StatePlane_Pennsylvania_South_FIPS_3702_Feet",
  },
  {
    value: "ESRI:102730",
    label: "ESRI:102730 / NAD_1983_StatePlane_Rhode_Island_FIPS_3800_Feet",
  },
  {
    value: "ESRI:102733",
    label: "ESRI:102733 / NAD_1983_StatePlane_South_Carolina_FIPS_3900_Feet",
  },
  {
    value: "ESRI:102734",
    label:
      "ESRI:102734 / NAD_1983_StatePlane_South_Dakota_North_FIPS_4001_Feet",
  },
  {
    value: "ESRI:102735",
    label:
      "ESRI:102735 / NAD_1983_StatePlane_South_Dakota_South_FIPS_4002_Feet",
  },
  {
    value: "ESRI:102736",
    label: "ESRI:102736 / NAD_1983_StatePlane_Tennessee_FIPS_4100_Feet",
  },
  {
    value: "ESRI:102737",
    label: "ESRI:102737 / NAD_1983_StatePlane_Texas_North_FIPS_4201_Feet",
  },
  {
    value: "ESRI:102738",
    label:
      "ESRI:102738 / NAD_1983_StatePlane_Texas_North_Central_FIPS_4202_Feet",
  },
  {
    value: "ESRI:102739",
    label: "ESRI:102739 / NAD_1983_StatePlane_Texas_Central_FIPS_4203_Feet",
  },
  {
    value: "ESRI:102740",
    label:
      "ESRI:102740 / NAD_1983_StatePlane_Texas_South_Central_FIPS_4204_Feet",
  },
  {
    value: "ESRI:102741",
    label: "ESRI:102741 / NAD_1983_StatePlane_Texas_South_FIPS_4205_Feet",
  },
  {
    value: "ESRI:102742",
    label: "ESRI:102742 / NAD_1983_StatePlane_Utah_North_FIPS_4301_Feet",
  },
  {
    value: "ESRI:102743",
    label: "ESRI:102743 / NAD_1983_StatePlane_Utah_Central_FIPS_4302_Feet",
  },
  {
    value: "ESRI:102744",
    label: "ESRI:102744 / NAD_1983_StatePlane_Utah_South_FIPS_4303_Feet",
  },
  {
    value: "ESRI:102745",
    label: "ESRI:102745 / NAD_1983_StatePlane_Vermont_FIPS_4400_Feet",
  },
  {
    value: "ESRI:102746",
    label: "ESRI:102746 / NAD_1983_StatePlane_Virginia_North_FIPS_4501_Feet",
  },
  {
    value: "ESRI:102747",
    label: "ESRI:102747 / NAD_1983_StatePlane_Virginia_South_FIPS_4502_Feet",
  },
  {
    value: "ESRI:102748",
    label: "ESRI:102748 / NAD_1983_StatePlane_Washington_North_FIPS_4601_Feet",
  },
  {
    value: "ESRI:102749",
    label: "ESRI:102749 / NAD_1983_StatePlane_Washington_South_FIPS_4602_Feet",
  },
  {
    value: "ESRI:102750",
    label:
      "ESRI:102750 / NAD_1983_StatePlane_West_Virginia_North_FIPS_4701_Feet",
  },
  {
    value: "ESRI:102751",
    label:
      "ESRI:102751 / NAD_1983_StatePlane_West_Virginia_South_FIPS_4702_Feet",
  },
  {
    value: "ESRI:102752",
    label: "ESRI:102752 / NAD_1983_StatePlane_Wisconsin_North_FIPS_4801_Feet",
  },
  {
    value: "ESRI:102753",
    label: "ESRI:102753 / NAD_1983_StatePlane_Wisconsin_Central_FIPS_4802_Feet",
  },
  {
    value: "ESRI:102754",
    label: "ESRI:102754 / NAD_1983_StatePlane_Wisconsin_South_FIPS_4803_Feet",
  },
  {
    value: "ESRI:102755",
    label: "ESRI:102755 / NAD_1983_StatePlane_Wyoming_East_FIPS_4901_Feet",
  },
  {
    value: "ESRI:102756",
    label:
      "ESRI:102756 / NAD_1983_StatePlane_Wyoming_East_Central_FIPS_4902_Feet",
  },
  {
    value: "ESRI:102757",
    label:
      "ESRI:102757 / NAD_1983_StatePlane_Wyoming_West_Central_FIPS_4903_Feet",
  },
  {
    value: "ESRI:102758",
    label: "ESRI:102758 / NAD_1983_StatePlane_Wyoming_West_FIPS_4904_Feet",
  },
  {
    value: "ESRI:102759",
    label: "ESRI:102759 / WGS_1984_California_Teale_Albers_Ft_Intl",
  },
  {
    value: "ESRI:102760",
    label: "ESRI:102760 / NAD_1983_California_Teale_Albers_Ft_Intl",
  },
  {
    value: "ESRI:102761",
    label:
      "ESRI:102761 / NAD_1983_StatePlane_Puerto_Rico_Virgin_Islands_FIPS_5200_Feet",
  },
  { value: "ESRI:102762", label: "ESRI:102762 / Katanga_1955_Katanga_Lambert" },
  {
    value: "ESRI:102763",
    label: "ESRI:102763 / NAD_1983_StatePlane_Kentucky_FIPS_1600_Feet",
  },
  {
    value: "ESRI:102764",
    label: "ESRI:102764 / Pulkovo_1942_Adj_1983_3_Degree_GK_Zone_7",
  },
  {
    value: "ESRI:102765",
    label: "ESRI:102765 / Pulkovo_1942_Adj_1983_3_Degree_GK_Zone_8",
  },
  {
    value: "ESRI:102766",
    label: "ESRI:102766 / NAD_1983_StatePlane_Guam_FIPS_5400_Feet",
  },
  { value: "ESRI:102767", label: "ESRI:102767 / MAGNA_Leticia_Amazonas_1994" },
  {
    value: "ESRI:102768",
    label: "ESRI:102768 / MAGNA_Medellin_Antioquia_2010",
  },
  { value: "ESRI:102769", label: "ESRI:102769 / MAGNA_Arauca_2007" },
  {
    value: "ESRI:102770",
    label: "ESRI:102770 / MAGNA_Barranquilla_Atlantico_1997",
  },
  { value: "ESRI:102771", label: "ESRI:102771 / MAGNA_Bogota_DC_2005" },
  { value: "ESRI:102772", label: "ESRI:102772 / MAGNA_Cartagena_Bolivar_2005" },
  { value: "ESRI:102773", label: "ESRI:102773 / MAGNA_Tunja_Boyaca_1997" },
  { value: "ESRI:102774", label: "ESRI:102774 / MAGNA_Manizales_Caldas_2011" },
  { value: "ESRI:102775", label: "ESRI:102775 / MAGNA_Florencia_Caqueta_2007" },
  { value: "ESRI:102776", label: "ESRI:102776 / MAGNA_Yopal_Casanare_2006" },
  { value: "ESRI:102777", label: "ESRI:102777 / MAGNA_Popayan_Cauca_2006" },
  { value: "ESRI:102778", label: "ESRI:102778 / MAGNA_Valledupar_Cesar_2011" },
  { value: "ESRI:102779", label: "ESRI:102779 / MAGNA_Quibdo_Choco_2011" },
  { value: "ESRI:102780", label: "ESRI:102780 / MAGNA_Monteria_Cordoba_2006" },
  { value: "ESRI:102781", label: "ESRI:102781 / MAGNA_Inirida_Guainia_2008" },
  {
    value: "ESRI:102782",
    label: "ESRI:102782 / MAGNA_San_Jose_del_Guaviare_2011",
  },
  { value: "ESRI:102783", label: "ESRI:102783 / MAGNA_Neiva_Huila_2006" },
  {
    value: "ESRI:102784",
    label: "ESRI:102784 / MAGNA_Riohacha_La_Guajira_2006",
  },
  {
    value: "ESRI:102785",
    label: "ESRI:102785 / MAGNA_Santa_Marta_Magdalena_2007",
  },
  {
    value: "ESRI:102786",
    label: "ESRI:102786 / MAGNA_Villavicencio_Meta_2011",
  },
  { value: "ESRI:102787", label: "ESRI:102787 / MAGNA_Pasto_Narino_2008" },
  {
    value: "ESRI:102788",
    label: "ESRI:102788 / MAGNA_Cucuta_Norte_de_Santander_2011",
  },
  { value: "ESRI:102789", label: "ESRI:102789 / MAGNA_Mocoa_Putumayo_2011" },
  { value: "ESRI:102790", label: "ESRI:102790 / MAGNA_Armenia_Quindio_2006" },
  { value: "ESRI:102791", label: "ESRI:102791 / MAGNA_Pereira_Risaralda_2007" },
  { value: "ESRI:102792", label: "ESRI:102792 / MAGNA_San_Andres_2007" },
  {
    value: "ESRI:102793",
    label: "ESRI:102793 / MAGNA_Bucaramanga_Santander_2008",
  },
  { value: "ESRI:102794", label: "ESRI:102794 / MAGNA_Sucre_2006" },
  { value: "ESRI:102795", label: "ESRI:102795 / MAGNA_Ibague_Tolima_2007" },
  {
    value: "ESRI:102796",
    label: "ESRI:102796 / MAGNA_Cali_Valle_del_Cauca_2009",
  },
  { value: "ESRI:102797", label: "ESRI:102797 / MAGNA_Mitu_Vaupes_2011" },
  {
    value: "ESRI:102798",
    label: "ESRI:102798 / MAGNA_Puerto_Carreno_Vichada_2011",
  },
  { value: "ESRI:102799", label: "ESRI:102799 / OSGB36_Highways_England_A1H1" },
  { value: "ESRI:102800", label: "ESRI:102800 / OSGB36_Highways_England_A2H1" },
  { value: "ESRI:102801", label: "ESRI:102801 / OSGB36_Highways_England_A3H1" },
  { value: "ESRI:102802", label: "ESRI:102802 / OSGB36_Highways_England_A3H2" },
  { value: "ESRI:102803", label: "ESRI:102803 / OSGB36_Highways_England_A4H1" },
  { value: "ESRI:102804", label: "ESRI:102804 / OSGB36_Highways_England_A5H1" },
  { value: "ESRI:102805", label: "ESRI:102805 / OSGB36_Highways_England_A5H2" },
  { value: "ESRI:102806", label: "ESRI:102806 / OSGB36_Highways_England_A6H1" },
  { value: "ESRI:102807", label: "ESRI:102807 / OSGB36_Highways_England_A6H2" },
  { value: "ESRI:102808", label: "ESRI:102808 / OSGB36_Highways_England_A7H1" },
  { value: "ESRI:102809", label: "ESRI:102809 / OSGB36_Highways_England_A7H2" },
  { value: "ESRI:102810", label: "ESRI:102810 / OSGB36_Highways_England_A8H1" },
  { value: "ESRI:102811", label: "ESRI:102811 / OSGB36_Highways_England_A8H2" },
  { value: "ESRI:102812", label: "ESRI:102812 / OSGB36_Highways_England_A9H1" },
  { value: "ESRI:102813", label: "ESRI:102813 / OSGB36_Highways_England_A9H2" },
  {
    value: "ESRI:102814",
    label: "ESRI:102814 / OSGB36_Highways_England_A10H1",
  },
  {
    value: "ESRI:102815",
    label: "ESRI:102815 / OSGB36_Highways_England_A10H2",
  },
  {
    value: "ESRI:102816",
    label: "ESRI:102816 / OSGB36_Highways_England_A11H1",
  },
  {
    value: "ESRI:102817",
    label: "ESRI:102817 / OSGB36_Highways_England_A11H2",
  },
  {
    value: "ESRI:102818",
    label: "ESRI:102818 / OSGB36_Highways_England_A11H3",
  },
  {
    value: "ESRI:102819",
    label: "ESRI:102819 / OSGB36_Highways_England_A12H1",
  },
  {
    value: "ESRI:102820",
    label: "ESRI:102820 / OSGB36_Highways_England_A12H2",
  },
  {
    value: "ESRI:102821",
    label: "ESRI:102821 / OSGB36_Highways_England_A12H3",
  },
  {
    value: "ESRI:102822",
    label: "ESRI:102822 / OSGB36_Highways_England_A13H1",
  },
  {
    value: "ESRI:102823",
    label: "ESRI:102823 / OSGB36_Highways_England_A13H2",
  },
  {
    value: "ESRI:102824",
    label: "ESRI:102824 / OSGB36_Highways_England_A14H1",
  },
  {
    value: "ESRI:102825",
    label: "ESRI:102825 / OSGB36_Highways_England_A14H2",
  },
  {
    value: "ESRI:102826",
    label: "ESRI:102826 / OSGB36_Highways_England_A15H1",
  },
  {
    value: "ESRI:102827",
    label: "ESRI:102827 / OSGB36_Highways_England_A15H2",
  },
  {
    value: "ESRI:102828",
    label: "ESRI:102828 / OSGB36_Highways_England_A16H1",
  },
  {
    value: "ESRI:102829",
    label: "ESRI:102829 / OSGB36_Highways_England_A16H2",
  },
  {
    value: "ESRI:102830",
    label: "ESRI:102830 / OSGB36_Highways_England_A17H1",
  },
  {
    value: "ESRI:102831",
    label: "ESRI:102831 / OSGB36_Highways_England_A17H2",
  },
  {
    value: "ESRI:102832",
    label: "ESRI:102832 / OSGB36_Highways_England_A18H1",
  },
  {
    value: "ESRI:102833",
    label: "ESRI:102833 / OSGB36_Highways_England_A18H2",
  },
  {
    value: "ESRI:102834",
    label: "ESRI:102834 / OSGB36_Highways_England_A19H1",
  },
  {
    value: "ESRI:102835",
    label: "ESRI:102835 / OSGB36_Highways_England_A19H2",
  },
  {
    value: "ESRI:102836",
    label: "ESRI:102836 / OSGB36_Highways_England_A20H1",
  },
  {
    value: "ESRI:102837",
    label: "ESRI:102837 / OSGB36_Highways_England_A20H2",
  },
  {
    value: "ESRI:102838",
    label: "ESRI:102838 / OSGB36_Highways_England_A21H1",
  },
  {
    value: "ESRI:102839",
    label: "ESRI:102839 / OSGB36_Highways_England_A21H2",
  },
  {
    value: "ESRI:102840",
    label: "ESRI:102840 / OSGB36_Highways_England_A22H1",
  },
  {
    value: "ESRI:102841",
    label: "ESRI:102841 / OSGB36_Highways_England_A22H2",
  },
  {
    value: "ESRI:102842",
    label: "ESRI:102842 / OSGB36_Highways_England_A23H1",
  },
  {
    value: "ESRI:102843",
    label: "ESRI:102843 / OSGB36_Highways_England_A23H2",
  },
  {
    value: "ESRI:102844",
    label: "ESRI:102844 / OSGB36_Highways_England_A24H1",
  },
  {
    value: "ESRI:102845",
    label: "ESRI:102845 / OSGB36_Highways_England_A24H2",
  },
  {
    value: "ESRI:102846",
    label: "ESRI:102846 / OSGB36_Highways_England_A25H1",
  },
  {
    value: "ESRI:102847",
    label: "ESRI:102847 / OSGB36_Highways_England_A25H2",
  },
  {
    value: "ESRI:102848",
    label: "ESRI:102848 / OSGB36_Highways_England_A26H1",
  },
  {
    value: "ESRI:102849",
    label: "ESRI:102849 / OSGB36_Highways_England_A26H2",
  },
  {
    value: "ESRI:102850",
    label: "ESRI:102850 / OSGB36_Highways_England_A27H1",
  },
  {
    value: "ESRI:102851",
    label: "ESRI:102851 / OSGB36_Highways_England_A27H2",
  },
  {
    value: "ESRI:102852",
    label: "ESRI:102852 / OSGB36_Highways_England_A28H1",
  },
  {
    value: "ESRI:102853",
    label: "ESRI:102853 / OSGB36_Highways_England_A28H2",
  },
  {
    value: "ESRI:102854",
    label: "ESRI:102854 / OSGB36_Highways_England_A29H1",
  },
  {
    value: "ESRI:102855",
    label: "ESRI:102855 / OSGB36_Highways_England_A30H1",
  },
  {
    value: "ESRI:102856",
    label: "ESRI:102856 / OSGB36_Highways_England_B15H1",
  },
  {
    value: "ESRI:102857",
    label: "ESRI:102857 / OSGB36_Highways_England_B15H2",
  },
  {
    value: "ESRI:102858",
    label: "ESRI:102858 / OSGB36_Highways_England_B15H3",
  },
  {
    value: "ESRI:102859",
    label: "ESRI:102859 / OSGB36_Highways_England_B16H1",
  },
  {
    value: "ESRI:102860",
    label: "ESRI:102860 / OSGB36_Highways_England_B16H2",
  },
  {
    value: "ESRI:102861",
    label: "ESRI:102861 / OSGB36_Highways_England_B16H3",
  },
  {
    value: "ESRI:102862",
    label: "ESRI:102862 / OSGB36_Highways_England_B16H4",
  },
  {
    value: "ESRI:102863",
    label: "ESRI:102863 / OSGB36_Highways_England_B17H1",
  },
  {
    value: "ESRI:102864",
    label: "ESRI:102864 / OSGB36_Highways_England_B17H2",
  },
  {
    value: "ESRI:102865",
    label: "ESRI:102865 / OSGB36_Highways_England_B18H1",
  },
  {
    value: "ESRI:102866",
    label: "ESRI:102866 / OSGB36_Highways_England_B18H2",
  },
  {
    value: "ESRI:102867",
    label: "ESRI:102867 / OSGB36_Highways_England_B19H1",
  },
  {
    value: "ESRI:102868",
    label: "ESRI:102868 / OSGB36_Highways_England_B20H1",
  },
  {
    value: "ESRI:102869",
    label: "ESRI:102869 / OSGB36_Highways_England_B21H1",
  },
  {
    value: "ESRI:102870",
    label: "ESRI:102870 / OSGB36_Highways_England_B22H1",
  },
  {
    value: "ESRI:102871",
    label: "ESRI:102871 / OSGB36_Highways_England_B23H1",
  },
  {
    value: "ESRI:102872",
    label: "ESRI:102872 / OSGB36_Highways_England_B24H1",
  },
  {
    value: "ESRI:102873",
    label: "ESRI:102873 / OSGB36_Highways_England_B25H1",
  },
  {
    value: "ESRI:102874",
    label: "ESRI:102874 / OSGB36_Highways_England_B26H1",
  },
  {
    value: "ESRI:102875",
    label: "ESRI:102875 / OSGB36_Highways_England_B27H1",
  },
  {
    value: "ESRI:102876",
    label: "ESRI:102876 / OSGB36_Highways_England_B28H1",
  },
  {
    value: "ESRI:102877",
    label: "ESRI:102877 / OSGB36_Highways_England_B29H1",
  },
  {
    value: "ESRI:102878",
    label: "ESRI:102878 / OSGB36_Highways_England_B30H1",
  },
  {
    value: "ESRI:102879",
    label: "ESRI:102879 / OSGB36_Highways_England_B31H1",
  },
  {
    value: "ESRI:102880",
    label: "ESRI:102880 / OSGB36_Highways_England_B32H1",
  },
  {
    value: "ESRI:102881",
    label: "ESRI:102881 / OSGB36_Highways_England_C13H1",
  },
  {
    value: "ESRI:102882",
    label: "ESRI:102882 / OSGB36_Highways_England_C14H1",
  },
  {
    value: "ESRI:102883",
    label: "ESRI:102883 / OSGB36_Highways_England_C14H2",
  },
  {
    value: "ESRI:102884",
    label: "ESRI:102884 / OSGB36_Highways_England_C14H3",
  },
  {
    value: "ESRI:102885",
    label: "ESRI:102885 / OSGB36_Highways_England_C14H4",
  },
  {
    value: "ESRI:102886",
    label: "ESRI:102886 / OSGB36_Highways_England_C15H1",
  },
  {
    value: "ESRI:102887",
    label: "ESRI:102887 / OSGB36_Highways_England_C15H2",
  },
  {
    value: "ESRI:102888",
    label: "ESRI:102888 / OSGB36_Highways_England_C15H3",
  },
  {
    value: "ESRI:102889",
    label: "ESRI:102889 / OSGB36_Highways_England_C15H4",
  },
  {
    value: "ESRI:102890",
    label: "ESRI:102890 / OSGB36_Highways_England_C15H5",
  },
  {
    value: "ESRI:102891",
    label: "ESRI:102891 / OSGB36_Highways_England_C16H1",
  },
  {
    value: "ESRI:102892",
    label: "ESRI:102892 / OSGB36_Highways_England_C16H2",
  },
  {
    value: "ESRI:102893",
    label: "ESRI:102893 / OSGB36_Highways_England_C16H3",
  },
  {
    value: "ESRI:102894",
    label: "ESRI:102894 / OSGB36_Highways_England_C16H4",
  },
  {
    value: "ESRI:102895",
    label: "ESRI:102895 / OSGB36_Highways_England_C17H1",
  },
  {
    value: "ESRI:102896",
    label: "ESRI:102896 / OSGB36_Highways_England_C17H2",
  },
  {
    value: "ESRI:102897",
    label: "ESRI:102897 / OSGB36_Highways_England_C18H1",
  },
  {
    value: "ESRI:102898",
    label: "ESRI:102898 / OSGB36_Highways_England_C18H2",
  },
  {
    value: "ESRI:102899",
    label: "ESRI:102899 / OSGB36_Highways_England_C19H1",
  },
  {
    value: "ESRI:102900",
    label: "ESRI:102900 / OSGB36_Highways_England_C19H2",
  },
  {
    value: "ESRI:102901",
    label: "ESRI:102901 / NAD_1983_(2011)_ICS_Aurora_(US_Feet)",
  },
  {
    value: "ESRI:102902",
    label: "ESRI:102902 / NAD_1983_(2011)_ICS_Freeport_(US_Feet)",
  },
  {
    value: "ESRI:102903",
    label: "ESRI:102903 / NAD_1983_(2011)_ICS_Chicago_(US_Feet)",
  },
  {
    value: "ESRI:102904",
    label: "ESRI:102904 / NAD_1983_(2011)_ICS_Rockford_(US_Feet)",
  },
  {
    value: "ESRI:102905",
    label: "ESRI:102905 / NAD_1983_(2011)_ICS_Moline_(US_Feet)",
  },
  {
    value: "ESRI:102906",
    label: "ESRI:102906 / NAD_1983_(2011)_ICS_Ottawa_(US_Feet)",
  },
  {
    value: "ESRI:102907",
    label: "ESRI:102907 / NAD_1983_(2011)_ICS_Sterling_(US_Feet)",
  },
  {
    value: "ESRI:102908",
    label: "ESRI:102908 / NAD_1983_(2011)_ICS_Joliet_(US_Feet)",
  },
  {
    value: "ESRI:102909",
    label: "ESRI:102909 / NAD_1983_(2011)_ICS_Eureka_(US_Feet)",
  },
  {
    value: "ESRI:102910",
    label: "ESRI:102910 / NAD_1983_(2011)_ICS_Pontiac_(US_Feet)",
  },
  {
    value: "ESRI:102911",
    label: "ESRI:102911 / NAD_1983_(2011)_ICS_Monmouth_(US_Feet)",
  },
  {
    value: "ESRI:102912",
    label: "ESRI:102912 / NAD_1983_(2011)_ICS_Watseka_(US_Feet)",
  },
  {
    value: "ESRI:102913",
    label: "ESRI:102913 / NAD_1983_(2011)_ICS_Peoria_(US_Feet)",
  },
  {
    value: "ESRI:102914",
    label: "ESRI:102914 / NAD_1983_(2011)_ICS_Bloomington_(US_Feet)",
  },
  {
    value: "ESRI:102915",
    label: "ESRI:102915 / NAD_1983_(2011)_ICS_Galesburg_(US_Feet)",
  },
  {
    value: "ESRI:102916",
    label: "ESRI:102916 / NAD_1983_(2011)_ICS_Champaign_(US_Feet)",
  },
  {
    value: "ESRI:102917",
    label: "ESRI:102917 / NAD_1983_(2011)_ICS_Decatur_(US_Feet)",
  },
  {
    value: "ESRI:102918",
    label: "ESRI:102918 / NAD_1983_(2011)_ICS_Quincy_(US_Feet)",
  },
  {
    value: "ESRI:102919",
    label: "ESRI:102919 / NAD_1983_(2011)_ICS_Lincoln_(US_Feet)",
  },
  {
    value: "ESRI:102920",
    label: "ESRI:102920 / NAD_1983_(2011)_ICS_Macomb_(US_Feet)",
  },
  {
    value: "ESRI:102921",
    label: "ESRI:102921 / NAD_1983_(2011)_ICS_Springfield_(US_Feet)",
  },
  {
    value: "ESRI:102922",
    label: "ESRI:102922 / NAD_1983_(2011)_ICS_Jacksonville_(US_Feet)",
  },
  {
    value: "ESRI:102923",
    label: "ESRI:102923 / NAD_1983_(2011)_ICS_Taylorville_(US_Feet)",
  },
  {
    value: "ESRI:102924",
    label: "ESRI:102924 / NAD_1983_(2011)_ICS_Charleston_(US_Feet)",
  },
  {
    value: "ESRI:102925",
    label: "ESRI:102925 / NAD_1983_(2011)_ICS_Carlinville_(US_Feet)",
  },
  {
    value: "ESRI:102926",
    label: "ESRI:102926 / NAD_1983_(2011)_ICS_Robinson_(US_Feet)",
  },
  {
    value: "ESRI:102927",
    label: "ESRI:102927 / NAD_1983_(2011)_ICS_Jerseyville_(US_Feet)",
  },
  {
    value: "ESRI:102928",
    label: "ESRI:102928 / NAD_1983_(2011)_ICS_Effingham_(US_Feet)",
  },
  {
    value: "ESRI:102929",
    label: "ESRI:102929 / NAD_1983_(2011)_ICS_Belleville_(US_Feet)",
  },
  {
    value: "ESRI:102930",
    label: "ESRI:102930 / NAD_1983_(2011)_ICS_Olney_(US_Feet)",
  },
  {
    value: "ESRI:102931",
    label: "ESRI:102931 / NAD_1983_(2011)_ICS_Mount_Vernon_(US_Feet)",
  },
  {
    value: "ESRI:102932",
    label: "ESRI:102932 / NAD_1983_(2011)_ICS_Carbondale_(US_Feet)",
  },
  {
    value: "ESRI:102933",
    label: "ESRI:102933 / NAD_1983_(2011)_ICS_Metropolis_(US_Feet)",
  },
  {
    value: "ESRI:102934",
    label: "ESRI:102934 / Cassini_Bangladesh_Zone_01_Dinajpur",
  },
  {
    value: "ESRI:102935",
    label: "ESRI:102935 / Cassini_Bangladesh_Zone_02_Rangpur",
  },
  {
    value: "ESRI:102936",
    label: "ESRI:102936 / Cassini_Bangladesh_Zone_03_Rajshahi",
  },
  {
    value: "ESRI:102937",
    label: "ESRI:102937 / Cassini_Bangladesh_Zone_04_Bogura",
  },
  {
    value: "ESRI:102938",
    label: "ESRI:102938 / Cassini_Bangladesh_Zone_05_Pabna",
  },
  {
    value: "ESRI:102939",
    label: "ESRI:102939 / Cassini_Bangladesh_Zone_06_Mymensingh",
  },
  {
    value: "ESRI:102940",
    label: "ESRI:102940 / Cassini_Bangladesh_Zone_07_Dhaka",
  },
  {
    value: "ESRI:102941",
    label: "ESRI:102941 / Cassini_Bangladesh_Zone_08_Faridpur",
  },
  {
    value: "ESRI:102942",
    label: "ESRI:102942 / Cassini_Bangladesh_Zone_09_Sylhet",
  },
  {
    value: "ESRI:102943",
    label: "ESRI:102943 / Cassini_Bangladesh_Zone_10_Kushtia",
  },
  {
    value: "ESRI:102944",
    label: "ESRI:102944 / Cassini_Bangladesh_Zone_11_Joshore",
  },
  {
    value: "ESRI:102945",
    label: "ESRI:102945 / Cassini_Bangladesh_Zone_12_Khulna",
  },
  {
    value: "ESRI:102946",
    label: "ESRI:102946 / Cassini_Bangladesh_Zone_13_Barishal",
  },
  {
    value: "ESRI:102947",
    label: "ESRI:102947 / Cassini_Bangladesh_Zone_14_Cumilla",
  },
  {
    value: "ESRI:102948",
    label: "ESRI:102948 / Cassini_Bangladesh_Zone_15_Noakhali",
  },
  {
    value: "ESRI:102949",
    label: "ESRI:102949 / Cassini_Bangladesh_Zone_16_Chottogram",
  },
  {
    value: "ESRI:102950",
    label: "ESRI:102950 / Cassini_Bangladesh_Zone_17_CHT",
  },
  { value: "ESRI:102951", label: "ESRI:102951 / LCC_Bangladesh" },
  { value: "ESRI:102952", label: "ESRI:102952 / LCC_Gulshan" },
  { value: "ESRI:102953", label: "ESRI:102953 / UTM_Bangladesh_(BTM)" },
  { value: "ESRI:102954", label: "ESRI:102954 / BUTM2010" },
  { value: "ESRI:102955", label: "ESRI:102955 / UTM_Gulshan" },
  { value: "ESRI:102961", label: "ESRI:102961 / AGD_1966_ISG_57_2" },
  {
    value: "ESRI:102962",
    label: "ESRI:102962 / NAD_1983_2011_California_Teale_Albers",
  },
  { value: "ESRI:102963", label: "ESRI:102963 / NAD_1983_2011_Mississippi_TM" },
  {
    value: "ESRI:102965",
    label: "ESRI:102965 / NAD_1983_2011_Contiguous_USA_Albers",
  },
  { value: "ESRI:102966", label: "ESRI:102966 / NAD_1983_2011_Alaska_Albers" },
  {
    value: "ESRI:102967",
    label: "ESRI:102967 / NAD_1983_2011_Florida_GDL_Albers",
  },
  {
    value: "ESRI:102968",
    label: "ESRI:102968 / NAD_1983_2011_Michigan_GeoRef_Meters",
  },
  {
    value: "ESRI:102969",
    label: "ESRI:102969 / NAD_1983_2011_Oregon_Statewide_Lambert",
  },
  {
    value: "ESRI:102970",
    label: "ESRI:102970 / NAD_1983_2011_Oregon_Statewide_Lambert_Ft_Intl",
  },
  {
    value: "ESRI:102971",
    label: "ESRI:102971 / NAD_1983_2011_Texas_Centric_Mapping_System_Albers",
  },
  {
    value: "ESRI:102972",
    label: "ESRI:102972 / NAD_1983_2011_Texas_Centric_Mapping_System_Lambert",
  },
  { value: "ESRI:102973", label: "ESRI:102973 / NAD_1983_2011_Wisconsin_TM" },
  {
    value: "ESRI:102974",
    label: "ESRI:102974 / NAD_1983_2011_Wisconsin_TM_US_Ft",
  },
  {
    value: "ESRI:102975",
    label: "ESRI:102975 / NAD_1983_2011_StatePlane_Alabama_East_FIPS_0101",
  },
  {
    value: "ESRI:102976",
    label: "ESRI:102976 / NAD_1983_2011_StatePlane_Alabama_West_FIPS_0102",
  },
  {
    value: "ESRI:102977",
    label: "ESRI:102977 / NAD_1983_2011_StatePlane_Alaska_1_FIPS_5001",
  },
  {
    value: "ESRI:102978",
    label: "ESRI:102978 / NAD_1983_2011_StatePlane_Alaska_2_FIPS_5002",
  },
  {
    value: "ESRI:102979",
    label: "ESRI:102979 / NAD_1983_2011_StatePlane_Alaska_3_FIPS_5003",
  },
  {
    value: "ESRI:102980",
    label: "ESRI:102980 / NAD_1983_2011_StatePlane_Alaska_4_FIPS_5004",
  },
  {
    value: "ESRI:102981",
    label: "ESRI:102981 / NAD_1983_2011_StatePlane_Alaska_5_FIPS_5005",
  },
  {
    value: "ESRI:102982",
    label: "ESRI:102982 / NAD_1983_2011_StatePlane_Alaska_6_FIPS_5006",
  },
  {
    value: "ESRI:102983",
    label: "ESRI:102983 / NAD_1983_2011_StatePlane_Alaska_7_FIPS_5007",
  },
  {
    value: "ESRI:102984",
    label: "ESRI:102984 / NAD_1983_2011_StatePlane_Alaska_8_FIPS_5008",
  },
  {
    value: "ESRI:102985",
    label: "ESRI:102985 / NAD_1983_2011_StatePlane_Alaska_9_FIPS_5009",
  },
  {
    value: "ESRI:102986",
    label: "ESRI:102986 / NAD_1983_2011_StatePlane_Alaska_10_FIPS_5010",
  },
  {
    value: "ESRI:102987",
    label: "ESRI:102987 / NAD_1983_2011_StatePlane_Arizona_East_FIPS_0201",
  },
  {
    value: "ESRI:102988",
    label: "ESRI:102988 / NAD_1983_2011_StatePlane_Arizona_Central_FIPS_0202",
  },
  {
    value: "ESRI:102989",
    label: "ESRI:102989 / NAD_1983_2011_StatePlane_Arizona_West_FIPS_0203",
  },
  {
    value: "ESRI:102990",
    label:
      "ESRI:102990 / NAD_1983_2011_StatePlane_Arizona_East_FIPS_0201_Ft_Intl",
  },
  {
    value: "ESRI:102991",
    label:
      "ESRI:102991 / NAD_1983_2011_StatePlane_Arizona_Central_FIPS_0202_Ft_Intl",
  },
  {
    value: "ESRI:102992",
    label:
      "ESRI:102992 / NAD_1983_2011_StatePlane_Arizona_West_FIPS_0203_Ft_Intl",
  },
  {
    value: "ESRI:102993",
    label: "ESRI:102993 / NAD_1983_2011_StatePlane_Arkansas_North_FIPS_0301",
  },
  {
    value: "ESRI:102994",
    label: "ESRI:102994 / NAD_1983_2011_StatePlane_Arkansas_South_FIPS_0302",
  },
  {
    value: "ESRI:102995",
    label:
      "ESRI:102995 / NAD_1983_2011_StatePlane_Arkansas_North_FIPS_0301_Ft_US",
  },
  {
    value: "ESRI:102996",
    label:
      "ESRI:102996 / NAD_1983_2011_StatePlane_Arkansas_South_FIPS_0302_Ft_US",
  },
  {
    value: "ESRI:102997",
    label: "ESRI:102997 / NAD_1983_2011_StatePlane_California_I_FIPS_0401",
  },
  {
    value: "ESRI:102998",
    label: "ESRI:102998 / NAD_1983_2011_StatePlane_California_II_FIPS_0402",
  },
  {
    value: "ESRI:102999",
    label: "ESRI:102999 / NAD_1983_2011_StatePlane_California_III_FIPS_0403",
  },
  {
    value: "ESRI:103000",
    label: "ESRI:103000 / NAD_1983_2011_StatePlane_California_IV_FIPS_0404",
  },
  {
    value: "ESRI:103001",
    label: "ESRI:103001 / NAD_1983_2011_StatePlane_California_V_FIPS_0405",
  },
  {
    value: "ESRI:103002",
    label: "ESRI:103002 / NAD_1983_2011_StatePlane_California_VI_FIPS_0406",
  },
  {
    value: "ESRI:103003",
    label:
      "ESRI:103003 / NAD_1983_2011_StatePlane_California_I_FIPS_0401_Ft_US",
  },
  {
    value: "ESRI:103004",
    label:
      "ESRI:103004 / NAD_1983_2011_StatePlane_California_II_FIPS_0402_Ft_US",
  },
  {
    value: "ESRI:103005",
    label:
      "ESRI:103005 / NAD_1983_2011_StatePlane_California_III_FIPS_0403_Ft_US",
  },
  {
    value: "ESRI:103006",
    label:
      "ESRI:103006 / NAD_1983_2011_StatePlane_California_IV_FIPS_0404_Ft_US",
  },
  {
    value: "ESRI:103007",
    label:
      "ESRI:103007 / NAD_1983_2011_StatePlane_California_V_FIPS_0405_Ft_US",
  },
  {
    value: "ESRI:103008",
    label:
      "ESRI:103008 / NAD_1983_2011_StatePlane_California_VI_FIPS_0406_Ft_US",
  },
  {
    value: "ESRI:103009",
    label: "ESRI:103009 / NAD_1983_2011_StatePlane_Colorado_North_FIPS_0501",
  },
  {
    value: "ESRI:103010",
    label: "ESRI:103010 / NAD_1983_2011_StatePlane_Colorado_Central_FIPS_0502",
  },
  {
    value: "ESRI:103011",
    label: "ESRI:103011 / NAD_1983_2011_StatePlane_Colorado_South_FIPS_0503",
  },
  {
    value: "ESRI:103012",
    label:
      "ESRI:103012 / NAD_1983_2011_StatePlane_Colorado_North_FIPS_0501_Ft_US",
  },
  {
    value: "ESRI:103013",
    label:
      "ESRI:103013 / NAD_1983_2011_StatePlane_Colorado_Central_FIPS_0502_Ft_US",
  },
  {
    value: "ESRI:103014",
    label:
      "ESRI:103014 / NAD_1983_2011_StatePlane_Colorado_South_FIPS_0503_Ft_US",
  },
  {
    value: "ESRI:103015",
    label: "ESRI:103015 / NAD_1983_2011_StatePlane_Connecticut_FIPS_0600",
  },
  {
    value: "ESRI:103016",
    label: "ESRI:103016 / NAD_1983_2011_StatePlane_Connecticut_FIPS_0600_Ft_US",
  },
  {
    value: "ESRI:103017",
    label: "ESRI:103017 / NAD_1983_2011_StatePlane_Delaware_FIPS_0700",
  },
  {
    value: "ESRI:103018",
    label: "ESRI:103018 / NAD_1983_2011_StatePlane_Delaware_FIPS_0700_Ft_US",
  },
  {
    value: "ESRI:103019",
    label: "ESRI:103019 / NAD_1983_2011_StatePlane_Florida_East_FIPS_0901",
  },
  {
    value: "ESRI:103020",
    label: "ESRI:103020 / NAD_1983_2011_StatePlane_Florida_West_FIPS_0902",
  },
  {
    value: "ESRI:103021",
    label: "ESRI:103021 / NAD_1983_2011_StatePlane_Florida_North_FIPS_0903",
  },
  {
    value: "ESRI:103022",
    label:
      "ESRI:103022 / NAD_1983_2011_StatePlane_Florida_East_FIPS_0901_Ft_US",
  },
  {
    value: "ESRI:103023",
    label:
      "ESRI:103023 / NAD_1983_2011_StatePlane_Florida_West_FIPS_0902_Ft_US",
  },
  {
    value: "ESRI:103024",
    label:
      "ESRI:103024 / NAD_1983_2011_StatePlane_Florida_North_FIPS_0903_Ft_US",
  },
  {
    value: "ESRI:103025",
    label: "ESRI:103025 / NAD_1983_2011_StatePlane_Georgia_East_FIPS_1001",
  },
  {
    value: "ESRI:103026",
    label: "ESRI:103026 / NAD_1983_2011_StatePlane_Georgia_West_FIPS_1002",
  },
  {
    value: "ESRI:103027",
    label:
      "ESRI:103027 / NAD_1983_2011_StatePlane_Georgia_East_FIPS_1001_Ft_US",
  },
  {
    value: "ESRI:103028",
    label:
      "ESRI:103028 / NAD_1983_2011_StatePlane_Georgia_West_FIPS_1002_Ft_US",
  },
  {
    value: "ESRI:103029",
    label: "ESRI:103029 / NAD_1983_2011_StatePlane_Idaho_East_FIPS_1101",
  },
  {
    value: "ESRI:103030",
    label: "ESRI:103030 / NAD_1983_2011_StatePlane_Idaho_Central_FIPS_1102",
  },
  {
    value: "ESRI:103031",
    label: "ESRI:103031 / NAD_1983_2011_StatePlane_Idaho_West_FIPS_1103",
  },
  {
    value: "ESRI:103032",
    label: "ESRI:103032 / NAD_1983_2011_StatePlane_Idaho_East_FIPS_1101_Ft_US",
  },
  {
    value: "ESRI:103033",
    label:
      "ESRI:103033 / NAD_1983_2011_StatePlane_Idaho_Central_FIPS_1102_Ft_US",
  },
  {
    value: "ESRI:103034",
    label: "ESRI:103034 / NAD_1983_2011_StatePlane_Idaho_West_FIPS_1103_Ft_US",
  },
  {
    value: "ESRI:103035",
    label: "ESRI:103035 / NAD_1983_2011_StatePlane_Illinois_East_FIPS_1201",
  },
  {
    value: "ESRI:103036",
    label: "ESRI:103036 / NAD_1983_2011_StatePlane_Illinois_West_FIPS_1202",
  },
  {
    value: "ESRI:103037",
    label:
      "ESRI:103037 / NAD_1983_2011_StatePlane_Illinois_East_FIPS_1201_Ft_US",
  },
  {
    value: "ESRI:103038",
    label:
      "ESRI:103038 / NAD_1983_2011_StatePlane_Illinois_West_FIPS_1202_Ft_US",
  },
  {
    value: "ESRI:103039",
    label: "ESRI:103039 / NAD_1983_2011_StatePlane_Indiana_East_FIPS_1301",
  },
  {
    value: "ESRI:103040",
    label: "ESRI:103040 / NAD_1983_2011_StatePlane_Indiana_West_FIPS_1302",
  },
  {
    value: "ESRI:103041",
    label:
      "ESRI:103041 / NAD_1983_2011_StatePlane_Indiana_East_FIPS_1301_Ft_US",
  },
  {
    value: "ESRI:103042",
    label:
      "ESRI:103042 / NAD_1983_2011_StatePlane_Indiana_West_FIPS_1302_Ft_US",
  },
  {
    value: "ESRI:103043",
    label: "ESRI:103043 / NAD_1983_2011_StatePlane_Iowa_North_FIPS_1401",
  },
  {
    value: "ESRI:103044",
    label: "ESRI:103044 / NAD_1983_2011_StatePlane_Iowa_South_FIPS_1402",
  },
  {
    value: "ESRI:103045",
    label: "ESRI:103045 / NAD_1983_2011_StatePlane_Iowa_North_FIPS_1401_Ft_US",
  },
  {
    value: "ESRI:103046",
    label: "ESRI:103046 / NAD_1983_2011_StatePlane_Iowa_South_FIPS_1402_Ft_US",
  },
  {
    value: "ESRI:103047",
    label: "ESRI:103047 / NAD_1983_2011_StatePlane_Kansas_North_FIPS_1501",
  },
  {
    value: "ESRI:103048",
    label: "ESRI:103048 / NAD_1983_2011_StatePlane_Kansas_South_FIPS_1502",
  },
  {
    value: "ESRI:103049",
    label:
      "ESRI:103049 / NAD_1983_2011_StatePlane_Kansas_North_FIPS_1501_Ft_US",
  },
  {
    value: "ESRI:103050",
    label:
      "ESRI:103050 / NAD_1983_2011_StatePlane_Kansas_South_FIPS_1502_Ft_US",
  },
  {
    value: "ESRI:103051",
    label: "ESRI:103051 / NAD_1983_2011_StatePlane_Kentucky_North_FIPS_1601",
  },
  {
    value: "ESRI:103052",
    label:
      "ESRI:103052 / NAD_1983_2011_StatePlane_Kentucky_North_FIPS_1601_Ft_US",
  },
  {
    value: "ESRI:103053",
    label: "ESRI:103053 / NAD_1983_2011_StatePlane_Kentucky_FIPS_1600",
  },
  {
    value: "ESRI:103054",
    label: "ESRI:103054 / NAD_1983_2011_StatePlane_Kentucky_FIPS_1600_Ft_US",
  },
  {
    value: "ESRI:103055",
    label: "ESRI:103055 / NAD_1983_2011_StatePlane_Kentucky_South_FIPS_1602",
  },
  {
    value: "ESRI:103056",
    label:
      "ESRI:103056 / NAD_1983_2011_StatePlane_Kentucky_South_FIPS_1602_Ft_US",
  },
  {
    value: "ESRI:103057",
    label: "ESRI:103057 / NAD_1983_2011_StatePlane_Louisiana_North_FIPS_1701",
  },
  {
    value: "ESRI:103058",
    label: "ESRI:103058 / NAD_1983_2011_StatePlane_Louisiana_South_FIPS_1702",
  },
  {
    value: "ESRI:103059",
    label:
      "ESRI:103059 / NAD_1983_2011_StatePlane_Louisiana_North_FIPS_1701_Ft_US",
  },
  {
    value: "ESRI:103060",
    label:
      "ESRI:103060 / NAD_1983_2011_StatePlane_Louisiana_South_FIPS_1702_Ft_US",
  },
  {
    value: "ESRI:103061",
    label: "ESRI:103061 / NAD_1983_2011_StatePlane_Maine_East_FIPS_1801",
  },
  {
    value: "ESRI:103062",
    label: "ESRI:103062 / NAD_1983_2011_StatePlane_Maine_West_FIPS_1802",
  },
  {
    value: "ESRI:103063",
    label: "ESRI:103063 / NAD_1983_2011_StatePlane_Maine_East_FIPS_1801_Ft_US",
  },
  {
    value: "ESRI:103064",
    label: "ESRI:103064 / NAD_1983_2011_StatePlane_Maine_West_FIPS_1802_Ft_US",
  },
  {
    value: "ESRI:103065",
    label: "ESRI:103065 / NAD_1983_2011_Maine_2000_East_Zone",
  },
  {
    value: "ESRI:103066",
    label: "ESRI:103066 / NAD_1983_2011_Maine_2000_Central_Zone",
  },
  {
    value: "ESRI:103067",
    label: "ESRI:103067 / NAD_1983_2011_Maine_2000_West_Zone",
  },
  {
    value: "ESRI:103068",
    label: "ESRI:103068 / NAD_1983_2011_StatePlane_Maryland_FIPS_1900",
  },
  {
    value: "ESRI:103069",
    label: "ESRI:103069 / NAD_1983_2011_StatePlane_Maryland_FIPS_1900_Ft_US",
  },
  {
    value: "ESRI:103070",
    label:
      "ESRI:103070 / NAD_1983_2011_StatePlane_Massachusetts_Mainland_FIPS_2001",
  },
  {
    value: "ESRI:103071",
    label:
      "ESRI:103071 / NAD_1983_2011_StatePlane_Massachusetts_Island_FIPS_2002",
  },
  {
    value: "ESRI:103072",
    label:
      "ESRI:103072 / NAD_1983_2011_StatePlane_Massachusetts_Mnld_FIPS_2001_FtUS",
  },
  {
    value: "ESRI:103073",
    label:
      "ESRI:103073 / NAD_1983_2011_StatePlane_Massachusetts_Isl_FIPS_2002_FtUS",
  },
  {
    value: "ESRI:103074",
    label: "ESRI:103074 / NAD_1983_2011_StatePlane_Michigan_North_FIPS_2111",
  },
  {
    value: "ESRI:103075",
    label: "ESRI:103075 / NAD_1983_2011_StatePlane_Michigan_Central_FIPS_2112",
  },
  {
    value: "ESRI:103076",
    label: "ESRI:103076 / NAD_1983_2011_StatePlane_Michigan_South_FIPS_2113",
  },
  {
    value: "ESRI:103077",
    label:
      "ESRI:103077 / NAD_1983_2011_StatePlane_Michigan_North_FIPS_2111_Ft_Intl",
  },
  {
    value: "ESRI:103078",
    label:
      "ESRI:103078 / NAD_1983_2011_StatePlane_Michigan_Central_FIPS_2112_Ft_Intl",
  },
  {
    value: "ESRI:103079",
    label:
      "ESRI:103079 / NAD_1983_2011_StatePlane_Michigan_South_FIPS_2113_Ft_Intl",
  },
  {
    value: "ESRI:103080",
    label: "ESRI:103080 / NAD_1983_2011_StatePlane_Minnesota_North_FIPS_2201",
  },
  {
    value: "ESRI:103081",
    label: "ESRI:103081 / NAD_1983_2011_StatePlane_Minnesota_Central_FIPS_2202",
  },
  {
    value: "ESRI:103082",
    label: "ESRI:103082 / NAD_1983_2011_StatePlane_Minnesota_South_FIPS_2203",
  },
  {
    value: "ESRI:103083",
    label:
      "ESRI:103083 / NAD_1983_2011_StatePlane_Minnesota_North_FIPS_2201_Ft_US",
  },
  {
    value: "ESRI:103084",
    label:
      "ESRI:103084 / NAD_1983_2011_StatePlane_Minnesota_Central_FIPS_2202_Ft_US",
  },
  {
    value: "ESRI:103085",
    label:
      "ESRI:103085 / NAD_1983_2011_StatePlane_Minnesota_South_FIPS_2203_Ft_US",
  },
  {
    value: "ESRI:103086",
    label: "ESRI:103086 / NAD_1983_2011_StatePlane_Mississippi_East_FIPS_2301",
  },
  {
    value: "ESRI:103087",
    label: "ESRI:103087 / NAD_1983_2011_StatePlane_Mississippi_West_FIPS_2302",
  },
  {
    value: "ESRI:103088",
    label:
      "ESRI:103088 / NAD_1983_2011_StatePlane_Mississippi_East_FIPS_2301_Ft_US",
  },
  {
    value: "ESRI:103089",
    label:
      "ESRI:103089 / NAD_1983_2011_StatePlane_Mississippi_West_FIPS_2302_Ft_US",
  },
  {
    value: "ESRI:103090",
    label: "ESRI:103090 / NAD_1983_2011_StatePlane_Missouri_East_FIPS_2401",
  },
  {
    value: "ESRI:103091",
    label: "ESRI:103091 / NAD_1983_2011_StatePlane_Missouri_Central_FIPS_2402",
  },
  {
    value: "ESRI:103092",
    label: "ESRI:103092 / NAD_1983_2011_StatePlane_Missouri_West_FIPS_2403",
  },
  {
    value: "ESRI:103093",
    label: "ESRI:103093 / NAD_1983_2011_StatePlane_Montana_FIPS_2500",
  },
  {
    value: "ESRI:103094",
    label: "ESRI:103094 / NAD_1983_2011_StatePlane_Montana_FIPS_2500_Ft_Intl",
  },
  {
    value: "ESRI:103095",
    label: "ESRI:103095 / NAD_1983_2011_StatePlane_Nebraska_FIPS_2600",
  },
  {
    value: "ESRI:103096",
    label: "ESRI:103096 / NAD_1983_2011_StatePlane_Nebraska_FIPS_2600_Ft_US",
  },
  {
    value: "ESRI:103097",
    label: "ESRI:103097 / NAD_1983_2011_StatePlane_Nevada_East_FIPS_2701",
  },
  {
    value: "ESRI:103098",
    label: "ESRI:103098 / NAD_1983_2011_StatePlane_Nevada_Central_FIPS_2702",
  },
  {
    value: "ESRI:103099",
    label: "ESRI:103099 / NAD_1983_2011_StatePlane_Nevada_West_FIPS_2703",
  },
  {
    value: "ESRI:103100",
    label: "ESRI:103100 / NAD_1983_2011_StatePlane_Nevada_East_FIPS_2701_Ft_US",
  },
  {
    value: "ESRI:103101",
    label:
      "ESRI:103101 / NAD_1983_2011_StatePlane_Nevada_Central_FIPS_2702_Ft_US",
  },
  {
    value: "ESRI:103102",
    label: "ESRI:103102 / NAD_1983_2011_StatePlane_Nevada_West_FIPS_2703_Ft_US",
  },
  {
    value: "ESRI:103103",
    label: "ESRI:103103 / NAD_1983_2011_StatePlane_New_Hampshire_FIPS_2800",
  },
  {
    value: "ESRI:103104",
    label:
      "ESRI:103104 / NAD_1983_2011_StatePlane_New_Hampshire_FIPS_2800_Ft_US",
  },
  {
    value: "ESRI:103105",
    label: "ESRI:103105 / NAD_1983_2011_StatePlane_New_Jersey_FIPS_2900",
  },
  {
    value: "ESRI:103106",
    label: "ESRI:103106 / NAD_1983_2011_StatePlane_New_Jersey_FIPS_2900_Ft_US",
  },
  {
    value: "ESRI:103107",
    label: "ESRI:103107 / NAD_1983_2011_StatePlane_New_Mexico_East_FIPS_3001",
  },
  {
    value: "ESRI:103108",
    label:
      "ESRI:103108 / NAD_1983_2011_StatePlane_New_Mexico_Central_FIPS_3002",
  },
  {
    value: "ESRI:103109",
    label: "ESRI:103109 / NAD_1983_2011_StatePlane_New_Mexico_West_FIPS_3003",
  },
  {
    value: "ESRI:103110",
    label:
      "ESRI:103110 / NAD_1983_2011_StatePlane_New_Mexico_East_FIPS_3001_Ft_US",
  },
  {
    value: "ESRI:103111",
    label:
      "ESRI:103111 / NAD_1983_2011_StatePlane_New_Mexico_Central_FIPS_3002_Ft_US",
  },
  {
    value: "ESRI:103112",
    label:
      "ESRI:103112 / NAD_1983_2011_StatePlane_New_Mexico_West_FIPS_3003_Ft_US",
  },
  {
    value: "ESRI:103113",
    label: "ESRI:103113 / NAD_1983_2011_StatePlane_New_York_East_FIPS_3101",
  },
  {
    value: "ESRI:103114",
    label: "ESRI:103114 / NAD_1983_2011_StatePlane_New_York_Central_FIPS_3102",
  },
  {
    value: "ESRI:103115",
    label: "ESRI:103115 / NAD_1983_2011_StatePlane_New_York_West_FIPS_3103",
  },
  {
    value: "ESRI:103116",
    label:
      "ESRI:103116 / NAD_1983_2011_StatePlane_New_York_Long_Island_FIPS_3104",
  },
  {
    value: "ESRI:103117",
    label:
      "ESRI:103117 / NAD_1983_2011_StatePlane_New_York_East_FIPS_3101_Ft_US",
  },
  {
    value: "ESRI:103118",
    label:
      "ESRI:103118 / NAD_1983_2011_StatePlane_New_York_Central_FIPS_3102_Ft_US",
  },
  {
    value: "ESRI:103119",
    label:
      "ESRI:103119 / NAD_1983_2011_StatePlane_New_York_West_FIPS_3103_Ft_US",
  },
  {
    value: "ESRI:103120",
    label:
      "ESRI:103120 / NAD_1983_2011_StatePlane_New_York_Long_Isl_FIPS_3104_Ft_US",
  },
  {
    value: "ESRI:103121",
    label: "ESRI:103121 / NAD_1983_2011_StatePlane_North_Carolina_FIPS_3200",
  },
  {
    value: "ESRI:103122",
    label:
      "ESRI:103122 / NAD_1983_2011_StatePlane_North_Carolina_FIPS_3200_Ft_US",
  },
  {
    value: "ESRI:103123",
    label:
      "ESRI:103123 / NAD_1983_2011_StatePlane_North_Dakota_North_FIPS_3301",
  },
  {
    value: "ESRI:103124",
    label:
      "ESRI:103124 / NAD_1983_2011_StatePlane_North_Dakota_South_FIPS_3302",
  },
  {
    value: "ESRI:103125",
    label:
      "ESRI:103125 / NAD_1983_2011_StatePlane_North_Dakota_North_FIPS_3301_FtI",
  },
  {
    value: "ESRI:103126",
    label:
      "ESRI:103126 / NAD_1983_2011_StatePlane_North_Dakota_South_FIPS_3302_FtI",
  },
  {
    value: "ESRI:103127",
    label: "ESRI:103127 / NAD_1983_2011_StatePlane_Ohio_North_FIPS_3401",
  },
  {
    value: "ESRI:103128",
    label: "ESRI:103128 / NAD_1983_2011_StatePlane_Ohio_South_FIPS_3402",
  },
  {
    value: "ESRI:103129",
    label: "ESRI:103129 / NAD_1983_2011_StatePlane_Ohio_North_FIPS_3401_Ft_US",
  },
  {
    value: "ESRI:103130",
    label: "ESRI:103130 / NAD_1983_2011_StatePlane_Ohio_South_FIPS_3402_Ft_US",
  },
  {
    value: "ESRI:103131",
    label: "ESRI:103131 / NAD_1983_2011_StatePlane_Oklahoma_North_FIPS_3501",
  },
  {
    value: "ESRI:103132",
    label: "ESRI:103132 / NAD_1983_2011_StatePlane_Oklahoma_South_FIPS_3502",
  },
  {
    value: "ESRI:103133",
    label:
      "ESRI:103133 / NAD_1983_2011_StatePlane_Oklahoma_North_FIPS_3501_Ft_US",
  },
  {
    value: "ESRI:103134",
    label:
      "ESRI:103134 / NAD_1983_2011_StatePlane_Oklahoma_South_FIPS_3502_Ft_US",
  },
  {
    value: "ESRI:103135",
    label: "ESRI:103135 / NAD_1983_2011_StatePlane_Oregon_North_FIPS_3601",
  },
  {
    value: "ESRI:103136",
    label: "ESRI:103136 / NAD_1983_2011_StatePlane_Oregon_South_FIPS_3602",
  },
  {
    value: "ESRI:103137",
    label:
      "ESRI:103137 / NAD_1983_2011_StatePlane_Oregon_North_FIPS_3601_Ft_Intl",
  },
  {
    value: "ESRI:103138",
    label:
      "ESRI:103138 / NAD_1983_2011_StatePlane_Oregon_South_FIPS_3602_Ft_Intl",
  },
  {
    value: "ESRI:103139",
    label:
      "ESRI:103139 / NAD_1983_2011_StatePlane_Pennsylvania_North_FIPS_3701",
  },
  {
    value: "ESRI:103140",
    label:
      "ESRI:103140 / NAD_1983_2011_StatePlane_Pennsylvania_North_FIPS_3701_Ft_US",
  },
  {
    value: "ESRI:103141",
    label:
      "ESRI:103141 / NAD_1983_2011_StatePlane_Pennsylvania_South_FIPS_3702",
  },
  {
    value: "ESRI:103142",
    label:
      "ESRI:103142 / NAD_1983_2011_StatePlane_Pennsylvania_South_FIPS_3702_Ft_US",
  },
  {
    value: "ESRI:103143",
    label: "ESRI:103143 / NAD_1983_2011_StatePlane_Rhode_Island_FIPS_3800",
  },
  {
    value: "ESRI:103144",
    label:
      "ESRI:103144 / NAD_1983_2011_StatePlane_Rhode_Island_FIPS_3800_Ft_US",
  },
  {
    value: "ESRI:103145",
    label: "ESRI:103145 / NAD_1983_2011_StatePlane_South_Carolina_FIPS_3900",
  },
  {
    value: "ESRI:103146",
    label:
      "ESRI:103146 / NAD_1983_2011_StatePlane_South_Carolina_FIPS_3900_Ft_Intl",
  },
  {
    value: "ESRI:103147",
    label:
      "ESRI:103147 / NAD_1983_2011_StatePlane_South_Dakota_North_FIPS_4001",
  },
  {
    value: "ESRI:103148",
    label:
      "ESRI:103148 / NAD_1983_2011_StatePlane_South_Dakota_South_FIPS_4002",
  },
  {
    value: "ESRI:103149",
    label:
      "ESRI:103149 / NAD_1983_2011_StatePlane_South_Dakota_North_FIPS_4001_Ft_US",
  },
  {
    value: "ESRI:103150",
    label:
      "ESRI:103150 / NAD_1983_2011_StatePlane_South_Dakota_South_FIPS_4002_Ft_US",
  },
  {
    value: "ESRI:103151",
    label: "ESRI:103151 / NAD_1983_2011_StatePlane_Tennessee_FIPS_4100",
  },
  {
    value: "ESRI:103152",
    label: "ESRI:103152 / NAD_1983_2011_StatePlane_Tennessee_FIPS_4100_Ft_US",
  },
  {
    value: "ESRI:103153",
    label: "ESRI:103153 / NAD_1983_2011_StatePlane_Texas_North_FIPS_4201",
  },
  {
    value: "ESRI:103154",
    label:
      "ESRI:103154 / NAD_1983_2011_StatePlane_Texas_North_Central_FIPS_4202",
  },
  {
    value: "ESRI:103155",
    label: "ESRI:103155 / NAD_1983_2011_StatePlane_Texas_Central_FIPS_4203",
  },
  {
    value: "ESRI:103156",
    label:
      "ESRI:103156 / NAD_1983_2011_StatePlane_Texas_South_Central_FIPS_4204",
  },
  {
    value: "ESRI:103157",
    label: "ESRI:103157 / NAD_1983_2011_StatePlane_Texas_South_FIPS_4205",
  },
  {
    value: "ESRI:103158",
    label: "ESRI:103158 / NAD_1983_2011_StatePlane_Texas_North_FIPS_4201_Ft_US",
  },
  {
    value: "ESRI:103159",
    label:
      "ESRI:103159 / NAD_1983_2011_StatePlane_Texas_North_Central_FIPS_4202_FtUS",
  },
  {
    value: "ESRI:103160",
    label:
      "ESRI:103160 / NAD_1983_2011_StatePlane_Texas_Central_FIPS_4203_Ft_US",
  },
  {
    value: "ESRI:103161",
    label:
      "ESRI:103161 / NAD_1983_2011_StatePlane_Texas_South_Central_FIPS_4204_FtUS",
  },
  {
    value: "ESRI:103162",
    label: "ESRI:103162 / NAD_1983_2011_StatePlane_Texas_South_FIPS_4205_Ft_US",
  },
  {
    value: "ESRI:103163",
    label: "ESRI:103163 / NAD_1983_2011_StatePlane_Utah_North_FIPS_4301",
  },
  {
    value: "ESRI:103164",
    label: "ESRI:103164 / NAD_1983_2011_StatePlane_Utah_Central_FIPS_4302",
  },
  {
    value: "ESRI:103165",
    label: "ESRI:103165 / NAD_1983_2011_StatePlane_Utah_South_FIPS_4303",
  },
  {
    value: "ESRI:103166",
    label:
      "ESRI:103166 / NAD_1983_2011_StatePlane_Utah_North_FIPS_4301_Ft_Intl",
  },
  {
    value: "ESRI:103167",
    label:
      "ESRI:103167 / NAD_1983_2011_StatePlane_Utah_Central_FIPS_4302_Ft_Intl",
  },
  {
    value: "ESRI:103168",
    label:
      "ESRI:103168 / NAD_1983_2011_StatePlane_Utah_South_FIPS_4303_Ft_Intl",
  },
  {
    value: "ESRI:103169",
    label: "ESRI:103169 / NAD_1983_2011_StatePlane_Utah_North_FIPS_4301_Ft_US",
  },
  {
    value: "ESRI:103170",
    label:
      "ESRI:103170 / NAD_1983_2011_StatePlane_Utah_Central_FIPS_4302_Ft_US",
  },
  {
    value: "ESRI:103171",
    label: "ESRI:103171 / NAD_1983_2011_StatePlane_Utah_South_FIPS_4303_Ft_US",
  },
  {
    value: "ESRI:103172",
    label: "ESRI:103172 / NAD_1983_2011_StatePlane_Vermont_FIPS_4400",
  },
  {
    value: "ESRI:103173",
    label: "ESRI:103173 / NAD_1983_2011_StatePlane_Vermont_FIPS_4400_Ft_US",
  },
  {
    value: "ESRI:103174",
    label: "ESRI:103174 / NAD_1983_2011_StatePlane_Virginia_North_FIPS_4501",
  },
  {
    value: "ESRI:103175",
    label: "ESRI:103175 / NAD_1983_2011_StatePlane_Virginia_South_FIPS_4502",
  },
  {
    value: "ESRI:103176",
    label:
      "ESRI:103176 / NAD_1983_2011_StatePlane_Virginia_North_FIPS_4501_Ft_US",
  },
  {
    value: "ESRI:103177",
    label:
      "ESRI:103177 / NAD_1983_2011_StatePlane_Virginia_South_FIPS_4502_Ft_US",
  },
  {
    value: "ESRI:103178",
    label: "ESRI:103178 / NAD_1983_2011_StatePlane_Washington_North_FIPS_4601",
  },
  {
    value: "ESRI:103179",
    label: "ESRI:103179 / NAD_1983_2011_StatePlane_Washington_South_FIPS_4602",
  },
  {
    value: "ESRI:103180",
    label:
      "ESRI:103180 / NAD_1983_2011_StatePlane_Washington_North_FIPS_4601_Ft_US",
  },
  {
    value: "ESRI:103181",
    label:
      "ESRI:103181 / NAD_1983_2011_StatePlane_Washington_South_FIPS_4602_Ft_US",
  },
  {
    value: "ESRI:103182",
    label:
      "ESRI:103182 / NAD_1983_2011_StatePlane_West_Virginia_North_FIPS_4701",
  },
  {
    value: "ESRI:103183",
    label:
      "ESRI:103183 / NAD_1983_2011_StatePlane_West_Virginia_South_FIPS_4702",
  },
  {
    value: "ESRI:103184",
    label:
      "ESRI:103184 / NAD_1983_2011_StatePlane_West_Virginia_North_FIPS_4701_FtUS",
  },
  {
    value: "ESRI:103185",
    label:
      "ESRI:103185 / NAD_1983_2011_StatePlane_West_Virginia_South_FIPS_4702_FtUS",
  },
  {
    value: "ESRI:103186",
    label: "ESRI:103186 / NAD_1983_2011_StatePlane_Wisconsin_North_FIPS_4801",
  },
  {
    value: "ESRI:103187",
    label: "ESRI:103187 / NAD_1983_2011_StatePlane_Wisconsin_Central_FIPS_4802",
  },
  {
    value: "ESRI:103188",
    label: "ESRI:103188 / NAD_1983_2011_StatePlane_Wisconsin_South_FIPS_4803",
  },
  {
    value: "ESRI:103189",
    label:
      "ESRI:103189 / NAD_1983_2011_StatePlane_Wisconsin_North_FIPS_4801_Ft_US",
  },
  {
    value: "ESRI:103190",
    label:
      "ESRI:103190 / NAD_1983_2011_StatePlane_Wisconsin_Central_FIPS_4802_Ft_US",
  },
  {
    value: "ESRI:103191",
    label:
      "ESRI:103191 / NAD_1983_2011_StatePlane_Wisconsin_South_FIPS_4803_Ft_US",
  },
  {
    value: "ESRI:103192",
    label: "ESRI:103192 / NAD_1983_2011_StatePlane_Wyoming_East_FIPS_4901",
  },
  {
    value: "ESRI:103193",
    label:
      "ESRI:103193 / NAD_1983_2011_StatePlane_Wyoming_East_Central_FIPS_4902",
  },
  {
    value: "ESRI:103194",
    label:
      "ESRI:103194 / NAD_1983_2011_StatePlane_Wyoming_West_Central_FIPS_4903",
  },
  {
    value: "ESRI:103195",
    label: "ESRI:103195 / NAD_1983_2011_StatePlane_Wyoming_West_FIPS_4904",
  },
  {
    value: "ESRI:103196",
    label:
      "ESRI:103196 / NAD_1983_2011_StatePlane_Wyoming_East_FIPS_4901_Ft_US",
  },
  {
    value: "ESRI:103197",
    label:
      "ESRI:103197 / NAD_1983_2011_StatePlane_Wyoming_E_Central_FIPS_4902_Ft_US",
  },
  {
    value: "ESRI:103198",
    label:
      "ESRI:103198 / NAD_1983_2011_StatePlane_Wyoming_W_Central_FIPS_4903_Ft_US",
  },
  {
    value: "ESRI:103199",
    label:
      "ESRI:103199 / NAD_1983_2011_StatePlane_Wyoming_West_FIPS_4904_Ft_US",
  },
  {
    value: "ESRI:103200",
    label:
      "ESRI:103200 / NAD_1983_2011_StatePlane_Puerto_Rico_Virgin_Isls_FIPS_5200",
  },
  { value: "ESRI:103201", label: "ESRI:103201 / RGRDC_2005_Congo_TM_Zone_12" },
  { value: "ESRI:103202", label: "ESRI:103202 / RGRDC_2005_Congo_TM_Zone_14" },
  { value: "ESRI:103203", label: "ESRI:103203 / RGRDC_2005_Congo_TM_Zone_16" },
  { value: "ESRI:103204", label: "ESRI:103204 / RGRDC_2005_Congo_TM_Zone_18" },
  { value: "ESRI:103205", label: "ESRI:103205 / RGRDC_2005_Congo_TM_Zone_20" },
  { value: "ESRI:103206", label: "ESRI:103206 / RGRDC_2005_Congo_TM_Zone_22" },
  { value: "ESRI:103207", label: "ESRI:103207 / RGRDC_2005_Congo_TM_Zone_24" },
  { value: "ESRI:103208", label: "ESRI:103208 / RGRDC_2005_Congo_TM_Zone_26" },
  { value: "ESRI:103209", label: "ESRI:103209 / RGRDC_2005_Congo_TM_Zone_28" },
  { value: "ESRI:103210", label: "ESRI:103210 / RGRDC_2005_UTM_Zone_33S" },
  { value: "ESRI:103211", label: "ESRI:103211 / RGRDC_2005_UTM_Zone_34S" },
  { value: "ESRI:103212", label: "ESRI:103212 / RGRDC_2005_UTM_Zone_35S" },
  { value: "ESRI:103213", label: "ESRI:103213 / Chua_UTM_Zone_23S" },
  { value: "ESRI:103214", label: "ESRI:103214 / REGCAN95_UTM_Zone_27N" },
  { value: "ESRI:103215", label: "ESRI:103215 / REGCAN95_UTM_Zone_28N" },
  { value: "ESRI:103216", label: "ESRI:103216 / ETRS_1989_DKTM1" },
  { value: "ESRI:103217", label: "ESRI:103217 / ETRS_1989_DKTM2" },
  { value: "ESRI:103218", label: "ESRI:103218 / ETRS_1989_DKTM3" },
  { value: "ESRI:103219", label: "ESRI:103219 / ETRS_1989_DKTM4" },
  {
    value: "ESRI:103220",
    label: "ESRI:103220 / NAD_1983_CORS96_StatePlane_Alabama_East_FIPS_0101",
  },
  {
    value: "ESRI:103221",
    label: "ESRI:103221 / NAD_1983_CORS96_StatePlane_Alabama_West_FIPS_0102",
  },
  {
    value: "ESRI:103222",
    label: "ESRI:103222 / NAD_1983_CORS96_StatePlane_Arizona_East_FIPS_0201",
  },
  {
    value: "ESRI:103223",
    label: "ESRI:103223 / NAD_1983_CORS96_StatePlane_Arizona_Central_FIPS_0202",
  },
  {
    value: "ESRI:103224",
    label: "ESRI:103224 / NAD_1983_CORS96_StatePlane_Arizona_West_FIPS_0203",
  },
  {
    value: "ESRI:103225",
    label:
      "ESRI:103225 / NAD_1983_CORS96_StatePlane_Arizona_East_FIPS_0201_Ft_Intl",
  },
  {
    value: "ESRI:103226",
    label:
      "ESRI:103226 / NAD_1983_CORS96_StatePlane_Arizona_Central_FIPS_0202_Ft_Intl",
  },
  {
    value: "ESRI:103227",
    label:
      "ESRI:103227 / NAD_1983_CORS96_StatePlane_Arizona_West_FIPS_0203_Ft_Intl",
  },
  {
    value: "ESRI:103228",
    label: "ESRI:103228 / NAD_1983_CORS96_StatePlane_Arkansas_North_FIPS_0301",
  },
  {
    value: "ESRI:103229",
    label: "ESRI:103229 / NAD_1983_CORS96_StatePlane_Arkansas_South_FIPS_0302",
  },
  {
    value: "ESRI:103230",
    label:
      "ESRI:103230 / NAD_1983_CORS96_StatePlane_Arkansas_North_FIPS_0301_Ft_US",
  },
  {
    value: "ESRI:103231",
    label:
      "ESRI:103231 / NAD_1983_CORS96_StatePlane_Arkansas_South_FIPS_0302_Ft_US",
  },
  {
    value: "ESRI:103232",
    label: "ESRI:103232 / NAD_1983_CORS96_StatePlane_California_I_FIPS_0401",
  },
  {
    value: "ESRI:103233",
    label: "ESRI:103233 / NAD_1983_CORS96_StatePlane_California_II_FIPS_0402",
  },
  {
    value: "ESRI:103234",
    label: "ESRI:103234 / NAD_1983_CORS96_StatePlane_California_III_FIPS_0403",
  },
  {
    value: "ESRI:103235",
    label: "ESRI:103235 / NAD_1983_CORS96_StatePlane_California_IV_FIPS_0404",
  },
  {
    value: "ESRI:103236",
    label: "ESRI:103236 / NAD_1983_CORS96_StatePlane_California_V_FIPS_0405",
  },
  {
    value: "ESRI:103237",
    label: "ESRI:103237 / NAD_1983_CORS96_StatePlane_California_VI_FIPS_0406",
  },
  {
    value: "ESRI:103238",
    label:
      "ESRI:103238 / NAD_1983_CORS96_StatePlane_California_I_FIPS_0401_Ft_US",
  },
  {
    value: "ESRI:103239",
    label:
      "ESRI:103239 / NAD_1983_CORS96_StatePlane_California_II_FIPS_0402_Ft_US",
  },
  {
    value: "ESRI:103240",
    label:
      "ESRI:103240 / NAD_1983_CORS96_StatePlane_California_III_FIPS_0403_Ft_US",
  },
  {
    value: "ESRI:103241",
    label:
      "ESRI:103241 / NAD_1983_CORS96_StatePlane_California_IV_FIPS_0404_Ft_US",
  },
  {
    value: "ESRI:103242",
    label:
      "ESRI:103242 / NAD_1983_CORS96_StatePlane_California_V_FIPS_0405_Ft_US",
  },
  {
    value: "ESRI:103243",
    label:
      "ESRI:103243 / NAD_1983_CORS96_StatePlane_California_VI_FIPS_0406_Ft_US",
  },
  {
    value: "ESRI:103244",
    label: "ESRI:103244 / NAD_1983_CORS96_StatePlane_Colorado_North_FIPS_0501",
  },
  {
    value: "ESRI:103245",
    label:
      "ESRI:103245 / NAD_1983_CORS96_StatePlane_Colorado_Central_FIPS_0502",
  },
  {
    value: "ESRI:103246",
    label: "ESRI:103246 / NAD_1983_CORS96_StatePlane_Colorado_South_FIPS_0503",
  },
  {
    value: "ESRI:103247",
    label:
      "ESRI:103247 / NAD_1983_CORS96_StatePlane_Colorado_North_FIPS_0501_Ft_US",
  },
  {
    value: "ESRI:103248",
    label:
      "ESRI:103248 / NAD_1983_CORS96_StatePlane_Colorado_Central_FIPS_0502_Ft_US",
  },
  {
    value: "ESRI:103249",
    label:
      "ESRI:103249 / NAD_1983_CORS96_StatePlane_Colorado_South_FIPS_0503_Ft_US",
  },
  {
    value: "ESRI:103250",
    label: "ESRI:103250 / NAD_1983_CORS96_StatePlane_Connecticut_FIPS_0600",
  },
  {
    value: "ESRI:103251",
    label:
      "ESRI:103251 / NAD_1983_CORS96_StatePlane_Connecticut_FIPS_0600_Ft_US",
  },
  {
    value: "ESRI:103252",
    label: "ESRI:103252 / NAD_1983_CORS96_StatePlane_Delaware_FIPS_0700",
  },
  {
    value: "ESRI:103253",
    label: "ESRI:103253 / NAD_1983_CORS96_StatePlane_Delaware_FIPS_0700_Ft_US",
  },
  {
    value: "ESRI:103254",
    label: "ESRI:103254 / NAD_1983_CORS96_StatePlane_Florida_East_FIPS_0901",
  },
  {
    value: "ESRI:103255",
    label: "ESRI:103255 / NAD_1983_CORS96_StatePlane_Florida_West_FIPS_0902",
  },
  {
    value: "ESRI:103256",
    label: "ESRI:103256 / NAD_1983_CORS96_StatePlane_Florida_North_FIPS_0903",
  },
  {
    value: "ESRI:103257",
    label:
      "ESRI:103257 / NAD_1983_CORS96_StatePlane_Florida_East_FIPS_0901_Ft_US",
  },
  {
    value: "ESRI:103258",
    label:
      "ESRI:103258 / NAD_1983_CORS96_StatePlane_Florida_West_FIPS_0902_Ft_US",
  },
  {
    value: "ESRI:103259",
    label:
      "ESRI:103259 / NAD_1983_CORS96_StatePlane_Florida_North_FIPS_0903_Ft_US",
  },
  {
    value: "ESRI:103260",
    label: "ESRI:103260 / NAD_1983_CORS96_StatePlane_Georgia_East_FIPS_1001",
  },
  {
    value: "ESRI:103261",
    label: "ESRI:103261 / NAD_1983_CORS96_StatePlane_Georgia_West_FIPS_1002",
  },
  {
    value: "ESRI:103262",
    label:
      "ESRI:103262 / NAD_1983_CORS96_StatePlane_Georgia_East_FIPS_1001_Ft_US",
  },
  {
    value: "ESRI:103263",
    label:
      "ESRI:103263 / NAD_1983_CORS96_StatePlane_Georgia_West_FIPS_1002_Ft_US",
  },
  {
    value: "ESRI:103264",
    label: "ESRI:103264 / NAD_1983_CORS96_StatePlane_Idaho_East_FIPS_1101",
  },
  {
    value: "ESRI:103265",
    label: "ESRI:103265 / NAD_1983_CORS96_StatePlane_Idaho_Central_FIPS_1102",
  },
  {
    value: "ESRI:103266",
    label: "ESRI:103266 / NAD_1983_CORS96_StatePlane_Idaho_West_FIPS_1103",
  },
  {
    value: "ESRI:103267",
    label:
      "ESRI:103267 / NAD_1983_CORS96_StatePlane_Idaho_East_FIPS_1101_Ft_US",
  },
  {
    value: "ESRI:103268",
    label:
      "ESRI:103268 / NAD_1983_CORS96_StatePlane_Idaho_Central_FIPS_1102_Ft_US",
  },
  {
    value: "ESRI:103269",
    label:
      "ESRI:103269 / NAD_1983_CORS96_StatePlane_Idaho_West_FIPS_1103_Ft_US",
  },
  {
    value: "ESRI:103270",
    label: "ESRI:103270 / NAD_1983_CORS96_StatePlane_Illinois_East_FIPS_1201",
  },
  {
    value: "ESRI:103271",
    label: "ESRI:103271 / NAD_1983_CORS96_StatePlane_Illinois_West_FIPS_1202",
  },
  {
    value: "ESRI:103272",
    label:
      "ESRI:103272 / NAD_1983_CORS96_StatePlane_Illinois_East_FIPS_1201_Ft_US",
  },
  {
    value: "ESRI:103273",
    label:
      "ESRI:103273 / NAD_1983_CORS96_StatePlane_Illinois_West_FIPS_1202_Ft_US",
  },
  {
    value: "ESRI:103274",
    label: "ESRI:103274 / NAD_1983_CORS96_StatePlane_Indiana_East_FIPS_1301",
  },
  {
    value: "ESRI:103275",
    label: "ESRI:103275 / NAD_1983_CORS96_StatePlane_Indiana_West_FIPS_1302",
  },
  {
    value: "ESRI:103276",
    label:
      "ESRI:103276 / NAD_1983_CORS96_StatePlane_Indiana_East_FIPS_1301_Ft_US",
  },
  {
    value: "ESRI:103277",
    label:
      "ESRI:103277 / NAD_1983_CORS96_StatePlane_Indiana_West_FIPS_1302_Ft_US",
  },
  {
    value: "ESRI:103278",
    label: "ESRI:103278 / NAD_1983_CORS96_StatePlane_Iowa_North_FIPS_1401",
  },
  {
    value: "ESRI:103279",
    label: "ESRI:103279 / NAD_1983_CORS96_StatePlane_Iowa_South_FIPS_1402",
  },
  {
    value: "ESRI:103280",
    label:
      "ESRI:103280 / NAD_1983_CORS96_StatePlane_Iowa_North_FIPS_1401_Ft_US",
  },
  {
    value: "ESRI:103281",
    label:
      "ESRI:103281 / NAD_1983_CORS96_StatePlane_Iowa_South_FIPS_1402_Ft_US",
  },
  {
    value: "ESRI:103282",
    label: "ESRI:103282 / NAD_1983_CORS96_StatePlane_Kansas_North_FIPS_1501",
  },
  {
    value: "ESRI:103283",
    label: "ESRI:103283 / NAD_1983_CORS96_StatePlane_Kansas_South_FIPS_1502",
  },
  {
    value: "ESRI:103284",
    label:
      "ESRI:103284 / NAD_1983_CORS96_StatePlane_Kansas_North_FIPS_1501_Ft_US",
  },
  {
    value: "ESRI:103285",
    label:
      "ESRI:103285 / NAD_1983_CORS96_StatePlane_Kansas_South_FIPS_1502_Ft_US",
  },
  {
    value: "ESRI:103286",
    label: "ESRI:103286 / NAD_1983_CORS96_StatePlane_Kentucky_North_FIPS_1601",
  },
  {
    value: "ESRI:103287",
    label:
      "ESRI:103287 / NAD_1983_CORS96_StatePlane_Kentucky_North_FIPS_1601_Ft_US",
  },
  {
    value: "ESRI:103288",
    label: "ESRI:103288 / NAD_1983_CORS96_StatePlane_Kentucky_FIPS_1600",
  },
  {
    value: "ESRI:103289",
    label: "ESRI:103289 / NAD_1983_CORS96_StatePlane_Kentucky_FIPS_1600_Ft_US",
  },
  {
    value: "ESRI:103290",
    label: "ESRI:103290 / NAD_1983_CORS96_StatePlane_Kentucky_South_FIPS_1602",
  },
  {
    value: "ESRI:103291",
    label:
      "ESRI:103291 / NAD_1983_CORS96_StatePlane_Kentucky_South_FIPS_1602_Ft_US",
  },
  {
    value: "ESRI:103292",
    label: "ESRI:103292 / NAD_1983_CORS96_StatePlane_Louisiana_North_FIPS_1701",
  },
  {
    value: "ESRI:103293",
    label: "ESRI:103293 / NAD_1983_CORS96_StatePlane_Louisiana_South_FIPS_1702",
  },
  {
    value: "ESRI:103294",
    label:
      "ESRI:103294 / NAD_1983_CORS96_StatePlane_Louisiana_North_FIPS_1701_Ft_US",
  },
  {
    value: "ESRI:103295",
    label:
      "ESRI:103295 / NAD_1983_CORS96_StatePlane_Louisiana_South_FIPS_1702_Ft_US",
  },
  {
    value: "ESRI:103296",
    label: "ESRI:103296 / NAD_1983_CORS96_StatePlane_Maine_East_FIPS_1801",
  },
  {
    value: "ESRI:103297",
    label: "ESRI:103297 / NAD_1983_CORS96_StatePlane_Maine_West_FIPS_1802",
  },
  {
    value: "ESRI:103298",
    label:
      "ESRI:103298 / NAD_1983_CORS96_StatePlane_Maine_East_FIPS_1801_Ft_US",
  },
  {
    value: "ESRI:103299",
    label:
      "ESRI:103299 / NAD_1983_CORS96_StatePlane_Maine_West_FIPS_1802_Ft_US",
  },
  {
    value: "ESRI:103300",
    label: "ESRI:103300 / NAD_1983_HARN_WISCRS_Adams_County_Meters",
  },
  {
    value: "ESRI:103301",
    label: "ESRI:103301 / NAD_1983_HARN_WISCRS_Ashland_County_Meters",
  },
  {
    value: "ESRI:103302",
    label: "ESRI:103302 / NAD_1983_HARN_WISCRS_Barron_County_Meters",
  },
  {
    value: "ESRI:103303",
    label: "ESRI:103303 / NAD_1983_HARN_WISCRS_Bayfield_County_Meters",
  },
  {
    value: "ESRI:103304",
    label: "ESRI:103304 / NAD_1983_HARN_WISCRS_Brown_County_Meters",
  },
  {
    value: "ESRI:103305",
    label: "ESRI:103305 / NAD_1983_HARN_WISCRS_Buffalo_County_Meters",
  },
  {
    value: "ESRI:103306",
    label: "ESRI:103306 / NAD_1983_HARN_WISCRS_Burnett_County_Meters",
  },
  {
    value: "ESRI:103307",
    label: "ESRI:103307 / NAD_1983_HARN_WISCRS_Calumet_County_Meters",
  },
  {
    value: "ESRI:103308",
    label: "ESRI:103308 / NAD_1983_HARN_WISCRS_Chippewa_County_Meters",
  },
  {
    value: "ESRI:103309",
    label: "ESRI:103309 / NAD_1983_HARN_WISCRS_Clark_County_Meters",
  },
  {
    value: "ESRI:103310",
    label: "ESRI:103310 / NAD_1983_HARN_WISCRS_Columbia_County_Meters",
  },
  {
    value: "ESRI:103311",
    label: "ESRI:103311 / NAD_1983_HARN_WISCRS_Crawford_County_Meters",
  },
  {
    value: "ESRI:103312",
    label: "ESRI:103312 / NAD_1983_HARN_WISCRS_Dane_County_Meters",
  },
  {
    value: "ESRI:103313",
    label: "ESRI:103313 / NAD_1983_HARN_WISCRS_Dodge_County_Meters",
  },
  {
    value: "ESRI:103314",
    label: "ESRI:103314 / NAD_1983_HARN_WISCRS_Door_County_Meters",
  },
  {
    value: "ESRI:103315",
    label: "ESRI:103315 / NAD_1983_HARN_WISCRS_Douglas_County_Meters",
  },
  {
    value: "ESRI:103316",
    label: "ESRI:103316 / NAD_1983_HARN_WISCRS_Dunn_County_Meters",
  },
  {
    value: "ESRI:103317",
    label: "ESRI:103317 / NAD_1983_HARN_WISCRS_EauClaire_County_Meters",
  },
  {
    value: "ESRI:103318",
    label: "ESRI:103318 / NAD_1983_HARN_WISCRS_Florence_County_Meters",
  },
  {
    value: "ESRI:103319",
    label: "ESRI:103319 / NAD_1983_HARN_WISCRS_Fond_du_Lac_County_Meters",
  },
  {
    value: "ESRI:103320",
    label: "ESRI:103320 / NAD_1983_HARN_WISCRS_Forest_County_Meters",
  },
  {
    value: "ESRI:103321",
    label: "ESRI:103321 / NAD_1983_HARN_WISCRS_Grant_County_Meters",
  },
  {
    value: "ESRI:103322",
    label: "ESRI:103322 / NAD_1983_HARN_WISCRS_Green_County_Meters",
  },
  {
    value: "ESRI:103323",
    label: "ESRI:103323 / NAD_1983_HARN_WISCRS_GreenLake_County_Meters",
  },
  {
    value: "ESRI:103324",
    label: "ESRI:103324 / NAD_1983_HARN_WISCRS_Iowa_County_Meters",
  },
  {
    value: "ESRI:103325",
    label: "ESRI:103325 / NAD_1983_HARN_WISCRS_Iron_County_Meters",
  },
  {
    value: "ESRI:103326",
    label: "ESRI:103326 / NAD_1983_HARN_WISCRS_Jackson_County_Meters",
  },
  {
    value: "ESRI:103327",
    label: "ESRI:103327 / NAD_1983_HARN_WISCRS_Jefferson_County_Meters",
  },
  {
    value: "ESRI:103328",
    label: "ESRI:103328 / NAD_1983_HARN_WISCRS_Juneau_County_Meters",
  },
  {
    value: "ESRI:103329",
    label: "ESRI:103329 / NAD_1983_HARN_WISCRS_Kenosha_County_Meters",
  },
  {
    value: "ESRI:103330",
    label: "ESRI:103330 / NAD_1983_HARN_WISCRS_Kewaunee_County_Meters",
  },
  {
    value: "ESRI:103331",
    label: "ESRI:103331 / NAD_1983_HARN_WISCRS_LaCrosse_County_Meters",
  },
  {
    value: "ESRI:103332",
    label: "ESRI:103332 / NAD_1983_HARN_WISCRS_Lafayette_County_Meters",
  },
  {
    value: "ESRI:103333",
    label: "ESRI:103333 / NAD_1983_HARN_WISCRS_Langlade_County_Meters",
  },
  {
    value: "ESRI:103334",
    label: "ESRI:103334 / NAD_1983_HARN_WISCRS_Lincoln_County_Meters",
  },
  {
    value: "ESRI:103335",
    label: "ESRI:103335 / NAD_1983_HARN_WISCRS_Manitowoc_County_Meters",
  },
  {
    value: "ESRI:103336",
    label: "ESRI:103336 / NAD_1983_HARN_WISCRS_Marathon_County_Meters",
  },
  {
    value: "ESRI:103337",
    label: "ESRI:103337 / NAD_1983_HARN_WISCRS_Marinette_County_Meters",
  },
  {
    value: "ESRI:103338",
    label: "ESRI:103338 / NAD_1983_HARN_WISCRS_Marquette_County_Meters",
  },
  {
    value: "ESRI:103339",
    label: "ESRI:103339 / NAD_1983_HARN_WISCRS_Menominee_County_Meters",
  },
  {
    value: "ESRI:103340",
    label: "ESRI:103340 / NAD_1983_HARN_WISCRS_Milwaukee_County_Meters",
  },
  {
    value: "ESRI:103341",
    label: "ESRI:103341 / NAD_1983_HARN_WISCRS_Monroe_County_Meters",
  },
  {
    value: "ESRI:103342",
    label: "ESRI:103342 / NAD_1983_HARN_WISCRS_Oconto_County_Meters",
  },
  {
    value: "ESRI:103343",
    label: "ESRI:103343 / NAD_1983_HARN_WISCRS_Oneida_County_Meters",
  },
  {
    value: "ESRI:103344",
    label: "ESRI:103344 / NAD_1983_HARN_WISCRS_Outagamie_County_Meters",
  },
  {
    value: "ESRI:103345",
    label: "ESRI:103345 / NAD_1983_HARN_WISCRS_Ozaukee_County_Meters",
  },
  {
    value: "ESRI:103346",
    label: "ESRI:103346 / NAD_1983_HARN_WISCRS_Pepin_County_Meters",
  },
  {
    value: "ESRI:103347",
    label: "ESRI:103347 / NAD_1983_HARN_WISCRS_Pierce_County_Meters",
  },
  {
    value: "ESRI:103348",
    label: "ESRI:103348 / NAD_1983_HARN_WISCRS_Polk_County_Meters",
  },
  {
    value: "ESRI:103349",
    label: "ESRI:103349 / NAD_1983_HARN_WISCRS_Portage_County_Meters",
  },
  {
    value: "ESRI:103350",
    label: "ESRI:103350 / NAD_1983_HARN_WISCRS_Price_County_Meters",
  },
  {
    value: "ESRI:103351",
    label: "ESRI:103351 / NAD_1983_HARN_WISCRS_Racine_County_Meters",
  },
  {
    value: "ESRI:103352",
    label: "ESRI:103352 / NAD_1983_HARN_WISCRS_Richland_County_Meters",
  },
  {
    value: "ESRI:103353",
    label: "ESRI:103353 / NAD_1983_HARN_WISCRS_Rock_County_Meters",
  },
  {
    value: "ESRI:103354",
    label: "ESRI:103354 / NAD_1983_HARN_WISCRS_Rusk_County_Meters",
  },
  {
    value: "ESRI:103355",
    label: "ESRI:103355 / NAD_1983_HARN_WISCRS_Sauk_County_Meters",
  },
  {
    value: "ESRI:103356",
    label: "ESRI:103356 / NAD_1983_HARN_WISCRS_Sawyer_County_Meters",
  },
  {
    value: "ESRI:103357",
    label: "ESRI:103357 / NAD_1983_HARN_WISCRS_Shawano_County_Meters",
  },
  {
    value: "ESRI:103358",
    label: "ESRI:103358 / NAD_1983_HARN_WISCRS_Sheboygan_County_Meters",
  },
  {
    value: "ESRI:103359",
    label: "ESRI:103359 / NAD_1983_HARN_WISCRS_St_Croix_County_Meters",
  },
  {
    value: "ESRI:103360",
    label: "ESRI:103360 / NAD_1983_HARN_WISCRS_Taylor_County_Meters",
  },
  {
    value: "ESRI:103361",
    label: "ESRI:103361 / NAD_1983_HARN_WISCRS_Trempealeau_County_Meters",
  },
  {
    value: "ESRI:103362",
    label: "ESRI:103362 / NAD_1983_HARN_WISCRS_Vernon_County_Meters",
  },
  {
    value: "ESRI:103363",
    label: "ESRI:103363 / NAD_1983_HARN_WISCRS_Vilas_County_Meters",
  },
  {
    value: "ESRI:103364",
    label: "ESRI:103364 / NAD_1983_HARN_WISCRS_Walworth_County_Meters",
  },
  {
    value: "ESRI:103365",
    label: "ESRI:103365 / NAD_1983_HARN_WISCRS_Washburn_County_Meters",
  },
  {
    value: "ESRI:103366",
    label: "ESRI:103366 / NAD_1983_HARN_WISCRS_Washington_County_Meters",
  },
  {
    value: "ESRI:103367",
    label: "ESRI:103367 / NAD_1983_HARN_WISCRS_Waukesha_County_Meters",
  },
  {
    value: "ESRI:103368",
    label: "ESRI:103368 / NAD_1983_HARN_WISCRS_Waupaca_County_Meters",
  },
  {
    value: "ESRI:103369",
    label: "ESRI:103369 / NAD_1983_HARN_WISCRS_Waushara_County_Meters",
  },
  {
    value: "ESRI:103370",
    label: "ESRI:103370 / NAD_1983_HARN_WISCRS_Winnebago_County_Meters",
  },
  {
    value: "ESRI:103371",
    label: "ESRI:103371 / NAD_1983_HARN_WISCRS_Wood_County_Meters",
  },
  {
    value: "ESRI:103372",
    label: "ESRI:103372 / NAD_1983_CORS96_Maine_2000_East_Zone",
  },
  {
    value: "ESRI:103373",
    label: "ESRI:103373 / NAD_1983_CORS96_Maine_2000_Central_Zone",
  },
  {
    value: "ESRI:103374",
    label: "ESRI:103374 / NAD_1983_CORS96_Maine_2000_West_Zone",
  },
  {
    value: "ESRI:103375",
    label: "ESRI:103375 / NAD_1983_CORS96_StatePlane_Maryland_FIPS_1900",
  },
  {
    value: "ESRI:103376",
    label: "ESRI:103376 / NAD_1983_CORS96_StatePlane_Maryland_FIPS_1900_Ft_US",
  },
  {
    value: "ESRI:103377",
    label:
      "ESRI:103377 / NAD_1983_CORS96_StatePlane_Massachusetts_Mainland_FIPS_2001",
  },
  {
    value: "ESRI:103378",
    label:
      "ESRI:103378 / NAD_1983_CORS96_StatePlane_Massachusetts_Island_FIPS_2002",
  },
  {
    value: "ESRI:103379",
    label:
      "ESRI:103379 / NAD_1983_CORS96_StatePlane_Massachusetts_Mnld_FIPS_2001_FtUS",
  },
  {
    value: "ESRI:103380",
    label:
      "ESRI:103380 / NAD_1983_CORS96_StatePlane_Massachusetts_Isl_FIPS_2002_FtUS",
  },
  {
    value: "ESRI:103381",
    label: "ESRI:103381 / NAD_1983_CORS96_StatePlane_Michigan_North_FIPS_2111",
  },
  {
    value: "ESRI:103382",
    label:
      "ESRI:103382 / NAD_1983_CORS96_StatePlane_Michigan_Central_FIPS_2112",
  },
  {
    value: "ESRI:103383",
    label: "ESRI:103383 / NAD_1983_CORS96_StatePlane_Michigan_South_FIPS_2113",
  },
  {
    value: "ESRI:103384",
    label:
      "ESRI:103384 / NAD_1983_CORS96_StatePlane_Michigan_North_FIPS_2111_Ft_Intl",
  },
  {
    value: "ESRI:103385",
    label:
      "ESRI:103385 / NAD_1983_CORS96_StatePlane_Michigan_Central_FIPS_2112_Ft_Intl",
  },
  {
    value: "ESRI:103386",
    label:
      "ESRI:103386 / NAD_1983_CORS96_StatePlane_Michigan_South_FIPS_2113_Ft_Intl",
  },
  {
    value: "ESRI:103387",
    label: "ESRI:103387 / NAD_1983_CORS96_StatePlane_Minnesota_North_FIPS_2201",
  },
  {
    value: "ESRI:103388",
    label:
      "ESRI:103388 / NAD_1983_CORS96_StatePlane_Minnesota_Central_FIPS_2202",
  },
  {
    value: "ESRI:103389",
    label: "ESRI:103389 / NAD_1983_CORS96_StatePlane_Minnesota_South_FIPS_2203",
  },
  {
    value: "ESRI:103390",
    label:
      "ESRI:103390 / NAD_1983_CORS96_StatePlane_Minnesota_North_FIPS_2201_Ft_US",
  },
  {
    value: "ESRI:103391",
    label:
      "ESRI:103391 / NAD_1983_CORS96_StatePlane_Minnesota_Central_FIPS_2202_Ft_US",
  },
  {
    value: "ESRI:103392",
    label:
      "ESRI:103392 / NAD_1983_CORS96_StatePlane_Minnesota_South_FIPS_2203_Ft_US",
  },
  {
    value: "ESRI:103393",
    label:
      "ESRI:103393 / NAD_1983_CORS96_StatePlane_Mississippi_East_FIPS_2301",
  },
  {
    value: "ESRI:103394",
    label:
      "ESRI:103394 / NAD_1983_CORS96_StatePlane_Mississippi_West_FIPS_2302",
  },
  {
    value: "ESRI:103395",
    label:
      "ESRI:103395 / NAD_1983_CORS96_StatePlane_Mississippi_East_FIPS_2301_Ft_US",
  },
  {
    value: "ESRI:103396",
    label:
      "ESRI:103396 / NAD_1983_CORS96_StatePlane_Mississippi_West_FIPS_2302_Ft_US",
  },
  {
    value: "ESRI:103397",
    label: "ESRI:103397 / NAD_1983_CORS96_StatePlane_Missouri_East_FIPS_2401",
  },
  {
    value: "ESRI:103398",
    label:
      "ESRI:103398 / NAD_1983_CORS96_StatePlane_Missouri_Central_FIPS_2402",
  },
  {
    value: "ESRI:103399",
    label: "ESRI:103399 / NAD_1983_CORS96_StatePlane_Missouri_West_FIPS_2403",
  },
  {
    value: "ESRI:103400",
    label: "ESRI:103400 / NAD_1983_HARN_WISCRS_Adams_County_Feet",
  },
  {
    value: "ESRI:103401",
    label: "ESRI:103401 / NAD_1983_HARN_WISCRS_Ashland_County_Feet",
  },
  {
    value: "ESRI:103402",
    label: "ESRI:103402 / NAD_1983_HARN_WISCRS_Barron_County_Feet",
  },
  {
    value: "ESRI:103403",
    label: "ESRI:103403 / NAD_1983_HARN_WISCRS_Bayfield_County_Feet",
  },
  {
    value: "ESRI:103404",
    label: "ESRI:103404 / NAD_1983_HARN_WISCRS_Brown_County_Feet",
  },
  {
    value: "ESRI:103405",
    label: "ESRI:103405 / NAD_1983_HARN_WISCRS_Buffalo_County_Feet",
  },
  {
    value: "ESRI:103406",
    label: "ESRI:103406 / NAD_1983_HARN_WISCRS_Burnett_County_Feet",
  },
  {
    value: "ESRI:103407",
    label: "ESRI:103407 / NAD_1983_HARN_WISCRS_Calumet_County_Feet",
  },
  {
    value: "ESRI:103408",
    label: "ESRI:103408 / NAD_1983_HARN_WISCRS_Chippewa_County_Feet",
  },
  {
    value: "ESRI:103409",
    label: "ESRI:103409 / NAD_1983_HARN_WISCRS_Clark_County_Feet",
  },
  {
    value: "ESRI:103410",
    label: "ESRI:103410 / NAD_1983_HARN_WISCRS_Columbia_County_Feet",
  },
  {
    value: "ESRI:103411",
    label: "ESRI:103411 / NAD_1983_HARN_WISCRS_Crawford_County_Feet",
  },
  {
    value: "ESRI:103412",
    label: "ESRI:103412 / NAD_1983_HARN_WISCRS_Dane_County_Feet",
  },
  {
    value: "ESRI:103413",
    label: "ESRI:103413 / NAD_1983_HARN_WISCRS_Dodge_County_Feet",
  },
  {
    value: "ESRI:103414",
    label: "ESRI:103414 / NAD_1983_HARN_WISCRS_Door_County_Feet",
  },
  {
    value: "ESRI:103415",
    label: "ESRI:103415 / NAD_1983_HARN_WISCRS_Douglas_County_Feet",
  },
  {
    value: "ESRI:103416",
    label: "ESRI:103416 / NAD_1983_HARN_WISCRS_Dunn_County_Feet",
  },
  {
    value: "ESRI:103417",
    label: "ESRI:103417 / NAD_1983_HARN_WISCRS_EauClaire_County_Feet",
  },
  {
    value: "ESRI:103418",
    label: "ESRI:103418 / NAD_1983_HARN_WISCRS_Florence_County_Feet",
  },
  {
    value: "ESRI:103419",
    label: "ESRI:103419 / NAD_1983_HARN_WISCRS_Fond_du_Lac_County_Feet",
  },
  {
    value: "ESRI:103420",
    label: "ESRI:103420 / NAD_1983_HARN_WISCRS_Forest_County_Feet",
  },
  {
    value: "ESRI:103421",
    label: "ESRI:103421 / NAD_1983_HARN_WISCRS_Grant_County_Feet",
  },
  {
    value: "ESRI:103422",
    label: "ESRI:103422 / NAD_1983_HARN_WISCRS_Green_County_Feet",
  },
  {
    value: "ESRI:103423",
    label: "ESRI:103423 / NAD_1983_HARN_WISCRS_GreenLake_County_Feet",
  },
  {
    value: "ESRI:103424",
    label: "ESRI:103424 / NAD_1983_HARN_WISCRS_Iowa_County_Feet",
  },
  {
    value: "ESRI:103425",
    label: "ESRI:103425 / NAD_1983_HARN_WISCRS_Iron_County_Feet",
  },
  {
    value: "ESRI:103426",
    label: "ESRI:103426 / NAD_1983_HARN_WISCRS_Jackson_County_Feet",
  },
  {
    value: "ESRI:103427",
    label: "ESRI:103427 / NAD_1983_HARN_WISCRS_Jefferson_County_Feet",
  },
  {
    value: "ESRI:103428",
    label: "ESRI:103428 / NAD_1983_HARN_WISCRS_Juneau_County_Feet",
  },
  {
    value: "ESRI:103429",
    label: "ESRI:103429 / NAD_1983_HARN_WISCRS_Kenosha_County_Feet",
  },
  {
    value: "ESRI:103430",
    label: "ESRI:103430 / NAD_1983_HARN_WISCRS_Kewaunee_County_Feet",
  },
  {
    value: "ESRI:103431",
    label: "ESRI:103431 / NAD_1983_HARN_WISCRS_LaCrosse_County_Feet",
  },
  {
    value: "ESRI:103432",
    label: "ESRI:103432 / NAD_1983_HARN_WISCRS_Lafayette_County_Feet",
  },
  {
    value: "ESRI:103433",
    label: "ESRI:103433 / NAD_1983_HARN_WISCRS_Langlade_County_Feet",
  },
  {
    value: "ESRI:103434",
    label: "ESRI:103434 / NAD_1983_HARN_WISCRS_Lincoln_County_Feet",
  },
  {
    value: "ESRI:103435",
    label: "ESRI:103435 / NAD_1983_HARN_WISCRS_Manitowoc_County_Feet",
  },
  {
    value: "ESRI:103436",
    label: "ESRI:103436 / NAD_1983_HARN_WISCRS_Marathon_County_Feet",
  },
  {
    value: "ESRI:103437",
    label: "ESRI:103437 / NAD_1983_HARN_WISCRS_Marinette_County_Feet",
  },
  {
    value: "ESRI:103438",
    label: "ESRI:103438 / NAD_1983_HARN_WISCRS_Marquette_County_Feet",
  },
  {
    value: "ESRI:103439",
    label: "ESRI:103439 / NAD_1983_HARN_WISCRS_Menominee_County_Feet",
  },
  {
    value: "ESRI:103440",
    label: "ESRI:103440 / NAD_1983_HARN_WISCRS_Milwaukee_County_Feet",
  },
  {
    value: "ESRI:103441",
    label: "ESRI:103441 / NAD_1983_HARN_WISCRS_Monroe_County_Feet",
  },
  {
    value: "ESRI:103442",
    label: "ESRI:103442 / NAD_1983_HARN_WISCRS_Oconto_County_Feet",
  },
  {
    value: "ESRI:103443",
    label: "ESRI:103443 / NAD_1983_HARN_WISCRS_Oneida_County_Feet",
  },
  {
    value: "ESRI:103444",
    label: "ESRI:103444 / NAD_1983_HARN_WISCRS_Outagamie_County_Feet",
  },
  {
    value: "ESRI:103445",
    label: "ESRI:103445 / NAD_1983_HARN_WISCRS_Ozaukee_County_Feet",
  },
  {
    value: "ESRI:103446",
    label: "ESRI:103446 / NAD_1983_HARN_WISCRS_Pepin_County_Feet",
  },
  {
    value: "ESRI:103447",
    label: "ESRI:103447 / NAD_1983_HARN_WISCRS_Pierce_County_Feet",
  },
  {
    value: "ESRI:103448",
    label: "ESRI:103448 / NAD_1983_HARN_WISCRS_Polk_County_Feet",
  },
  {
    value: "ESRI:103449",
    label: "ESRI:103449 / NAD_1983_HARN_WISCRS_Portage_County_Feet",
  },
  {
    value: "ESRI:103450",
    label: "ESRI:103450 / NAD_1983_HARN_WISCRS_Price_County_Feet",
  },
  {
    value: "ESRI:103451",
    label: "ESRI:103451 / NAD_1983_HARN_WISCRS_Racine_County_Feet",
  },
  {
    value: "ESRI:103452",
    label: "ESRI:103452 / NAD_1983_HARN_WISCRS_Richland_County_Feet",
  },
  {
    value: "ESRI:103453",
    label: "ESRI:103453 / NAD_1983_HARN_WISCRS_Rock_County_Feet",
  },
  {
    value: "ESRI:103454",
    label: "ESRI:103454 / NAD_1983_HARN_WISCRS_Rusk_County_Feet",
  },
  {
    value: "ESRI:103455",
    label: "ESRI:103455 / NAD_1983_HARN_WISCRS_Sauk_County_Feet",
  },
  {
    value: "ESRI:103456",
    label: "ESRI:103456 / NAD_1983_HARN_WISCRS_Sawyer_County_Feet",
  },
  {
    value: "ESRI:103457",
    label: "ESRI:103457 / NAD_1983_HARN_WISCRS_Shawano_County_Feet",
  },
  {
    value: "ESRI:103458",
    label: "ESRI:103458 / NAD_1983_HARN_WISCRS_Sheboygan_County_Feet",
  },
  {
    value: "ESRI:103459",
    label: "ESRI:103459 / NAD_1983_HARN_WISCRS_St_Croix_County_Feet",
  },
  {
    value: "ESRI:103460",
    label: "ESRI:103460 / NAD_1983_HARN_WISCRS_Taylor_County_Feet",
  },
  {
    value: "ESRI:103461",
    label: "ESRI:103461 / NAD_1983_HARN_WISCRS_Trempealeau_County_Feet",
  },
  {
    value: "ESRI:103462",
    label: "ESRI:103462 / NAD_1983_HARN_WISCRS_Vernon_County_Feet",
  },
  {
    value: "ESRI:103463",
    label: "ESRI:103463 / NAD_1983_HARN_WISCRS_Vilas_County_Feet",
  },
  {
    value: "ESRI:103464",
    label: "ESRI:103464 / NAD_1983_HARN_WISCRS_Walworth_County_Feet",
  },
  {
    value: "ESRI:103465",
    label: "ESRI:103465 / NAD_1983_HARN_WISCRS_Washburn_County_Feet",
  },
  {
    value: "ESRI:103466",
    label: "ESRI:103466 / NAD_1983_HARN_WISCRS_Washington_County_Feet",
  },
  {
    value: "ESRI:103467",
    label: "ESRI:103467 / NAD_1983_HARN_WISCRS_Waukesha_County_Feet",
  },
  {
    value: "ESRI:103468",
    label: "ESRI:103468 / NAD_1983_HARN_WISCRS_Waupaca_County_Feet",
  },
  {
    value: "ESRI:103469",
    label: "ESRI:103469 / NAD_1983_HARN_WISCRS_Waushara_County_Feet",
  },
  {
    value: "ESRI:103470",
    label: "ESRI:103470 / NAD_1983_HARN_WISCRS_Winnebago_County_Feet",
  },
  {
    value: "ESRI:103471",
    label: "ESRI:103471 / NAD_1983_HARN_WISCRS_Wood_County_Feet",
  },
  {
    value: "ESRI:103472",
    label: "ESRI:103472 / NAD_1983_CORS96_StatePlane_Montana_FIPS_2500",
  },
  {
    value: "ESRI:103473",
    label: "ESRI:103473 / NAD_1983_CORS96_StatePlane_Montana_FIPS_2500_Ft_Intl",
  },
  {
    value: "ESRI:103474",
    label: "ESRI:103474 / NAD_1983_CORS96_StatePlane_Nebraska_FIPS_2600",
  },
  {
    value: "ESRI:103475",
    label: "ESRI:103475 / NAD_1983_CORS96_StatePlane_Nebraska_FIPS_2600_Ft_US",
  },
  {
    value: "ESRI:103476",
    label: "ESRI:103476 / NAD_1983_CORS96_StatePlane_Nevada_East_FIPS_2701",
  },
  {
    value: "ESRI:103477",
    label: "ESRI:103477 / NAD_1983_CORS96_StatePlane_Nevada_Central_FIPS_2702",
  },
  {
    value: "ESRI:103478",
    label: "ESRI:103478 / NAD_1983_CORS96_StatePlane_Nevada_West_FIPS_2703",
  },
  {
    value: "ESRI:103479",
    label:
      "ESRI:103479 / NAD_1983_CORS96_StatePlane_Nevada_East_FIPS_2701_Ft_US",
  },
  {
    value: "ESRI:103480",
    label:
      "ESRI:103480 / NAD_1983_CORS96_StatePlane_Nevada_Central_FIPS_2702_Ft_US",
  },
  {
    value: "ESRI:103481",
    label:
      "ESRI:103481 / NAD_1983_CORS96_StatePlane_Nevada_West_FIPS_2703_Ft_US",
  },
  {
    value: "ESRI:103482",
    label: "ESRI:103482 / NAD_1983_CORS96_StatePlane_New_Hampshire_FIPS_2800",
  },
  {
    value: "ESRI:103483",
    label:
      "ESRI:103483 / NAD_1983_CORS96_StatePlane_New_Hampshire_FIPS_2800_Ft_US",
  },
  {
    value: "ESRI:103484",
    label: "ESRI:103484 / NAD_1983_CORS96_StatePlane_New_Jersey_FIPS_2900",
  },
  {
    value: "ESRI:103485",
    label:
      "ESRI:103485 / NAD_1983_CORS96_StatePlane_New_Jersey_FIPS_2900_Ft_US",
  },
  {
    value: "ESRI:103486",
    label: "ESRI:103486 / NAD_1983_CORS96_StatePlane_New_Mexico_East_FIPS_3001",
  },
  {
    value: "ESRI:103487",
    label:
      "ESRI:103487 / NAD_1983_CORS96_StatePlane_New_Mexico_Central_FIPS_3002",
  },
  {
    value: "ESRI:103488",
    label: "ESRI:103488 / NAD_1983_CORS96_StatePlane_New_Mexico_West_FIPS_3003",
  },
  {
    value: "ESRI:103489",
    label:
      "ESRI:103489 / NAD_1983_CORS96_StatePlane_New_Mexico_East_FIPS_3001_Ft_US",
  },
  {
    value: "ESRI:103490",
    label:
      "ESRI:103490 / NAD_1983_CORS96_StatePlane_New_Mexico_Central_FIPS_3002_Ft_US",
  },
  {
    value: "ESRI:103491",
    label:
      "ESRI:103491 / NAD_1983_CORS96_StatePlane_New_Mexico_West_FIPS_3003_Ft_US",
  },
  {
    value: "ESRI:103492",
    label: "ESRI:103492 / NAD_1983_CORS96_StatePlane_New_York_East_FIPS_3101",
  },
  {
    value: "ESRI:103493",
    label:
      "ESRI:103493 / NAD_1983_CORS96_StatePlane_New_York_Central_FIPS_3102",
  },
  {
    value: "ESRI:103494",
    label: "ESRI:103494 / NAD_1983_CORS96_StatePlane_New_York_West_FIPS_3103",
  },
  {
    value: "ESRI:103495",
    label:
      "ESRI:103495 / NAD_1983_CORS96_StatePlane_New_York_Long_Island_FIPS_3104",
  },
  {
    value: "ESRI:103496",
    label:
      "ESRI:103496 / NAD_1983_CORS96_StatePlane_New_York_East_FIPS_3101_Ft_US",
  },
  {
    value: "ESRI:103497",
    label:
      "ESRI:103497 / NAD_1983_CORS96_StatePlane_New_York_Central_FIPS_3102_Ft_US",
  },
  {
    value: "ESRI:103498",
    label:
      "ESRI:103498 / NAD_1983_CORS96_StatePlane_New_York_West_FIPS_3103_Ft_US",
  },
  {
    value: "ESRI:103499",
    label:
      "ESRI:103499 / NAD_1983_CORS96_StatePlane_New_York_Long_Isl_FIPS_3104_Ft_US",
  },
  {
    value: "ESRI:103500",
    label: "ESRI:103500 / NAD_1983_CORS96_StatePlane_North_Carolina_FIPS_3200",
  },
  {
    value: "ESRI:103501",
    label:
      "ESRI:103501 / NAD_1983_CORS96_StatePlane_North_Carolina_FIPS_3200_Ft_US",
  },
  {
    value: "ESRI:103502",
    label:
      "ESRI:103502 / NAD_1983_CORS96_StatePlane_North_Dakota_North_FIPS_3301",
  },
  {
    value: "ESRI:103503",
    label:
      "ESRI:103503 / NAD_1983_CORS96_StatePlane_North_Dakota_South_FIPS_3302",
  },
  {
    value: "ESRI:103504",
    label:
      "ESRI:103504 / NAD_1983_CORS96_StatePlane_North_Dakota_North_FIPS_3301_FtI",
  },
  {
    value: "ESRI:103505",
    label:
      "ESRI:103505 / NAD_1983_CORS96_StatePlane_North_Dakota_South_FIPS_3302_FtI",
  },
  {
    value: "ESRI:103506",
    label: "ESRI:103506 / NAD_1983_CORS96_StatePlane_Ohio_North_FIPS_3401",
  },
  {
    value: "ESRI:103507",
    label: "ESRI:103507 / NAD_1983_CORS96_StatePlane_Ohio_South_FIPS_3402",
  },
  {
    value: "ESRI:103508",
    label:
      "ESRI:103508 / NAD_1983_CORS96_StatePlane_Ohio_North_FIPS_3401_Ft_US",
  },
  {
    value: "ESRI:103509",
    label:
      "ESRI:103509 / NAD_1983_CORS96_StatePlane_Ohio_South_FIPS_3402_Ft_US",
  },
  {
    value: "ESRI:103510",
    label: "ESRI:103510 / NAD_1983_CORS96_StatePlane_Oklahoma_North_FIPS_3501",
  },
  {
    value: "ESRI:103511",
    label: "ESRI:103511 / NAD_1983_CORS96_StatePlane_Oklahoma_South_FIPS_3502",
  },
  {
    value: "ESRI:103512",
    label:
      "ESRI:103512 / NAD_1983_CORS96_StatePlane_Oklahoma_North_FIPS_3501_Ft_US",
  },
  {
    value: "ESRI:103513",
    label:
      "ESRI:103513 / NAD_1983_CORS96_StatePlane_Oklahoma_South_FIPS_3502_Ft_US",
  },
  {
    value: "ESRI:103514",
    label:
      "ESRI:103514 / NAD_1983_CORS96_StatePlane_Pennsylvania_North_FIPS_3701",
  },
  {
    value: "ESRI:103515",
    label:
      "ESRI:103515 / NAD_1983_CORS96_StatePlane_Pennsylvania_North_FIPS_3701_Ft_US",
  },
  {
    value: "ESRI:103516",
    label:
      "ESRI:103516 / NAD_1983_CORS96_StatePlane_Pennsylvania_South_FIPS_3702",
  },
  {
    value: "ESRI:103517",
    label:
      "ESRI:103517 / NAD_1983_CORS96_StatePlane_Pennsylvania_South_FIPS_3702_Ft_US",
  },
  {
    value: "ESRI:103518",
    label: "ESRI:103518 / NAD_1983_CORS96_StatePlane_Rhode_Island_FIPS_3800",
  },
  {
    value: "ESRI:103519",
    label:
      "ESRI:103519 / NAD_1983_CORS96_StatePlane_Rhode_Island_FIPS_3800_Ft_US",
  },
  {
    value: "ESRI:103520",
    label: "ESRI:103520 / NAD_1983_CORS96_StatePlane_South_Carolina_FIPS_3900",
  },
  {
    value: "ESRI:103521",
    label:
      "ESRI:103521 / NAD_1983_CORS96_StatePlane_South_Carolina_FIPS_3900_Ft_Intl",
  },
  {
    value: "ESRI:103522",
    label:
      "ESRI:103522 / NAD_1983_CORS96_StatePlane_South_Dakota_North_FIPS_4001",
  },
  {
    value: "ESRI:103523",
    label:
      "ESRI:103523 / NAD_1983_CORS96_StatePlane_South_Dakota_South_FIPS_4002",
  },
  {
    value: "ESRI:103524",
    label:
      "ESRI:103524 / NAD_1983_CORS96_StatePlane_South_Dakota_North_FIPS_4001_Ft_US",
  },
  {
    value: "ESRI:103525",
    label:
      "ESRI:103525 / NAD_1983_CORS96_StatePlane_South_Dakota_South_FIPS_4002_Ft_US",
  },
  {
    value: "ESRI:103526",
    label: "ESRI:103526 / NAD_1983_CORS96_StatePlane_Tennessee_FIPS_4100",
  },
  {
    value: "ESRI:103527",
    label: "ESRI:103527 / NAD_1983_CORS96_StatePlane_Tennessee_FIPS_4100_Ft_US",
  },
  { value: "ESRI:103528", label: "ESRI:103528 / ETRF_1989_UTM_Zone_28N" },
  { value: "ESRI:103529", label: "ESRI:103529 / ETRF_1989_UTM_Zone_29N" },
  { value: "ESRI:103530", label: "ESRI:103530 / ETRF_1989_UTM_Zone_30N" },
  { value: "ESRI:103531", label: "ESRI:103531 / ETRF_1989_UTM_Zone_31N" },
  { value: "ESRI:103532", label: "ESRI:103532 / ETRF_1989_UTM_Zone_32N" },
  { value: "ESRI:103533", label: "ESRI:103533 / ETRF_1989_UTM_Zone_33N" },
  { value: "ESRI:103534", label: "ESRI:103534 / ETRF_1989_UTM_Zone_34N" },
  { value: "ESRI:103535", label: "ESRI:103535 / ETRF_1989_UTM_Zone_35N" },
  { value: "ESRI:103536", label: "ESRI:103536 / ETRF_1989_UTM_Zone_36N" },
  { value: "ESRI:103537", label: "ESRI:103537 / ETRF_1989_UTM_Zone_37N" },
  { value: "ESRI:103538", label: "ESRI:103538 / ETRF_1989_UTM_Zone_38N" },
  {
    value: "ESRI:103539",
    label: "ESRI:103539 / NAD_1983_CORS96_StatePlane_Texas_North_FIPS_4201",
  },
  {
    value: "ESRI:103540",
    label:
      "ESRI:103540 / NAD_1983_CORS96_StatePlane_Texas_North_Central_FIPS_4202",
  },
  {
    value: "ESRI:103541",
    label: "ESRI:103541 / NAD_1983_CORS96_StatePlane_Texas_Central_FIPS_4203",
  },
  {
    value: "ESRI:103542",
    label:
      "ESRI:103542 / NAD_1983_CORS96_StatePlane_Texas_South_Central_FIPS_4204",
  },
  {
    value: "ESRI:103543",
    label: "ESRI:103543 / NAD_1983_CORS96_StatePlane_Texas_South_FIPS_4205",
  },
  {
    value: "ESRI:103544",
    label:
      "ESRI:103544 / NAD_1983_CORS96_StatePlane_Texas_North_FIPS_4201_Ft_US",
  },
  {
    value: "ESRI:103545",
    label:
      "ESRI:103545 / NAD_1983_CORS96_StatePlane_Texas_North_Central_FIPS_4202_FtUS",
  },
  {
    value: "ESRI:103546",
    label:
      "ESRI:103546 / NAD_1983_CORS96_StatePlane_Texas_Central_FIPS_4203_Ft_US",
  },
  {
    value: "ESRI:103547",
    label:
      "ESRI:103547 / NAD_1983_CORS96_StatePlane_Texas_South_Central_FIPS_4204_FtUS",
  },
  {
    value: "ESRI:103548",
    label:
      "ESRI:103548 / NAD_1983_CORS96_StatePlane_Texas_South_FIPS_4205_Ft_US",
  },
  {
    value: "ESRI:103549",
    label: "ESRI:103549 / NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301",
  },
  {
    value: "ESRI:103550",
    label: "ESRI:103550 / NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302",
  },
  {
    value: "ESRI:103551",
    label: "ESRI:103551 / NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303",
  },
  {
    value: "ESRI:103552",
    label:
      "ESRI:103552 / NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301_Ft_Intl",
  },
  {
    value: "ESRI:103553",
    label:
      "ESRI:103553 / NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302_Ft_Intl",
  },
  {
    value: "ESRI:103554",
    label:
      "ESRI:103554 / NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303_Ft_Intl",
  },
  {
    value: "ESRI:103555",
    label:
      "ESRI:103555 / NAD_1983_CORS96_StatePlane_Utah_North_FIPS_4301_Ft_US",
  },
  {
    value: "ESRI:103556",
    label:
      "ESRI:103556 / NAD_1983_CORS96_StatePlane_Utah_Central_FIPS_4302_Ft_US",
  },
  {
    value: "ESRI:103557",
    label:
      "ESRI:103557 / NAD_1983_CORS96_StatePlane_Utah_South_FIPS_4303_Ft_US",
  },
  {
    value: "ESRI:103558",
    label: "ESRI:103558 / NAD_1983_CORS96_StatePlane_Vermont_FIPS_4400",
  },
  {
    value: "ESRI:103559",
    label: "ESRI:103559 / NAD_1983_CORS96_StatePlane_Virginia_North_FIPS_4501",
  },
  {
    value: "ESRI:103560",
    label: "ESRI:103560 / NAD_1983_CORS96_StatePlane_Virginia_South_FIPS_4502",
  },
  {
    value: "ESRI:103561",
    label:
      "ESRI:103561 / NAD_1983_CORS96_StatePlane_Virginia_North_FIPS_4501_Ft_US",
  },
  {
    value: "ESRI:103562",
    label:
      "ESRI:103562 / NAD_1983_CORS96_StatePlane_Virginia_South_FIPS_4502_Ft_US",
  },
  {
    value: "ESRI:103563",
    label:
      "ESRI:103563 / NAD_1983_CORS96_StatePlane_Washington_North_FIPS_4601",
  },
  {
    value: "ESRI:103564",
    label:
      "ESRI:103564 / NAD_1983_CORS96_StatePlane_Washington_South_FIPS_4602",
  },
  {
    value: "ESRI:103565",
    label:
      "ESRI:103565 / NAD_1983_CORS96_StatePlane_Washington_North_FIPS_4601_Ft_US",
  },
  {
    value: "ESRI:103566",
    label:
      "ESRI:103566 / NAD_1983_CORS96_StatePlane_Washington_South_FIPS_4602_Ft_US",
  },
  {
    value: "ESRI:103567",
    label:
      "ESRI:103567 / NAD_1983_CORS96_StatePlane_West_Virginia_North_FIPS_4701",
  },
  {
    value: "ESRI:103568",
    label:
      "ESRI:103568 / NAD_1983_CORS96_StatePlane_West_Virginia_South_FIPS_4702",
  },
  {
    value: "ESRI:103569",
    label:
      "ESRI:103569 / NAD_1983_CORS96_StatePlane_West_Virginia_North_FIPS_4701_FtUS",
  },
  {
    value: "ESRI:103570",
    label:
      "ESRI:103570 / NAD_1983_CORS96_StatePlane_West_Virginia_South_FIPS_4702_FtUS",
  },
  {
    value: "ESRI:103571",
    label: "ESRI:103571 / NAD_1983_CORS96_StatePlane_Wisconsin_North_FIPS_4801",
  },
  {
    value: "ESRI:103572",
    label:
      "ESRI:103572 / NAD_1983_CORS96_StatePlane_Wisconsin_Central_FIPS_4802",
  },
  {
    value: "ESRI:103573",
    label: "ESRI:103573 / NAD_1983_CORS96_StatePlane_Wisconsin_South_FIPS_4803",
  },
  {
    value: "ESRI:103574",
    label:
      "ESRI:103574 / NAD_1983_CORS96_StatePlane_Wisconsin_North_FIPS_4801_Ft_US",
  },
  {
    value: "ESRI:103575",
    label:
      "ESRI:103575 / NAD_1983_CORS96_StatePlane_Wisconsin_Central_FIPS_4802_Ft_US",
  },
  {
    value: "ESRI:103576",
    label:
      "ESRI:103576 / NAD_1983_CORS96_StatePlane_Wisconsin_South_FIPS_4803_Ft_US",
  },
  {
    value: "ESRI:103577",
    label: "ESRI:103577 / NAD_1983_CORS96_StatePlane_Wyoming_East_FIPS_4901",
  },
  {
    value: "ESRI:103578",
    label:
      "ESRI:103578 / NAD_1983_CORS96_StatePlane_Wyoming_East_Central_FIPS_4902",
  },
  {
    value: "ESRI:103579",
    label:
      "ESRI:103579 / NAD_1983_CORS96_StatePlane_Wyoming_West_Central_FIPS_4903",
  },
  {
    value: "ESRI:103580",
    label: "ESRI:103580 / NAD_1983_CORS96_StatePlane_Wyoming_West_FIPS_4904",
  },
  {
    value: "ESRI:103581",
    label:
      "ESRI:103581 / NAD_1983_CORS96_StatePlane_Wyoming_East_FIPS_4901_Ft_US",
  },
  {
    value: "ESRI:103582",
    label:
      "ESRI:103582 / NAD_1983_CORS96_StatePlane_Wyoming_E_Central_FIPS_4902_Ft_US",
  },
  {
    value: "ESRI:103583",
    label:
      "ESRI:103583 / NAD_1983_CORS96_StatePlane_Wyoming_W_Central_FIPS_4903_Ft_US",
  },
  { value: "ESRI:103584", label: "ESRI:103584 / ETRF_1989_TM_Baltic_1993" },
  {
    value: "ESRI:103585",
    label:
      "ESRI:103585 / NAD_1983_CORS96_StatePlane_Wyoming_West_FIPS_4904_Ft_US",
  },
  {
    value: "ESRI:103586",
    label: "ESRI:103586 / NAD_1983_HARN_Navajo_Nation_Coordinate_System_Meters",
  },
  {
    value: "ESRI:103587",
    label:
      "ESRI:103587 / NAD_1983_HARN_Navajo_Nation_Coordinate_System_US_Feet",
  },
  {
    value: "ESRI:103588",
    label:
      "ESRI:103588 / NAD_1983_HARN_Navajo_Nation_Coordinate_System_Intl_Feet",
  },
  {
    value: "ESRI:103589",
    label:
      "ESRI:103589 / NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_Meters",
  },
  {
    value: "ESRI:103590",
    label:
      "ESRI:103590 / NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_US_Feet",
  },
  {
    value: "ESRI:103591",
    label:
      "ESRI:103591 / NAD_1983_NSRS2007_Navajo_Nation_Coordinate_System_Intl_Feet",
  },
  {
    value: "ESRI:103592",
    label:
      "ESRI:103592 / NAD_1983_(2011)_Navajo_Nation_Coordinate_System_Meters",
  },
  {
    value: "ESRI:103593",
    label:
      "ESRI:103593 / NAD_1983_(2011)_Navajo_Nation_Coordinate_System_US_Feet",
  },
  {
    value: "ESRI:103594",
    label:
      "ESRI:103594 / NAD_1983_(2011)_Navajo_Nation_Coordinate_System_Intl_Feet",
  },
  { value: "ESRI:103595", label: "ESRI:103595 / ONGD17_UTM_Zone_39N" },
  { value: "ESRI:103596", label: "ESRI:103596 / ONGD17_UTM_Zone_40N" },
  { value: "ESRI:103597", label: "ESRI:103597 / ONGD17_UTM_Zone_41N" },
  { value: "ESRI:103598", label: "ESRI:103598 / GTM" },
  { value: "ESRI:103599", label: "ESRI:103599 / MAGNA-SIRGAS_CMT12" },
  {
    value: "ESRI:103600",
    label: "ESRI:103600 / NAD_1983_HARN_Adj_MN_Aitkin_Meters",
  },
  {
    value: "ESRI:103601",
    label: "ESRI:103601 / NAD_1983_HARN_Adj_MN_Clay_Meters",
  },
  {
    value: "ESRI:103602",
    label: "ESRI:103602 / NAD_1983_HARN_Adj_MN_Clearwater_Meters",
  },
  {
    value: "ESRI:103603",
    label: "ESRI:103603 / NAD_1983_HARN_Adj_MN_Hubbard_Meters",
  },
  {
    value: "ESRI:103604",
    label: "ESRI:103604 / NAD_1983_HARN_Adj_MN_Lake_Meters",
  },
  {
    value: "ESRI:103605",
    label: "ESRI:103605 / NAD_1983_HARN_Adj_MN_Mille_Lacs_Meters",
  },
  {
    value: "ESRI:103606",
    label: "ESRI:103606 / NAD_1983_HARN_Adj_MN_Washington_Meters",
  },
  {
    value: "ESRI:103607",
    label: "ESRI:103607 / NAD_1983_HARN_Adj_MN_Wilkin_Meters",
  },
  {
    value: "ESRI:103608",
    label: "ESRI:103608 / NAD_1983_HARN_Adj_MN_Anoka_Meters",
  },
  {
    value: "ESRI:103609",
    label: "ESRI:103609 / NAD_1983_HARN_Adj_MN_Becker_Meters",
  },
  {
    value: "ESRI:103610",
    label: "ESRI:103610 / NAD_1983_HARN_Adj_MN_Beltrami_North_Meters",
  },
  {
    value: "ESRI:103611",
    label: "ESRI:103611 / NAD_1983_HARN_Adj_MN_Beltrami_South_Meters",
  },
  {
    value: "ESRI:103612",
    label: "ESRI:103612 / NAD_1983_HARN_Adj_MN_Benton_Meters",
  },
  {
    value: "ESRI:103613",
    label: "ESRI:103613 / NAD_1983_HARN_Adj_MN_Big_Stone_Meters",
  },
  {
    value: "ESRI:103614",
    label: "ESRI:103614 / NAD_1983_HARN_Adj_MN_Blue_Earth_Meters",
  },
  {
    value: "ESRI:103615",
    label: "ESRI:103615 / NAD_1983_HARN_Adj_MN_Brown_Meters",
  },
  {
    value: "ESRI:103616",
    label: "ESRI:103616 / NAD_1983_HARN_Adj_MN_Carlton_Meters",
  },
  {
    value: "ESRI:103617",
    label: "ESRI:103617 / NAD_1983_HARN_Adj_MN_Carver_Meters",
  },
  {
    value: "ESRI:103618",
    label: "ESRI:103618 / NAD_1983_HARN_Adj_MN_Cass_North_Meters",
  },
  {
    value: "ESRI:103619",
    label: "ESRI:103619 / NAD_1983_HARN_Adj_MN_Cass_South_Meters",
  },
  {
    value: "ESRI:103620",
    label: "ESRI:103620 / NAD_1983_HARN_Adj_MN_Chippewa_Meters",
  },
  {
    value: "ESRI:103621",
    label: "ESRI:103621 / NAD_1983_HARN_Adj_MN_Chisago_Meters",
  },
  {
    value: "ESRI:103622",
    label: "ESRI:103622 / NAD_1983_HARN_Adj_MN_Cook_North_Meters",
  },
  {
    value: "ESRI:103623",
    label: "ESRI:103623 / NAD_1983_HARN_Adj_MN_Cook_South_Meters",
  },
  {
    value: "ESRI:103624",
    label: "ESRI:103624 / NAD_1983_HARN_Adj_MN_Cottonwood_Meters",
  },
  {
    value: "ESRI:103625",
    label: "ESRI:103625 / NAD_1983_HARN_Adj_MN_Crow_Wing_Meters",
  },
  {
    value: "ESRI:103626",
    label: "ESRI:103626 / NAD_1983_HARN_Adj_MN_Dakota_Meters",
  },
  {
    value: "ESRI:103627",
    label: "ESRI:103627 / NAD_1983_HARN_Adj_MN_Dodge_Meters",
  },
  {
    value: "ESRI:103628",
    label: "ESRI:103628 / NAD_1983_HARN_Adj_MN_Douglas_Meters",
  },
  {
    value: "ESRI:103629",
    label: "ESRI:103629 / NAD_1983_HARN_Adj_MN_Faribault_Meters",
  },
  {
    value: "ESRI:103630",
    label: "ESRI:103630 / NAD_1983_HARN_Adj_MN_Fillmore_Meters",
  },
  {
    value: "ESRI:103631",
    label: "ESRI:103631 / NAD_1983_HARN_Adj_MN_Freeborn_Meters",
  },
  {
    value: "ESRI:103632",
    label: "ESRI:103632 / NAD_1983_HARN_Adj_MN_Goodhue_Meters",
  },
  {
    value: "ESRI:103633",
    label: "ESRI:103633 / NAD_1983_HARN_Adj_MN_Grant_Meters",
  },
  {
    value: "ESRI:103634",
    label: "ESRI:103634 / NAD_1983_HARN_Adj_MN_Hennepin_Meters",
  },
  {
    value: "ESRI:103635",
    label: "ESRI:103635 / NAD_1983_HARN_Adj_MN_Houston_Meters",
  },
  {
    value: "ESRI:103636",
    label: "ESRI:103636 / NAD_1983_HARN_Adj_MN_Isanti_Meters",
  },
  {
    value: "ESRI:103637",
    label: "ESRI:103637 / NAD_1983_HARN_Adj_MN_Itasca_North_Meters",
  },
  {
    value: "ESRI:103638",
    label: "ESRI:103638 / NAD_1983_HARN_Adj_MN_Itasca_South_Meters",
  },
  {
    value: "ESRI:103639",
    label: "ESRI:103639 / NAD_1983_HARN_Adj_MN_Jackson_Meters",
  },
  {
    value: "ESRI:103640",
    label: "ESRI:103640 / NAD_1983_HARN_Adj_MN_Kanabec_Meters",
  },
  {
    value: "ESRI:103641",
    label: "ESRI:103641 / NAD_1983_HARN_Adj_MN_Kandiyohi_Meters",
  },
  {
    value: "ESRI:103642",
    label: "ESRI:103642 / NAD_1983_HARN_Adj_MN_Kittson_Meters",
  },
  {
    value: "ESRI:103643",
    label: "ESRI:103643 / NAD_1983_HARN_Adj_MN_Koochiching_Meters",
  },
  {
    value: "ESRI:103644",
    label: "ESRI:103644 / NAD_1983_HARN_Adj_MN_Lac_Qui_Parle_Meters",
  },
  {
    value: "ESRI:103645",
    label: "ESRI:103645 / NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North_Meters",
  },
  {
    value: "ESRI:103646",
    label: "ESRI:103646 / NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South_Meters",
  },
  {
    value: "ESRI:103647",
    label: "ESRI:103647 / NAD_1983_HARN_Adj_MN_Le_Sueur_Meters",
  },
  {
    value: "ESRI:103648",
    label: "ESRI:103648 / NAD_1983_HARN_Adj_MN_Lincoln_Meters",
  },
  {
    value: "ESRI:103649",
    label: "ESRI:103649 / NAD_1983_HARN_Adj_MN_Lyon_Meters",
  },
  {
    value: "ESRI:103650",
    label: "ESRI:103650 / NAD_1983_HARN_Adj_MN_McLeod_Meters",
  },
  {
    value: "ESRI:103651",
    label: "ESRI:103651 / NAD_1983_HARN_Adj_MN_Mahnomen_Meters",
  },
  {
    value: "ESRI:103652",
    label: "ESRI:103652 / NAD_1983_HARN_Adj_MN_Marshall_Meters",
  },
  {
    value: "ESRI:103653",
    label: "ESRI:103653 / NAD_1983_HARN_Adj_MN_Martin_Meters",
  },
  {
    value: "ESRI:103654",
    label: "ESRI:103654 / NAD_1983_HARN_Adj_MN_Meeker_Meters",
  },
  {
    value: "ESRI:103655",
    label: "ESRI:103655 / NAD_1983_HARN_Adj_MN_Morrison_Meters",
  },
  {
    value: "ESRI:103656",
    label: "ESRI:103656 / NAD_1983_HARN_Adj_MN_Mower_Meters",
  },
  {
    value: "ESRI:103657",
    label: "ESRI:103657 / NAD_1983_HARN_Adj_MN_Murray_Meters",
  },
  {
    value: "ESRI:103658",
    label: "ESRI:103658 / NAD_1983_HARN_Adj_MN_Nicollet_Meters",
  },
  {
    value: "ESRI:103659",
    label: "ESRI:103659 / NAD_1983_HARN_Adj_MN_Nobles_Meters",
  },
  {
    value: "ESRI:103660",
    label: "ESRI:103660 / NAD_1983_HARN_Adj_MN_Norman_Meters",
  },
  {
    value: "ESRI:103661",
    label: "ESRI:103661 / NAD_1983_HARN_Adj_MN_Olmsted_Meters",
  },
  {
    value: "ESRI:103662",
    label: "ESRI:103662 / NAD_1983_HARN_Adj_MN_Ottertail_Meters",
  },
  {
    value: "ESRI:103663",
    label: "ESRI:103663 / NAD_1983_HARN_Adj_MN_Pennington_Meters",
  },
  {
    value: "ESRI:103664",
    label: "ESRI:103664 / NAD_1983_HARN_Adj_MN_Pine_Meters",
  },
  {
    value: "ESRI:103665",
    label: "ESRI:103665 / NAD_1983_HARN_Adj_MN_Pipestone_Meters",
  },
  {
    value: "ESRI:103666",
    label: "ESRI:103666 / NAD_1983_HARN_Adj_MN_Polk_Meters",
  },
  {
    value: "ESRI:103667",
    label: "ESRI:103667 / NAD_1983_HARN_Adj_MN_Pope_Meters",
  },
  {
    value: "ESRI:103668",
    label: "ESRI:103668 / NAD_1983_HARN_Adj_MN_Ramsey_Meters",
  },
  {
    value: "ESRI:103669",
    label: "ESRI:103669 / NAD_1983_HARN_Adj_MN_Red_Lake_Meters",
  },
  {
    value: "ESRI:103670",
    label: "ESRI:103670 / NAD_1983_HARN_Adj_MN_Redwood_Meters",
  },
  {
    value: "ESRI:103671",
    label: "ESRI:103671 / NAD_1983_HARN_Adj_MN_Renville_Meters",
  },
  {
    value: "ESRI:103672",
    label: "ESRI:103672 / NAD_1983_HARN_Adj_MN_Rice_Meters",
  },
  {
    value: "ESRI:103673",
    label: "ESRI:103673 / NAD_1983_HARN_Adj_MN_Rock_Meters",
  },
  {
    value: "ESRI:103674",
    label: "ESRI:103674 / NAD_1983_HARN_Adj_MN_Roseau_Meters",
  },
  {
    value: "ESRI:103675",
    label: "ESRI:103675 / NAD_1983_HARN_Adj_MN_St_Louis_North_Meters",
  },
  {
    value: "ESRI:103676",
    label: "ESRI:103676 / NAD_1983_HARN_Adj_MN_St_Louis_Central_Meters",
  },
  {
    value: "ESRI:103677",
    label: "ESRI:103677 / NAD_1983_HARN_Adj_MN_St_Louis_South_Meters",
  },
  {
    value: "ESRI:103678",
    label: "ESRI:103678 / NAD_1983_HARN_Adj_MN_Scott_Meters",
  },
  {
    value: "ESRI:103679",
    label: "ESRI:103679 / NAD_1983_HARN_Adj_MN_Sherburne_Meters",
  },
  {
    value: "ESRI:103680",
    label: "ESRI:103680 / NAD_1983_HARN_Adj_MN_Sibley_Meters",
  },
  {
    value: "ESRI:103681",
    label: "ESRI:103681 / NAD_1983_HARN_Adj_MN_Stearns_Meters",
  },
  {
    value: "ESRI:103682",
    label: "ESRI:103682 / NAD_1983_HARN_Adj_MN_Steele_Meters",
  },
  {
    value: "ESRI:103683",
    label: "ESRI:103683 / NAD_1983_HARN_Adj_MN_Stevens_Meters",
  },
  {
    value: "ESRI:103684",
    label: "ESRI:103684 / NAD_1983_HARN_Adj_MN_Swift_Meters",
  },
  {
    value: "ESRI:103685",
    label: "ESRI:103685 / NAD_1983_HARN_Adj_MN_Todd_Meters",
  },
  {
    value: "ESRI:103686",
    label: "ESRI:103686 / NAD_1983_HARN_Adj_MN_Traverse_Meters",
  },
  {
    value: "ESRI:103687",
    label: "ESRI:103687 / NAD_1983_HARN_Adj_MN_Wabasha_Meters",
  },
  {
    value: "ESRI:103688",
    label: "ESRI:103688 / NAD_1983_HARN_Adj_MN_Wadena_Meters",
  },
  {
    value: "ESRI:103689",
    label: "ESRI:103689 / NAD_1983_HARN_Adj_MN_Waseca_Meters",
  },
  {
    value: "ESRI:103690",
    label: "ESRI:103690 / NAD_1983_HARN_Adj_MN_Watonwan_Meters",
  },
  {
    value: "ESRI:103691",
    label: "ESRI:103691 / NAD_1983_HARN_Adj_MN_Winona_Meters",
  },
  {
    value: "ESRI:103692",
    label: "ESRI:103692 / NAD_1983_HARN_Adj_MN_Wright_Meters",
  },
  {
    value: "ESRI:103693",
    label: "ESRI:103693 / NAD_1983_HARN_Adj_MN_Yellow_Medicine_Meters",
  },
  {
    value: "ESRI:103694",
    label: "ESRI:103694 / NAD_1983_HARN_Adj_MN_St_Louis_CS96_Meters",
  },
  {
    value: "ESRI:103695",
    label: "ESRI:103695 / NAD_1983_HARN_Adj_MN_St_Louis_CS96_Feet",
  },
  {
    value: "ESRI:103696",
    label: "ESRI:103696 / NAD_1983_(CSRS)_v6_UTM_Zone_19N",
  },
  {
    value: "ESRI:103697",
    label: "ESRI:103697 / NAD_1983_(CSRS)_v6_UTM_Zone_20N",
  },
  {
    value: "ESRI:103698",
    label: "ESRI:103698 / NAD_1983_(CSRS)_v6_UTM_Zone_21N",
  },
  {
    value: "ESRI:103699",
    label: "ESRI:103699 / Palestine_Grid_1923_Modified_TM",
  },
  {
    value: "ESRI:103700",
    label: "ESRI:103700 / NAD_1983_HARN_Adj_MN_Aitkin_Feet",
  },
  {
    value: "ESRI:103701",
    label: "ESRI:103701 / NAD_1983_HARN_Adj_MN_Clay_Feet",
  },
  {
    value: "ESRI:103702",
    label: "ESRI:103702 / NAD_1983_HARN_Adj_MN_Clearwater_Feet",
  },
  {
    value: "ESRI:103703",
    label: "ESRI:103703 / NAD_1983_HARN_Adj_MN_Hubbard_Feet",
  },
  {
    value: "ESRI:103704",
    label: "ESRI:103704 / NAD_1983_HARN_Adj_MN_Lake_Feet",
  },
  {
    value: "ESRI:103705",
    label: "ESRI:103705 / NAD_1983_HARN_Adj_MN_Mille_Lacs_Feet",
  },
  {
    value: "ESRI:103706",
    label: "ESRI:103706 / NAD_1983_HARN_Adj_MN_Washington_Feet",
  },
  {
    value: "ESRI:103707",
    label: "ESRI:103707 / NAD_1983_HARN_Adj_MN_Wilkin_Feet",
  },
  {
    value: "ESRI:103708",
    label: "ESRI:103708 / NAD_1983_HARN_Adj_MN_Anoka_Feet",
  },
  {
    value: "ESRI:103709",
    label: "ESRI:103709 / NAD_1983_HARN_Adj_MN_Becker_Feet",
  },
  {
    value: "ESRI:103710",
    label: "ESRI:103710 / NAD_1983_HARN_Adj_MN_Beltrami_North_Feet",
  },
  {
    value: "ESRI:103711",
    label: "ESRI:103711 / NAD_1983_HARN_Adj_MN_Beltrami_South_Feet",
  },
  {
    value: "ESRI:103712",
    label: "ESRI:103712 / NAD_1983_HARN_Adj_MN_Benton_Feet",
  },
  {
    value: "ESRI:103713",
    label: "ESRI:103713 / NAD_1983_HARN_Adj_MN_Big_Stone_Feet",
  },
  {
    value: "ESRI:103714",
    label: "ESRI:103714 / NAD_1983_HARN_Adj_MN_Blue_Earth_Feet",
  },
  {
    value: "ESRI:103715",
    label: "ESRI:103715 / NAD_1983_HARN_Adj_MN_Brown_Feet",
  },
  {
    value: "ESRI:103716",
    label: "ESRI:103716 / NAD_1983_HARN_Adj_MN_Carlton_Feet",
  },
  {
    value: "ESRI:103717",
    label: "ESRI:103717 / NAD_1983_HARN_Adj_MN_Carver_Feet",
  },
  {
    value: "ESRI:103718",
    label: "ESRI:103718 / NAD_1983_HARN_Adj_MN_Cass_North_Feet",
  },
  {
    value: "ESRI:103719",
    label: "ESRI:103719 / NAD_1983_HARN_Adj_MN_Cass_South_Feet",
  },
  {
    value: "ESRI:103720",
    label: "ESRI:103720 / NAD_1983_HARN_Adj_MN_Chippewa_Feet",
  },
  {
    value: "ESRI:103721",
    label: "ESRI:103721 / NAD_1983_HARN_Adj_MN_Chisago_Feet",
  },
  {
    value: "ESRI:103722",
    label: "ESRI:103722 / NAD_1983_HARN_Adj_MN_Cook_North_Feet",
  },
  {
    value: "ESRI:103723",
    label: "ESRI:103723 / NAD_1983_HARN_Adj_MN_Cook_South_Feet",
  },
  {
    value: "ESRI:103724",
    label: "ESRI:103724 / NAD_1983_HARN_Adj_MN_Cottonwood_Feet",
  },
  {
    value: "ESRI:103725",
    label: "ESRI:103725 / NAD_1983_HARN_Adj_MN_Crow_Wing_Feet",
  },
  {
    value: "ESRI:103726",
    label: "ESRI:103726 / NAD_1983_HARN_Adj_MN_Dakota_Feet",
  },
  {
    value: "ESRI:103727",
    label: "ESRI:103727 / NAD_1983_HARN_Adj_MN_Dodge_Feet",
  },
  {
    value: "ESRI:103728",
    label: "ESRI:103728 / NAD_1983_HARN_Adj_MN_Douglas_Feet",
  },
  {
    value: "ESRI:103729",
    label: "ESRI:103729 / NAD_1983_HARN_Adj_MN_Faribault_Feet",
  },
  {
    value: "ESRI:103730",
    label: "ESRI:103730 / NAD_1983_HARN_Adj_MN_Fillmore_Feet",
  },
  {
    value: "ESRI:103731",
    label: "ESRI:103731 / NAD_1983_HARN_Adj_MN_Freeborn_Feet",
  },
  {
    value: "ESRI:103732",
    label: "ESRI:103732 / NAD_1983_HARN_Adj_MN_Goodhue_Feet",
  },
  {
    value: "ESRI:103733",
    label: "ESRI:103733 / NAD_1983_HARN_Adj_MN_Grant_Feet",
  },
  {
    value: "ESRI:103734",
    label: "ESRI:103734 / NAD_1983_HARN_Adj_MN_Hennepin_Feet",
  },
  {
    value: "ESRI:103735",
    label: "ESRI:103735 / NAD_1983_HARN_Adj_MN_Houston_Feet",
  },
  {
    value: "ESRI:103736",
    label: "ESRI:103736 / NAD_1983_HARN_Adj_MN_Isanti_Feet",
  },
  {
    value: "ESRI:103737",
    label: "ESRI:103737 / NAD_1983_HARN_Adj_MN_Itasca_North_Feet",
  },
  {
    value: "ESRI:103738",
    label: "ESRI:103738 / NAD_1983_HARN_Adj_MN_Itasca_South_Feet",
  },
  {
    value: "ESRI:103739",
    label: "ESRI:103739 / NAD_1983_HARN_Adj_MN_Jackson_Feet",
  },
  {
    value: "ESRI:103740",
    label: "ESRI:103740 / NAD_1983_HARN_Adj_MN_Kanabec_Feet",
  },
  {
    value: "ESRI:103741",
    label: "ESRI:103741 / NAD_1983_HARN_Adj_MN_Kandiyohi_Feet",
  },
  {
    value: "ESRI:103742",
    label: "ESRI:103742 / NAD_1983_HARN_Adj_MN_Kittson_Feet",
  },
  {
    value: "ESRI:103743",
    label: "ESRI:103743 / NAD_1983_HARN_Adj_MN_Koochiching_Feet",
  },
  {
    value: "ESRI:103744",
    label: "ESRI:103744 / NAD_1983_HARN_Adj_MN_Lac_Qui_Parle_Feet",
  },
  {
    value: "ESRI:103745",
    label: "ESRI:103745 / NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North_Feet",
  },
  {
    value: "ESRI:103746",
    label: "ESRI:103746 / NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South_Feet",
  },
  {
    value: "ESRI:103747",
    label: "ESRI:103747 / NAD_1983_HARN_Adj_MN_Le_Sueur_Feet",
  },
  {
    value: "ESRI:103748",
    label: "ESRI:103748 / NAD_1983_HARN_Adj_MN_Lincoln_Feet",
  },
  {
    value: "ESRI:103749",
    label: "ESRI:103749 / NAD_1983_HARN_Adj_MN_Lyon_Feet",
  },
  {
    value: "ESRI:103750",
    label: "ESRI:103750 / NAD_1983_HARN_Adj_MN_McLeod_Feet",
  },
  {
    value: "ESRI:103751",
    label: "ESRI:103751 / NAD_1983_HARN_Adj_MN_Mahnomen_Feet",
  },
  {
    value: "ESRI:103752",
    label: "ESRI:103752 / NAD_1983_HARN_Adj_MN_Marshall_Feet",
  },
  {
    value: "ESRI:103753",
    label: "ESRI:103753 / NAD_1983_HARN_Adj_MN_Martin_Feet",
  },
  {
    value: "ESRI:103754",
    label: "ESRI:103754 / NAD_1983_HARN_Adj_MN_Meeker_Feet",
  },
  {
    value: "ESRI:103755",
    label: "ESRI:103755 / NAD_1983_HARN_Adj_MN_Morrison_Feet",
  },
  {
    value: "ESRI:103756",
    label: "ESRI:103756 / NAD_1983_HARN_Adj_MN_Mower_Feet",
  },
  {
    value: "ESRI:103757",
    label: "ESRI:103757 / NAD_1983_HARN_Adj_MN_Murray_Feet",
  },
  {
    value: "ESRI:103758",
    label: "ESRI:103758 / NAD_1983_HARN_Adj_MN_Nicollet_Feet",
  },
  {
    value: "ESRI:103759",
    label: "ESRI:103759 / NAD_1983_HARN_Adj_MN_Nobles_Feet",
  },
  {
    value: "ESRI:103760",
    label: "ESRI:103760 / NAD_1983_HARN_Adj_MN_Norman_Feet",
  },
  {
    value: "ESRI:103761",
    label: "ESRI:103761 / NAD_1983_HARN_Adj_MN_Olmsted_Feet",
  },
  {
    value: "ESRI:103762",
    label: "ESRI:103762 / NAD_1983_HARN_Adj_MN_Ottertail_Feet",
  },
  {
    value: "ESRI:103763",
    label: "ESRI:103763 / NAD_1983_HARN_Adj_MN_Pennington_Feet",
  },
  {
    value: "ESRI:103764",
    label: "ESRI:103764 / NAD_1983_HARN_Adj_MN_Pine_Feet",
  },
  {
    value: "ESRI:103765",
    label: "ESRI:103765 / NAD_1983_HARN_Adj_MN_Pipestone_Feet",
  },
  {
    value: "ESRI:103766",
    label: "ESRI:103766 / NAD_1983_HARN_Adj_MN_Polk_Feet",
  },
  {
    value: "ESRI:103767",
    label: "ESRI:103767 / NAD_1983_HARN_Adj_MN_Pope_Feet",
  },
  {
    value: "ESRI:103768",
    label: "ESRI:103768 / NAD_1983_HARN_Adj_MN_Ramsey_Feet",
  },
  {
    value: "ESRI:103769",
    label: "ESRI:103769 / NAD_1983_HARN_Adj_MN_Red_Lake_Feet",
  },
  {
    value: "ESRI:103770",
    label: "ESRI:103770 / NAD_1983_HARN_Adj_MN_Redwood_Feet",
  },
  {
    value: "ESRI:103771",
    label: "ESRI:103771 / NAD_1983_HARN_Adj_MN_Renville_Feet",
  },
  {
    value: "ESRI:103772",
    label: "ESRI:103772 / NAD_1983_HARN_Adj_MN_Rice_Feet",
  },
  {
    value: "ESRI:103773",
    label: "ESRI:103773 / NAD_1983_HARN_Adj_MN_Rock_Feet",
  },
  {
    value: "ESRI:103774",
    label: "ESRI:103774 / NAD_1983_HARN_Adj_MN_Roseau_Feet",
  },
  {
    value: "ESRI:103775",
    label: "ESRI:103775 / NAD_1983_HARN_Adj_MN_St_Louis_North_Feet",
  },
  {
    value: "ESRI:103776",
    label: "ESRI:103776 / NAD_1983_HARN_Adj_MN_St_Louis_Central_Feet",
  },
  {
    value: "ESRI:103777",
    label: "ESRI:103777 / NAD_1983_HARN_Adj_MN_St_Louis_South_Feet",
  },
  {
    value: "ESRI:103778",
    label: "ESRI:103778 / NAD_1983_HARN_Adj_MN_Scott_Feet",
  },
  {
    value: "ESRI:103779",
    label: "ESRI:103779 / NAD_1983_HARN_Adj_MN_Sherburne_Feet",
  },
  {
    value: "ESRI:103780",
    label: "ESRI:103780 / NAD_1983_HARN_Adj_MN_Sibley_Feet",
  },
  {
    value: "ESRI:103781",
    label: "ESRI:103781 / NAD_1983_HARN_Adj_MN_Stearns_Feet",
  },
  {
    value: "ESRI:103782",
    label: "ESRI:103782 / NAD_1983_HARN_Adj_MN_Steele_Feet",
  },
  {
    value: "ESRI:103783",
    label: "ESRI:103783 / NAD_1983_HARN_Adj_MN_Stevens_Feet",
  },
  {
    value: "ESRI:103784",
    label: "ESRI:103784 / NAD_1983_HARN_Adj_MN_Swift_Feet",
  },
  {
    value: "ESRI:103785",
    label: "ESRI:103785 / NAD_1983_HARN_Adj_MN_Todd_Feet",
  },
  {
    value: "ESRI:103786",
    label: "ESRI:103786 / NAD_1983_HARN_Adj_MN_Traverse_Feet",
  },
  {
    value: "ESRI:103787",
    label: "ESRI:103787 / NAD_1983_HARN_Adj_MN_Wabasha_Feet",
  },
  {
    value: "ESRI:103788",
    label: "ESRI:103788 / NAD_1983_HARN_Adj_MN_Wadena_Feet",
  },
  {
    value: "ESRI:103789",
    label: "ESRI:103789 / NAD_1983_HARN_Adj_MN_Waseca_Feet",
  },
  {
    value: "ESRI:103790",
    label: "ESRI:103790 / NAD_1983_HARN_Adj_MN_Watonwan_Feet",
  },
  {
    value: "ESRI:103791",
    label: "ESRI:103791 / NAD_1983_HARN_Adj_MN_Winona_Feet",
  },
  {
    value: "ESRI:103792",
    label: "ESRI:103792 / NAD_1983_HARN_Adj_MN_Wright_Feet",
  },
  {
    value: "ESRI:103793",
    label: "ESRI:103793 / NAD_1983_HARN_Adj_MN_Yellow_Medicine_Feet",
  },
  {
    value: "ESRI:103794",
    label: "ESRI:103794 / Mexican_Datum_1993_UTM_Zone_11N",
  },
  {
    value: "ESRI:103795",
    label: "ESRI:103795 / Mexican_Datum_1993_UTM_Zone_12N",
  },
  {
    value: "ESRI:103796",
    label: "ESRI:103796 / Mexican_Datum_1993_UTM_Zone_13N",
  },
  {
    value: "ESRI:103797",
    label: "ESRI:103797 / Mexican_Datum_1993_UTM_Zone_14N",
  },
  {
    value: "ESRI:103798",
    label: "ESRI:103798 / Mexican_Datum_1993_UTM_Zone_15N",
  },
  {
    value: "ESRI:103799",
    label: "ESRI:103799 / Mexican_Datum_1993_UTM_Zone_16N",
  },
  {
    value: "ESRI:103800",
    label: "ESRI:103800 / NAD_1983_HARN_Adj_WI_Adams_Meters",
  },
  {
    value: "ESRI:103801",
    label: "ESRI:103801 / NAD_1983_HARN_Adj_WI_Ashland_Meters",
  },
  {
    value: "ESRI:103802",
    label: "ESRI:103802 / NAD_1983_HARN_Adj_WI_Barron_Meters",
  },
  {
    value: "ESRI:103803",
    label: "ESRI:103803 / NAD_1983_HARN_Adj_WI_Brown_Meters",
  },
  {
    value: "ESRI:103804",
    label: "ESRI:103804 / NAD_1983_HARN_Adj_WI_Buffalo_Meters",
  },
  {
    value: "ESRI:103805",
    label: "ESRI:103805 / NAD_1983_HARN_Adj_WI_Calumet_Meters",
  },
  {
    value: "ESRI:103806",
    label: "ESRI:103806 / NAD_1983_HARN_Adj_WI_Clark_Meters",
  },
  {
    value: "ESRI:103807",
    label: "ESRI:103807 / NAD_1983_HARN_Adj_WI_Dodge_Meters",
  },
  {
    value: "ESRI:103808",
    label: "ESRI:103808 / NAD_1983_HARN_Adj_WI_Door_Meters",
  },
  {
    value: "ESRI:103809",
    label: "ESRI:103809 / NAD_1983_HARN_Adj_WI_Douglas_Meters",
  },
  {
    value: "ESRI:103810",
    label: "ESRI:103810 / NAD_1983_HARN_Adj_WI_Dunn_Meters",
  },
  {
    value: "ESRI:103811",
    label: "ESRI:103811 / NAD_1983_HARN_Adj_WI_Florence_Meters",
  },
  {
    value: "ESRI:103812",
    label: "ESRI:103812 / NAD_1983_HARN_Adj_WI_Fond_du_Lac_Meters",
  },
  {
    value: "ESRI:103813",
    label: "ESRI:103813 / NAD_1983_HARN_Adj_WI_Forest_Meters",
  },
  {
    value: "ESRI:103814",
    label: "ESRI:103814 / NAD_1983_HARN_Adj_WI_Grant_Meters",
  },
  {
    value: "ESRI:103815",
    label: "ESRI:103815 / NAD_1983_HARN_Adj_WI_Iowa_Meters",
  },
  {
    value: "ESRI:103816",
    label: "ESRI:103816 / NAD_1983_HARN_Adj_WI_Iron_Meters",
  },
  {
    value: "ESRI:103817",
    label: "ESRI:103817 / NAD_1983_HARN_Adj_WI_Jefferson_Meters",
  },
  {
    value: "ESRI:103818",
    label: "ESRI:103818 / NAD_1983_HARN_Adj_WI_Juneau_Meters",
  },
  {
    value: "ESRI:103819",
    label: "ESRI:103819 / NAD_1983_HARN_Adj_WI_Kenosha_Meters",
  },
  {
    value: "ESRI:103820",
    label: "ESRI:103820 / NAD_1983_HARN_Adj_WI_Kewaunee_Meters",
  },
  {
    value: "ESRI:103821",
    label: "ESRI:103821 / NAD_1983_HARN_Adj_WI_LaCrosse_Meters",
  },
  {
    value: "ESRI:103822",
    label: "ESRI:103822 / NAD_1983_HARN_Adj_WI_Lincoln_Meters",
  },
  {
    value: "ESRI:103823",
    label: "ESRI:103823 / NAD_1983_HARN_Adj_WI_Manitowoc_Meters",
  },
  {
    value: "ESRI:103824",
    label: "ESRI:103824 / NAD_1983_HARN_Adj_WI_Marinette_Meters",
  },
  {
    value: "ESRI:103825",
    label: "ESRI:103825 / NAD_1983_HARN_Adj_WI_Menominee_Meters",
  },
  {
    value: "ESRI:103826",
    label: "ESRI:103826 / NAD_1983_HARN_Adj_WI_Milwaukee_Meters",
  },
  {
    value: "ESRI:103827",
    label: "ESRI:103827 / NAD_1983_HARN_Adj_WI_Oconto_Meters",
  },
  {
    value: "ESRI:103828",
    label: "ESRI:103828 / NAD_1983_HARN_Adj_WI_Outagamie_Meters",
  },
  {
    value: "ESRI:103829",
    label: "ESRI:103829 / NAD_1983_HARN_Adj_WI_Ozaukee_Meters",
  },
  {
    value: "ESRI:103830",
    label: "ESRI:103830 / NAD_1983_HARN_Adj_WI_Polk_Meters",
  },
  {
    value: "ESRI:103831",
    label: "ESRI:103831 / NAD_1983_HARN_Adj_WI_Price_Meters",
  },
  {
    value: "ESRI:103832",
    label: "ESRI:103832 / NAD_1983_HARN_Adj_WI_Racine_Meters",
  },
  {
    value: "ESRI:103833",
    label: "ESRI:103833 / NAD_1983_HARN_Adj_WI_Rock_Meters",
  },
  {
    value: "ESRI:103834",
    label: "ESRI:103834 / NAD_1983_HARN_Adj_WI_Rusk_Meters",
  },
  {
    value: "ESRI:103835",
    label: "ESRI:103835 / NAD_1983_HARN_Adj_WI_St_Croix_Meters",
  },
  {
    value: "ESRI:103836",
    label: "ESRI:103836 / NAD_1983_HARN_Adj_WI_Sauk_Meters",
  },
  {
    value: "ESRI:103837",
    label: "ESRI:103837 / NAD_1983_HARN_Adj_WI_Shawano_Meters",
  },
  {
    value: "ESRI:103838",
    label: "ESRI:103838 / NAD_1983_HARN_Adj_WI_Sheboygan_Meters",
  },
  {
    value: "ESRI:103839",
    label: "ESRI:103839 / NAD_1983_HARN_Adj_WI_Trempealeau_Meters",
  },
  {
    value: "ESRI:103840",
    label: "ESRI:103840 / NAD_1983_HARN_Adj_WI_Washington_Meters",
  },
  {
    value: "ESRI:103841",
    label: "ESRI:103841 / NAD_1983_HARN_Adj_WI_Waukesha_Meters",
  },
  {
    value: "ESRI:103842",
    label: "ESRI:103842 / NAD_1983_HARN_Adj_WI_Waupaca_Meters",
  },
  {
    value: "ESRI:103843",
    label: "ESRI:103843 / NAD_1983_HARN_Adj_WI_Winnebago_Meters",
  },
  {
    value: "ESRI:103844",
    label: "ESRI:103844 / NAD_1983_HARN_Adj_WI_Bayfield_Meters",
  },
  {
    value: "ESRI:103845",
    label: "ESRI:103845 / NAD_1983_HARN_Adj_WI_Burnett_Meters",
  },
  {
    value: "ESRI:103846",
    label: "ESRI:103846 / NAD_1983_HARN_Adj_WI_Chippewa_Meters",
  },
  {
    value: "ESRI:103847",
    label: "ESRI:103847 / NAD_1983_HARN_Adj_WI_Columbia_Meters",
  },
  {
    value: "ESRI:103848",
    label: "ESRI:103848 / NAD_1983_HARN_Adj_WI_Crawford_Meters",
  },
  {
    value: "ESRI:103849",
    label: "ESRI:103849 / NAD_1983_HARN_Adj_WI_Dane_Meters",
  },
  {
    value: "ESRI:103850",
    label: "ESRI:103850 / NAD_1983_HARN_Adj_WI_EauClaire_Meters",
  },
  {
    value: "ESRI:103851",
    label: "ESRI:103851 / NAD_1983_HARN_Adj_WI_Green_Meters",
  },
  {
    value: "ESRI:103852",
    label: "ESRI:103852 / NAD_1983_HARN_Adj_WI_GreenLake_Meters",
  },
  {
    value: "ESRI:103853",
    label: "ESRI:103853 / NAD_1983_HARN_Adj_WI_Jackson_Meters",
  },
  {
    value: "ESRI:103854",
    label: "ESRI:103854 / NAD_1983_HARN_Adj_WI_Lafayette_Meters",
  },
  {
    value: "ESRI:103855",
    label: "ESRI:103855 / NAD_1983_HARN_Adj_WI_Langlade_Meters",
  },
  {
    value: "ESRI:103856",
    label: "ESRI:103856 / NAD_1983_HARN_Adj_WI_Marathon_Meters",
  },
  {
    value: "ESRI:103857",
    label: "ESRI:103857 / NAD_1983_HARN_Adj_WI_Marquette_Meters",
  },
  {
    value: "ESRI:103858",
    label: "ESRI:103858 / NAD_1983_HARN_Adj_WI_Monroe_Meters",
  },
  {
    value: "ESRI:103859",
    label: "ESRI:103859 / NAD_1983_HARN_Adj_WI_Oneida_Meters",
  },
  {
    value: "ESRI:103860",
    label: "ESRI:103860 / NAD_1983_HARN_Adj_WI_Pepin_Meters",
  },
  {
    value: "ESRI:103861",
    label: "ESRI:103861 / NAD_1983_HARN_Adj_WI_Pierce_Meters",
  },
  {
    value: "ESRI:103862",
    label: "ESRI:103862 / NAD_1983_HARN_Adj_WI_Portage_Meters",
  },
  {
    value: "ESRI:103863",
    label: "ESRI:103863 / NAD_1983_HARN_Adj_WI_Richland_Meters",
  },
  {
    value: "ESRI:103864",
    label: "ESRI:103864 / NAD_1983_HARN_Adj_WI_Sawyer_Meters",
  },
  {
    value: "ESRI:103865",
    label: "ESRI:103865 / NAD_1983_HARN_Adj_WI_Taylor_Meters",
  },
  {
    value: "ESRI:103866",
    label: "ESRI:103866 / NAD_1983_HARN_Adj_WI_Vernon_Meters",
  },
  {
    value: "ESRI:103867",
    label: "ESRI:103867 / NAD_1983_HARN_Adj_WI_Vilas_Meters",
  },
  {
    value: "ESRI:103868",
    label: "ESRI:103868 / NAD_1983_HARN_Adj_WI_Walworth_Meters",
  },
  {
    value: "ESRI:103869",
    label: "ESRI:103869 / NAD_1983_HARN_Adj_WI_Washburn_Meters",
  },
  {
    value: "ESRI:103870",
    label: "ESRI:103870 / NAD_1983_HARN_Adj_WI_Waushara_Meters",
  },
  {
    value: "ESRI:103871",
    label: "ESRI:103871 / NAD_1983_HARN_Adj_WI_Wood_Meters",
  },
  { value: "ESRI:103872", label: "ESRI:103872 / GDM2008_LGM2012" },
  {
    value: "ESRI:103873",
    label: "ESRI:103873 / NAD_1983_(CSRS)_v6_UTM_Zone_15N",
  },
  {
    value: "ESRI:103874",
    label: "ESRI:103874 / NAD_1983_(CSRS)_v6_UTM_Zone_16N",
  },
  {
    value: "ESRI:103875",
    label: "ESRI:103875 / NAD_1983_(CSRS)_v6_UTM_Zone_17N",
  },
  {
    value: "ESRI:103876",
    label: "ESRI:103876 / NAD_1983_(CSRS)_v6_UTM_Zone_18N",
  },
  {
    value: "ESRI:103877",
    label: "ESRI:103877 / Moon_2000_North_Pole_Stereographic",
  },
  {
    value: "ESRI:103878",
    label: "ESRI:103878 / Moon_2000_South_Pole_Stereographic",
  },
  {
    value: "ESRI:103879",
    label: "ESRI:103879 / Moon_2000_Far_Side_Lambert_Azimuthal_Equal_Area",
  },
  {
    value: "ESRI:103880",
    label: "ESRI:103880 / Moon_2000_Near_Side_Lambert_Azimuthal_Equal_Area",
  },
  {
    value: "ESRI:103881",
    label: "ESRI:103881 / Moon_2000_Equidistant_Cylindrical",
  },
  { value: "ESRI:103882", label: "ESRI:103882 / Moon_2000_Sinusoidal" },
  {
    value: "ESRI:103883",
    label: "ESRI:103883 / Mars_2000_North_Pole_Stereographic_sphere",
  },
  {
    value: "ESRI:103884",
    label: "ESRI:103884 / Mars_2000_South_Pole_Stereographic_sphere",
  },
  {
    value: "ESRI:103885",
    label: "ESRI:103885 / Mars_2000_Equidistant_Cylindrical_sphere",
  },
  { value: "ESRI:103886", label: "ESRI:103886 / Mars_2000_Sinusoidal_sphere" },
  {
    value: "ESRI:103887",
    label: "ESRI:103887 / Mars_2000_Winkel_Tripel_sphere",
  },
  {
    value: "ESRI:103900",
    label: "ESRI:103900 / NAD_1983_HARN_Adj_WI_Adams_Feet",
  },
  {
    value: "ESRI:103901",
    label: "ESRI:103901 / NAD_1983_HARN_Adj_WI_Ashland_Feet",
  },
  {
    value: "ESRI:103902",
    label: "ESRI:103902 / NAD_1983_HARN_Adj_WI_Barron_Feet",
  },
  {
    value: "ESRI:103903",
    label: "ESRI:103903 / NAD_1983_HARN_Adj_WI_Brown_Feet",
  },
  {
    value: "ESRI:103904",
    label: "ESRI:103904 / NAD_1983_HARN_Adj_WI_Buffalo_Feet",
  },
  {
    value: "ESRI:103905",
    label: "ESRI:103905 / NAD_1983_HARN_Adj_WI_Calumet_Feet",
  },
  {
    value: "ESRI:103906",
    label: "ESRI:103906 / NAD_1983_HARN_Adj_WI_Clark_Feet",
  },
  {
    value: "ESRI:103907",
    label: "ESRI:103907 / NAD_1983_HARN_Adj_WI_Dodge_Feet",
  },
  {
    value: "ESRI:103908",
    label: "ESRI:103908 / NAD_1983_HARN_Adj_WI_Door_Feet",
  },
  {
    value: "ESRI:103909",
    label: "ESRI:103909 / NAD_1983_HARN_Adj_WI_Douglas_Feet",
  },
  {
    value: "ESRI:103910",
    label: "ESRI:103910 / NAD_1983_HARN_Adj_WI_Dunn_Feet",
  },
  {
    value: "ESRI:103911",
    label: "ESRI:103911 / NAD_1983_HARN_Adj_WI_Florence_Feet",
  },
  {
    value: "ESRI:103912",
    label: "ESRI:103912 / NAD_1983_HARN_Adj_WI_Fond_du_Lac_Feet",
  },
  {
    value: "ESRI:103913",
    label: "ESRI:103913 / NAD_1983_HARN_Adj_WI_Forest_Feet",
  },
  {
    value: "ESRI:103914",
    label: "ESRI:103914 / NAD_1983_HARN_Adj_WI_Grant_Feet",
  },
  {
    value: "ESRI:103915",
    label: "ESRI:103915 / NAD_1983_HARN_Adj_WI_Iowa_Feet",
  },
  {
    value: "ESRI:103916",
    label: "ESRI:103916 / NAD_1983_HARN_Adj_WI_Iron_Feet",
  },
  {
    value: "ESRI:103917",
    label: "ESRI:103917 / NAD_1983_HARN_Adj_WI_Jefferson_Feet",
  },
  {
    value: "ESRI:103918",
    label: "ESRI:103918 / NAD_1983_HARN_Adj_WI_Juneau_Feet",
  },
  {
    value: "ESRI:103919",
    label: "ESRI:103919 / NAD_1983_HARN_Adj_WI_Kenosha_Feet",
  },
  {
    value: "ESRI:103920",
    label: "ESRI:103920 / NAD_1983_HARN_Adj_WI_Kewaunee_Feet",
  },
  {
    value: "ESRI:103921",
    label: "ESRI:103921 / NAD_1983_HARN_Adj_WI_LaCrosse_Feet",
  },
  {
    value: "ESRI:103922",
    label: "ESRI:103922 / NAD_1983_HARN_Adj_WI_Lincoln_Feet",
  },
  {
    value: "ESRI:103923",
    label: "ESRI:103923 / NAD_1983_HARN_Adj_WI_Manitowoc_Feet",
  },
  {
    value: "ESRI:103924",
    label: "ESRI:103924 / NAD_1983_HARN_Adj_WI_Marinette_Feet",
  },
  {
    value: "ESRI:103925",
    label: "ESRI:103925 / NAD_1983_HARN_Adj_WI_Menominee_Feet",
  },
  {
    value: "ESRI:103926",
    label: "ESRI:103926 / NAD_1983_HARN_Adj_WI_Milwaukee_Feet",
  },
  {
    value: "ESRI:103927",
    label: "ESRI:103927 / NAD_1983_HARN_Adj_WI_Oconto_Feet",
  },
  {
    value: "ESRI:103928",
    label: "ESRI:103928 / NAD_1983_HARN_Adj_WI_Outagamie_Feet",
  },
  {
    value: "ESRI:103929",
    label: "ESRI:103929 / NAD_1983_HARN_Adj_WI_Ozaukee_Feet",
  },
  {
    value: "ESRI:103930",
    label: "ESRI:103930 / NAD_1983_HARN_Adj_WI_Polk_Feet",
  },
  {
    value: "ESRI:103931",
    label: "ESRI:103931 / NAD_1983_HARN_Adj_WI_Price_Feet",
  },
  {
    value: "ESRI:103932",
    label: "ESRI:103932 / NAD_1983_HARN_Adj_WI_Racine_Feet",
  },
  {
    value: "ESRI:103933",
    label: "ESRI:103933 / NAD_1983_HARN_Adj_WI_Rock_Feet",
  },
  {
    value: "ESRI:103934",
    label: "ESRI:103934 / NAD_1983_HARN_Adj_WI_Rusk_Feet",
  },
  {
    value: "ESRI:103935",
    label: "ESRI:103935 / NAD_1983_HARN_Adj_WI_St_Croix_Feet",
  },
  {
    value: "ESRI:103936",
    label: "ESRI:103936 / NAD_1983_HARN_Adj_WI_Sauk_Feet",
  },
  {
    value: "ESRI:103937",
    label: "ESRI:103937 / NAD_1983_HARN_Adj_WI_Shawano_Feet",
  },
  {
    value: "ESRI:103938",
    label: "ESRI:103938 / NAD_1983_HARN_Adj_WI_Sheboygan_Feet",
  },
  {
    value: "ESRI:103939",
    label: "ESRI:103939 / NAD_1983_HARN_Adj_WI_Trempealeau_Feet",
  },
  {
    value: "ESRI:103940",
    label: "ESRI:103940 / NAD_1983_HARN_Adj_WI_Washington_Feet",
  },
  {
    value: "ESRI:103941",
    label: "ESRI:103941 / NAD_1983_HARN_Adj_WI_Waukesha_Feet",
  },
  {
    value: "ESRI:103942",
    label: "ESRI:103942 / NAD_1983_HARN_Adj_WI_Waupaca_Feet",
  },
  {
    value: "ESRI:103943",
    label: "ESRI:103943 / NAD_1983_HARN_Adj_WI_Winnebago_Feet",
  },
  {
    value: "ESRI:103944",
    label: "ESRI:103944 / NAD_1983_HARN_Adj_WI_Bayfield_Feet",
  },
  {
    value: "ESRI:103945",
    label: "ESRI:103945 / NAD_1983_HARN_Adj_WI_Burnett_Feet",
  },
  {
    value: "ESRI:103946",
    label: "ESRI:103946 / NAD_1983_HARN_Adj_WI_Chippewa_Feet",
  },
  {
    value: "ESRI:103947",
    label: "ESRI:103947 / NAD_1983_HARN_Adj_WI_Columbia_Feet",
  },
  {
    value: "ESRI:103948",
    label: "ESRI:103948 / NAD_1983_HARN_Adj_WI_Crawford_Feet",
  },
  {
    value: "ESRI:103949",
    label: "ESRI:103949 / NAD_1983_HARN_Adj_WI_Dane_Feet",
  },
  {
    value: "ESRI:103950",
    label: "ESRI:103950 / NAD_1983_HARN_Adj_WI_EauClaire_Feet",
  },
  {
    value: "ESRI:103951",
    label: "ESRI:103951 / NAD_1983_HARN_Adj_WI_Green_Feet",
  },
  {
    value: "ESRI:103952",
    label: "ESRI:103952 / NAD_1983_HARN_Adj_WI_GreenLake_Feet",
  },
  {
    value: "ESRI:103953",
    label: "ESRI:103953 / NAD_1983_HARN_Adj_WI_Jackson_Feet",
  },
  {
    value: "ESRI:103954",
    label: "ESRI:103954 / NAD_1983_HARN_Adj_WI_Lafayette_Feet",
  },
  {
    value: "ESRI:103955",
    label: "ESRI:103955 / NAD_1983_HARN_Adj_WI_Langlade_Feet",
  },
  {
    value: "ESRI:103956",
    label: "ESRI:103956 / NAD_1983_HARN_Adj_WI_Marathon_Feet",
  },
  {
    value: "ESRI:103957",
    label: "ESRI:103957 / NAD_1983_HARN_Adj_WI_Marquette_Feet",
  },
  {
    value: "ESRI:103958",
    label: "ESRI:103958 / NAD_1983_HARN_Adj_WI_Monroe_Feet",
  },
  {
    value: "ESRI:103959",
    label: "ESRI:103959 / NAD_1983_HARN_Adj_WI_Oneida_Feet",
  },
  {
    value: "ESRI:103960",
    label: "ESRI:103960 / NAD_1983_HARN_Adj_WI_Pepin_Feet",
  },
  {
    value: "ESRI:103961",
    label: "ESRI:103961 / NAD_1983_HARN_Adj_WI_Pierce_Feet",
  },
  {
    value: "ESRI:103962",
    label: "ESRI:103962 / NAD_1983_HARN_Adj_WI_Portage_Feet",
  },
  {
    value: "ESRI:103963",
    label: "ESRI:103963 / NAD_1983_HARN_Adj_WI_Richland_Feet",
  },
  {
    value: "ESRI:103964",
    label: "ESRI:103964 / NAD_1983_HARN_Adj_WI_Sawyer_Feet",
  },
  {
    value: "ESRI:103965",
    label: "ESRI:103965 / NAD_1983_HARN_Adj_WI_Taylor_Feet",
  },
  {
    value: "ESRI:103966",
    label: "ESRI:103966 / NAD_1983_HARN_Adj_WI_Vernon_Feet",
  },
  {
    value: "ESRI:103967",
    label: "ESRI:103967 / NAD_1983_HARN_Adj_WI_Vilas_Feet",
  },
  {
    value: "ESRI:103968",
    label: "ESRI:103968 / NAD_1983_HARN_Adj_WI_Walworth_Feet",
  },
  {
    value: "ESRI:103969",
    label: "ESRI:103969 / NAD_1983_HARN_Adj_WI_Washburn_Feet",
  },
  {
    value: "ESRI:103970",
    label: "ESRI:103970 / NAD_1983_HARN_Adj_WI_Waushara_Feet",
  },
  {
    value: "ESRI:103971",
    label: "ESRI:103971 / NAD_1983_HARN_Adj_WI_Wood_Feet",
  },
  {
    value: "IAU_2015:1010",
    label:
      "IAU_2015:1010 / Sun (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:1015",
    label:
      "IAU_2015:1015 / Sun (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:1020",
    label:
      "IAU_2015:1020 / Sun (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:1025",
    label:
      "IAU_2015:1025 / Sun (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:1030",
    label: "IAU_2015:1030 / Sun (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:1035",
    label: "IAU_2015:1035 / Sun (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:1040",
    label:
      "IAU_2015:1040 / Sun (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:1045",
    label:
      "IAU_2015:1045 / Sun (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:1050",
    label:
      "IAU_2015:1050 / Sun (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:1055",
    label:
      "IAU_2015:1055 / Sun (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:1060",
    label:
      "IAU_2015:1060 / Sun (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:1065",
    label:
      "IAU_2015:1065 / Sun (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:1070",
    label:
      "IAU_2015:1070 / Sun (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:1075",
    label:
      "IAU_2015:1075 / Sun (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:1080",
    label:
      "IAU_2015:1080 / Sun (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:1085",
    label: "IAU_2015:1085 / Sun (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:19910",
    label:
      "IAU_2015:19910 / Mercury (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:19911",
    label:
      "IAU_2015:19911 / Mercury (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:19912",
    label:
      "IAU_2015:19912 / Mercury (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:19915",
    label:
      "IAU_2015:19915 / Mercury (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:19916",
    label:
      "IAU_2015:19916 / Mercury (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:19917",
    label:
      "IAU_2015:19917 / Mercury (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:19920",
    label:
      "IAU_2015:19920 / Mercury (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:19921",
    label: "IAU_2015:19921 / Mercury (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:19922",
    label: "IAU_2015:19922 / Mercury (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:19925",
    label:
      "IAU_2015:19925 / Mercury (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:19926",
    label:
      "IAU_2015:19926 / Mercury (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:19927",
    label:
      "IAU_2015:19927 / Mercury (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:19930",
    label: "IAU_2015:19930 / Mercury (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:19931",
    label: "IAU_2015:19931 / Mercury (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:19932",
    label: "IAU_2015:19932 / Mercury (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:19935",
    label: "IAU_2015:19935 / Mercury (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:19936",
    label: "IAU_2015:19936 / Mercury (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:19937",
    label: "IAU_2015:19937 / Mercury (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:19940",
    label:
      "IAU_2015:19940 / Mercury (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:19941",
    label: "IAU_2015:19941 / Mercury (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:19942",
    label: "IAU_2015:19942 / Mercury (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:19945",
    label:
      "IAU_2015:19945 / Mercury (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:19946",
    label: "IAU_2015:19946 / Mercury (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:19947",
    label: "IAU_2015:19947 / Mercury (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:19950",
    label:
      "IAU_2015:19950 / Mercury (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:19951",
    label: "IAU_2015:19951 / Mercury (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:19952",
    label: "IAU_2015:19952 / Mercury (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:19955",
    label:
      "IAU_2015:19955 / Mercury (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:19956",
    label: "IAU_2015:19956 / Mercury (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:19957",
    label: "IAU_2015:19957 / Mercury (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:19960",
    label:
      "IAU_2015:19960 / Mercury (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:19961",
    label: "IAU_2015:19961 / Mercury (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:19962",
    label: "IAU_2015:19962 / Mercury (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:19965",
    label:
      "IAU_2015:19965 / Mercury (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:19966",
    label:
      "IAU_2015:19966 / Mercury (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:19967",
    label:
      "IAU_2015:19967 / Mercury (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:19970",
    label:
      "IAU_2015:19970 / Mercury (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:19971",
    label:
      "IAU_2015:19971 / Mercury (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:19972",
    label:
      "IAU_2015:19972 / Mercury (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:19975",
    label:
      "IAU_2015:19975 / Mercury (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:19976",
    label:
      "IAU_2015:19976 / Mercury (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:19977",
    label:
      "IAU_2015:19977 / Mercury (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:19980",
    label:
      "IAU_2015:19980 / Mercury (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:19981",
    label:
      "IAU_2015:19981 / Mercury (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:19982",
    label:
      "IAU_2015:19982 / Mercury (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:19985",
    label:
      "IAU_2015:19985 / Mercury (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:19986",
    label: "IAU_2015:19986 / Mercury (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:19987",
    label: "IAU_2015:19987 / Mercury (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:29910",
    label:
      "IAU_2015:29910 / Venus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:29915",
    label:
      "IAU_2015:29915 / Venus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:29920",
    label:
      "IAU_2015:29920 / Venus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:29925",
    label:
      "IAU_2015:29925 / Venus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:29930",
    label: "IAU_2015:29930 / Venus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:29935",
    label: "IAU_2015:29935 / Venus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:29940",
    label:
      "IAU_2015:29940 / Venus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:29945",
    label:
      "IAU_2015:29945 / Venus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:29950",
    label:
      "IAU_2015:29950 / Venus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:29955",
    label:
      "IAU_2015:29955 / Venus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:29960",
    label:
      "IAU_2015:29960 / Venus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:29965",
    label:
      "IAU_2015:29965 / Venus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:29970",
    label:
      "IAU_2015:29970 / Venus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:29975",
    label:
      "IAU_2015:29975 / Venus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:29980",
    label:
      "IAU_2015:29980 / Venus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:29985",
    label:
      "IAU_2015:29985 / Venus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:30110",
    label:
      "IAU_2015:30110 / Moon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:30115",
    label:
      "IAU_2015:30115 / Moon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:30120",
    label:
      "IAU_2015:30120 / Moon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:30125",
    label:
      "IAU_2015:30125 / Moon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:30130",
    label: "IAU_2015:30130 / Moon (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:30135",
    label: "IAU_2015:30135 / Moon (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:30140",
    label:
      "IAU_2015:30140 / Moon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:30145",
    label:
      "IAU_2015:30145 / Moon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:30150",
    label:
      "IAU_2015:30150 / Moon (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:30155",
    label:
      "IAU_2015:30155 / Moon (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:30160",
    label:
      "IAU_2015:30160 / Moon (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:30165",
    label:
      "IAU_2015:30165 / Moon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:30170",
    label:
      "IAU_2015:30170 / Moon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:30175",
    label:
      "IAU_2015:30175 / Moon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:30180",
    label:
      "IAU_2015:30180 / Moon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:30185",
    label:
      "IAU_2015:30185 / Moon (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:39910",
    label:
      "IAU_2015:39910 / Earth (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:39911",
    label:
      "IAU_2015:39911 / Earth (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:39915",
    label:
      "IAU_2015:39915 / Earth (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:39916",
    label:
      "IAU_2015:39916 / Earth (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:39920",
    label:
      "IAU_2015:39920 / Earth (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:39921",
    label: "IAU_2015:39921 / Earth (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:39925",
    label:
      "IAU_2015:39925 / Earth (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:39926",
    label: "IAU_2015:39926 / Earth (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:39930",
    label: "IAU_2015:39930 / Earth (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:39931",
    label: "IAU_2015:39931 / Earth (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:39935",
    label: "IAU_2015:39935 / Earth (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:39936",
    label: "IAU_2015:39936 / Earth (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:39940",
    label:
      "IAU_2015:39940 / Earth (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:39941",
    label: "IAU_2015:39941 / Earth (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:39945",
    label:
      "IAU_2015:39945 / Earth (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:39946",
    label: "IAU_2015:39946 / Earth (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:39950",
    label:
      "IAU_2015:39950 / Earth (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:39951",
    label: "IAU_2015:39951 / Earth (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:39955",
    label:
      "IAU_2015:39955 / Earth (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:39956",
    label: "IAU_2015:39956 / Earth (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:39960",
    label:
      "IAU_2015:39960 / Earth (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:39961",
    label: "IAU_2015:39961 / Earth (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:39965",
    label:
      "IAU_2015:39965 / Earth (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:39966",
    label: "IAU_2015:39966 / Earth (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:39970",
    label:
      "IAU_2015:39970 / Earth (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:39971",
    label:
      "IAU_2015:39971 / Earth (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:39975",
    label:
      "IAU_2015:39975 / Earth (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:39976",
    label: "IAU_2015:39976 / Earth (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:39980",
    label:
      "IAU_2015:39980 / Earth (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:39981",
    label:
      "IAU_2015:39981 / Earth (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:39985",
    label:
      "IAU_2015:39985 / Earth (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:39986",
    label: "IAU_2015:39986 / Earth (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:40110",
    label:
      "IAU_2015:40110 / Phobos (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:40115",
    label:
      "IAU_2015:40115 / Phobos (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:40120",
    label:
      "IAU_2015:40120 / Phobos (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:40125",
    label:
      "IAU_2015:40125 / Phobos (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:40130",
    label: "IAU_2015:40130 / Phobos (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:40135",
    label: "IAU_2015:40135 / Phobos (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:40140",
    label:
      "IAU_2015:40140 / Phobos (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:40145",
    label:
      "IAU_2015:40145 / Phobos (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:40150",
    label:
      "IAU_2015:40150 / Phobos (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:40155",
    label:
      "IAU_2015:40155 / Phobos (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:40160",
    label:
      "IAU_2015:40160 / Phobos (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:40165",
    label:
      "IAU_2015:40165 / Phobos (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:40170",
    label:
      "IAU_2015:40170 / Phobos (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:40175",
    label:
      "IAU_2015:40175 / Phobos (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:40180",
    label:
      "IAU_2015:40180 / Phobos (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:40185",
    label:
      "IAU_2015:40185 / Phobos (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:40210",
    label:
      "IAU_2015:40210 / Deimos (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:40215",
    label:
      "IAU_2015:40215 / Deimos (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:40220",
    label:
      "IAU_2015:40220 / Deimos (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:40225",
    label:
      "IAU_2015:40225 / Deimos (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:40230",
    label: "IAU_2015:40230 / Deimos (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:40235",
    label: "IAU_2015:40235 / Deimos (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:40240",
    label:
      "IAU_2015:40240 / Deimos (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:40245",
    label:
      "IAU_2015:40245 / Deimos (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:40250",
    label:
      "IAU_2015:40250 / Deimos (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:40255",
    label:
      "IAU_2015:40255 / Deimos (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:40260",
    label:
      "IAU_2015:40260 / Deimos (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:40265",
    label:
      "IAU_2015:40265 / Deimos (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:40270",
    label:
      "IAU_2015:40270 / Deimos (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:40275",
    label:
      "IAU_2015:40275 / Deimos (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:40280",
    label:
      "IAU_2015:40280 / Deimos (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:40285",
    label:
      "IAU_2015:40285 / Deimos (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:49910",
    label:
      "IAU_2015:49910 / Mars (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:49911",
    label:
      "IAU_2015:49911 / Mars (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:49912",
    label:
      "IAU_2015:49912 / Mars (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:49915",
    label:
      "IAU_2015:49915 / Mars (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:49916",
    label:
      "IAU_2015:49916 / Mars (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:49917",
    label:
      "IAU_2015:49917 / Mars (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:49920",
    label:
      "IAU_2015:49920 / Mars (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:49921",
    label: "IAU_2015:49921 / Mars (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:49922",
    label: "IAU_2015:49922 / Mars (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:49925",
    label:
      "IAU_2015:49925 / Mars (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:49926",
    label: "IAU_2015:49926 / Mars (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:49927",
    label: "IAU_2015:49927 / Mars (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:49930",
    label: "IAU_2015:49930 / Mars (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:49931",
    label: "IAU_2015:49931 / Mars (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:49932",
    label: "IAU_2015:49932 / Mars (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:49935",
    label: "IAU_2015:49935 / Mars (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:49936",
    label: "IAU_2015:49936 / Mars (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:49937",
    label: "IAU_2015:49937 / Mars (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:49940",
    label:
      "IAU_2015:49940 / Mars (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:49941",
    label: "IAU_2015:49941 / Mars (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:49942",
    label: "IAU_2015:49942 / Mars (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:49945",
    label:
      "IAU_2015:49945 / Mars (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:49946",
    label: "IAU_2015:49946 / Mars (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:49947",
    label: "IAU_2015:49947 / Mars (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:49950",
    label:
      "IAU_2015:49950 / Mars (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:49951",
    label: "IAU_2015:49951 / Mars (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:49952",
    label: "IAU_2015:49952 / Mars (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:49955",
    label:
      "IAU_2015:49955 / Mars (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:49956",
    label: "IAU_2015:49956 / Mars (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:49957",
    label: "IAU_2015:49957 / Mars (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:49960",
    label:
      "IAU_2015:49960 / Mars (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:49961",
    label: "IAU_2015:49961 / Mars (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:49962",
    label: "IAU_2015:49962 / Mars (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:49965",
    label:
      "IAU_2015:49965 / Mars (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:49966",
    label: "IAU_2015:49966 / Mars (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:49967",
    label: "IAU_2015:49967 / Mars (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:49970",
    label:
      "IAU_2015:49970 / Mars (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:49971",
    label: "IAU_2015:49971 / Mars (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:49972",
    label: "IAU_2015:49972 / Mars (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:49975",
    label:
      "IAU_2015:49975 / Mars (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:49976",
    label: "IAU_2015:49976 / Mars (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:49977",
    label: "IAU_2015:49977 / Mars (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:49980",
    label:
      "IAU_2015:49980 / Mars (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:49981",
    label:
      "IAU_2015:49981 / Mars (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:49982",
    label:
      "IAU_2015:49982 / Mars (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:49985",
    label:
      "IAU_2015:49985 / Mars (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:49986",
    label: "IAU_2015:49986 / Mars (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:49987",
    label: "IAU_2015:49987 / Mars (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50110",
    label:
      "IAU_2015:50110 / Io (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50115",
    label:
      "IAU_2015:50115 / Io (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50120",
    label:
      "IAU_2015:50120 / Io (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50125",
    label:
      "IAU_2015:50125 / Io (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50130",
    label: "IAU_2015:50130 / Io (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50135",
    label: "IAU_2015:50135 / Io (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50140",
    label:
      "IAU_2015:50140 / Io (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50145",
    label:
      "IAU_2015:50145 / Io (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50150",
    label:
      "IAU_2015:50150 / Io (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50155",
    label:
      "IAU_2015:50155 / Io (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50160",
    label:
      "IAU_2015:50160 / Io (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50165",
    label:
      "IAU_2015:50165 / Io (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50170",
    label:
      "IAU_2015:50170 / Io (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50175",
    label:
      "IAU_2015:50175 / Io (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50180",
    label:
      "IAU_2015:50180 / Io (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50185",
    label: "IAU_2015:50185 / Io (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50210",
    label:
      "IAU_2015:50210 / Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50215",
    label:
      "IAU_2015:50215 / Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50220",
    label:
      "IAU_2015:50220 / Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50225",
    label:
      "IAU_2015:50225 / Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50230",
    label: "IAU_2015:50230 / Europa (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50235",
    label: "IAU_2015:50235 / Europa (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50240",
    label:
      "IAU_2015:50240 / Europa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50245",
    label:
      "IAU_2015:50245 / Europa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50250",
    label:
      "IAU_2015:50250 / Europa (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50255",
    label:
      "IAU_2015:50255 / Europa (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50260",
    label:
      "IAU_2015:50260 / Europa (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50265",
    label:
      "IAU_2015:50265 / Europa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50270",
    label:
      "IAU_2015:50270 / Europa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50275",
    label:
      "IAU_2015:50275 / Europa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50280",
    label:
      "IAU_2015:50280 / Europa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50285",
    label:
      "IAU_2015:50285 / Europa (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50310",
    label:
      "IAU_2015:50310 / Ganymede (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50311",
    label:
      "IAU_2015:50311 / Ganymede (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50315",
    label:
      "IAU_2015:50315 / Ganymede (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50316",
    label:
      "IAU_2015:50316 / Ganymede (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50320",
    label:
      "IAU_2015:50320 / Ganymede (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50321",
    label: "IAU_2015:50321 / Ganymede (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50325",
    label:
      "IAU_2015:50325 / Ganymede (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50326",
    label:
      "IAU_2015:50326 / Ganymede (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50330",
    label: "IAU_2015:50330 / Ganymede (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50331",
    label: "IAU_2015:50331 / Ganymede (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:50335",
    label: "IAU_2015:50335 / Ganymede (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50336",
    label: "IAU_2015:50336 / Ganymede (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:50340",
    label:
      "IAU_2015:50340 / Ganymede (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50341",
    label: "IAU_2015:50341 / Ganymede (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50345",
    label:
      "IAU_2015:50345 / Ganymede (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50346",
    label:
      "IAU_2015:50346 / Ganymede (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50350",
    label:
      "IAU_2015:50350 / Ganymede (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50351",
    label: "IAU_2015:50351 / Ganymede (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50355",
    label:
      "IAU_2015:50355 / Ganymede (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50356",
    label: "IAU_2015:50356 / Ganymede (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50360",
    label:
      "IAU_2015:50360 / Ganymede (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50361",
    label: "IAU_2015:50361 / Ganymede (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50365",
    label:
      "IAU_2015:50365 / Ganymede (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50366",
    label:
      "IAU_2015:50366 / Ganymede (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50370",
    label:
      "IAU_2015:50370 / Ganymede (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50371",
    label:
      "IAU_2015:50371 / Ganymede (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50375",
    label:
      "IAU_2015:50375 / Ganymede (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50376",
    label:
      "IAU_2015:50376 / Ganymede (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50380",
    label:
      "IAU_2015:50380 / Ganymede (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50381",
    label:
      "IAU_2015:50381 / Ganymede (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50385",
    label:
      "IAU_2015:50385 / Ganymede (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50386",
    label: "IAU_2015:50386 / Ganymede (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:50410",
    label:
      "IAU_2015:50410 / Callisto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50411",
    label:
      "IAU_2015:50411 / Callisto (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50415",
    label:
      "IAU_2015:50415 / Callisto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50416",
    label:
      "IAU_2015:50416 / Callisto (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50420",
    label:
      "IAU_2015:50420 / Callisto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50421",
    label: "IAU_2015:50421 / Callisto (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50425",
    label:
      "IAU_2015:50425 / Callisto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50426",
    label:
      "IAU_2015:50426 / Callisto (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50430",
    label: "IAU_2015:50430 / Callisto (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50431",
    label: "IAU_2015:50431 / Callisto (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:50435",
    label: "IAU_2015:50435 / Callisto (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50436",
    label: "IAU_2015:50436 / Callisto (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:50440",
    label:
      "IAU_2015:50440 / Callisto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50441",
    label: "IAU_2015:50441 / Callisto (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50445",
    label:
      "IAU_2015:50445 / Callisto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50446",
    label:
      "IAU_2015:50446 / Callisto (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50450",
    label:
      "IAU_2015:50450 / Callisto (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50451",
    label: "IAU_2015:50451 / Callisto (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50455",
    label:
      "IAU_2015:50455 / Callisto (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50456",
    label: "IAU_2015:50456 / Callisto (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50460",
    label:
      "IAU_2015:50460 / Callisto (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50461",
    label: "IAU_2015:50461 / Callisto (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50465",
    label:
      "IAU_2015:50465 / Callisto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50466",
    label:
      "IAU_2015:50466 / Callisto (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50470",
    label:
      "IAU_2015:50470 / Callisto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50471",
    label:
      "IAU_2015:50471 / Callisto (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50475",
    label:
      "IAU_2015:50475 / Callisto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50476",
    label:
      "IAU_2015:50476 / Callisto (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50480",
    label:
      "IAU_2015:50480 / Callisto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50481",
    label:
      "IAU_2015:50481 / Callisto (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50485",
    label:
      "IAU_2015:50485 / Callisto (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50486",
    label: "IAU_2015:50486 / Callisto (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:50510",
    label:
      "IAU_2015:50510 / Amalthea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50515",
    label:
      "IAU_2015:50515 / Amalthea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50520",
    label:
      "IAU_2015:50520 / Amalthea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50525",
    label:
      "IAU_2015:50525 / Amalthea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50530",
    label: "IAU_2015:50530 / Amalthea (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50535",
    label: "IAU_2015:50535 / Amalthea (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50540",
    label:
      "IAU_2015:50540 / Amalthea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50545",
    label:
      "IAU_2015:50545 / Amalthea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50550",
    label:
      "IAU_2015:50550 / Amalthea (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50555",
    label:
      "IAU_2015:50555 / Amalthea (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50560",
    label:
      "IAU_2015:50560 / Amalthea (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50565",
    label:
      "IAU_2015:50565 / Amalthea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50570",
    label:
      "IAU_2015:50570 / Amalthea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50575",
    label:
      "IAU_2015:50575 / Amalthea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50580",
    label:
      "IAU_2015:50580 / Amalthea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50585",
    label:
      "IAU_2015:50585 / Amalthea (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50610",
    label:
      "IAU_2015:50610 / Himalia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50615",
    label:
      "IAU_2015:50615 / Himalia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50620",
    label:
      "IAU_2015:50620 / Himalia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50625",
    label:
      "IAU_2015:50625 / Himalia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50630",
    label: "IAU_2015:50630 / Himalia (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50635",
    label: "IAU_2015:50635 / Himalia (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50640",
    label:
      "IAU_2015:50640 / Himalia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50645",
    label:
      "IAU_2015:50645 / Himalia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50650",
    label:
      "IAU_2015:50650 / Himalia (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50655",
    label:
      "IAU_2015:50655 / Himalia (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50660",
    label:
      "IAU_2015:50660 / Himalia (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50665",
    label:
      "IAU_2015:50665 / Himalia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50670",
    label:
      "IAU_2015:50670 / Himalia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50675",
    label:
      "IAU_2015:50675 / Himalia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50680",
    label:
      "IAU_2015:50680 / Himalia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50685",
    label:
      "IAU_2015:50685 / Himalia (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50710",
    label:
      "IAU_2015:50710 / Elara (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50715",
    label:
      "IAU_2015:50715 / Elara (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50720",
    label:
      "IAU_2015:50720 / Elara (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50725",
    label:
      "IAU_2015:50725 / Elara (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50730",
    label: "IAU_2015:50730 / Elara (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50735",
    label: "IAU_2015:50735 / Elara (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50740",
    label:
      "IAU_2015:50740 / Elara (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50745",
    label:
      "IAU_2015:50745 / Elara (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50750",
    label:
      "IAU_2015:50750 / Elara (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50755",
    label:
      "IAU_2015:50755 / Elara (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50760",
    label:
      "IAU_2015:50760 / Elara (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50765",
    label:
      "IAU_2015:50765 / Elara (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50770",
    label:
      "IAU_2015:50770 / Elara (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50775",
    label:
      "IAU_2015:50775 / Elara (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50780",
    label:
      "IAU_2015:50780 / Elara (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50785",
    label:
      "IAU_2015:50785 / Elara (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50810",
    label:
      "IAU_2015:50810 / Pasiphae (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50815",
    label:
      "IAU_2015:50815 / Pasiphae (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50820",
    label:
      "IAU_2015:50820 / Pasiphae (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50825",
    label:
      "IAU_2015:50825 / Pasiphae (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50830",
    label: "IAU_2015:50830 / Pasiphae (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50835",
    label: "IAU_2015:50835 / Pasiphae (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50840",
    label:
      "IAU_2015:50840 / Pasiphae (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50845",
    label:
      "IAU_2015:50845 / Pasiphae (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50850",
    label:
      "IAU_2015:50850 / Pasiphae (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50855",
    label:
      "IAU_2015:50855 / Pasiphae (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50860",
    label:
      "IAU_2015:50860 / Pasiphae (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50865",
    label:
      "IAU_2015:50865 / Pasiphae (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50870",
    label:
      "IAU_2015:50870 / Pasiphae (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50875",
    label:
      "IAU_2015:50875 / Pasiphae (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50880",
    label:
      "IAU_2015:50880 / Pasiphae (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50885",
    label:
      "IAU_2015:50885 / Pasiphae (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:50910",
    label:
      "IAU_2015:50910 / Sinope (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:50915",
    label:
      "IAU_2015:50915 / Sinope (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:50920",
    label:
      "IAU_2015:50920 / Sinope (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:50925",
    label:
      "IAU_2015:50925 / Sinope (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:50930",
    label: "IAU_2015:50930 / Sinope (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:50935",
    label: "IAU_2015:50935 / Sinope (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:50940",
    label:
      "IAU_2015:50940 / Sinope (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:50945",
    label:
      "IAU_2015:50945 / Sinope (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:50950",
    label:
      "IAU_2015:50950 / Sinope (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:50955",
    label:
      "IAU_2015:50955 / Sinope (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:50960",
    label:
      "IAU_2015:50960 / Sinope (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:50965",
    label:
      "IAU_2015:50965 / Sinope (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:50970",
    label:
      "IAU_2015:50970 / Sinope (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:50975",
    label:
      "IAU_2015:50975 / Sinope (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:50980",
    label:
      "IAU_2015:50980 / Sinope (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:50985",
    label:
      "IAU_2015:50985 / Sinope (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51010",
    label:
      "IAU_2015:51010 / Lysithea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51015",
    label:
      "IAU_2015:51015 / Lysithea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51020",
    label:
      "IAU_2015:51020 / Lysithea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51025",
    label:
      "IAU_2015:51025 / Lysithea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51030",
    label: "IAU_2015:51030 / Lysithea (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51035",
    label: "IAU_2015:51035 / Lysithea (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51040",
    label:
      "IAU_2015:51040 / Lysithea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51045",
    label:
      "IAU_2015:51045 / Lysithea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51050",
    label:
      "IAU_2015:51050 / Lysithea (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51055",
    label:
      "IAU_2015:51055 / Lysithea (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51060",
    label:
      "IAU_2015:51060 / Lysithea (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51065",
    label:
      "IAU_2015:51065 / Lysithea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51070",
    label:
      "IAU_2015:51070 / Lysithea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51075",
    label:
      "IAU_2015:51075 / Lysithea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51080",
    label:
      "IAU_2015:51080 / Lysithea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51085",
    label:
      "IAU_2015:51085 / Lysithea (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51110",
    label:
      "IAU_2015:51110 / Carme (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51115",
    label:
      "IAU_2015:51115 / Carme (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51120",
    label:
      "IAU_2015:51120 / Carme (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51125",
    label:
      "IAU_2015:51125 / Carme (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51130",
    label: "IAU_2015:51130 / Carme (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51135",
    label: "IAU_2015:51135 / Carme (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51140",
    label:
      "IAU_2015:51140 / Carme (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51145",
    label:
      "IAU_2015:51145 / Carme (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51150",
    label:
      "IAU_2015:51150 / Carme (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51155",
    label:
      "IAU_2015:51155 / Carme (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51160",
    label:
      "IAU_2015:51160 / Carme (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51165",
    label:
      "IAU_2015:51165 / Carme (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51170",
    label:
      "IAU_2015:51170 / Carme (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51175",
    label:
      "IAU_2015:51175 / Carme (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51180",
    label:
      "IAU_2015:51180 / Carme (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51185",
    label:
      "IAU_2015:51185 / Carme (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51210",
    label:
      "IAU_2015:51210 / Ananke (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51215",
    label:
      "IAU_2015:51215 / Ananke (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51220",
    label:
      "IAU_2015:51220 / Ananke (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51225",
    label:
      "IAU_2015:51225 / Ananke (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51230",
    label: "IAU_2015:51230 / Ananke (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51235",
    label: "IAU_2015:51235 / Ananke (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51240",
    label:
      "IAU_2015:51240 / Ananke (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51245",
    label:
      "IAU_2015:51245 / Ananke (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51250",
    label:
      "IAU_2015:51250 / Ananke (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51255",
    label:
      "IAU_2015:51255 / Ananke (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51260",
    label:
      "IAU_2015:51260 / Ananke (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51265",
    label:
      "IAU_2015:51265 / Ananke (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51270",
    label:
      "IAU_2015:51270 / Ananke (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51275",
    label:
      "IAU_2015:51275 / Ananke (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51280",
    label:
      "IAU_2015:51280 / Ananke (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51285",
    label:
      "IAU_2015:51285 / Ananke (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51310",
    label:
      "IAU_2015:51310 / Leda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51315",
    label:
      "IAU_2015:51315 / Leda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51320",
    label:
      "IAU_2015:51320 / Leda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51325",
    label:
      "IAU_2015:51325 / Leda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51330",
    label: "IAU_2015:51330 / Leda (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51335",
    label: "IAU_2015:51335 / Leda (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51340",
    label:
      "IAU_2015:51340 / Leda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51345",
    label:
      "IAU_2015:51345 / Leda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51350",
    label:
      "IAU_2015:51350 / Leda (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51355",
    label:
      "IAU_2015:51355 / Leda (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51360",
    label:
      "IAU_2015:51360 / Leda (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51365",
    label:
      "IAU_2015:51365 / Leda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51370",
    label:
      "IAU_2015:51370 / Leda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51375",
    label:
      "IAU_2015:51375 / Leda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51380",
    label:
      "IAU_2015:51380 / Leda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51385",
    label:
      "IAU_2015:51385 / Leda (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51410",
    label:
      "IAU_2015:51410 / Thebe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51415",
    label:
      "IAU_2015:51415 / Thebe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51420",
    label:
      "IAU_2015:51420 / Thebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51425",
    label:
      "IAU_2015:51425 / Thebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51430",
    label: "IAU_2015:51430 / Thebe (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51435",
    label: "IAU_2015:51435 / Thebe (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51440",
    label:
      "IAU_2015:51440 / Thebe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51445",
    label:
      "IAU_2015:51445 / Thebe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51450",
    label:
      "IAU_2015:51450 / Thebe (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51455",
    label:
      "IAU_2015:51455 / Thebe (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51460",
    label:
      "IAU_2015:51460 / Thebe (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51465",
    label:
      "IAU_2015:51465 / Thebe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51470",
    label:
      "IAU_2015:51470 / Thebe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51475",
    label:
      "IAU_2015:51475 / Thebe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51480",
    label:
      "IAU_2015:51480 / Thebe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51485",
    label:
      "IAU_2015:51485 / Thebe (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51510",
    label:
      "IAU_2015:51510 / Adrastea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51515",
    label:
      "IAU_2015:51515 / Adrastea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51520",
    label:
      "IAU_2015:51520 / Adrastea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51525",
    label:
      "IAU_2015:51525 / Adrastea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51530",
    label: "IAU_2015:51530 / Adrastea (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51535",
    label: "IAU_2015:51535 / Adrastea (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51540",
    label:
      "IAU_2015:51540 / Adrastea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51545",
    label:
      "IAU_2015:51545 / Adrastea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51550",
    label:
      "IAU_2015:51550 / Adrastea (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51555",
    label:
      "IAU_2015:51555 / Adrastea (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51560",
    label:
      "IAU_2015:51560 / Adrastea (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51565",
    label:
      "IAU_2015:51565 / Adrastea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51570",
    label:
      "IAU_2015:51570 / Adrastea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51575",
    label:
      "IAU_2015:51575 / Adrastea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51580",
    label:
      "IAU_2015:51580 / Adrastea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51585",
    label:
      "IAU_2015:51585 / Adrastea (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:51610",
    label:
      "IAU_2015:51610 / Metis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:51615",
    label:
      "IAU_2015:51615 / Metis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:51620",
    label:
      "IAU_2015:51620 / Metis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:51625",
    label:
      "IAU_2015:51625 / Metis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:51630",
    label: "IAU_2015:51630 / Metis (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:51635",
    label: "IAU_2015:51635 / Metis (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:51640",
    label:
      "IAU_2015:51640 / Metis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:51645",
    label:
      "IAU_2015:51645 / Metis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:51650",
    label:
      "IAU_2015:51650 / Metis (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:51655",
    label:
      "IAU_2015:51655 / Metis (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:51660",
    label:
      "IAU_2015:51660 / Metis (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:51665",
    label:
      "IAU_2015:51665 / Metis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:51670",
    label:
      "IAU_2015:51670 / Metis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:51675",
    label:
      "IAU_2015:51675 / Metis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:51680",
    label:
      "IAU_2015:51680 / Metis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:51685",
    label:
      "IAU_2015:51685 / Metis (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:59910",
    label:
      "IAU_2015:59910 / Jupiter (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:59911",
    label:
      "IAU_2015:59911 / Jupiter (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:59912",
    label:
      "IAU_2015:59912 / Jupiter (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:59915",
    label:
      "IAU_2015:59915 / Jupiter (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:59916",
    label:
      "IAU_2015:59916 / Jupiter (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:59917",
    label:
      "IAU_2015:59917 / Jupiter (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:59920",
    label:
      "IAU_2015:59920 / Jupiter (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:59921",
    label: "IAU_2015:59921 / Jupiter (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:59922",
    label: "IAU_2015:59922 / Jupiter (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:59925",
    label:
      "IAU_2015:59925 / Jupiter (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:59926",
    label:
      "IAU_2015:59926 / Jupiter (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:59927",
    label:
      "IAU_2015:59927 / Jupiter (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:59930",
    label: "IAU_2015:59930 / Jupiter (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:59931",
    label: "IAU_2015:59931 / Jupiter (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:59932",
    label: "IAU_2015:59932 / Jupiter (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:59935",
    label: "IAU_2015:59935 / Jupiter (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:59936",
    label: "IAU_2015:59936 / Jupiter (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:59937",
    label: "IAU_2015:59937 / Jupiter (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:59940",
    label:
      "IAU_2015:59940 / Jupiter (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:59941",
    label: "IAU_2015:59941 / Jupiter (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:59942",
    label: "IAU_2015:59942 / Jupiter (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:59945",
    label:
      "IAU_2015:59945 / Jupiter (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:59946",
    label: "IAU_2015:59946 / Jupiter (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:59947",
    label: "IAU_2015:59947 / Jupiter (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:59950",
    label:
      "IAU_2015:59950 / Jupiter (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:59951",
    label: "IAU_2015:59951 / Jupiter (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:59952",
    label: "IAU_2015:59952 / Jupiter (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:59955",
    label:
      "IAU_2015:59955 / Jupiter (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:59956",
    label: "IAU_2015:59956 / Jupiter (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:59957",
    label: "IAU_2015:59957 / Jupiter (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:59960",
    label:
      "IAU_2015:59960 / Jupiter (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:59961",
    label: "IAU_2015:59961 / Jupiter (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:59962",
    label: "IAU_2015:59962 / Jupiter (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:59965",
    label:
      "IAU_2015:59965 / Jupiter (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:59966",
    label:
      "IAU_2015:59966 / Jupiter (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:59967",
    label:
      "IAU_2015:59967 / Jupiter (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:59970",
    label:
      "IAU_2015:59970 / Jupiter (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:59971",
    label:
      "IAU_2015:59971 / Jupiter (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:59972",
    label:
      "IAU_2015:59972 / Jupiter (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:59975",
    label:
      "IAU_2015:59975 / Jupiter (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:59976",
    label:
      "IAU_2015:59976 / Jupiter (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:59977",
    label:
      "IAU_2015:59977 / Jupiter (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:59980",
    label:
      "IAU_2015:59980 / Jupiter (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:59981",
    label:
      "IAU_2015:59981 / Jupiter (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:59982",
    label:
      "IAU_2015:59982 / Jupiter (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:59985",
    label:
      "IAU_2015:59985 / Jupiter (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:59986",
    label: "IAU_2015:59986 / Jupiter (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:59987",
    label: "IAU_2015:59987 / Jupiter (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60110",
    label:
      "IAU_2015:60110 / Mimas (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60115",
    label:
      "IAU_2015:60115 / Mimas (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60120",
    label:
      "IAU_2015:60120 / Mimas (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60125",
    label:
      "IAU_2015:60125 / Mimas (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60130",
    label: "IAU_2015:60130 / Mimas (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60135",
    label: "IAU_2015:60135 / Mimas (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60140",
    label:
      "IAU_2015:60140 / Mimas (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60145",
    label:
      "IAU_2015:60145 / Mimas (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60150",
    label:
      "IAU_2015:60150 / Mimas (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60155",
    label:
      "IAU_2015:60155 / Mimas (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60160",
    label:
      "IAU_2015:60160 / Mimas (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60165",
    label:
      "IAU_2015:60165 / Mimas (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60170",
    label:
      "IAU_2015:60170 / Mimas (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60175",
    label:
      "IAU_2015:60175 / Mimas (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60180",
    label:
      "IAU_2015:60180 / Mimas (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60185",
    label:
      "IAU_2015:60185 / Mimas (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60210",
    label:
      "IAU_2015:60210 / Enceladus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60215",
    label:
      "IAU_2015:60215 / Enceladus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60220",
    label:
      "IAU_2015:60220 / Enceladus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60225",
    label:
      "IAU_2015:60225 / Enceladus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60230",
    label:
      "IAU_2015:60230 / Enceladus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60235",
    label:
      "IAU_2015:60235 / Enceladus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60240",
    label:
      "IAU_2015:60240 / Enceladus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60245",
    label:
      "IAU_2015:60245 / Enceladus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60250",
    label:
      "IAU_2015:60250 / Enceladus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60255",
    label:
      "IAU_2015:60255 / Enceladus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60260",
    label:
      "IAU_2015:60260 / Enceladus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60265",
    label:
      "IAU_2015:60265 / Enceladus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60270",
    label:
      "IAU_2015:60270 / Enceladus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60275",
    label:
      "IAU_2015:60275 / Enceladus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60280",
    label:
      "IAU_2015:60280 / Enceladus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60285",
    label:
      "IAU_2015:60285 / Enceladus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60310",
    label:
      "IAU_2015:60310 / Tethys (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60315",
    label:
      "IAU_2015:60315 / Tethys (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60320",
    label:
      "IAU_2015:60320 / Tethys (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60325",
    label:
      "IAU_2015:60325 / Tethys (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60330",
    label: "IAU_2015:60330 / Tethys (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60335",
    label: "IAU_2015:60335 / Tethys (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60340",
    label:
      "IAU_2015:60340 / Tethys (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60345",
    label:
      "IAU_2015:60345 / Tethys (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60350",
    label:
      "IAU_2015:60350 / Tethys (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60355",
    label:
      "IAU_2015:60355 / Tethys (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60360",
    label:
      "IAU_2015:60360 / Tethys (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60365",
    label:
      "IAU_2015:60365 / Tethys (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60370",
    label:
      "IAU_2015:60370 / Tethys (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60375",
    label:
      "IAU_2015:60375 / Tethys (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60380",
    label:
      "IAU_2015:60380 / Tethys (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60385",
    label:
      "IAU_2015:60385 / Tethys (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60410",
    label:
      "IAU_2015:60410 / Dione (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60415",
    label:
      "IAU_2015:60415 / Dione (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60420",
    label:
      "IAU_2015:60420 / Dione (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60425",
    label:
      "IAU_2015:60425 / Dione (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60430",
    label: "IAU_2015:60430 / Dione (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60435",
    label: "IAU_2015:60435 / Dione (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60440",
    label:
      "IAU_2015:60440 / Dione (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60445",
    label:
      "IAU_2015:60445 / Dione (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60450",
    label:
      "IAU_2015:60450 / Dione (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60455",
    label:
      "IAU_2015:60455 / Dione (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60460",
    label:
      "IAU_2015:60460 / Dione (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60465",
    label:
      "IAU_2015:60465 / Dione (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60470",
    label:
      "IAU_2015:60470 / Dione (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60475",
    label:
      "IAU_2015:60475 / Dione (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60480",
    label:
      "IAU_2015:60480 / Dione (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60485",
    label:
      "IAU_2015:60485 / Dione (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60510",
    label:
      "IAU_2015:60510 / Rhea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60515",
    label:
      "IAU_2015:60515 / Rhea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60520",
    label:
      "IAU_2015:60520 / Rhea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60525",
    label:
      "IAU_2015:60525 / Rhea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60530",
    label: "IAU_2015:60530 / Rhea (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60535",
    label: "IAU_2015:60535 / Rhea (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60540",
    label:
      "IAU_2015:60540 / Rhea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60545",
    label:
      "IAU_2015:60545 / Rhea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60550",
    label:
      "IAU_2015:60550 / Rhea (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60555",
    label:
      "IAU_2015:60555 / Rhea (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60560",
    label:
      "IAU_2015:60560 / Rhea (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60565",
    label:
      "IAU_2015:60565 / Rhea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60570",
    label:
      "IAU_2015:60570 / Rhea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60575",
    label:
      "IAU_2015:60575 / Rhea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60580",
    label:
      "IAU_2015:60580 / Rhea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60585",
    label:
      "IAU_2015:60585 / Rhea (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60610",
    label:
      "IAU_2015:60610 / Titan (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60615",
    label:
      "IAU_2015:60615 / Titan (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60620",
    label:
      "IAU_2015:60620 / Titan (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60625",
    label:
      "IAU_2015:60625 / Titan (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60630",
    label: "IAU_2015:60630 / Titan (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60635",
    label: "IAU_2015:60635 / Titan (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60640",
    label:
      "IAU_2015:60640 / Titan (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60645",
    label:
      "IAU_2015:60645 / Titan (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60650",
    label:
      "IAU_2015:60650 / Titan (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60655",
    label:
      "IAU_2015:60655 / Titan (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60660",
    label:
      "IAU_2015:60660 / Titan (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60665",
    label:
      "IAU_2015:60665 / Titan (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60670",
    label:
      "IAU_2015:60670 / Titan (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60675",
    label:
      "IAU_2015:60675 / Titan (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60680",
    label:
      "IAU_2015:60680 / Titan (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60685",
    label:
      "IAU_2015:60685 / Titan (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60710",
    label:
      "IAU_2015:60710 / Hyperion (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60715",
    label:
      "IAU_2015:60715 / Hyperion (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60720",
    label:
      "IAU_2015:60720 / Hyperion (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60725",
    label:
      "IAU_2015:60725 / Hyperion (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60730",
    label: "IAU_2015:60730 / Hyperion (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60735",
    label: "IAU_2015:60735 / Hyperion (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60740",
    label:
      "IAU_2015:60740 / Hyperion (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60745",
    label:
      "IAU_2015:60745 / Hyperion (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60750",
    label:
      "IAU_2015:60750 / Hyperion (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60755",
    label:
      "IAU_2015:60755 / Hyperion (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60760",
    label:
      "IAU_2015:60760 / Hyperion (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60765",
    label:
      "IAU_2015:60765 / Hyperion (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60770",
    label:
      "IAU_2015:60770 / Hyperion (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60775",
    label:
      "IAU_2015:60775 / Hyperion (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60780",
    label:
      "IAU_2015:60780 / Hyperion (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60785",
    label:
      "IAU_2015:60785 / Hyperion (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60810",
    label:
      "IAU_2015:60810 / Iapetus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60811",
    label:
      "IAU_2015:60811 / Iapetus (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60812",
    label:
      "IAU_2015:60812 / Iapetus (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60815",
    label:
      "IAU_2015:60815 / Iapetus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60816",
    label:
      "IAU_2015:60816 / Iapetus (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60817",
    label:
      "IAU_2015:60817 / Iapetus (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60820",
    label:
      "IAU_2015:60820 / Iapetus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60821",
    label: "IAU_2015:60821 / Iapetus (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60822",
    label: "IAU_2015:60822 / Iapetus (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60825",
    label:
      "IAU_2015:60825 / Iapetus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60826",
    label:
      "IAU_2015:60826 / Iapetus (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60827",
    label:
      "IAU_2015:60827 / Iapetus (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60830",
    label: "IAU_2015:60830 / Iapetus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60831",
    label: "IAU_2015:60831 / Iapetus (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:60832",
    label: "IAU_2015:60832 / Iapetus (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60835",
    label: "IAU_2015:60835 / Iapetus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60836",
    label: "IAU_2015:60836 / Iapetus (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:60837",
    label: "IAU_2015:60837 / Iapetus (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60840",
    label:
      "IAU_2015:60840 / Iapetus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60841",
    label: "IAU_2015:60841 / Iapetus (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60842",
    label: "IAU_2015:60842 / Iapetus (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60845",
    label:
      "IAU_2015:60845 / Iapetus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60846",
    label: "IAU_2015:60846 / Iapetus (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60847",
    label: "IAU_2015:60847 / Iapetus (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60850",
    label:
      "IAU_2015:60850 / Iapetus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60851",
    label: "IAU_2015:60851 / Iapetus (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60852",
    label: "IAU_2015:60852 / Iapetus (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60855",
    label:
      "IAU_2015:60855 / Iapetus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60856",
    label: "IAU_2015:60856 / Iapetus (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60857",
    label: "IAU_2015:60857 / Iapetus (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60860",
    label:
      "IAU_2015:60860 / Iapetus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60861",
    label: "IAU_2015:60861 / Iapetus (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60862",
    label: "IAU_2015:60862 / Iapetus (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60865",
    label:
      "IAU_2015:60865 / Iapetus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60866",
    label:
      "IAU_2015:60866 / Iapetus (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60867",
    label:
      "IAU_2015:60867 / Iapetus (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60870",
    label:
      "IAU_2015:60870 / Iapetus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60871",
    label:
      "IAU_2015:60871 / Iapetus (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60872",
    label:
      "IAU_2015:60872 / Iapetus (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60875",
    label:
      "IAU_2015:60875 / Iapetus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60876",
    label:
      "IAU_2015:60876 / Iapetus (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60877",
    label:
      "IAU_2015:60877 / Iapetus (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60880",
    label:
      "IAU_2015:60880 / Iapetus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60881",
    label:
      "IAU_2015:60881 / Iapetus (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60882",
    label:
      "IAU_2015:60882 / Iapetus (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60885",
    label:
      "IAU_2015:60885 / Iapetus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60886",
    label: "IAU_2015:60886 / Iapetus (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:60887",
    label: "IAU_2015:60887 / Iapetus (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:60910",
    label:
      "IAU_2015:60910 / Phoebe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:60915",
    label:
      "IAU_2015:60915 / Phoebe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:60920",
    label:
      "IAU_2015:60920 / Phoebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:60925",
    label:
      "IAU_2015:60925 / Phoebe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:60930",
    label: "IAU_2015:60930 / Phoebe (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:60935",
    label: "IAU_2015:60935 / Phoebe (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:60940",
    label:
      "IAU_2015:60940 / Phoebe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:60945",
    label:
      "IAU_2015:60945 / Phoebe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:60950",
    label:
      "IAU_2015:60950 / Phoebe (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:60955",
    label:
      "IAU_2015:60955 / Phoebe (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:60960",
    label:
      "IAU_2015:60960 / Phoebe (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:60965",
    label:
      "IAU_2015:60965 / Phoebe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:60970",
    label:
      "IAU_2015:60970 / Phoebe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:60975",
    label:
      "IAU_2015:60975 / Phoebe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:60980",
    label:
      "IAU_2015:60980 / Phoebe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:60985",
    label:
      "IAU_2015:60985 / Phoebe (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61010",
    label:
      "IAU_2015:61010 / Janus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61015",
    label:
      "IAU_2015:61015 / Janus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61020",
    label:
      "IAU_2015:61020 / Janus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61025",
    label:
      "IAU_2015:61025 / Janus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61030",
    label: "IAU_2015:61030 / Janus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61035",
    label: "IAU_2015:61035 / Janus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61040",
    label:
      "IAU_2015:61040 / Janus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61045",
    label:
      "IAU_2015:61045 / Janus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61050",
    label:
      "IAU_2015:61050 / Janus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61055",
    label:
      "IAU_2015:61055 / Janus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61060",
    label:
      "IAU_2015:61060 / Janus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61065",
    label:
      "IAU_2015:61065 / Janus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61070",
    label:
      "IAU_2015:61070 / Janus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61075",
    label:
      "IAU_2015:61075 / Janus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61080",
    label:
      "IAU_2015:61080 / Janus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61085",
    label:
      "IAU_2015:61085 / Janus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61110",
    label:
      "IAU_2015:61110 / Epimetheus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61115",
    label:
      "IAU_2015:61115 / Epimetheus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61120",
    label:
      "IAU_2015:61120 / Epimetheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61125",
    label:
      "IAU_2015:61125 / Epimetheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61130",
    label:
      "IAU_2015:61130 / Epimetheus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61135",
    label:
      "IAU_2015:61135 / Epimetheus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61140",
    label:
      "IAU_2015:61140 / Epimetheus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61145",
    label:
      "IAU_2015:61145 / Epimetheus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61150",
    label:
      "IAU_2015:61150 / Epimetheus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61155",
    label:
      "IAU_2015:61155 / Epimetheus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61160",
    label:
      "IAU_2015:61160 / Epimetheus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61165",
    label:
      "IAU_2015:61165 / Epimetheus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61170",
    label:
      "IAU_2015:61170 / Epimetheus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61175",
    label:
      "IAU_2015:61175 / Epimetheus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61180",
    label:
      "IAU_2015:61180 / Epimetheus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61185",
    label:
      "IAU_2015:61185 / Epimetheus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61210",
    label:
      "IAU_2015:61210 / Helene (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61215",
    label:
      "IAU_2015:61215 / Helene (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61220",
    label:
      "IAU_2015:61220 / Helene (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61225",
    label:
      "IAU_2015:61225 / Helene (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61230",
    label: "IAU_2015:61230 / Helene (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61235",
    label: "IAU_2015:61235 / Helene (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61240",
    label:
      "IAU_2015:61240 / Helene (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61245",
    label:
      "IAU_2015:61245 / Helene (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61250",
    label:
      "IAU_2015:61250 / Helene (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61255",
    label:
      "IAU_2015:61255 / Helene (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61260",
    label:
      "IAU_2015:61260 / Helene (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61265",
    label:
      "IAU_2015:61265 / Helene (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61270",
    label:
      "IAU_2015:61270 / Helene (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61275",
    label:
      "IAU_2015:61275 / Helene (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61280",
    label:
      "IAU_2015:61280 / Helene (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61285",
    label:
      "IAU_2015:61285 / Helene (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61310",
    label:
      "IAU_2015:61310 / Telesto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61315",
    label:
      "IAU_2015:61315 / Telesto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61320",
    label:
      "IAU_2015:61320 / Telesto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61325",
    label:
      "IAU_2015:61325 / Telesto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61330",
    label: "IAU_2015:61330 / Telesto (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61335",
    label: "IAU_2015:61335 / Telesto (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61340",
    label:
      "IAU_2015:61340 / Telesto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61345",
    label:
      "IAU_2015:61345 / Telesto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61350",
    label:
      "IAU_2015:61350 / Telesto (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61355",
    label:
      "IAU_2015:61355 / Telesto (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61360",
    label:
      "IAU_2015:61360 / Telesto (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61365",
    label:
      "IAU_2015:61365 / Telesto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61370",
    label:
      "IAU_2015:61370 / Telesto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61375",
    label:
      "IAU_2015:61375 / Telesto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61380",
    label:
      "IAU_2015:61380 / Telesto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61385",
    label:
      "IAU_2015:61385 / Telesto (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61410",
    label:
      "IAU_2015:61410 / Calypso (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61415",
    label:
      "IAU_2015:61415 / Calypso (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61420",
    label:
      "IAU_2015:61420 / Calypso (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61425",
    label:
      "IAU_2015:61425 / Calypso (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61430",
    label: "IAU_2015:61430 / Calypso (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61435",
    label: "IAU_2015:61435 / Calypso (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61440",
    label:
      "IAU_2015:61440 / Calypso (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61445",
    label:
      "IAU_2015:61445 / Calypso (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61450",
    label:
      "IAU_2015:61450 / Calypso (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61455",
    label:
      "IAU_2015:61455 / Calypso (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61460",
    label:
      "IAU_2015:61460 / Calypso (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61465",
    label:
      "IAU_2015:61465 / Calypso (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61470",
    label:
      "IAU_2015:61470 / Calypso (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61475",
    label:
      "IAU_2015:61475 / Calypso (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61480",
    label:
      "IAU_2015:61480 / Calypso (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61485",
    label:
      "IAU_2015:61485 / Calypso (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61510",
    label:
      "IAU_2015:61510 / Atlas (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61515",
    label:
      "IAU_2015:61515 / Atlas (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61520",
    label:
      "IAU_2015:61520 / Atlas (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61525",
    label:
      "IAU_2015:61525 / Atlas (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61530",
    label: "IAU_2015:61530 / Atlas (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61535",
    label: "IAU_2015:61535 / Atlas (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61540",
    label:
      "IAU_2015:61540 / Atlas (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61545",
    label:
      "IAU_2015:61545 / Atlas (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61550",
    label:
      "IAU_2015:61550 / Atlas (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61555",
    label:
      "IAU_2015:61555 / Atlas (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61560",
    label:
      "IAU_2015:61560 / Atlas (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61565",
    label:
      "IAU_2015:61565 / Atlas (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61570",
    label:
      "IAU_2015:61570 / Atlas (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61575",
    label:
      "IAU_2015:61575 / Atlas (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61580",
    label:
      "IAU_2015:61580 / Atlas (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61585",
    label:
      "IAU_2015:61585 / Atlas (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61610",
    label:
      "IAU_2015:61610 / Prometheus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61615",
    label:
      "IAU_2015:61615 / Prometheus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61620",
    label:
      "IAU_2015:61620 / Prometheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61625",
    label:
      "IAU_2015:61625 / Prometheus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61630",
    label:
      "IAU_2015:61630 / Prometheus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61635",
    label:
      "IAU_2015:61635 / Prometheus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61640",
    label:
      "IAU_2015:61640 / Prometheus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61645",
    label:
      "IAU_2015:61645 / Prometheus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61650",
    label:
      "IAU_2015:61650 / Prometheus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61655",
    label:
      "IAU_2015:61655 / Prometheus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61660",
    label:
      "IAU_2015:61660 / Prometheus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61665",
    label:
      "IAU_2015:61665 / Prometheus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61670",
    label:
      "IAU_2015:61670 / Prometheus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61675",
    label:
      "IAU_2015:61675 / Prometheus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61680",
    label:
      "IAU_2015:61680 / Prometheus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61685",
    label:
      "IAU_2015:61685 / Prometheus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61710",
    label:
      "IAU_2015:61710 / Pandora (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61715",
    label:
      "IAU_2015:61715 / Pandora (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61720",
    label:
      "IAU_2015:61720 / Pandora (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61725",
    label:
      "IAU_2015:61725 / Pandora (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61730",
    label: "IAU_2015:61730 / Pandora (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61735",
    label: "IAU_2015:61735 / Pandora (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61740",
    label:
      "IAU_2015:61740 / Pandora (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61745",
    label:
      "IAU_2015:61745 / Pandora (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61750",
    label:
      "IAU_2015:61750 / Pandora (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61755",
    label:
      "IAU_2015:61755 / Pandora (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61760",
    label:
      "IAU_2015:61760 / Pandora (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61765",
    label:
      "IAU_2015:61765 / Pandora (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61770",
    label:
      "IAU_2015:61770 / Pandora (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61775",
    label:
      "IAU_2015:61775 / Pandora (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61780",
    label:
      "IAU_2015:61780 / Pandora (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61785",
    label:
      "IAU_2015:61785 / Pandora (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:61810",
    label:
      "IAU_2015:61810 / Pan (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:61815",
    label:
      "IAU_2015:61815 / Pan (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:61820",
    label:
      "IAU_2015:61820 / Pan (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:61825",
    label:
      "IAU_2015:61825 / Pan (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:61830",
    label: "IAU_2015:61830 / Pan (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:61835",
    label: "IAU_2015:61835 / Pan (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:61840",
    label:
      "IAU_2015:61840 / Pan (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:61845",
    label:
      "IAU_2015:61845 / Pan (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:61850",
    label:
      "IAU_2015:61850 / Pan (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:61855",
    label:
      "IAU_2015:61855 / Pan (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:61860",
    label:
      "IAU_2015:61860 / Pan (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:61865",
    label:
      "IAU_2015:61865 / Pan (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:61870",
    label:
      "IAU_2015:61870 / Pan (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:61875",
    label:
      "IAU_2015:61875 / Pan (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:61880",
    label:
      "IAU_2015:61880 / Pan (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:61885",
    label:
      "IAU_2015:61885 / Pan (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:63210",
    label:
      "IAU_2015:63210 / Methone (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:63215",
    label:
      "IAU_2015:63215 / Methone (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:63220",
    label:
      "IAU_2015:63220 / Methone (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:63225",
    label:
      "IAU_2015:63225 / Methone (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:63230",
    label: "IAU_2015:63230 / Methone (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:63235",
    label: "IAU_2015:63235 / Methone (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:63240",
    label:
      "IAU_2015:63240 / Methone (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:63245",
    label:
      "IAU_2015:63245 / Methone (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:63250",
    label:
      "IAU_2015:63250 / Methone (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:63255",
    label:
      "IAU_2015:63255 / Methone (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:63260",
    label:
      "IAU_2015:63260 / Methone (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:63265",
    label:
      "IAU_2015:63265 / Methone (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:63270",
    label:
      "IAU_2015:63270 / Methone (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:63275",
    label:
      "IAU_2015:63275 / Methone (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:63280",
    label:
      "IAU_2015:63280 / Methone (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:63285",
    label:
      "IAU_2015:63285 / Methone (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:63310",
    label:
      "IAU_2015:63310 / Pallene (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:63315",
    label:
      "IAU_2015:63315 / Pallene (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:63320",
    label:
      "IAU_2015:63320 / Pallene (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:63325",
    label:
      "IAU_2015:63325 / Pallene (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:63330",
    label: "IAU_2015:63330 / Pallene (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:63335",
    label: "IAU_2015:63335 / Pallene (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:63340",
    label:
      "IAU_2015:63340 / Pallene (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:63345",
    label:
      "IAU_2015:63345 / Pallene (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:63350",
    label:
      "IAU_2015:63350 / Pallene (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:63355",
    label:
      "IAU_2015:63355 / Pallene (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:63360",
    label:
      "IAU_2015:63360 / Pallene (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:63365",
    label:
      "IAU_2015:63365 / Pallene (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:63370",
    label:
      "IAU_2015:63370 / Pallene (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:63375",
    label:
      "IAU_2015:63375 / Pallene (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:63380",
    label:
      "IAU_2015:63380 / Pallene (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:63385",
    label:
      "IAU_2015:63385 / Pallene (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:63410",
    label:
      "IAU_2015:63410 / Polydeuces (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:63415",
    label:
      "IAU_2015:63415 / Polydeuces (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:63420",
    label:
      "IAU_2015:63420 / Polydeuces (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:63425",
    label:
      "IAU_2015:63425 / Polydeuces (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:63430",
    label:
      "IAU_2015:63430 / Polydeuces (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:63435",
    label:
      "IAU_2015:63435 / Polydeuces (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:63440",
    label:
      "IAU_2015:63440 / Polydeuces (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:63445",
    label:
      "IAU_2015:63445 / Polydeuces (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:63450",
    label:
      "IAU_2015:63450 / Polydeuces (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:63455",
    label:
      "IAU_2015:63455 / Polydeuces (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:63460",
    label:
      "IAU_2015:63460 / Polydeuces (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:63465",
    label:
      "IAU_2015:63465 / Polydeuces (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:63470",
    label:
      "IAU_2015:63470 / Polydeuces (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:63475",
    label:
      "IAU_2015:63475 / Polydeuces (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:63480",
    label:
      "IAU_2015:63480 / Polydeuces (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:63485",
    label:
      "IAU_2015:63485 / Polydeuces (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:63510",
    label:
      "IAU_2015:63510 / Daphnis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:63515",
    label:
      "IAU_2015:63515 / Daphnis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:63520",
    label:
      "IAU_2015:63520 / Daphnis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:63525",
    label:
      "IAU_2015:63525 / Daphnis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:63530",
    label: "IAU_2015:63530 / Daphnis (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:63535",
    label: "IAU_2015:63535 / Daphnis (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:63540",
    label:
      "IAU_2015:63540 / Daphnis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:63545",
    label:
      "IAU_2015:63545 / Daphnis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:63550",
    label:
      "IAU_2015:63550 / Daphnis (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:63555",
    label:
      "IAU_2015:63555 / Daphnis (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:63560",
    label:
      "IAU_2015:63560 / Daphnis (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:63565",
    label:
      "IAU_2015:63565 / Daphnis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:63570",
    label:
      "IAU_2015:63570 / Daphnis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:63575",
    label:
      "IAU_2015:63575 / Daphnis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:63580",
    label:
      "IAU_2015:63580 / Daphnis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:63585",
    label:
      "IAU_2015:63585 / Daphnis (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:64910",
    label:
      "IAU_2015:64910 / Anthe (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:64915",
    label:
      "IAU_2015:64915 / Anthe (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:64920",
    label:
      "IAU_2015:64920 / Anthe (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:64925",
    label:
      "IAU_2015:64925 / Anthe (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:64930",
    label: "IAU_2015:64930 / Anthe (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:64935",
    label: "IAU_2015:64935 / Anthe (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:64940",
    label:
      "IAU_2015:64940 / Anthe (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:64945",
    label:
      "IAU_2015:64945 / Anthe (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:64950",
    label:
      "IAU_2015:64950 / Anthe (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:64955",
    label:
      "IAU_2015:64955 / Anthe (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:64960",
    label:
      "IAU_2015:64960 / Anthe (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:64965",
    label:
      "IAU_2015:64965 / Anthe (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:64970",
    label:
      "IAU_2015:64970 / Anthe (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:64975",
    label:
      "IAU_2015:64975 / Anthe (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:64980",
    label:
      "IAU_2015:64980 / Anthe (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:64985",
    label:
      "IAU_2015:64985 / Anthe (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:65310",
    label:
      "IAU_2015:65310 / Aegaeon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:65315",
    label:
      "IAU_2015:65315 / Aegaeon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:65320",
    label:
      "IAU_2015:65320 / Aegaeon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:65325",
    label:
      "IAU_2015:65325 / Aegaeon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:65330",
    label: "IAU_2015:65330 / Aegaeon (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:65335",
    label: "IAU_2015:65335 / Aegaeon (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:65340",
    label:
      "IAU_2015:65340 / Aegaeon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:65345",
    label:
      "IAU_2015:65345 / Aegaeon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:65350",
    label:
      "IAU_2015:65350 / Aegaeon (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:65355",
    label:
      "IAU_2015:65355 / Aegaeon (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:65360",
    label:
      "IAU_2015:65360 / Aegaeon (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:65365",
    label:
      "IAU_2015:65365 / Aegaeon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:65370",
    label:
      "IAU_2015:65370 / Aegaeon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:65375",
    label:
      "IAU_2015:65375 / Aegaeon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:65380",
    label:
      "IAU_2015:65380 / Aegaeon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:65385",
    label:
      "IAU_2015:65385 / Aegaeon (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:69910",
    label:
      "IAU_2015:69910 / Saturn (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:69911",
    label:
      "IAU_2015:69911 / Saturn (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:69912",
    label:
      "IAU_2015:69912 / Saturn (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:69915",
    label:
      "IAU_2015:69915 / Saturn (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:69916",
    label:
      "IAU_2015:69916 / Saturn (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:69917",
    label:
      "IAU_2015:69917 / Saturn (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:69920",
    label:
      "IAU_2015:69920 / Saturn (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:69921",
    label: "IAU_2015:69921 / Saturn (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:69922",
    label: "IAU_2015:69922 / Saturn (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:69925",
    label:
      "IAU_2015:69925 / Saturn (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:69926",
    label: "IAU_2015:69926 / Saturn (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:69927",
    label: "IAU_2015:69927 / Saturn (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:69930",
    label: "IAU_2015:69930 / Saturn (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:69931",
    label: "IAU_2015:69931 / Saturn (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:69932",
    label: "IAU_2015:69932 / Saturn (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:69935",
    label: "IAU_2015:69935 / Saturn (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:69936",
    label: "IAU_2015:69936 / Saturn (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:69937",
    label: "IAU_2015:69937 / Saturn (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:69940",
    label:
      "IAU_2015:69940 / Saturn (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:69941",
    label: "IAU_2015:69941 / Saturn (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:69942",
    label: "IAU_2015:69942 / Saturn (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:69945",
    label:
      "IAU_2015:69945 / Saturn (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:69946",
    label: "IAU_2015:69946 / Saturn (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:69947",
    label: "IAU_2015:69947 / Saturn (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:69950",
    label:
      "IAU_2015:69950 / Saturn (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:69951",
    label: "IAU_2015:69951 / Saturn (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:69952",
    label: "IAU_2015:69952 / Saturn (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:69955",
    label:
      "IAU_2015:69955 / Saturn (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:69956",
    label: "IAU_2015:69956 / Saturn (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:69957",
    label: "IAU_2015:69957 / Saturn (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:69960",
    label:
      "IAU_2015:69960 / Saturn (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:69961",
    label: "IAU_2015:69961 / Saturn (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:69962",
    label: "IAU_2015:69962 / Saturn (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:69965",
    label:
      "IAU_2015:69965 / Saturn (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:69966",
    label: "IAU_2015:69966 / Saturn (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:69967",
    label: "IAU_2015:69967 / Saturn (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:69970",
    label:
      "IAU_2015:69970 / Saturn (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:69971",
    label:
      "IAU_2015:69971 / Saturn (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:69972",
    label:
      "IAU_2015:69972 / Saturn (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:69975",
    label:
      "IAU_2015:69975 / Saturn (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:69976",
    label:
      "IAU_2015:69976 / Saturn (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:69977",
    label:
      "IAU_2015:69977 / Saturn (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:69980",
    label:
      "IAU_2015:69980 / Saturn (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:69981",
    label:
      "IAU_2015:69981 / Saturn (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:69982",
    label:
      "IAU_2015:69982 / Saturn (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:69985",
    label:
      "IAU_2015:69985 / Saturn (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:69986",
    label: "IAU_2015:69986 / Saturn (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:69987",
    label: "IAU_2015:69987 / Saturn (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70110",
    label:
      "IAU_2015:70110 / Ariel (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70115",
    label:
      "IAU_2015:70115 / Ariel (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70120",
    label:
      "IAU_2015:70120 / Ariel (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70125",
    label:
      "IAU_2015:70125 / Ariel (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70130",
    label: "IAU_2015:70130 / Ariel (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70135",
    label: "IAU_2015:70135 / Ariel (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70140",
    label:
      "IAU_2015:70140 / Ariel (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70145",
    label:
      "IAU_2015:70145 / Ariel (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70150",
    label:
      "IAU_2015:70150 / Ariel (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70155",
    label:
      "IAU_2015:70155 / Ariel (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70160",
    label:
      "IAU_2015:70160 / Ariel (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70165",
    label:
      "IAU_2015:70165 / Ariel (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70170",
    label:
      "IAU_2015:70170 / Ariel (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70175",
    label:
      "IAU_2015:70175 / Ariel (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70180",
    label:
      "IAU_2015:70180 / Ariel (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70185",
    label:
      "IAU_2015:70185 / Ariel (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70210",
    label:
      "IAU_2015:70210 / Umbriel (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70215",
    label:
      "IAU_2015:70215 / Umbriel (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70220",
    label:
      "IAU_2015:70220 / Umbriel (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70225",
    label:
      "IAU_2015:70225 / Umbriel (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70230",
    label: "IAU_2015:70230 / Umbriel (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70235",
    label: "IAU_2015:70235 / Umbriel (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70240",
    label:
      "IAU_2015:70240 / Umbriel (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70245",
    label:
      "IAU_2015:70245 / Umbriel (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70250",
    label:
      "IAU_2015:70250 / Umbriel (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70255",
    label:
      "IAU_2015:70255 / Umbriel (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70260",
    label:
      "IAU_2015:70260 / Umbriel (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70265",
    label:
      "IAU_2015:70265 / Umbriel (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70270",
    label:
      "IAU_2015:70270 / Umbriel (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70275",
    label:
      "IAU_2015:70275 / Umbriel (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70280",
    label:
      "IAU_2015:70280 / Umbriel (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70285",
    label:
      "IAU_2015:70285 / Umbriel (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70310",
    label:
      "IAU_2015:70310 / Titania (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70315",
    label:
      "IAU_2015:70315 / Titania (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70320",
    label:
      "IAU_2015:70320 / Titania (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70325",
    label:
      "IAU_2015:70325 / Titania (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70330",
    label: "IAU_2015:70330 / Titania (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70335",
    label: "IAU_2015:70335 / Titania (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70340",
    label:
      "IAU_2015:70340 / Titania (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70345",
    label:
      "IAU_2015:70345 / Titania (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70350",
    label:
      "IAU_2015:70350 / Titania (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70355",
    label:
      "IAU_2015:70355 / Titania (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70360",
    label:
      "IAU_2015:70360 / Titania (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70365",
    label:
      "IAU_2015:70365 / Titania (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70370",
    label:
      "IAU_2015:70370 / Titania (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70375",
    label:
      "IAU_2015:70375 / Titania (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70380",
    label:
      "IAU_2015:70380 / Titania (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70385",
    label:
      "IAU_2015:70385 / Titania (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70410",
    label:
      "IAU_2015:70410 / Oberon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70415",
    label:
      "IAU_2015:70415 / Oberon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70420",
    label:
      "IAU_2015:70420 / Oberon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70425",
    label:
      "IAU_2015:70425 / Oberon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70430",
    label: "IAU_2015:70430 / Oberon (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70435",
    label: "IAU_2015:70435 / Oberon (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70440",
    label:
      "IAU_2015:70440 / Oberon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70445",
    label:
      "IAU_2015:70445 / Oberon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70450",
    label:
      "IAU_2015:70450 / Oberon (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70455",
    label:
      "IAU_2015:70455 / Oberon (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70460",
    label:
      "IAU_2015:70460 / Oberon (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70465",
    label:
      "IAU_2015:70465 / Oberon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70470",
    label:
      "IAU_2015:70470 / Oberon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70475",
    label:
      "IAU_2015:70475 / Oberon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70480",
    label:
      "IAU_2015:70480 / Oberon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70485",
    label:
      "IAU_2015:70485 / Oberon (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70510",
    label:
      "IAU_2015:70510 / Miranda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70515",
    label:
      "IAU_2015:70515 / Miranda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70520",
    label:
      "IAU_2015:70520 / Miranda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70525",
    label:
      "IAU_2015:70525 / Miranda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70530",
    label: "IAU_2015:70530 / Miranda (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70535",
    label: "IAU_2015:70535 / Miranda (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70540",
    label:
      "IAU_2015:70540 / Miranda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70545",
    label:
      "IAU_2015:70545 / Miranda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70550",
    label:
      "IAU_2015:70550 / Miranda (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70555",
    label:
      "IAU_2015:70555 / Miranda (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70560",
    label:
      "IAU_2015:70560 / Miranda (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70565",
    label:
      "IAU_2015:70565 / Miranda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70570",
    label:
      "IAU_2015:70570 / Miranda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70575",
    label:
      "IAU_2015:70575 / Miranda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70580",
    label:
      "IAU_2015:70580 / Miranda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70585",
    label:
      "IAU_2015:70585 / Miranda (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70610",
    label:
      "IAU_2015:70610 / Cordelia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70615",
    label:
      "IAU_2015:70615 / Cordelia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70620",
    label:
      "IAU_2015:70620 / Cordelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70625",
    label:
      "IAU_2015:70625 / Cordelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70630",
    label: "IAU_2015:70630 / Cordelia (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70635",
    label: "IAU_2015:70635 / Cordelia (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70640",
    label:
      "IAU_2015:70640 / Cordelia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70645",
    label:
      "IAU_2015:70645 / Cordelia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70650",
    label:
      "IAU_2015:70650 / Cordelia (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70655",
    label:
      "IAU_2015:70655 / Cordelia (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70660",
    label:
      "IAU_2015:70660 / Cordelia (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70665",
    label:
      "IAU_2015:70665 / Cordelia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70670",
    label:
      "IAU_2015:70670 / Cordelia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70675",
    label:
      "IAU_2015:70675 / Cordelia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70680",
    label:
      "IAU_2015:70680 / Cordelia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70685",
    label:
      "IAU_2015:70685 / Cordelia (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70710",
    label:
      "IAU_2015:70710 / Ophelia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70715",
    label:
      "IAU_2015:70715 / Ophelia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70720",
    label:
      "IAU_2015:70720 / Ophelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70725",
    label:
      "IAU_2015:70725 / Ophelia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70730",
    label: "IAU_2015:70730 / Ophelia (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70735",
    label: "IAU_2015:70735 / Ophelia (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70740",
    label:
      "IAU_2015:70740 / Ophelia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70745",
    label:
      "IAU_2015:70745 / Ophelia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70750",
    label:
      "IAU_2015:70750 / Ophelia (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70755",
    label:
      "IAU_2015:70755 / Ophelia (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70760",
    label:
      "IAU_2015:70760 / Ophelia (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70765",
    label:
      "IAU_2015:70765 / Ophelia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70770",
    label:
      "IAU_2015:70770 / Ophelia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70775",
    label:
      "IAU_2015:70775 / Ophelia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70780",
    label:
      "IAU_2015:70780 / Ophelia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70785",
    label:
      "IAU_2015:70785 / Ophelia (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70810",
    label:
      "IAU_2015:70810 / Bianca (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70815",
    label:
      "IAU_2015:70815 / Bianca (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70820",
    label:
      "IAU_2015:70820 / Bianca (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70825",
    label:
      "IAU_2015:70825 / Bianca (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70830",
    label: "IAU_2015:70830 / Bianca (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70835",
    label: "IAU_2015:70835 / Bianca (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70840",
    label:
      "IAU_2015:70840 / Bianca (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70845",
    label:
      "IAU_2015:70845 / Bianca (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70850",
    label:
      "IAU_2015:70850 / Bianca (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70855",
    label:
      "IAU_2015:70855 / Bianca (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70860",
    label:
      "IAU_2015:70860 / Bianca (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70865",
    label:
      "IAU_2015:70865 / Bianca (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70870",
    label:
      "IAU_2015:70870 / Bianca (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70875",
    label:
      "IAU_2015:70875 / Bianca (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70880",
    label:
      "IAU_2015:70880 / Bianca (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70885",
    label:
      "IAU_2015:70885 / Bianca (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:70910",
    label:
      "IAU_2015:70910 / Cressida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:70915",
    label:
      "IAU_2015:70915 / Cressida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:70920",
    label:
      "IAU_2015:70920 / Cressida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:70925",
    label:
      "IAU_2015:70925 / Cressida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:70930",
    label: "IAU_2015:70930 / Cressida (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:70935",
    label: "IAU_2015:70935 / Cressida (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:70940",
    label:
      "IAU_2015:70940 / Cressida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:70945",
    label:
      "IAU_2015:70945 / Cressida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:70950",
    label:
      "IAU_2015:70950 / Cressida (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:70955",
    label:
      "IAU_2015:70955 / Cressida (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:70960",
    label:
      "IAU_2015:70960 / Cressida (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:70965",
    label:
      "IAU_2015:70965 / Cressida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:70970",
    label:
      "IAU_2015:70970 / Cressida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:70975",
    label:
      "IAU_2015:70975 / Cressida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:70980",
    label:
      "IAU_2015:70980 / Cressida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:70985",
    label:
      "IAU_2015:70985 / Cressida (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71010",
    label:
      "IAU_2015:71010 / Desdemona (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71015",
    label:
      "IAU_2015:71015 / Desdemona (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71020",
    label:
      "IAU_2015:71020 / Desdemona (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71025",
    label:
      "IAU_2015:71025 / Desdemona (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71030",
    label:
      "IAU_2015:71030 / Desdemona (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71035",
    label:
      "IAU_2015:71035 / Desdemona (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71040",
    label:
      "IAU_2015:71040 / Desdemona (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71045",
    label:
      "IAU_2015:71045 / Desdemona (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71050",
    label:
      "IAU_2015:71050 / Desdemona (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71055",
    label:
      "IAU_2015:71055 / Desdemona (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71060",
    label:
      "IAU_2015:71060 / Desdemona (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71065",
    label:
      "IAU_2015:71065 / Desdemona (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71070",
    label:
      "IAU_2015:71070 / Desdemona (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71075",
    label:
      "IAU_2015:71075 / Desdemona (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71080",
    label:
      "IAU_2015:71080 / Desdemona (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71085",
    label:
      "IAU_2015:71085 / Desdemona (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71110",
    label:
      "IAU_2015:71110 / Juliet (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71115",
    label:
      "IAU_2015:71115 / Juliet (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71120",
    label:
      "IAU_2015:71120 / Juliet (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71125",
    label:
      "IAU_2015:71125 / Juliet (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71130",
    label: "IAU_2015:71130 / Juliet (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71135",
    label: "IAU_2015:71135 / Juliet (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71140",
    label:
      "IAU_2015:71140 / Juliet (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71145",
    label:
      "IAU_2015:71145 / Juliet (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71150",
    label:
      "IAU_2015:71150 / Juliet (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71155",
    label:
      "IAU_2015:71155 / Juliet (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71160",
    label:
      "IAU_2015:71160 / Juliet (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71165",
    label:
      "IAU_2015:71165 / Juliet (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71170",
    label:
      "IAU_2015:71170 / Juliet (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71175",
    label:
      "IAU_2015:71175 / Juliet (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71180",
    label:
      "IAU_2015:71180 / Juliet (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71185",
    label:
      "IAU_2015:71185 / Juliet (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71210",
    label:
      "IAU_2015:71210 / Portia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71215",
    label:
      "IAU_2015:71215 / Portia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71220",
    label:
      "IAU_2015:71220 / Portia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71225",
    label:
      "IAU_2015:71225 / Portia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71230",
    label: "IAU_2015:71230 / Portia (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71235",
    label: "IAU_2015:71235 / Portia (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71240",
    label:
      "IAU_2015:71240 / Portia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71245",
    label:
      "IAU_2015:71245 / Portia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71250",
    label:
      "IAU_2015:71250 / Portia (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71255",
    label:
      "IAU_2015:71255 / Portia (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71260",
    label:
      "IAU_2015:71260 / Portia (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71265",
    label:
      "IAU_2015:71265 / Portia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71270",
    label:
      "IAU_2015:71270 / Portia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71275",
    label:
      "IAU_2015:71275 / Portia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71280",
    label:
      "IAU_2015:71280 / Portia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71285",
    label:
      "IAU_2015:71285 / Portia (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71310",
    label:
      "IAU_2015:71310 / Rosalind (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71315",
    label:
      "IAU_2015:71315 / Rosalind (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71320",
    label:
      "IAU_2015:71320 / Rosalind (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71325",
    label:
      "IAU_2015:71325 / Rosalind (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71330",
    label: "IAU_2015:71330 / Rosalind (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71335",
    label: "IAU_2015:71335 / Rosalind (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71340",
    label:
      "IAU_2015:71340 / Rosalind (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71345",
    label:
      "IAU_2015:71345 / Rosalind (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71350",
    label:
      "IAU_2015:71350 / Rosalind (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71355",
    label:
      "IAU_2015:71355 / Rosalind (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71360",
    label:
      "IAU_2015:71360 / Rosalind (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71365",
    label:
      "IAU_2015:71365 / Rosalind (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71370",
    label:
      "IAU_2015:71370 / Rosalind (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71375",
    label:
      "IAU_2015:71375 / Rosalind (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71380",
    label:
      "IAU_2015:71380 / Rosalind (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71385",
    label:
      "IAU_2015:71385 / Rosalind (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71410",
    label:
      "IAU_2015:71410 / Belinda (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71415",
    label:
      "IAU_2015:71415 / Belinda (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71420",
    label:
      "IAU_2015:71420 / Belinda (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71425",
    label:
      "IAU_2015:71425 / Belinda (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71430",
    label: "IAU_2015:71430 / Belinda (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71435",
    label: "IAU_2015:71435 / Belinda (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71440",
    label:
      "IAU_2015:71440 / Belinda (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71445",
    label:
      "IAU_2015:71445 / Belinda (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71450",
    label:
      "IAU_2015:71450 / Belinda (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71455",
    label:
      "IAU_2015:71455 / Belinda (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71460",
    label:
      "IAU_2015:71460 / Belinda (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71465",
    label:
      "IAU_2015:71465 / Belinda (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71470",
    label:
      "IAU_2015:71470 / Belinda (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71475",
    label:
      "IAU_2015:71475 / Belinda (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71480",
    label:
      "IAU_2015:71480 / Belinda (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71485",
    label:
      "IAU_2015:71485 / Belinda (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:71510",
    label:
      "IAU_2015:71510 / Puck (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:71515",
    label:
      "IAU_2015:71515 / Puck (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:71520",
    label:
      "IAU_2015:71520 / Puck (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:71525",
    label:
      "IAU_2015:71525 / Puck (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:71530",
    label: "IAU_2015:71530 / Puck (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:71535",
    label: "IAU_2015:71535 / Puck (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:71540",
    label:
      "IAU_2015:71540 / Puck (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:71545",
    label:
      "IAU_2015:71545 / Puck (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:71550",
    label:
      "IAU_2015:71550 / Puck (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:71555",
    label:
      "IAU_2015:71555 / Puck (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:71560",
    label:
      "IAU_2015:71560 / Puck (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:71565",
    label:
      "IAU_2015:71565 / Puck (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:71570",
    label:
      "IAU_2015:71570 / Puck (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:71575",
    label:
      "IAU_2015:71575 / Puck (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:71580",
    label:
      "IAU_2015:71580 / Puck (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:71585",
    label:
      "IAU_2015:71585 / Puck (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:79910",
    label:
      "IAU_2015:79910 / Uranus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:79911",
    label:
      "IAU_2015:79911 / Uranus (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:79915",
    label:
      "IAU_2015:79915 / Uranus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:79916",
    label:
      "IAU_2015:79916 / Uranus (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:79920",
    label:
      "IAU_2015:79920 / Uranus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:79921",
    label: "IAU_2015:79921 / Uranus (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:79925",
    label:
      "IAU_2015:79925 / Uranus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:79926",
    label: "IAU_2015:79926 / Uranus (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:79930",
    label: "IAU_2015:79930 / Uranus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:79931",
    label: "IAU_2015:79931 / Uranus (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:79935",
    label: "IAU_2015:79935 / Uranus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:79936",
    label: "IAU_2015:79936 / Uranus (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:79940",
    label:
      "IAU_2015:79940 / Uranus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:79941",
    label: "IAU_2015:79941 / Uranus (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:79945",
    label:
      "IAU_2015:79945 / Uranus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:79946",
    label: "IAU_2015:79946 / Uranus (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:79950",
    label:
      "IAU_2015:79950 / Uranus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:79951",
    label: "IAU_2015:79951 / Uranus (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:79955",
    label:
      "IAU_2015:79955 / Uranus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:79956",
    label: "IAU_2015:79956 / Uranus (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:79960",
    label:
      "IAU_2015:79960 / Uranus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:79961",
    label: "IAU_2015:79961 / Uranus (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:79965",
    label:
      "IAU_2015:79965 / Uranus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:79966",
    label: "IAU_2015:79966 / Uranus (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:79970",
    label:
      "IAU_2015:79970 / Uranus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:79971",
    label:
      "IAU_2015:79971 / Uranus (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:79975",
    label:
      "IAU_2015:79975 / Uranus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:79976",
    label:
      "IAU_2015:79976 / Uranus (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:79980",
    label:
      "IAU_2015:79980 / Uranus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:79981",
    label:
      "IAU_2015:79981 / Uranus (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:79985",
    label:
      "IAU_2015:79985 / Uranus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:79986",
    label: "IAU_2015:79986 / Uranus (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80110",
    label:
      "IAU_2015:80110 / Triton (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80115",
    label:
      "IAU_2015:80115 / Triton (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80120",
    label:
      "IAU_2015:80120 / Triton (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80125",
    label:
      "IAU_2015:80125 / Triton (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80130",
    label: "IAU_2015:80130 / Triton (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80135",
    label: "IAU_2015:80135 / Triton (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80140",
    label:
      "IAU_2015:80140 / Triton (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80145",
    label:
      "IAU_2015:80145 / Triton (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80150",
    label:
      "IAU_2015:80150 / Triton (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80155",
    label:
      "IAU_2015:80155 / Triton (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80160",
    label:
      "IAU_2015:80160 / Triton (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80165",
    label:
      "IAU_2015:80165 / Triton (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80170",
    label:
      "IAU_2015:80170 / Triton (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80175",
    label:
      "IAU_2015:80175 / Triton (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80180",
    label:
      "IAU_2015:80180 / Triton (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80185",
    label:
      "IAU_2015:80185 / Triton (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80210",
    label:
      "IAU_2015:80210 / Nereid (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80215",
    label:
      "IAU_2015:80215 / Nereid (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80220",
    label:
      "IAU_2015:80220 / Nereid (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80225",
    label:
      "IAU_2015:80225 / Nereid (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80230",
    label: "IAU_2015:80230 / Nereid (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80235",
    label: "IAU_2015:80235 / Nereid (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80240",
    label:
      "IAU_2015:80240 / Nereid (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80245",
    label:
      "IAU_2015:80245 / Nereid (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80250",
    label:
      "IAU_2015:80250 / Nereid (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80255",
    label:
      "IAU_2015:80255 / Nereid (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80260",
    label:
      "IAU_2015:80260 / Nereid (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80265",
    label:
      "IAU_2015:80265 / Nereid (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80270",
    label:
      "IAU_2015:80270 / Nereid (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80275",
    label:
      "IAU_2015:80275 / Nereid (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80280",
    label:
      "IAU_2015:80280 / Nereid (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80285",
    label:
      "IAU_2015:80285 / Nereid (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80310",
    label:
      "IAU_2015:80310 / Naiad (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80311",
    label:
      "IAU_2015:80311 / Naiad (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80315",
    label:
      "IAU_2015:80315 / Naiad (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80316",
    label:
      "IAU_2015:80316 / Naiad (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80320",
    label:
      "IAU_2015:80320 / Naiad (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80321",
    label: "IAU_2015:80321 / Naiad (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80325",
    label:
      "IAU_2015:80325 / Naiad (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80326",
    label: "IAU_2015:80326 / Naiad (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80330",
    label: "IAU_2015:80330 / Naiad (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80331",
    label: "IAU_2015:80331 / Naiad (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:80335",
    label: "IAU_2015:80335 / Naiad (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80336",
    label: "IAU_2015:80336 / Naiad (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:80340",
    label:
      "IAU_2015:80340 / Naiad (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80341",
    label: "IAU_2015:80341 / Naiad (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80345",
    label:
      "IAU_2015:80345 / Naiad (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80346",
    label: "IAU_2015:80346 / Naiad (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80350",
    label:
      "IAU_2015:80350 / Naiad (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80351",
    label: "IAU_2015:80351 / Naiad (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80355",
    label:
      "IAU_2015:80355 / Naiad (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80356",
    label: "IAU_2015:80356 / Naiad (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80360",
    label:
      "IAU_2015:80360 / Naiad (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80361",
    label: "IAU_2015:80361 / Naiad (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80365",
    label:
      "IAU_2015:80365 / Naiad (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80366",
    label: "IAU_2015:80366 / Naiad (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80370",
    label:
      "IAU_2015:80370 / Naiad (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80371",
    label:
      "IAU_2015:80371 / Naiad (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80375",
    label:
      "IAU_2015:80375 / Naiad (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80376",
    label: "IAU_2015:80376 / Naiad (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80380",
    label:
      "IAU_2015:80380 / Naiad (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80381",
    label:
      "IAU_2015:80381 / Naiad (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80385",
    label:
      "IAU_2015:80385 / Naiad (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80386",
    label: "IAU_2015:80386 / Naiad (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80410",
    label:
      "IAU_2015:80410 / Thalassa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80411",
    label:
      "IAU_2015:80411 / Thalassa (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80415",
    label:
      "IAU_2015:80415 / Thalassa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80416",
    label:
      "IAU_2015:80416 / Thalassa (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80420",
    label:
      "IAU_2015:80420 / Thalassa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80421",
    label: "IAU_2015:80421 / Thalassa (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80425",
    label:
      "IAU_2015:80425 / Thalassa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80426",
    label:
      "IAU_2015:80426 / Thalassa (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80430",
    label: "IAU_2015:80430 / Thalassa (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80431",
    label: "IAU_2015:80431 / Thalassa (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:80435",
    label: "IAU_2015:80435 / Thalassa (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80436",
    label: "IAU_2015:80436 / Thalassa (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:80440",
    label:
      "IAU_2015:80440 / Thalassa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80441",
    label: "IAU_2015:80441 / Thalassa (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80445",
    label:
      "IAU_2015:80445 / Thalassa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80446",
    label:
      "IAU_2015:80446 / Thalassa (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80450",
    label:
      "IAU_2015:80450 / Thalassa (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80451",
    label: "IAU_2015:80451 / Thalassa (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80455",
    label:
      "IAU_2015:80455 / Thalassa (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80456",
    label: "IAU_2015:80456 / Thalassa (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80460",
    label:
      "IAU_2015:80460 / Thalassa (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80461",
    label: "IAU_2015:80461 / Thalassa (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80465",
    label:
      "IAU_2015:80465 / Thalassa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80466",
    label:
      "IAU_2015:80466 / Thalassa (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80470",
    label:
      "IAU_2015:80470 / Thalassa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80471",
    label:
      "IAU_2015:80471 / Thalassa (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80475",
    label:
      "IAU_2015:80475 / Thalassa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80476",
    label:
      "IAU_2015:80476 / Thalassa (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80480",
    label:
      "IAU_2015:80480 / Thalassa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80481",
    label:
      "IAU_2015:80481 / Thalassa (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80485",
    label:
      "IAU_2015:80485 / Thalassa (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80486",
    label: "IAU_2015:80486 / Thalassa (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80510",
    label:
      "IAU_2015:80510 / Despina (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80511",
    label:
      "IAU_2015:80511 / Despina (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80515",
    label:
      "IAU_2015:80515 / Despina (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80516",
    label:
      "IAU_2015:80516 / Despina (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80520",
    label:
      "IAU_2015:80520 / Despina (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80521",
    label: "IAU_2015:80521 / Despina (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80525",
    label:
      "IAU_2015:80525 / Despina (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80526",
    label:
      "IAU_2015:80526 / Despina (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80530",
    label: "IAU_2015:80530 / Despina (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80531",
    label: "IAU_2015:80531 / Despina (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:80535",
    label: "IAU_2015:80535 / Despina (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80536",
    label: "IAU_2015:80536 / Despina (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:80540",
    label:
      "IAU_2015:80540 / Despina (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80541",
    label: "IAU_2015:80541 / Despina (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80545",
    label:
      "IAU_2015:80545 / Despina (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80546",
    label: "IAU_2015:80546 / Despina (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80550",
    label:
      "IAU_2015:80550 / Despina (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80551",
    label: "IAU_2015:80551 / Despina (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80555",
    label:
      "IAU_2015:80555 / Despina (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80556",
    label: "IAU_2015:80556 / Despina (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80560",
    label:
      "IAU_2015:80560 / Despina (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80561",
    label: "IAU_2015:80561 / Despina (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80565",
    label:
      "IAU_2015:80565 / Despina (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80566",
    label:
      "IAU_2015:80566 / Despina (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80570",
    label:
      "IAU_2015:80570 / Despina (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80571",
    label:
      "IAU_2015:80571 / Despina (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80575",
    label:
      "IAU_2015:80575 / Despina (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80576",
    label:
      "IAU_2015:80576 / Despina (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80580",
    label:
      "IAU_2015:80580 / Despina (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80581",
    label:
      "IAU_2015:80581 / Despina (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80585",
    label:
      "IAU_2015:80585 / Despina (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80586",
    label: "IAU_2015:80586 / Despina (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80610",
    label:
      "IAU_2015:80610 / Galatea (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80611",
    label:
      "IAU_2015:80611 / Galatea (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80615",
    label:
      "IAU_2015:80615 / Galatea (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80616",
    label:
      "IAU_2015:80616 / Galatea (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80620",
    label:
      "IAU_2015:80620 / Galatea (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80621",
    label: "IAU_2015:80621 / Galatea (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80625",
    label:
      "IAU_2015:80625 / Galatea (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80626",
    label:
      "IAU_2015:80626 / Galatea (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80630",
    label: "IAU_2015:80630 / Galatea (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80631",
    label: "IAU_2015:80631 / Galatea (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:80635",
    label: "IAU_2015:80635 / Galatea (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80636",
    label: "IAU_2015:80636 / Galatea (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:80640",
    label:
      "IAU_2015:80640 / Galatea (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80641",
    label: "IAU_2015:80641 / Galatea (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80645",
    label:
      "IAU_2015:80645 / Galatea (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80646",
    label: "IAU_2015:80646 / Galatea (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80650",
    label:
      "IAU_2015:80650 / Galatea (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80651",
    label: "IAU_2015:80651 / Galatea (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80655",
    label:
      "IAU_2015:80655 / Galatea (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80656",
    label: "IAU_2015:80656 / Galatea (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80660",
    label:
      "IAU_2015:80660 / Galatea (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80661",
    label: "IAU_2015:80661 / Galatea (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80665",
    label:
      "IAU_2015:80665 / Galatea (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80666",
    label:
      "IAU_2015:80666 / Galatea (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80670",
    label:
      "IAU_2015:80670 / Galatea (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80671",
    label:
      "IAU_2015:80671 / Galatea (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80675",
    label:
      "IAU_2015:80675 / Galatea (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80676",
    label:
      "IAU_2015:80676 / Galatea (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80680",
    label:
      "IAU_2015:80680 / Galatea (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80681",
    label:
      "IAU_2015:80681 / Galatea (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80685",
    label:
      "IAU_2015:80685 / Galatea (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80686",
    label: "IAU_2015:80686 / Galatea (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80710",
    label:
      "IAU_2015:80710 / Larissa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80711",
    label:
      "IAU_2015:80711 / Larissa (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80712",
    label:
      "IAU_2015:80712 / Larissa (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80715",
    label:
      "IAU_2015:80715 / Larissa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80716",
    label:
      "IAU_2015:80716 / Larissa (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80717",
    label:
      "IAU_2015:80717 / Larissa (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80720",
    label:
      "IAU_2015:80720 / Larissa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80721",
    label: "IAU_2015:80721 / Larissa (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80722",
    label: "IAU_2015:80722 / Larissa (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80725",
    label:
      "IAU_2015:80725 / Larissa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80726",
    label:
      "IAU_2015:80726 / Larissa (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80727",
    label:
      "IAU_2015:80727 / Larissa (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80730",
    label: "IAU_2015:80730 / Larissa (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80731",
    label: "IAU_2015:80731 / Larissa (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:80732",
    label: "IAU_2015:80732 / Larissa (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80735",
    label: "IAU_2015:80735 / Larissa (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80736",
    label: "IAU_2015:80736 / Larissa (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:80737",
    label: "IAU_2015:80737 / Larissa (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80740",
    label:
      "IAU_2015:80740 / Larissa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80741",
    label: "IAU_2015:80741 / Larissa (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80742",
    label: "IAU_2015:80742 / Larissa (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80745",
    label:
      "IAU_2015:80745 / Larissa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80746",
    label: "IAU_2015:80746 / Larissa (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80747",
    label: "IAU_2015:80747 / Larissa (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80750",
    label:
      "IAU_2015:80750 / Larissa (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80751",
    label: "IAU_2015:80751 / Larissa (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80752",
    label: "IAU_2015:80752 / Larissa (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80755",
    label:
      "IAU_2015:80755 / Larissa (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80756",
    label: "IAU_2015:80756 / Larissa (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80757",
    label: "IAU_2015:80757 / Larissa (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80760",
    label:
      "IAU_2015:80760 / Larissa (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80761",
    label: "IAU_2015:80761 / Larissa (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80762",
    label: "IAU_2015:80762 / Larissa (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80765",
    label:
      "IAU_2015:80765 / Larissa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80766",
    label:
      "IAU_2015:80766 / Larissa (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80767",
    label:
      "IAU_2015:80767 / Larissa (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80770",
    label:
      "IAU_2015:80770 / Larissa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80771",
    label:
      "IAU_2015:80771 / Larissa (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80772",
    label:
      "IAU_2015:80772 / Larissa (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80775",
    label:
      "IAU_2015:80775 / Larissa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80776",
    label:
      "IAU_2015:80776 / Larissa (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80777",
    label:
      "IAU_2015:80777 / Larissa (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80780",
    label:
      "IAU_2015:80780 / Larissa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80781",
    label:
      "IAU_2015:80781 / Larissa (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80782",
    label:
      "IAU_2015:80782 / Larissa (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80785",
    label:
      "IAU_2015:80785 / Larissa (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80786",
    label: "IAU_2015:80786 / Larissa (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:80787",
    label: "IAU_2015:80787 / Larissa (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:80810",
    label:
      "IAU_2015:80810 / Proteus (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:80815",
    label:
      "IAU_2015:80815 / Proteus (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:80820",
    label:
      "IAU_2015:80820 / Proteus (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:80825",
    label:
      "IAU_2015:80825 / Proteus (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:80830",
    label: "IAU_2015:80830 / Proteus (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:80835",
    label: "IAU_2015:80835 / Proteus (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:80840",
    label:
      "IAU_2015:80840 / Proteus (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:80845",
    label:
      "IAU_2015:80845 / Proteus (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:80850",
    label:
      "IAU_2015:80850 / Proteus (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:80855",
    label:
      "IAU_2015:80855 / Proteus (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:80860",
    label:
      "IAU_2015:80860 / Proteus (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:80865",
    label:
      "IAU_2015:80865 / Proteus (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:80870",
    label:
      "IAU_2015:80870 / Proteus (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:80875",
    label:
      "IAU_2015:80875 / Proteus (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:80880",
    label:
      "IAU_2015:80880 / Proteus (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:80885",
    label:
      "IAU_2015:80885 / Proteus (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:89910",
    label:
      "IAU_2015:89910 / Neptune (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:89911",
    label:
      "IAU_2015:89911 / Neptune (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:89912",
    label:
      "IAU_2015:89912 / Neptune (2015) / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:89915",
    label:
      "IAU_2015:89915 / Neptune (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:89916",
    label:
      "IAU_2015:89916 / Neptune (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:89917",
    label:
      "IAU_2015:89917 / Neptune (2015) / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:89920",
    label:
      "IAU_2015:89920 / Neptune (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:89921",
    label: "IAU_2015:89921 / Neptune (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:89922",
    label: "IAU_2015:89922 / Neptune (2015) / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:89925",
    label:
      "IAU_2015:89925 / Neptune (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:89926",
    label:
      "IAU_2015:89926 / Neptune (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:89927",
    label:
      "IAU_2015:89927 / Neptune (2015) / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:89930",
    label: "IAU_2015:89930 / Neptune (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:89931",
    label: "IAU_2015:89931 / Neptune (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:89932",
    label: "IAU_2015:89932 / Neptune (2015) / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:89935",
    label: "IAU_2015:89935 / Neptune (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:89936",
    label: "IAU_2015:89936 / Neptune (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:89937",
    label: "IAU_2015:89937 / Neptune (2015) / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:89940",
    label:
      "IAU_2015:89940 / Neptune (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:89941",
    label: "IAU_2015:89941 / Neptune (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:89942",
    label: "IAU_2015:89942 / Neptune (2015) / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:89945",
    label:
      "IAU_2015:89945 / Neptune (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:89946",
    label: "IAU_2015:89946 / Neptune (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:89947",
    label: "IAU_2015:89947 / Neptune (2015) / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:89950",
    label:
      "IAU_2015:89950 / Neptune (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:89951",
    label: "IAU_2015:89951 / Neptune (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:89952",
    label: "IAU_2015:89952 / Neptune (2015) / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:89955",
    label:
      "IAU_2015:89955 / Neptune (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:89956",
    label: "IAU_2015:89956 / Neptune (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:89957",
    label: "IAU_2015:89957 / Neptune (2015) / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:89960",
    label:
      "IAU_2015:89960 / Neptune (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:89961",
    label: "IAU_2015:89961 / Neptune (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:89962",
    label: "IAU_2015:89962 / Neptune (2015) / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:89965",
    label:
      "IAU_2015:89965 / Neptune (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:89966",
    label:
      "IAU_2015:89966 / Neptune (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:89967",
    label:
      "IAU_2015:89967 / Neptune (2015) / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:89970",
    label:
      "IAU_2015:89970 / Neptune (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:89971",
    label:
      "IAU_2015:89971 / Neptune (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:89972",
    label:
      "IAU_2015:89972 / Neptune (2015) / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:89975",
    label:
      "IAU_2015:89975 / Neptune (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:89976",
    label:
      "IAU_2015:89976 / Neptune (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:89977",
    label:
      "IAU_2015:89977 / Neptune (2015) / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:89980",
    label:
      "IAU_2015:89980 / Neptune (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:89981",
    label:
      "IAU_2015:89981 / Neptune (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:89982",
    label:
      "IAU_2015:89982 / Neptune (2015) / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:89985",
    label:
      "IAU_2015:89985 / Neptune (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:89986",
    label: "IAU_2015:89986 / Neptune (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:89987",
    label: "IAU_2015:89987 / Neptune (2015) / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:90110",
    label:
      "IAU_2015:90110 / Charon (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:90115",
    label:
      "IAU_2015:90115 / Charon (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:90120",
    label:
      "IAU_2015:90120 / Charon (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:90125",
    label:
      "IAU_2015:90125 / Charon (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:90130",
    label: "IAU_2015:90130 / Charon (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:90135",
    label: "IAU_2015:90135 / Charon (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:90140",
    label:
      "IAU_2015:90140 / Charon (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:90145",
    label:
      "IAU_2015:90145 / Charon (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:90150",
    label:
      "IAU_2015:90150 / Charon (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:90155",
    label:
      "IAU_2015:90155 / Charon (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:90160",
    label:
      "IAU_2015:90160 / Charon (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:90165",
    label:
      "IAU_2015:90165 / Charon (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:90170",
    label:
      "IAU_2015:90170 / Charon (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:90175",
    label:
      "IAU_2015:90175 / Charon (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:90180",
    label:
      "IAU_2015:90180 / Charon (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:90185",
    label:
      "IAU_2015:90185 / Charon (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:99910",
    label:
      "IAU_2015:99910 / Pluto (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:99915",
    label:
      "IAU_2015:99915 / Pluto (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:99920",
    label:
      "IAU_2015:99920 / Pluto (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:99925",
    label:
      "IAU_2015:99925 / Pluto (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:99930",
    label: "IAU_2015:99930 / Pluto (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:99935",
    label: "IAU_2015:99935 / Pluto (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:99940",
    label:
      "IAU_2015:99940 / Pluto (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:99945",
    label:
      "IAU_2015:99945 / Pluto (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:99950",
    label:
      "IAU_2015:99950 / Pluto (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:99955",
    label:
      "IAU_2015:99955 / Pluto (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:99960",
    label:
      "IAU_2015:99960 / Pluto (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:99965",
    label:
      "IAU_2015:99965 / Pluto (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:99970",
    label:
      "IAU_2015:99970 / Pluto (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:99975",
    label:
      "IAU_2015:99975 / Pluto (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:99980",
    label:
      "IAU_2015:99980 / Pluto (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:99985",
    label:
      "IAU_2015:99985 / Pluto (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100000510",
    label:
      "IAU_2015:100000510 / Borrelly (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100000515",
    label:
      "IAU_2015:100000515 / Borrelly (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100000520",
    label:
      "IAU_2015:100000520 / Borrelly (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100000525",
    label:
      "IAU_2015:100000525 / Borrelly (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100000530",
    label:
      "IAU_2015:100000530 / Borrelly (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100000535",
    label:
      "IAU_2015:100000535 / Borrelly (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100000540",
    label:
      "IAU_2015:100000540 / Borrelly (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100000545",
    label:
      "IAU_2015:100000545 / Borrelly (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100000550",
    label:
      "IAU_2015:100000550 / Borrelly (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100000555",
    label:
      "IAU_2015:100000555 / Borrelly (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100000560",
    label:
      "IAU_2015:100000560 / Borrelly (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100000565",
    label:
      "IAU_2015:100000565 / Borrelly (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100000570",
    label:
      "IAU_2015:100000570 / Borrelly (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100000575",
    label:
      "IAU_2015:100000575 / Borrelly (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100000580",
    label:
      "IAU_2015:100000580 / Borrelly (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100000585",
    label:
      "IAU_2015:100000585 / Borrelly (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100001210",
    label:
      "IAU_2015:100001210 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100001215",
    label:
      "IAU_2015:100001215 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100001220",
    label:
      "IAU_2015:100001220 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100001225",
    label:
      "IAU_2015:100001225 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100001230",
    label:
      "IAU_2015:100001230 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100001235",
    label:
      "IAU_2015:100001235 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100001240",
    label:
      "IAU_2015:100001240 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100001245",
    label:
      "IAU_2015:100001245 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100001250",
    label:
      "IAU_2015:100001250 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100001255",
    label:
      "IAU_2015:100001255 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100001260",
    label:
      "IAU_2015:100001260 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100001265",
    label:
      "IAU_2015:100001265 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100001270",
    label:
      "IAU_2015:100001270 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100001275",
    label:
      "IAU_2015:100001275 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100001280",
    label:
      "IAU_2015:100001280 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100001285",
    label:
      "IAU_2015:100001285 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100003610",
    label:
      "IAU_2015:100003610 / Halley (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100003611",
    label:
      "IAU_2015:100003611 / Halley (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100003615",
    label:
      "IAU_2015:100003615 / Halley (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100003616",
    label:
      "IAU_2015:100003616 / Halley (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100003620",
    label:
      "IAU_2015:100003620 / Halley (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100003621",
    label:
      "IAU_2015:100003621 / Halley (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100003625",
    label:
      "IAU_2015:100003625 / Halley (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100003626",
    label:
      "IAU_2015:100003626 / Halley (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100003630",
    label:
      "IAU_2015:100003630 / Halley (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100003631",
    label: "IAU_2015:100003631 / Halley (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:100003635",
    label:
      "IAU_2015:100003635 / Halley (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100003636",
    label: "IAU_2015:100003636 / Halley (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:100003640",
    label:
      "IAU_2015:100003640 / Halley (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100003641",
    label:
      "IAU_2015:100003641 / Halley (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100003645",
    label:
      "IAU_2015:100003645 / Halley (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100003646",
    label:
      "IAU_2015:100003646 / Halley (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100003650",
    label:
      "IAU_2015:100003650 / Halley (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100003651",
    label: "IAU_2015:100003651 / Halley (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100003655",
    label:
      "IAU_2015:100003655 / Halley (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100003656",
    label:
      "IAU_2015:100003656 / Halley (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100003660",
    label:
      "IAU_2015:100003660 / Halley (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100003661",
    label: "IAU_2015:100003661 / Halley (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100003665",
    label:
      "IAU_2015:100003665 / Halley (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100003666",
    label:
      "IAU_2015:100003666 / Halley (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100003670",
    label:
      "IAU_2015:100003670 / Halley (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100003671",
    label:
      "IAU_2015:100003671 / Halley (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100003675",
    label:
      "IAU_2015:100003675 / Halley (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100003676",
    label:
      "IAU_2015:100003676 / Halley (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100003680",
    label:
      "IAU_2015:100003680 / Halley (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100003681",
    label:
      "IAU_2015:100003681 / Halley (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100003685",
    label:
      "IAU_2015:100003685 / Halley (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100003686",
    label: "IAU_2015:100003686 / Halley (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:100004110",
    label:
      "IAU_2015:100004110 / Hartley 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100004115",
    label:
      "IAU_2015:100004115 / Hartley 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100004120",
    label:
      "IAU_2015:100004120 / Hartley 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100004125",
    label:
      "IAU_2015:100004125 / Hartley 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100004130",
    label:
      "IAU_2015:100004130 / Hartley 2 (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100004135",
    label:
      "IAU_2015:100004135 / Hartley 2 (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100004140",
    label:
      "IAU_2015:100004140 / Hartley 2 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100004145",
    label:
      "IAU_2015:100004145 / Hartley 2 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100004150",
    label:
      "IAU_2015:100004150 / Hartley 2 (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100004155",
    label:
      "IAU_2015:100004155 / Hartley 2 (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100004160",
    label:
      "IAU_2015:100004160 / Hartley 2 (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100004165",
    label:
      "IAU_2015:100004165 / Hartley 2 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100004170",
    label:
      "IAU_2015:100004170 / Hartley 2 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100004175",
    label:
      "IAU_2015:100004175 / Hartley 2 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100004180",
    label:
      "IAU_2015:100004180 / Hartley 2 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100004185",
    label:
      "IAU_2015:100004185 / Hartley 2 (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100009310",
    label:
      "IAU_2015:100009310 / Tempel 1 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100009315",
    label:
      "IAU_2015:100009315 / Tempel 1 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100009320",
    label:
      "IAU_2015:100009320 / Tempel 1 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100009325",
    label:
      "IAU_2015:100009325 / Tempel 1 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100009330",
    label:
      "IAU_2015:100009330 / Tempel 1 (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100009335",
    label:
      "IAU_2015:100009335 / Tempel 1 (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100009340",
    label:
      "IAU_2015:100009340 / Tempel 1 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100009345",
    label:
      "IAU_2015:100009345 / Tempel 1 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100009350",
    label:
      "IAU_2015:100009350 / Tempel 1 (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100009355",
    label:
      "IAU_2015:100009355 / Tempel 1 (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100009360",
    label:
      "IAU_2015:100009360 / Tempel 1 (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100009365",
    label:
      "IAU_2015:100009365 / Tempel 1 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100009370",
    label:
      "IAU_2015:100009370 / Tempel 1 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100009375",
    label:
      "IAU_2015:100009375 / Tempel 1 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100009380",
    label:
      "IAU_2015:100009380 / Tempel 1 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100009385",
    label:
      "IAU_2015:100009385 / Tempel 1 (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:100010710",
    label:
      "IAU_2015:100010710 / Wild 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:100010715",
    label:
      "IAU_2015:100010715 / Wild 2 (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:100010720",
    label:
      "IAU_2015:100010720 / Wild 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:100010725",
    label:
      "IAU_2015:100010725 / Wild 2 (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:100010730",
    label:
      "IAU_2015:100010730 / Wild 2 (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:100010735",
    label:
      "IAU_2015:100010735 / Wild 2 (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:100010740",
    label:
      "IAU_2015:100010740 / Wild 2 (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:100010745",
    label:
      "IAU_2015:100010745 / Wild 2 (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:100010750",
    label:
      "IAU_2015:100010750 / Wild 2 (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:100010755",
    label:
      "IAU_2015:100010755 / Wild 2 (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:100010760",
    label:
      "IAU_2015:100010760 / Wild 2 (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:100010765",
    label:
      "IAU_2015:100010765 / Wild 2 (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:100010770",
    label:
      "IAU_2015:100010770 / Wild 2 (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:100010775",
    label:
      "IAU_2015:100010775 / Wild 2 (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:100010780",
    label:
      "IAU_2015:100010780 / Wild 2 (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:100010785",
    label:
      "IAU_2015:100010785 / Wild 2 (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200000110",
    label:
      "IAU_2015:200000110 / Ceres (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200000111",
    label:
      "IAU_2015:200000111 / Ceres (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200000115",
    label:
      "IAU_2015:200000115 / Ceres (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200000116",
    label:
      "IAU_2015:200000116 / Ceres (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200000120",
    label:
      "IAU_2015:200000120 / Ceres (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200000121",
    label:
      "IAU_2015:200000121 / Ceres (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200000125",
    label:
      "IAU_2015:200000125 / Ceres (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200000126",
    label:
      "IAU_2015:200000126 / Ceres (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200000130",
    label:
      "IAU_2015:200000130 / Ceres (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200000131",
    label: "IAU_2015:200000131 / Ceres (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:200000135",
    label:
      "IAU_2015:200000135 / Ceres (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200000136",
    label: "IAU_2015:200000136 / Ceres (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:200000140",
    label:
      "IAU_2015:200000140 / Ceres (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200000141",
    label: "IAU_2015:200000141 / Ceres (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200000145",
    label:
      "IAU_2015:200000145 / Ceres (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200000146",
    label:
      "IAU_2015:200000146 / Ceres (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200000150",
    label:
      "IAU_2015:200000150 / Ceres (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200000151",
    label: "IAU_2015:200000151 / Ceres (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200000155",
    label:
      "IAU_2015:200000155 / Ceres (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200000156",
    label:
      "IAU_2015:200000156 / Ceres (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200000160",
    label:
      "IAU_2015:200000160 / Ceres (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200000161",
    label: "IAU_2015:200000161 / Ceres (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200000165",
    label:
      "IAU_2015:200000165 / Ceres (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200000166",
    label:
      "IAU_2015:200000166 / Ceres (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200000170",
    label:
      "IAU_2015:200000170 / Ceres (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200000171",
    label:
      "IAU_2015:200000171 / Ceres (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200000175",
    label:
      "IAU_2015:200000175 / Ceres (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200000176",
    label:
      "IAU_2015:200000176 / Ceres (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200000180",
    label:
      "IAU_2015:200000180 / Ceres (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200000181",
    label:
      "IAU_2015:200000181 / Ceres (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200000185",
    label:
      "IAU_2015:200000185 / Ceres (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200000186",
    label: "IAU_2015:200000186 / Ceres (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:200000410",
    label:
      "IAU_2015:200000410 / Vesta (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200000415",
    label:
      "IAU_2015:200000415 / Vesta (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200000420",
    label:
      "IAU_2015:200000420 / Vesta (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200000425",
    label:
      "IAU_2015:200000425 / Vesta (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200000430",
    label:
      "IAU_2015:200000430 / Vesta (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200000435",
    label:
      "IAU_2015:200000435 / Vesta (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200000440",
    label:
      "IAU_2015:200000440 / Vesta (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200000445",
    label:
      "IAU_2015:200000445 / Vesta (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200000450",
    label:
      "IAU_2015:200000450 / Vesta (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200000455",
    label:
      "IAU_2015:200000455 / Vesta (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200000460",
    label:
      "IAU_2015:200000460 / Vesta (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200000465",
    label:
      "IAU_2015:200000465 / Vesta (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200000470",
    label:
      "IAU_2015:200000470 / Vesta (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200000475",
    label:
      "IAU_2015:200000475 / Vesta (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200000480",
    label:
      "IAU_2015:200000480 / Vesta (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200000485",
    label:
      "IAU_2015:200000485 / Vesta (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200001610",
    label:
      "IAU_2015:200001610 / Psyche (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200001615",
    label:
      "IAU_2015:200001615 / Psyche (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200001620",
    label:
      "IAU_2015:200001620 / Psyche (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200001625",
    label:
      "IAU_2015:200001625 / Psyche (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200001630",
    label:
      "IAU_2015:200001630 / Psyche (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200001635",
    label:
      "IAU_2015:200001635 / Psyche (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200001640",
    label:
      "IAU_2015:200001640 / Psyche (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200001645",
    label:
      "IAU_2015:200001645 / Psyche (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200001650",
    label:
      "IAU_2015:200001650 / Psyche (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200001655",
    label:
      "IAU_2015:200001655 / Psyche (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200001660",
    label:
      "IAU_2015:200001660 / Psyche (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200001665",
    label:
      "IAU_2015:200001665 / Psyche (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200001670",
    label:
      "IAU_2015:200001670 / Psyche (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200001675",
    label:
      "IAU_2015:200001675 / Psyche (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200001680",
    label:
      "IAU_2015:200001680 / Psyche (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200001685",
    label:
      "IAU_2015:200001685 / Psyche (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200002110",
    label:
      "IAU_2015:200002110 / Lutetia (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200002115",
    label:
      "IAU_2015:200002115 / Lutetia (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200002120",
    label:
      "IAU_2015:200002120 / Lutetia (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200002125",
    label:
      "IAU_2015:200002125 / Lutetia (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200002130",
    label:
      "IAU_2015:200002130 / Lutetia (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200002135",
    label:
      "IAU_2015:200002135 / Lutetia (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200002140",
    label:
      "IAU_2015:200002140 / Lutetia (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200002145",
    label:
      "IAU_2015:200002145 / Lutetia (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200002150",
    label:
      "IAU_2015:200002150 / Lutetia (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200002155",
    label:
      "IAU_2015:200002155 / Lutetia (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200002160",
    label:
      "IAU_2015:200002160 / Lutetia (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200002165",
    label:
      "IAU_2015:200002165 / Lutetia (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200002170",
    label:
      "IAU_2015:200002170 / Lutetia (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200002175",
    label:
      "IAU_2015:200002175 / Lutetia (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200002180",
    label:
      "IAU_2015:200002180 / Lutetia (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200002185",
    label:
      "IAU_2015:200002185 / Lutetia (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200005210",
    label:
      "IAU_2015:200005210 / 52 Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200005215",
    label:
      "IAU_2015:200005215 / 52 Europa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200005220",
    label:
      "IAU_2015:200005220 / 52 Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200005225",
    label:
      "IAU_2015:200005225 / 52 Europa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200005230",
    label:
      "IAU_2015:200005230 / 52 Europa (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200005235",
    label:
      "IAU_2015:200005235 / 52 Europa (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200005240",
    label:
      "IAU_2015:200005240 / 52 Europa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200005245",
    label:
      "IAU_2015:200005245 / 52 Europa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200005250",
    label:
      "IAU_2015:200005250 / 52 Europa (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200005255",
    label:
      "IAU_2015:200005255 / 52 Europa (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200005260",
    label:
      "IAU_2015:200005260 / 52 Europa (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200005265",
    label:
      "IAU_2015:200005265 / 52 Europa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200005270",
    label:
      "IAU_2015:200005270 / 52 Europa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200005275",
    label:
      "IAU_2015:200005275 / 52 Europa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200005280",
    label:
      "IAU_2015:200005280 / 52 Europa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200005285",
    label:
      "IAU_2015:200005285 / 52 Europa (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200021610",
    label:
      "IAU_2015:200021610 / Kleopatra (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200021615",
    label:
      "IAU_2015:200021615 / Kleopatra (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200021620",
    label:
      "IAU_2015:200021620 / Kleopatra (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200021625",
    label:
      "IAU_2015:200021625 / Kleopatra (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200021630",
    label:
      "IAU_2015:200021630 / Kleopatra (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200021635",
    label:
      "IAU_2015:200021635 / Kleopatra (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200021640",
    label:
      "IAU_2015:200021640 / Kleopatra (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200021645",
    label:
      "IAU_2015:200021645 / Kleopatra (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200021650",
    label:
      "IAU_2015:200021650 / Kleopatra (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200021655",
    label:
      "IAU_2015:200021655 / Kleopatra (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200021660",
    label:
      "IAU_2015:200021660 / Kleopatra (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200021665",
    label:
      "IAU_2015:200021665 / Kleopatra (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200021670",
    label:
      "IAU_2015:200021670 / Kleopatra (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200021675",
    label:
      "IAU_2015:200021675 / Kleopatra (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200021680",
    label:
      "IAU_2015:200021680 / Kleopatra (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200021685",
    label:
      "IAU_2015:200021685 / Kleopatra (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200025310",
    label:
      "IAU_2015:200025310 / Mathilde (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200025315",
    label:
      "IAU_2015:200025315 / Mathilde (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200025320",
    label:
      "IAU_2015:200025320 / Mathilde (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200025325",
    label:
      "IAU_2015:200025325 / Mathilde (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200025330",
    label:
      "IAU_2015:200025330 / Mathilde (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200025335",
    label:
      "IAU_2015:200025335 / Mathilde (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200025340",
    label:
      "IAU_2015:200025340 / Mathilde (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200025345",
    label:
      "IAU_2015:200025345 / Mathilde (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200025350",
    label:
      "IAU_2015:200025350 / Mathilde (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200025355",
    label:
      "IAU_2015:200025355 / Mathilde (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200025360",
    label:
      "IAU_2015:200025360 / Mathilde (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200025365",
    label:
      "IAU_2015:200025365 / Mathilde (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200025370",
    label:
      "IAU_2015:200025370 / Mathilde (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200025375",
    label:
      "IAU_2015:200025375 / Mathilde (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200025380",
    label:
      "IAU_2015:200025380 / Mathilde (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200025385",
    label:
      "IAU_2015:200025385 / Mathilde (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200043310",
    label:
      "IAU_2015:200043310 / Eros (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200043311",
    label:
      "IAU_2015:200043311 / Eros (2015) / Ographic / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200043315",
    label:
      "IAU_2015:200043315 / Eros (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200043316",
    label:
      "IAU_2015:200043316 / Eros (2015) / Ographic / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200043320",
    label:
      "IAU_2015:200043320 / Eros (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200043321",
    label: "IAU_2015:200043321 / Eros (2015) / Ographic / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200043325",
    label:
      "IAU_2015:200043325 / Eros (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200043326",
    label:
      "IAU_2015:200043326 / Eros (2015) / Ographic / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200043330",
    label: "IAU_2015:200043330 / Eros (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200043331",
    label: "IAU_2015:200043331 / Eros (2015) / Ographic / North Polar",
  },
  {
    value: "IAU_2015:200043335",
    label: "IAU_2015:200043335 / Eros (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200043336",
    label: "IAU_2015:200043336 / Eros (2015) / Ographic / South Polar",
  },
  {
    value: "IAU_2015:200043340",
    label:
      "IAU_2015:200043340 / Eros (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200043341",
    label: "IAU_2015:200043341 / Eros (2015) / Ographic / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200043345",
    label:
      "IAU_2015:200043345 / Eros (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200043346",
    label:
      "IAU_2015:200043346 / Eros (2015) / Ographic / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200043350",
    label:
      "IAU_2015:200043350 / Eros (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200043351",
    label: "IAU_2015:200043351 / Eros (2015) / Ographic / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200043355",
    label:
      "IAU_2015:200043355 / Eros (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200043356",
    label: "IAU_2015:200043356 / Eros (2015) / Ographic / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200043360",
    label:
      "IAU_2015:200043360 / Eros (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200043361",
    label: "IAU_2015:200043361 / Eros (2015) / Ographic / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200043365",
    label:
      "IAU_2015:200043365 / Eros (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200043366",
    label:
      "IAU_2015:200043366 / Eros (2015) / Ographic / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200043370",
    label:
      "IAU_2015:200043370 / Eros (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200043371",
    label:
      "IAU_2015:200043371 / Eros (2015) / Ographic / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200043375",
    label:
      "IAU_2015:200043375 / Eros (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200043376",
    label:
      "IAU_2015:200043376 / Eros (2015) / Ographic / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200043380",
    label:
      "IAU_2015:200043380 / Eros (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200043381",
    label:
      "IAU_2015:200043381 / Eros (2015) / Ographic / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200043385",
    label:
      "IAU_2015:200043385 / Eros (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200043386",
    label: "IAU_2015:200043386 / Eros (2015) / Ographic / Albers Equal Area",
  },
  {
    value: "IAU_2015:200051110",
    label:
      "IAU_2015:200051110 / Davida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200051115",
    label:
      "IAU_2015:200051115 / Davida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200051120",
    label:
      "IAU_2015:200051120 / Davida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200051125",
    label:
      "IAU_2015:200051125 / Davida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200051130",
    label:
      "IAU_2015:200051130 / Davida (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200051135",
    label:
      "IAU_2015:200051135 / Davida (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200051140",
    label:
      "IAU_2015:200051140 / Davida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200051145",
    label:
      "IAU_2015:200051145 / Davida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200051150",
    label:
      "IAU_2015:200051150 / Davida (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200051155",
    label:
      "IAU_2015:200051155 / Davida (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200051160",
    label:
      "IAU_2015:200051160 / Davida (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200051165",
    label:
      "IAU_2015:200051165 / Davida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200051170",
    label:
      "IAU_2015:200051170 / Davida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200051175",
    label:
      "IAU_2015:200051175 / Davida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200051180",
    label:
      "IAU_2015:200051180 / Davida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200051185",
    label:
      "IAU_2015:200051185 / Davida (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200286710",
    label:
      "IAU_2015:200286710 / Steins (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200286715",
    label:
      "IAU_2015:200286715 / Steins (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200286720",
    label:
      "IAU_2015:200286720 / Steins (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200286725",
    label:
      "IAU_2015:200286725 / Steins (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200286730",
    label:
      "IAU_2015:200286730 / Steins (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200286735",
    label:
      "IAU_2015:200286735 / Steins (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200286740",
    label:
      "IAU_2015:200286740 / Steins (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200286745",
    label:
      "IAU_2015:200286745 / Steins (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200286750",
    label:
      "IAU_2015:200286750 / Steins (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200286755",
    label:
      "IAU_2015:200286755 / Steins (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200286760",
    label:
      "IAU_2015:200286760 / Steins (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200286765",
    label:
      "IAU_2015:200286765 / Steins (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200286770",
    label:
      "IAU_2015:200286770 / Steins (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200286775",
    label:
      "IAU_2015:200286775 / Steins (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200286780",
    label:
      "IAU_2015:200286780 / Steins (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200286785",
    label:
      "IAU_2015:200286785 / Steins (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:200417910",
    label:
      "IAU_2015:200417910 / Toutatis (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:200417915",
    label:
      "IAU_2015:200417915 / Toutatis (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:200417920",
    label:
      "IAU_2015:200417920 / Toutatis (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:200417925",
    label:
      "IAU_2015:200417925 / Toutatis (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:200417930",
    label:
      "IAU_2015:200417930 / Toutatis (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:200417935",
    label:
      "IAU_2015:200417935 / Toutatis (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:200417940",
    label:
      "IAU_2015:200417940 / Toutatis (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:200417945",
    label:
      "IAU_2015:200417945 / Toutatis (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:200417950",
    label:
      "IAU_2015:200417950 / Toutatis (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:200417955",
    label:
      "IAU_2015:200417955 / Toutatis (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:200417960",
    label:
      "IAU_2015:200417960 / Toutatis (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:200417965",
    label:
      "IAU_2015:200417965 / Toutatis (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:200417970",
    label:
      "IAU_2015:200417970 / Toutatis (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:200417975",
    label:
      "IAU_2015:200417975 / Toutatis (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:200417980",
    label:
      "IAU_2015:200417980 / Toutatis (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:200417985",
    label:
      "IAU_2015:200417985 / Toutatis (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:202514310",
    label:
      "IAU_2015:202514310 / Itokawa (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:202514315",
    label:
      "IAU_2015:202514315 / Itokawa (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:202514320",
    label:
      "IAU_2015:202514320 / Itokawa (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:202514325",
    label:
      "IAU_2015:202514325 / Itokawa (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:202514330",
    label:
      "IAU_2015:202514330 / Itokawa (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:202514335",
    label:
      "IAU_2015:202514335 / Itokawa (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:202514340",
    label:
      "IAU_2015:202514340 / Itokawa (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:202514345",
    label:
      "IAU_2015:202514345 / Itokawa (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:202514350",
    label:
      "IAU_2015:202514350 / Itokawa (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:202514355",
    label:
      "IAU_2015:202514355 / Itokawa (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:202514360",
    label:
      "IAU_2015:202514360 / Itokawa (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:202514365",
    label:
      "IAU_2015:202514365 / Itokawa (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:202514370",
    label:
      "IAU_2015:202514370 / Itokawa (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:202514375",
    label:
      "IAU_2015:202514375 / Itokawa (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:202514380",
    label:
      "IAU_2015:202514380 / Itokawa (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:202514385",
    label:
      "IAU_2015:202514385 / Itokawa (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:243101010",
    label:
      "IAU_2015:243101010 / Ida (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:243101015",
    label:
      "IAU_2015:243101015 / Ida (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:243101020",
    label:
      "IAU_2015:243101020 / Ida (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:243101025",
    label:
      "IAU_2015:243101025 / Ida (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:243101030",
    label: "IAU_2015:243101030 / Ida (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:243101035",
    label: "IAU_2015:243101035 / Ida (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:243101040",
    label:
      "IAU_2015:243101040 / Ida (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:243101045",
    label:
      "IAU_2015:243101045 / Ida (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:243101050",
    label:
      "IAU_2015:243101050 / Ida (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:243101055",
    label:
      "IAU_2015:243101055 / Ida (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:243101060",
    label:
      "IAU_2015:243101060 / Ida (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:243101065",
    label:
      "IAU_2015:243101065 / Ida (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:243101070",
    label:
      "IAU_2015:243101070 / Ida (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:243101075",
    label:
      "IAU_2015:243101075 / Ida (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:243101080",
    label:
      "IAU_2015:243101080 / Ida (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:243101085",
    label:
      "IAU_2015:243101085 / Ida (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IAU_2015:951101010",
    label:
      "IAU_2015:951101010 / Gaspra (2015) - Sphere / Ocentric / Equirectangular, clon = 0",
  },
  {
    value: "IAU_2015:951101015",
    label:
      "IAU_2015:951101015 / Gaspra (2015) - Sphere / Ocentric / Equirectangular, clon = 180",
  },
  {
    value: "IAU_2015:951101020",
    label:
      "IAU_2015:951101020 / Gaspra (2015) - Sphere / Ocentric / Sinusoidal, clon = 0",
  },
  {
    value: "IAU_2015:951101025",
    label:
      "IAU_2015:951101025 / Gaspra (2015) - Sphere / Ocentric / Sinusoidal, clon = 180",
  },
  {
    value: "IAU_2015:951101030",
    label:
      "IAU_2015:951101030 / Gaspra (2015) - Sphere / Ocentric / North Polar",
  },
  {
    value: "IAU_2015:951101035",
    label:
      "IAU_2015:951101035 / Gaspra (2015) - Sphere / Ocentric / South Polar",
  },
  {
    value: "IAU_2015:951101040",
    label:
      "IAU_2015:951101040 / Gaspra (2015) - Sphere / Ocentric / Mollweide, clon = 0",
  },
  {
    value: "IAU_2015:951101045",
    label:
      "IAU_2015:951101045 / Gaspra (2015) - Sphere / Ocentric / Mollweide, clon = 180",
  },
  {
    value: "IAU_2015:951101050",
    label:
      "IAU_2015:951101050 / Gaspra (2015) - Sphere / Ocentric / Robinson, clon = 0",
  },
  {
    value: "IAU_2015:951101055",
    label:
      "IAU_2015:951101055 / Gaspra (2015) - Sphere / Ocentric / Robinson, clon = 180",
  },
  {
    value: "IAU_2015:951101060",
    label:
      "IAU_2015:951101060 / Gaspra (2015) - Sphere / Ocentric / Tranverse Mercator",
  },
  {
    value: "IAU_2015:951101065",
    label:
      "IAU_2015:951101065 / Gaspra (2015) - Sphere / Ocentric / Orthographic, clon = 0",
  },
  {
    value: "IAU_2015:951101070",
    label:
      "IAU_2015:951101070 / Gaspra (2015) - Sphere / Ocentric / Orthographic, clon = 180",
  },
  {
    value: "IAU_2015:951101075",
    label:
      "IAU_2015:951101075 / Gaspra (2015) - Sphere / Ocentric / Lambert Conic Conformal",
  },
  {
    value: "IAU_2015:951101080",
    label:
      "IAU_2015:951101080 / Gaspra (2015) - Sphere / Ocentric / Lambert Azimuthal Equal Area",
  },
  {
    value: "IAU_2015:951101085",
    label:
      "IAU_2015:951101085 / Gaspra (2015) - Sphere / Ocentric / Albers Equal Area",
  },
  {
    value: "IGNF:AMANU63UTM7S",
    label: "IGNF:AMANU63UTM7S / Amanu (MHPF 1963) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:AMST63UTM43S",
    label: "IGNF:AMST63UTM43S / Amsterdam 1963 UTM Sud fuseau 43",
  },
  {
    value: "IGNF:ANAA47UTM6S",
    label: "IGNF:ANAA47UTM6S / Anaa (SHM 1947) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:ANAA92UTM6S",
    label: "IGNF:ANAA92UTM6S / Anaa (MOP92) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:APAT80UTM6S",
    label: "IGNF:APAT80UTM6S / Apataki (Cadastre 1980) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:APAT86UTM6S",
    label: "IGNF:APAT86UTM6S / Tuamotu (MOP86) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:APAT86UTM7S",
    label: "IGNF:APAT86UTM7S / Tuamotu (MOP86) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:ATIGBONNE",
    label: "IGNF:ATIGBONNE / ATIG Bonne France Etat Major",
  },
  {
    value: "IGNF:ATUO63UTM7S",
    label: "IGNF:ATUO63UTM7S / IGN 1963 UTM Sud fuseau 7",
  },
  {
    value: "IGNF:C67IG95UTM21",
    label: "IGNF:C67IG95UTM21 / CSG67(IGN 1995) UTM Nord fuseau 21",
  },
  {
    value: "IGNF:C67IG95UTM22",
    label: "IGNF:C67IG95UTM22 / CSG67 (IGN 1995) UTM Nord fuseau 22",
  },
  {
    value: "IGNF:CAD97UTM38S",
    label: "IGNF:CAD97UTM38S / Cadastre 1997 UTM Sud fuseau 38",
  },
  {
    value: "IGNF:CLIP57UTM12",
    label: "IGNF:CLIP57UTM12 / Clipperton 1967 UTM Nord fuseau 12",
  },
  {
    value: "IGNF:CLIP67UTM12",
    label: "IGNF:CLIP67UTM12 / Clipperton 1967 UTM Nord fuseau 12",
  },
  {
    value: "IGNF:CROZ63UTM39S",
    label: "IGNF:CROZ63UTM39S / CROZET POSSESSION 1963 UTM SUD FUSEAU 39",
  },
  {
    value: "IGNF:CSG67UTM21",
    label: "IGNF:CSG67UTM21 / CSG67 UTM Nord fuseau 21",
  },
  {
    value: "IGNF:CSG67UTM22",
    label: "IGNF:CSG67UTM22 / CSG67 UTM Nord fuseau 22",
  },
  { value: "IGNF:ED50UTM30", label: "IGNF:ED50UTM30 / ED50 UTM fuseau 30" },
  {
    value: "IGNF:ED50UTM31",
    label: "IGNF:ED50UTM31 / ED50 UTM NORD FUSEAU 31",
  },
  { value: "IGNF:ED50UTM32", label: "IGNF:ED50UTM32 / ED50 UTM fuseau 32" },
  {
    value: "IGNF:EFAT57UTM59S",
    label: "IGNF:EFAT57UTM59S / Efate UTM Sud fuseau 59",
  },
  {
    value: "IGNF:EFATE57UT59S",
    label: "IGNF:EFATE57UT59S / Efate UTM Sud fuseau 59",
  },
  {
    value: "IGNF:ETRS89LAEA",
    label: "IGNF:ETRS89LAEA / ETRS89 Lambert Azimutal Equal Area",
  },
  {
    value: "IGNF:ETRS89LCC",
    label: "IGNF:ETRS89LCC / ETRS89 Lambert Conformal Conic",
  },
  {
    value: "IGNF:ETRS89UTM26",
    label: "IGNF:ETRS89UTM26 / ETRS89 UTM Nord fuseau 26",
  },
  {
    value: "IGNF:ETRS89UTM27",
    label: "IGNF:ETRS89UTM27 / ETRS89 UTM Nord fuseau 27",
  },
  {
    value: "IGNF:ETRS89UTM28",
    label: "IGNF:ETRS89UTM28 / ETRS89 UTM Nord fuseau 28",
  },
  {
    value: "IGNF:ETRS89UTM29",
    label: "IGNF:ETRS89UTM29 / ETRS89 UTM Nord fuseau 29",
  },
  {
    value: "IGNF:ETRS89UTM30",
    label: "IGNF:ETRS89UTM30 / ETRS89 UTM Nord fuseau 30",
  },
  {
    value: "IGNF:ETRS89UTM31",
    label: "IGNF:ETRS89UTM31 / ETRS89 UTM Nord fuseau 31",
  },
  {
    value: "IGNF:ETRS89UTM32",
    label: "IGNF:ETRS89UTM32 / ETRS89 UTM Nord fuseau 32",
  },
  {
    value: "IGNF:ETRS89UTM33",
    label: "IGNF:ETRS89UTM33 / ETRS89 UTM Nord fuseau 33",
  },
  {
    value: "IGNF:ETRS89UTM34",
    label: "IGNF:ETRS89UTM34 / ETRS89 UTM Nord fuseau 34",
  },
  {
    value: "IGNF:ETRS89UTM35",
    label: "IGNF:ETRS89UTM35 / ETRS89 UTM Nord fuseau 35",
  },
  {
    value: "IGNF:ETRS89UTM36",
    label: "IGNF:ETRS89UTM36 / ETRS89 UTM Nord fuseau 36",
  },
  {
    value: "IGNF:ETRS89UTM37",
    label: "IGNF:ETRS89UTM37 / ETRS89 UTM Nord fuseau 37",
  },
  {
    value: "IGNF:ETRS89UTM38",
    label: "IGNF:ETRS89UTM38 / ETRS89 UTM Nord fuseau 38",
  },
  {
    value: "IGNF:EURO54UTM37S",
    label: "IGNF:EURO54UTM37S / EUROPA MHM 1954 UTM SUD FUSEAU 37",
  },
  {
    value: "IGNF:EUROPA54MD",
    label: "IGNF:EUROPA54MD / Europa Mercator directe",
  },
  {
    value: "IGNF:FAKA50UTM6S",
    label: "IGNF:FAKA50UTM6S / Fakarava (SHM 1947-1950) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:FANG651UTM7S",
    label: "IGNF:FANG651UTM7S / Fangataufa (MHPF 1965-1) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANG652UTM7S",
    label: "IGNF:FANG652UTM7S / Fangataufa (MHPF 1965-2) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANGA64UTM7S",
    label: "IGNF:FANGA64UTM7S / Fangataufa (MHPF 1964) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANGA651U7S",
    label: "IGNF:FANGA651U7S / Fangataufa (MHPF 1965-1) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANGA652U7S",
    label: "IGNF:FANGA652U7S / Fangataufa (MHPF 1965-2) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANGA66UTM7S",
    label: "IGNF:FANGA66UTM7S / Fangataufa (MHPF 1966) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:FANGA84UTM7S",
    label: "IGNF:FANGA84UTM7S / Fangataufa (MOP84) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:GEOPORTALANF",
    label: "IGNF:GEOPORTALANF / ANTILLES FRANCAISES PROJECTION GEOPORTAIL",
  },
  {
    value: "IGNF:GEOPORTALASP",
    label: "IGNF:GEOPORTALASP / Amsterdam Saint-Paul projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALCRZ",
    label: "IGNF:GEOPORTALCRZ / Crozet projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALFXX",
    label: "IGNF:GEOPORTALFXX / France Metropolitaine projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALGUF",
    label: "IGNF:GEOPORTALGUF / Guyane Francaise projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALKER",
    label: "IGNF:GEOPORTALKER / Kerguelen projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALMYT",
    label: "IGNF:GEOPORTALMYT / Mayotte projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALNCL",
    label: "IGNF:GEOPORTALNCL / Nouvelle Caledonie projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALPYF",
    label: "IGNF:GEOPORTALPYF / Polynesie Francaise projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALREU",
    label: "IGNF:GEOPORTALREU / Reunion projection Geoportail",
  },
  {
    value: "IGNF:GEOPORTALSPM",
    label: "IGNF:GEOPORTALSPM / Saint-Pierre-et-Miquelon Geoportail",
  },
  {
    value: "IGNF:GEOPORTALWLF",
    label: "IGNF:GEOPORTALWLF / Wallis et Futuna projection Geoportail",
  },
  {
    value: "IGNF:GLOR77MD",
    label: "IGNF:GLOR77MD / Glorieuses Mercator directe",
  },
  {
    value: "IGNF:GLOR77UTM38S",
    label: "IGNF:GLOR77UTM38S / GLORIEUSES MHG 1977 UTM SUD FUSEAU 38",
  },
  {
    value: "IGNF:GTN51UTM58S",
    label: "IGNF:GTN51UTM58S / GOMEN TERME NORD 1951 UTM SUD FUSEAU 58",
  },
  {
    value: "IGNF:GUAD48UTM20",
    label: "IGNF:GUAD48UTM20 / Guadeloupe Ste Anne UTM Nord fuseau 20",
  },
  {
    value: "IGNF:GUADANNUTM20",
    label: "IGNF:GUADANNUTM20 / Guadeloupe Ste Anne UTM Nord fuseau 20",
  },
  {
    value: "IGNF:GUADFM49U20",
    label: "IGNF:GUADFM49U20 / Guadeloupe Fort-Marigot UTM Nord fuseau 20",
  },
  {
    value: "IGNF:GUADFMUTM20",
    label: "IGNF:GUADFMUTM20 / Guadeloupe Fort-Marigot UTM Nord fuseau 20",
  },
  {
    value: "IGNF:HAO58UTM7S",
    label: "IGNF:HAO58UTM7S / Hao (MHPF 1958) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HAO67UTM7S",
    label: "IGNF:HAO67UTM7S / Hao Amanu (MHPF 1967) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HAOAM67UTM7S",
    label: "IGNF:HAOAM67UTM7S / Hao Amanu (MHPF 1967) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HARA49UTM7S",
    label: "IGNF:HARA49UTM7S / Haraiki (SHM 1949) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HIKU50UTM7S",
    label: "IGNF:HIKU50UTM7S / Hikueru (SHM 1947-1950) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HIVA60UTM7S",
    label: "IGNF:HIVA60UTM7S / Hiva Oa (MHPF 1960) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:HIVA67UTM7S",
    label: "IGNF:HIVA67UTM7S / Hiva Oa (MHPF 1967) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:IGN63UTM7S",
    label: "IGNF:IGN63UTM7S / IGN 1963 UTM Sud fuseau 7",
  },
  {
    value: "IGNF:IGN72LAM",
    label: "IGNF:IGN72LAM / IGN72 Lambert Nouvelle-Caledonie",
  },
  {
    value: "IGNF:IGN72LAMBNC",
    label: "IGNF:IGN72LAMBNC / IGN72 Lambert Nouvelle-Caledonie",
  },
  {
    value: "IGNF:IGN72UTM58S",
    label: "IGNF:IGN72UTM58S / IGN72 UTM Sud fuseau 58",
  },
  {
    value: "IGNF:KAUE70UTM6S",
    label: "IGNF:KAUE70UTM6S / Kauehi (MHPF70) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:KERG62UTM42S",
    label: "IGNF:KERG62UTM42S / KERGUELEN K0 IGN 1962 UTM SUD FUSEAU 42",
  },
  { value: "IGNF:LAMB1", label: "IGNF:LAMB1 / NTF Lambert I" },
  { value: "IGNF:LAMB1C", label: "IGNF:LAMB1C / NTF Lambert I carto" },
  { value: "IGNF:LAMB2", label: "IGNF:LAMB2 / NTF Lambert II" },
  { value: "IGNF:LAMB2C", label: "IGNF:LAMB2C / NTF Lambert II carto" },
  { value: "IGNF:LAMB3", label: "IGNF:LAMB3 / NTF Lambert III" },
  { value: "IGNF:LAMB3C", label: "IGNF:LAMB3C / NTF Lambert III carto" },
  { value: "IGNF:LAMB4", label: "IGNF:LAMB4 / NTF Lambert IV" },
  { value: "IGNF:LAMB4C", label: "IGNF:LAMB4C / NTF Lambert IV carto" },
  { value: "IGNF:LAMB93", label: "IGNF:LAMB93 / RGF93 Lambert 93" },
  { value: "IGNF:LAMBE", label: "IGNF:LAMBE / NTF Lambert II etendu" },
  { value: "IGNF:LAMBGC", label: "IGNF:LAMBGC / NTF Lambert Grand Champ" },
  {
    value: "IGNF:LIFOU56UT58S",
    label: "IGNF:LIFOU56UT58S / Lifou IGN 56 UTM Sud fuseau 58",
  },
  {
    value: "IGNF:LNGLNG",
    label: "IGNF:LNGLNG / Lambert Nord de Guerre Lambert Nord de Guerre",
  },
  {
    value: "IGNF:LURESGKL",
    label:
      "IGNF:LURESGKL / NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG",
  },
  {
    value: "IGNF:LUXGAUSSK",
    label:
      "IGNF:LUXGAUSSK / NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG",
  },
  {
    value: "IGNF:MAKE50UTM7S",
    label: "IGNF:MAKE50UTM7S / Makemo (SHM 1947-1950) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:MANGA51U8S",
    label: "IGNF:MANGA51U8S / Mangareva 1951 UTM Sud fuseau 8",
  },
  {
    value: "IGNF:MANGA51UTM8S",
    label: "IGNF:MANGA51UTM8S / Mangareva 1951 UTM Sud fuseau 8",
  },
  {
    value: "IGNF:MARE53UTM58S",
    label: "IGNF:MARE53UTM58S / Mare IGN53 UTM Sud fuseau 58",
  },
  {
    value: "IGNF:MART38UTM20",
    label: "IGNF:MART38UTM20 / Martinique Fort-Desaix UTM Nord fuseau 20",
  },
  {
    value: "IGNF:MARTFDUTM20",
    label: "IGNF:MARTFDUTM20 / Martinique Fort-Desaix UTM Nord fuseau 20",
  },
  {
    value: "IGNF:MAUPITIUTM5S",
    label: "IGNF:MAUPITIUTM5S / Maupiti (MOP 1983) UTM Sud fuseau 5",
  },
  {
    value: "IGNF:MAYO50UTM38S",
    label: "IGNF:MAYO50UTM38S / Combani UTM Sud fuseau 38",
  },
  {
    value: "IGNF:MHPF67UTM8S",
    label: "IGNF:MHPF67UTM8S / MHPF 1967 UTM SUD FUSEAU 8",
  },
  {
    value: "IGNF:MILLER",
    label: "IGNF:MILLER / WGS84 PROJECTION MILLER GEOPORTAIL",
  },
  {
    value: "IGNF:MOORE87UTM6S",
    label: "IGNF:MOORE87UTM6S / Moorea 1987 UTM Sud fuseau 6",
  },
  {
    value: "IGNF:MOOREA87U6S",
    label: "IGNF:MOOREA87U6S / Moorea 1987 UTM Sud fuseau 6",
  },
  {
    value: "IGNF:MOP90UTM6S",
    label: "IGNF:MOP90UTM6S / Tetiaroa (MOP90) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:MURU59UTM7S",
    label: "IGNF:MURU59UTM7S / Mururoa (MHPF 1959) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:MURU62UTM7S",
    label: "IGNF:MURU62UTM7S / Mururoa (MHOI 1962) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:MURU78UTM7S",
    label: "IGNF:MURU78UTM7S / Mururoa (IGN 1978) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:NC51UTM58S",
    label: "IGNF:NC51UTM58S / GOMEN TERME NORD 1951 UTM SUD FUSEAU 58",
  },
  {
    value: "IGNF:NEA74LBTNM2",
    label: "IGNF:NEA74LBTNM2 / NEA74 NOUMEA Lambert Noumea 2",
  },
  {
    value: "IGNF:NOVA53UTM38S",
    label: "IGNF:NOVA53UTM38S / JUAN DE NOVA MHM 1953 UTM SUD FUSEAU 38",
  },
  { value: "IGNF:NTFLAMB1", label: "IGNF:NTFLAMB1 / NTF Lambert I" },
  { value: "IGNF:NTFLAMB1C", label: "IGNF:NTFLAMB1C / NTF Lambert I carto" },
  { value: "IGNF:NTFLAMB2", label: "IGNF:NTFLAMB2 / NTF Lambert II" },
  { value: "IGNF:NTFLAMB2C", label: "IGNF:NTFLAMB2C / NTF Lambert II carto" },
  { value: "IGNF:NTFLAMB2E", label: "IGNF:NTFLAMB2E / NTF Lambert II etendu" },
  { value: "IGNF:NTFLAMB3", label: "IGNF:NTFLAMB3 / NTF Lambert III" },
  { value: "IGNF:NTFLAMB3C", label: "IGNF:NTFLAMB3C / NTF Lambert III carto" },
  { value: "IGNF:NTFLAMB4", label: "IGNF:NTFLAMB4 / NTF Lambert IV" },
  { value: "IGNF:NTFLAMB4C", label: "IGNF:NTFLAMB4C / NTF Lambert IV carto" },
  {
    value: "IGNF:NTFLAMBGC",
    label: "IGNF:NTFLAMBGC / NTF Lambert Grand Champ",
  },
  {
    value: "IGNF:NUKU72U7S",
    label: "IGNF:NUKU72U7S / Nuku Hiva UTM Sud fuseau 7",
  },
  {
    value: "IGNF:NUKU72UTM7S",
    label: "IGNF:NUKU72UTM7S / Nuku Hiva UTM Sud fuseau 7",
  },
  {
    value: "IGNF:OUVE72UTM58S",
    label: "IGNF:OUVE72UTM58S / Ouvea MHNC 1972 UTM Sud fuseau 58",
  },
  {
    value: "IGNF:OUVEA72U58S",
    label: "IGNF:OUVEA72U58S / Ouvea MHNC 1972 UTM Sud fuseau 58",
  },
  {
    value: "IGNF:PDN08GAUSSL",
    label: "IGNF:PDN08GAUSSL / Piton des Neiges (2008) Gauss Laborde Reunion",
  },
  {
    value: "IGNF:PDN92GAUSSL",
    label: "IGNF:PDN92GAUSSL / Piton des Neiges (1992) Gauss Laborde Reunion",
  },
  {
    value: "IGNF:PGP50STEREPS",
    label:
      "IGNF:PGP50STEREPS / TERRE ADELIE POINTE GEOLOGIE PERROUD STEREO POLAIRE SUD (TANGENTE)",
  },
  {
    value: "IGNF:RAIA53UTM5S",
    label: "IGNF:RAIA53UTM5S / IGN53 Societe UTM Sud fuseau 5",
  },
  {
    value: "IGNF:RAIV54UTM6S",
    label: "IGNF:RAIV54UTM6S / Raivavae (Cadastre) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RAIV66UTM6S",
    label: "IGNF:RAIV66UTM6S / Raivavae (MHPF 1966) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI47U6S",
    label: "IGNF:RANGI47U6S / Rangiroa (MGT 1947) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI47UTM6S",
    label: "IGNF:RANGI47UTM6S / Rangiroa (MGT 1947) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI59U6S",
    label: "IGNF:RANGI59U6S / Rangiroa (MHPF 1959) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI59UTM6S",
    label: "IGNF:RANGI59UTM6S / Rangiroa (MHPF 1959) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI68U6S",
    label: "IGNF:RANGI68U6S / Rangiroa (MHPF 1966-68) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:RANGI68UTM6S",
    label: "IGNF:RANGI68UTM6S / Rangiroa (MHPF 1966-68) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:REUN47GAUSSL",
    label: "IGNF:REUN47GAUSSL / Reunion Piton des Neiges Gauss Laborde",
  },
  {
    value: "IGNF:REUN49GAUSSL",
    label: "IGNF:REUN49GAUSSL / Reunion Piton des Neiges Gauss Laborde",
  },
  {
    value: "IGNF:RGAF09UTM20",
    label: "IGNF:RGAF09UTM20 / RGAF09 UTM Nord Fuseau 20",
  },
  { value: "IGNF:RGF93CC42", label: "IGNF:RGF93CC42 / RGF93 CC42 zone 1" },
  { value: "IGNF:RGF93CC43", label: "IGNF:RGF93CC43 / RGF93 CC43 zone 2" },
  { value: "IGNF:RGF93CC44", label: "IGNF:RGF93CC44 / RGF93 CC44 zone 3" },
  { value: "IGNF:RGF93CC45", label: "IGNF:RGF93CC45 / RGF93 CC45 zone 4" },
  { value: "IGNF:RGF93CC46", label: "IGNF:RGF93CC46 / RGF93 CC46 zone 5" },
  { value: "IGNF:RGF93CC47", label: "IGNF:RGF93CC47 / RGF93 CC47 zone 6" },
  { value: "IGNF:RGF93CC48", label: "IGNF:RGF93CC48 / RGF93 CC48 zone 7" },
  { value: "IGNF:RGF93CC49", label: "IGNF:RGF93CC49 / RGF93 CC49 zone 8" },
  { value: "IGNF:RGF93CC50", label: "IGNF:RGF93CC50 / RGF93 CC50 zone 9" },
  {
    value: "IGNF:RGF93EQGPFR",
    label: "IGNF:RGF93EQGPFR / France Metropolitaine projection Geoportail",
  },
  { value: "IGNF:RGF93LAMB93", label: "IGNF:RGF93LAMB93 / RGF93 Lambert 93" },
  {
    value: "IGNF:RGF93UTM30",
    label: "IGNF:RGF93UTM30 / RGF93 UTM NORD FUSEAU 30",
  },
  { value: "IGNF:RGF93UTM31", label: "IGNF:RGF93UTM31 / RGF93 UTM fuseau 31" },
  { value: "IGNF:RGF93UTM32", label: "IGNF:RGF93UTM32 / RGF93 UTM fuseau 32" },
  {
    value: "IGNF:RGFG95EQGPGU",
    label: "IGNF:RGFG95EQGPGU / Guyane Francaise projection Geoportail",
  },
  {
    value: "IGNF:RGFG95UTM21",
    label: "IGNF:RGFG95UTM21 / RGFG95 UTM Nord f.21",
  },
  {
    value: "IGNF:RGFG95UTM22",
    label: "IGNF:RGFG95UTM22 / RGFG95 UTM Nord f.22",
  },
  {
    value: "IGNF:RGM04EQGPMYT",
    label: "IGNF:RGM04EQGPMYT / Mayotte projection Geoportail",
  },
  {
    value: "IGNF:RGM04UTM38S",
    label: "IGNF:RGM04UTM38S / RGM04 UTM Sud fuseau 38",
  },
  {
    value: "IGNF:RGNC91EQGPNC",
    label: "IGNF:RGNC91EQGPNC / Nouvelle Caledonie projection Geoportail",
  },
  {
    value: "IGNF:RGNCLAM",
    label: "IGNF:RGNCLAM / RGNC Lambert Nouvelle-Caledonie",
  },
  {
    value: "IGNF:RGNCLAMBNC",
    label: "IGNF:RGNCLAMBNC / RGNC Lambert Nouvelle-Caledonie",
  },
  {
    value: "IGNF:RGNCUTM57S",
    label: "IGNF:RGNCUTM57S / RGNC UTM Sud fuseau 57",
  },
  {
    value: "IGNF:RGNCUTM58S",
    label: "IGNF:RGNCUTM58S / RGNC UTM Sud fuseau 58",
  },
  {
    value: "IGNF:RGNCUTM59S",
    label: "IGNF:RGNCUTM59S / RGNC UTM Sud fuseau 59",
  },
  {
    value: "IGNF:RGPFEQGPPF",
    label: "IGNF:RGPFEQGPPF / Polynesie Francaise projection Geoportail",
  },
  { value: "IGNF:RGPFUTM5S", label: "IGNF:RGPFUTM5S / RGPF UTM Sud fuseau 5" },
  { value: "IGNF:RGPFUTM6S", label: "IGNF:RGPFUTM6S / RGPF UTM Sud fuseau 6" },
  { value: "IGNF:RGPFUTM7S", label: "IGNF:RGPFUTM7S / RGPF UTM Sud fuseau 7" },
  { value: "IGNF:RGPFUTM8S", label: "IGNF:RGPFUTM8S / RGPF UTM SUD FUSEAU 8" },
  {
    value: "IGNF:RGR92EQGPREU",
    label: "IGNF:RGR92EQGPREU / Reunion projection Geoportail",
  },
  { value: "IGNF:RGR92UTM40S", label: "IGNF:RGR92UTM40S / RGR92 UTM 40 Sud" },
  {
    value: "IGNF:RGSPM06EQGP",
    label: "IGNF:RGSPM06EQGP / Saint-Pierre-et-Miquelon Geoportail",
  },
  {
    value: "IGNF:RGSPM06U21",
    label: "IGNF:RGSPM06U21 / RGSPM06 UTM Nord fuseau 21",
  },
  {
    value: "IGNF:RGTAAFUTM37S",
    label: "IGNF:RGTAAFUTM37S / RGTAAF07 UTM Sud fuseau 37",
  },
  {
    value: "IGNF:RGTAAFUTM39S",
    label: "IGNF:RGTAAFUTM39S / RGTAAF07 UTM Sud fuseau 39",
  },
  {
    value: "IGNF:RGTAAFUTM42S",
    label: "IGNF:RGTAAFUTM42S / RGTAAF07 UTM Sud fuseau 42",
  },
  {
    value: "IGNF:RGTAAFUTM43S",
    label: "IGNF:RGTAAFUTM43S / RGTAAF07 UTM Sud fuseau 43",
  },
  {
    value: "IGNF:RGTAAFUTM53S",
    label: "IGNF:RGTAAFUTM53S / RGTAAF07 UTM SUD FUSEAU 53",
  },
  {
    value: "IGNF:RGWF96UTM1S",
    label:
      "IGNF:RGWF96UTM1S / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1",
  },
  {
    value: "IGNF:RRAFUTM20",
    label: "IGNF:RRAFUTM20 / RRAF UTM Nord fuseau 20",
  },
  {
    value: "IGNF:RUSAT84UTM5S",
    label: "IGNF:RUSAT84UTM5S / Rurutu (SAT84) UTM Sud fuseau 5",
  },
  {
    value: "IGNF:SAT84UTM5S",
    label: "IGNF:SAT84UTM5S / Rurutu (SAT84) UTM Sud fuseau 5",
  },
  {
    value: "IGNF:ST84UTM58S",
    label: "IGNF:ST84UTM58S / ST 84 ILE DES PINS UTM Sud fuseau 58",
  },
  {
    value: "IGNF:ST87UTM58S",
    label: "IGNF:ST87UTM58S / ST 87 OUVEA UTM Sud fuseau 58",
  },
  {
    value: "IGNF:STPL69UTM43S",
    label: "IGNF:STPL69UTM43S / Saint-Paul UTM Sud fuseau 43",
  },
  {
    value: "IGNF:STPM50UTM21",
    label: "IGNF:STPM50UTM21 / St-Pierre-et-Miquelon UTM Nord f.21",
  },
  {
    value: "IGNF:SYSLN",
    label: "IGNF:SYSLN / Lambert Nord de Guerre Lambert Nord de Guerre",
  },
  {
    value: "IGNF:TAHAA53UTM5S",
    label: "IGNF:TAHAA53UTM5S / IGN53 Societe UTM Sud fuseau 5",
  },
  {
    value: "IGNF:TAHAAUTM05S",
    label: "IGNF:TAHAAUTM05S / Tahaa UTM Sud fuseau 5",
  },
  {
    value: "IGNF:TAHAAUTM5S",
    label: "IGNF:TAHAAUTM5S / Tahaa UTM Sud fuseau 5",
  },
  {
    value: "IGNF:TAHI51UTM06S",
    label: "IGNF:TAHI51UTM06S / TAHITI TERME NORD UTM SUD FUSEAU 6",
  },
  {
    value: "IGNF:TAHI51UTM6S",
    label: "IGNF:TAHI51UTM6S / TAHITI TERME NORD UTM SUD FUSEAU 6",
  },
  {
    value: "IGNF:TAHI79UTM6S",
    label: "IGNF:TAHI79UTM6S / Tahiti (IGN79) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TAKA69UTM6S",
    label: "IGNF:TAKA69UTM6S / Takaroa Takapoto (SHM 1969) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TANNAUTM59S",
    label: "IGNF:TANNAUTM59S / Tanna UTM Sud fuseau 59",
  },
  {
    value: "IGNF:TERA50STEREO",
    label:
      "IGNF:TERA50STEREO / TERRE ADELIE POINTE GEOLOGIE PERROUD STEREO POLAIRE SUD (TANGENTE)",
  },
  {
    value: "IGNF:TETIA90UTM6S",
    label: "IGNF:TETIA90UTM6S / Tetiaroa (MOP90) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TIKE50UTM6S",
    label: "IGNF:TIKE50UTM6S / Tikehau (SHM 1947-1950) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TIKE60UTM6S",
    label: "IGNF:TIKE60UTM6S / Tikehau (MHPF 1960) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TIKE88UTM6S",
    label: "IGNF:TIKE88UTM6S / TIKEHAU (MOP88) UTM SUD FUSEAU 6",
  },
  {
    value: "IGNF:TROM56MD",
    label: "IGNF:TROM56MD / TROMELIN SGM 1956 MERCATOR DIRECTE",
  },
  {
    value: "IGNF:TUAM86UTM6S",
    label: "IGNF:TUAM86UTM6S / Tuamotu (MOP86) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TUAM86UTM7S",
    label: "IGNF:TUAM86UTM7S / Tuamotu (MOP86) UTM Sud fuseau 7",
  },
  {
    value: "IGNF:TUBU69UTM6S",
    label: "IGNF:TUBU69UTM6S / Tubuai (MHPF 1969) UTM Sud fuseau 6",
  },
  {
    value: "IGNF:TURI69UTM7S",
    label: "IGNF:TURI69UTM7S / Tureia (SHM 1969) UTM Sud fuseau 7",
  },
  { value: "IGNF:UTM01SW84", label: "IGNF:UTM01SW84 / WGS84 UTM Sud Fuseau 1" },
  {
    value: "IGNF:UTM20W84MART",
    label: "IGNF:UTM20W84MART / RRAF UTM Nord fuseau 20",
  },
  {
    value: "IGNF:UTM21RGFG95",
    label: "IGNF:UTM21RGFG95 / RGFG95 UTM Nord f.21",
  },
  {
    value: "IGNF:UTM22RGFG95",
    label: "IGNF:UTM22RGFG95 / RGFG95 UTM Nord f.22",
  },
  {
    value: "IGNF:UTM26ETRS89",
    label: "IGNF:UTM26ETRS89 / ETRS89 UTM Nord fuseau 26",
  },
  {
    value: "IGNF:UTM27ETRS89",
    label: "IGNF:UTM27ETRS89 / ETRS89 UTM Nord fuseau 27",
  },
  {
    value: "IGNF:UTM28ETRS89",
    label: "IGNF:UTM28ETRS89 / ETRS89 UTM Nord fuseau 28",
  },
  {
    value: "IGNF:UTM29ETRS89",
    label: "IGNF:UTM29ETRS89 / ETRS89 UTM Nord fuseau 29",
  },
  { value: "IGNF:UTM30", label: "IGNF:UTM30 / ED50 UTM fuseau 30" },
  {
    value: "IGNF:UTM30ETRS89",
    label: "IGNF:UTM30ETRS89 / ETRS89 UTM Nord fuseau 30",
  },
  {
    value: "IGNF:UTM30RGF93",
    label: "IGNF:UTM30RGF93 / RGF93 UTM NORD FUSEAU 30",
  },
  { value: "IGNF:UTM30W72", label: "IGNF:UTM30W72 / WGS72 UTM fuseau 30" },
  { value: "IGNF:UTM30W84", label: "IGNF:UTM30W84 / WGS84 UTM fuseau 30" },
  { value: "IGNF:UTM31", label: "IGNF:UTM31 / ED50 UTM NORD FUSEAU 31" },
  {
    value: "IGNF:UTM31ETRS89",
    label: "IGNF:UTM31ETRS89 / ETRS89 UTM Nord fuseau 31",
  },
  { value: "IGNF:UTM31RGF93", label: "IGNF:UTM31RGF93 / RGF93 UTM fuseau 31" },
  { value: "IGNF:UTM31W72", label: "IGNF:UTM31W72 / WGS72 UTM fuseau 31" },
  { value: "IGNF:UTM31W84", label: "IGNF:UTM31W84 / WGS84 UTM fuseau 31" },
  { value: "IGNF:UTM32", label: "IGNF:UTM32 / ED50 UTM fuseau 32" },
  {
    value: "IGNF:UTM32ETRS89",
    label: "IGNF:UTM32ETRS89 / ETRS89 UTM Nord fuseau 32",
  },
  { value: "IGNF:UTM32RGF93", label: "IGNF:UTM32RGF93 / RGF93 UTM fuseau 32" },
  { value: "IGNF:UTM32W72", label: "IGNF:UTM32W72 / WGS72 UTM fuseau 32" },
  { value: "IGNF:UTM32W84", label: "IGNF:UTM32W84 / WGS84 UTM NORD FUSEAU 32" },
  {
    value: "IGNF:UTM33ETRS89",
    label: "IGNF:UTM33ETRS89 / ETRS89 UTM Nord fuseau 33",
  },
  {
    value: "IGNF:UTM34ETRS89",
    label: "IGNF:UTM34ETRS89 / ETRS89 UTM Nord fuseau 34",
  },
  {
    value: "IGNF:UTM35ETRS89",
    label: "IGNF:UTM35ETRS89 / ETRS89 UTM Nord fuseau 35",
  },
  {
    value: "IGNF:UTM36ETRS89",
    label: "IGNF:UTM36ETRS89 / ETRS89 UTM Nord fuseau 36",
  },
  {
    value: "IGNF:UTM37ETRS89",
    label: "IGNF:UTM37ETRS89 / ETRS89 UTM Nord fuseau 37",
  },
  {
    value: "IGNF:UTM38ETRS89",
    label: "IGNF:UTM38ETRS89 / ETRS89 UTM Nord fuseau 38",
  },
  {
    value: "IGNF:UTM39SW84",
    label: "IGNF:UTM39SW84 / WGS84 UTM SUD FUSEAU 39",
  },
  {
    value: "IGNF:UTM42SW84",
    label: "IGNF:UTM42SW84 / WGS84 UTM SUD FUSEAU 42",
  },
  {
    value: "IGNF:UTM43SW84",
    label: "IGNF:UTM43SW84 / WGS84 UTM SUD FUSEAU 43",
  },
  {
    value: "IGNF:WALL76UTM1S",
    label: "IGNF:WALL76UTM1S / Wallis (MOP 1976) UTM Sud fuseau 1",
  },
  {
    value: "IGNF:WALL78UTM1S",
    label: "IGNF:WALL78UTM1S / Wallis (MOP 1978) UTM Sud fuseau 1",
  },
  {
    value: "IGNF:WGS72UTM1S",
    label: "IGNF:WGS72UTM1S / WGS72 UTM Sud Fuseau 1",
  },
  { value: "IGNF:WGS72UTM30", label: "IGNF:WGS72UTM30 / WGS72 UTM fuseau 30" },
  { value: "IGNF:WGS72UTM31", label: "IGNF:WGS72UTM31 / WGS72 UTM fuseau 31" },
  { value: "IGNF:WGS72UTM32", label: "IGNF:WGS72UTM32 / WGS72 UTM fuseau 32" },
  {
    value: "IGNF:WGS84EQGPASP",
    label: "IGNF:WGS84EQGPASP / Amsterdam Saint-Paul projection Geoportail",
  },
  {
    value: "IGNF:WGS84EQGPCRZ",
    label: "IGNF:WGS84EQGPCRZ / Crozet projection Geoportail",
  },
  {
    value: "IGNF:WGS84EQGPKER",
    label: "IGNF:WGS84EQGPKER / Kerguelen projection Geoportail",
  },
  {
    value: "IGNF:WGS84EQGPWF",
    label: "IGNF:WGS84EQGPWF / Wallis et Futuna projection Geoportail",
  },
  {
    value: "IGNF:WGS84GPAF",
    label: "IGNF:WGS84GPAF / ANTILLES FRANCAISES PROJECTION GEOPORTAIL",
  },
  {
    value: "IGNF:WGS84MILLGP",
    label: "IGNF:WGS84MILLGP / WGS84 PROJECTION MILLER GEOPORTAIL",
  },
  {
    value: "IGNF:WGS84UTM1S",
    label: "IGNF:WGS84UTM1S / WGS84 UTM Sud Fuseau 1",
  },
  { value: "IGNF:WGS84UTM30", label: "IGNF:WGS84UTM30 / WGS84 UTM fuseau 30" },
  { value: "IGNF:WGS84UTM31", label: "IGNF:WGS84UTM31 / WGS84 UTM fuseau 31" },
  {
    value: "IGNF:WGS84UTM32",
    label: "IGNF:WGS84UTM32 / WGS84 UTM NORD FUSEAU 32",
  },
  {
    value: "IGNF:WGS84UTM39S",
    label: "IGNF:WGS84UTM39S / WGS84 UTM SUD FUSEAU 39",
  },
  {
    value: "IGNF:WGS84UTM42S",
    label: "IGNF:WGS84UTM42S / WGS84 UTM SUD FUSEAU 42",
  },
  {
    value: "IGNF:WGS84UTM43S",
    label: "IGNF:WGS84UTM43S / WGS84 UTM SUD FUSEAU 43",
  },
  {
    value: "IGNF:WGS84WMSV",
    label: "IGNF:WGS84WMSV / WGS84 WEB MERCATOR SPHERIQUE (VISUALISATION)",
  },
  {
    value: "CZM:OSGB36Cartographic",
    label: "OSGB36Cartographic / OSGB36 (with EPSG 1314 Helmert transform)",
  },
  {
    value: "CZM:OSTN02Cartographic",
    label: "OSTN02Cartographic / OSGB36 with OSTN02 grid shift",
  },
  { value: "EPSG:3819", label: "EPSG:3819 / HD1909" },
  { value: "EPSG:3821", label: "EPSG:3821 / TWD67" },
  { value: "EPSG:3822", label: "EPSG:3822 / TWD97" },
  { value: "EPSG:3823", label: "EPSG:3823 / TWD97" },
  { value: "EPSG:3824", label: "EPSG:3824 / TWD97" },
  { value: "EPSG:3887", label: "EPSG:3887 / IGRS" },
  { value: "EPSG:3888", label: "EPSG:3888 / IGRS" },
  { value: "EPSG:3889", label: "EPSG:3889 / IGRS" },
  { value: "EPSG:3906", label: "EPSG:3906 / MGI 1901" },
  { value: "EPSG:4000", label: "EPSG:4000 / MOLDREF99" },
  {
    value: "EPSG:4001",
    label: "EPSG:4001 / Unknown datum based upon the Airy 1830 ellipsoid",
  },
  {
    value: "EPSG:4002",
    label:
      "EPSG:4002 / Unknown datum based upon the Airy Modified 1849 ellipsoid",
  },
  {
    value: "EPSG:4003",
    label:
      "EPSG:4003 / Unknown datum based upon the Australian National Spheroid",
  },
  {
    value: "EPSG:4004",
    label: "EPSG:4004 / Unknown datum based upon the Bessel 1841 ellipsoid",
  },
  {
    value: "EPSG:4005",
    label: "EPSG:4005 / Unknown datum based upon the Bessel Modified ellipsoid",
  },
  {
    value: "EPSG:4006",
    label: "EPSG:4006 / Unknown datum based upon the Bessel Namibia ellipsoid",
  },
  {
    value: "EPSG:4007",
    label: "EPSG:4007 / Unknown datum based upon the Clarke 1858 ellipsoid",
  },
  {
    value: "EPSG:4008",
    label: "EPSG:4008 / Unknown datum based upon the Clarke 1866 ellipsoid",
  },
  {
    value: "EPSG:4009",
    label:
      "EPSG:4009 / Unknown datum based upon the Clarke 1866 Michigan ellipsoid",
  },
  {
    value: "EPSG:4010",
    label:
      "EPSG:4010 / Unknown datum based upon the Clarke 1880 (Benoit) ellipsoid",
  },
  {
    value: "EPSG:4011",
    label:
      "EPSG:4011 / Unknown datum based upon the Clarke 1880 (IGN) ellipsoid",
  },
  {
    value: "EPSG:4012",
    label:
      "EPSG:4012 / Unknown datum based upon the Clarke 1880 (RGS) ellipsoid",
  },
  {
    value: "EPSG:4013",
    label:
      "EPSG:4013 / Unknown datum based upon the Clarke 1880 (Arc) ellipsoid",
  },
  {
    value: "EPSG:4014",
    label:
      "EPSG:4014 / Unknown datum based upon the Clarke 1880 (SGA 1922) ellipsoid",
  },
  {
    value: "EPSG:4015",
    label:
      "EPSG:4015 / Unknown datum based upon the Everest 1830 (1937 Adjustment) ellipsoid",
  },
  {
    value: "EPSG:4016",
    label:
      "EPSG:4016 / Unknown datum based upon the Everest 1830 (1967 Definition) ellipsoid",
  },
  { value: "EPSG:4017", label: "EPSG:4017 / MOLDREF99" },
  {
    value: "EPSG:4018",
    label:
      "EPSG:4018 / Unknown datum based upon the Everest 1830 Modified ellipsoid",
  },
  {
    value: "EPSG:4019",
    label: "EPSG:4019 / Unknown datum based upon the GRS 1980 ellipsoid",
  },
  {
    value: "EPSG:4020",
    label: "EPSG:4020 / Unknown datum based upon the Helmert 1906 ellipsoid",
  },
  {
    value: "EPSG:4021",
    label:
      "EPSG:4021 / Unknown datum based upon the Indonesian National Spheroid",
  },
  {
    value: "EPSG:4022",
    label:
      "EPSG:4022 / Unknown datum based upon the International 1924 ellipsoid",
  },
  { value: "EPSG:4023", label: "EPSG:4023 / MOLDREF99" },
  {
    value: "EPSG:4024",
    label: "EPSG:4024 / Unknown datum based upon the Krassowsky 1940 ellipsoid",
  },
  {
    value: "EPSG:4025",
    label: "EPSG:4025 / Unknown datum based upon the NWL 9D ellipsoid",
  },
  {
    value: "EPSG:4027",
    label: "EPSG:4027 / Unknown datum based upon the Plessis 1817 ellipsoid",
  },
  {
    value: "EPSG:4028",
    label: "EPSG:4028 / Unknown datum based upon the Struve 1860 ellipsoid",
  },
  {
    value: "EPSG:4029",
    label: "EPSG:4029 / Unknown datum based upon the War Office ellipsoid",
  },
  {
    value: "EPSG:4030",
    label: "EPSG:4030 / Unknown datum based upon the WGS 84 ellipsoid",
  },
  {
    value: "EPSG:4031",
    label: "EPSG:4031 / Unknown datum based upon the GEM 10C ellipsoid",
  },
  {
    value: "EPSG:4032",
    label: "EPSG:4032 / Unknown datum based upon the OSU86F ellipsoid",
  },
  {
    value: "EPSG:4033",
    label: "EPSG:4033 / Unknown datum based upon the OSU91A ellipsoid",
  },
  {
    value: "EPSG:4034",
    label: "EPSG:4034 / Unknown datum based upon the Clarke 1880 ellipsoid",
  },
  {
    value: "EPSG:4035",
    label: "EPSG:4035 / Unknown datum based upon the Authalic Sphere",
  },
  {
    value: "EPSG:4036",
    label: "EPSG:4036 / Unknown datum based upon the GRS 1967 ellipsoid",
  },
  { value: "EPSG:4039", label: "EPSG:4039 / RGRDC 2005" },
  { value: "EPSG:4040", label: "EPSG:4040 / RGRDC 2005" },
  {
    value: "EPSG:4041",
    label:
      "EPSG:4041 / Unknown datum based upon the Average Terrestrial System 1977 ellipsoid",
  },
  {
    value: "EPSG:4042",
    label:
      "EPSG:4042 / Unknown datum based upon the Everest (1830 Definition) ellipsoid",
  },
  {
    value: "EPSG:4043",
    label: "EPSG:4043 / Unknown datum based upon the WGS 72 ellipsoid",
  },
  {
    value: "EPSG:4044",
    label:
      "EPSG:4044 / Unknown datum based upon the Everest 1830 (1962 Definition) ellipsoid",
  },
  {
    value: "EPSG:4045",
    label:
      "EPSG:4045 / Unknown datum based upon the Everest 1830 (1975 Definition) ellipsoid",
  },
  { value: "EPSG:4046", label: "EPSG:4046 / RGRDC 2005" },
  {
    value: "EPSG:4047",
    label:
      "EPSG:4047 / Unspecified datum based upon the GRS 1980 Authalic Sphere",
  },
  {
    value: "EPSG:4052",
    label:
      "EPSG:4052 / Unspecified datum based upon the Clarke 1866 Authalic Sphere",
  },
  {
    value: "EPSG:4053",
    label:
      "EPSG:4053 / Unspecified datum based upon the International 1924 Authalic Sphere",
  },
  {
    value: "EPSG:4054",
    label: "EPSG:4054 / Unspecified datum based upon the Hughes 1980 ellipsoid",
  },
  { value: "EPSG:4055", label: "EPSG:4055 / Popular Visualisation CRS" },
  { value: "EPSG:4073", label: "EPSG:4073 / SREF98" },
  { value: "EPSG:4074", label: "EPSG:4074 / SREF98" },
  { value: "EPSG:4075", label: "EPSG:4075 / SREF98" },
  { value: "EPSG:4079", label: "EPSG:4079 / REGCAN95" },
  { value: "EPSG:4080", label: "EPSG:4080 / REGCAN95" },
  { value: "EPSG:4081", label: "EPSG:4081 / REGCAN95" },
  { value: "EPSG:4120", label: "EPSG:4120 / Greek" },
  { value: "EPSG:4121", label: "EPSG:4121 / GGRS87" },
  { value: "EPSG:4122", label: "EPSG:4122 / ATS77" },
  { value: "EPSG:4123", label: "EPSG:4123 / KKJ" },
  { value: "EPSG:4124", label: "EPSG:4124 / RT90" },
  { value: "EPSG:4125", label: "EPSG:4125 / Samboja" },
  { value: "EPSG:4126", label: "EPSG:4126 / LKS94 (ETRS89)" },
  { value: "EPSG:4127", label: "EPSG:4127 / Tete" },
  { value: "EPSG:4128", label: "EPSG:4128 / Madzansua" },
  { value: "EPSG:4129", label: "EPSG:4129 / Observatario" },
  { value: "EPSG:4130", label: "EPSG:4130 / Moznet" },
  { value: "EPSG:4131", label: "EPSG:4131 / Indian 1960" },
  { value: "EPSG:4132", label: "EPSG:4132 / FD58" },
  { value: "EPSG:4133", label: "EPSG:4133 / EST92" },
  { value: "EPSG:4134", label: "EPSG:4134 / PSD93" },
  { value: "EPSG:4135", label: "EPSG:4135 / Old Hawaiian" },
  { value: "EPSG:4136", label: "EPSG:4136 / St. Lawrence Island" },
  { value: "EPSG:4137", label: "EPSG:4137 / St. Paul Island" },
  { value: "EPSG:4138", label: "EPSG:4138 / St. George Island" },
  { value: "EPSG:4139", label: "EPSG:4139 / Puerto Rico" },
  { value: "EPSG:4140", label: "EPSG:4140 / NAD83(CSRS98)" },
  { value: "EPSG:4141", label: "EPSG:4141 / Israel 1993" },
  { value: "EPSG:4142", label: "EPSG:4142 / Locodjo 1965" },
  { value: "EPSG:4143", label: "EPSG:4143 / Abidjan 1987" },
  { value: "EPSG:4144", label: "EPSG:4144 / Kalianpur 1937" },
  { value: "EPSG:4145", label: "EPSG:4145 / Kalianpur 1962" },
  { value: "EPSG:4146", label: "EPSG:4146 / Kalianpur 1975" },
  { value: "EPSG:4147", label: "EPSG:4147 / Hanoi 1972" },
  { value: "EPSG:4148", label: "EPSG:4148 / Hartebeesthoek94" },
  { value: "EPSG:4149", label: "EPSG:4149 / CH1903" },
  { value: "EPSG:4150", label: "EPSG:4150 / CH1903+" },
  { value: "EPSG:4151", label: "EPSG:4151 / CHTRS95" },
  { value: "EPSG:4152", label: "EPSG:4152 / NAD83(HARN)" },
  { value: "EPSG:4153", label: "EPSG:4153 / Rassadiran" },
  { value: "EPSG:4154", label: "EPSG:4154 / ED50(ED77)" },
  { value: "EPSG:4155", label: "EPSG:4155 / Dabola 1981" },
  { value: "EPSG:4156", label: "EPSG:4156 / S-JTSK" },
  { value: "EPSG:4157", label: "EPSG:4157 / Mount Dillon" },
  { value: "EPSG:4158", label: "EPSG:4158 / Naparima 1955" },
  { value: "EPSG:4159", label: "EPSG:4159 / ELD79" },
  { value: "EPSG:4160", label: "EPSG:4160 / Chos Malal 1914" },
  { value: "EPSG:4161", label: "EPSG:4161 / Pampa del Castillo" },
  { value: "EPSG:4162", label: "EPSG:4162 / Korean 1985" },
  { value: "EPSG:4163", label: "EPSG:4163 / Yemen NGN96" },
  { value: "EPSG:4164", label: "EPSG:4164 / South Yemen" },
  { value: "EPSG:4165", label: "EPSG:4165 / Bissau" },
  { value: "EPSG:4166", label: "EPSG:4166 / Korean 1995" },
  { value: "EPSG:4167", label: "EPSG:4167 / NZGD2000" },
  { value: "EPSG:4168", label: "EPSG:4168 / Accra" },
  { value: "EPSG:4169", label: "EPSG:4169 / American Samoa 1962" },
  { value: "EPSG:4170", label: "EPSG:4170 / SIRGAS 1995" },
  { value: "EPSG:4171", label: "EPSG:4171 / RGF93 v1" },
  { value: "EPSG:4172", label: "EPSG:4172 / POSGAR" },
  { value: "EPSG:4173", label: "EPSG:4173 / IRENET95" },
  { value: "EPSG:4174", label: "EPSG:4174 / Sierra Leone 1924" },
  { value: "EPSG:4175", label: "EPSG:4175 / Sierra Leone 1968" },
  { value: "EPSG:4176", label: "EPSG:4176 / Australian Antarctic" },
  { value: "EPSG:4178", label: "EPSG:4178 / Pulkovo 1942(83)" },
  { value: "EPSG:4179", label: "EPSG:4179 / Pulkovo 1942(58)" },
  { value: "EPSG:4180", label: "EPSG:4180 / EST97" },
  { value: "EPSG:4181", label: "EPSG:4181 / LUREF" },
  { value: "EPSG:4182", label: "EPSG:4182 / Azores Occidental 1939" },
  { value: "EPSG:4183", label: "EPSG:4183 / Azores Central 1948" },
  { value: "EPSG:4184", label: "EPSG:4184 / Azores Oriental 1940" },
  { value: "EPSG:4185", label: "EPSG:4185 / Madeira 1936" },
  { value: "EPSG:4188", label: "EPSG:4188 / OSNI 1952" },
  { value: "EPSG:4189", label: "EPSG:4189 / REGVEN" },
  { value: "EPSG:4190", label: "EPSG:4190 / POSGAR 98" },
  { value: "EPSG:4191", label: "EPSG:4191 / Albanian 1987" },
  { value: "EPSG:4192", label: "EPSG:4192 / Douala 1948" },
  { value: "EPSG:4193", label: "EPSG:4193 / Manoca 1962" },
  { value: "EPSG:4194", label: "EPSG:4194 / Qornoq 1927" },
  { value: "EPSG:4195", label: "EPSG:4195 / Scoresbysund 1952" },
  { value: "EPSG:4196", label: "EPSG:4196 / Ammassalik 1958" },
  { value: "EPSG:4197", label: "EPSG:4197 / Garoua" },
  { value: "EPSG:4198", label: "EPSG:4198 / Kousseri" },
  { value: "EPSG:4199", label: "EPSG:4199 / Egypt 1930" },
  { value: "EPSG:4200", label: "EPSG:4200 / Pulkovo 1995" },
  { value: "EPSG:4201", label: "EPSG:4201 / Adindan" },
  { value: "EPSG:4202", label: "EPSG:4202 / AGD66" },
  { value: "EPSG:4203", label: "EPSG:4203 / AGD84" },
  { value: "EPSG:4204", label: "EPSG:4204 / Ain el Abd" },
  { value: "EPSG:4205", label: "EPSG:4205 / Afgooye" },
  { value: "EPSG:4206", label: "EPSG:4206 / Agadez" },
  { value: "EPSG:4207", label: "EPSG:4207 / Lisbon" },
  { value: "EPSG:4208", label: "EPSG:4208 / Aratu" },
  { value: "EPSG:4209", label: "EPSG:4209 / Arc 1950" },
  { value: "EPSG:4210", label: "EPSG:4210 / Arc 1960" },
  { value: "EPSG:4211", label: "EPSG:4211 / Batavia" },
  { value: "EPSG:4212", label: "EPSG:4212 / Barbados 1938" },
  { value: "EPSG:4213", label: "EPSG:4213 / Beduaram" },
  { value: "EPSG:4214", label: "EPSG:4214 / Beijing 1954" },
  { value: "EPSG:4215", label: "EPSG:4215 / BD50" },
  { value: "EPSG:4216", label: "EPSG:4216 / Bermuda 1957" },
  { value: "EPSG:4218", label: "EPSG:4218 / Bogota 1975" },
  { value: "EPSG:4219", label: "EPSG:4219 / Bukit Rimpah" },
  { value: "EPSG:4220", label: "EPSG:4220 / Camacupa 1948" },
  { value: "EPSG:4221", label: "EPSG:4221 / Campo Inchauspe" },
  { value: "EPSG:4222", label: "EPSG:4222 / Cape" },
  { value: "EPSG:4223", label: "EPSG:4223 / Carthage" },
  { value: "EPSG:4224", label: "EPSG:4224 / Chua" },
  { value: "EPSG:4225", label: "EPSG:4225 / Corrego Alegre 1970-72" },
  { value: "EPSG:4226", label: "EPSG:4226 / Cote d'Ivoire" },
  { value: "EPSG:4227", label: "EPSG:4227 / Deir ez Zor" },
  { value: "EPSG:4228", label: "EPSG:4228 / Douala" },
  { value: "EPSG:4229", label: "EPSG:4229 / Egypt 1907" },
  { value: "EPSG:4230", label: "EPSG:4230 / ED50" },
  { value: "EPSG:4231", label: "EPSG:4231 / ED87" },
  { value: "EPSG:4232", label: "EPSG:4232 / Fahud" },
  { value: "EPSG:4233", label: "EPSG:4233 / Gandajika 1970" },
  { value: "EPSG:4234", label: "EPSG:4234 / Garoua" },
  { value: "EPSG:4235", label: "EPSG:4235 / Guyane Francaise" },
  { value: "EPSG:4236", label: "EPSG:4236 / Hu Tzu Shan 1950" },
  { value: "EPSG:4237", label: "EPSG:4237 / HD72" },
  { value: "EPSG:4238", label: "EPSG:4238 / ID74" },
  { value: "EPSG:4239", label: "EPSG:4239 / Indian 1954" },
  { value: "EPSG:4240", label: "EPSG:4240 / Indian 1975" },
  { value: "EPSG:4241", label: "EPSG:4241 / Jamaica 1875" },
  { value: "EPSG:4242", label: "EPSG:4242 / JAD69" },
  { value: "EPSG:4243", label: "EPSG:4243 / Kalianpur 1880" },
  { value: "EPSG:4244", label: "EPSG:4244 / Kandawala" },
  { value: "EPSG:4245", label: "EPSG:4245 / Kertau 1968" },
  { value: "EPSG:4246", label: "EPSG:4246 / KOC" },
  { value: "EPSG:4247", label: "EPSG:4247 / La Canoa" },
  { value: "EPSG:4248", label: "EPSG:4248 / PSAD56" },
  { value: "EPSG:4249", label: "EPSG:4249 / Lake" },
  { value: "EPSG:4250", label: "EPSG:4250 / Leigon" },
  { value: "EPSG:4251", label: "EPSG:4251 / Liberia 1964" },
  { value: "EPSG:4252", label: "EPSG:4252 / Lome" },
  { value: "EPSG:4253", label: "EPSG:4253 / Luzon 1911" },
  { value: "EPSG:4254", label: "EPSG:4254 / Hito XVIII 1963" },
  { value: "EPSG:4255", label: "EPSG:4255 / Herat North" },
  { value: "EPSG:4256", label: "EPSG:4256 / Mahe 1971" },
  { value: "EPSG:4257", label: "EPSG:4257 / Makassar" },
  { value: "EPSG:4258", label: "EPSG:4258 / ETRS89" },
  { value: "EPSG:4259", label: "EPSG:4259 / Malongo 1987" },
  { value: "EPSG:4260", label: "EPSG:4260 / Manoca" },
  { value: "EPSG:4261", label: "EPSG:4261 / Merchich" },
  { value: "EPSG:4262", label: "EPSG:4262 / Massawa" },
  { value: "EPSG:4263", label: "EPSG:4263 / Minna" },
  { value: "EPSG:4264", label: "EPSG:4264 / Mhast" },
  { value: "EPSG:4265", label: "EPSG:4265 / Monte Mario" },
  { value: "EPSG:4266", label: "EPSG:4266 / M'poraloko" },
  { value: "EPSG:4267", label: "EPSG:4267 / NAD27" },
  { value: "EPSG:4268", label: "EPSG:4268 / NAD27 Michigan" },
  { value: "EPSG:4269", label: "EPSG:4269 / NAD83" },
  { value: "EPSG:4270", label: "EPSG:4270 / Nahrwan 1967" },
  { value: "EPSG:4271", label: "EPSG:4271 / Naparima 1972" },
  { value: "EPSG:4272", label: "EPSG:4272 / NZGD49" },
  { value: "EPSG:4273", label: "EPSG:4273 / NGO 1948" },
  { value: "EPSG:4274", label: "EPSG:4274 / Datum 73" },
  { value: "EPSG:4275", label: "EPSG:4275 / NTF" },
  { value: "EPSG:4276", label: "EPSG:4276 / NSWC 9Z-2" },
  { value: "EPSG:4277", label: "EPSG:4277 / OSGB36" },
  { value: "EPSG:4278", label: "EPSG:4278 / OSGB70" },
  { value: "EPSG:4279", label: "EPSG:4279 / OS(SN)80" },
  { value: "EPSG:4280", label: "EPSG:4280 / Padang" },
  { value: "EPSG:4281", label: "EPSG:4281 / Palestine 1923" },
  { value: "EPSG:4282", label: "EPSG:4282 / Pointe Noire" },
  { value: "EPSG:4283", label: "EPSG:4283 / GDA94" },
  { value: "EPSG:4284", label: "EPSG:4284 / Pulkovo 1942" },
  { value: "EPSG:4285", label: "EPSG:4285 / Qatar 1974" },
  { value: "EPSG:4286", label: "EPSG:4286 / Qatar 1948" },
  { value: "EPSG:4287", label: "EPSG:4287 / Qornoq" },
  { value: "EPSG:4288", label: "EPSG:4288 / Loma Quintana" },
  { value: "EPSG:4289", label: "EPSG:4289 / Amersfoort" },
  { value: "EPSG:4291", label: "EPSG:4291 / SAD69" },
  { value: "EPSG:4292", label: "EPSG:4292 / Sapper Hill 1943" },
  { value: "EPSG:4293", label: "EPSG:4293 / Schwarzeck" },
  { value: "EPSG:4294", label: "EPSG:4294 / Segora" },
  { value: "EPSG:4295", label: "EPSG:4295 / Serindung" },
  { value: "EPSG:4296", label: "EPSG:4296 / Sudan" },
  { value: "EPSG:4297", label: "EPSG:4297 / Tananarive" },
  { value: "EPSG:4298", label: "EPSG:4298 / Timbalai 1948" },
  { value: "EPSG:4299", label: "EPSG:4299 / TM65" },
  { value: "EPSG:4300", label: "EPSG:4300 / TM75" },
  { value: "EPSG:4301", label: "EPSG:4301 / Tokyo" },
  { value: "EPSG:4302", label: "EPSG:4302 / Trinidad 1903" },
  { value: "EPSG:4303", label: "EPSG:4303 / TC(1948)" },
  { value: "EPSG:4304", label: "EPSG:4304 / Voirol 1875" },
  { value: "EPSG:4306", label: "EPSG:4306 / Bern 1938" },
  { value: "EPSG:4307", label: "EPSG:4307 / Nord Sahara 1959" },
  { value: "EPSG:4308", label: "EPSG:4308 / RT38" },
  { value: "EPSG:4309", label: "EPSG:4309 / Yacare" },
  { value: "EPSG:4310", label: "EPSG:4310 / Yoff" },
  { value: "EPSG:4311", label: "EPSG:4311 / Zanderij" },
  { value: "EPSG:4312", label: "EPSG:4312 / MGI" },
  { value: "EPSG:4313", label: "EPSG:4313 / BD72" },
  { value: "EPSG:4314", label: "EPSG:4314 / DHDN" },
  { value: "EPSG:4315", label: "EPSG:4315 / Conakry 1905" },
  { value: "EPSG:4316", label: "EPSG:4316 / Dealul Piscului 1930" },
  { value: "EPSG:4317", label: "EPSG:4317 / Dealul Piscului 1970" },
  { value: "EPSG:4318", label: "EPSG:4318 / NGN" },
  { value: "EPSG:4319", label: "EPSG:4319 / KUDAMS" },
  { value: "EPSG:4322", label: "EPSG:4322 / WGS 72" },
  { value: "EPSG:4324", label: "EPSG:4324 / WGS 72BE" },
  { value: "EPSG:4326", label: "EPSG:4326 / WGS 84" },
  { value: "EPSG:4327", label: "EPSG:4327 / WGS 84 (geographic 3D)" },
  { value: "EPSG:4328", label: "EPSG:4328 / WGS 84 (geocentric)" },
  { value: "EPSG:4329", label: "EPSG:4329 / WGS 84 (3D)" },
  { value: "EPSG:4330", label: "EPSG:4330 / ITRF88 (geocentric)" },
  { value: "EPSG:4331", label: "EPSG:4331 / ITRF89 (geocentric)" },
  { value: "EPSG:4332", label: "EPSG:4332 / ITRF90 (geocentric)" },
  { value: "EPSG:4333", label: "EPSG:4333 / ITRF91 (geocentric)" },
  { value: "EPSG:4334", label: "EPSG:4334 / ITRF92 (geocentric)" },
  { value: "EPSG:4335", label: "EPSG:4335 / ITRF93 (geocentric)" },
  { value: "EPSG:4336", label: "EPSG:4336 / ITRF94 (geocentric)" },
  { value: "EPSG:4337", label: "EPSG:4337 / ITRF96 (geocentric)" },
  { value: "EPSG:4338", label: "EPSG:4338 / ITRF97 (geocentric)" },
  { value: "EPSG:4339", label: "EPSG:4339 / Australian Antarctic (3D)" },
  {
    value: "EPSG:4340",
    label: "EPSG:4340 / Australian Antarctic (geocentric)",
  },
  { value: "EPSG:4341", label: "EPSG:4341 / EST97 (3D)" },
  { value: "EPSG:4342", label: "EPSG:4342 / EST97 (geocentric)" },
  { value: "EPSG:4343", label: "EPSG:4343 / CHTRF95 (3D)" },
  { value: "EPSG:4344", label: "EPSG:4344 / CHTRF95 (geocentric)" },
  { value: "EPSG:4345", label: "EPSG:4345 / ETRS89 (3D)" },
  { value: "EPSG:4346", label: "EPSG:4346 / ETRS89 (geocentric)" },
  { value: "EPSG:4347", label: "EPSG:4347 / GDA94 (3D)" },
  { value: "EPSG:4348", label: "EPSG:4348 / GDA94 (geocentric)" },
  { value: "EPSG:4349", label: "EPSG:4349 / Hartebeesthoek94 (3D)" },
  { value: "EPSG:4350", label: "EPSG:4350 / Hartebeesthoek94 (geocentric)" },
  { value: "EPSG:4351", label: "EPSG:4351 / IRENET95 (3D)" },
  { value: "EPSG:4352", label: "EPSG:4352 / IRENET95 (geocentric)" },
  { value: "EPSG:4353", label: "EPSG:4353 / JGD2000 (3D)" },
  { value: "EPSG:4354", label: "EPSG:4354 / JGD2000 (geocentric)" },
  { value: "EPSG:4355", label: "EPSG:4355 / LKS94 (ETRS89) (3D)" },
  { value: "EPSG:4356", label: "EPSG:4356 / LKS94 (ETRS89) (geocentric)" },
  { value: "EPSG:4357", label: "EPSG:4357 / Moznet (3D)" },
  { value: "EPSG:4358", label: "EPSG:4358 / Moznet (geocentric)" },
  { value: "EPSG:4359", label: "EPSG:4359 / NAD83(CSRS) (3D)" },
  { value: "EPSG:4360", label: "EPSG:4360 / NAD83(CSRS) (geocentric)" },
  { value: "EPSG:4361", label: "EPSG:4361 / NAD83(HARN) (3D)" },
  { value: "EPSG:4362", label: "EPSG:4362 / NAD83(HARN) (geocentric)" },
  { value: "EPSG:4363", label: "EPSG:4363 / NZGD2000 (3D)" },
  { value: "EPSG:4364", label: "EPSG:4364 / NZGD2000 (geocentric)" },
  { value: "EPSG:4365", label: "EPSG:4365 / POSGAR 98 (3D)" },
  { value: "EPSG:4366", label: "EPSG:4366 / POSGAR 98 (geocentric)" },
  { value: "EPSG:4367", label: "EPSG:4367 / REGVEN (3D)" },
  { value: "EPSG:4368", label: "EPSG:4368 / REGVEN (geocentric)" },
  { value: "EPSG:4369", label: "EPSG:4369 / RGF93 (3D)" },
  { value: "EPSG:4370", label: "EPSG:4370 / RGF93 (geocentric)" },
  { value: "EPSG:4371", label: "EPSG:4371 / RGFG95 (3D)" },
  { value: "EPSG:4372", label: "EPSG:4372 / RGFG95 (geocentric)" },
  { value: "EPSG:4373", label: "EPSG:4373 / RGR92 (3D)" },
  { value: "EPSG:4374", label: "EPSG:4374 / RGR92 (geocentric)" },
  { value: "EPSG:4375", label: "EPSG:4375 / SIRGAS (3D)" },
  { value: "EPSG:4376", label: "EPSG:4376 / SIRGAS (geocentric)" },
  { value: "EPSG:4377", label: "EPSG:4377 / SWEREF99 (3D)" },
  { value: "EPSG:4378", label: "EPSG:4378 / SWEREF99 (geocentric)" },
  { value: "EPSG:4379", label: "EPSG:4379 / Yemen NGN96 (3D)" },
  { value: "EPSG:4380", label: "EPSG:4380 / Yemen NGN96 (geocentric)" },
  { value: "EPSG:4381", label: "EPSG:4381 / RGNC 1991 (3D)" },
  { value: "EPSG:4382", label: "EPSG:4382 / RGNC 1991 (geocentric)" },
  { value: "EPSG:4383", label: "EPSG:4383 / RRAF 1991 (3D)" },
  { value: "EPSG:4384", label: "EPSG:4384 / RRAF 1991 (geocentric)" },
  { value: "EPSG:4385", label: "EPSG:4385 / ITRF2000 (geocentric)" },
  { value: "EPSG:4386", label: "EPSG:4386 / ISN93 (3D)" },
  { value: "EPSG:4387", label: "EPSG:4387 / ISN93 (geocentric)" },
  { value: "EPSG:4388", label: "EPSG:4388 / LKS92 (3D)" },
  { value: "EPSG:4389", label: "EPSG:4389 / LKS92 (geocentric)" },
  { value: "EPSG:4463", label: "EPSG:4463 / RGSPM06" },
  { value: "EPSG:4465", label: "EPSG:4465 / RGSPM06" },
  { value: "EPSG:4466", label: "EPSG:4466 / RGSPM06" },
  { value: "EPSG:4468", label: "EPSG:4468 / RGM04" },
  { value: "EPSG:4469", label: "EPSG:4469 / RGM04" },
  { value: "EPSG:4470", label: "EPSG:4470 / RGM04" },
  { value: "EPSG:4472", label: "EPSG:4472 / Cadastre 1997" },
  { value: "EPSG:4473", label: "EPSG:4473 / Cadastre 1997" },
  { value: "EPSG:4475", label: "EPSG:4475 / Cadastre 1997" },
  {
    value: "EPSG:4479",
    label: "EPSG:4479 / China Geodetic Coordinate System 2000",
  },
  {
    value: "EPSG:4480",
    label: "EPSG:4480 / China Geodetic Coordinate System 2000",
  },
  { value: "EPSG:4481", label: "EPSG:4481 / Mexico ITRF92" },
  { value: "EPSG:4482", label: "EPSG:4482 / Mexico ITRF92" },
  { value: "EPSG:4483", label: "EPSG:4483 / Mexico ITRF92" },
  {
    value: "EPSG:4490",
    label: "EPSG:4490 / China Geodetic Coordinate System 2000",
  },
  { value: "EPSG:4555", label: "EPSG:4555 / New Beijing" },
  { value: "EPSG:4556", label: "EPSG:4556 / RRAF 1991" },
  { value: "EPSG:4557", label: "EPSG:4557 / RRAF 1991" },
  { value: "EPSG:4558", label: "EPSG:4558 / RRAF 1991" },
  { value: "EPSG:4600", label: "EPSG:4600 / Anguilla 1957" },
  { value: "EPSG:4601", label: "EPSG:4601 / Antigua 1943" },
  { value: "EPSG:4602", label: "EPSG:4602 / Dominica 1945" },
  { value: "EPSG:4603", label: "EPSG:4603 / Grenada 1953" },
  { value: "EPSG:4604", label: "EPSG:4604 / Montserrat 1958" },
  { value: "EPSG:4605", label: "EPSG:4605 / St. Kitts 1955" },
  { value: "EPSG:4606", label: "EPSG:4606 / St. Lucia 1955" },
  { value: "EPSG:4607", label: "EPSG:4607 / St. Vincent 1945" },
  { value: "EPSG:4608", label: "EPSG:4608 / NAD27(76)" },
  { value: "EPSG:4609", label: "EPSG:4609 / NAD27(CGQ77)" },
  { value: "EPSG:4610", label: "EPSG:4610 / Xian 1980" },
  { value: "EPSG:4611", label: "EPSG:4611 / Hong Kong 1980" },
  { value: "EPSG:4612", label: "EPSG:4612 / JGD2000" },
  { value: "EPSG:4613", label: "EPSG:4613 / Segara" },
  { value: "EPSG:4614", label: "EPSG:4614 / QND95" },
  { value: "EPSG:4615", label: "EPSG:4615 / Porto Santo" },
  { value: "EPSG:4616", label: "EPSG:4616 / Selvagem Grande" },
  { value: "EPSG:4617", label: "EPSG:4617 / NAD83(CSRS)" },
  { value: "EPSG:4618", label: "EPSG:4618 / SAD69" },
  { value: "EPSG:4619", label: "EPSG:4619 / SWEREF99" },
  { value: "EPSG:4620", label: "EPSG:4620 / Point 58" },
  { value: "EPSG:4621", label: "EPSG:4621 / Fort Marigot" },
  { value: "EPSG:4622", label: "EPSG:4622 / Guadeloupe 1948" },
  { value: "EPSG:4623", label: "EPSG:4623 / CSG67" },
  { value: "EPSG:4624", label: "EPSG:4624 / RGFG95" },
  { value: "EPSG:4625", label: "EPSG:4625 / Martinique 1938" },
  { value: "EPSG:4626", label: "EPSG:4626 / Reunion 1947" },
  { value: "EPSG:4627", label: "EPSG:4627 / RGR92" },
  { value: "EPSG:4628", label: "EPSG:4628 / Tahiti 52" },
  { value: "EPSG:4629", label: "EPSG:4629 / Tahaa 54" },
  { value: "EPSG:4630", label: "EPSG:4630 / IGN72 Nuku Hiva" },
  { value: "EPSG:4631", label: "EPSG:4631 / K0 1949" },
  { value: "EPSG:4632", label: "EPSG:4632 / Combani 1950" },
  { value: "EPSG:4633", label: "EPSG:4633 / IGN56 Lifou" },
  { value: "EPSG:4634", label: "EPSG:4634 / IGN72 Grand Terre" },
  { value: "EPSG:4635", label: "EPSG:4635 / ST87 Ouvea" },
  { value: "EPSG:4636", label: "EPSG:4636 / Petrels 1972" },
  { value: "EPSG:4637", label: "EPSG:4637 / Perroud 1950" },
  { value: "EPSG:4638", label: "EPSG:4638 / Saint Pierre et Miquelon 1950" },
  { value: "EPSG:4639", label: "EPSG:4639 / MOP78" },
  { value: "EPSG:4640", label: "EPSG:4640 / RRAF 1991" },
  { value: "EPSG:4641", label: "EPSG:4641 / IGN53 Mare" },
  { value: "EPSG:4642", label: "EPSG:4642 / ST84 Ile des Pins" },
  { value: "EPSG:4643", label: "EPSG:4643 / ST71 Belep" },
  { value: "EPSG:4644", label: "EPSG:4644 / NEA74 Noumea" },
  { value: "EPSG:4645", label: "EPSG:4645 / RGNC 1991" },
  { value: "EPSG:4646", label: "EPSG:4646 / Grand Comoros" },
  { value: "EPSG:4657", label: "EPSG:4657 / Reykjavik 1900" },
  { value: "EPSG:4658", label: "EPSG:4658 / Hjorsey 1955" },
  { value: "EPSG:4659", label: "EPSG:4659 / ISN93" },
  { value: "EPSG:4660", label: "EPSG:4660 / Helle 1954" },
  { value: "EPSG:4661", label: "EPSG:4661 / LKS92" },
  { value: "EPSG:4662", label: "EPSG:4662 / IGN72 Grande Terre" },
  { value: "EPSG:4663", label: "EPSG:4663 / Porto Santo 1995" },
  { value: "EPSG:4664", label: "EPSG:4664 / Azores Oriental 1995" },
  { value: "EPSG:4665", label: "EPSG:4665 / Azores Central 1995" },
  { value: "EPSG:4666", label: "EPSG:4666 / Lisbon 1890" },
  { value: "EPSG:4667", label: "EPSG:4667 / IKBD-92" },
  { value: "EPSG:4668", label: "EPSG:4668 / ED79" },
  { value: "EPSG:4669", label: "EPSG:4669 / LKS94" },
  { value: "EPSG:4670", label: "EPSG:4670 / IGM95" },
  { value: "EPSG:4671", label: "EPSG:4671 / Voirol 1879" },
  { value: "EPSG:4672", label: "EPSG:4672 / Chatham Islands 1971" },
  { value: "EPSG:4673", label: "EPSG:4673 / Chatham Islands 1979" },
  { value: "EPSG:4674", label: "EPSG:4674 / SIRGAS 2000" },
  { value: "EPSG:4675", label: "EPSG:4675 / Guam 1963" },
  { value: "EPSG:4676", label: "EPSG:4676 / Vientiane 1982" },
  { value: "EPSG:4677", label: "EPSG:4677 / Lao 1993" },
  { value: "EPSG:4678", label: "EPSG:4678 / Lao 1997" },
  { value: "EPSG:4679", label: "EPSG:4679 / Jouik 1961" },
  { value: "EPSG:4680", label: "EPSG:4680 / Nouakchott 1965" },
  { value: "EPSG:4681", label: "EPSG:4681 / Mauritania 1999" },
  { value: "EPSG:4682", label: "EPSG:4682 / Gulshan 303" },
  { value: "EPSG:4683", label: "EPSG:4683 / PRS92" },
  { value: "EPSG:4684", label: "EPSG:4684 / Gan 1970" },
  { value: "EPSG:4685", label: "EPSG:4685 / Gandajika" },
  { value: "EPSG:4686", label: "EPSG:4686 / MAGNA-SIRGAS" },
  { value: "EPSG:4687", label: "EPSG:4687 / RGPF" },
  { value: "EPSG:4688", label: "EPSG:4688 / Fatu Iva 72" },
  { value: "EPSG:4689", label: "EPSG:4689 / IGN63 Hiva Oa" },
  { value: "EPSG:4690", label: "EPSG:4690 / Tahiti 79" },
  { value: "EPSG:4691", label: "EPSG:4691 / Moorea 87" },
  { value: "EPSG:4692", label: "EPSG:4692 / Maupiti 83" },
  { value: "EPSG:4693", label: "EPSG:4693 / Nakhl-e Ghanem" },
  { value: "EPSG:4694", label: "EPSG:4694 / POSGAR 94" },
  { value: "EPSG:4695", label: "EPSG:4695 / Katanga 1955" },
  { value: "EPSG:4696", label: "EPSG:4696 / Kasai 1953" },
  { value: "EPSG:4697", label: "EPSG:4697 / IGC 1962 6th Parallel South" },
  { value: "EPSG:4698", label: "EPSG:4698 / IGN 1962 Kerguelen" },
  { value: "EPSG:4699", label: "EPSG:4699 / Le Pouce 1934" },
  { value: "EPSG:4700", label: "EPSG:4700 / IGN Astro 1960" },
  { value: "EPSG:4701", label: "EPSG:4701 / IGCB 1955" },
  { value: "EPSG:4702", label: "EPSG:4702 / Mauritania 1999" },
  { value: "EPSG:4703", label: "EPSG:4703 / Mhast 1951" },
  { value: "EPSG:4704", label: "EPSG:4704 / Mhast (onshore)" },
  { value: "EPSG:4705", label: "EPSG:4705 / Mhast (offshore)" },
  { value: "EPSG:4706", label: "EPSG:4706 / Egypt Gulf of Suez S-650 TL" },
  { value: "EPSG:4707", label: "EPSG:4707 / Tern Island 1961" },
  { value: "EPSG:4708", label: "EPSG:4708 / Cocos Islands 1965" },
  { value: "EPSG:4709", label: "EPSG:4709 / Iwo Jima 1945" },
  { value: "EPSG:4710", label: "EPSG:4710 / Astro DOS 71" },
  { value: "EPSG:4711", label: "EPSG:4711 / Marcus Island 1952" },
  { value: "EPSG:4712", label: "EPSG:4712 / Ascension Island 1958" },
  { value: "EPSG:4713", label: "EPSG:4713 / Ayabelle Lighthouse" },
  { value: "EPSG:4714", label: "EPSG:4714 / Bellevue" },
  { value: "EPSG:4715", label: "EPSG:4715 / Camp Area Astro" },
  { value: "EPSG:4716", label: "EPSG:4716 / Phoenix Islands 1966" },
  { value: "EPSG:4717", label: "EPSG:4717 / Cape Canaveral" },
  { value: "EPSG:4718", label: "EPSG:4718 / Solomon 1968" },
  { value: "EPSG:4719", label: "EPSG:4719 / Easter Island 1967" },
  { value: "EPSG:4720", label: "EPSG:4720 / Fiji 1986" },
  { value: "EPSG:4721", label: "EPSG:4721 / Fiji 1956" },
  { value: "EPSG:4722", label: "EPSG:4722 / South Georgia 1968" },
  { value: "EPSG:4723", label: "EPSG:4723 / GCGD59" },
  { value: "EPSG:4724", label: "EPSG:4724 / Diego Garcia 1969" },
  { value: "EPSG:4725", label: "EPSG:4725 / Johnston Island 1961" },
  { value: "EPSG:4726", label: "EPSG:4726 / SIGD61" },
  { value: "EPSG:4727", label: "EPSG:4727 / Midway 1961" },
  { value: "EPSG:4728", label: "EPSG:4728 / PN84" },
  { value: "EPSG:4729", label: "EPSG:4729 / Pitcairn 1967" },
  { value: "EPSG:4730", label: "EPSG:4730 / Santo 1965" },
  { value: "EPSG:4731", label: "EPSG:4731 / Viti Levu 1916" },
  { value: "EPSG:4732", label: "EPSG:4732 / Marshall Islands 1960" },
  { value: "EPSG:4733", label: "EPSG:4733 / Wake Island 1952" },
  { value: "EPSG:4734", label: "EPSG:4734 / Tristan 1968" },
  { value: "EPSG:4735", label: "EPSG:4735 / Kusaie 1951" },
  { value: "EPSG:4736", label: "EPSG:4736 / Deception Island" },
  { value: "EPSG:4737", label: "EPSG:4737 / Korea 2000" },
  { value: "EPSG:4738", label: "EPSG:4738 / Hong Kong 1963" },
  { value: "EPSG:4739", label: "EPSG:4739 / Hong Kong 1963(67)" },
  { value: "EPSG:4740", label: "EPSG:4740 / PZ-90" },
  { value: "EPSG:4741", label: "EPSG:4741 / FD54" },
  { value: "EPSG:4742", label: "EPSG:4742 / GDM2000" },
  { value: "EPSG:4743", label: "EPSG:4743 / Karbala 1979" },
  { value: "EPSG:4744", label: "EPSG:4744 / Nahrwan 1934" },
  { value: "EPSG:4745", label: "EPSG:4745 / RD/83" },
  { value: "EPSG:4746", label: "EPSG:4746 / PD/83" },
  { value: "EPSG:4747", label: "EPSG:4747 / GR96" },
  { value: "EPSG:4748", label: "EPSG:4748 / Vanua Levu 1915" },
  { value: "EPSG:4749", label: "EPSG:4749 / RGNC91-93" },
  { value: "EPSG:4750", label: "EPSG:4750 / ST87 Ouvea" },
  { value: "EPSG:4751", label: "EPSG:4751 / Kertau (RSO)" },
  { value: "EPSG:4752", label: "EPSG:4752 / Viti Levu 1912" },
  { value: "EPSG:4753", label: "EPSG:4753 / fk89" },
  { value: "EPSG:4754", label: "EPSG:4754 / LGD2006" },
  { value: "EPSG:4755", label: "EPSG:4755 / DGN95" },
  { value: "EPSG:4756", label: "EPSG:4756 / VN-2000" },
  { value: "EPSG:4757", label: "EPSG:4757 / SVY21" },
  { value: "EPSG:4758", label: "EPSG:4758 / JAD2001" },
  { value: "EPSG:4759", label: "EPSG:4759 / NAD83(NSRS2007)" },
  { value: "EPSG:4760", label: "EPSG:4760 / WGS 66" },
  { value: "EPSG:4761", label: "EPSG:4761 / HTRS96" },
  { value: "EPSG:4762", label: "EPSG:4762 / BDA2000" },
  { value: "EPSG:4763", label: "EPSG:4763 / Pitcairn 2006" },
  { value: "EPSG:4764", label: "EPSG:4764 / RSRGD2000" },
  { value: "EPSG:4765", label: "EPSG:4765 / Slovenia 1996" },
  { value: "EPSG:4801", label: "EPSG:4801 / Bern 1898 (Bern)" },
  { value: "EPSG:4802", label: "EPSG:4802 / Bogota 1975 (Bogota)" },
  { value: "EPSG:4803", label: "EPSG:4803 / Lisbon (Lisbon)" },
  { value: "EPSG:4804", label: "EPSG:4804 / Makassar (Jakarta)" },
  { value: "EPSG:4805", label: "EPSG:4805 / MGI (Ferro)" },
  { value: "EPSG:4806", label: "EPSG:4806 / Monte Mario (Rome)" },
  { value: "EPSG:4807", label: "EPSG:4807 / NTF (Paris)" },
  { value: "EPSG:4808", label: "EPSG:4808 / Padang (Jakarta)" },
  { value: "EPSG:4809", label: "EPSG:4809 / BD50 (Brussels)" },
  { value: "EPSG:4810", label: "EPSG:4810 / Tananarive (Paris)" },
  { value: "EPSG:4811", label: "EPSG:4811 / Voirol 1875 (Paris)" },
  { value: "EPSG:4813", label: "EPSG:4813 / Batavia (Jakarta)" },
  { value: "EPSG:4814", label: "EPSG:4814 / RT38 (Stockholm)" },
  { value: "EPSG:4815", label: "EPSG:4815 / Greek (Athens)" },
  { value: "EPSG:4816", label: "EPSG:4816 / Carthage (Paris)" },
  { value: "EPSG:4817", label: "EPSG:4817 / NGO 1948 (Oslo)" },
  { value: "EPSG:4818", label: "EPSG:4818 / S-JTSK (Ferro)" },
  { value: "EPSG:4819", label: "EPSG:4819 / Nord Sahara 1959 (Paris)" },
  { value: "EPSG:4820", label: "EPSG:4820 / Segara (Jakarta)" },
  { value: "EPSG:4821", label: "EPSG:4821 / Voirol 1879 (Paris)" },
  { value: "EPSG:4823", label: "EPSG:4823 / Sao Tome" },
  { value: "EPSG:4824", label: "EPSG:4824 / Principe" },
  { value: "EPSG:4882", label: "EPSG:4882 / Slovenia 1996" },
  { value: "EPSG:4883", label: "EPSG:4883 / Slovenia 1996" },
  { value: "EPSG:4884", label: "EPSG:4884 / RSRGD2000" },
  { value: "EPSG:4885", label: "EPSG:4885 / RSRGD2000" },
  { value: "EPSG:4886", label: "EPSG:4886 / BDA2000" },
  { value: "EPSG:4887", label: "EPSG:4887 / BDA2000" },
  { value: "EPSG:4888", label: "EPSG:4888 / HTRS96" },
  { value: "EPSG:4889", label: "EPSG:4889 / HTRS96" },
  { value: "EPSG:4890", label: "EPSG:4890 / WGS 66" },
  { value: "EPSG:4891", label: "EPSG:4891 / WGS 66" },
  { value: "EPSG:4892", label: "EPSG:4892 / NAD83(NSRS2007)" },
  { value: "EPSG:4893", label: "EPSG:4893 / NAD83(NSRS2007)" },
  { value: "EPSG:4894", label: "EPSG:4894 / JAD2001" },
  { value: "EPSG:4895", label: "EPSG:4895 / JAD2001" },
  { value: "EPSG:4896", label: "EPSG:4896 / ITRF2005" },
  { value: "EPSG:4897", label: "EPSG:4897 / DGN95" },
  { value: "EPSG:4898", label: "EPSG:4898 / DGN95" },
  { value: "EPSG:4899", label: "EPSG:4899 / LGD2006" },
  { value: "EPSG:4900", label: "EPSG:4900 / LGD2006" },
  { value: "EPSG:4901", label: "EPSG:4901 / ATF (Paris)" },
  { value: "EPSG:4902", label: "EPSG:4902 / NDG (Paris)" },
  { value: "EPSG:4903", label: "EPSG:4903 / Madrid 1870 (Madrid)" },
  { value: "EPSG:4904", label: "EPSG:4904 / Lisbon 1890 (Lisbon)" },
  { value: "EPSG:4906", label: "EPSG:4906 / RGNC91-93" },
  { value: "EPSG:4907", label: "EPSG:4907 / RGNC91-93" },
  { value: "EPSG:4908", label: "EPSG:4908 / GR96" },
  { value: "EPSG:4909", label: "EPSG:4909 / GR96" },
  { value: "EPSG:4910", label: "EPSG:4910 / ITRF88" },
  { value: "EPSG:4911", label: "EPSG:4911 / ITRF89" },
  { value: "EPSG:4912", label: "EPSG:4912 / ITRF90" },
  { value: "EPSG:4913", label: "EPSG:4913 / ITRF91" },
  { value: "EPSG:4914", label: "EPSG:4914 / ITRF92" },
  { value: "EPSG:4915", label: "EPSG:4915 / ITRF93" },
  { value: "EPSG:4916", label: "EPSG:4916 / ITRF94" },
  { value: "EPSG:4917", label: "EPSG:4917 / ITRF96" },
  { value: "EPSG:4918", label: "EPSG:4918 / ITRF97" },
  { value: "EPSG:4919", label: "EPSG:4919 / ITRF2000" },
  { value: "EPSG:4920", label: "EPSG:4920 / GDM2000" },
  { value: "EPSG:4921", label: "EPSG:4921 / GDM2000" },
  { value: "EPSG:4922", label: "EPSG:4922 / PZ-90" },
  { value: "EPSG:4923", label: "EPSG:4923 / PZ-90" },
  { value: "EPSG:4924", label: "EPSG:4924 / Mauritania 1999" },
  { value: "EPSG:4925", label: "EPSG:4925 / Mauritania 1999" },
  { value: "EPSG:4926", label: "EPSG:4926 / Korea 2000" },
  { value: "EPSG:4927", label: "EPSG:4927 / Korea 2000" },
  { value: "EPSG:4928", label: "EPSG:4928 / POSGAR 94" },
  { value: "EPSG:4929", label: "EPSG:4929 / POSGAR 94" },
  { value: "EPSG:4930", label: "EPSG:4930 / Australian Antarctic" },
  { value: "EPSG:4931", label: "EPSG:4931 / Australian Antarctic" },
  { value: "EPSG:4932", label: "EPSG:4932 / CHTRS95" },
  { value: "EPSG:4933", label: "EPSG:4933 / CHTRS95" },
  { value: "EPSG:4934", label: "EPSG:4934 / EST97" },
  { value: "EPSG:4935", label: "EPSG:4935 / EST97" },
  { value: "EPSG:4936", label: "EPSG:4936 / ETRS89" },
  { value: "EPSG:4937", label: "EPSG:4937 / ETRS89" },
  { value: "EPSG:4938", label: "EPSG:4938 / GDA94" },
  { value: "EPSG:4939", label: "EPSG:4939 / GDA94" },
  { value: "EPSG:4940", label: "EPSG:4940 / Hartebeesthoek94" },
  { value: "EPSG:4941", label: "EPSG:4941 / Hartebeesthoek94" },
  { value: "EPSG:4942", label: "EPSG:4942 / IRENET95" },
  { value: "EPSG:4943", label: "EPSG:4943 / IRENET95" },
  { value: "EPSG:4944", label: "EPSG:4944 / ISN93" },
  { value: "EPSG:4945", label: "EPSG:4945 / ISN93" },
  { value: "EPSG:4946", label: "EPSG:4946 / JGD2000" },
  { value: "EPSG:4947", label: "EPSG:4947 / JGD2000" },
  { value: "EPSG:4948", label: "EPSG:4948 / LKS92" },
  { value: "EPSG:4949", label: "EPSG:4949 / LKS92" },
  { value: "EPSG:4950", label: "EPSG:4950 / LKS94" },
  { value: "EPSG:4951", label: "EPSG:4951 / LKS94" },
  { value: "EPSG:4952", label: "EPSG:4952 / Moznet" },
  { value: "EPSG:4953", label: "EPSG:4953 / Moznet" },
  { value: "EPSG:4954", label: "EPSG:4954 / NAD83(CSRS)" },
  { value: "EPSG:4955", label: "EPSG:4955 / NAD83(CSRS)" },
  { value: "EPSG:4956", label: "EPSG:4956 / NAD83(HARN)" },
  { value: "EPSG:4957", label: "EPSG:4957 / NAD83(HARN)" },
  { value: "EPSG:4958", label: "EPSG:4958 / NZGD2000" },
  { value: "EPSG:4959", label: "EPSG:4959 / NZGD2000" },
  { value: "EPSG:4960", label: "EPSG:4960 / POSGAR 98" },
  { value: "EPSG:4961", label: "EPSG:4961 / POSGAR 98" },
  { value: "EPSG:4962", label: "EPSG:4962 / REGVEN" },
  { value: "EPSG:4963", label: "EPSG:4963 / REGVEN" },
  { value: "EPSG:4964", label: "EPSG:4964 / RGF93 v1" },
  { value: "EPSG:4965", label: "EPSG:4965 / RGF93 v1" },
  { value: "EPSG:4966", label: "EPSG:4966 / RGFG95" },
  { value: "EPSG:4967", label: "EPSG:4967 / RGFG95" },
  { value: "EPSG:4968", label: "EPSG:4968 / RGNC 1991" },
  { value: "EPSG:4969", label: "EPSG:4969 / RGNC 1991" },
  { value: "EPSG:4970", label: "EPSG:4970 / RGR92" },
  { value: "EPSG:4971", label: "EPSG:4971 / RGR92" },
  { value: "EPSG:4972", label: "EPSG:4972 / RRAF 1991" },
  { value: "EPSG:4973", label: "EPSG:4973 / RRAF 1991" },
  { value: "EPSG:4974", label: "EPSG:4974 / SIRGAS 1995" },
  { value: "EPSG:4975", label: "EPSG:4975 / SIRGAS 1995" },
  { value: "EPSG:4976", label: "EPSG:4976 / SWEREF99" },
  { value: "EPSG:4977", label: "EPSG:4977 / SWEREF99" },
  { value: "EPSG:4978", label: "EPSG:4978 / WGS 84" },
  { value: "EPSG:4979", label: "EPSG:4979 / WGS 84" },
  { value: "EPSG:4980", label: "EPSG:4980 / Yemen NGN96" },
  { value: "EPSG:4981", label: "EPSG:4981 / Yemen NGN96" },
  { value: "EPSG:4982", label: "EPSG:4982 / IGM95" },
  { value: "EPSG:4983", label: "EPSG:4983 / IGM95" },
  { value: "EPSG:4984", label: "EPSG:4984 / WGS 72" },
  { value: "EPSG:4985", label: "EPSG:4985 / WGS 72" },
  { value: "EPSG:4986", label: "EPSG:4986 / WGS 72BE" },
  { value: "EPSG:4987", label: "EPSG:4987 / WGS 72BE" },
  { value: "EPSG:4988", label: "EPSG:4988 / SIRGAS 2000" },
  { value: "EPSG:4989", label: "EPSG:4989 / SIRGAS 2000" },
  { value: "EPSG:4990", label: "EPSG:4990 / Lao 1993" },
  { value: "EPSG:4991", label: "EPSG:4991 / Lao 1993" },
  { value: "EPSG:4992", label: "EPSG:4992 / Lao 1997" },
  { value: "EPSG:4993", label: "EPSG:4993 / Lao 1997" },
  { value: "EPSG:4994", label: "EPSG:4994 / PRS92" },
  { value: "EPSG:4995", label: "EPSG:4995 / PRS92" },
  { value: "EPSG:4996", label: "EPSG:4996 / MAGNA-SIRGAS" },
  { value: "EPSG:4997", label: "EPSG:4997 / MAGNA-SIRGAS" },
  { value: "EPSG:4998", label: "EPSG:4998 / RGPF" },
  { value: "EPSG:4999", label: "EPSG:4999 / RGPF" },
  { value: "EPSG:5011", label: "EPSG:5011 / PTRA08" },
  { value: "EPSG:5012", label: "EPSG:5012 / PTRA08" },
  { value: "EPSG:5013", label: "EPSG:5013 / PTRA08" },
  { value: "EPSG:5132", label: "EPSG:5132 / Tokyo 1892" },
  { value: "EPSG:5228", label: "EPSG:5228 / S-JTSK/05" },
  { value: "EPSG:5229", label: "EPSG:5229 / S-JTSK/05 (Ferro)" },
  { value: "EPSG:5233", label: "EPSG:5233 / SLD99" },
  { value: "EPSG:5244", label: "EPSG:5244 / GDBD2009" },
  { value: "EPSG:5245", label: "EPSG:5245 / GDBD2009" },
  { value: "EPSG:5246", label: "EPSG:5246 / GDBD2009" },
  { value: "EPSG:5250", label: "EPSG:5250 / TUREF" },
  { value: "EPSG:5251", label: "EPSG:5251 / TUREF" },
  { value: "EPSG:5252", label: "EPSG:5252 / TUREF" },
  { value: "EPSG:5262", label: "EPSG:5262 / DRUKREF 03" },
  { value: "EPSG:5263", label: "EPSG:5263 / DRUKREF 03" },
  { value: "EPSG:5264", label: "EPSG:5264 / DRUKREF 03" },
  { value: "EPSG:5322", label: "EPSG:5322 / ISN2004" },
  { value: "EPSG:5323", label: "EPSG:5323 / ISN2004" },
  { value: "EPSG:5324", label: "EPSG:5324 / ISN2004" },
  { value: "EPSG:5332", label: "EPSG:5332 / ITRF2008" },
  { value: "EPSG:5340", label: "EPSG:5340 / POSGAR 2007" },
  { value: "EPSG:5341", label: "EPSG:5341 / POSGAR 2007" },
  { value: "EPSG:5342", label: "EPSG:5342 / POSGAR 2007" },
  { value: "EPSG:5352", label: "EPSG:5352 / MARGEN" },
  { value: "EPSG:5353", label: "EPSG:5353 / MARGEN" },
  { value: "EPSG:5354", label: "EPSG:5354 / MARGEN" },
  { value: "EPSG:5358", label: "EPSG:5358 / SIRGAS-Chile 2002" },
  { value: "EPSG:5359", label: "EPSG:5359 / SIRGAS-Chile 2002" },
  { value: "EPSG:5360", label: "EPSG:5360 / SIRGAS-Chile 2002" },
  { value: "EPSG:5363", label: "EPSG:5363 / CR05" },
  { value: "EPSG:5364", label: "EPSG:5364 / CR05" },
  { value: "EPSG:5365", label: "EPSG:5365 / CR05" },
  { value: "EPSG:5368", label: "EPSG:5368 / MACARIO SOLIS" },
  { value: "EPSG:5369", label: "EPSG:5369 / Peru96" },
  { value: "EPSG:5370", label: "EPSG:5370 / MACARIO SOLIS" },
  { value: "EPSG:5371", label: "EPSG:5371 / MACARIO SOLIS" },
  { value: "EPSG:5372", label: "EPSG:5372 / Peru96" },
  { value: "EPSG:5373", label: "EPSG:5373 / Peru96" },
  { value: "EPSG:5379", label: "EPSG:5379 / SIRGAS-ROU98" },
  { value: "EPSG:5380", label: "EPSG:5380 / SIRGAS-ROU98" },
  { value: "EPSG:5381", label: "EPSG:5381 / SIRGAS-ROU98" },
  { value: "EPSG:5391", label: "EPSG:5391 / SIRGAS_ES2007.8" },
  { value: "EPSG:5392", label: "EPSG:5392 / SIRGAS_ES2007.8" },
  { value: "EPSG:5393", label: "EPSG:5393 / SIRGAS_ES2007.8" },
  { value: "EPSG:5451", label: "EPSG:5451 / Ocotepeque 1935" },
  { value: "EPSG:5464", label: "EPSG:5464 / Sibun Gorge 1922" },
  { value: "EPSG:5467", label: "EPSG:5467 / Panama-Colon 1911" },
  { value: "EPSG:5487", label: "EPSG:5487 / RGAF09" },
  { value: "EPSG:5488", label: "EPSG:5488 / RGAF09" },
  { value: "EPSG:5489", label: "EPSG:5489 / RGAF09" },
  { value: "EPSG:5524", label: "EPSG:5524 / Corrego Alegre 1961" },
  { value: "EPSG:5527", label: "EPSG:5527 / SAD69(96)" },
  { value: "EPSG:5544", label: "EPSG:5544 / PNG94" },
  { value: "EPSG:5545", label: "EPSG:5545 / PNG94" },
  { value: "EPSG:5546", label: "EPSG:5546 / PNG94" },
  { value: "EPSG:5558", label: "EPSG:5558 / UCS-2000" },
  { value: "EPSG:5560", label: "EPSG:5560 / UCS-2000" },
  { value: "EPSG:5561", label: "EPSG:5561 / UCS-2000" },
  { value: "EPSG:5591", label: "EPSG:5591 / FEH2010" },
  { value: "EPSG:5592", label: "EPSG:5592 / FEH2010" },
  { value: "EPSG:5593", label: "EPSG:5593 / FEH2010" },
  { value: "EPSG:5681", label: "EPSG:5681 / DB_REF" },
  { value: "EPSG:5828", label: "EPSG:5828 / DB_REF" },
  { value: "EPSG:5830", label: "EPSG:5830 / DB_REF" },
  { value: "EPSG:5884", label: "EPSG:5884 / TGD2005" },
  { value: "EPSG:5885", label: "EPSG:5885 / TGD2005" },
  { value: "EPSG:5886", label: "EPSG:5886 / TGD2005" },
  { value: "EPSG:6133", label: "EPSG:6133 / CIGD11" },
  { value: "EPSG:6134", label: "EPSG:6134 / CIGD11" },
  { value: "EPSG:6135", label: "EPSG:6135 / CIGD11" },
  { value: "EPSG:6207", label: "EPSG:6207 / Nepal 1981" },
  { value: "EPSG:6309", label: "EPSG:6309 / CGRS93" },
  { value: "EPSG:6310", label: "EPSG:6310 / CGRS93" },
  { value: "EPSG:6311", label: "EPSG:6311 / CGRS93" },
  { value: "EPSG:6317", label: "EPSG:6317 / NAD83(2011)" },
  { value: "EPSG:6318", label: "EPSG:6318 / NAD83(2011)" },
  { value: "EPSG:6319", label: "EPSG:6319 / NAD83(2011)" },
  { value: "EPSG:6320", label: "EPSG:6320 / NAD83(PA11)" },
  { value: "EPSG:6321", label: "EPSG:6321 / NAD83(PA11)" },
  { value: "EPSG:6322", label: "EPSG:6322 / NAD83(PA11)" },
  { value: "EPSG:6323", label: "EPSG:6323 / NAD83(MA11)" },
  { value: "EPSG:6324", label: "EPSG:6324 / NAD83(MA11)" },
  { value: "EPSG:6325", label: "EPSG:6325 / NAD83(MA11)" },
  { value: "EPSG:6363", label: "EPSG:6363 / Mexico ITRF2008" },
  { value: "EPSG:6364", label: "EPSG:6364 / Mexico ITRF2008" },
  { value: "EPSG:6365", label: "EPSG:6365 / Mexico ITRF2008" },
  { value: "EPSG:6666", label: "EPSG:6666 / JGD2011" },
  { value: "EPSG:6667", label: "EPSG:6667 / JGD2011" },
  { value: "EPSG:6668", label: "EPSG:6668 / JGD2011" },
  { value: "EPSG:6704", label: "EPSG:6704 / RDN2008" },
  { value: "EPSG:6705", label: "EPSG:6705 / RDN2008" },
  { value: "EPSG:6706", label: "EPSG:6706 / RDN2008" },
  { value: "EPSG:6781", label: "EPSG:6781 / NAD83(CORS96)" },
  { value: "EPSG:6782", label: "EPSG:6782 / NAD83(CORS96)" },
  { value: "EPSG:6783", label: "EPSG:6783 / NAD83(CORS96)" },
  { value: "EPSG:6881", label: "EPSG:6881 / Aden 1925" },
  { value: "EPSG:6882", label: "EPSG:6882 / Bekaa Valley 1920" },
  { value: "EPSG:6883", label: "EPSG:6883 / Bioko" },
  { value: "EPSG:6892", label: "EPSG:6892 / South East Island 1943" },
  { value: "EPSG:6894", label: "EPSG:6894 / Gambia" },
  { value: "EPSG:6934", label: "EPSG:6934 / IGS08" },
  { value: "EPSG:6978", label: "EPSG:6978 / IGD05" },
  { value: "EPSG:6979", label: "EPSG:6979 / IGD05" },
  { value: "EPSG:6980", label: "EPSG:6980 / IGD05" },
  { value: "EPSG:6981", label: "EPSG:6981 / IG05 Intermediate CRS" },
  { value: "EPSG:6982", label: "EPSG:6982 / IG05 Intermediate CRS" },
  { value: "EPSG:6983", label: "EPSG:6983 / IG05 Intermediate CRS" },
  { value: "EPSG:6985", label: "EPSG:6985 / IGD05/12" },
  { value: "EPSG:6986", label: "EPSG:6986 / IGD05/12" },
  { value: "EPSG:6987", label: "EPSG:6987 / IGD05/12" },
  { value: "EPSG:6988", label: "EPSG:6988 / IG05/12 Intermediate CRS" },
  { value: "EPSG:6989", label: "EPSG:6989 / IG05/12 Intermediate CRS" },
  { value: "EPSG:6990", label: "EPSG:6990 / IG05/12 Intermediate CRS" },
  { value: "EPSG:7034", label: "EPSG:7034 / RGSPM06 (lon-lat)" },
  { value: "EPSG:7035", label: "EPSG:7035 / RGSPM06 (lon-lat)" },
  { value: "EPSG:7036", label: "EPSG:7036 / RGR92 (lon-lat)" },
  { value: "EPSG:7037", label: "EPSG:7037 / RGR92 (lon-lat)" },
  { value: "EPSG:7038", label: "EPSG:7038 / RGM04 (lon-lat)" },
  { value: "EPSG:7039", label: "EPSG:7039 / RGM04 (lon-lat)" },
  { value: "EPSG:7040", label: "EPSG:7040 / RGFG95 (lon-lat)" },
  { value: "EPSG:7041", label: "EPSG:7041 / RGFG95 (lon-lat)" },
  { value: "EPSG:7042", label: "EPSG:7042 / RGF93 v1 (lon-lat)" },
  { value: "EPSG:7071", label: "EPSG:7071 / RGTAAF07" },
  { value: "EPSG:7072", label: "EPSG:7072 / RGTAAF07" },
  { value: "EPSG:7073", label: "EPSG:7073 / RGTAAF07" },
  { value: "EPSG:7084", label: "EPSG:7084 / RGF93 v1 (lon-lat)" },
  { value: "EPSG:7085", label: "EPSG:7085 / RGAF09 (lon-lat)" },
  { value: "EPSG:7086", label: "EPSG:7086 / RGAF09 (lon-lat)" },
  { value: "EPSG:7087", label: "EPSG:7087 / RGTAAF07 (lon-lat)" },
  { value: "EPSG:7088", label: "EPSG:7088 / RGTAAF07 (lon-lat)" },
  { value: "EPSG:7133", label: "EPSG:7133 / RGTAAF07 (lon-lat)" },
  { value: "EPSG:7134", label: "EPSG:7134 / IGD05" },
  { value: "EPSG:7135", label: "EPSG:7135 / IGD05" },
  { value: "EPSG:7136", label: "EPSG:7136 / IGD05" },
  { value: "EPSG:7137", label: "EPSG:7137 / IGD05/12" },
  { value: "EPSG:7138", label: "EPSG:7138 / IGD05/12" },
  { value: "EPSG:7139", label: "EPSG:7139 / IGD05/12" },
  { value: "EPSG:7371", label: "EPSG:7371 / ONGD14" },
  { value: "EPSG:7372", label: "EPSG:7372 / ONGD14" },
  { value: "EPSG:7373", label: "EPSG:7373 / ONGD14" },
  { value: "EPSG:7656", label: "EPSG:7656 / WGS 84 (G730)" },
  { value: "EPSG:7657", label: "EPSG:7657 / WGS 84 (G730)" },
  { value: "EPSG:7658", label: "EPSG:7658 / WGS 84 (G873)" },
  { value: "EPSG:7659", label: "EPSG:7659 / WGS 84 (G873)" },
  { value: "EPSG:7660", label: "EPSG:7660 / WGS 84 (G1150)" },
  { value: "EPSG:7661", label: "EPSG:7661 / WGS 84 (G1150)" },
  { value: "EPSG:7662", label: "EPSG:7662 / WGS 84 (G1674)" },
  { value: "EPSG:7663", label: "EPSG:7663 / WGS 84 (G1674)" },
  { value: "EPSG:7664", label: "EPSG:7664 / WGS 84 (G1762)" },
  { value: "EPSG:7665", label: "EPSG:7665 / WGS 84 (G1762)" },
  { value: "EPSG:7677", label: "EPSG:7677 / PZ-90.02" },
  { value: "EPSG:7678", label: "EPSG:7678 / PZ-90.02" },
  { value: "EPSG:7679", label: "EPSG:7679 / PZ-90.11" },
  { value: "EPSG:7680", label: "EPSG:7680 / PZ-90.11" },
  { value: "EPSG:7681", label: "EPSG:7681 / GSK-2011" },
  { value: "EPSG:7682", label: "EPSG:7682 / GSK-2011" },
  { value: "EPSG:7683", label: "EPSG:7683 / GSK-2011" },
  { value: "EPSG:7684", label: "EPSG:7684 / Kyrg-06" },
  { value: "EPSG:7685", label: "EPSG:7685 / Kyrg-06" },
  { value: "EPSG:7686", label: "EPSG:7686 / Kyrg-06" },
  { value: "EPSG:7789", label: "EPSG:7789 / ITRF2014" },
  { value: "EPSG:7796", label: "EPSG:7796 / BGS2005" },
  { value: "EPSG:7797", label: "EPSG:7797 / BGS2005" },
  { value: "EPSG:7798", label: "EPSG:7798 / BGS2005" },
  { value: "EPSG:7815", label: "EPSG:7815 / WGS 84 (Transit)" },
  { value: "EPSG:7816", label: "EPSG:7816 / WGS 84 (Transit)" },
  { value: "EPSG:7842", label: "EPSG:7842 / GDA2020" },
  { value: "EPSG:7843", label: "EPSG:7843 / GDA2020" },
  { value: "EPSG:7844", label: "EPSG:7844 / GDA2020" },
  { value: "EPSG:7879", label: "EPSG:7879 / St. Helena Tritan" },
  { value: "EPSG:7880", label: "EPSG:7880 / St. Helena Tritan" },
  { value: "EPSG:7881", label: "EPSG:7881 / St. Helena Tritan" },
  { value: "EPSG:7884", label: "EPSG:7884 / SHGD2015" },
  { value: "EPSG:7885", label: "EPSG:7885 / SHGD2015" },
  { value: "EPSG:7886", label: "EPSG:7886 / SHGD2015" },
  { value: "EPSG:7900", label: "EPSG:7900 / ITRF88" },
  { value: "EPSG:7901", label: "EPSG:7901 / ITRF89" },
  { value: "EPSG:7902", label: "EPSG:7902 / ITRF90" },
  { value: "EPSG:7903", label: "EPSG:7903 / ITRF91" },
  { value: "EPSG:7904", label: "EPSG:7904 / ITRF92" },
  { value: "EPSG:7905", label: "EPSG:7905 / ITRF93" },
  { value: "EPSG:7906", label: "EPSG:7906 / ITRF94" },
  { value: "EPSG:7907", label: "EPSG:7907 / ITRF96" },
  { value: "EPSG:7908", label: "EPSG:7908 / ITRF97" },
  { value: "EPSG:7909", label: "EPSG:7909 / ITRF2000" },
  { value: "EPSG:7910", label: "EPSG:7910 / ITRF2005" },
  { value: "EPSG:7911", label: "EPSG:7911 / ITRF2008" },
  { value: "EPSG:7912", label: "EPSG:7912 / ITRF2014" },
  { value: "EPSG:7914", label: "EPSG:7914 / ETRF89" },
  { value: "EPSG:7915", label: "EPSG:7915 / ETRF89" },
  { value: "EPSG:7916", label: "EPSG:7916 / ETRF90" },
  { value: "EPSG:7917", label: "EPSG:7917 / ETRF90" },
  { value: "EPSG:7918", label: "EPSG:7918 / ETRF91" },
  { value: "EPSG:7919", label: "EPSG:7919 / ETRF91" },
  { value: "EPSG:7920", label: "EPSG:7920 / ETRF92" },
  { value: "EPSG:7921", label: "EPSG:7921 / ETRF92" },
  { value: "EPSG:7922", label: "EPSG:7922 / ETRF93" },
  { value: "EPSG:7923", label: "EPSG:7923 / ETRF93" },
  { value: "EPSG:7924", label: "EPSG:7924 / ETRF94" },
  { value: "EPSG:7925", label: "EPSG:7925 / ETRF94" },
  { value: "EPSG:7926", label: "EPSG:7926 / ETRF96" },
  { value: "EPSG:7927", label: "EPSG:7927 / ETRF96" },
  { value: "EPSG:7928", label: "EPSG:7928 / ETRF97" },
  { value: "EPSG:7929", label: "EPSG:7929 / ETRF97" },
  { value: "EPSG:7930", label: "EPSG:7930 / ETRF2000" },
  { value: "EPSG:7931", label: "EPSG:7931 / ETRF2000" },
  { value: "EPSG:8042", label: "EPSG:8042 / Gusterberg (Ferro)" },
  { value: "EPSG:8043", label: "EPSG:8043 / St. Stephen (Ferro)" },
  { value: "EPSG:8084", label: "EPSG:8084 / ISN2016" },
  { value: "EPSG:8085", label: "EPSG:8085 / ISN2016" },
  { value: "EPSG:8086", label: "EPSG:8086 / ISN2016" },
  { value: "EPSG:8227", label: "EPSG:8227 / IGS14" },
  { value: "EPSG:8230", label: "EPSG:8230 / NAD83(CSRS96)" },
  { value: "EPSG:8231", label: "EPSG:8231 / NAD83(CSRS96)" },
  { value: "EPSG:8232", label: "EPSG:8232 / NAD83(CSRS96)" },
  { value: "EPSG:8233", label: "EPSG:8233 / NAD83(CSRS)v2" },
  { value: "EPSG:8235", label: "EPSG:8235 / NAD83(CSRS)v2" },
  { value: "EPSG:8237", label: "EPSG:8237 / NAD83(CSRS)v2" },
  { value: "EPSG:8238", label: "EPSG:8238 / NAD83(CSRS)v3" },
  { value: "EPSG:8239", label: "EPSG:8239 / NAD83(CSRS)v3" },
  { value: "EPSG:8240", label: "EPSG:8240 / NAD83(CSRS)v3" },
  { value: "EPSG:8242", label: "EPSG:8242 / NAD83(CSRS)v4" },
  { value: "EPSG:8244", label: "EPSG:8244 / NAD83(CSRS)v4" },
  { value: "EPSG:8246", label: "EPSG:8246 / NAD83(CSRS)v4" },
  { value: "EPSG:8247", label: "EPSG:8247 / NAD83(CSRS)v5" },
  { value: "EPSG:8248", label: "EPSG:8248 / NAD83(CSRS)v5" },
  { value: "EPSG:8249", label: "EPSG:8249 / NAD83(CSRS)v5" },
  { value: "EPSG:8250", label: "EPSG:8250 / NAD83(CSRS)v6" },
  { value: "EPSG:8251", label: "EPSG:8251 / NAD83(CSRS)v6" },
  { value: "EPSG:8252", label: "EPSG:8252 / NAD83(CSRS)v6" },
  { value: "EPSG:8253", label: "EPSG:8253 / NAD83(CSRS)v7" },
  { value: "EPSG:8254", label: "EPSG:8254 / NAD83(CSRS)v7" },
  { value: "EPSG:8255", label: "EPSG:8255 / NAD83(CSRS)v7" },
  { value: "EPSG:8351", label: "EPSG:8351 / S-JTSK [JTSK03]" },
  { value: "EPSG:8397", label: "EPSG:8397 / ETRF2005" },
  { value: "EPSG:8399", label: "EPSG:8399 / ETRF2005" },
  { value: "EPSG:8401", label: "EPSG:8401 / ETRF2014" },
  { value: "EPSG:8403", label: "EPSG:8403 / ETRF2014" },
  { value: "EPSG:8425", label: "EPSG:8425 / Hong Kong Geodetic CS" },
  { value: "EPSG:8426", label: "EPSG:8426 / Hong Kong Geodetic CS" },
  { value: "EPSG:8427", label: "EPSG:8427 / Hong Kong Geodetic CS" },
  { value: "EPSG:8428", label: "EPSG:8428 / Macao 1920" },
  { value: "EPSG:8429", label: "EPSG:8429 / Macao 2008" },
  { value: "EPSG:8430", label: "EPSG:8430 / Macao 2008" },
  { value: "EPSG:8431", label: "EPSG:8431 / Macao 2008" },
  { value: "EPSG:8449", label: "EPSG:8449 / NAD83(FBN)" },
  { value: "EPSG:8541", label: "EPSG:8541 / NAD83(FBN)" },
  { value: "EPSG:8542", label: "EPSG:8542 / NAD83(FBN)" },
  { value: "EPSG:8543", label: "EPSG:8543 / NAD83(HARN Corrected)" },
  { value: "EPSG:8544", label: "EPSG:8544 / NAD83(HARN Corrected)" },
  { value: "EPSG:8545", label: "EPSG:8545 / NAD83(HARN Corrected)" },
  { value: "EPSG:8683", label: "EPSG:8683 / SRB_ETRS89" },
  { value: "EPSG:8684", label: "EPSG:8684 / SRB_ETRS89" },
  { value: "EPSG:8685", label: "EPSG:8685 / SRB_ETRS89" },
  { value: "EPSG:8694", label: "EPSG:8694 / Camacupa 2015" },
  { value: "EPSG:8697", label: "EPSG:8697 / RSAO13" },
  { value: "EPSG:8698", label: "EPSG:8698 / RSAO13" },
  { value: "EPSG:8699", label: "EPSG:8699 / RSAO13" },
  { value: "EPSG:8816", label: "EPSG:8816 / MTRF-2000" },
  { value: "EPSG:8817", label: "EPSG:8817 / MTRF-2000" },
  { value: "EPSG:8818", label: "EPSG:8818 / MTRF-2000" },
  { value: "EPSG:8860", label: "EPSG:8860 / NAD83(FBN)" },
  { value: "EPSG:8888", label: "EPSG:8888 / WGS 84 (Transit)" },
  { value: "EPSG:8898", label: "EPSG:8898 / RGWF96" },
  { value: "EPSG:8899", label: "EPSG:8899 / RGWF96" },
  { value: "EPSG:8900", label: "EPSG:8900 / RGWF96" },
  { value: "EPSG:8901", label: "EPSG:8901 / RGWF96 (lon-lat)" },
  { value: "EPSG:8902", label: "EPSG:8902 / RGWF96 (lon-lat)" },
  { value: "EPSG:8905", label: "EPSG:8905 / CR-SIRGAS" },
  { value: "EPSG:8906", label: "EPSG:8906 / CR-SIRGAS" },
  { value: "EPSG:8907", label: "EPSG:8907 / CR-SIRGAS" },
  { value: "EPSG:8915", label: "EPSG:8915 / SIRGAS-CON DGF00P01" },
  { value: "EPSG:8916", label: "EPSG:8916 / SIRGAS-CON DGF00P01" },
  { value: "EPSG:8917", label: "EPSG:8917 / SIRGAS-CON DGF01P01" },
  { value: "EPSG:8918", label: "EPSG:8918 / SIRGAS-CON DGF01P01" },
  { value: "EPSG:8919", label: "EPSG:8919 / SIRGAS-CON DGF01P02" },
  { value: "EPSG:8920", label: "EPSG:8920 / SIRGAS-CON DGF01P02" },
  { value: "EPSG:8921", label: "EPSG:8921 / SIRGAS-CON DGF02P01" },
  { value: "EPSG:8922", label: "EPSG:8922 / SIRGAS-CON DGF02P01" },
  { value: "EPSG:8923", label: "EPSG:8923 / SIRGAS-CON DGF04P01" },
  { value: "EPSG:8924", label: "EPSG:8924 / SIRGAS-CON DGF04P01" },
  { value: "EPSG:8925", label: "EPSG:8925 / SIRGAS-CON DGF05P01" },
  { value: "EPSG:8926", label: "EPSG:8926 / SIRGAS-CON DGF05P01" },
  { value: "EPSG:8927", label: "EPSG:8927 / SIRGAS-CON DGF06P01" },
  { value: "EPSG:8928", label: "EPSG:8928 / SIRGAS-CON DGF06P01" },
  { value: "EPSG:8929", label: "EPSG:8929 / SIRGAS-CON DGF07P01" },
  { value: "EPSG:8930", label: "EPSG:8930 / SIRGAS-CON DGF07P01" },
  { value: "EPSG:8931", label: "EPSG:8931 / SIRGAS-CON DGF08P01" },
  { value: "EPSG:8932", label: "EPSG:8932 / SIRGAS-CON DGF08P01" },
  { value: "EPSG:8933", label: "EPSG:8933 / SIRGAS-CON SIR09P01" },
  { value: "EPSG:8934", label: "EPSG:8934 / SIRGAS-CON SIR09P01" },
  { value: "EPSG:8935", label: "EPSG:8935 / SIRGAS-CON SIR10P01" },
  { value: "EPSG:8936", label: "EPSG:8936 / SIRGAS-CON SIR10P01" },
  { value: "EPSG:8937", label: "EPSG:8937 / SIRGAS-CON SIR11P01" },
  { value: "EPSG:8938", label: "EPSG:8938 / SIRGAS-CON SIR11P01" },
  { value: "EPSG:8939", label: "EPSG:8939 / SIRGAS-CON SIR13P01" },
  { value: "EPSG:8940", label: "EPSG:8940 / SIRGAS-CON SIR13P01" },
  { value: "EPSG:8941", label: "EPSG:8941 / SIRGAS-CON SIR14P01" },
  { value: "EPSG:8942", label: "EPSG:8942 / SIRGAS-CON SIR14P01" },
  { value: "EPSG:8943", label: "EPSG:8943 / SIRGAS-CON SIR15P01" },
  { value: "EPSG:8944", label: "EPSG:8944 / SIRGAS-CON SIR15P01" },
  { value: "EPSG:8945", label: "EPSG:8945 / SIRGAS-CON SIR17P01" },
  { value: "EPSG:8946", label: "EPSG:8946 / SIRGAS-CON SIR17P01" },
  { value: "EPSG:8947", label: "EPSG:8947 / SIRGAS-Chile 2010" },
  { value: "EPSG:8948", label: "EPSG:8948 / SIRGAS-Chile 2010" },
  { value: "EPSG:8949", label: "EPSG:8949 / SIRGAS-Chile 2010" },
  { value: "EPSG:8972", label: "EPSG:8972 / SIRGAS-CON DGF00P01" },
  { value: "EPSG:8973", label: "EPSG:8973 / SIRGAS-CON DGF01P01" },
  { value: "EPSG:8974", label: "EPSG:8974 / SIRGAS-CON DGF01P02" },
  { value: "EPSG:8975", label: "EPSG:8975 / SIRGAS-CON DGF02P01" },
  { value: "EPSG:8976", label: "EPSG:8976 / SIRGAS-CON DGF04P01" },
  { value: "EPSG:8977", label: "EPSG:8977 / SIRGAS-CON DGF05P01" },
  { value: "EPSG:8978", label: "EPSG:8978 / SIRGAS-CON DGF06P01" },
  { value: "EPSG:8979", label: "EPSG:8979 / SIRGAS-CON DGF07P01" },
  { value: "EPSG:8980", label: "EPSG:8980 / SIRGAS-CON DGF08P01" },
  { value: "EPSG:8981", label: "EPSG:8981 / SIRGAS-CON SIR09P01" },
  { value: "EPSG:8982", label: "EPSG:8982 / SIRGAS-CON SIR10P01" },
  { value: "EPSG:8983", label: "EPSG:8983 / SIRGAS-CON SIR11P01" },
  { value: "EPSG:8984", label: "EPSG:8984 / SIRGAS-CON SIR13P01" },
  { value: "EPSG:8985", label: "EPSG:8985 / SIRGAS-CON SIR14P01" },
  { value: "EPSG:8986", label: "EPSG:8986 / SIRGAS-CON SIR15P01" },
  { value: "EPSG:8987", label: "EPSG:8987 / SIRGAS-CON SIR17P01" },
  { value: "EPSG:8988", label: "EPSG:8988 / ITRF88" },
  { value: "EPSG:8989", label: "EPSG:8989 / ITRF89" },
  { value: "EPSG:8990", label: "EPSG:8990 / ITRF90" },
  { value: "EPSG:8991", label: "EPSG:8991 / ITRF91" },
  { value: "EPSG:8992", label: "EPSG:8992 / ITRF92" },
  { value: "EPSG:8993", label: "EPSG:8993 / ITRF93" },
  { value: "EPSG:8994", label: "EPSG:8994 / ITRF94" },
  { value: "EPSG:8995", label: "EPSG:8995 / ITRF96" },
  { value: "EPSG:8996", label: "EPSG:8996 / ITRF97" },
  { value: "EPSG:8997", label: "EPSG:8997 / ITRF2000" },
  { value: "EPSG:8998", label: "EPSG:8998 / ITRF2005" },
  { value: "EPSG:8999", label: "EPSG:8999 / ITRF2008" },
  { value: "EPSG:9000", label: "EPSG:9000 / ITRF2014" },
  { value: "EPSG:9001", label: "EPSG:9001 / IGS97" },
  { value: "EPSG:9002", label: "EPSG:9002 / IGS97" },
  { value: "EPSG:9003", label: "EPSG:9003 / IGS97" },
  { value: "EPSG:9004", label: "EPSG:9004 / IGS00" },
  { value: "EPSG:9005", label: "EPSG:9005 / IGS00" },
  { value: "EPSG:9006", label: "EPSG:9006 / IGS00" },
  { value: "EPSG:9007", label: "EPSG:9007 / IGb00" },
  { value: "EPSG:9008", label: "EPSG:9008 / IGb00" },
  { value: "EPSG:9009", label: "EPSG:9009 / IGb00" },
  { value: "EPSG:9010", label: "EPSG:9010 / IGS05" },
  { value: "EPSG:9011", label: "EPSG:9011 / IGS05" },
  { value: "EPSG:9012", label: "EPSG:9012 / IGS05" },
  { value: "EPSG:9013", label: "EPSG:9013 / IGS08" },
  { value: "EPSG:9014", label: "EPSG:9014 / IGS08" },
  { value: "EPSG:9015", label: "EPSG:9015 / IGb08" },
  { value: "EPSG:9016", label: "EPSG:9016 / IGb08" },
  { value: "EPSG:9017", label: "EPSG:9017 / IGb08" },
  { value: "EPSG:9018", label: "EPSG:9018 / IGS14" },
  { value: "EPSG:9019", label: "EPSG:9019 / IGS14" },
  { value: "EPSG:9053", label: "EPSG:9053 / WGS 84 (G730)" },
  { value: "EPSG:9054", label: "EPSG:9054 / WGS 84 (G873)" },
  { value: "EPSG:9055", label: "EPSG:9055 / WGS 84 (G1150)" },
  { value: "EPSG:9056", label: "EPSG:9056 / WGS 84 (G1674)" },
  { value: "EPSG:9057", label: "EPSG:9057 / WGS 84 (G1762)" },
  { value: "EPSG:9059", label: "EPSG:9059 / ETRF89" },
  { value: "EPSG:9060", label: "EPSG:9060 / ETRF90" },
  { value: "EPSG:9061", label: "EPSG:9061 / ETRF91" },
  { value: "EPSG:9062", label: "EPSG:9062 / ETRF92" },
  { value: "EPSG:9063", label: "EPSG:9063 / ETRF93" },
  { value: "EPSG:9064", label: "EPSG:9064 / ETRF94" },
  { value: "EPSG:9065", label: "EPSG:9065 / ETRF96" },
  { value: "EPSG:9066", label: "EPSG:9066 / ETRF97" },
  { value: "EPSG:9067", label: "EPSG:9067 / ETRF2000" },
  { value: "EPSG:9068", label: "EPSG:9068 / ETRF2005" },
  { value: "EPSG:9069", label: "EPSG:9069 / ETRF2014" },
  { value: "EPSG:9070", label: "EPSG:9070 / NAD83(MARP00)" },
  { value: "EPSG:9071", label: "EPSG:9071 / NAD83(MARP00)" },
  { value: "EPSG:9072", label: "EPSG:9072 / NAD83(MARP00)" },
  { value: "EPSG:9073", label: "EPSG:9073 / NAD83(PACP00)" },
  { value: "EPSG:9074", label: "EPSG:9074 / NAD83(PACP00)" },
  { value: "EPSG:9075", label: "EPSG:9075 / NAD83(PACP00)" },
  { value: "EPSG:9138", label: "EPSG:9138 / KOSOVAREF01" },
  { value: "EPSG:9139", label: "EPSG:9139 / KOSOVAREF01" },
  { value: "EPSG:9140", label: "EPSG:9140 / KOSOVAREF01" },
  { value: "EPSG:9146", label: "EPSG:9146 / SIRGAS-Chile 2013" },
  { value: "EPSG:9147", label: "EPSG:9147 / SIRGAS-Chile 2013" },
  { value: "EPSG:9148", label: "EPSG:9148 / SIRGAS-Chile 2013" },
  { value: "EPSG:9151", label: "EPSG:9151 / SIRGAS-Chile 2016" },
  { value: "EPSG:9152", label: "EPSG:9152 / SIRGAS-Chile 2016" },
  { value: "EPSG:9153", label: "EPSG:9153 / SIRGAS-Chile 2016" },
  { value: "EPSG:9182", label: "EPSG:9182 / SIRGAS-Chile" },
  { value: "EPSG:9183", label: "EPSG:9183 / SIRGAS-Chile" },
  { value: "EPSG:9184", label: "EPSG:9184 / SIRGAS-Chile" },
  { value: "EPSG:9248", label: "EPSG:9248 / Tapi Aike" },
  { value: "EPSG:9251", label: "EPSG:9251 / MMN" },
  { value: "EPSG:9253", label: "EPSG:9253 / MMS" },
  { value: "EPSG:9266", label: "EPSG:9266 / MGI" },
  { value: "EPSG:9267", label: "EPSG:9267 / MGI" },
  { value: "EPSG:9292", label: "EPSG:9292 / ONGD17" },
  { value: "EPSG:9293", label: "EPSG:9293 / ONGD17" },
  { value: "EPSG:9294", label: "EPSG:9294 / ONGD17" },
  { value: "EPSG:9299", label: "EPSG:9299 / HS2-IRF" },
  { value: "EPSG:9307", label: "EPSG:9307 / ATRF2014" },
  { value: "EPSG:9308", label: "EPSG:9308 / ATRF2014" },
  { value: "EPSG:9309", label: "EPSG:9309 / ATRF2014" },
  { value: "EPSG:9331", label: "EPSG:9331 / KSA-GRF17" },
  { value: "EPSG:9332", label: "EPSG:9332 / KSA-GRF17" },
  { value: "EPSG:9333", label: "EPSG:9333 / KSA-GRF17" },
  { value: "EPSG:9364", label: "EPSG:9364 / TPEN11-IRF" },
  { value: "EPSG:9372", label: "EPSG:9372 / MML07-IRF" },
  { value: "EPSG:9378", label: "EPSG:9378 / IGb14" },
  { value: "EPSG:9379", label: "EPSG:9379 / IGb14" },
  { value: "EPSG:9380", label: "EPSG:9380 / IGb14" },
  { value: "EPSG:9384", label: "EPSG:9384 / AbInvA96_2020-IRF" },
  { value: "EPSG:9403", label: "EPSG:9403 / PN68" },
  { value: "EPSG:9453", label: "EPSG:9453 / GBK19-IRF" },
  { value: "EPSG:9468", label: "EPSG:9468 / SRGI2013" },
  { value: "EPSG:9469", label: "EPSG:9469 / SRGI2013" },
  { value: "EPSG:9470", label: "EPSG:9470 / SRGI2013" },
  { value: "EPSG:9474", label: "EPSG:9474 / PZ-90.02" },
  { value: "EPSG:9475", label: "EPSG:9475 / PZ-90.11" },
  { value: "EPSG:9545", label: "EPSG:9545 / LTF2004(G)" },
  { value: "EPSG:9546", label: "EPSG:9546 / LTF2004(G)" },
  { value: "EPSG:9547", label: "EPSG:9547 / LTF2004(G)" },
  { value: "EPSG:9694", label: "EPSG:9694 / REDGEOMIN" },
  { value: "EPSG:9695", label: "EPSG:9695 / REDGEOMIN" },
  { value: "EPSG:9696", label: "EPSG:9696 / REDGEOMIN" },
  { value: "EPSG:9700", label: "EPSG:9700 / ETRF2000-PL" },
  { value: "EPSG:9701", label: "EPSG:9701 / ETRF2000-PL" },
  { value: "EPSG:9702", label: "EPSG:9702 / ETRF2000-PL" },
  { value: "EPSG:9739", label: "EPSG:9739 / EOS21-IRF" },
  { value: "EPSG:9753", label: "EPSG:9753 / WGS 84 (G2139)" },
  { value: "EPSG:9754", label: "EPSG:9754 / WGS 84 (G2139)" },
  { value: "EPSG:9755", label: "EPSG:9755 / WGS 84 (G2139)" },
  { value: "EPSG:9758", label: "EPSG:9758 / ECML14_NB-IRF" },
  { value: "EPSG:9763", label: "EPSG:9763 / EWR2-IRF" },
  { value: "EPSG:9775", label: "EPSG:9775 / RGF93 v2" },
  { value: "EPSG:9776", label: "EPSG:9776 / RGF93 v2" },
  { value: "EPSG:9777", label: "EPSG:9777 / RGF93 v2" },
  { value: "EPSG:9778", label: "EPSG:9778 / RGF93 v2 (lon-lat)" },
  { value: "EPSG:9779", label: "EPSG:9779 / RGF93 v2 (lon-lat)" },
  { value: "EPSG:9780", label: "EPSG:9780 / RGF93 v2b" },
  { value: "EPSG:9781", label: "EPSG:9781 / RGF93 v2b" },
  { value: "EPSG:9782", label: "EPSG:9782 / RGF93 v2b" },
  { value: "EPSG:9783", label: "EPSG:9783 / RGF93 v2b (lon-lat)" },
  { value: "EPSG:9784", label: "EPSG:9784 / RGF93 v2b (lon-lat)" },
  { value: "EPSG:9866", label: "EPSG:9866 / MRH21-IRF" },
  { value: "EPSG:9871", label: "EPSG:9871 / MOLDOR11-IRF" },
  { value: "EPSG:9892", label: "EPSG:9892 / LUREF" },
  { value: "EPSG:9893", label: "EPSG:9893 / LUREF" },
  { value: "EPSG:9939", label: "EPSG:9939 / EBBWV14-IRF" },
  { value: "EPSG:9964", label: "EPSG:9964 / HULLEE13-IRF" },
  { value: "EPSG:9969", label: "EPSG:9969 / SCM22-IRF" },
  { value: "EPSG:9974", label: "EPSG:9974 / FNL22-IRF" },
  { value: "EPSG:9988", label: "EPSG:9988 / ITRF2020" },
  { value: "EPSG:9989", label: "EPSG:9989 / ITRF2020" },
  { value: "EPSG:9990", label: "EPSG:9990 / ITRF2020" },
  { value: "EPSG:20033", label: "EPSG:20033 / MWC18-IRF" },
  { value: "EPSG:20039", label: "EPSG:20039 / SIRGAS-Chile 2021" },
  { value: "EPSG:20040", label: "EPSG:20040 / SIRGAS-Chile 2021" },
  { value: "EPSG:20041", label: "EPSG:20041 / SIRGAS-Chile 2021" },
  { value: "ESRI:4305", label: "ESRI:4305 / GCS_Voirol_Unifie_1960" },
  { value: "ESRI:4812", label: "ESRI:4812 / GCS_Voirol_Unifie_1960_Paris" },
  { value: "ESRI:9701", label: "ESRI:9701 / ETRF2000-PL_(3D)" },
  { value: "ESRI:9702", label: "ESRI:9702 / ETRF2000-PL" },
  { value: "ESRI:9739", label: "ESRI:9739 / EOS21-IRF" },
  { value: "ESRI:9758", label: "ESRI:9758 / ECML14_NB-IRF" },
  { value: "ESRI:9763", label: "ESRI:9763 / EWR2-IRF" },
  { value: "ESRI:37001", label: "ESRI:37001 / GCS_WGS_1966" },
  { value: "ESRI:37002", label: "ESRI:37002 / GCS_Fischer_1960" },
  { value: "ESRI:37003", label: "ESRI:37003 / GCS_Fischer_1968" },
  { value: "ESRI:37004", label: "ESRI:37004 / GCS_Fischer_Modified" },
  { value: "ESRI:37005", label: "ESRI:37005 / GCS_Hough_1960" },
  { value: "ESRI:37006", label: "ESRI:37006 / GCS_Everest_Modified_1969" },
  { value: "ESRI:37007", label: "ESRI:37007 / GCS_Walbeck" },
  { value: "ESRI:37008", label: "ESRI:37008 / GCS_Sphere_ARC_INFO" },
  { value: "ESRI:37201", label: "ESRI:37201 / GCS_European_1979" },
  { value: "ESRI:37202", label: "ESRI:37202 / GCS_Everest_Bangladesh" },
  { value: "ESRI:37203", label: "ESRI:37203 / GCS_Everest_India_Nepal" },
  { value: "ESRI:37204", label: "ESRI:37204 / GCS_Hjorsey_1955" },
  { value: "ESRI:37205", label: "ESRI:37205 / GCS_Hong_Kong_1963_67" },
  { value: "ESRI:37206", label: "ESRI:37206 / GCS_Oman" },
  { value: "ESRI:37207", label: "ESRI:37207 / GCS_South_Asia_Singapore" },
  { value: "ESRI:37208", label: "ESRI:37208 / GCS_Ayabelle" },
  { value: "ESRI:37211", label: "ESRI:37211 / GCS_Point_58" },
  { value: "ESRI:37212", label: "ESRI:37212 / GCS_Beacon_E_1945" },
  { value: "ESRI:37213", label: "ESRI:37213 / GCS_Tern_Island_1961" },
  { value: "ESRI:37214", label: "ESRI:37214 / GCS_Astro_1952" },
  { value: "ESRI:37215", label: "ESRI:37215 / GCS_Bellevue_IGN" },
  { value: "ESRI:37216", label: "ESRI:37216 / GCS_Canton_1966" },
  { value: "ESRI:37217", label: "ESRI:37217 / GCS_Chatham_Island_1971" },
  { value: "ESRI:37218", label: "ESRI:37218 / GCS_DOS_1968" },
  { value: "ESRI:37219", label: "ESRI:37219 / GCS_Easter_Island_1967" },
  { value: "ESRI:37220", label: "ESRI:37220 / GCS_Guam_1963" },
  { value: "ESRI:37221", label: "ESRI:37221 / GCS_GUX_1" },
  { value: "ESRI:37222", label: "ESRI:37222 / GCS_Johnston_Island_1961" },
  { value: "ESRI:37223", label: "ESRI:37223 / GCS_Carthage" },
  { value: "ESRI:37224", label: "ESRI:37224 / GCS_Midway_1961" },
  { value: "ESRI:37225", label: "ESRI:37225 / GCS_Carthage_Grad" },
  { value: "ESRI:37226", label: "ESRI:37226 / GCS_Pitcairn_1967" },
  { value: "ESRI:37227", label: "ESRI:37227 / GCS_Santo_DOS_1965" },
  { value: "ESRI:37228", label: "ESRI:37228 / GCS_Viti_Levu_1916" },
  { value: "ESRI:37229", label: "ESRI:37229 / GCS_Wake_Eniwetok_1960" },
  { value: "ESRI:37230", label: "ESRI:37230 / GCS_Wake_Island_1952" },
  { value: "ESRI:37231", label: "ESRI:37231 / GCS_Anna_1_1965" },
  { value: "ESRI:37232", label: "ESRI:37232 / GCS_Gan_1970" },
  { value: "ESRI:37233", label: "ESRI:37233 / GCS_ISTS_073_1969" },
  { value: "ESRI:37234", label: "ESRI:37234 / GCS_Kerguelen_Island_1949" },
  { value: "ESRI:37235", label: "ESRI:37235 / GCS_Reunion_1947" },
  { value: "ESRI:37237", label: "ESRI:37237 / GCS_Ascension_Island_1958" },
  { value: "ESRI:37238", label: "ESRI:37238 / GCS_DOS_71_4" },
  { value: "ESRI:37239", label: "ESRI:37239 / GCS_Cape_Canaveral" },
  { value: "ESRI:37240", label: "ESRI:37240 / GCS_Fort_Thomas_1955" },
  { value: "ESRI:37241", label: "ESRI:37241 / GCS_Graciosa_Base_SW_1948" },
  { value: "ESRI:37242", label: "ESRI:37242 / GCS_ISTS_061_1968" },
  { value: "ESRI:37243", label: "ESRI:37243 / GCS_LC5_1961" },
  {
    value: "ESRI:37245",
    label: "ESRI:37245 / GCS_Observatorio_Meteorologico_1939",
  },
  { value: "ESRI:37246", label: "ESRI:37246 / GCS_Pico_de_Las_Nieves" },
  { value: "ESRI:37247", label: "ESRI:37247 / GCS_Porto_Santo_1936" },
  { value: "ESRI:37249", label: "ESRI:37249 / GCS_Sao_Braz" },
  { value: "ESRI:37250", label: "ESRI:37250 / GCS_Selvagem_Grande_1938" },
  { value: "ESRI:37251", label: "ESRI:37251 / GCS_Tristan_1968" },
  { value: "ESRI:37252", label: "ESRI:37252 / GCS_American_Samoa_1962" },
  { value: "ESRI:37253", label: "ESRI:37253 / GCS_Camp_Area" },
  { value: "ESRI:37254", label: "ESRI:37254 / GCS_Deception_Island" },
  { value: "ESRI:37255", label: "ESRI:37255 / GCS_Gunung_Segara" },
  { value: "ESRI:37257", label: "ESRI:37257 / GCS_S42_Hungary" },
  { value: "ESRI:37259", label: "ESRI:37259 / GCS_Kusaie_1951" },
  { value: "ESRI:37260", label: "ESRI:37260 / GCS_Alaskan_Islands" },
  { value: "ESRI:104000", label: "ESRI:104000 / GCS_Assumed_Geographic_1" },
  { value: "ESRI:104009", label: "ESRI:104009 / GCS_Kyrg-06" },
  { value: "ESRI:104010", label: "ESRI:104010 / GCS_IGS08" },
  { value: "ESRI:104011", label: "ESRI:104011 / WGS_1984_(G730)" },
  { value: "ESRI:104012", label: "ESRI:104012 / WGS_1984_(G873)" },
  { value: "ESRI:104013", label: "ESRI:104013 / WGS_1984_(G1150)" },
  { value: "ESRI:104014", label: "ESRI:104014 / WGS_1984_(G1674)" },
  { value: "ESRI:104015", label: "ESRI:104015 / WGS_1984_(G1762)" },
  { value: "ESRI:104016", label: "ESRI:104016 / WGS_1984_(Transit)" },
  { value: "ESRI:104017", label: "ESRI:104017 / PZ-90.02" },
  { value: "ESRI:104018", label: "ESRI:104018 / PZ-90.11" },
  { value: "ESRI:104019", label: "ESRI:104019 / ITRF2014" },
  { value: "ESRI:104020", label: "ESRI:104020 / GCS_JGD_2011" },
  { value: "ESRI:104021", label: "ESRI:104021 / IGS14" },
  { value: "ESRI:104022", label: "ESRI:104022 / GGD" },
  { value: "ESRI:104023", label: "ESRI:104023 / GCS_International_1967" },
  {
    value: "ESRI:104024",
    label: "ESRI:104024 / California_SRS_Epoch_2017.50_(NAD83)",
  },
  { value: "ESRI:104025", label: "ESRI:104025 / GCS_Voirol_Unifie_1960_Paris" },
  { value: "ESRI:104026", label: "ESRI:104026 / GCS_Voirol_Unifie_1960" },
  { value: "ESRI:104027", label: "ESRI:104027 / ONGD17" },
  { value: "ESRI:104028", label: "ESRI:104028 / GDM2008" },
  {
    value: "ESRI:104047",
    label: "ESRI:104047 / GCS_Sphere_GRS_1980_Mean_Radius",
  },
  { value: "ESRI:104050", label: "ESRI:104050 / GCS_Xrail84" },
  { value: "ESRI:104100", label: "ESRI:104100 / GCS_GDBD2009" },
  { value: "ESRI:104101", label: "ESRI:104101 / GCS_Estonia_1937" },
  { value: "ESRI:104102", label: "ESRI:104102 / GCS_Hermannskogel" },
  { value: "ESRI:104103", label: "ESRI:104103 / GCS_Sierra_Leone_1960" },
  { value: "ESRI:104104", label: "ESRI:104104 / GCS_Hong_Kong_1980" },
  { value: "ESRI:104105", label: "ESRI:104105 / GCS_Datum_Lisboa_Bessel" },
  { value: "ESRI:104106", label: "ESRI:104106 / GCS_Datum_Lisboa_Hayford" },
  { value: "ESRI:104107", label: "ESRI:104107 / GCS_RGF_1993" },
  { value: "ESRI:104108", label: "ESRI:104108 / GCS_NZGD_2000" },
  { value: "ESRI:104109", label: "ESRI:104109 / GCS_Pohnpei" },
  { value: "ESRI:104110", label: "ESRI:104110 / GCS_REGVEN" },
  { value: "ESRI:104111", label: "ESRI:104111 / GCS_JGD_2000" },
  { value: "ESRI:104112", label: "ESRI:104112 / GCS_Bab_South" },
  { value: "ESRI:104113", label: "ESRI:104113 / GCS_Majuro" },
  { value: "ESRI:104114", label: "ESRI:104114 / GCS_Bermuda_2000" },
  { value: "ESRI:104115", label: "ESRI:104115 / GCS_ITRF_1988" },
  { value: "ESRI:104116", label: "ESRI:104116 / GCS_ITRF_1989" },
  { value: "ESRI:104117", label: "ESRI:104117 / GCS_ITRF_1990" },
  { value: "ESRI:104118", label: "ESRI:104118 / GCS_ITRF_1991" },
  { value: "ESRI:104119", label: "ESRI:104119 / GCS_ITRF_1992" },
  { value: "ESRI:104120", label: "ESRI:104120 / GCS_ITRF_1993" },
  { value: "ESRI:104121", label: "ESRI:104121 / GCS_ITRF_1994" },
  { value: "ESRI:104122", label: "ESRI:104122 / GCS_ITRF_1996" },
  { value: "ESRI:104123", label: "ESRI:104123 / GCS_ITRF_1997" },
  { value: "ESRI:104124", label: "ESRI:104124 / GCS_ITRF_2000" },
  { value: "ESRI:104125", label: "ESRI:104125 / GCS_Chatham_Islands_1979" },
  {
    value: "ESRI:104126",
    label: "ESRI:104126 / GCS_Observatorio_Meteorologico_1965",
  },
  { value: "ESRI:104127", label: "ESRI:104127 / GCS_Roma_1940" },
  { value: "ESRI:104128", label: "ESRI:104128 / GCS_Sphere_EMEP" },
  { value: "ESRI:104129", label: "ESRI:104129 / GCS_EUREF_FIN" },
  { value: "ESRI:104130", label: "ESRI:104130 / GCS_Jordan" },
  { value: "ESRI:104131", label: "ESRI:104131 / GCS_D48" },
  { value: "ESRI:104132", label: "ESRI:104132 / GCS_Ocotepeque_1935" },
  { value: "ESRI:104133", label: "ESRI:104133 / GCS_JAD_2001" },
  { value: "ESRI:104134", label: "ESRI:104134 / GCS_MONREF_1997" },
  { value: "ESRI:104135", label: "ESRI:104135 / GCS_MSK_1942" },
  { value: "ESRI:104136", label: "ESRI:104136 / GCS_TWD_1967" },
  { value: "ESRI:104137", label: "ESRI:104137 / GCS_TWD_1997" },
  { value: "ESRI:104138", label: "ESRI:104138 / GCS_Old_Hawaiian_Intl_1924" },
  { value: "ESRI:104139", label: "ESRI:104139 / GCS_Voirol_1875_Grad" },
  { value: "ESRI:104140", label: "ESRI:104140 / GCS_Voirol_1879_Grad" },
  { value: "ESRI:104141", label: "ESRI:104141 / GCS_CGRS_1993" },
  { value: "ESRI:104142", label: "ESRI:104142 / GCS_PTRA08" },
  { value: "ESRI:104143", label: "ESRI:104143 / GCS_CR05" },
  { value: "ESRI:104144", label: "ESRI:104144 / GCS_ISN_2004" },
  { value: "ESRI:104145", label: "ESRI:104145 / GCS_NAD_1983_2011" },
  { value: "ESRI:104179", label: "ESRI:104179 / ETRF90" },
  { value: "ESRI:104180", label: "ESRI:104180 / ETRF91" },
  { value: "ESRI:104181", label: "ESRI:104181 / ETRF92" },
  { value: "ESRI:104182", label: "ESRI:104182 / ETRF93" },
  { value: "ESRI:104183", label: "ESRI:104183 / ETRF94" },
  { value: "ESRI:104184", label: "ESRI:104184 / ETRF96" },
  { value: "ESRI:104185", label: "ESRI:104185 / ETRF97" },
  { value: "ESRI:104186", label: "ESRI:104186 / ETRF2000" },
  {
    value: "ESRI:104199",
    label: "ESRI:104199 / GCS_WGS_1984_Major_Auxiliary_Sphere",
  },
  { value: "ESRI:104223", label: "ESRI:104223 / GCS_NAD_1983_CORS96" },
  { value: "ESRI:104248", label: "ESRI:104248 / GCS_MACAO_2008" },
  { value: "ESRI:104256", label: "ESRI:104256 / GCS_Nepal_Nagarkot" },
  { value: "ESRI:104257", label: "ESRI:104257 / GCS_ITRF_2008" },
  { value: "ESRI:104258", label: "ESRI:104258 / GCS_ETRF_1989" },
  { value: "ESRI:104259", label: "ESRI:104259 / GCS_NAD_1983_PACP00" },
  { value: "ESRI:104260", label: "ESRI:104260 / GCS_NAD_1983_MARP00" },
  { value: "ESRI:104261", label: "ESRI:104261 / GCS_Merchich_Degree" },
  { value: "ESRI:104286", label: "ESRI:104286 / GCS_NAD_1983_MA11" },
  { value: "ESRI:104287", label: "ESRI:104287 / GCS_NAD_1983_PA11" },
  { value: "ESRI:104304", label: "ESRI:104304 / GCS_Voirol_1875" },
  {
    value: "ESRI:104305",
    label: "ESRI:104305 / GCS_Voirol_Unifie_1960_Degree",
  },
  { value: "ESRI:104602", label: "ESRI:104602 / North_American_1983_3D" },
  { value: "ESRI:104613", label: "ESRI:104613 / EUREF_FIN_3D" },
  {
    value: "ESRI:104644",
    label: "ESRI:104644 / California_SRS_Epoch_2017.50_(NAD83)_3D",
  },
  { value: "ESRI:104645", label: "ESRI:104645 / GGD_3D" },
  { value: "ESRI:104647", label: "ESRI:104647 / ONGD17_3D" },
  { value: "ESRI:104648", label: "ESRI:104648 / S-JTSK_[JTSK03]_3D" },
  { value: "ESRI:104653", label: "ESRI:104653 / MONREF_1997_3D" },
  { value: "ESRI:104664", label: "ESRI:104664 / Nepal_Nagarkot_3D" },
  { value: "ESRI:104693", label: "ESRI:104693 / SLD99_3D" },
  { value: "ESRI:104696", label: "ESRI:104696 / S_JTSK/05_3D" },
  { value: "ESRI:104697", label: "ESRI:104697 / S_JTSK/05_Ferro_3D" },
  {
    value: "ESRI:104700",
    label: "ESRI:104700 / GCS_NAD_1983_HARN_Adj_MN_Anoka",
  },
  {
    value: "ESRI:104701",
    label: "ESRI:104701 / GCS_NAD_1983_HARN_Adj_MN_Becker",
  },
  {
    value: "ESRI:104702",
    label: "ESRI:104702 / GCS_NAD_1983_HARN_Adj_MN_Beltrami_North",
  },
  {
    value: "ESRI:104703",
    label: "ESRI:104703 / GCS_NAD_1983_HARN_Adj_MN_Beltrami_South",
  },
  {
    value: "ESRI:104704",
    label: "ESRI:104704 / GCS_NAD_1983_HARN_Adj_MN_Benton",
  },
  {
    value: "ESRI:104705",
    label: "ESRI:104705 / GCS_NAD_1983_HARN_Adj_MN_Big_Stone",
  },
  {
    value: "ESRI:104706",
    label: "ESRI:104706 / GCS_NAD_1983_HARN_Adj_MN_Blue_Earth",
  },
  {
    value: "ESRI:104707",
    label: "ESRI:104707 / GCS_NAD_1983_HARN_Adj_MN_Brown",
  },
  {
    value: "ESRI:104708",
    label: "ESRI:104708 / GCS_NAD_1983_HARN_Adj_MN_Carlton",
  },
  {
    value: "ESRI:104709",
    label: "ESRI:104709 / GCS_NAD_1983_HARN_Adj_MN_Carver",
  },
  {
    value: "ESRI:104710",
    label: "ESRI:104710 / GCS_NAD_1983_HARN_Adj_MN_Cass_North",
  },
  {
    value: "ESRI:104711",
    label: "ESRI:104711 / GCS_NAD_1983_HARN_Adj_MN_Cass_South",
  },
  {
    value: "ESRI:104712",
    label: "ESRI:104712 / GCS_NAD_1983_HARN_Adj_MN_Chippewa",
  },
  {
    value: "ESRI:104713",
    label: "ESRI:104713 / GCS_NAD_1983_HARN_Adj_MN_Chisago",
  },
  {
    value: "ESRI:104714",
    label: "ESRI:104714 / GCS_NAD_1983_HARN_Adj_MN_Cook_North",
  },
  {
    value: "ESRI:104715",
    label: "ESRI:104715 / GCS_NAD_1983_HARN_Adj_MN_Cook_South",
  },
  {
    value: "ESRI:104716",
    label: "ESRI:104716 / GCS_NAD_1983_HARN_Adj_MN_Cottonwood",
  },
  {
    value: "ESRI:104717",
    label: "ESRI:104717 / GCS_NAD_1983_HARN_Adj_MN_Crow_Wing",
  },
  {
    value: "ESRI:104718",
    label: "ESRI:104718 / GCS_NAD_1983_HARN_Adj_MN_Dakota",
  },
  {
    value: "ESRI:104719",
    label: "ESRI:104719 / GCS_NAD_1983_HARN_Adj_MN_Dodge",
  },
  {
    value: "ESRI:104720",
    label: "ESRI:104720 / GCS_NAD_1983_HARN_Adj_MN_Douglas",
  },
  {
    value: "ESRI:104721",
    label: "ESRI:104721 / GCS_NAD_1983_HARN_Adj_MN_Faribault",
  },
  {
    value: "ESRI:104722",
    label: "ESRI:104722 / GCS_NAD_1983_HARN_Adj_MN_Fillmore",
  },
  {
    value: "ESRI:104723",
    label: "ESRI:104723 / GCS_NAD_1983_HARN_Adj_MN_Freeborn",
  },
  {
    value: "ESRI:104724",
    label: "ESRI:104724 / GCS_NAD_1983_HARN_Adj_MN_Goodhue",
  },
  {
    value: "ESRI:104725",
    label: "ESRI:104725 / GCS_NAD_1983_HARN_Adj_MN_Grant",
  },
  {
    value: "ESRI:104726",
    label: "ESRI:104726 / GCS_NAD_1983_HARN_Adj_MN_Hennepin",
  },
  {
    value: "ESRI:104727",
    label: "ESRI:104727 / GCS_NAD_1983_HARN_Adj_MN_Houston",
  },
  {
    value: "ESRI:104728",
    label: "ESRI:104728 / GCS_NAD_1983_HARN_Adj_MN_Isanti",
  },
  {
    value: "ESRI:104729",
    label: "ESRI:104729 / GCS_NAD_1983_HARN_Adj_MN_Itasca_North",
  },
  {
    value: "ESRI:104730",
    label: "ESRI:104730 / GCS_NAD_1983_HARN_Adj_MN_Itasca_South",
  },
  {
    value: "ESRI:104731",
    label: "ESRI:104731 / GCS_NAD_1983_HARN_Adj_MN_Jackson",
  },
  {
    value: "ESRI:104732",
    label: "ESRI:104732 / GCS_NAD_1983_HARN_Adj_MN_Kanabec",
  },
  {
    value: "ESRI:104733",
    label: "ESRI:104733 / GCS_NAD_1983_HARN_Adj_MN_Kandiyohi",
  },
  {
    value: "ESRI:104734",
    label: "ESRI:104734 / GCS_NAD_1983_HARN_Adj_MN_Kittson",
  },
  {
    value: "ESRI:104735",
    label: "ESRI:104735 / GCS_NAD_1983_HARN_Adj_MN_Koochiching",
  },
  {
    value: "ESRI:104736",
    label: "ESRI:104736 / GCS_NAD_1983_HARN_Adj_MN_Lac_Qui_Parle",
  },
  {
    value: "ESRI:104737",
    label: "ESRI:104737 / GCS_NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_North",
  },
  {
    value: "ESRI:104738",
    label: "ESRI:104738 / GCS_NAD_1983_HARN_Adj_MN_Lake_of_the_Woods_South",
  },
  {
    value: "ESRI:104739",
    label: "ESRI:104739 / GCS_NAD_1983_HARN_Adj_MN_Le_Sueur",
  },
  {
    value: "ESRI:104740",
    label: "ESRI:104740 / GCS_NAD_1983_HARN_Adj_MN_Lincoln",
  },
  {
    value: "ESRI:104741",
    label: "ESRI:104741 / GCS_NAD_1983_HARN_Adj_MN_Lyon",
  },
  {
    value: "ESRI:104742",
    label: "ESRI:104742 / GCS_NAD_1983_HARN_Adj_MN_McLeod",
  },
  {
    value: "ESRI:104743",
    label: "ESRI:104743 / GCS_NAD_1983_HARN_Adj_MN_Mahnomen",
  },
  {
    value: "ESRI:104744",
    label: "ESRI:104744 / GCS_NAD_1983_HARN_Adj_MN_Marshall",
  },
  {
    value: "ESRI:104745",
    label: "ESRI:104745 / GCS_NAD_1983_HARN_Adj_MN_Martin",
  },
  {
    value: "ESRI:104746",
    label: "ESRI:104746 / GCS_NAD_1983_HARN_Adj_MN_Meeker",
  },
  {
    value: "ESRI:104747",
    label: "ESRI:104747 / GCS_NAD_1983_HARN_Adj_MN_Morrison",
  },
  {
    value: "ESRI:104748",
    label: "ESRI:104748 / GCS_NAD_1983_HARN_Adj_MN_Mower",
  },
  {
    value: "ESRI:104749",
    label: "ESRI:104749 / GCS_NAD_1983_HARN_Adj_MN_Murray",
  },
  {
    value: "ESRI:104750",
    label: "ESRI:104750 / GCS_NAD_1983_HARN_Adj_MN_Nicollet",
  },
  {
    value: "ESRI:104751",
    label: "ESRI:104751 / GCS_NAD_1983_HARN_Adj_MN_Nobles",
  },
  {
    value: "ESRI:104752",
    label: "ESRI:104752 / GCS_NAD_1983_HARN_Adj_MN_Norman",
  },
  {
    value: "ESRI:104753",
    label: "ESRI:104753 / GCS_NAD_1983_HARN_Adj_MN_Olmsted",
  },
  {
    value: "ESRI:104754",
    label: "ESRI:104754 / GCS_NAD_1983_HARN_Adj_MN_Ottertail",
  },
  {
    value: "ESRI:104755",
    label: "ESRI:104755 / GCS_NAD_1983_HARN_Adj_MN_Pennington",
  },
  {
    value: "ESRI:104756",
    label: "ESRI:104756 / GCS_NAD_1983_HARN_Adj_MN_Pine",
  },
  {
    value: "ESRI:104757",
    label: "ESRI:104757 / GCS_NAD_1983_HARN_Adj_MN_Pipestone",
  },
  {
    value: "ESRI:104758",
    label: "ESRI:104758 / GCS_NAD_1983_HARN_Adj_MN_Polk",
  },
  {
    value: "ESRI:104759",
    label: "ESRI:104759 / GCS_NAD_1983_HARN_Adj_MN_Pope",
  },
  {
    value: "ESRI:104760",
    label: "ESRI:104760 / GCS_NAD_1983_HARN_Adj_MN_Ramsey",
  },
  {
    value: "ESRI:104761",
    label: "ESRI:104761 / GCS_NAD_1983_HARN_Adj_MN_Red_Lake",
  },
  {
    value: "ESRI:104762",
    label: "ESRI:104762 / GCS_NAD_1983_HARN_Adj_MN_Redwood",
  },
  {
    value: "ESRI:104763",
    label: "ESRI:104763 / GCS_NAD_1983_HARN_Adj_MN_Renville",
  },
  {
    value: "ESRI:104764",
    label: "ESRI:104764 / GCS_NAD_1983_HARN_Adj_MN_Rice",
  },
  {
    value: "ESRI:104765",
    label: "ESRI:104765 / GCS_NAD_1983_HARN_Adj_MN_Rock",
  },
  {
    value: "ESRI:104766",
    label: "ESRI:104766 / GCS_NAD_1983_HARN_Adj_MN_Roseau",
  },
  {
    value: "ESRI:104767",
    label: "ESRI:104767 / GCS_NAD_1983_HARN_Adj_MN_St_Louis_North",
  },
  {
    value: "ESRI:104768",
    label: "ESRI:104768 / GCS_NAD_1983_HARN_Adj_MN_St_Louis_Central",
  },
  {
    value: "ESRI:104769",
    label: "ESRI:104769 / GCS_NAD_1983_HARN_Adj_MN_St_Louis_South",
  },
  {
    value: "ESRI:104770",
    label: "ESRI:104770 / GCS_NAD_1983_HARN_Adj_MN_Scott",
  },
  {
    value: "ESRI:104771",
    label: "ESRI:104771 / GCS_NAD_1983_HARN_Adj_MN_Sherburne",
  },
  {
    value: "ESRI:104772",
    label: "ESRI:104772 / GCS_NAD_1983_HARN_Adj_MN_Sibley",
  },
  {
    value: "ESRI:104773",
    label: "ESRI:104773 / GCS_NAD_1983_HARN_Adj_MN_Stearns",
  },
  {
    value: "ESRI:104774",
    label: "ESRI:104774 / GCS_NAD_1983_HARN_Adj_MN_Steele",
  },
  {
    value: "ESRI:104775",
    label: "ESRI:104775 / GCS_NAD_1983_HARN_Adj_MN_Stevens",
  },
  {
    value: "ESRI:104776",
    label: "ESRI:104776 / GCS_NAD_1983_HARN_Adj_MN_Swift",
  },
  {
    value: "ESRI:104777",
    label: "ESRI:104777 / GCS_NAD_1983_HARN_Adj_MN_Todd",
  },
  {
    value: "ESRI:104778",
    label: "ESRI:104778 / GCS_NAD_1983_HARN_Adj_MN_Traverse",
  },
  {
    value: "ESRI:104779",
    label: "ESRI:104779 / GCS_NAD_1983_HARN_Adj_MN_Wabasha",
  },
  {
    value: "ESRI:104780",
    label: "ESRI:104780 / GCS_NAD_1983_HARN_Adj_MN_Wadena",
  },
  {
    value: "ESRI:104781",
    label: "ESRI:104781 / GCS_NAD_1983_HARN_Adj_MN_Waseca",
  },
  {
    value: "ESRI:104782",
    label: "ESRI:104782 / GCS_NAD_1983_HARN_Adj_MN_Watonwan",
  },
  {
    value: "ESRI:104783",
    label: "ESRI:104783 / GCS_NAD_1983_HARN_Adj_MN_Winona",
  },
  {
    value: "ESRI:104784",
    label: "ESRI:104784 / GCS_NAD_1983_HARN_Adj_MN_Wright",
  },
  {
    value: "ESRI:104785",
    label: "ESRI:104785 / GCS_NAD_1983_HARN_Adj_MN_Yellow_Medicine",
  },
  {
    value: "ESRI:104786",
    label: "ESRI:104786 / GCS_NAD_1983_HARN_Adj_MN_St_Louis",
  },
  {
    value: "ESRI:104800",
    label: "ESRI:104800 / GCS_NAD_1983_HARN_Adj_WI_Adams",
  },
  {
    value: "ESRI:104801",
    label: "ESRI:104801 / GCS_NAD_1983_HARN_Adj_WI_Ashland",
  },
  {
    value: "ESRI:104802",
    label: "ESRI:104802 / GCS_NAD_1983_HARN_Adj_WI_Barron",
  },
  {
    value: "ESRI:104803",
    label: "ESRI:104803 / GCS_NAD_1983_HARN_Adj_WI_Bayfield",
  },
  {
    value: "ESRI:104804",
    label: "ESRI:104804 / GCS_NAD_1983_HARN_Adj_WI_Brown",
  },
  {
    value: "ESRI:104805",
    label: "ESRI:104805 / GCS_NAD_1983_HARN_Adj_WI_Buffalo",
  },
  {
    value: "ESRI:104806",
    label: "ESRI:104806 / GCS_NAD_1983_HARN_Adj_WI_Burnett",
  },
  {
    value: "ESRI:104807",
    label: "ESRI:104807 / GCS_NAD_1983_HARN_Adj_WI_Calumet",
  },
  {
    value: "ESRI:104808",
    label: "ESRI:104808 / GCS_NAD_1983_HARN_Adj_WI_Chippewa",
  },
  {
    value: "ESRI:104809",
    label: "ESRI:104809 / GCS_NAD_1983_HARN_Adj_WI_Clark",
  },
  {
    value: "ESRI:104810",
    label: "ESRI:104810 / GCS_NAD_1983_HARN_Adj_WI_Columbia",
  },
  {
    value: "ESRI:104811",
    label: "ESRI:104811 / GCS_NAD_1983_HARN_Adj_WI_Crawford",
  },
  {
    value: "ESRI:104812",
    label: "ESRI:104812 / GCS_NAD_1983_HARN_Adj_WI_Dane",
  },
  {
    value: "ESRI:104813",
    label: "ESRI:104813 / GCS_NAD_1983_HARN_Adj_WI_Dodge",
  },
  {
    value: "ESRI:104814",
    label: "ESRI:104814 / GCS_NAD_1983_HARN_Adj_WI_Door",
  },
  {
    value: "ESRI:104815",
    label: "ESRI:104815 / GCS_NAD_1983_HARN_Adj_WI_Douglas",
  },
  {
    value: "ESRI:104816",
    label: "ESRI:104816 / GCS_NAD_1983_HARN_Adj_WI_Dunn",
  },
  {
    value: "ESRI:104817",
    label: "ESRI:104817 / GCS_NAD_1983_HARN_Adj_WI_EauClaire",
  },
  {
    value: "ESRI:104818",
    label: "ESRI:104818 / GCS_NAD_1983_HARN_Adj_WI_Florence",
  },
  {
    value: "ESRI:104819",
    label: "ESRI:104819 / GCS_NAD_1983_HARN_Adj_WI_FondduLac",
  },
  {
    value: "ESRI:104820",
    label: "ESRI:104820 / GCS_NAD_1983_HARN_Adj_WI_Forest",
  },
  {
    value: "ESRI:104821",
    label: "ESRI:104821 / GCS_NAD_1983_HARN_Adj_WI_Grant",
  },
  {
    value: "ESRI:104822",
    label: "ESRI:104822 / GCS_NAD_1983_HARN_Adj_WI_Green",
  },
  {
    value: "ESRI:104823",
    label: "ESRI:104823 / GCS_NAD_1983_HARN_Adj_WI_GreenLake",
  },
  {
    value: "ESRI:104824",
    label: "ESRI:104824 / GCS_NAD_1983_HARN_Adj_WI_Iowa",
  },
  {
    value: "ESRI:104825",
    label: "ESRI:104825 / GCS_NAD_1983_HARN_Adj_WI_Iron",
  },
  {
    value: "ESRI:104826",
    label: "ESRI:104826 / GCS_NAD_1983_HARN_Adj_WI_Jackson",
  },
  {
    value: "ESRI:104827",
    label: "ESRI:104827 / GCS_NAD_1983_HARN_Adj_WI_Jefferson",
  },
  {
    value: "ESRI:104828",
    label: "ESRI:104828 / GCS_NAD_1983_HARN_Adj_WI_Juneau",
  },
  {
    value: "ESRI:104829",
    label: "ESRI:104829 / GCS_NAD_1983_HARN_Adj_WI_Kenosha",
  },
  {
    value: "ESRI:104830",
    label: "ESRI:104830 / GCS_NAD_1983_HARN_Adj_WI_Kewaunee",
  },
  {
    value: "ESRI:104831",
    label: "ESRI:104831 / GCS_NAD_1983_HARN_Adj_WI_LaCrosse",
  },
  {
    value: "ESRI:104832",
    label: "ESRI:104832 / GCS_NAD_1983_HARN_Adj_WI_Lafayette",
  },
  {
    value: "ESRI:104833",
    label: "ESRI:104833 / GCS_NAD_1983_HARN_Adj_WI_Langlade",
  },
  {
    value: "ESRI:104834",
    label: "ESRI:104834 / GCS_NAD_1983_HARN_Adj_WI_Lincoln",
  },
  {
    value: "ESRI:104835",
    label: "ESRI:104835 / GCS_NAD_1983_HARN_Adj_WI_Manitowoc",
  },
  {
    value: "ESRI:104836",
    label: "ESRI:104836 / GCS_NAD_1983_HARN_Adj_WI_Marathon",
  },
  {
    value: "ESRI:104837",
    label: "ESRI:104837 / GCS_NAD_1983_HARN_Adj_WI_Marinette",
  },
  {
    value: "ESRI:104838",
    label: "ESRI:104838 / GCS_NAD_1983_HARN_Adj_WI_Marquette",
  },
  {
    value: "ESRI:104839",
    label: "ESRI:104839 / GCS_NAD_1983_HARN_Adj_WI_Menominee",
  },
  {
    value: "ESRI:104840",
    label: "ESRI:104840 / GCS_NAD_1983_HARN_Adj_WI_Milwaukee",
  },
  {
    value: "ESRI:104841",
    label: "ESRI:104841 / GCS_NAD_1983_HARN_Adj_WI_Monroe",
  },
  {
    value: "ESRI:104842",
    label: "ESRI:104842 / GCS_NAD_1983_HARN_Adj_WI_Oconto",
  },
  {
    value: "ESRI:104843",
    label: "ESRI:104843 / GCS_NAD_1983_HARN_Adj_WI_Oneida",
  },
  {
    value: "ESRI:104844",
    label: "ESRI:104844 / GCS_NAD_1983_HARN_Adj_WI_Outagamie",
  },
  {
    value: "ESRI:104845",
    label: "ESRI:104845 / GCS_NAD_1983_HARN_Adj_WI_Ozaukee",
  },
  {
    value: "ESRI:104846",
    label: "ESRI:104846 / GCS_NAD_1983_HARN_Adj_WI_Pepin",
  },
  {
    value: "ESRI:104847",
    label: "ESRI:104847 / GCS_NAD_1983_HARN_Adj_WI_Pierce",
  },
  {
    value: "ESRI:104848",
    label: "ESRI:104848 / GCS_NAD_1983_HARN_Adj_WI_Polk",
  },
  {
    value: "ESRI:104849",
    label: "ESRI:104849 / GCS_NAD_1983_HARN_Adj_WI_Portage",
  },
  {
    value: "ESRI:104850",
    label: "ESRI:104850 / GCS_NAD_1983_HARN_Adj_WI_Price",
  },
  {
    value: "ESRI:104851",
    label: "ESRI:104851 / GCS_NAD_1983_HARN_Adj_WI_Racine",
  },
  {
    value: "ESRI:104852",
    label: "ESRI:104852 / GCS_NAD_1983_HARN_Adj_WI_Richland",
  },
  {
    value: "ESRI:104853",
    label: "ESRI:104853 / GCS_NAD_1983_HARN_Adj_WI_Rock",
  },
  {
    value: "ESRI:104854",
    label: "ESRI:104854 / GCS_NAD_1983_HARN_Adj_WI_Rusk",
  },
  {
    value: "ESRI:104855",
    label: "ESRI:104855 / GCS_NAD_1983_HARN_Adj_WI_StCroix",
  },
  {
    value: "ESRI:104856",
    label: "ESRI:104856 / GCS_NAD_1983_HARN_Adj_WI_Sauk",
  },
  {
    value: "ESRI:104857",
    label: "ESRI:104857 / GCS_NAD_1983_HARN_Adj_WI_Sawyer",
  },
  {
    value: "ESRI:104858",
    label: "ESRI:104858 / GCS_NAD_1983_HARN_Adj_WI_Shawano",
  },
  {
    value: "ESRI:104859",
    label: "ESRI:104859 / GCS_NAD_1983_HARN_Adj_WI_Sheboygan",
  },
  {
    value: "ESRI:104860",
    label: "ESRI:104860 / GCS_NAD_1983_HARN_Adj_WI_Taylor",
  },
  {
    value: "ESRI:104861",
    label: "ESRI:104861 / GCS_NAD_1983_HARN_Adj_WI_Trempealeau",
  },
  {
    value: "ESRI:104862",
    label: "ESRI:104862 / GCS_NAD_1983_HARN_Adj_WI_Vernon",
  },
  {
    value: "ESRI:104863",
    label: "ESRI:104863 / GCS_NAD_1983_HARN_Adj_WI_Vilas",
  },
  {
    value: "ESRI:104864",
    label: "ESRI:104864 / GCS_NAD_1983_HARN_Adj_WI_Walworth",
  },
  {
    value: "ESRI:104865",
    label: "ESRI:104865 / GCS_NAD_1983_HARN_Adj_WI_Washburn",
  },
  {
    value: "ESRI:104866",
    label: "ESRI:104866 / GCS_NAD_1983_HARN_Adj_WI_Washington",
  },
  {
    value: "ESRI:104867",
    label: "ESRI:104867 / GCS_NAD_1983_HARN_Adj_WI_Waukesha",
  },
  {
    value: "ESRI:104868",
    label: "ESRI:104868 / GCS_NAD_1983_HARN_Adj_WI_Waupaca",
  },
  {
    value: "ESRI:104869",
    label: "ESRI:104869 / GCS_NAD_1983_HARN_Adj_WI_Waushara",
  },
  {
    value: "ESRI:104870",
    label: "ESRI:104870 / GCS_NAD_1983_HARN_Adj_WI_Winnebago",
  },
  {
    value: "ESRI:104871",
    label: "ESRI:104871 / GCS_NAD_1983_HARN_Adj_WI_Wood",
  },
  { value: "ESRI:104872", label: "ESRI:104872 / Phobos_2015" },
  { value: "ESRI:104873", label: "ESRI:104873 / Callisto_2015" },
  { value: "ESRI:104874", label: "ESRI:104874 / Europa_2015" },
  { value: "ESRI:104875", label: "ESRI:104875 / Ganymede_2015" },
  { value: "ESRI:104876", label: "ESRI:104876 / Io_2015" },
  { value: "ESRI:104877", label: "ESRI:104877 / Metis_2015" },
  { value: "ESRI:104878", label: "ESRI:104878 / Aegaeon_2015" },
  { value: "ESRI:104879", label: "ESRI:104879 / Anthe_2015" },
  { value: "ESRI:104896", label: "ESRI:104896 / GCS_ITRF_2005" },
  { value: "ESRI:104897", label: "ESRI:104897 / Pandora_2015" },
  { value: "ESRI:104898", label: "ESRI:104898 / Phoebe_2015" },
  { value: "ESRI:104899", label: "ESRI:104899 / Polydeuces_2015" },
  { value: "ESRI:104900", label: "ESRI:104900 / GCS_Mercury_2000" },
  { value: "ESRI:104901", label: "ESRI:104901 / GCS_Venus_1985" },
  { value: "ESRI:104902", label: "ESRI:104902 / GCS_Venus_2000" },
  { value: "ESRI:104903", label: "ESRI:104903 / GCS_Moon_2000" },
  { value: "ESRI:104904", label: "ESRI:104904 / GCS_Mars_1979" },
  { value: "ESRI:104905", label: "ESRI:104905 / GCS_Mars_2000" },
  { value: "ESRI:104906", label: "ESRI:104906 / GCS_Deimos_2000" },
  { value: "ESRI:104907", label: "ESRI:104907 / GCS_Phobos_2000" },
  { value: "ESRI:104908", label: "ESRI:104908 / GCS_Jupiter_2000" },
  { value: "ESRI:104909", label: "ESRI:104909 / GCS_Adrastea_2000" },
  { value: "ESRI:104910", label: "ESRI:104910 / GCS_Amalthea_2000" },
  { value: "ESRI:104911", label: "ESRI:104911 / GCS_Ananke_2000" },
  { value: "ESRI:104912", label: "ESRI:104912 / GCS_Callisto_2000" },
  { value: "ESRI:104913", label: "ESRI:104913 / GCS_Carme_2000" },
  { value: "ESRI:104914", label: "ESRI:104914 / GCS_Elara_2000" },
  { value: "ESRI:104915", label: "ESRI:104915 / GCS_Europa_2000" },
  { value: "ESRI:104916", label: "ESRI:104916 / GCS_Ganymede_2000" },
  { value: "ESRI:104917", label: "ESRI:104917 / GCS_Himalia_2000" },
  { value: "ESRI:104918", label: "ESRI:104918 / GCS_Io_2000" },
  { value: "ESRI:104919", label: "ESRI:104919 / GCS_Leda_2000" },
  { value: "ESRI:104920", label: "ESRI:104920 / GCS_Lysithea_2000" },
  { value: "ESRI:104921", label: "ESRI:104921 / GCS_Metis_2000" },
  { value: "ESRI:104922", label: "ESRI:104922 / GCS_Pasiphae_2000" },
  { value: "ESRI:104923", label: "ESRI:104923 / GCS_Sinope_2000" },
  { value: "ESRI:104924", label: "ESRI:104924 / GCS_Thebe_2000" },
  { value: "ESRI:104925", label: "ESRI:104925 / GCS_Saturn_2000" },
  { value: "ESRI:104926", label: "ESRI:104926 / GCS_Atlas_2000" },
  { value: "ESRI:104927", label: "ESRI:104927 / GCS_Calypso_2000" },
  { value: "ESRI:104928", label: "ESRI:104928 / GCS_Dione_2000" },
  { value: "ESRI:104929", label: "ESRI:104929 / GCS_Enceladus_2000" },
  { value: "ESRI:104930", label: "ESRI:104930 / GCS_Epimetheus_2000" },
  { value: "ESRI:104931", label: "ESRI:104931 / GCS_Helene_2000" },
  { value: "ESRI:104932", label: "ESRI:104932 / GCS_Hyperion_2000" },
  { value: "ESRI:104933", label: "ESRI:104933 / GCS_Iapetus_2000" },
  { value: "ESRI:104934", label: "ESRI:104934 / GCS_Janus_2000" },
  { value: "ESRI:104935", label: "ESRI:104935 / GCS_Mimas_2000" },
  { value: "ESRI:104936", label: "ESRI:104936 / GCS_Pan_2000" },
  { value: "ESRI:104937", label: "ESRI:104937 / GCS_Pandora_2000" },
  { value: "ESRI:104938", label: "ESRI:104938 / GCS_Phoebe_2000" },
  { value: "ESRI:104939", label: "ESRI:104939 / GCS_Prometheus_2000" },
  { value: "ESRI:104940", label: "ESRI:104940 / GCS_Rhea_2000" },
  { value: "ESRI:104941", label: "ESRI:104941 / GCS_Telesto_2000" },
  { value: "ESRI:104942", label: "ESRI:104942 / GCS_Tethys_2000" },
  { value: "ESRI:104943", label: "ESRI:104943 / GCS_Titan_2000" },
  { value: "ESRI:104944", label: "ESRI:104944 / GCS_Uranus_2000" },
  { value: "ESRI:104945", label: "ESRI:104945 / GCS_Ariel_2000" },
  { value: "ESRI:104946", label: "ESRI:104946 / GCS_Belinda_2000" },
  { value: "ESRI:104947", label: "ESRI:104947 / GCS_Bianca_2000" },
  { value: "ESRI:104948", label: "ESRI:104948 / GCS_Cordelia_2000" },
  { value: "ESRI:104949", label: "ESRI:104949 / GCS_Cressida_2000" },
  { value: "ESRI:104950", label: "ESRI:104950 / GCS_Desdemona_2000" },
  { value: "ESRI:104951", label: "ESRI:104951 / GCS_Juliet_2000" },
  { value: "ESRI:104952", label: "ESRI:104952 / GCS_Miranda_2000" },
  { value: "ESRI:104953", label: "ESRI:104953 / GCS_Oberon_2000" },
  { value: "ESRI:104954", label: "ESRI:104954 / GCS_Ophelia_2000" },
  { value: "ESRI:104955", label: "ESRI:104955 / GCS_Portia_2000" },
  { value: "ESRI:104956", label: "ESRI:104956 / GCS_Puck_2000" },
  { value: "ESRI:104957", label: "ESRI:104957 / GCS_Rosalind_2000" },
  { value: "ESRI:104958", label: "ESRI:104958 / GCS_Titania_2000" },
  { value: "ESRI:104959", label: "ESRI:104959 / GCS_Umbriel_2000" },
  { value: "ESRI:104960", label: "ESRI:104960 / GCS_Neptune_2000" },
  { value: "ESRI:104961", label: "ESRI:104961 / GCS_Despina_2000" },
  { value: "ESRI:104962", label: "ESRI:104962 / GCS_Galatea_2000" },
  { value: "ESRI:104963", label: "ESRI:104963 / GCS_Larissa_2000" },
  { value: "ESRI:104964", label: "ESRI:104964 / GCS_Naiad_2000" },
  { value: "ESRI:104965", label: "ESRI:104965 / GCS_Nereid_2000" },
  { value: "ESRI:104966", label: "ESRI:104966 / GCS_Proteus_2000" },
  { value: "ESRI:104967", label: "ESRI:104967 / GCS_Thalassa_2000" },
  { value: "ESRI:104968", label: "ESRI:104968 / GCS_Triton_2000" },
  { value: "ESRI:104969", label: "ESRI:104969 / GCS_Pluto_2000" },
  { value: "ESRI:104970", label: "ESRI:104970 / GCS_Charon_2000" },
  { value: "ESRI:104971", label: "ESRI:104971 / Mars_2000_(Sphere)" },
  { value: "ESRI:104972", label: "ESRI:104972 / 1_Ceres_2015" },
  { value: "ESRI:104973", label: "ESRI:104973 / 4_Vesta_2015" },
  { value: "ESRI:104974", label: "ESRI:104974 / Mercury_2015" },
  { value: "ESRI:104975", label: "ESRI:104975 / Sun_2015" },
  { value: "ESRI:104976", label: "ESRI:104976 / Atlas_2015" },
  { value: "ESRI:104977", label: "ESRI:104977 / Calypso_2015" },
  { value: "ESRI:104978", label: "ESRI:104978 / Daphnis_2015" },
  { value: "ESRI:104979", label: "ESRI:104979 / Dione_2015" },
  { value: "ESRI:104980", label: "ESRI:104980 / Enceladus_2015" },
  { value: "ESRI:104981", label: "ESRI:104981 / Epimetheus_2015" },
  { value: "ESRI:104982", label: "ESRI:104982 / Helene_2015" },
  { value: "ESRI:104983", label: "ESRI:104983 / Hyperion_2015" },
  { value: "ESRI:104984", label: "ESRI:104984 / Iapetus_2015" },
  { value: "ESRI:104985", label: "ESRI:104985 / Janus_2015" },
  { value: "ESRI:104986", label: "ESRI:104986 / Methone_2015" },
  { value: "ESRI:104987", label: "ESRI:104987 / Mimas_2015" },
  { value: "ESRI:104988", label: "ESRI:104988 / Pallene_2015" },
  { value: "ESRI:104989", label: "ESRI:104989 / Pan_2015" },
  { value: "ESRI:104990", label: "ESRI:104990 / GCS_HD1909" },
  { value: "ESRI:104991", label: "ESRI:104991 / GCS_IGRS" },
  { value: "ESRI:104992", label: "ESRI:104992 / GCS_MGI_1901" },
  { value: "ESRI:104993", label: "ESRI:104993 / Prometheus_2015" },
  { value: "ESRI:104994", label: "ESRI:104994 / Rhea_2015" },
  { value: "ESRI:104995", label: "ESRI:104995 / Telesto_2015" },
  { value: "ESRI:104996", label: "ESRI:104996 / Tethys_2015" },
  { value: "ESRI:104997", label: "ESRI:104997 / Larissa_2015" },
  { value: "ESRI:104998", label: "ESRI:104998 / Pluto_2015" },
  { value: "ESRI:104999", label: "ESRI:104999 / Charon_2015" },
  {
    value: "IAU_2015:1000",
    label: "IAU_2015:1000 / Sun (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:19900",
    label: "IAU_2015:19900 / Mercury (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:19901",
    label: "IAU_2015:19901 / Mercury (2015) / Ographic",
  },
  {
    value: "IAU_2015:19902",
    label: "IAU_2015:19902 / Mercury (2015) / Ocentric",
  },
  {
    value: "IAU_2015:29900",
    label: "IAU_2015:29900 / Venus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:30100",
    label: "IAU_2015:30100 / Moon (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:39900",
    label: "IAU_2015:39900 / Earth (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:39901",
    label: "IAU_2015:39901 / Earth (2015) / Ographic",
  },
  {
    value: "IAU_2015:39902",
    label: "IAU_2015:39902 / Earth (2015) / Ocentric",
  },
  {
    value: "IAU_2015:40100",
    label: "IAU_2015:40100 / Phobos (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:40200",
    label: "IAU_2015:40200 / Deimos (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:49900",
    label: "IAU_2015:49900 / Mars (2015) - Sphere / Ocentric",
  },
  { value: "IAU_2015:49901", label: "IAU_2015:49901 / Mars (2015) / Ographic" },
  { value: "IAU_2015:49902", label: "IAU_2015:49902 / Mars (2015) / Ocentric" },
  {
    value: "IAU_2015:50100",
    label: "IAU_2015:50100 / Io (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50200",
    label: "IAU_2015:50200 / Europa (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50300",
    label: "IAU_2015:50300 / Ganymede (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50301",
    label: "IAU_2015:50301 / Ganymede (2015) / Ographic",
  },
  {
    value: "IAU_2015:50400",
    label: "IAU_2015:50400 / Callisto (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50401",
    label: "IAU_2015:50401 / Callisto (2015) / Ographic",
  },
  {
    value: "IAU_2015:50500",
    label: "IAU_2015:50500 / Amalthea (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50600",
    label: "IAU_2015:50600 / Himalia (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50700",
    label: "IAU_2015:50700 / Elara (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50800",
    label: "IAU_2015:50800 / Pasiphae (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:50900",
    label: "IAU_2015:50900 / Sinope (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51000",
    label: "IAU_2015:51000 / Lysithea (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51100",
    label: "IAU_2015:51100 / Carme (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51200",
    label: "IAU_2015:51200 / Ananke (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51300",
    label: "IAU_2015:51300 / Leda (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51400",
    label: "IAU_2015:51400 / Thebe (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51500",
    label: "IAU_2015:51500 / Adrastea (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:51600",
    label: "IAU_2015:51600 / Metis (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:59900",
    label: "IAU_2015:59900 / Jupiter (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:59901",
    label: "IAU_2015:59901 / Jupiter (2015) / Ographic",
  },
  {
    value: "IAU_2015:59902",
    label: "IAU_2015:59902 / Jupiter (2015) / Ocentric",
  },
  {
    value: "IAU_2015:60100",
    label: "IAU_2015:60100 / Mimas (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60200",
    label: "IAU_2015:60200 / Enceladus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60300",
    label: "IAU_2015:60300 / Tethys (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60400",
    label: "IAU_2015:60400 / Dione (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60500",
    label: "IAU_2015:60500 / Rhea (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60600",
    label: "IAU_2015:60600 / Titan (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60700",
    label: "IAU_2015:60700 / Hyperion (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60800",
    label: "IAU_2015:60800 / Iapetus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:60801",
    label: "IAU_2015:60801 / Iapetus (2015) / Ographic",
  },
  {
    value: "IAU_2015:60802",
    label: "IAU_2015:60802 / Iapetus (2015) / Ocentric",
  },
  {
    value: "IAU_2015:60900",
    label: "IAU_2015:60900 / Phoebe (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61000",
    label: "IAU_2015:61000 / Janus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61100",
    label: "IAU_2015:61100 / Epimetheus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61200",
    label: "IAU_2015:61200 / Helene (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61300",
    label: "IAU_2015:61300 / Telesto (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61400",
    label: "IAU_2015:61400 / Calypso (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61500",
    label: "IAU_2015:61500 / Atlas (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61600",
    label: "IAU_2015:61600 / Prometheus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61700",
    label: "IAU_2015:61700 / Pandora (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:61800",
    label: "IAU_2015:61800 / Pan (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:63200",
    label: "IAU_2015:63200 / Methone (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:63300",
    label: "IAU_2015:63300 / Pallene (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:63400",
    label: "IAU_2015:63400 / Polydeuces (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:63500",
    label: "IAU_2015:63500 / Daphnis (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:64900",
    label: "IAU_2015:64900 / Anthe (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:65300",
    label: "IAU_2015:65300 / Aegaeon (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:69900",
    label: "IAU_2015:69900 / Saturn (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:69901",
    label: "IAU_2015:69901 / Saturn (2015) / Ographic",
  },
  {
    value: "IAU_2015:69902",
    label: "IAU_2015:69902 / Saturn (2015) / Ocentric",
  },
  {
    value: "IAU_2015:70100",
    label: "IAU_2015:70100 / Ariel (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70200",
    label: "IAU_2015:70200 / Umbriel (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70300",
    label: "IAU_2015:70300 / Titania (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70400",
    label: "IAU_2015:70400 / Oberon (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70500",
    label: "IAU_2015:70500 / Miranda (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70600",
    label: "IAU_2015:70600 / Cordelia (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70700",
    label: "IAU_2015:70700 / Ophelia (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70800",
    label: "IAU_2015:70800 / Bianca (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:70900",
    label: "IAU_2015:70900 / Cressida (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71000",
    label: "IAU_2015:71000 / Desdemona (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71100",
    label: "IAU_2015:71100 / Juliet (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71200",
    label: "IAU_2015:71200 / Portia (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71300",
    label: "IAU_2015:71300 / Rosalind (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71400",
    label: "IAU_2015:71400 / Belinda (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:71500",
    label: "IAU_2015:71500 / Puck (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:79900",
    label: "IAU_2015:79900 / Uranus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:79901",
    label: "IAU_2015:79901 / Uranus (2015) / Ographic",
  },
  {
    value: "IAU_2015:79902",
    label: "IAU_2015:79902 / Uranus (2015) / Ocentric",
  },
  {
    value: "IAU_2015:80100",
    label: "IAU_2015:80100 / Triton (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80200",
    label: "IAU_2015:80200 / Nereid (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80300",
    label: "IAU_2015:80300 / Naiad (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80301",
    label: "IAU_2015:80301 / Naiad (2015) / Ographic",
  },
  {
    value: "IAU_2015:80400",
    label: "IAU_2015:80400 / Thalassa (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80401",
    label: "IAU_2015:80401 / Thalassa (2015) / Ographic",
  },
  {
    value: "IAU_2015:80500",
    label: "IAU_2015:80500 / Despina (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80501",
    label: "IAU_2015:80501 / Despina (2015) / Ographic",
  },
  {
    value: "IAU_2015:80600",
    label: "IAU_2015:80600 / Galatea (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80601",
    label: "IAU_2015:80601 / Galatea (2015) / Ographic",
  },
  {
    value: "IAU_2015:80700",
    label: "IAU_2015:80700 / Larissa (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:80701",
    label: "IAU_2015:80701 / Larissa (2015) / Ographic",
  },
  {
    value: "IAU_2015:80702",
    label: "IAU_2015:80702 / Larissa (2015) / Ocentric",
  },
  {
    value: "IAU_2015:80800",
    label: "IAU_2015:80800 / Proteus (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:89900",
    label: "IAU_2015:89900 / Neptune (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:89901",
    label: "IAU_2015:89901 / Neptune (2015) / Ographic",
  },
  {
    value: "IAU_2015:89902",
    label: "IAU_2015:89902 / Neptune (2015) / Ocentric",
  },
  {
    value: "IAU_2015:90100",
    label: "IAU_2015:90100 / Charon (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:99900",
    label: "IAU_2015:99900 / Pluto (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100000500",
    label: "IAU_2015:100000500 / Borrelly (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100001200",
    label:
      "IAU_2015:100001200 / Churyumov-Gerasimenko (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100003600",
    label: "IAU_2015:100003600 / Halley (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100003601",
    label: "IAU_2015:100003601 / Halley (2015) / Ographic",
  },
  {
    value: "IAU_2015:100003602",
    label: "IAU_2015:100003602 / Halley (2015) / Ocentric",
  },
  {
    value: "IAU_2015:100004100",
    label: "IAU_2015:100004100 / Hartley 2 (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100009300",
    label: "IAU_2015:100009300 / Tempel 1 (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:100010700",
    label: "IAU_2015:100010700 / Wild 2 (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200000100",
    label: "IAU_2015:200000100 / Ceres (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200000101",
    label: "IAU_2015:200000101 / Ceres (2015) / Ographic",
  },
  {
    value: "IAU_2015:200000102",
    label: "IAU_2015:200000102 / Ceres (2015) / Ocentric",
  },
  {
    value: "IAU_2015:200000400",
    label: "IAU_2015:200000400 / Vesta (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200001600",
    label: "IAU_2015:200001600 / Psyche (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200002100",
    label: "IAU_2015:200002100 / Lutetia (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200005200",
    label: "IAU_2015:200005200 / 52 Europa (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200021600",
    label: "IAU_2015:200021600 / Kleopatra (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200025300",
    label: "IAU_2015:200025300 / Mathilde (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200043300",
    label: "IAU_2015:200043300 / Eros (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200043301",
    label: "IAU_2015:200043301 / Eros (2015) / Ographic",
  },
  {
    value: "IAU_2015:200043302",
    label: "IAU_2015:200043302 / Eros (2015) / Ocentric",
  },
  {
    value: "IAU_2015:200051100",
    label: "IAU_2015:200051100 / Davida (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200286700",
    label: "IAU_2015:200286700 / Steins (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:200417900",
    label: "IAU_2015:200417900 / Toutatis (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:202514300",
    label: "IAU_2015:202514300 / Itokawa (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:243101000",
    label: "IAU_2015:243101000 / Ida (2015) - Sphere / Ocentric",
  },
  {
    value: "IAU_2015:951101000",
    label: "IAU_2015:951101000 / Gaspra (2015) - Sphere / Ocentric",
  },
  {
    value: "IGNF:AMANU49",
    label: "IGNF:AMANU49 / Amanu NGT 1949 cartesiennes geocentriques",
  },
  {
    value: "IGNF:AMANU49G",
    label: "IGNF:AMANU49G / Amanu (NGT 1949) geographiques (dms)",
  },
  {
    value: "IGNF:AMANU63",
    label: "IGNF:AMANU63 / Amanu MHPF 1963 cartesiennes geocent.",
  },
  {
    value: "IGNF:AMANU63G",
    label: "IGNF:AMANU63G / Amanu (MHPF 1963) geographiques (dms)",
  },
  {
    value: "IGNF:AMST63",
    label: "IGNF:AMST63 / Ile Amsterdam 1963 cartesiennes geocentriques",
  },
  {
    value: "IGNF:AMST63G",
    label: "IGNF:AMST63G / Amsterdam 1963 geographiques (dms)",
  },
  {
    value: "IGNF:AMST63GEO",
    label: "IGNF:AMST63GEO / Ile Amsterdam 1963 geographiques (dms)",
  },
  {
    value: "IGNF:ANAA47",
    label: "IGNF:ANAA47 / Anaa SHM 1947 cartesiennes geocentriques",
  },
  {
    value: "IGNF:ANAA47G",
    label: "IGNF:ANAA47G / Anaa (SHM 1947) geographiques (dms)",
  },
  {
    value: "IGNF:ANAA92",
    label: "IGNF:ANAA92 / Anaa (MOP92) cartesiennes geocentriques",
  },
  {
    value: "IGNF:ANAA92G",
    label: "IGNF:ANAA92G / Anaa (MOP92) geographiques (dms)",
  },
  {
    value: "IGNF:ANAA92GEO",
    label: "IGNF:ANAA92GEO / Anaa (MOP92) geographiques (dms)",
  },
  {
    value: "IGNF:APAT48",
    label: "IGNF:APAT48 / Apataki MGT 1948 cartesiennes geocentriques",
  },
  {
    value: "IGNF:APAT48G",
    label: "IGNF:APAT48G / Apataki (MGT 1948) geographiques (dms)",
  },
  {
    value: "IGNF:APAT49",
    label: "IGNF:APAT49 / Apataki FG 1949 cartesiennes geocentriques",
  },
  {
    value: "IGNF:APAT49G",
    label: "IGNF:APAT49G / Apataki (FG 1949) geographiques (dms)",
  },
  {
    value: "IGNF:APAT80",
    label: "IGNF:APAT80 / Apataki Cadastre 1980 cartesiennes geocentriques",
  },
  {
    value: "IGNF:APAT80G",
    label: "IGNF:APAT80G / Apataki (Cadastre 1980) geographiques (dms)",
  },
  { value: "IGNF:APAT86", label: "IGNF:APAT86 / TUAMOTU (MOP86) CARTESIENNES" },
  {
    value: "IGNF:APAT86G",
    label: "IGNF:APAT86G / Tuamotu (MOP86) geographiques (dms)",
  },
  { value: "IGNF:ATI", label: "IGNF:ATI / ATIG cartesiennes geocentriques" },
  { value: "IGNF:ATIG", label: "IGNF:ATIG / ATIG cartesiennes geocentriques" },
  {
    value: "IGNF:ATIGG",
    label: "IGNF:ATIGG / ATIG geographiques grades Paris (gr)",
  },
  {
    value: "IGNF:ATUO63",
    label: "IGNF:ATUO63 / Hiva Oa Tahuata Motohani IGN 1963 cartesiennes",
  },
  {
    value: "IGNF:ATUO63G",
    label: "IGNF:ATUO63G / IGN 1963 geographiques (dms)",
  },
  {
    value: "IGNF:BIEN55",
    label: "IGNF:BIEN55 / Cap Bienvenue - Perroud 1955 cartesiennes",
  },
  {
    value: "IGNF:BIEN55G",
    label: "IGNF:BIEN55G / Cap Bienvenue geographiques (dms)",
  },
  {
    value: "IGNF:C67I95",
    label: "IGNF:C67I95 / CSG67 (IGN 1995) CARTESIENNES GEOCENTRIQUES",
  },
  {
    value: "IGNF:C67IG95G",
    label: "IGNF:C67IG95G / CSG67 (IGN 1995) geographiques (dms)",
  },
  {
    value: "IGNF:CAD97",
    label: "IGNF:CAD97 / Cadastre 1997 cartesiennes geocentriques",
  },
  {
    value: "IGNF:CAD97G",
    label: "IGNF:CAD97G / Cadastre 1997 geographiques (dms)",
  },
  {
    value: "IGNF:CAD97GEO",
    label: "IGNF:CAD97GEO / Cadastre 1997 geographiques (dms)",
  },
  {
    value: "IGNF:CADA80",
    label: "IGNF:CADA80 / Apataki Cadastre 1980 cartesiennes geocentriques",
  },
  {
    value: "IGNF:CADA80G",
    label: "IGNF:CADA80G / Apataki (Cadastre 1980) geographiques (dms)",
  },
  {
    value: "IGNF:CAPBP55",
    label: "IGNF:CAPBP55 / Cap Bienvenue - Perroud 1955 cartesiennes",
  },
  {
    value: "IGNF:CAPBP55G",
    label: "IGNF:CAPBP55G / Cap Bienvenue geographiques (dms)",
  },
  {
    value: "IGNF:CAPJP55",
    label: "IGNF:CAPJP55 / Cap Jules - Perroud 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:CAPJP55G",
    label: "IGNF:CAPJP55G / Cap Jules geographiques (dms)",
  },
  {
    value: "IGNF:CLIP67",
    label: "IGNF:CLIP67 / Clipperton (Marine 1967) cartesiennes geocent.",
  },
  {
    value: "IGNF:CLIP67G",
    label: "IGNF:CLIP67G / Clipperton 1967 geographiques (dms)",
  },
  {
    value: "IGNF:CROZ63",
    label: "IGNF:CROZ63 / Crozet-Possession 1963 cartesiennes geocent.",
  },
  {
    value: "IGNF:CROZ63G",
    label: "IGNF:CROZ63G / Crozet Possession 1963 geographiques (dms)",
  },
  {
    value: "IGNF:CROZ63GEO",
    label: "IGNF:CROZ63GEO / Crozet - Possession 1963 geographiques (dms)",
  },
  {
    value: "IGNF:CSG67",
    label: "IGNF:CSG67 / CSG 1967 cartesiennes geocentriques",
  },
  { value: "IGNF:CSG67G", label: "IGNF:CSG67G / CSG67 geographiques (dms)" },
  {
    value: "IGNF:CSG67GEO",
    label: "IGNF:CSG67GEO / CSG67 geographiques (dms)",
  },
  { value: "IGNF:ED50", label: "IGNF:ED50 / ED50 CARTESIENNES GEOCENTRIQUES" },
  { value: "IGNF:ED50G", label: "IGNF:ED50G / ED50 geographiques (dms)" },
  { value: "IGNF:ED50GEO", label: "IGNF:ED50GEO / ED50 geographiques (dms)" },
  {
    value: "IGNF:EFATE57",
    label: "IGNF:EFATE57 / Efate - IGN 1957 cartesiennes geocentriques",
  },
  {
    value: "IGNF:EFATE57G",
    label: "IGNF:EFATE57G / Efate geographiques (dms)",
  },
  {
    value: "IGNF:EFATE57GEO",
    label: "IGNF:EFATE57GEO / Efate geographiques (dms)",
  },
  {
    value: "IGNF:ETRS89",
    label: "IGNF:ETRS89 / ETRS89 cartesiennes geocentriques",
  },
  { value: "IGNF:ETRS89G", label: "IGNF:ETRS89G / ETRS89 geographiques (dms)" },
  {
    value: "IGNF:ETRS89GEO",
    label: "IGNF:ETRS89GEO / ETRS89 geographiques (dms)",
  },
  {
    value: "IGNF:EUROPA54",
    label: "IGNF:EUROPA54 / Europa MHM 1954 cartesiennes geocentriques",
  },
  {
    value: "IGNF:EUROPA54G",
    label: "IGNF:EUROPA54G / Europa geographiques (dms)",
  },
  {
    value: "IGNF:FAKA50",
    label: "IGNF:FAKA50 / Fakarava SHM 1947-1950 cartesiennes",
  },
  {
    value: "IGNF:FAKA50G",
    label: "IGNF:FAKA50G / Fakarava (SHM 1947-1950) geographiques (dms)",
  },
  {
    value: "IGNF:FANG651G",
    label: "IGNF:FANG651G / Fangataufa (MHPF 1965-1) geographiques (dms)",
  },
  {
    value: "IGNF:FANG652G",
    label: "IGNF:FANG652G / Fangataufa (MHPF 1965-2) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA50",
    label: "IGNF:FANGA50 / Fangataufa MGT 1950 cartesiennes geocentriques",
  },
  {
    value: "IGNF:FANGA50G",
    label: "IGNF:FANGA50G / Fangataufa (MGT 1950) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA64",
    label: "IGNF:FANGA64 / Fangataufa MHPF 1964 cartesiennes geocentriques",
  },
  {
    value: "IGNF:FANGA64G",
    label: "IGNF:FANGA64G / Fangataufa (MHPF 1964) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA651",
    label: "IGNF:FANGA651 / Fangataufa MHPF 1965-1 cartesiennes geocent.",
  },
  {
    value: "IGNF:FANGA651G",
    label: "IGNF:FANGA651G / Fangataufa (MHPF 1965-1) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA652",
    label: "IGNF:FANGA652 / Fangataufa MHPF 1965-2 cartesiennes geocent.",
  },
  {
    value: "IGNF:FANGA652G",
    label: "IGNF:FANGA652G / Fangataufa (MHPF 1965-2) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA66",
    label: "IGNF:FANGA66 / Fangataufa MHPF 1966 cartesiennes geocentriques",
  },
  {
    value: "IGNF:FANGA66G",
    label: "IGNF:FANGA66G / Fangataufa (MHPF 1966) geographiques (dms)",
  },
  {
    value: "IGNF:FANGA84",
    label: "IGNF:FANGA84 / Fangataufa MOP 1984 cartesiennes geocentriques",
  },
  {
    value: "IGNF:FANGA84G",
    label: "IGNF:FANGA84G / Fangataufa (MOP84) geographiques (dms)",
  },
  {
    value: "IGNF:FATU55",
    label: "IGNF:FATU55 / Fatu Huku MHEFO 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:FATU55FG",
    label: "IGNF:FATU55FG / Fatu Huku (MHEFO 1955) geographiques (dms)",
  },
  {
    value: "IGNF:GLOR77CAR",
    label: "IGNF:GLOR77CAR / Glorieuses (MHG 1977) cartesiennes geocent.",
  },
  {
    value: "IGNF:GLOR77G",
    label: "IGNF:GLOR77G / Glorieuses geographiques (dms)",
  },
  {
    value: "IGNF:GLOR77MHG",
    label: "IGNF:GLOR77MHG / Glorieuses (MHG 1977) cartesiennes geocent.",
  },
  {
    value: "IGNF:GTN51",
    label: "IGNF:GTN51 / GOMEN TERME NORD 1951 CARTESIENNES",
  },
  {
    value: "IGNF:GTN51G",
    label: "IGNF:GTN51G / Gomen Terme Nord 1951 geographiques (dms)",
  },
  {
    value: "IGNF:GUAD48",
    label: "IGNF:GUAD48 / Guadeloupe Sainte-Anne cartesiennes",
  },
  {
    value: "IGNF:GUAD48G",
    label: "IGNF:GUAD48G / Guadeloupe Sainte-Anne geographiques (dms)",
  },
  {
    value: "IGNF:GUAD48GEO",
    label: "IGNF:GUAD48GEO / Guadeloupe Sainte-Anne geographiques (dms)",
  },
  {
    value: "IGNF:GUADANN",
    label: "IGNF:GUADANN / Guadeloupe Sainte-Anne cartesiennes",
  },
  {
    value: "IGNF:GUADANNG",
    label: "IGNF:GUADANNG / Guadeloupe Sainte-Anne geographiques (dms)",
  },
  {
    value: "IGNF:GUADFM",
    label: "IGNF:GUADFM / Guadeloupe Fort Marigot cartesiennes geocent.",
  },
  {
    value: "IGNF:GUADFM49",
    label: "IGNF:GUADFM49 / Guadeloupe Fort Marigot cartesiennes geocent.",
  },
  {
    value: "IGNF:GUADFM49GEO",
    label: "IGNF:GUADFM49GEO / Guadeloupe Fort-Marigot geographiques (dms)",
  },
  {
    value: "IGNF:GUADFMG",
    label: "IGNF:GUADFMG / Guadeloupe Fort-Marigot geographiques (dms)",
  },
  {
    value: "IGNF:GUAFM48G",
    label: "IGNF:GUAFM48G / Guadeloupe Fort-Marigot geographiques (dms)",
  },
  {
    value: "IGNF:HAO49",
    label: "IGNF:HAO49 / Hao MGT 1949 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HAO49G",
    label: "IGNF:HAO49G / Hao (MGT 1949) geographiques (dms)",
  },
  {
    value: "IGNF:HAO58",
    label: "IGNF:HAO58 / Hao MHPF 1958 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HAO58G",
    label: "IGNF:HAO58G / Hao (MHPF 1958) geographiques (dms)",
  },
  {
    value: "IGNF:HAO67",
    label: "IGNF:HAO67 / Hao Amanu MHPF 1967 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HAOAM67",
    label: "IGNF:HAOAM67 / Hao Amanu MHPF 1967 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HAOAM67G",
    label: "IGNF:HAOAM67G / Hao Amanu (MHPF 1967) geographiques (dms)",
  },
  {
    value: "IGNF:HAOAMA67G",
    label: "IGNF:HAOAMA67G / Hao Amanu (MHPF 1967) geographiques (dms)",
  },
  {
    value: "IGNF:HARA49",
    label: "IGNF:HARA49 / Haraiki SHM 1949 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HARA49G",
    label: "IGNF:HARA49G / Haraiki (SHM 1949) geographiques (dms)",
  },
  {
    value: "IGNF:HIKU50",
    label: "IGNF:HIKU50 / Hikureu SHM 1947-1950 cartesiennes",
  },
  {
    value: "IGNF:HIKU50G",
    label: "IGNF:HIKU50G / Hikueru (SHM 1947-1950) geographiques (dms)",
  },
  {
    value: "IGNF:HIVA60",
    label: "IGNF:HIVA60 / Hiva Oa MHPF 1960 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HIVA60G",
    label: "IGNF:HIVA60G / Hiva Oa (MHPF 1960) geographiques (dms)",
  },
  {
    value: "IGNF:HIVA67",
    label: "IGNF:HIVA67 / Hiva Oa MHPF 1967 cartesiennes geocentriques",
  },
  {
    value: "IGNF:HIVA67G",
    label: "IGNF:HIVA67G / Hiva Oa (MHPF 1967) geographiques (dms)",
  },
  {
    value: "IGNF:IGN63",
    label: "IGNF:IGN63 / Hiva Oa Tahuata Motohani IGN 1963 cartesiennes",
  },
  { value: "IGNF:IGN63G", label: "IGNF:IGN63G / IGN 1963 geographiques (dms)" },
  {
    value: "IGNF:IGN63GEO",
    label: "IGNF:IGN63GEO / IGN63 geographiques (dms)",
  },
  {
    value: "IGNF:IGN72",
    label: "IGNF:IGN72 / Grande Terre - Ile des Pins IGN 72 cartesiennes",
  },
  { value: "IGNF:IGN72G", label: "IGNF:IGN72G / IGN72 geographiques (dms)" },
  {
    value: "IGNF:IGN72GEO",
    label: "IGNF:IGN72GEO / IGN72 geographiques (dms)",
  },
  {
    value: "IGNF:JULES55",
    label: "IGNF:JULES55 / Cap Jules - Perroud 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:JULES55G",
    label: "IGNF:JULES55G / Cap Jules geographiques (dms)",
  },
  {
    value: "IGNF:KAUE70",
    label: "IGNF:KAUE70 / Kauehi MHPF70 cartesiennes geocentriques",
  },
  {
    value: "IGNF:KAUE70G",
    label: "IGNF:KAUE70G / Kauehi (MHPF70) geographiques (dms)",
  },
  {
    value: "IGNF:KERG62CAR",
    label: "IGNF:KERG62CAR / Kerguelen - K0 IGN 1962 cartesiennes geocent.",
  },
  {
    value: "IGNF:KERG62G",
    label: "IGNF:KERG62G / Kerguelen geographiques (dms)",
  },
  {
    value: "IGNF:KERG62GEO",
    label: "IGNF:KERG62GEO / Kerguelen - K0 geographiques (dms)",
  },
  {
    value: "IGNF:KERG62K0",
    label: "IGNF:KERG62K0 / Kerguelen - K0 IGN 1962 cartesiennes geocent.",
  },
  {
    value: "IGNF:LIFOU56",
    label: "IGNF:LIFOU56 / Lifou IGN 1956 cartesiennes geocentriques",
  },
  {
    value: "IGNF:LIFOU56G",
    label: "IGNF:LIFOU56G / Lifou IGN 56 geographiques (dms)",
  },
  {
    value: "IGNF:LNGPGG",
    label: "IGNF:LNGPGG / Lambert Nord de Guerre grades Paris",
  },
  {
    value: "IGNF:LUREF",
    label: "IGNF:LUREF / Nouvelle Triangulation Luxembourg cartesiennes",
  },
  {
    value: "IGNF:LURES",
    label: "IGNF:LURES / Nouvelle Triangulation Luxembourg cartesiennes",
  },
  {
    value: "IGNF:LURESG",
    label:
      "IGNF:LURESG / NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:LUXGEO",
    label:
      "IGNF:LUXGEO / NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:MAKE50",
    label: "IGNF:MAKE50 / Makemo SHM 1947-1950 cartesiennes",
  },
  {
    value: "IGNF:MAKE50G",
    label: "IGNF:MAKE50G / Makemo (SHM 1947-1950) geographiques (dms)",
  },
  {
    value: "IGNF:MANGA51",
    label: "IGNF:MANGA51 / Mangareva 1951 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MANGA51G",
    label: "IGNF:MANGA51G / Mangareva 1951 geographiques (dms)",
  },
  {
    value: "IGNF:MARE53",
    label: "IGNF:MARE53 / Mare IGN 1953 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MARE53G",
    label: "IGNF:MARE53G / Mare IGN53 geographiques (dms)",
  },
  {
    value: "IGNF:MARQUI72",
    label: "IGNF:MARQUI72 / Eiao Hiva Oa Motohani cartesiennes geocent.",
  },
  {
    value: "IGNF:MARQUI72G",
    label: "IGNF:MARQUI72G / Marquises (IGN72) geographiques (dms)",
  },
  {
    value: "IGNF:MART38",
    label: "IGNF:MART38 / Martinique Fort-Desaix cartesiennes",
  },
  {
    value: "IGNF:MART38G",
    label: "IGNF:MART38G / Martinique Fort-Desaix geographiques (dms)",
  },
  {
    value: "IGNF:MART38GEO",
    label: "IGNF:MART38GEO / Martinique Fort-Desaix geographiques (dms)",
  },
  {
    value: "IGNF:MARTFD",
    label: "IGNF:MARTFD / Martinique Fort-Desaix cartesiennes",
  },
  {
    value: "IGNF:MARTFDG",
    label: "IGNF:MARTFDG / Martinique Fort-Desaix geographiques (dms)",
  },
  {
    value: "IGNF:MAUPITI",
    label: "IGNF:MAUPITI / Maupiti MOP 1983 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MAUPITIG",
    label: "IGNF:MAUPITIG / Maupiti (MOP 1983) geographiques (dms)",
  },
  { value: "IGNF:MAYO50", label: "IGNF:MAYO50 / Combani cartesiennes" },
  {
    value: "IGNF:MAYO50G",
    label: "IGNF:MAYO50G / Combani triangulation IGN 1950 geographiques (dms)",
  },
  {
    value: "IGNF:MAYO50GEO",
    label: "IGNF:MAYO50GEO / Combani geographiques (dms)",
  },
  {
    value: "IGNF:MHEFO55F",
    label: "IGNF:MHEFO55F / Fatu Huku MHEFO 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:MHEFO55FG",
    label: "IGNF:MHEFO55FG / Fatu Huku (MHEFO 1955) geographiques (dms)",
  },
  {
    value: "IGNF:MHEFO55M",
    label: "IGNF:MHEFO55M / Mohotani MHEFO 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:MHEFO55MG",
    label: "IGNF:MHEFO55MG / Mohotani (MHEFO 1955) geographiques (dms)",
  },
  {
    value: "IGNF:MHPF67",
    label: "IGNF:MHPF67 / Gambier MHPF 1967 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MHPF67G",
    label: "IGNF:MHPF67G / MHPF 1967 GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:MOHO55",
    label: "IGNF:MOHO55 / Mohotani MHEFO 1955 cartesiennes geocent.",
  },
  {
    value: "IGNF:MOHO55G",
    label: "IGNF:MOHO55G / Mohotani (MHEFO 1955) geographiques (dms)",
  },
  {
    value: "IGNF:MOOREA87",
    label: "IGNF:MOOREA87 / MOOREA 1987 CARTESIENNES GEOCENTRIQUES",
  },
  {
    value: "IGNF:MOOREA87G",
    label: "IGNF:MOOREA87G / Moorea 1987 geographiques (dms)",
  },
  {
    value: "IGNF:MOOREA87GEO",
    label: "IGNF:MOOREA87GEO / Moorea 1987 geographiques (dms)",
  },
  { value: "IGNF:MOP90", label: "IGNF:MOP90 / Tetiaroa (MOP90) cartesiennes" },
  {
    value: "IGNF:MOP90G",
    label: "IGNF:MOP90G / Tetiaroa (MOP90) geographiques (dms)",
  },
  {
    value: "IGNF:MURU51",
    label: "IGNF:MURU51 / Mururoa MGT 1951 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MURU51G",
    label: "IGNF:MURU51G / Mururoa (MGT 1951) geographiques (dms)",
  },
  {
    value: "IGNF:MURU59",
    label: "IGNF:MURU59 / Mururoa MHPF 1959 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MURU59G",
    label: "IGNF:MURU59G / Mururoa (MHPF 1959) geographiques (dms)",
  },
  {
    value: "IGNF:MURU62",
    label: "IGNF:MURU62 / Mururoa MHOI 1962 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MURU62G",
    label: "IGNF:MURU62G / Mururoa (MHOI 1962) geographiques (dms)",
  },
  {
    value: "IGNF:MURU78",
    label: "IGNF:MURU78 / Mururoa IGN 1978 cartesiennes geocentriques",
  },
  {
    value: "IGNF:MURU78G",
    label: "IGNF:MURU78G / Mururoa (IGN 1978) geographiques (dms)",
  },
  {
    value: "IGNF:NC51",
    label: "IGNF:NC51 / GOMEN TERME NORD 1951 CARTESIENNES",
  },
  {
    value: "IGNF:NC51G",
    label: "IGNF:NC51G / Gomen Terme Nord 1951 geographiques (dms)",
  },
  {
    value: "IGNF:NEA74",
    label: "IGNF:NEA74 / Noumea 1974 cartesiennes geocentriques",
  },
  {
    value: "IGNF:NEA74G",
    label: "IGNF:NEA74G / NEA74 NOUMEA geographiques (dms)",
  },
  {
    value: "IGNF:NOVA53",
    label: "IGNF:NOVA53 / Juan de Nova MHM 1953 cartesiennes geocentriques",
  },
  {
    value: "IGNF:NOVA53G",
    label: "IGNF:NOVA53G / Juan de Nova  geographiques (dms)",
  },
  { value: "IGNF:NTF", label: "IGNF:NTF / NTF cartesiennes" },
  {
    value: "IGNF:NTFG",
    label: "IGNF:NTFG / NTF GEOGRAPHIQUES GREENWICH (DMS)",
  },
  { value: "IGNF:NTFP", label: "IGNF:NTFP / NTF geographiques Paris (gr)" },
  {
    value: "IGNF:NTFPGRAD",
    label: "IGNF:NTFPGRAD / NTF geographiques Paris (gr)",
  },
  {
    value: "IGNF:NUKU72",
    label: "IGNF:NUKU72 / Nuku Hiva IGN 1972 cartesiennes geocentriques",
  },
  {
    value: "IGNF:NUKU72G",
    label: "IGNF:NUKU72G / Nuku Hiva 1972 geographiques (dms)",
  },
  {
    value: "IGNF:NUKU72GEO",
    label: "IGNF:NUKU72GEO / Nuku Hiva 1972 geographiques (dms)",
  },
  {
    value: "IGNF:OUVE72",
    label: "IGNF:OUVE72 / Ouvea MHNC 1972 cartesiennes geocentriques",
  },
  {
    value: "IGNF:OUVE72G",
    label: "IGNF:OUVE72G / Ouvea MHNC 1972 geographiques (dms)",
  },
  {
    value: "IGNF:OUVEA72",
    label: "IGNF:OUVEA72 / Ouvea MHNC 1972 cartesiennes geocentriques",
  },
  {
    value: "IGNF:OUVEA72G",
    label: "IGNF:OUVEA72G / Ouvea MHNC 1972 geographiques (dms)",
  },
  {
    value: "IGNF:PDN08G",
    label: "IGNF:PDN08G / PITON DES NEIGES (2008) GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:PDN92G",
    label: "IGNF:PDN92G / PITON DES NEIGES (1992) GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:PETRELS72",
    label: "IGNF:PETRELS72 / Petrels IGN 1972 cartesiennes geocentriques",
  },
  {
    value: "IGNF:PETRELS72G",
    label: "IGNF:PETRELS72G / Petrels geographiques (dms)",
  },
  {
    value: "IGNF:PGP50",
    label: "IGNF:PGP50 / Pointe Geologie Perroud 1950 cartesiennes",
  },
  {
    value: "IGNF:PGP50G",
    label: "IGNF:PGP50G / Pointe Geologie Perroud 1950 geographiques (dms)",
  },
  {
    value: "IGNF:PMAR55",
    label: "IGNF:PMAR55 / Port Martin Perroud 1955 cartesiennes",
  },
  {
    value: "IGNF:PMAR55G",
    label: "IGNF:PMAR55G / Port Martin geographiques (dms)",
  },
  {
    value: "IGNF:PMARP55",
    label: "IGNF:PMARP55 / Port Martin Perroud 1955 cartesiennes",
  },
  {
    value: "IGNF:PMARP55G",
    label: "IGNF:PMARP55G / Port Martin geographiques (dms)",
  },
  {
    value: "IGNF:RAIA53",
    label: "IGNF:RAIA53 / Raiatea Tahaa Bora Bora Huahine 1953 cartesiennes",
  },
  {
    value: "IGNF:RAIA53G",
    label: "IGNF:RAIA53G / IGN53 Societe geographiques (dms)",
  },
  {
    value: "IGNF:RAIV54",
    label: "IGNF:RAIV54 / Raivavae cadastre 1953-1954 cartesiennes geocent.",
  },
  {
    value: "IGNF:RAIV54G",
    label: "IGNF:RAIV54G / Raivavae (Cadastre) geographiques (dms)",
  },
  {
    value: "IGNF:RAIV66",
    label: "IGNF:RAIV66 / Raivavae MHPF 1966 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RAIV66G",
    label: "IGNF:RAIV66G / Raivavae (MHPF 1966) geographiques (dms)",
  },
  {
    value: "IGNF:RANGI47",
    label: "IGNF:RANGI47 / Rangiroa MGT 1947 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RANGI47G",
    label: "IGNF:RANGI47G / Rangiroa (MGT 1947) geographiques (dms)",
  },
  {
    value: "IGNF:RANGI47GEO",
    label: "IGNF:RANGI47GEO / MGT 1947 geographiques (dms)",
  },
  {
    value: "IGNF:RANGI59",
    label: "IGNF:RANGI59 / Rangiroa MHPF 1959 cartesiennes geocent.",
  },
  {
    value: "IGNF:RANGI59G",
    label: "IGNF:RANGI59G / Rangiroa (MHPF 1959) geographiques (dms)",
  },
  {
    value: "IGNF:RANGI68",
    label: "IGNF:RANGI68 / Rangiroa MHPF 1966-1968 cartesiennes geocent.",
  },
  {
    value: "IGNF:RANGI68G",
    label: "IGNF:RANGI68G / Rangiroa (MHPF 1966-68) geographiques (dms)",
  },
  {
    value: "IGNF:RAPA55",
    label: "IGNF:RAPA55 / Rapa MHEFO 1955 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RAPA55G",
    label: "IGNF:RAPA55G / Rapa (MHEFO 1955) geographiques (dms)",
  },
  {
    value: "IGNF:RAPA80",
    label: "IGNF:RAPA80 / Rapa SEQ 1980 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RAPA80G",
    label: "IGNF:RAPA80G / Rapa (SEQ 1980) geographiques (dms)",
  },
  {
    value: "IGNF:REUN47",
    label: "IGNF:REUN47 / Reunion Piton des Neiges 1949 cartesiennes",
  },
  {
    value: "IGNF:REUN47G",
    label: "IGNF:REUN47G / Reunion Piton des Neiges geographiques (dms)",
  },
  {
    value: "IGNF:REUN47GEO",
    label: "IGNF:REUN47GEO / Reunion Piton des Neiges geographiques (dms)",
  },
  {
    value: "IGNF:REUN49",
    label: "IGNF:REUN49 / Reunion Piton des Neiges 1949 cartesiennes",
  },
  {
    value: "IGNF:REUN49G",
    label: "IGNF:REUN49G / Reunion Piton des Neiges geographiques (dms)",
  },
  {
    value: "IGNF:RGAF09",
    label: "IGNF:RGAF09 / RGAF09 cartesiennes geocentriques",
  },
  { value: "IGNF:RGAF09G", label: "IGNF:RGAF09G / RGAF09 geographiques (dms)" },
  {
    value: "IGNF:RGAF09GDD",
    label: "IGNF:RGAF09GDD / RGAF09 geographiques (dd)",
  },
  {
    value: "IGNF:RGAF09GEO",
    label: "IGNF:RGAF09GEO / RGAF09 geographiques (dms)",
  },
  {
    value: "IGNF:RGAF09GEODD",
    label: "IGNF:RGAF09GEODD / RGAF09 geographiques (dd)",
  },
  {
    value: "IGNF:RGF93",
    label: "IGNF:RGF93 / RGF93 cartesiennes geocentriques",
  },
  { value: "IGNF:RGF93G", label: "IGNF:RGF93G / RGF93 geographiques (dms)" },
  { value: "IGNF:RGF93GDD", label: "IGNF:RGF93GDD / RGF93 geographiques (dd)" },
  {
    value: "IGNF:RGF93GEO",
    label: "IGNF:RGF93GEO / RGF93 geographiques (dms)",
  },
  {
    value: "IGNF:RGF93GEODD",
    label: "IGNF:RGF93GEODD / RGF93 geographiques (dd)",
  },
  {
    value: "IGNF:RGFG95",
    label: "IGNF:RGFG95 / RGFG95 cartesiennes geocentriques",
  },
  { value: "IGNF:RGFG95G", label: "IGNF:RGFG95G / RGFG95 geographiques (dms)" },
  {
    value: "IGNF:RGFG95GDD",
    label: "IGNF:RGFG95GDD / RGFG95 geographiques (dd)",
  },
  {
    value: "IGNF:RGFG95GEO",
    label: "IGNF:RGFG95GEO / RGFG95 geographiques (dms)",
  },
  {
    value: "IGNF:RGFG95GEODD",
    label: "IGNF:RGFG95GEODD / RGFG95 geographiques (dd)",
  },
  {
    value: "IGNF:RGM04",
    label: "IGNF:RGM04 / RGM04 cartesiennes geocentriques",
  },
  { value: "IGNF:RGM04G", label: "IGNF:RGM04G / RGM04 geographiques (dms)" },
  { value: "IGNF:RGM04GDD", label: "IGNF:RGM04GDD / RGM04 geographiques (dd)" },
  {
    value: "IGNF:RGM04GEO",
    label: "IGNF:RGM04GEO / RGM04 geographiques (dms)",
  },
  {
    value: "IGNF:RGM04GEODD",
    label: "IGNF:RGM04GEODD / RGM04 geographiques (dd)",
  },
  { value: "IGNF:RGNC", label: "IGNF:RGNC / RGNC cartesiennes geocentriques" },
  { value: "IGNF:RGNCG", label: "IGNF:RGNCG / RGNC geographiques (dms)" },
  { value: "IGNF:RGNCGEO", label: "IGNF:RGNCGEO / RGNC geographiques (dms)" },
  {
    value: "IGNF:RGNCGEODD",
    label: "IGNF:RGNCGEODD / RGNC GEOGRAPHIQUES (DD)",
  },
  { value: "IGNF:RGPF", label: "IGNF:RGPF / RGPF cartesiennes geocentriques" },
  { value: "IGNF:RGPFG", label: "IGNF:RGPFG / RGPF geographiques (dms)" },
  { value: "IGNF:RGPFGDD", label: "IGNF:RGPFGDD / RGPF geographiques (dd)" },
  { value: "IGNF:RGPFGEO", label: "IGNF:RGPFGEO / RGPF geographiques (dms)" },
  {
    value: "IGNF:RGR92",
    label: "IGNF:RGR92 / RGR92 cartesiennes geocentriques",
  },
  { value: "IGNF:RGR92G", label: "IGNF:RGR92G / RGR92 geographiques (dms)" },
  { value: "IGNF:RGR92GDD", label: "IGNF:RGR92GDD / RGR92 geographiques (dd)" },
  {
    value: "IGNF:RGR92GEO",
    label: "IGNF:RGR92GEO / RGR92 geographiques (dms)",
  },
  {
    value: "IGNF:RGR92GEODD",
    label: "IGNF:RGR92GEODD / RGR92 geographiques (dd)",
  },
  {
    value: "IGNF:RGSPM06",
    label: "IGNF:RGSPM06 / RGSPM06 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RGSPM06G",
    label: "IGNF:RGSPM06G / RGSPM06 geographiques (dms)",
  },
  {
    value: "IGNF:RGSPM06GDD",
    label: "IGNF:RGSPM06GDD / RGSPM06 geographiques (dd)",
  },
  {
    value: "IGNF:RGSPM06GEO",
    label: "IGNF:RGSPM06GEO / RGSPM06 geographiques (dms)",
  },
  {
    value: "IGNF:RGSPM06GEODD",
    label: "IGNF:RGSPM06GEODD / RGSPM06 geographiques (dd)",
  },
  {
    value: "IGNF:RGTAAF07",
    label: "IGNF:RGTAAF07 / RGTAAF07 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RGTAAF07G",
    label: "IGNF:RGTAAF07G / RGTAAF07 geographiques (dms)",
  },
  {
    value: "IGNF:RGTAAF07GDD",
    label: "IGNF:RGTAAF07GDD / RGTAAF07 geographiques (dd)",
  },
  {
    value: "IGNF:RGTAAFGEO",
    label: "IGNF:RGTAAFGEO / RGTAAF07 geographiques (dms)",
  },
  {
    value: "IGNF:RGTAAFGEODD",
    label: "IGNF:RGTAAFGEODD / RGTAAF07 geographiques (dd)",
  },
  {
    value: "IGNF:RGWF96",
    label:
      "IGNF:RGWF96 / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 CARTESIENNES GEOCENTRIQUES",
  },
  {
    value: "IGNF:RGWF96G",
    label:
      "IGNF:RGWF96G / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:RGWF96GDD",
    label:
      "IGNF:RGWF96GDD / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DD)",
  },
  {
    value: "IGNF:RGWF96GEO",
    label:
      "IGNF:RGWF96GEO / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:RGWF96GEODD",
    label:
      "IGNF:RGWF96GEODD / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DD)",
  },
  { value: "IGNF:RRAF", label: "IGNF:RRAF / RRAF cartesiennes geocentriques" },
  {
    value: "IGNF:RRAF91",
    label: "IGNF:RRAF91 / WGS84 cartesiennes geocentriques",
  },
  { value: "IGNF:RRAFG", label: "IGNF:RRAFG / RRAF geographiques (dms)" },
  { value: "IGNF:RRAFGDD", label: "IGNF:RRAFGDD / RRAF geographiques (dd)" },
  { value: "IGNF:RRAFGEO", label: "IGNF:RRAFGEO / RRAF geographiques (dms)" },
  {
    value: "IGNF:RRAFGEODD",
    label: "IGNF:RRAFGEODD / RRAF geographiques (dd)",
  },
  {
    value: "IGNF:RUSAT84",
    label: "IGNF:RUSAT84 / Rurutu SAT84 cartesiennes geocentriques",
  },
  {
    value: "IGNF:RUSAT84G",
    label: "IGNF:RUSAT84G / Rurutu (SAT84) geographiques (dms)",
  },
  {
    value: "IGNF:SAT84",
    label: "IGNF:SAT84 / Rurutu SAT84 cartesiennes geocentriques",
  },
  {
    value: "IGNF:SAT84G",
    label: "IGNF:SAT84G / Rurutu (SAT84) geographiques (dms)",
  },
  {
    value: "IGNF:ST84",
    label: "IGNF:ST84 / Ile des Pins ST84 cartesiennes geocentriques",
  },
  {
    value: "IGNF:ST84G",
    label: "IGNF:ST84G / ST 84 ILE DES PINS geographiques (dms)",
  },
  { value: "IGNF:ST87", label: "IGNF:ST87 / ST 87 cartesiennes geocentriques" },
  {
    value: "IGNF:ST87G",
    label: "IGNF:ST87G / ST 87 OUVEA geographiques (dms)",
  },
  {
    value: "IGNF:ST87GEO",
    label: "IGNF:ST87GEO / ST 87 OUVEA geographiques (dms)",
  },
  {
    value: "IGNF:STPL69",
    label: "IGNF:STPL69 / Saint-Paul 1969 cartesiennes geocentriques",
  },
  {
    value: "IGNF:STPL69G",
    label: "IGNF:STPL69G / Saint-Paul geographiques (dms)",
  },
  {
    value: "IGNF:STPL69GEO",
    label: "IGNF:STPL69GEO / Ile Saint-Paul 1969 geographiques (dms)",
  },
  {
    value: "IGNF:STPM50",
    label: "IGNF:STPM50 / St Pierre Miquelon 1950 cartesiennes",
  },
  {
    value: "IGNF:STPM50G",
    label: "IGNF:STPM50G / St Pierre Miquelon 1950 geographiques (dms)",
  },
  {
    value: "IGNF:STPM50GEO",
    label: "IGNF:STPM50GEO / St Pierre Miquelon 1950 geographiques (dms)",
  },
  {
    value: "IGNF:SYSLNG",
    label: "IGNF:SYSLNG / Lambert Nord de Guerre grades Paris",
  },
  {
    value: "IGNF:TAHAA",
    label: "IGNF:TAHAA / Tahaa 1951 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TAHAA53",
    label: "IGNF:TAHAA53 / Raiatea Tahaa Bora Bora Huahine 1953 cartesiennes",
  },
  {
    value: "IGNF:TAHAA53G",
    label: "IGNF:TAHAA53G / IGN53 Societe geographiques (dms)",
  },
  { value: "IGNF:TAHAAG", label: "IGNF:TAHAAG / Tahaa geographiques (dms)" },
  {
    value: "IGNF:TAHAAGEO",
    label: "IGNF:TAHAAGEO / Tahaa geographiques (dms)",
  },
  {
    value: "IGNF:TAHI51",
    label: "IGNF:TAHI51 / TAHITI TERME NORD CARTESIENNES GEOCENTRIQUES",
  },
  {
    value: "IGNF:TAHI51G",
    label: "IGNF:TAHI51G / TAHITI TERME NORD GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:TAHI79",
    label: "IGNF:TAHI79 / Tahiti IGN 1979 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TAHI79G",
    label: "IGNF:TAHI79G / Tahiti (IGN79) geographiques (dms)",
  },
  {
    value: "IGNF:TAHI79GEO",
    label: "IGNF:TAHI79GEO / Tahiti (IGN79) geographiques (dms)",
  },
  {
    value: "IGNF:TAKA69",
    label: "IGNF:TAKA69 / Takaroa Takapoto SHM 1969 cartesiennes",
  },
  {
    value: "IGNF:TAKA69G",
    label: "IGNF:TAKA69G / Takaroa Takapoto (SHM 1969) geo. (dms)",
  },
  {
    value: "IGNF:TANNA",
    label: "IGNF:TANNA / Tanna Bloc Sud 1957 cartesiennes geocentriques",
  },
  { value: "IGNF:TANNAG", label: "IGNF:TANNAG / Tanna geographiques (dms)" },
  {
    value: "IGNF:TERA50",
    label: "IGNF:TERA50 / Pointe Geologie Perroud 1950 cartesiennes",
  },
  {
    value: "IGNF:TERA50G",
    label: "IGNF:TERA50G / Pointe Geologie Perroud 1950 geographiques (dms)",
  },
  {
    value: "IGNF:TERA50GEO",
    label: "IGNF:TERA50GEO / Pointe Geologie Perroud 1950 geographiques (dms)",
  },
  {
    value: "IGNF:TETIA90",
    label: "IGNF:TETIA90 / Tetiaroa (MOP90) cartesiennes",
  },
  {
    value: "IGNF:TETIA90G",
    label: "IGNF:TETIA90G / Tetiaroa (MOP90) geographiques (dms)",
  },
  {
    value: "IGNF:TIKE50",
    label: "IGNF:TIKE50 / Tikehau SHM 1947-1950 cartesiennes",
  },
  {
    value: "IGNF:TIKE50G",
    label: "IGNF:TIKE50G / Tikehau (SHM 1947-1950) geographiques (dms)",
  },
  {
    value: "IGNF:TIKE60",
    label: "IGNF:TIKE60 / Tikehau MHPF 1960 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TIKE60G",
    label: "IGNF:TIKE60G / Tikehau (MHPF 1960) geographiques (dms)",
  },
  {
    value: "IGNF:TIKE88G",
    label: "IGNF:TIKE88G / TIKEHAU (MOP88) GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:TIKE88GEO",
    label: "IGNF:TIKE88GEO / TIKEHAU (MOP88) GEOGRAPHIQUES (DMS)",
  },
  {
    value: "IGNF:TROM56",
    label: "IGNF:TROM56 / Tromelin SGM 1956 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TROM56G",
    label: "IGNF:TROM56G / Tromelin geographiques (dms)",
  },
  { value: "IGNF:TUAM86", label: "IGNF:TUAM86 / TUAMOTU (MOP86) CARTESIENNES" },
  {
    value: "IGNF:TUAM86G",
    label: "IGNF:TUAM86G / Tuamotu (MOP86) geographiques (dms)",
  },
  {
    value: "IGNF:TUBU55",
    label: "IGNF:TUBU55 / Tubuai MGT 1955 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TUBU55G",
    label: "IGNF:TUBU55G / Tubuai (MGT 1955) geographiques (dms)",
  },
  {
    value: "IGNF:TUBU69",
    label: "IGNF:TUBU69 / Tubuai MHPF 1969 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TUBU69G",
    label: "IGNF:TUBU69G / Tubuai (MHPF 1969) geographiques (dms)",
  },
  {
    value: "IGNF:TURI69",
    label: "IGNF:TURI69 / Tureia SHM 1969 cartesiennes geocentriques",
  },
  {
    value: "IGNF:TURI69G",
    label: "IGNF:TURI69G / Tureia (SHM 1969) geographiques (dms)",
  },
  {
    value: "IGNF:W84MARTGEODD",
    label: "IGNF:W84MARTGEODD / RRAF geographiques (dd)",
  },
  {
    value: "IGNF:WALL76",
    label: "IGNF:WALL76 / Wallis - Uvea MOP 1976 cartesiennes geocentriques",
  },
  {
    value: "IGNF:WALL76G",
    label: "IGNF:WALL76G / Wallis (MOP 1976) geographiques (dms)",
  },
  {
    value: "IGNF:WALL78",
    label: "IGNF:WALL78 / Wallis - Uvea Shom 1978 cartesiennes geocentriques",
  },
  {
    value: "IGNF:WALL78G",
    label: "IGNF:WALL78G / Wallis (MOP 1978) geographiques (dms)",
  },
  {
    value: "IGNF:WALL78GEO",
    label: "IGNF:WALL78GEO / MOP 1978 geographiques (dms)",
  },
  {
    value: "IGNF:WGS72",
    label: "IGNF:WGS72 / WGS72 cartesiennes geocentriques",
  },
  { value: "IGNF:WGS72G", label: "IGNF:WGS72G / WGS72 geographiques (dms)" },
  {
    value: "IGNF:WGS72GEO",
    label: "IGNF:WGS72GEO / WGS72 geographiques (dms)",
  },
  {
    value: "IGNF:WGS84",
    label: "IGNF:WGS84 / WGS84 cartesiennes geocentriques",
  },
  { value: "IGNF:WGS84G", label: "IGNF:WGS84G / WGS84 geographiques (dms)" },
  { value: "IGNF:WGS84GDD", label: "IGNF:WGS84GDD / WGS84 geographiques (dd)" },
  {
    value: "IGNF:WGS84GEO",
    label: "IGNF:WGS84GEO / WGS84 geographiques (dms)",
  },
  {
    value: "IGNF:WGS84GEODD",
    label: "IGNF:WGS84GEODD / WGS84 geographiques (dd)",
  },
  {
    value: "IGNF:WGS84GUAD",
    label: "IGNF:WGS84GUAD / RRAF cartesiennes geocentriques",
  },
  {
    value: "IGNF:WGS84GUADGEO",
    label: "IGNF:WGS84GUADGEO / RRAF geographiques (dms)",
  },
  {
    value: "IGNF:WGS84MARTG",
    label: "IGNF:WGS84MARTG / RRAF geographiques (dms)",
  },
  {
    value: "IGNF:WGS84MARTGDD",
    label: "IGNF:WGS84MARTGDD / RRAF geographiques (dd)",
  },
  {
    value: "IGNF:WGS84RRAFGEO",
    label: "IGNF:WGS84RRAFGEO / WGS84 geographiques (dms)",
  },
  { value: "NKG:ETRF00", label: "NKG:ETRF00 / NKG_ETRF00" },
  { value: "NKG:ETRF14", label: "NKG:ETRF14 / NKG_ETRF14" },
  { value: "OGC:CRS27", label: "OGC:CRS27 / NAD27 (CRS27)" },
  { value: "OGC:CRS83", label: "OGC:CRS83 / NAD83 (CRS83)" },
  { value: "OGC:CRS84", label: "OGC:CRS84 / WGS 84 (CRS84)" },
  {
    value: "OGC:CRS84h",
    label: "OGC:CRS84h / WGS 84 longitude-latitude-height",
  },
  {
    value: "CZM:7405",
    label:
      "7405 / OSGB36 (with EPSG 1314 Helmert transform) / British National Grid + OSGM15 height",
  },
  {
    value: "CZM:5513Plus5705",
    label: "5513Plus5705 / S - JTSK Krakov with Baltic Heights",
  },
  {
    value: "CZM:5514Plus5705",
    label: "5514Plus5705 / S - JTSK Krakov Inversed with Baltic Heights",
  },
  { value: "CZM:HS215", label: "HS215 / HS2TN15 + HS2GM15" },
  {
    value: "EPSG:3901",
    label: "EPSG:3901 / KKJ / Finland Uniform Coordinate System + N60 height",
  },
  {
    value: "EPSG:3902",
    label: "EPSG:3902 / ETRS89 / TM35FIN(N,E) + N60 height",
  },
  {
    value: "EPSG:3903",
    label: "EPSG:3903 / ETRS89 / TM35FIN(N,E) + N2000 height",
  },
  { value: "EPSG:4097", label: "EPSG:4097 / ETRS89 / DKTM1 + DVR90 height" },
  { value: "EPSG:4098", label: "EPSG:4098 / ETRS89 / DKTM2 + DVR90 height" },
  { value: "EPSG:4099", label: "EPSG:4099 / ETRS89 / DKTM3 + DVR90 height" },
  { value: "EPSG:4100", label: "EPSG:4100 / ETRS89 / DKTM4 + DVR90 height" },
  { value: "EPSG:5318", label: "EPSG:5318 / ETRS89 / Faroe TM + FVR09 height" },
  { value: "EPSG:5498", label: "EPSG:5498 / NAD83 + NAVD88 height" },
  { value: "EPSG:5499", label: "EPSG:5499 / NAD83(HARN) + NAVD88 height" },
  { value: "EPSG:5500", label: "EPSG:5500 / NAD83(NSRS2007) + NAVD88 height" },
  {
    value: "EPSG:5554",
    label: "EPSG:5554 / ETRS89 / UTM zone 31N + DHHN92 height",
  },
  {
    value: "EPSG:5555",
    label: "EPSG:5555 / ETRS89 / UTM zone 32N + DHHN92 height",
  },
  {
    value: "EPSG:5556",
    label: "EPSG:5556 / ETRS89 / UTM zone 33N + DHHN92 height",
  },
  {
    value: "EPSG:5598",
    label: "EPSG:5598 / FEH2010 / Fehmarnbelt TM + FCSVR10 height",
  },
  { value: "EPSG:5628", label: "EPSG:5628 / SWEREF99 + RH2000 height" },
  {
    value: "EPSG:5698",
    label: "EPSG:5698 / RGF93 v1 / Lambert-93 + NGF-IGN69 height",
  },
  {
    value: "EPSG:5699",
    label: "EPSG:5699 / RGF93 v1 / Lambert-93 + NGF-IGN78 height",
  },
  {
    value: "EPSG:5707",
    label: "EPSG:5707 / NTF (Paris) / Lambert zone I + NGF-IGN69 height",
  },
  {
    value: "EPSG:5708",
    label: "EPSG:5708 / NTF (Paris) / Lambert zone IV + NGF-IGN78 height",
  },
  {
    value: "EPSG:5832",
    label:
      "EPSG:5832 / DB_REF / 3-degree Gauss-Kruger zone 2 (E-N) + DHHN92 height",
  },
  {
    value: "EPSG:5833",
    label:
      "EPSG:5833 / DB_REF / 3-degree Gauss-Kruger zone 3 (E-N) + DHHN92 height",
  },
  {
    value: "EPSG:5834",
    label:
      "EPSG:5834 / DB_REF / 3-degree Gauss-Kruger zone 4 (E-N) + DHHN92 height",
  },
  {
    value: "EPSG:5835",
    label:
      "EPSG:5835 / DB_REF / 3-degree Gauss-Kruger zone 5 (E-N) + DHHN92 height",
  },
  { value: "EPSG:5845", label: "EPSG:5845 / SWEREF99 TM + RH2000 height" },
  { value: "EPSG:5846", label: "EPSG:5846 / SWEREF99 12 00 + RH2000 height" },
  { value: "EPSG:5847", label: "EPSG:5847 / SWEREF99 13 30 + RH2000 height" },
  { value: "EPSG:5848", label: "EPSG:5848 / SWEREF99 15 00 + RH2000 height" },
  { value: "EPSG:5849", label: "EPSG:5849 / SWEREF99 16 30 + RH2000 height" },
  { value: "EPSG:5850", label: "EPSG:5850 / SWEREF99 18 00 + RH2000 height" },
  { value: "EPSG:5851", label: "EPSG:5851 / SWEREF99 14 15 + RH2000 height" },
  { value: "EPSG:5852", label: "EPSG:5852 / SWEREF99 15 45 + RH2000 height" },
  { value: "EPSG:5853", label: "EPSG:5853 / SWEREF99 17 15 + RH2000 height" },
  { value: "EPSG:5854", label: "EPSG:5854 / SWEREF99 18 45 + RH2000 height" },
  { value: "EPSG:5855", label: "EPSG:5855 / SWEREF99 20 15 + RH2000 height" },
  { value: "EPSG:5856", label: "EPSG:5856 / SWEREF99 21 45 + RH2000 height" },
  { value: "EPSG:5857", label: "EPSG:5857 / SWEREF99 23 15 + RH2000 height" },
  { value: "EPSG:5942", label: "EPSG:5942 / ETRS89 + NN2000 height" },
  {
    value: "EPSG:5945",
    label: "EPSG:5945 / ETRS89 / NTM zone 5 + NN2000 height",
  },
  {
    value: "EPSG:5946",
    label: "EPSG:5946 / ETRS89 / NTM zone 6 + NN2000 height",
  },
  {
    value: "EPSG:5947",
    label: "EPSG:5947 / ETRS89 / NTM zone 7 + NN2000 height",
  },
  {
    value: "EPSG:5948",
    label: "EPSG:5948 / ETRS89 / NTM zone 8 + NN2000 height",
  },
  {
    value: "EPSG:5949",
    label: "EPSG:5949 / ETRS89 / NTM zone 9 + NN2000 height",
  },
  {
    value: "EPSG:5950",
    label: "EPSG:5950 / ETRS89 / NTM zone 10 + NN2000 height",
  },
  {
    value: "EPSG:5951",
    label: "EPSG:5951 / ETRS89 / NTM zone 11 + NN2000 height",
  },
  {
    value: "EPSG:5952",
    label: "EPSG:5952 / ETRS89 / NTM zone 12 + NN2000 height",
  },
  {
    value: "EPSG:5953",
    label: "EPSG:5953 / ETRS89 / NTM zone 13 + NN2000 height",
  },
  {
    value: "EPSG:5954",
    label: "EPSG:5954 / ETRS89 / NTM zone 14 + NN2000 height",
  },
  {
    value: "EPSG:5955",
    label: "EPSG:5955 / ETRS89 / NTM zone 15 + NN2000 height",
  },
  {
    value: "EPSG:5956",
    label: "EPSG:5956 / ETRS89 / NTM zone 16 + NN2000 height",
  },
  {
    value: "EPSG:5957",
    label: "EPSG:5957 / ETRS89 / NTM zone 17 + NN2000 height",
  },
  {
    value: "EPSG:5958",
    label: "EPSG:5958 / ETRS89 / NTM zone 18 + NN2000 height",
  },
  {
    value: "EPSG:5959",
    label: "EPSG:5959 / ETRS89 / NTM zone 19 + NN2000 height",
  },
  {
    value: "EPSG:5960",
    label: "EPSG:5960 / ETRS89 / NTM zone 20 + NN2000 height",
  },
  {
    value: "EPSG:5961",
    label: "EPSG:5961 / ETRS89 / NTM zone 21 + NN2000 height",
  },
  {
    value: "EPSG:5962",
    label: "EPSG:5962 / ETRS89 / NTM zone 22 + NN2000 height",
  },
  {
    value: "EPSG:5963",
    label: "EPSG:5963 / ETRS89 / NTM zone 23 + NN2000 height",
  },
  {
    value: "EPSG:5964",
    label: "EPSG:5964 / ETRS89 / NTM zone 24 + NN2000 height",
  },
  {
    value: "EPSG:5965",
    label: "EPSG:5965 / ETRS89 / NTM zone 25 + NN2000 height",
  },
  {
    value: "EPSG:5966",
    label: "EPSG:5966 / ETRS89 / NTM zone 26 + NN2000 height",
  },
  {
    value: "EPSG:5967",
    label: "EPSG:5967 / ETRS89 / NTM zone 27 + NN2000 height",
  },
  {
    value: "EPSG:5968",
    label: "EPSG:5968 / ETRS89 / NTM zone 28 + NN2000 height",
  },
  {
    value: "EPSG:5969",
    label: "EPSG:5969 / ETRS89 / NTM zone 29 + NN2000 height",
  },
  {
    value: "EPSG:5970",
    label: "EPSG:5970 / ETRS89 / NTM zone 30 + NN2000 height",
  },
  {
    value: "EPSG:5971",
    label: "EPSG:5971 / ETRS89 / UTM zone 31N + NN2000 height",
  },
  {
    value: "EPSG:5972",
    label: "EPSG:5972 / ETRS89 / UTM zone 32N + NN2000 height",
  },
  {
    value: "EPSG:5973",
    label: "EPSG:5973 / ETRS89 / UTM zone 33N + NN2000 height",
  },
  {
    value: "EPSG:5974",
    label: "EPSG:5974 / ETRS89 / UTM zone 34N + NN2000 height",
  },
  {
    value: "EPSG:5975",
    label: "EPSG:5975 / ETRS89 / UTM zone 35N + NN2000 height",
  },
  {
    value: "EPSG:5976",
    label: "EPSG:5976 / ETRS89 / UTM zone 36N + NN2000 height",
  },
  { value: "EPSG:6144", label: "EPSG:6144 / ETRS89 + NN54 height" },
  {
    value: "EPSG:6145",
    label: "EPSG:6145 / ETRS89 / NTM zone 5 + NN54 height",
  },
  {
    value: "EPSG:6146",
    label: "EPSG:6146 / ETRS89 / NTM zone 6 + NN54 height",
  },
  {
    value: "EPSG:6147",
    label: "EPSG:6147 / ETRS89 / NTM zone 7 + NN54 height",
  },
  {
    value: "EPSG:6148",
    label: "EPSG:6148 / ETRS89 / NTM zone 8 + NN54 height",
  },
  {
    value: "EPSG:6149",
    label: "EPSG:6149 / ETRS89 / NTM zone 9 + NN54 height",
  },
  {
    value: "EPSG:6150",
    label: "EPSG:6150 / ETRS89 / NTM zone 10 + NN54 height",
  },
  {
    value: "EPSG:6151",
    label: "EPSG:6151 / ETRS89 / NTM zone 11 + NN54 height",
  },
  {
    value: "EPSG:6152",
    label: "EPSG:6152 / ETRS89 / NTM zone 12 + NN54 height",
  },
  {
    value: "EPSG:6153",
    label: "EPSG:6153 / ETRS89 / NTM zone 13 + NN54 height",
  },
  {
    value: "EPSG:6154",
    label: "EPSG:6154 / ETRS89 / NTM zone 14 + NN54 height",
  },
  {
    value: "EPSG:6155",
    label: "EPSG:6155 / ETRS89 / NTM zone 15 + NN54 height",
  },
  {
    value: "EPSG:6156",
    label: "EPSG:6156 / ETRS89 / NTM zone 16 + NN54 height",
  },
  {
    value: "EPSG:6157",
    label: "EPSG:6157 / ETRS89 / NTM zone 17 + NN54 height",
  },
  {
    value: "EPSG:6158",
    label: "EPSG:6158 / ETRS89 / NTM zone 18 + NN54 height",
  },
  {
    value: "EPSG:6159",
    label: "EPSG:6159 / ETRS89 / NTM zone 19 + NN54 height",
  },
  {
    value: "EPSG:6160",
    label: "EPSG:6160 / ETRS89 / NTM zone 20 + NN54 height",
  },
  {
    value: "EPSG:6161",
    label: "EPSG:6161 / ETRS89 / NTM zone 21 + NN54 height",
  },
  {
    value: "EPSG:6162",
    label: "EPSG:6162 / ETRS89 / NTM zone 22 + NN54 height",
  },
  {
    value: "EPSG:6163",
    label: "EPSG:6163 / ETRS89 / NTM zone 23 + NN54 height",
  },
  {
    value: "EPSG:6164",
    label: "EPSG:6164 / ETRS89 / NTM zone 24 + NN54 height",
  },
  {
    value: "EPSG:6165",
    label: "EPSG:6165 / ETRS89 / NTM zone 25 + NN54 height",
  },
  {
    value: "EPSG:6166",
    label: "EPSG:6166 / ETRS89 / NTM zone 26 + NN54 height",
  },
  {
    value: "EPSG:6167",
    label: "EPSG:6167 / ETRS89 / NTM zone 27 + NN54 height",
  },
  {
    value: "EPSG:6168",
    label: "EPSG:6168 / ETRS89 / NTM zone 28 + NN54 height",
  },
  {
    value: "EPSG:6169",
    label: "EPSG:6169 / ETRS89 / NTM zone 29 + NN54 height",
  },
  {
    value: "EPSG:6170",
    label: "EPSG:6170 / ETRS89 / NTM zone 30 + NN54 height",
  },
  {
    value: "EPSG:6171",
    label: "EPSG:6171 / ETRS89 / UTM zone 31N + NN54 height",
  },
  {
    value: "EPSG:6172",
    label: "EPSG:6172 / ETRS89 / UTM zone 32N + NN54 height",
  },
  {
    value: "EPSG:6173",
    label: "EPSG:6173 / ETRS89 / UTM zone 33N + NN54 height",
  },
  {
    value: "EPSG:6174",
    label: "EPSG:6174 / ETRS89 / UTM zone 34N + NN54 height",
  },
  {
    value: "EPSG:6175",
    label: "EPSG:6175 / ETRS89 / UTM zone 35N + NN54 height",
  },
  {
    value: "EPSG:6176",
    label: "EPSG:6176 / ETRS89 / UTM zone 36N + NN54 height",
  },
  {
    value: "EPSG:6190",
    label: "EPSG:6190 / BD72 / Belgian Lambert 72 + Ostend height",
  },
  { value: "EPSG:6349", label: "EPSG:6349 / NAD83(2011) + NAVD88 height" },
  {
    value: "EPSG:6649",
    label: "EPSG:6649 / NAD83(CSRS) + CGVD2013(CGG2013) height",
  },
  {
    value: "EPSG:6650",
    label: "EPSG:6650 / NAD83(CSRS) / UTM zone 7N + CGVD2013 height",
  },
  {
    value: "EPSG:6651",
    label: "EPSG:6651 / NAD83(CSRS) / UTM zone 8N + CGVD2013 height",
  },
  {
    value: "EPSG:6652",
    label: "EPSG:6652 / NAD83(CSRS) / UTM zone 9N + CGVD2013 height",
  },
  {
    value: "EPSG:6653",
    label: "EPSG:6653 / NAD83(CSRS) / UTM zone 10N + CGVD2013 height",
  },
  {
    value: "EPSG:6654",
    label: "EPSG:6654 / NAD83(CSRS) / UTM zone 11N + CGVD2013 height",
  },
  {
    value: "EPSG:6655",
    label: "EPSG:6655 / NAD83(CSRS) / UTM zone 12N + CGVD2013 height",
  },
  {
    value: "EPSG:6656",
    label: "EPSG:6656 / NAD83(CSRS) / UTM zone 13N + CGVD2013 height",
  },
  {
    value: "EPSG:6657",
    label: "EPSG:6657 / NAD83(CSRS) / UTM zone 14N + CGVD2013 height",
  },
  {
    value: "EPSG:6658",
    label: "EPSG:6658 / NAD83(CSRS) / UTM zone 15N + CGVD2013 height",
  },
  {
    value: "EPSG:6659",
    label: "EPSG:6659 / NAD83(CSRS) / UTM zone 16N + CGVD2013 height",
  },
  {
    value: "EPSG:6660",
    label: "EPSG:6660 / NAD83(CSRS) / UTM zone 17N + CGVD2013 height",
  },
  {
    value: "EPSG:6661",
    label: "EPSG:6661 / NAD83(CSRS) / UTM zone 18N + CGVD2013 height",
  },
  {
    value: "EPSG:6662",
    label: "EPSG:6662 / NAD83(CSRS) / UTM zone 19N + CGVD2013 height",
  },
  {
    value: "EPSG:6663",
    label: "EPSG:6663 / NAD83(CSRS) / UTM zone 20N + CGVD2013 height",
  },
  {
    value: "EPSG:6664",
    label: "EPSG:6664 / NAD83(CSRS) / UTM zone 21N + CGVD2013 height",
  },
  {
    value: "EPSG:6665",
    label: "EPSG:6665 / NAD83(CSRS) / UTM zone 22N + CGVD2013 height",
  },
  {
    value: "EPSG:6696",
    label: "EPSG:6696 / JGD2000 + JGD2000 (vertical) height",
  },
  {
    value: "EPSG:6697",
    label: "EPSG:6697 / JGD2011 + JGD2011 (vertical) height",
  },
  { value: "EPSG:6700", label: "EPSG:6700 / Tokyo + JSLD72 height" },
  {
    value: "EPSG:6871",
    label: "EPSG:6871 / WGS 84 / Pseudo-Mercator +  EGM2008 geoid height",
  },
  {
    value: "EPSG:6893",
    label: "EPSG:6893 / WGS 84 / World Mercator + EGM2008 height",
  },
  { value: "EPSG:6917", label: "EPSG:6917 / SVY21 + SHD height" },
  {
    value: "EPSG:6927",
    label: "EPSG:6927 / SVY21 / Singapore TM + SHD height",
  },
  { value: "EPSG:7400", label: "EPSG:7400 / NTF (Paris) + NGF IGN69 height" },
  {
    value: "EPSG:7401",
    label: "EPSG:7401 / NTF (Paris) / France II + NGF Lallemand",
  },
  {
    value: "EPSG:7402",
    label: "EPSG:7402 / NTF (Paris) / France II + NGF IGN69",
  },
  {
    value: "EPSG:7403",
    label: "EPSG:7403 / NTF (Paris) / France III + NGF IGN69",
  },
  { value: "EPSG:7404", label: "EPSG:7404 / RT90 + RH70 height" },
  {
    value: "EPSG:7405",
    label: "EPSG:7405 / OSGB36 / British National Grid + ODN height",
  },
  { value: "EPSG:7406", label: "EPSG:7406 / NAD27 + NGVD29 height (ftUS)" },
  {
    value: "EPSG:7407",
    label: "EPSG:7407 / NAD27 / Texas North + NGVD29 height (ftUS)",
  },
  { value: "EPSG:7408", label: "EPSG:7408 / RD/NAP" },
  { value: "EPSG:7409", label: "EPSG:7409 / ETRS89 + EVRF2000 height" },
  { value: "EPSG:7410", label: "EPSG:7410 / PSHD93" },
  {
    value: "EPSG:7411",
    label: "EPSG:7411 / NTF (Paris) / Lambert zone II + NGF Lallemand height",
  },
  {
    value: "EPSG:7412",
    label: "EPSG:7412 / NTF (Paris) / Lambert zone II + NGF IGN69",
  },
  {
    value: "EPSG:7413",
    label: "EPSG:7413 / NTF (Paris) / Lambert zone III + NGF IGN69",
  },
  { value: "EPSG:7414", label: "EPSG:7414 / Tokyo + JSLD69 height" },
  { value: "EPSG:7415", label: "EPSG:7415 / Amersfoort / RD New + NAP height" },
  {
    value: "EPSG:7416",
    label: "EPSG:7416 / ETRS89 / UTM zone 32N + DVR90 height",
  },
  {
    value: "EPSG:7417",
    label: "EPSG:7417 / ETRS89 / UTM zone 33N + DVR90 height",
  },
  {
    value: "EPSG:7418",
    label: "EPSG:7418 / ETRS89 / Kp2000 Jutland + DVR90 height",
  },
  {
    value: "EPSG:7419",
    label: "EPSG:7419 / ETRS89 / Kp2000 Zealand + DVR90 height",
  },
  {
    value: "EPSG:7420",
    label: "EPSG:7420 / ETRS89 / Kp2000 Bornholm + DVR90 height",
  },
  {
    value: "EPSG:7421",
    label: "EPSG:7421 / NTF (Paris) / Lambert zone II + NGF-IGN69 height",
  },
  {
    value: "EPSG:7422",
    label: "EPSG:7422 / NTF (Paris) / Lambert zone III + NGF-IGN69 height",
  },
  { value: "EPSG:7423", label: "EPSG:7423 / ETRS89 + EVRF2007 height" },
  {
    value: "EPSG:7952",
    label: "EPSG:7952 / EPSG:7952 / OSTN02 + OSGM02 Height",
  },
  {
    value: "EPSG:7953",
    label: "EPSG:7953 / EPSG:7953 / OSTN15 + OSGM15 Height",
  },
  {
    value: "EPSG:7954",
    label: "EPSG:7954 / Astro DOS 71 / UTM zone 30S + Jamestown 1971 height",
  },
  {
    value: "EPSG:7955",
    label: "EPSG:7955 / St. Helena Tritan / UTM zone 30S + Tritan 2011 height",
  },
  { value: "EPSG:7956", label: "EPSG:7956 / SHMG2015 + SHVD2015 height" },
  { value: "EPSG:8349", label: "EPSG:8349 / GR96 + GVR2000 height" },
  { value: "EPSG:8350", label: "EPSG:8350 / GR96 + GVR2016 height" },
  { value: "EPSG:8360", label: "EPSG:8360 / ETRS89 + Baltic 1957 height" },
  {
    value: "EPSG:8370",
    label: "EPSG:8370 / ETRS89 / Belgian Lambert 2008 + Ostend height",
  },
  {
    value: "EPSG:8700",
    label: "EPSG:8700 / NAD83 / Arizona East (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8701",
    label: "EPSG:8701 / NAD83 / Arizona Central (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8702",
    label: "EPSG:8702 / NAD83 / Arizona West (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8703",
    label: "EPSG:8703 / NAD83 / Michigan North (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8704",
    label: "EPSG:8704 / NAD83 / Michigan Central (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8705",
    label: "EPSG:8705 / NAD83 / Michigan South (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8706",
    label: "EPSG:8706 / NAD83 / Montana (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8707",
    label: "EPSG:8707 / NAD83 / North Dakota North (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8708",
    label: "EPSG:8708 / NAD83 / North Dakota South (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8709",
    label: "EPSG:8709 / NAD83 / Oregon North (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8710",
    label: "EPSG:8710 / NAD83 / Oregon South (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8711",
    label: "EPSG:8711 / NAD83 / South Carolina (ft) + NAVD88 height (ft)",
  },
  {
    value: "EPSG:8712",
    label: "EPSG:8712 / NAD83 / Arkansas North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8713",
    label: "EPSG:8713 / NAD83 / Arkansas South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8714",
    label:
      "EPSG:8714 / NAD83 / California zone 1 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8715",
    label:
      "EPSG:8715 / NAD83 / California zone 2 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8716",
    label:
      "EPSG:8716 / NAD83 / California zone 3 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8717",
    label:
      "EPSG:8717 / NAD83 / California zone 4 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8718",
    label:
      "EPSG:8718 / NAD83 / California zone 5 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8719",
    label:
      "EPSG:8719 / NAD83 / California zone 6 (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8720",
    label: "EPSG:8720 / NAD83 / Colorado North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8721",
    label: "EPSG:8721 / NAD83 / Colorado Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8722",
    label: "EPSG:8722 / NAD83 / Colorado South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8723",
    label: "EPSG:8723 / NAD83 / Connecticut (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8724",
    label: "EPSG:8724 / NAD83 / Delaware (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8725",
    label: "EPSG:8725 / NAD83 / Florida North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8726",
    label: "EPSG:8726 / NAD83 / Florida East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8727",
    label: "EPSG:8727 / NAD83 / Florida West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8728",
    label: "EPSG:8728 / NAD83 / Georgia East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8729",
    label: "EPSG:8729 / NAD83 / Georgia West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8730",
    label: "EPSG:8730 / NAD83 / Idaho East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8731",
    label: "EPSG:8731 / NAD83 / Idaho Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8732",
    label: "EPSG:8732 / NAD83 / Idaho West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8733",
    label: "EPSG:8733 / NAD83 / Illinois East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8734",
    label: "EPSG:8734 / NAD83 / Illinois West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8735",
    label: "EPSG:8735 / NAD83 / Indiana East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8736",
    label: "EPSG:8736 / NAD83 / Indiana West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8737",
    label: "EPSG:8737 / NAD83 / Iowa North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8738",
    label: "EPSG:8738 / NAD83 / Iowa South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8739",
    label: "EPSG:8739 / NAD83 / Kansas North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8740",
    label: "EPSG:8740 / NAD83 / Kansas South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8741",
    label: "EPSG:8741 / NAD83 / Kentucky North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8742",
    label: "EPSG:8742 / NAD83 / Kentucky South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8743",
    label: "EPSG:8743 / NAD83 / Louisiana North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8744",
    label: "EPSG:8744 / NAD83 / Louisiana South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8745",
    label: "EPSG:8745 / NAD83 / Maine East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8746",
    label: "EPSG:8746 / NAD83 / Maine West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8747",
    label: "EPSG:8747 / NAD83 / Maryland (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8748",
    label:
      "EPSG:8748 / NAD83 / Massachusetts Mainland (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8749",
    label:
      "EPSG:8749 / NAD83 / Massachusetts Island (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8750",
    label: "EPSG:8750 / NAD83 / Minnesota North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8751",
    label:
      "EPSG:8751 / NAD83 / Minnesota Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8752",
    label: "EPSG:8752 / NAD83 / Minnesota South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8753",
    label: "EPSG:8753 / NAD83 / Mississippi East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8754",
    label: "EPSG:8754 / NAD83 / Mississippi West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8755",
    label: "EPSG:8755 / NAD83 / Nebraska (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8756",
    label: "EPSG:8756 / NAD83 / Nevada East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8757",
    label: "EPSG:8757 / NAD83 / Nevada Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8758",
    label: "EPSG:8758 / NAD83 / Nevada West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8759",
    label: "EPSG:8759 / NAD83 / New Hampshire (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8760",
    label: "EPSG:8760 / NAD83 / New Jersey (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8761",
    label: "EPSG:8761 / NAD83 / New Mexico East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8762",
    label:
      "EPSG:8762 / NAD83 / New Mexico Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8763",
    label: "EPSG:8763 / NAD83 / New Mexico West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8764",
    label: "EPSG:8764 / NAD83 / New York East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8765",
    label: "EPSG:8765 / NAD83 / New York Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8766",
    label: "EPSG:8766 / NAD83 / New York West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8767",
    label:
      "EPSG:8767 / NAD83 / New York Long Island (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8768",
    label: "EPSG:8768 / NAD83 / North Carolina (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8769",
    label: "EPSG:8769 / NAD83 / Ohio North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8770",
    label: "EPSG:8770 / NAD83 / Ohio South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8771",
    label: "EPSG:8771 / NAD83 / Oklahoma North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8772",
    label: "EPSG:8772 / NAD83 / Oklahoma South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8773",
    label:
      "EPSG:8773 / NAD83 / Pennsylvania North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8774",
    label:
      "EPSG:8774 / NAD83 / Pennsylvania South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8775",
    label: "EPSG:8775 / NAD83 / Rhode Island (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8776",
    label:
      "EPSG:8776 / NAD83 / South Dakota North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8777",
    label:
      "EPSG:8777 / NAD83 / South Dakota South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8778",
    label: "EPSG:8778 / NAD83 / Tennessee (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8779",
    label: "EPSG:8779 / NAD83 / Texas North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8780",
    label:
      "EPSG:8780 / NAD83 / Texas North Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8781",
    label: "EPSG:8781 / NAD83 / Texas Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8782",
    label:
      "EPSG:8782 / NAD83 / Texas South Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8783",
    label: "EPSG:8783 / NAD83 / Texas South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8784",
    label: "EPSG:8784 / NAD83 / Utah North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8785",
    label: "EPSG:8785 / NAD83 / Utah Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8786",
    label: "EPSG:8786 / NAD83 / Utah South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8787",
    label: "EPSG:8787 / NAD83 / Vermont (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8788",
    label: "EPSG:8788 / NAD83 / Virginia North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8789",
    label: "EPSG:8789 / NAD83 / Virginia South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8790",
    label: "EPSG:8790 / NAD83 / Washington North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8791",
    label: "EPSG:8791 / NAD83 / Washington South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8792",
    label:
      "EPSG:8792 / NAD83 / West Virginia North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8793",
    label:
      "EPSG:8793 / NAD83 / West Virginia South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8794",
    label: "EPSG:8794 / NAD83 / Wisconsin North (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8795",
    label:
      "EPSG:8795 / NAD83 / Wisconsin Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8796",
    label: "EPSG:8796 / NAD83 / Wisconsin South (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8797",
    label: "EPSG:8797 / NAD83 / Wyoming East (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8798",
    label:
      "EPSG:8798 / NAD83 / Wyoming East Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8799",
    label:
      "EPSG:8799 / NAD83 / Wyoming West Central (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8800",
    label: "EPSG:8800 / NAD83 / Wyoming West (ftUS) + NAVD88 height (ftUS)",
  },
  {
    value: "EPSG:8801",
    label: "EPSG:8801 / NAD83 / Alabama East + NAVD88 height",
  },
  {
    value: "EPSG:8802",
    label: "EPSG:8802 / NAD83 / Alabama West + NAVD88 height",
  },
  {
    value: "EPSG:8803",
    label: "EPSG:8803 / NAD83 / Alaska zone 1 + NAVD88 height",
  },
  {
    value: "EPSG:8804",
    label: "EPSG:8804 / NAD83 / Alaska zone 2 + NAVD88 height",
  },
  {
    value: "EPSG:8805",
    label: "EPSG:8805 / NAD83 / Alaska zone 3 + NAVD88 height",
  },
  {
    value: "EPSG:8806",
    label: "EPSG:8806 / NAD83 / Alaska zone 4 + NAVD88 height",
  },
  {
    value: "EPSG:8807",
    label: "EPSG:8807 / NAD83 / Alaska zone 5 + NAVD88 height",
  },
  {
    value: "EPSG:8808",
    label: "EPSG:8808 / NAD83 / Alaska zone 6 + NAVD88 height",
  },
  {
    value: "EPSG:8809",
    label: "EPSG:8809 / NAD83 / Alaska zone 7 + NAVD88 height",
  },
  {
    value: "EPSG:8810",
    label: "EPSG:8810 / NAD83 / Alaska zone 8 + NAVD88 height",
  },
  {
    value: "EPSG:8811",
    label: "EPSG:8811 / NAD83 / Alaska zone 9 + NAVD88 height",
  },
  {
    value: "EPSG:8812",
    label: "EPSG:8812 / NAD83 / Alaska zone 10 + NAVD88 height",
  },
  {
    value: "EPSG:8813",
    label: "EPSG:8813 / NAD83 / Missouri East + NAVD88 height",
  },
  {
    value: "EPSG:8814",
    label: "EPSG:8814 / NAD83 / Missouri Central + NAVD88 height",
  },
  {
    value: "EPSG:8815",
    label: "EPSG:8815 / NAD83 / Missouri West + NAVD88 height",
  },
  {
    value: "EPSG:8912",
    label: "EPSG:8912 / CR-SIRGAS / CRTM05 + DACR52 height",
  },
  { value: "EPSG:9286", label: "EPSG:9286 / ETRS89 + NAP height" },
  { value: "EPSG:9289", label: "EPSG:9289 / ETRS89 + LAT NL depth" },
  { value: "EPSG:9290", label: "EPSG:9290 / ETRS89 + MSL NL depth" },
  { value: "EPSG:9306", label: "EPSG:9306 / HS2 Survey Grid + HS2-VRF height" },
  { value: "EPSG:9368", label: "EPSG:9368 / TPEN11 Grid + ODN height" },
  { value: "EPSG:9374", label: "EPSG:9374 / MML07 Grid + ODN height" },
  { value: "EPSG:9388", label: "EPSG:9388 / AbInvA96_2020 Grid + ODN height" },
  { value: "EPSG:9422", label: "EPSG:9422 / ETRS89 + EVRF2019 height" },
  {
    value: "EPSG:9423",
    label: "EPSG:9423 / ETRS89 + EVRF2019 mean-tide height",
  },
  { value: "EPSG:9424", label: "EPSG:9424 / ETRS89 + ODN height" },
  { value: "EPSG:9425", label: "EPSG:9425 / ETRS89 + ODN (Offshore) height" },
  { value: "EPSG:9426", label: "EPSG:9426 / ETRS89 + ODN Orkney height" },
  { value: "EPSG:9427", label: "EPSG:9427 / ETRS89 + Lerwick height" },
  { value: "EPSG:9428", label: "EPSG:9428 / ETRS89 + Stornoway height" },
  { value: "EPSG:9429", label: "EPSG:9429 / ETRS89 + Douglas height" },
  { value: "EPSG:9430", label: "EPSG:9430 / ETRS89 + St. Marys height" },
  { value: "EPSG:9449", label: "EPSG:9449 / ETRS89 + Malin Head height" },
  { value: "EPSG:9450", label: "EPSG:9450 / ETRS89 + Belfast height" },
  { value: "EPSG:9452", label: "EPSG:9452 / ETRS89 + BI height" },
  { value: "EPSG:9457", label: "EPSG:9457 / GBK19 Grid + ODN height" },
  { value: "EPSG:9462", label: "EPSG:9462 / GDA2020 + AVWS height" },
  { value: "EPSG:9463", label: "EPSG:9463 / GDA2020 + AHD height" },
  { value: "EPSG:9464", label: "EPSG:9464 / GDA94 + AHD height" },
  { value: "EPSG:9500", label: "EPSG:9500 / ETRS89 + EVRF2000 Austria height" },
  { value: "EPSG:9501", label: "EPSG:9501 / MGI + EVRF2000 Austria height" },
  { value: "EPSG:9502", label: "EPSG:9502 / CIGD11 + CBVD61 height (ft)" },
  { value: "EPSG:9503", label: "EPSG:9503 / CIGD11 + GCVD54 height (ft)" },
  { value: "EPSG:9504", label: "EPSG:9504 / CIGD11 + LCVD61 height (ft)" },
  { value: "EPSG:9505", label: "EPSG:9505 / ETRS89 + Alicante height" },
  { value: "EPSG:9506", label: "EPSG:9506 / ETRS89 + Ceuta 2 height" },
  { value: "EPSG:9507", label: "EPSG:9507 / ETRS89 + Ibiza height" },
  { value: "EPSG:9508", label: "EPSG:9508 / ETRS89 + Mallorca height" },
  { value: "EPSG:9509", label: "EPSG:9509 / ETRS89 + Menorca height" },
  { value: "EPSG:9510", label: "EPSG:9510 / REGCAN95 + El Hierro height" },
  { value: "EPSG:9511", label: "EPSG:9511 / REGCAN95 + Fuerteventura height" },
  { value: "EPSG:9512", label: "EPSG:9512 / REGCAN95 + Gran Canaria height" },
  { value: "EPSG:9513", label: "EPSG:9513 / REGCAN95 + La Gomera height" },
  { value: "EPSG:9514", label: "EPSG:9514 / REGCAN95 + La Palma height" },
  { value: "EPSG:9515", label: "EPSG:9515 / REGCAN95 + Lanzarote height" },
  { value: "EPSG:9516", label: "EPSG:9516 / REGCAN95 + Tenerife height" },
  { value: "EPSG:9517", label: "EPSG:9517 / SHGD2015 + SHVD2015 height" },
  { value: "EPSG:9518", label: "EPSG:9518 / WGS 84 + EGM2008 height" },
  { value: "EPSG:9519", label: "EPSG:9519 / FEH2010 + FCSVR10 height" },
  { value: "EPSG:9520", label: "EPSG:9520 / KSA-GRF17 + KSA-VRF14 height" },
  { value: "EPSG:9521", label: "EPSG:9521 / POSGAR 2007 + SRVN16 height" },
  { value: "EPSG:9522", label: "EPSG:9522 / NAD83(2011) + PRVD02 height" },
  { value: "EPSG:9523", label: "EPSG:9523 / NAD83(2011) + VIVD09 height" },
  { value: "EPSG:9524", label: "EPSG:9524 / NAD83(MA11) + GUVD04 height" },
  { value: "EPSG:9525", label: "EPSG:9525 / NAD83(MA11) + NMVD03 height" },
  { value: "EPSG:9526", label: "EPSG:9526 / NAD83(PA11) + ASVD02 height" },
  { value: "EPSG:9527", label: "EPSG:9527 / NZGD2000 + NZVD2009 height" },
  { value: "EPSG:9528", label: "EPSG:9528 / NZGD2000 + NZVD2016 height" },
  {
    value: "EPSG:9529",
    label: "EPSG:9529 / SRGI2013 + INAGeoid2020 v1 height",
  },
  { value: "EPSG:9530", label: "EPSG:9530 / RGFG95 + NGG1977 height" },
  { value: "EPSG:9531", label: "EPSG:9531 / RGAF09 + Guadeloupe 1988 height" },
  { value: "EPSG:9532", label: "EPSG:9532 / RGAF09 + IGN 1988 LS height" },
  { value: "EPSG:9533", label: "EPSG:9533 / RGAF09 + IGN 1988 MG height" },
  { value: "EPSG:9534", label: "EPSG:9534 / RGAF09 + IGN 1988 SB height" },
  { value: "EPSG:9535", label: "EPSG:9535 / RGAF09 + IGN 1988 SM height" },
  { value: "EPSG:9536", label: "EPSG:9536 / RGAF09 + IGN 2008 LD height" },
  { value: "EPSG:9537", label: "EPSG:9537 / RGAF09 + Martinique 1987 height" },
  { value: "EPSG:9538", label: "EPSG:9538 / RGF93 v2 + NGF-IGN69 height" },
  { value: "EPSG:9539", label: "EPSG:9539 / RGF93 v2 + NGF-IGN78 height" },
  { value: "EPSG:9540", label: "EPSG:9540 / RGNC91-93 + NGNC08 height" },
  { value: "EPSG:9541", label: "EPSG:9541 / RGSPM06 + Danger 1950 height" },
  { value: "EPSG:9542", label: "EPSG:9542 / RRAF 1991 + IGN 2008 LD height" },
  { value: "EPSG:9543", label: "EPSG:9543 / ITRF2005 + SA LLD height" },
  {
    value: "EPSG:9544",
    label: "EPSG:9544 / NAD83(CSRS)v6 + CGVD2013a(2010) height",
  },
  { value: "EPSG:9656", label: "EPSG:9656 / ETRF2000-PL + Baltic 1986 height" },
  { value: "EPSG:9657", label: "EPSG:9657 / ETRF2000-PL + EVRF2007-PL height" },
  { value: "EPSG:9705", label: "EPSG:9705 / WGS 84 + MSL height" },
  { value: "EPSG:9707", label: "EPSG:9707 / WGS 84 + EGM96 height" },
  {
    value: "EPSG:9711",
    label: "EPSG:9711 / NAD83(CSRS) / UTM zone 23N + CGVD2013 height",
  },
  {
    value: "EPSG:9714",
    label: "EPSG:9714 / NAD83(CSRS) / UTM zone 24N + CGVD2013 height",
  },
  {
    value: "EPSG:9715",
    label: "EPSG:9715 / NAD83(CSRS) / UTM zone 15N + CGVD2013a(2010) height",
  },
  { value: "EPSG:9723", label: "EPSG:9723 / ETRS89 + Genoa 1942 height" },
  { value: "EPSG:9724", label: "EPSG:9724 / ETRS89 + Catania 1965 height" },
  { value: "EPSG:9725", label: "EPSG:9725 / ETRS89 + Cagliari 1956 height" },
  { value: "EPSG:9742", label: "EPSG:9742 / EOS21 Grid + ODN height" },
  { value: "EPSG:9762", label: "EPSG:9762 / ECML14_NB Grid + ODN height" },
  { value: "EPSG:9767", label: "EPSG:9767 / EWR2 Grid + ODN height" },
  { value: "EPSG:9785", label: "EPSG:9785 / RGF93 v2b + NGF-IGN69 height" },
  { value: "EPSG:9870", label: "EPSG:9870 / MRH21 Grid + ODN height" },
  { value: "EPSG:9881", label: "EPSG:9881 / MOLDOR11 Grid + ODN height" },
  { value: "EPSG:9883", label: "EPSG:9883 / ETRS89 + CD Norway depth" },
  {
    value: "EPSG:9897",
    label: "EPSG:9897 / LUREF / Luxembourg TM + NG95 height",
  },
  { value: "EPSG:9907", label: "EPSG:9907 / ETRS89 + Ostend height" },
  {
    value: "EPSG:9920",
    label: "EPSG:9920 / OSGB36 / British National Grid + BI height",
  },
  { value: "EPSG:9922", label: "EPSG:9922 / ETRS89 / ITM + BI height" },
  { value: "EPSG:9924", label: "EPSG:9924 / ETRS89 + DHHN2016 height" },
  { value: "EPSG:9928", label: "EPSG:9928 / DB_REF2003 zone 2" },
  { value: "EPSG:9929", label: "EPSG:9929 / DB_REF2003 zone 3" },
  { value: "EPSG:9930", label: "EPSG:9930 / DB_REF2003 zone 4" },
  { value: "EPSG:9931", label: "EPSG:9931 / DB_REF2003 zone 5" },
  { value: "EPSG:9932", label: "EPSG:9932 / DB_REF2016 zone 2" },
  { value: "EPSG:9933", label: "EPSG:9933 / DB_REF2016 zone 3" },
  { value: "EPSG:9934", label: "EPSG:9934 / DB_REF2016 zone 4" },
  { value: "EPSG:9935", label: "EPSG:9935 / DB_REF2016 zone 5" },
  { value: "EPSG:9944", label: "EPSG:9944 / EBBWV14 Grid + ODN height" },
  { value: "EPSG:9948", label: "EPSG:9948 / ISN93 + ISH2004 height " },
  { value: "EPSG:9949", label: "EPSG:9949 / ISN2004 + ISH2004 height" },
  { value: "EPSG:9950", label: "EPSG:9950 / ISN2016 + ISH2004 height" },
  {
    value: "EPSG:9951",
    label: "EPSG:9951 / ISN93 / Lambert 1993 + ISH2004 height",
  },
  {
    value: "EPSG:9952",
    label: "EPSG:9952 / ISN2004 / Lambert 2004 + ISH2004 height",
  },
  {
    value: "EPSG:9953",
    label: "EPSG:9953 / ISN2016 / Lambert 2016 + ISH2004 height",
  },
  { value: "EPSG:9968", label: "EPSG:9968 / HULLEE13 Grid + ODN height" },
  { value: "EPSG:9973", label: "EPSG:9973 / SCM22 Grid + ODN height" },
  { value: "EPSG:9978", label: "EPSG:9978 / FNL22 Grid + ODN height" },
  { value: "EPSG:20001", label: "EPSG:20001 / ETRS89 + SVD2006 height" },
  { value: "EPSG:20003", label: "EPSG:20003 / MWC18 Grid + ODN height" },
  {
    value: "EPSG:20037",
    label: "EPSG:20037 / NAD83(CSRS)v4 + CGVD2013a(2002) height",
  },
  {
    value: "EPSG:20038",
    label: "EPSG:20038 / NAD83(CSRS)v3 + CGVD2013a(1997) height",
  },
  {
    value: "EPSG:20043",
    label: "EPSG:20043 / SRGI2013 + INAGeoid2020 v2 height",
  },
  {
    value: "IGNF:ATIGBONNE.BOURD",
    label:
      "IGNF:ATIGBONNE.BOURD / ATIG Bonne France Etat Major et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:ATIGBONNE.NGF84",
    label:
      "IGNF:ATIGBONNE.NGF84 / ATIG Bonne France Etat Major et NGF-LALLEMAND",
  },
  {
    value: "IGNF:ATIGG.BOURD",
    label:
      "IGNF:ATIGG.BOURD / ATIG geographiques grades Paris (gr) et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:ATIGG.NGF84",
    label:
      "IGNF:ATIGG.NGF84 / ATIG geographiques grades Paris (gr) et NGF-LALLEMAND",
  },
  {
    value: "IGNF:C67IG95G.GUYA77",
    label:
      "IGNF:C67IG95G.GUYA77 / CSG67 (IGN 1995) geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:C67IG95UTM21.GUYA77",
    label:
      "IGNF:C67IG95UTM21.GUYA77 / CSG67(IGN 1995) UTM Nord fuseau 21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:C67IG95UTM22.GUYA77",
    label:
      "IGNF:C67IG95UTM22.GUYA77 / CSG67 (IGN 1995) UTM Nord fuseau 22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:CAD97G.MAYO53",
    label:
      "IGNF:CAD97G.MAYO53 / Cadastre 1997 geographiques (dms) et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:CAD97UTM38S.MAYO53",
    label:
      "IGNF:CAD97UTM38S.MAYO53 / Cadastre 1997 UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:CSG67G.GUYA77",
    label:
      "IGNF:CSG67G.GUYA77 / CSG67 geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:CSG67UTM21.GUYA77",
    label:
      "IGNF:CSG67UTM21.GUYA77 / CSG67 UTM Nord fuseau 21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:CSG67UTM22.GUYA77",
    label:
      "IGNF:CSG67UTM22.GUYA77 / CSG67 UTM Nord fuseau 22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:ED50G.IGN69",
    label: "IGNF:ED50G.IGN69 / ED50 geographiques (dms) et NGF-IGN 1969",
  },
  {
    value: "IGNF:ED50G.IGN78C",
    label: "IGNF:ED50G.IGN78C / ED50 geographiques (dms) et NGF-IGN 1978",
  },
  {
    value: "IGNF:ED50G.NGC48",
    label:
      "IGNF:ED50G.NGC48 / ED50 geographiques (dms) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:ED50G.NGF84",
    label: "IGNF:ED50G.NGF84 / ED50 geographiques (dms) et NGF-LALLEMAND",
  },
  {
    value: "IGNF:ED50UTM30.IGN69",
    label: "IGNF:ED50UTM30.IGN69 / ED50 UTM fuseau 30 et NGF-IGN 1969",
  },
  {
    value: "IGNF:ED50UTM30.NGF84",
    label: "IGNF:ED50UTM30.NGF84 / ED50 UTM fuseau 30 et NGF-LALLEMAND",
  },
  {
    value: "IGNF:ED50UTM31.IGN69",
    label: "IGNF:ED50UTM31.IGN69 / ED50 UTM NORD FUSEAU 31 et NGF-IGN 1969",
  },
  {
    value: "IGNF:ED50UTM31.NGF84",
    label: "IGNF:ED50UTM31.NGF84 / ED50 UTM NORD FUSEAU 31 et NGF-LALLEMAND",
  },
  {
    value: "IGNF:ED50UTM32.IGN69",
    label: "IGNF:ED50UTM32.IGN69 / ED50 UTM fuseau 32 et NGF-IGN 1969",
  },
  {
    value: "IGNF:ED50UTM32.IGN78C",
    label: "IGNF:ED50UTM32.IGN78C / ED50 UTM fuseau 32 et NGF-IGN 1978",
  },
  {
    value: "IGNF:ED50UTM32.NGC48",
    label:
      "IGNF:ED50UTM32.NGC48 / ED50 UTM fuseau 32 et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:ED50UTM32.NGF84",
    label: "IGNF:ED50UTM32.NGF84 / ED50 UTM fuseau 32 et NGF-LALLEMAND",
  },
  {
    value: "IGNF:ETRS89G.EVRF2000",
    label:
      "IGNF:ETRS89G.EVRF2000 / ETRS89 geographiques (dms) et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89LAEA.EVRF2000",
    label:
      "IGNF:ETRS89LAEA.EVRF2000 / ETRS89 Lambert Azimutal Equal Area et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89LCC.EVRF2000",
    label:
      "IGNF:ETRS89LCC.EVRF2000 / ETRS89 Lambert Conformal Conic et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM29.EVRF2000",
    label:
      "IGNF:ETRS89UTM29.EVRF2000 / ETRS89 UTM Nord fuseau 29 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM30.EVRF2000",
    label:
      "IGNF:ETRS89UTM30.EVRF2000 / ETRS89 UTM Nord fuseau 30 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM31.EVRF2000",
    label:
      "IGNF:ETRS89UTM31.EVRF2000 / ETRS89 UTM Nord fuseau 31 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM32.EVRF2000",
    label:
      "IGNF:ETRS89UTM32.EVRF2000 / ETRS89 UTM Nord fuseau 32 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM33.EVRF2000",
    label:
      "IGNF:ETRS89UTM33.EVRF2000 / ETRS89 UTM Nord fuseau 33 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM34.EVRF2000",
    label:
      "IGNF:ETRS89UTM34.EVRF2000 / ETRS89 UTM Nord fuseau 34 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM35.EVRF2000",
    label:
      "IGNF:ETRS89UTM35.EVRF2000 / ETRS89 UTM Nord fuseau 35 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:ETRS89UTM36.EVRF2000",
    label:
      "IGNF:ETRS89UTM36.EVRF2000 / ETRS89 UTM Nord fuseau 36 et EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:GLOR77G.GLOR77",
    label:
      "IGNF:GLOR77G.GLOR77 / Glorieuses geographiques (dms) et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
  },
  {
    value: "IGNF:GLOR77MD.GLOR77",
    label:
      "IGNF:GLOR77MD.GLOR77 / Glorieuses Mercator directe et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
  },
  {
    value: "IGNF:GLOR77UTM38S.GLOR77",
    label:
      "IGNF:GLOR77UTM38S.GLOR77 / GLORIEUSES MHG 1977 UTM SUD FUSEAU 38 et SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
  },
  {
    value: "IGNF:GUADANNG.GUAD88",
    label:
      "IGNF:GUADANNG.GUAD88 / Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:GUADANNG.GUAD88LS",
    label:
      "IGNF:GUADANNG.GUAD88LS / Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:GUADANNG.GUAD88MG",
    label:
      "IGNF:GUADANNG.GUAD88MG / Guadeloupe Sainte-Anne geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:GUADANNG.GUAD92LD",
    label:
      "IGNF:GUADANNG.GUAD92LD / Guadeloupe Sainte-Anne geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:GUADANNUTM20.GUAD88",
    label:
      "IGNF:GUADANNUTM20.GUAD88 / Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:GUADANNUTM20.GUAD88LS",
    label:
      "IGNF:GUADANNUTM20.GUAD88LS / Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:GUADANNUTM20.GUAD88MG",
    label:
      "IGNF:GUADANNUTM20.GUAD88MG / Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:GUADANNUTM20.GUAD92LD",
    label:
      "IGNF:GUADANNUTM20.GUAD92LD / Guadeloupe Ste Anne UTM Nord fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:GUADFMG.GUAD88SB",
    label:
      "IGNF:GUADFMG.GUAD88SB / Guadeloupe Fort-Marigot geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:GUADFMG.GUAD88SM",
    label:
      "IGNF:GUADFMG.GUAD88SM / Guadeloupe Fort-Marigot geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:GUADFMUTM20.GUAD88SB",
    label:
      "IGNF:GUADFMUTM20.GUAD88SB / Guadeloupe Fort-Marigot UTM Nord fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:GUADFMUTM20.GUAD88SM",
    label:
      "IGNF:GUADFMUTM20.GUAD88SM / Guadeloupe Fort-Marigot UTM Nord fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:IGN72G.NCAL69",
    label:
      "IGNF:IGN72G.NCAL69 / IGN72 geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:IGN72UTM58S.NCAL69",
    label:
      "IGNF:IGN72UTM58S.NCAL69 / IGN72 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:KERG62G.KERG62",
    label:
      "IGNF:KERG62G.KERG62 / Kerguelen geographiques (dms) et IGN 1962 (KERGUELEN)",
  },
  {
    value: "IGNF:KERG62UTM42S.KERG62",
    label:
      "IGNF:KERG62UTM42S.KERG62 / KERGUELEN K0 IGN 1962 UTM SUD FUSEAU 42 et IGN 1962 (KERGUELEN)",
  },
  {
    value: "IGNF:LIFOU56G.LIFOU91",
    label:
      "IGNF:LIFOU56G.LIFOU91 / Lifou IGN 56 geographiques (dms) et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
  },
  {
    value: "IGNF:LIFOU56UT58S.LIFOU91",
    label:
      "IGNF:LIFOU56UT58S.LIFOU91 / Lifou IGN 56 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
  },
  {
    value: "IGNF:LURESGKL.NNLUX",
    label:
      "IGNF:LURESGKL.NNLUX / NOUVELLE TRIANGULATION DU DUCHE DU LUXEMBOURG GAUSS KRUGER LUXEMBOURG et NIVELLEMENT GENERAL DU LUXEMBOURG",
  },
  {
    value: "IGNF:MARE53G.MARE91",
    label:
      "IGNF:MARE53G.MARE91 / Mare IGN53 geographiques (dms) et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
  },
  {
    value: "IGNF:MARE53UTM58S.MARE91",
    label:
      "IGNF:MARE53UTM58S.MARE91 / Mare IGN53 UTM Sud fuseau 58 et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
  },
  {
    value: "IGNF:MARTFDG.MART87",
    label:
      "IGNF:MARTFDG.MART87 / Martinique Fort-Desaix geographiques (dms) et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:MARTFDUTM20.MART87",
    label:
      "IGNF:MARTFDUTM20.MART87 / Martinique Fort-Desaix UTM Nord fuseau 20 et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:MAUPITIG.MAUPITI01",
    label:
      "IGNF:MAUPITIG.MAUPITI01 / Maupiti (MOP 1983) geographiques (dms) et MAUPITI_SAU 2001",
  },
  {
    value: "IGNF:MAUPITIUTM5S.MAUPITI01",
    label:
      "IGNF:MAUPITIUTM5S.MAUPITI01 / Maupiti (MOP 1983) UTM Sud fuseau 5 et MAUPITI_SAU 2001",
  },
  {
    value: "IGNF:MAYO50G.MAYO53",
    label:
      "IGNF:MAYO50G.MAYO53 / Combani triangulation IGN 1950 geographiques (dms) et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:MAYO50UTM38S.MAYO53",
    label:
      "IGNF:MAYO50UTM38S.MAYO53 / Combani UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:MOORE87UTM6S.MOOREA81",
    label:
      "IGNF:MOORE87UTM6S.MOOREA81 / Moorea 1987 UTM Sud fuseau 6 et MOOREA 1981 (MOOREA_SAU 2001)",
  },
  {
    value: "IGNF:MOOREA87G.MOOREA81",
    label:
      "IGNF:MOOREA87G.MOOREA81 / Moorea 1987 geographiques (dms) et MOOREA 1981 (MOOREA_SAU 2001)",
  },
  {
    value: "IGNF:NEA74G.NCAL69",
    label:
      "IGNF:NEA74G.NCAL69 / NEA74 NOUMEA geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:NEA74LBTNM2.NCAL69",
    label:
      "IGNF:NEA74LBTNM2.NCAL69 / NEA74 NOUMEA Lambert Noumea 2 et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:NTFLAMB1.BOURD",
    label: "IGNF:NTFLAMB1.BOURD / NTF Lambert I et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:NTFLAMB1.IGN69",
    label: "IGNF:NTFLAMB1.IGN69 / NTF Lambert I et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB1.NGF84",
    label: "IGNF:NTFLAMB1.NGF84 / NTF Lambert I et NGF-LALLEMAND",
  },
  {
    value: "IGNF:NTFLAMB1C.IGN69",
    label: "IGNF:NTFLAMB1C.IGN69 / NTF Lambert I carto et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB2.BOURD",
    label: "IGNF:NTFLAMB2.BOURD / NTF Lambert II et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:NTFLAMB2.IGN69",
    label: "IGNF:NTFLAMB2.IGN69 / NTF Lambert II et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB2.NGF84",
    label: "IGNF:NTFLAMB2.NGF84 / NTF Lambert II et NGF-LALLEMAND",
  },
  {
    value: "IGNF:NTFLAMB2C.IGN69",
    label: "IGNF:NTFLAMB2C.IGN69 / NTF Lambert II carto et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB2E.BOURD",
    label: "IGNF:NTFLAMB2E.BOURD / NTF Lambert II etendu et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:NTFLAMB2E.IGN69",
    label: "IGNF:NTFLAMB2E.IGN69 / NTF Lambert II etendu et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB2E.IGN78C",
    label: "IGNF:NTFLAMB2E.IGN78C / NTF Lambert II etendu et NGF-IGN 1978",
  },
  {
    value: "IGNF:NTFLAMB2E.NGC48",
    label:
      "IGNF:NTFLAMB2E.NGC48 / NTF Lambert II etendu et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:NTFLAMB2E.NGF84",
    label: "IGNF:NTFLAMB2E.NGF84 / NTF Lambert II etendu et NGF-LALLEMAND",
  },
  {
    value: "IGNF:NTFLAMB3.BOURD",
    label: "IGNF:NTFLAMB3.BOURD / NTF Lambert III et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:NTFLAMB3.IGN69",
    label: "IGNF:NTFLAMB3.IGN69 / NTF Lambert III et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB3.NGF84",
    label: "IGNF:NTFLAMB3.NGF84 / NTF Lambert III et NGF-LALLEMAND",
  },
  {
    value: "IGNF:NTFLAMB3C.IGN69",
    label: "IGNF:NTFLAMB3C.IGN69 / NTF Lambert III carto et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFLAMB4.IGN78C",
    label: "IGNF:NTFLAMB4.IGN78C / NTF Lambert IV et NGF-IGN 1978",
  },
  {
    value: "IGNF:NTFLAMB4.NGC48",
    label:
      "IGNF:NTFLAMB4.NGC48 / NTF Lambert IV et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:NTFLAMB4C.IGN78C",
    label: "IGNF:NTFLAMB4C.IGN78C / NTF Lambert IV carto et NGF-IGN 1978",
  },
  {
    value: "IGNF:NTFPGRAD.BOURD",
    label:
      "IGNF:NTFPGRAD.BOURD / NTF geographiques Paris (gr) et NGF-BOURDALOUE",
  },
  {
    value: "IGNF:NTFPGRAD.IGN69",
    label: "IGNF:NTFPGRAD.IGN69 / NTF geographiques Paris (gr) et NGF-IGN 1969",
  },
  {
    value: "IGNF:NTFPGRAD.IGN78C",
    label:
      "IGNF:NTFPGRAD.IGN78C / NTF geographiques Paris (gr) et NGF-IGN 1978",
  },
  {
    value: "IGNF:NTFPGRAD.NGC48",
    label:
      "IGNF:NTFPGRAD.NGC48 / NTF geographiques Paris (gr) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:NTFPGRAD.NGF84",
    label:
      "IGNF:NTFPGRAD.NGF84 / NTF geographiques Paris (gr) et NGF-LALLEMAND",
  },
  {
    value: "IGNF:PDN08GAUSSL.REUN89",
    label:
      "IGNF:PDN08GAUSSL.REUN89 / Piton des Neiges (2008) Gauss Laborde Reunion et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:PDN92GAUSSL.REUN89",
    label:
      "IGNF:PDN92GAUSSL.REUN89 / Piton des Neiges (1992) Gauss Laborde Reunion et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:REUN49G.REUN89",
    label:
      "IGNF:REUN49G.REUN89 / Reunion Piton des Neiges geographiques (dms) et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:REUN49GAUSSL.REUN89",
    label:
      "IGNF:REUN49GAUSSL.REUN89 / Reunion Piton des Neiges Gauss Laborde et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:RGAF09G.GUAD2008LD",
    label:
      "IGNF:RGAF09G.GUAD2008LD / RGAF09 geographiques (dms) et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09G.GUAD88",
    label:
      "IGNF:RGAF09G.GUAD88 / RGAF09 geographiques (dms) et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:RGAF09G.GUAD88LS",
    label:
      "IGNF:RGAF09G.GUAD88LS / RGAF09 geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:RGAF09G.GUAD88MG",
    label:
      "IGNF:RGAF09G.GUAD88MG / RGAF09 geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:RGAF09G.GUAD88SB",
    label:
      "IGNF:RGAF09G.GUAD88SB / RGAF09 geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:RGAF09G.GUAD88SM",
    label:
      "IGNF:RGAF09G.GUAD88SM / RGAF09 geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:RGAF09G.GUAD92LD",
    label:
      "IGNF:RGAF09G.GUAD92LD / RGAF09 geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09G.MART87",
    label:
      "IGNF:RGAF09G.MART87 / RGAF09 geographiques (dms) et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD2008LD",
    label:
      "IGNF:RGAF09GDD.GUAD2008LD / RGAF09 geographiques (dd) et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD88",
    label:
      "IGNF:RGAF09GDD.GUAD88 / RGAF09 geographiques (dd) et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD88LS",
    label:
      "IGNF:RGAF09GDD.GUAD88LS / RGAF09 geographiques (dd) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD88MG",
    label:
      "IGNF:RGAF09GDD.GUAD88MG / RGAF09 geographiques (dd) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD88SB",
    label:
      "IGNF:RGAF09GDD.GUAD88SB / RGAF09 geographiques (dd) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD88SM",
    label:
      "IGNF:RGAF09GDD.GUAD88SM / RGAF09 geographiques (dd) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:RGAF09GDD.GUAD92LD",
    label:
      "IGNF:RGAF09GDD.GUAD92LD / RGAF09 geographiques (dd) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09GDD.MART87",
    label:
      "IGNF:RGAF09GDD.MART87 / RGAF09 geographiques (dd) et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD2008LD",
    label:
      "IGNF:RGAF09UTM20.GUAD2008LD / RGAF09 UTM Nord Fuseau 20 et IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD88",
    label:
      "IGNF:RGAF09UTM20.GUAD88 / RGAF09 UTM Nord Fuseau 20 et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD88LS",
    label:
      "IGNF:RGAF09UTM20.GUAD88LS / RGAF09 UTM Nord Fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD88MG",
    label:
      "IGNF:RGAF09UTM20.GUAD88MG / RGAF09 UTM Nord Fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD88SB",
    label:
      "IGNF:RGAF09UTM20.GUAD88SB / RGAF09 UTM Nord Fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD88SM",
    label:
      "IGNF:RGAF09UTM20.GUAD88SM / RGAF09 UTM Nord Fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:RGAF09UTM20.GUAD92LD",
    label:
      "IGNF:RGAF09UTM20.GUAD92LD / RGAF09 UTM Nord Fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RGAF09UTM20.MART87",
    label:
      "IGNF:RGAF09UTM20.MART87 / RGAF09 UTM Nord Fuseau 20 et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:RGF93CC42.IGN69",
    label: "IGNF:RGF93CC42.IGN69 / RGF93 CC42 zone 1 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC42.IGN78C",
    label: "IGNF:RGF93CC42.IGN78C / RGF93 CC42 zone 1 et NGF-IGN 1978",
  },
  {
    value: "IGNF:RGF93CC43.IGN69",
    label: "IGNF:RGF93CC43.IGN69 / RGF93 CC43 zone 2 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC43.IGN78C",
    label: "IGNF:RGF93CC43.IGN78C / RGF93 CC43 zone 2 et NGF-IGN 1978",
  },
  {
    value: "IGNF:RGF93CC44.IGN69",
    label: "IGNF:RGF93CC44.IGN69 / RGF93 CC44 zone 3 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC45.IGN69",
    label: "IGNF:RGF93CC45.IGN69 / RGF93 CC45 zone 4 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC46.IGN69",
    label: "IGNF:RGF93CC46.IGN69 / RGF93 CC46 zone 5 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC47.IGN69",
    label: "IGNF:RGF93CC47.IGN69 / RGF93 CC47 zone 6 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC48.IGN69",
    label: "IGNF:RGF93CC48.IGN69 / RGF93 CC48 zone 7 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC49.IGN69",
    label: "IGNF:RGF93CC49.IGN69 / RGF93 CC49 zone 8 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93CC50.IGN69",
    label: "IGNF:RGF93CC50.IGN69 / RGF93 CC50 zone 9 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93G.IGN69",
    label: "IGNF:RGF93G.IGN69 / RGF93 geographiques (dms) et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93G.IGN78C",
    label: "IGNF:RGF93G.IGN78C / RGF93 geographiques (dms) et NGF-IGN 1978",
  },
  {
    value: "IGNF:RGF93LAMB93.IGN69",
    label: "IGNF:RGF93LAMB93.IGN69 / RGF93 Lambert 93 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93LAMB93.IGN78C",
    label: "IGNF:RGF93LAMB93.IGN78C / RGF93 Lambert 93 et NGF-IGN 1978",
  },
  {
    value: "IGNF:RGF93UTM30.IGN69",
    label: "IGNF:RGF93UTM30.IGN69 / RGF93 UTM NORD FUSEAU 30 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93UTM31.IGN69",
    label: "IGNF:RGF93UTM31.IGN69 / RGF93 UTM fuseau 31 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93UTM32.IGN69",
    label: "IGNF:RGF93UTM32.IGN69 / RGF93 UTM fuseau 32 et NGF-IGN 1969",
  },
  {
    value: "IGNF:RGF93UTM32.IGN78C",
    label: "IGNF:RGF93UTM32.IGN78C / RGF93 UTM fuseau 32 et NGF-IGN 1978",
  },
  {
    value: "IGNF:RGFG95G.GUYA77",
    label:
      "IGNF:RGFG95G.GUYA77 / RGFG95 geographiques (dms) et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:RGFG95UTM21.GUYA77",
    label:
      "IGNF:RGFG95UTM21.GUYA77 / RGFG95 UTM Nord f.21 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:RGFG95UTM22.GUYA77",
    label:
      "IGNF:RGFG95UTM22.GUYA77 / RGFG95 UTM Nord f.22 et NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  {
    value: "IGNF:RGM04G.MAYO53",
    label:
      "IGNF:RGM04G.MAYO53 / RGM04 geographiques (dms) et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:RGM04GDD.MAYO53",
    label:
      "IGNF:RGM04GDD.MAYO53 / RGM04 geographiques (dd) et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:RGM04UTM38S.MAYO53",
    label:
      "IGNF:RGM04UTM38S.MAYO53 / RGM04 UTM Sud fuseau 38 et SHOM 1953 (MAYOTTE)",
  },
  {
    value: "IGNF:RGNCG.LIFOU91",
    label:
      "IGNF:RGNCG.LIFOU91 / RGNC geographiques (dms) et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
  },
  {
    value: "IGNF:RGNCG.MARE91",
    label:
      "IGNF:RGNCG.MARE91 / RGNC geographiques (dms) et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
  },
  {
    value: "IGNF:RGNCG.NCAL69",
    label:
      "IGNF:RGNCG.NCAL69 / RGNC geographiques (dms) et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:RGNCG.PINS78",
    label:
      "IGNF:RGNCG.PINS78 / RGNC geographiques (dms) et SHOM 1978 (ILE DES PINS)",
  },
  {
    value: "IGNF:RGNCLAMBNC.LIFOU91",
    label:
      "IGNF:RGNCLAMBNC.LIFOU91 / RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
  },
  {
    value: "IGNF:RGNCLAMBNC.MARE91",
    label:
      "IGNF:RGNCLAMBNC.MARE91 / RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
  },
  {
    value: "IGNF:RGNCLAMBNC.NCAL69",
    label:
      "IGNF:RGNCLAMBNC.NCAL69 / RGNC Lambert Nouvelle-Caledonie et NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:RGNCLAMBNC.PINS78",
    label:
      "IGNF:RGNCLAMBNC.PINS78 / RGNC Lambert Nouvelle-Caledonie et SHOM 1978 (ILE DES PINS)",
  },
  {
    value: "IGNF:RGPFG.BORA01",
    label: "IGNF:RGPFG.BORA01 / RGPF geographiques (dms) et BORA_SAU 2001",
  },
  {
    value: "IGNF:RGPFG.HUAH01",
    label: "IGNF:RGPFG.HUAH01 / RGPF geographiques (dms) et HUAHINE_SAU 2001",
  },
  {
    value: "IGNF:RGPFG.MAUPITI01",
    label:
      "IGNF:RGPFG.MAUPITI01 / RGPF geographiques (dms) et MAUPITI_SAU 2001",
  },
  {
    value: "IGNF:RGPFG.MOOREA81",
    label:
      "IGNF:RGPFG.MOOREA81 / RGPF geographiques (dms) et MOOREA 1981 (MOOREA_SAU 2001)",
  },
  {
    value: "IGNF:RGPFG.RAIA01",
    label: "IGNF:RGPFG.RAIA01 / RGPF geographiques (dms) et RAIATEA_SAU 2001",
  },
  {
    value: "IGNF:RGPFG.TAHAA01",
    label: "IGNF:RGPFG.TAHAA01 / RGPF geographiques (dms) et TAHAA_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM5S.BORA01",
    label: "IGNF:RGPFUTM5S.BORA01 / RGPF UTM Sud fuseau 5 et BORA_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM5S.HUAH01",
    label: "IGNF:RGPFUTM5S.HUAH01 / RGPF UTM Sud fuseau 5 et HUAHINE_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM5S.MAUPITI01",
    label:
      "IGNF:RGPFUTM5S.MAUPITI01 / RGPF UTM Sud fuseau 5 et MAUPITI_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM5S.RAIA01",
    label: "IGNF:RGPFUTM5S.RAIA01 / RGPF UTM Sud fuseau 5 et RAIATEA_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM5S.TAHAA01",
    label: "IGNF:RGPFUTM5S.TAHAA01 / RGPF UTM Sud fuseau 5 et TAHAA_SAU 2001",
  },
  {
    value: "IGNF:RGPFUTM6S.MOOREA81",
    label:
      "IGNF:RGPFUTM6S.MOOREA81 / RGPF UTM Sud fuseau 6 et MOOREA 1981 (MOOREA_SAU 2001)",
  },
  {
    value: "IGNF:RGR92G.REUN89",
    label:
      "IGNF:RGR92G.REUN89 / RGR92 geographiques (dms) et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:RGR92UTM40S.REUN89",
    label: "IGNF:RGR92UTM40S.REUN89 / RGR92 UTM 40 Sud et IGN 1989 (REUNION)",
  },
  {
    value: "IGNF:RGSPM06G.STPM50",
    label:
      "IGNF:RGSPM06G.STPM50 / RGSPM06 geographiques (dms) et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
  },
  {
    value: "IGNF:RGSPM06U21.STPM50",
    label:
      "IGNF:RGSPM06U21.STPM50 / RGSPM06 UTM Nord fuseau 21 et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
  },
  {
    value: "IGNF:RGTAAF07G.KERG62",
    label:
      "IGNF:RGTAAF07G.KERG62 / RGTAAF07 geographiques (dms) et IGN 1962 (KERGUELEN)",
  },
  {
    value: "IGNF:RGTAAF07GDD.KERG62",
    label:
      "IGNF:RGTAAF07GDD.KERG62 / RGTAAF07 geographiques (dd) et IGN 1962 (KERGUELEN)",
  },
  {
    value: "IGNF:RGTAAFUTM42S.KERG62",
    label:
      "IGNF:RGTAAFUTM42S.KERG62 / RGTAAF07 UTM Sud fuseau 42 et IGN 1962 (KERGUELEN)",
  },
  {
    value: "IGNF:RGWF96GEO.FUTUNA1997",
    label:
      "IGNF:RGWF96GEO.FUTUNA1997 / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS) et NGWF ILES HORN (FUTUNA ET ALOFI)",
  },
  {
    value: "IGNF:RGWF96GEO.WALLIS96",
    label:
      "IGNF:RGWF96GEO.WALLIS96 / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 GEOGRAPHIQUES (DMS) et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:RGWF96UTM1S.FUTUNA1997",
    label:
      "IGNF:RGWF96UTM1S.FUTUNA1997 / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1 et NGWF ILES HORN (FUTUNA ET ALOFI)",
  },
  {
    value: "IGNF:RGWF96UTM1S.WALLIS96",
    label:
      "IGNF:RGWF96UTM1S.WALLIS96 / RESEAU GEODESIQUE DE WALLIS ET FUTUNA 1996 UTM SUD FUSEAU 1 et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:RRAFG.GUAD88",
    label:
      "IGNF:RRAFG.GUAD88 / RRAF geographiques (dms) et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:RRAFG.GUAD88LS",
    label:
      "IGNF:RRAFG.GUAD88LS / RRAF geographiques (dms) et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:RRAFG.GUAD88MG",
    label:
      "IGNF:RRAFG.GUAD88MG / RRAF geographiques (dms) et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:RRAFG.GUAD88SB",
    label:
      "IGNF:RRAFG.GUAD88SB / RRAF geographiques (dms) et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:RRAFG.GUAD88SM",
    label:
      "IGNF:RRAFG.GUAD88SM / RRAF geographiques (dms) et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:RRAFG.GUAD92LD",
    label:
      "IGNF:RRAFG.GUAD92LD / RRAF geographiques (dms) et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RRAFG.MART87",
    label:
      "IGNF:RRAFG.MART87 / RRAF geographiques (dms) et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD88",
    label:
      "IGNF:RRAFUTM20.GUAD88 / RRAF UTM Nord fuseau 20 et IGN 1988 (GUADELOUPE)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD88LS",
    label:
      "IGNF:RRAFUTM20.GUAD88LS / RRAF UTM Nord fuseau 20 et IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD88MG",
    label:
      "IGNF:RRAFUTM20.GUAD88MG / RRAF UTM Nord fuseau 20 et IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD88SB",
    label:
      "IGNF:RRAFUTM20.GUAD88SB / RRAF UTM Nord fuseau 20 et IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD88SM",
    label:
      "IGNF:RRAFUTM20.GUAD88SM / RRAF UTM Nord fuseau 20 et IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:RRAFUTM20.GUAD92LD",
    label:
      "IGNF:RRAFUTM20.GUAD92LD / RRAF UTM Nord fuseau 20 et IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:RRAFUTM20.MART87",
    label:
      "IGNF:RRAFUTM20.MART87 / RRAF UTM Nord fuseau 20 et IGN 1987 (MARTINIQUE)",
  },
  {
    value: "IGNF:ST84G.PINS78",
    label:
      "IGNF:ST84G.PINS78 / ST 84 ILE DES PINS geographiques (dms) et SHOM 1978 (ILE DES PINS)",
  },
  {
    value: "IGNF:ST84UTM58S.PINS78",
    label:
      "IGNF:ST84UTM58S.PINS78 / ST 84 ILE DES PINS UTM Sud fuseau 58 et SHOM 1978 (ILE DES PINS)",
  },
  {
    value: "IGNF:STPM50G.STPM50",
    label:
      "IGNF:STPM50G.STPM50 / St Pierre Miquelon 1950 geographiques (dms) et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
  },
  {
    value: "IGNF:STPM50UTM21.STPM50",
    label:
      "IGNF:STPM50UTM21.STPM50 / St-Pierre-et-Miquelon UTM Nord f.21 et DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
  },
  {
    value: "IGNF:TAHAA53G.BORA01",
    label:
      "IGNF:TAHAA53G.BORA01 / IGN53 Societe geographiques (dms) et BORA_SAU 2001",
  },
  {
    value: "IGNF:TAHAA53G.HUAH01",
    label:
      "IGNF:TAHAA53G.HUAH01 / IGN53 Societe geographiques (dms) et HUAHINE_SAU 2001",
  },
  {
    value: "IGNF:TAHAA53G.RAIA01",
    label:
      "IGNF:TAHAA53G.RAIA01 / IGN53 Societe geographiques (dms) et RAIATEA_SAU 2001",
  },
  {
    value: "IGNF:TAHAA53UTM5S.BORA01",
    label:
      "IGNF:TAHAA53UTM5S.BORA01 / IGN53 Societe UTM Sud fuseau 5 et BORA_SAU 2001",
  },
  {
    value: "IGNF:TAHAA53UTM5S.HUAH01",
    label:
      "IGNF:TAHAA53UTM5S.HUAH01 / IGN53 Societe UTM Sud fuseau 5 et HUAHINE_SAU 2001",
  },
  {
    value: "IGNF:TAHAA53UTM5S.RAIA01",
    label:
      "IGNF:TAHAA53UTM5S.RAIA01 / IGN53 Societe UTM Sud fuseau 5 et RAIATEA_SAU 2001",
  },
  {
    value: "IGNF:TAHAAG.TAHAA01",
    label: "IGNF:TAHAAG.TAHAA01 / Tahaa geographiques (dms) et TAHAA_SAU 2001",
  },
  {
    value: "IGNF:TAHAAUTM5S.TAHAA01",
    label: "IGNF:TAHAAUTM5S.TAHAA01 / Tahaa UTM Sud fuseau 5 et TAHAA_SAU 2001",
  },
  {
    value: "IGNF:TAHI51UTM6S.TAHITI66",
    label:
      "IGNF:TAHI51UTM6S.TAHITI66 / TAHITI TERME NORD UTM SUD FUSEAU 6 et IGN 1966 (TAHITI)",
  },
  {
    value: "IGNF:TAHI79G.TAHITI66",
    label:
      "IGNF:TAHI79G.TAHITI66 / Tahiti (IGN79) geographiques (dms) et IGN 1966 (TAHITI)",
  },
  {
    value: "IGNF:TAHI79UTM6S.TAHITI66",
    label:
      "IGNF:TAHI79UTM6S.TAHITI66 / Tahiti (IGN79) UTM Sud fuseau 6 et IGN 1966 (TAHITI)",
  },
  {
    value: "IGNF:WALL76G.WALLIS96",
    label:
      "IGNF:WALL76G.WALLIS96 / Wallis (MOP 1976) geographiques (dms) et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:WALL76UTM1S.WALLIS96",
    label:
      "IGNF:WALL76UTM1S.WALLIS96 / Wallis (MOP 1976) UTM Sud fuseau 1 et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:WALL78G.WALLIS96",
    label:
      "IGNF:WALL78G.WALLIS96 / Wallis (MOP 1978) geographiques (dms) et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:WALL78UTM1S.WALLIS96",
    label:
      "IGNF:WALL78UTM1S.WALLIS96 / Wallis (MOP 1978) UTM Sud fuseau 1 et NGWF WALLIS (MOP 1996)",
  },
  {
    value: "IGNF:WGS72G.IGN69",
    label: "IGNF:WGS72G.IGN69 / WGS72 geographiques (dms) et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS72G.IGN78C",
    label: "IGNF:WGS72G.IGN78C / WGS72 geographiques (dms) et NGF-IGN 1978",
  },
  {
    value: "IGNF:WGS72G.NGC48",
    label:
      "IGNF:WGS72G.NGC48 / WGS72 geographiques (dms) et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:WGS72UTM30.IGN69",
    label: "IGNF:WGS72UTM30.IGN69 / WGS72 UTM fuseau 30 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS72UTM31.IGN69",
    label: "IGNF:WGS72UTM31.IGN69 / WGS72 UTM fuseau 31 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS72UTM32.IGN69",
    label: "IGNF:WGS72UTM32.IGN69 / WGS72 UTM fuseau 32 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS72UTM32.IGN78C",
    label: "IGNF:WGS72UTM32.IGN78C / WGS72 UTM fuseau 32 et NGF-IGN 1978",
  },
  {
    value: "IGNF:WGS72UTM32.NGC48",
    label:
      "IGNF:WGS72UTM32.NGC48 / WGS72 UTM fuseau 32 et NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  {
    value: "IGNF:WGS84G.IGN69",
    label: "IGNF:WGS84G.IGN69 / WGS84 geographiques (dms) et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS84G.IGN78C",
    label: "IGNF:WGS84G.IGN78C / WGS84 geographiques (dms) et NGF-IGN 1978",
  },
  {
    value: "IGNF:WGS84GDD.IGN69",
    label: "IGNF:WGS84GDD.IGN69 / WGS84 geographiques (dd) et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS84GDD.IGN78C",
    label: "IGNF:WGS84GDD.IGN78C / WGS84 geographiques (dd) et NGF-IGN 1978",
  },
  {
    value: "IGNF:WGS84UTM30.IGN69",
    label: "IGNF:WGS84UTM30.IGN69 / WGS84 UTM fuseau 30 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS84UTM31.IGN69",
    label: "IGNF:WGS84UTM31.IGN69 / WGS84 UTM fuseau 31 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS84UTM32.IGN69",
    label: "IGNF:WGS84UTM32.IGN69 / WGS84 UTM NORD FUSEAU 32 et NGF-IGN 1969",
  },
  {
    value: "IGNF:WGS84UTM32.IGN78C",
    label: "IGNF:WGS84UTM32.IGN78C / WGS84 UTM NORD FUSEAU 32 et NGF-IGN 1978",
  },
];

// 鉛直変位(vartical)
export const verticalShift = [
  { value: "CZM:5705", label: "5705 / Baltic 1977 height" },
  { value: "CZM:GCG2016", label: "GCG2016 / GCG2016 geoid model heights" },
  { value: "CZM:GEOID03", label: "GEOID03 / GEOID03 geoid model heights" },
  { value: "CZM:GEOID06", label: "GEOID06 / GEOID06 geoid model heights" },
  { value: "CZM:GEOID09", label: "GEOID09 / GEOID09 geoid model heights" },
  { value: "CZM:GEOID12", label: "GEOID12 / GEOID12 geoid model heights" },
  { value: "CZM:GEOID12A", label: "GEOID12A / GEOID12A geoid model heights" },
  { value: "CZM:GEOID12B", label: "GEOID12B / GEOID12B geoid model heights" },
  { value: "CZM:GEOID96", label: "GEOID96 / GEOID96 geoid model heights" },
  { value: "CZM:GEOID99", label: "GEOID99 / GEOID99 geoid model heights" },
  { value: "CZM:JGD2024", label: "JGD2024 / (EPSG Undefined) JGD2024(vertical) height" },
  { value: "CZM:LIT20G", label: "LIT20G / LIT20G model" },
  { value: "CZM:LV14", label: "LV14 / LV14" },
  { value: "CZM:OSGM02", label: "OSGM02 / OSGM02" },
  { value: "CZM:OSGM15", label: "OSGM15 / OSGM15" },
  { value: "CZM:RAC09", label: "RAC09 / RAC09 geoid model heights" },
  { value: "CZM:RAF09", label: "RAF09 / RAF09 geoid model heights" },
  { value: "CZM:RAF18", label: "RAF18 / RAF18 geoid model heights" },
  { value: "CZM:RAF20", label: "RAF20 / RAF20 geoid model heights" },
  { value: "CZM:RAF98", label: "RAF98 / RAF98 geoid model heights" },
  { value: "CZM:RIGA20", label: "RIGA20 / RIGA20" },
  { value: "CZM:SGEOID09", label: "SGEOID09 / SGEOID09" },
  { value: "CZM:TGM2017", label: "TGM2017 / TGM2017 vertical CRS" },
  { value: "CZM:hBG03", label: "hBG03 / hBG03 geoid model heights" },
  { value: "CZM:hBG18", label: "hBG18 / hBG18 geoid model heights" },
  { value: "EPSG:3855", label: "EPSG:3855 / EGM2008 height" },
  { value: "EPSG:3886", label: "EPSG:3886 / Fao 1979 height" },
  { value: "EPSG:3900", label: "EPSG:3900 / N2000 height" },
  { value: "EPSG:4440", label: "EPSG:4440 / NZVD2009 height" },
  { value: "EPSG:4458", label: "EPSG:4458 / Dunedin-Bluff 1960 height" },
  { value: "EPSG:5193", label: "EPSG:5193 / Incheon height" },
  { value: "EPSG:5195", label: "EPSG:5195 / Trieste height" },
  { value: "EPSG:5214", label: "EPSG:5214 / Genoa 1942 height" },
  { value: "EPSG:5237", label: "EPSG:5237 / SLVD height" },
  { value: "EPSG:5317", label: "EPSG:5317 / FVR09 height" },
  { value: "EPSG:5336", label: "EPSG:5336 / Black Sea depth" },
  { value: "EPSG:5597", label: "EPSG:5597 / FCSVR10 height" },
  { value: "EPSG:5600", label: "EPSG:5600 / NGPF height" },
  { value: "EPSG:5601", label: "EPSG:5601 / IGN 1966 height" },
  { value: "EPSG:5602", label: "EPSG:5602 / Moorea SAU 1981 height" },
  { value: "EPSG:5603", label: "EPSG:5603 / Raiatea SAU 2001 height" },
  { value: "EPSG:5604", label: "EPSG:5604 / Maupiti SAU 2001 height" },
  { value: "EPSG:5605", label: "EPSG:5605 / Huahine SAU 2001 height" },
  { value: "EPSG:5606", label: "EPSG:5606 / Tahaa SAU 2001 height" },
  { value: "EPSG:5607", label: "EPSG:5607 / Bora Bora SAU 2001 height" },
  { value: "EPSG:5608", label: "EPSG:5608 / IGLD 1955 height" },
  { value: "EPSG:5609", label: "EPSG:5609 / IGLD 1985 height" },
  { value: "EPSG:5610", label: "EPSG:5610 / HVRS71 height" },
  { value: "EPSG:5611", label: "EPSG:5611 / Caspian height" },
  { value: "EPSG:5612", label: "EPSG:5612 / Baltic 1977 depth" },
  { value: "EPSG:5613", label: "EPSG:5613 / RH2000 height" },
  { value: "EPSG:5614", label: "EPSG:5614 / KOC WD depth (ft)" },
  { value: "EPSG:5615", label: "EPSG:5615 / RH00 height" },
  { value: "EPSG:5616", label: "EPSG:5616 / IGN 1988 LS height" },
  { value: "EPSG:5617", label: "EPSG:5617 / IGN 1988 MG height" },
  { value: "EPSG:5618", label: "EPSG:5618 / IGN 1992 LD height" },
  { value: "EPSG:5619", label: "EPSG:5619 / IGN 1988 SB height" },
  { value: "EPSG:5620", label: "EPSG:5620 / IGN 1988 SM height" },
  { value: "EPSG:5621", label: "EPSG:5621 / EVRF2007 height" },
  { value: "EPSG:5701", label: "EPSG:5701 / ODN height" },
  { value: "EPSG:5702", label: "EPSG:5702 / NGVD29 height (ftUS)" },
  { value: "EPSG:5703", label: "EPSG:5703 / NAVD88 height" },
  { value: "EPSG:5704", label: "EPSG:5704 / Yellow Sea" },
  { value: "EPSG:5705", label: "EPSG:5705 / Baltic 1977 height" },
  { value: "EPSG:5706", label: "EPSG:5706 / Caspian depth" },
  { value: "EPSG:5709", label: "EPSG:5709 / NAP height" },
  { value: "EPSG:5710", label: "EPSG:5710 / Ostend height" },
  { value: "EPSG:5711", label: "EPSG:5711 / AHD height" },
  { value: "EPSG:5712", label: "EPSG:5712 / AHD (Tasmania) height" },
  { value: "EPSG:5713", label: "EPSG:5713 / CGVD28 height" },
  { value: "EPSG:5714", label: "EPSG:5714 / MSL height" },
  { value: "EPSG:5715", label: "EPSG:5715 / MSL depth" },
  { value: "EPSG:5716", label: "EPSG:5716 / Piraeus height" },
  { value: "EPSG:5717", label: "EPSG:5717 / N60 height" },
  { value: "EPSG:5718", label: "EPSG:5718 / RH70 height" },
  { value: "EPSG:5719", label: "EPSG:5719 / NGF Lallemand height" },
  { value: "EPSG:5720", label: "EPSG:5720 / NGF-IGN69 height" },
  { value: "EPSG:5721", label: "EPSG:5721 / NGF-IGN78 height" },
  { value: "EPSG:5722", label: "EPSG:5722 / Maputo height" },
  { value: "EPSG:5723", label: "EPSG:5723 / JSLD69 height" },
  { value: "EPSG:5724", label: "EPSG:5724 / PHD93 height" },
  { value: "EPSG:5725", label: "EPSG:5725 / Fahud HD height" },
  { value: "EPSG:5726", label: "EPSG:5726 / Ha Tien 1960 height" },
  { value: "EPSG:5727", label: "EPSG:5727 / Hon Dau 1992 height" },
  { value: "EPSG:5728", label: "EPSG:5728 / LN02 height" },
  { value: "EPSG:5729", label: "EPSG:5729 / LHN95 height" },
  { value: "EPSG:5730", label: "EPSG:5730 / EVRF2000 height" },
  { value: "EPSG:5731", label: "EPSG:5731 / Malin Head height" },
  { value: "EPSG:5732", label: "EPSG:5732 / Belfast height" },
  { value: "EPSG:5733", label: "EPSG:5733 / DNN height" },
  { value: "EPSG:5734", label: "EPSG:5734 / AIOC95 depth" },
  { value: "EPSG:5735", label: "EPSG:5735 / Black Sea height" },
  { value: "EPSG:5736", label: "EPSG:5736 / Yellow Sea 1956 height" },
  { value: "EPSG:5737", label: "EPSG:5737 / Yellow Sea 1985 height" },
  { value: "EPSG:5738", label: "EPSG:5738 / HKPD height" },
  { value: "EPSG:5739", label: "EPSG:5739 / HKCD depth" },
  { value: "EPSG:5740", label: "EPSG:5740 / ODN Orkney height" },
  { value: "EPSG:5741", label: "EPSG:5741 / Fair Isle height" },
  { value: "EPSG:5742", label: "EPSG:5742 / Lerwick height" },
  { value: "EPSG:5743", label: "EPSG:5743 / Foula height" },
  { value: "EPSG:5744", label: "EPSG:5744 / Sule Skerry height" },
  { value: "EPSG:5745", label: "EPSG:5745 / North Rona height" },
  { value: "EPSG:5746", label: "EPSG:5746 / Stornoway height" },
  { value: "EPSG:5747", label: "EPSG:5747 / St. Kilda height" },
  { value: "EPSG:5748", label: "EPSG:5748 / Flannan Isles height" },
  { value: "EPSG:5749", label: "EPSG:5749 / St. Marys height" },
  { value: "EPSG:5750", label: "EPSG:5750 / Douglas height" },
  { value: "EPSG:5751", label: "EPSG:5751 / Fao height" },
  { value: "EPSG:5752", label: "EPSG:5752 / Bandar Abbas height" },
  { value: "EPSG:5753", label: "EPSG:5753 / NGNC69 height" },
  { value: "EPSG:5754", label: "EPSG:5754 / Poolbeg height (ft(Br36))" },
  { value: "EPSG:5755", label: "EPSG:5755 / NGG1977 height" },
  { value: "EPSG:5756", label: "EPSG:5756 / Martinique 1987 height" },
  { value: "EPSG:5757", label: "EPSG:5757 / Guadeloupe 1988 height" },
  { value: "EPSG:5758", label: "EPSG:5758 / Reunion 1989 height" },
  { value: "EPSG:5759", label: "EPSG:5759 / Auckland 1946 height" },
  { value: "EPSG:5760", label: "EPSG:5760 / Bluff 1955 height" },
  { value: "EPSG:5761", label: "EPSG:5761 / Dunedin 1958 height" },
  { value: "EPSG:5762", label: "EPSG:5762 / Gisborne 1926 height" },
  { value: "EPSG:5763", label: "EPSG:5763 / Lyttelton 1937 height" },
  { value: "EPSG:5764", label: "EPSG:5764 / Moturiki 1953 height" },
  { value: "EPSG:5765", label: "EPSG:5765 / Napier 1962 height" },
  { value: "EPSG:5766", label: "EPSG:5766 / Nelson 1955 height" },
  { value: "EPSG:5767", label: "EPSG:5767 / One Tree Point 1964 height" },
  { value: "EPSG:5768", label: "EPSG:5768 / Tararu 1952 height" },
  { value: "EPSG:5769", label: "EPSG:5769 / Taranaki 1970 height" },
  { value: "EPSG:5770", label: "EPSG:5770 / Wellington 1953 height" },
  { value: "EPSG:5771", label: "EPSG:5771 / Chatham Island 1959 height" },
  { value: "EPSG:5772", label: "EPSG:5772 / Stewart Island 1977 height" },
  { value: "EPSG:5773", label: "EPSG:5773 / EGM96 height" },
  { value: "EPSG:5774", label: "EPSG:5774 / NG95 height" },
  { value: "EPSG:5775", label: "EPSG:5775 / Antalya height" },
  { value: "EPSG:5776", label: "EPSG:5776 / NN54 height" },
  { value: "EPSG:5777", label: "EPSG:5777 / Durres height" },
  { value: "EPSG:5778", label: "EPSG:5778 / GHA height" },
  { value: "EPSG:5779", label: "EPSG:5779 / SVS2000 height" },
  { value: "EPSG:5780", label: "EPSG:5780 / Cascais height" },
  { value: "EPSG:5781", label: "EPSG:5781 / Constanta height" },
  { value: "EPSG:5782", label: "EPSG:5782 / Alicante height" },
  { value: "EPSG:5783", label: "EPSG:5783 / DHHN92 height" },
  { value: "EPSG:5784", label: "EPSG:5784 / DHHN85 height" },
  { value: "EPSG:5785", label: "EPSG:5785 / SNN76 height" },
  { value: "EPSG:5786", label: "EPSG:5786 / Baltic 1982 height" },
  { value: "EPSG:5787", label: "EPSG:5787 / EOMA 1980 height" },
  { value: "EPSG:5788", label: "EPSG:5788 / Kuwait PWD height" },
  { value: "EPSG:5789", label: "EPSG:5789 / KOC WD depth" },
  { value: "EPSG:5790", label: "EPSG:5790 / KOC CD height" },
  { value: "EPSG:5791", label: "EPSG:5791 / NGC 1948 height" },
  { value: "EPSG:5792", label: "EPSG:5792 / Danger 1950 height" },
  { value: "EPSG:5793", label: "EPSG:5793 / Mayotte 1950 height" },
  { value: "EPSG:5794", label: "EPSG:5794 / Martinique 1955 height" },
  { value: "EPSG:5795", label: "EPSG:5795 / Guadeloupe 1951 height" },
  { value: "EPSG:5796", label: "EPSG:5796 / Lagos 1955 height" },
  { value: "EPSG:5797", label: "EPSG:5797 / AIOC95 height" },
  { value: "EPSG:5798", label: "EPSG:5798 / EGM84 height" },
  { value: "EPSG:5799", label: "EPSG:5799 / DVR90 height" },
  { value: "EPSG:5829", label: "EPSG:5829 / Instantaneous Water Level height" },
  { value: "EPSG:5831", label: "EPSG:5831 / Instantaneous Water Level depth" },
  { value: "EPSG:5843", label: "EPSG:5843 / Ras Ghumays height" },
  { value: "EPSG:5861", label: "EPSG:5861 / LAT depth" },
  { value: "EPSG:5862", label: "EPSG:5862 / LLWLT depth" },
  { value: "EPSG:5863", label: "EPSG:5863 / ISLW depth" },
  { value: "EPSG:5864", label: "EPSG:5864 / MLLWS depth" },
  { value: "EPSG:5865", label: "EPSG:5865 / MLWS depth" },
  { value: "EPSG:5866", label: "EPSG:5866 / MLLW depth" },
  { value: "EPSG:5867", label: "EPSG:5867 / MLW depth" },
  { value: "EPSG:5868", label: "EPSG:5868 / MHW height" },
  { value: "EPSG:5869", label: "EPSG:5869 / MHHW height" },
  { value: "EPSG:5870", label: "EPSG:5870 / MHWS height" },
  { value: "EPSG:5871", label: "EPSG:5871 / HHWLT height" },
  { value: "EPSG:5872", label: "EPSG:5872 / HAT height" },
  { value: "EPSG:5873", label: "EPSG:5873 / Low Water depth" },
  { value: "EPSG:5874", label: "EPSG:5874 / High Water height" },
  { value: "EPSG:5941", label: "EPSG:5941 / NN2000 height" },
  { value: "EPSG:6130", label: "EPSG:6130 / GCVD54 height (ft)" },
  { value: "EPSG:6131", label: "EPSG:6131 / LCVD61 height (ft)" },
  { value: "EPSG:6132", label: "EPSG:6132 / CBVD61 height (ft)" },
  {
    value: "EPSG:6178",
    label: "EPSG:6178 / Cais da Pontinha - Funchal height",
  },
  {
    value: "EPSG:6179",
    label: "EPSG:6179 / Cais da Vila - Porto Santo height",
  },
  { value: "EPSG:6180", label: "EPSG:6180 / Cais das Velas height" },
  { value: "EPSG:6181", label: "EPSG:6181 / Horta height" },
  { value: "EPSG:6182", label: "EPSG:6182 / Cais da Madalena height" },
  { value: "EPSG:6183", label: "EPSG:6183 / Santa Cruz da Graciosa height" },
  {
    value: "EPSG:6184",
    label: "EPSG:6184 / Cais da Figueirinha - Angra do Heroismo height",
  },
  { value: "EPSG:6185", label: "EPSG:6185 / Santa Cruz das Flores height" },
  { value: "EPSG:6186", label: "EPSG:6186 / Cais da Vila do Porto height" },
  { value: "EPSG:6187", label: "EPSG:6187 / Ponta Delgada height" },
  { value: "EPSG:6357", label: "EPSG:6357 / NAVD88 depth" },
  { value: "EPSG:6358", label: "EPSG:6358 / NAVD88 depth (ftUS)" },
  { value: "EPSG:6359", label: "EPSG:6359 / NGVD29 depth (ftUS)" },
  { value: "EPSG:6360", label: "EPSG:6360 / NAVD88 height (ftUS)" },
  { value: "EPSG:6638", label: "EPSG:6638 / Tutuila 1962 height" },
  { value: "EPSG:6639", label: "EPSG:6639 / Guam 1963 height" },
  { value: "EPSG:6640", label: "EPSG:6640 / NMVD03 height" },
  { value: "EPSG:6641", label: "EPSG:6641 / PRVD02 height" },
  { value: "EPSG:6642", label: "EPSG:6642 / VIVD09 height" },
  { value: "EPSG:6643", label: "EPSG:6643 / ASVD02 height" },
  { value: "EPSG:6644", label: "EPSG:6644 / GUVD04 height" },
  { value: "EPSG:6647", label: "EPSG:6647 / CGVD2013(CGG2013) height" },
  { value: "EPSG:6693", label: "EPSG:6693 / JSLD72 height" },
  { value: "EPSG:6694", label: "EPSG:6694 / JGD2000 (vertical) height" },
  { value: "EPSG:6695", label: "EPSG:6695 / JGD2011 (vertical) height" },
  { value: "EPSG:6916", label: "EPSG:6916 / SHD height" },
  { value: "EPSG:7446", label: "EPSG:7446 / Famagusta 1960 height" },
  { value: "EPSG:7447", label: "EPSG:7447 / PNG08 height" },
  { value: "EPSG:7651", label: "EPSG:7651 / Kumul 34 height" },
  { value: "EPSG:7652", label: "EPSG:7652 / Kiunga height" },
  { value: "EPSG:7699", label: "EPSG:7699 / DHHN12 height" },
  { value: "EPSG:7700", label: "EPSG:7700 / Latvia 2000 height" },
  { value: "EPSG:7707", label: "EPSG:7707 / ODN (Offshore) height" },
  { value: "EPSG:7832", label: "EPSG:7832 / POM96 height" },
  { value: "EPSG:7837", label: "EPSG:7837 / DHHN2016 height" },
  { value: "EPSG:7839", label: "EPSG:7839 / NZVD2016 height" },
  { value: "EPSG:7841", label: "EPSG:7841 / POM08 height" },
  { value: "EPSG:7888", label: "EPSG:7888 / Jamestown 1971 height" },
  { value: "EPSG:7889", label: "EPSG:7889 / St. Helena Tritan 2011 height" },
  { value: "EPSG:7890", label: "EPSG:7890 / SHVD2015 height" },
  { value: "EPSG:7962", label: "EPSG:7962 / Poolbeg height (m)" },
  { value: "EPSG:7968", label: "EPSG:7968 / NGVD29 height (m)" },
  { value: "EPSG:7976", label: "EPSG:7976 / HKPD depth" },
  { value: "EPSG:7979", label: "EPSG:7979 / KOC WD height" },
  { value: "EPSG:8050", label: "EPSG:8050 / MSL height (ft)" },
  { value: "EPSG:8051", label: "EPSG:8051 / MSL depth (ft)" },
  { value: "EPSG:8052", label: "EPSG:8052 / MSL height (ftUS)" },
  { value: "EPSG:8053", label: "EPSG:8053 / MSL depth (ftUS)" },
  { value: "EPSG:8089", label: "EPSG:8089 / ISH2004 height" },
  { value: "EPSG:8228", label: "EPSG:8228 / NAVD88 height (ft)" },
  { value: "EPSG:8266", label: "EPSG:8266 / GVR2000 height" },
  { value: "EPSG:8267", label: "EPSG:8267 / GVR2016 height" },
  { value: "EPSG:8357", label: "EPSG:8357 / Baltic 1957 height" },
  { value: "EPSG:8358", label: "EPSG:8358 / Baltic 1957 depth" },
  {
    value: "EPSG:8378",
    label: "EPSG:8378 / EPSG example wellbore local vertical CRS",
  },
  { value: "EPSG:8434", label: "EPSG:8434 / Macao height" },
  { value: "EPSG:8675", label: "EPSG:8675 / N43 height" },
  { value: "EPSG:8690", label: "EPSG:8690 / SVS2010 height" },
  { value: "EPSG:8691", label: "EPSG:8691 / SRB_VRS12 height" },
  { value: "EPSG:8841", label: "EPSG:8841 / MVGC height" },
  { value: "EPSG:8881", label: "EPSG:8881 / Vienna height" },
  {
    value: "EPSG:8897",
    label: "EPSG:8897 / EPSG example wellbore local vertical CRS (ft)",
  },
  { value: "EPSG:8904", label: "EPSG:8904 / TWVD 2001 height" },
  { value: "EPSG:8911", label: "EPSG:8911 / DACR52 height" },
  { value: "EPSG:9130", label: "EPSG:9130 / IGN 2008 LD height" },
  { value: "EPSG:9245", label: "EPSG:9245 / CGVD2013a(2010) height" },
  { value: "EPSG:9255", label: "EPSG:9255 / SRVN16 height" },
  { value: "EPSG:9274", label: "EPSG:9274 / EVRF2000 Austria height" },
  { value: "EPSG:9279", label: "EPSG:9279 / SA LLD height" },
  { value: "EPSG:9287", label: "EPSG:9287 / LAT NL depth" },
  { value: "EPSG:9288", label: "EPSG:9288 / MSL NL depth" },
  { value: "EPSG:9303", label: "EPSG:9303 / HS2-VRF height" },
  { value: "EPSG:9335", label: "EPSG:9335 / KSA-VRF14 height" },
  { value: "EPSG:9351", label: "EPSG:9351 / NGNC08 height" },
  { value: "EPSG:9389", label: "EPSG:9389 / EVRF2019 height" },
  { value: "EPSG:9390", label: "EPSG:9390 / EVRF2019 mean-tide height" },
  { value: "EPSG:9392", label: "EPSG:9392 / Mallorca height" },
  { value: "EPSG:9393", label: "EPSG:9393 / Menorca height" },
  { value: "EPSG:9394", label: "EPSG:9394 / Ibiza height" },
  { value: "EPSG:9395", label: "EPSG:9395 / Lanzarote height" },
  { value: "EPSG:9396", label: "EPSG:9396 / Fuerteventura height" },
  { value: "EPSG:9397", label: "EPSG:9397 / Gran Canaria height" },
  { value: "EPSG:9398", label: "EPSG:9398 / Tenerife height" },
  { value: "EPSG:9399", label: "EPSG:9399 / La Gomera height" },
  { value: "EPSG:9400", label: "EPSG:9400 / La Palma height" },
  { value: "EPSG:9401", label: "EPSG:9401 / El Hierro height" },
  { value: "EPSG:9402", label: "EPSG:9402 / Ceuta 2 height" },
  { value: "EPSG:9451", label: "EPSG:9451 / BI height" },
  { value: "EPSG:9458", label: "EPSG:9458 / AVWS height" },
  { value: "EPSG:9471", label: "EPSG:9471 / INAGeoid2020 v1 height" },
  { value: "EPSG:9650", label: "EPSG:9650 / Baltic 1986 height" },
  { value: "EPSG:9651", label: "EPSG:9651 / EVRF2007-PL height" },
  { value: "EPSG:9663", label: "EPSG:9663 / EH2000 height" },
  { value: "EPSG:9666", label: "EPSG:9666 / LAS07 height" },
  { value: "EPSG:9669", label: "EPSG:9669 / BGS2005 height" },
  { value: "EPSG:9672", label: "EPSG:9672 / CD Norway depth" },
  { value: "EPSG:9675", label: "EPSG:9675 / Pago Pago 2020 height" },
  { value: "EPSG:9681", label: "EPSG:9681 / NVD 1992 height" },
  { value: "EPSG:9721", label: "EPSG:9721 / Catania 1965 height" },
  { value: "EPSG:9722", label: "EPSG:9722 / Cagliari 1956 height" },
  { value: "EPSG:9923", label: "EPSG:9923 / GNTRANS height" },
  { value: "EPSG:9927", label: "EPSG:9927 / GNTRANS2016 height" },
  { value: "EPSG:20000", label: "EPSG:20000 / SVD2006 height" },
  { value: "EPSG:20034", label: "EPSG:20034 / CGVD2013a(2002) height" },
  { value: "EPSG:20035", label: "EPSG:20035 / CGVD2013a(1997) height" },
  { value: "EPSG:20036", label: "EPSG:20036 / INAGeoid2020 v2 height" },
  { value: "ESRI:9650", label: "ESRI:9650 / Baltic_1986_height" },
  { value: "ESRI:9651", label: "ESRI:9651 / EVRF_2007_PL_height" },
  { value: "ESRI:9721", label: "ESRI:9721 / Catania_1965_height" },
  { value: "ESRI:9722", label: "ESRI:9722 / Cagliari_1956_height" },
  { value: "ESRI:105603", label: "ESRI:105603 / REDNAP_height" },
  { value: "ESRI:105700", label: "ESRI:105700 / WGS_1984_Geoid" },
  { value: "ESRI:105701", label: "ESRI:105701 / DVR90" },
  { value: "ESRI:105702", label: "ESRI:105702 / RH2000" },
  { value: "ESRI:105703", label: "ESRI:105703 / NAVD88_height_(ftUS)" },
  { value: "ESRI:105704", label: "ESRI:105704 / LAS07_height" },
  { value: "ESRI:105790", label: "ESRI:105790 / EGM2008_Geoid" },
  { value: "ESRI:105791", label: "ESRI:105791 / Fao_1979" },
  { value: "ESRI:105792", label: "ESRI:105792 / NZVD2009_height" },
  { value: "ESRI:105793", label: "ESRI:105793 / N2000_height" },
  { value: "ESRI:105794", label: "ESRI:105794 / Dunedin_Bluff_1960_height" },
  { value: "ESRI:115700", label: "ESRI:115700 / WGS_1984" },
  { value: "ESRI:115701", label: "ESRI:115701 / ETRS_1989" },
  { value: "ESRI:115702", label: "ESRI:115702 / NAD_1983" },
  { value: "ESRI:115703", label: "ESRI:115703 / Australian_Antarctic_1998" },
  { value: "ESRI:115704", label: "ESRI:115704 / Cadastre_1997" },
  {
    value: "ESRI:115705",
    label: "ESRI:115705 / China_Geodetic_Coordinate_System_2000",
  },
  { value: "ESRI:115706", label: "ESRI:115706 / Swiss_TRF_1995" },
  { value: "ESRI:115707", label: "ESRI:115707 / CIGD11" },
  { value: "ESRI:115708", label: "ESRI:115708 / CR05" },
  { value: "ESRI:115709", label: "ESRI:115709 / DB_REF" },
  { value: "ESRI:115710", label: "ESRI:115710 / DGN_1995" },
  { value: "ESRI:115711", label: "ESRI:115711 / DRUKREF_03" },
  { value: "ESRI:115712", label: "ESRI:115712 / Estonia_1997" },
  { value: "ESRI:115713", label: "ESRI:115713 / EUREF_FIN" },
  { value: "ESRI:115714", label: "ESRI:115714 / FEH2010" },
  { value: "ESRI:115715", label: "ESRI:115715 / GDA_1994" },
  { value: "ESRI:115716", label: "ESRI:115716 / GDBD2009" },
  { value: "ESRI:115717", label: "ESRI:115717 / GDM_2000" },
  { value: "ESRI:115718", label: "ESRI:115718 / Greenland_1996" },
  { value: "ESRI:115719", label: "ESRI:115719 / Hartebeesthoek_1994" },
  { value: "ESRI:115720", label: "ESRI:115720 / IGD05" },
  { value: "ESRI:115721", label: "ESRI:115721 / IG05_Intermediate_CRS" },
  { value: "ESRI:115722", label: "ESRI:115722 / IGD05(2012)" },
  { value: "ESRI:115723", label: "ESRI:115723 / IG05(2012)_Intermediate_CRS" },
  { value: "ESRI:115724", label: "ESRI:115724 / IGM_1995" },
  { value: "ESRI:115725", label: "ESRI:115725 / IGRS" },
  { value: "ESRI:115726", label: "ESRI:115726 / IRENET95" },
  { value: "ESRI:115727", label: "ESRI:115727 / ISN_1993" },
  { value: "ESRI:115728", label: "ESRI:115728 / ISN_2004" },
  { value: "ESRI:115729", label: "ESRI:115729 / ITRF_1988" },
  { value: "ESRI:115730", label: "ESRI:115730 / ITRF_1989" },
  { value: "ESRI:115731", label: "ESRI:115731 / ITRF_1990" },
  { value: "ESRI:115732", label: "ESRI:115732 / ITRF_1991" },
  { value: "ESRI:115733", label: "ESRI:115733 / ITRF_1992" },
  { value: "ESRI:115734", label: "ESRI:115734 / ITRF_1993" },
  { value: "ESRI:115735", label: "ESRI:115735 / ITRF_1996" },
  { value: "ESRI:115736", label: "ESRI:115736 / ITRF_1997" },
  { value: "ESRI:115737", label: "ESRI:115737 / ITRF_2000" },
  { value: "ESRI:115738", label: "ESRI:115738 / ITRF_2005" },
  { value: "ESRI:115739", label: "ESRI:115739 / JAD_2001" },
  { value: "ESRI:115740", label: "ESRI:115740 / JGD_2000" },
  { value: "ESRI:115741", label: "ESRI:115741 / JGD_2011" },
  { value: "ESRI:115742", label: "ESRI:115742 / Korea_2000" },
  { value: "ESRI:115743", label: "ESRI:115743 / Lao_1997" },
  { value: "ESRI:115744", label: "ESRI:115744 / LGD2006" },
  { value: "ESRI:115745", label: "ESRI:115745 / LKS_1992" },
  { value: "ESRI:115746", label: "ESRI:115746 / LKS_1994" },
  { value: "ESRI:115747", label: "ESRI:115747 / MACAO_2008" },
  { value: "ESRI:115748", label: "ESRI:115748 / MAGNA" },
  { value: "ESRI:115749", label: "ESRI:115749 / MARCARIO_SOLIS" },
  { value: "ESRI:115750", label: "ESRI:115750 / MARGEN" },
  { value: "ESRI:115751", label: "ESRI:115751 / Mexico_ITRF2008" },
  { value: "ESRI:115752", label: "ESRI:115752 / MOLDREF99" },
  { value: "ESRI:115753", label: "ESRI:115753 / MONREF_1997" },
  { value: "ESRI:115754", label: "ESRI:115754 / Moznet" },
  { value: "ESRI:115755", label: "ESRI:115755 / NAD_1983_2011" },
  { value: "ESRI:115756", label: "ESRI:115756 / NAD_1983_CORS96" },
  { value: "ESRI:115757", label: "ESRI:115757 / North_American_1983_CSRS" },
  { value: "ESRI:115758", label: "ESRI:115758 / North_American_1983_HARN" },
  { value: "ESRI:115759", label: "ESRI:115759 / NAD_1983_MA11" },
  { value: "ESRI:115760", label: "ESRI:115760 / NAD_1983_MARP00" },
  { value: "ESRI:115761", label: "ESRI:115761 / NAD_1983_NSRS2007" },
  { value: "ESRI:115762", label: "ESRI:115762 / NAD_1983_PA11" },
  { value: "ESRI:115763", label: "ESRI:115763 / NAD_1983_PACP00" },
  { value: "ESRI:115764", label: "ESRI:115764 / Nepal_Nagarkot" },
  { value: "ESRI:115765", label: "ESRI:115765 / NZGD_2000" },
  { value: "ESRI:115766", label: "ESRI:115766 / Peru96" },
  { value: "ESRI:115767", label: "ESRI:115767 / PNG94" },
  { value: "ESRI:115768", label: "ESRI:115768 / POSGAR" },
  { value: "ESRI:115769", label: "ESRI:115769 / POSGAR_1994" },
  { value: "ESRI:115770", label: "ESRI:115770 / POSGAR_1998" },
  { value: "ESRI:115771", label: "ESRI:115771 / PRS_1992" },
  { value: "ESRI:115772", label: "ESRI:115772 / PTRA08" },
  { value: "ESRI:115773", label: "ESRI:115773 / PZ_1990" },
  { value: "ESRI:115774", label: "ESRI:115774 / RDN2008" },
  { value: "ESRI:115775", label: "ESRI:115775 / REGCAN95" },
  { value: "ESRI:115776", label: "ESRI:115776 / REGVEN" },
  { value: "ESRI:115777", label: "ESRI:115777 / RGAF09" },
  { value: "ESRI:115778", label: "ESRI:115778 / RGF_1993" },
  { value: "ESRI:115779", label: "ESRI:115779 / RGFG_1995" },
  { value: "ESRI:115780", label: "ESRI:115780 / RGM_2004" },
  { value: "ESRI:115781", label: "ESRI:115781 / RGNC_1991" },
  { value: "ESRI:115782", label: "ESRI:115782 / RGNC_1991-93" },
  { value: "ESRI:115783", label: "ESRI:115783 / RGPF" },
  { value: "ESRI:115784", label: "ESRI:115784 / RGR_1992" },
  { value: "ESRI:115785", label: "ESRI:115785 / RGRDC_2005" },
  { value: "ESRI:115786", label: "ESRI:115786 / RGSPM_2006" },
  { value: "ESRI:115787", label: "ESRI:115787 / RRAF_1991" },
  { value: "ESRI:115788", label: "ESRI:115788 / RSRGD2000" },
  { value: "ESRI:115789", label: "ESRI:115789 / SIRGAS_2000" },
  { value: "ESRI:115790", label: "ESRI:115790 / SIRGAS-Chile" },
  { value: "ESRI:115791", label: "ESRI:115791 / SIRGAS_ES2007.8" },
  { value: "ESRI:115792", label: "ESRI:115792 / SIRGAS-ROU98" },
  { value: "ESRI:115793", label: "ESRI:115793 / SLD99" },
  { value: "ESRI:115794", label: "ESRI:115794 / Slovenia_1996" },
  { value: "ESRI:115795", label: "ESRI:115795 / SREF98" },
  { value: "ESRI:115796", label: "ESRI:115796 / S_JTSK/05" },
  { value: "ESRI:115797", label: "ESRI:115797 / S_JTSK/05_Ferro" },
  { value: "ESRI:115798", label: "ESRI:115798 / SWEREF99" },
  { value: "ESRI:115799", label: "ESRI:115799 / TGD2005" },
  { value: "ESRI:115800", label: "ESRI:115800 / TWD_1997" },
  { value: "ESRI:115801", label: "ESRI:115801 / Ukraine_2000" },
  { value: "ESRI:115802", label: "ESRI:115802 / Yemen_NGN_1996" },
  { value: "ESRI:115803", label: "ESRI:115803 / ITRF_2008" },
  { value: "ESRI:115804", label: "ESRI:115804 / TUREF" },
  { value: "ESRI:115805", label: "ESRI:115805 / GDA2020" },
  { value: "ESRI:115806", label: "ESRI:115806 / BGS2005" },
  {
    value: "ESRI:115807",
    label: "ESRI:115807 / Unknown_height_system_(meters)",
  },
  {
    value: "ESRI:115808",
    label: "ESRI:115808 / Unknown_height_system_(US_survey_feet)",
  },
  {
    value: "ESRI:115809",
    label: "ESRI:115809 / Unknown_height_system_(Intl_Feet)",
  },
  { value: "ESRI:115810", label: "ESRI:115810 / ITRF2014" },
  { value: "ESRI:115811", label: "ESRI:115811 / SHGD2015" },
  { value: "ESRI:115812", label: "ESRI:115812 / St_Helena_Tritan" },
  { value: "ESRI:115813", label: "ESRI:115813 / GSK-2011" },
  { value: "ESRI:115814", label: "ESRI:115814 / PZ-90.11" },
  { value: "ESRI:115815", label: "ESRI:115815 / PZ-90.02" },
  { value: "ESRI:115816", label: "ESRI:115816 / WGS_1984_(Transit)" },
  { value: "ESRI:115817", label: "ESRI:115817 / WGS_1984_(G1762)" },
  { value: "ESRI:115818", label: "ESRI:115818 / WGS_1984_(G1674)" },
  { value: "ESRI:115819", label: "ESRI:115819 / WGS_1984_(G1150)" },
  { value: "ESRI:115820", label: "ESRI:115820 / WGS_1984_(G873)" },
  { value: "ESRI:115821", label: "ESRI:115821 / WGS_1984_(G730)" },
  { value: "ESRI:115822", label: "ESRI:115822 / ETRF90" },
  { value: "ESRI:115823", label: "ESRI:115823 / ETRF91" },
  { value: "ESRI:115824", label: "ESRI:115824 / ETRF92" },
  { value: "ESRI:115825", label: "ESRI:115825 / ETRF93" },
  { value: "ESRI:115826", label: "ESRI:115826 / ETRF94" },
  { value: "ESRI:115827", label: "ESRI:115827 / ETRF96" },
  { value: "ESRI:115828", label: "ESRI:115828 / ETRF97" },
  { value: "ESRI:115829", label: "ESRI:115829 / ETRF2000" },
  { value: "ESRI:115830", label: "ESRI:115830 / NAD83(CSRS96)" },
  { value: "ESRI:115831", label: "ESRI:115831 / NAD83(CSRS)v2" },
  { value: "ESRI:115832", label: "ESRI:115832 / NAD83(CSRS)v3" },
  { value: "ESRI:115833", label: "ESRI:115833 / NAD83(CSRS)v4" },
  { value: "ESRI:115834", label: "ESRI:115834 / NAD83(CSRS)v5" },
  { value: "ESRI:115835", label: "ESRI:115835 / NAD83(CSRS)v6" },
  { value: "ESRI:115836", label: "ESRI:115836 / NAD83(CSRS)v7" },
  { value: "ESRI:115837", label: "ESRI:115837 / IGS14" },
  { value: "ESRI:115838", label: "ESRI:115838 / ISN2016" },
  { value: "ESRI:115839", label: "ESRI:115839 / Hong_Kong_Geodetic_CS" },
  { value: "ESRI:115840", label: "ESRI:115840 / NAD_1983_(FBN)" },
  { value: "ESRI:115841", label: "ESRI:115841 / NAD_1983_(HARN_Corrected)" },
  { value: "ESRI:115842", label: "ESRI:115842 / SRB_ETRS89" },
  { value: "ESRI:115843", label: "ESRI:115843 / MTRF-2000" },
  {
    value: "ESRI:115844",
    label: "ESRI:115844 / California_SRS_Epoch_2017.50_(NAD83)",
  },
  { value: "ESRI:115845", label: "ESRI:115845 / GGD" },
  { value: "ESRI:115846", label: "ESRI:115846 / ONGD14" },
  { value: "ESRI:115847", label: "ESRI:115847 / ONGD17" },
  { value: "ESRI:115848", label: "ESRI:115848 / S-JTSK_[JTSK03]" },
  { value: "ESRI:115849", label: "ESRI:115849 / CR-SIRGAS" },
  { value: "ESRI:115850", label: "ESRI:115850 / RGWF96" },
  { value: "ESRI:115851", label: "ESRI:115851 / SIRGAS-CON_DGF00P01" },
  { value: "ESRI:115852", label: "ESRI:115852 / SIRGAS-CON_DGF01P01" },
  { value: "ESRI:115853", label: "ESRI:115853 / SIRGAS-CON_DGF01P02" },
  { value: "ESRI:115854", label: "ESRI:115854 / SIRGAS-CON_DGF02P01" },
  { value: "ESRI:115855", label: "ESRI:115855 / SIRGAS-CON_DGF04P01" },
  { value: "ESRI:115856", label: "ESRI:115856 / SIRGAS-CON_DGF05P01" },
  { value: "ESRI:115857", label: "ESRI:115857 / SIRGAS-CON_DGF06P01" },
  { value: "ESRI:115858", label: "ESRI:115858 / SIRGAS-CON_DGF07P01" },
  { value: "ESRI:115859", label: "ESRI:115859 / SIRGAS-CON_DGF08P01" },
  { value: "ESRI:115860", label: "ESRI:115860 / SIRGAS-CON_SIR09P01" },
  { value: "ESRI:115861", label: "ESRI:115861 / SIRGAS-CON_SIR10P01" },
  { value: "ESRI:115862", label: "ESRI:115862 / SIRGAS-CON_SIR11P01" },
  { value: "ESRI:115863", label: "ESRI:115863 / SIRGAS-CON_SIR13P01" },
  { value: "ESRI:115864", label: "ESRI:115864 / SIRGAS-CON_SIR14P01" },
  { value: "ESRI:115865", label: "ESRI:115865 / SIRGAS-CON_SIR15P01" },
  { value: "ESRI:115866", label: "ESRI:115866 / SIRGAS-CON_SIR17P01" },
  { value: "ESRI:115867", label: "ESRI:115867 / IGS97" },
  { value: "ESRI:115868", label: "ESRI:115868 / IGS00" },
  { value: "ESRI:115869", label: "ESRI:115869 / IGb00" },
  { value: "ESRI:115870", label: "ESRI:115870 / IGS05" },
  { value: "ESRI:115871", label: "ESRI:115871 / IGb08" },
  { value: "ESRI:115872", label: "ESRI:115872 / KOSOVAREF01" },
  { value: "ESRI:115873", label: "ESRI:115873 / ETRF2005" },
  { value: "ESRI:115874", label: "ESRI:115874 / ETRF2014" },
  { value: "ESRI:115875", label: "ESRI:115875 / CH1903+" },
  { value: "ESRI:115876", label: "ESRI:115876 / ATRF2014" },
  { value: "ESRI:115877", label: "ESRI:115877 / Australian_1984" },
  { value: "ESRI:115878", label: "ESRI:115878 / Australian_1966" },
  { value: "ESRI:115879", label: "ESRI:115879 / ITRF_1994" },
  { value: "IGNF:BORA01", label: "IGNF:BORA01 / BORA_SAU 2001" },
  { value: "IGNF:BOURD", label: "IGNF:BOURD / NGF-BOURDALOUE" },
  {
    value: "IGNF:EVRF2000",
    label:
      "IGNF:EVRF2000 / EVRF2000 (UELN-95/98)(EUROPEAN VERTICAL REFERENCE FRAME)",
  },
  {
    value: "IGNF:EVRF2007",
    label: "IGNF:EVRF2007 / EVRF2007 (EUROPEAN VERTICAL REFERENCE FRAME 2007)",
  },
  {
    value: "IGNF:FUTUNA1997",
    label: "IGNF:FUTUNA1997 / NGWF ILES HORN (FUTUNA ET ALOFI)",
  },
  {
    value: "IGNF:GLOR77",
    label: "IGNF:GLOR77 / SHOM 1977 (ILES GLORIEUSES - CANAL DE MOZAMBIQUE)",
  },
  {
    value: "IGNF:GUAD2008LD",
    label: "IGNF:GUAD2008LD / IGN 2008 LD (GUADELOUPE / LA DESIRADE)",
  },
  { value: "IGNF:GUAD88", label: "IGNF:GUAD88 / IGN 1988 (GUADELOUPE)" },
  {
    value: "IGNF:GUAD88LS",
    label: "IGNF:GUAD88LS / IGN 1988 LS (GUADELOUPE / LES SAINTES)",
  },
  {
    value: "IGNF:GUAD88MG",
    label: "IGNF:GUAD88MG / IGN 1988 MG (GUADELOUPE / MARIE-GALANTE)",
  },
  {
    value: "IGNF:GUAD88SB",
    label: "IGNF:GUAD88SB / IGN 1988 SB (GUADELOUPE / SAINT-BARTHELEMY)",
  },
  {
    value: "IGNF:GUAD88SM",
    label: "IGNF:GUAD88SM / IGN 1988 SM (GUADELOUPE / SAINT-MARTIN)",
  },
  {
    value: "IGNF:GUAD92LD",
    label: "IGNF:GUAD92LD / IGN 1992 LD (GUADELOUPE / LA DESIRADE)",
  },
  {
    value: "IGNF:GUYA77",
    label: "IGNF:GUYA77 / NIVELLEMENT GENERAL DE GUYANE (NGG) 1977",
  },
  { value: "IGNF:HUAH01", label: "IGNF:HUAH01 / HUAHINE_SAU 2001" },
  { value: "IGNF:IGN69", label: "IGNF:IGN69 / NGF-IGN 1969" },
  { value: "IGNF:IGN78C", label: "IGNF:IGN78C / NGF-IGN 1978" },
  { value: "IGNF:KERG62", label: "IGNF:KERG62 / IGN 1962 (KERGUELEN)" },
  {
    value: "IGNF:LIFOU91",
    label: "IGNF:LIFOU91 / NIVELLEMENT GENERAL DE LIFOU (IGN 1991 LF)",
  },
  {
    value: "IGNF:MARE91",
    label: "IGNF:MARE91 / NIVELLEMENT GENERAL DE MARE (IGN 1991 MR)",
  },
  { value: "IGNF:MART87", label: "IGNF:MART87 / IGN 1987 (MARTINIQUE)" },
  { value: "IGNF:MAUPITI01", label: "IGNF:MAUPITI01 / MAUPITI_SAU 2001" },
  { value: "IGNF:MAYO53", label: "IGNF:MAYO53 / SHOM 1953 (MAYOTTE)" },
  {
    value: "IGNF:MOOREA81",
    label: "IGNF:MOOREA81 / MOOREA 1981 (MOOREA_SAU 2001)",
  },
  {
    value: "IGNF:NCAL69",
    label: "IGNF:NCAL69 / NIVELLEMENT GENERAL DE NOUVELLE-CALEDONIE (NGNC)",
  },
  {
    value: "IGNF:NGC48",
    label: "IGNF:NGC48 / NIVELLEMENT GENERAL DE LA CORSE (NGC)",
  },
  { value: "IGNF:NGF84", label: "IGNF:NGF84 / NGF-LALLEMAND" },
  {
    value: "IGNF:NNLUX",
    label: "IGNF:NNLUX / NIVELLEMENT GENERAL DU LUXEMBOURG",
  },
  {
    value: "IGNF:PETRELS52",
    label: "IGNF:PETRELS52 / EPF 1952 (ILE DES PETRELS)",
  },
  { value: "IGNF:PINS78", label: "IGNF:PINS78 / SHOM 1978 (ILE DES PINS)" },
  { value: "IGNF:RAIA01", label: "IGNF:RAIA01 / RAIATEA_SAU 2001" },
  { value: "IGNF:REUN89", label: "IGNF:REUN89 / IGN 1989 (REUNION)" },
  {
    value: "IGNF:SHOM1984WF",
    label: "IGNF:SHOM1984WF / SHOM 1984 (WALLIS ET FUTUNA)",
  },
  {
    value: "IGNF:STPM50_V",
    label: "IGNF:STPM50_V / DANGER 1950 (SAINT-PIERRE-ET-MIQUELON)",
  },
  { value: "IGNF:TAHAA01", label: "IGNF:TAHAA01 / TAHAA_SAU 2001" },
  { value: "IGNF:TAHITI66", label: "IGNF:TAHITI66 / IGN 1966 (TAHITI)" },
  { value: "IGNF:UVEA84", label: "IGNF:UVEA84 / IGN 1984 (ILE UVEA)" },
  { value: "IGNF:WALLIS96", label: "IGNF:WALLIS96 / NGWF WALLIS (MOP 1996)" },
];
